{
  "reporting.title": "Exportación de datos personalizados",
  "reporting.description": "Choose your report, reporting period and columns, then download a spreadsheet-ready CSV.",
  "reporting.builder": "Back to report builder",
  "reporting.queue": "My Report Queue",
  "reporting.queueEmpty": "Your generated reports will appear here.",
  "reporting.design.emptyQueuePage": "There are no reports on this page.",
  "reporting.design.firstQueuePage": "Return to the first page",
  "reporting.reportType": "Report type",
  "reporting.layout": "CSV layout",
  "reporting.layout.SPREADSHEET": "Spreadsheet — tests in columns",
  "reporting.layout.RESULT_LIST": "Detailed list — results in rows",
  "reporting.layout.TABLE": "Table",
  "reporting.meaning.SPREADSHEET": "Tests appear as columns for each specimen. Repeated results use extra rows; unrelated repeat readings are kept separate.",
  "reporting.meaning.RESULT_LIST": "Each independent result appears on its own row. Repeated results are preserved.",
  "reporting.meaning.TABLE": "Each recorded occurrence appears on its own row.",
  "reporting.dateFrom": "Date from",
  "reporting.dateTo": "Date to",
  "reporting.dates.required": "Required",
  "reporting.dates.requiredFrom": "Choose a start date.",
  "reporting.dates.requiredTo": "Choose an end date.",
  "reporting.dates.invalid": "Choose a valid calendar date.",
  "reporting.dates.reversed": "End date must be on or after the start date.",
  "reporting.dates.tooLong": "Choose a period of {days} days or fewer, including both dates.",
  "reporting.dates.range": "Choose an ordered period within the maximum shown above.",
  "reporting.periodHelp": "Uses {dateMeaning} in {timezone}, including both dates. Maximum period: {days} days.",
  "reporting.dateAnchor.collectionDate": "specimen collection dates",
  "reporting.dateAnchor.requestDate": "referral request dates",
  "reporting.dateAnchor.sentDate": "referral sent dates",
  "reporting.dateAnchor.eventOrRecordedDate": "event dates when known, otherwise recorded dates (identified by Date Basis)",
  "reporting.dateAnchor.dateOfEvent": "non-conformance event dates",
  "reporting.dateAnchor.enteredDate": "recorded rejection dates",
  "reporting.labSections": "Lab sections",
  "reporting.allAccessibleSections": "All accessible lab sections",
  "reporting.tests": "Pruebas",
  "reporting.allTests": "All tests",
  "reporting.resultStatuses": "Result statuses",
  "reporting.finalized": "Finalizado",
  "reporting.all": "Todos",
  "reporting.available": "Available columns",
  "reporting.search": "Search columns",
  "reporting.selected": "Selected columns",
  "reporting.selectedCount": "Selected columns ({count})",
  "reporting.group.sample": "Sample and order",
  "reporting.group.referrals": "Referencias",
  "reporting.group.nonConformance": "Non-Conformance / Rejections",
  "reporting.group.patient": "Paciente",
  "reporting.group.result": "Result details",
  "reporting.group.tests": "Configured tests",
  "reporting.group.components": "Configured result components",
  "reporting.group.turnaround": "Turnaround time",
  "reporting.group.testTurnaround": "Turnaround by test",
  "reporting.group.componentTurnaround": "Turnaround by result component",
  "reporting.group.observations": "Additional questions",
  "reporting.headerPreview": "CSV header preview",
  "reporting.moveUp": "Move {field} up",
  "reporting.moveDown": "Move {field} down",
  "reporting.remove": "Eliminar «{field}»",
  "reporting.position": "{field}: position {position} of {count}",
  "reporting.review": "Review report",
  "reporting.edit": "Edit report",
  "reporting.generate": "Generar CSV",
  "reporting.submitting": "Submitting report…",
  "reporting.generating": "Preparing your CSV…",
  "reporting.download": "Download CSV",
  "reporting.loading": "Loading report options…",
  "reporting.currentReport": "Your current report",
  "reporting.previous": "Anterior",
  "reporting.next": "Siguiente",
  "reporting.rows": "{count, plural, one {# row} other {# rows}}",
  "reporting.state.QUEUED": "Queued",
  "reporting.state.GENERATING": "Generating",
  "reporting.state.READY": "Ready to download",
  "reporting.state.FAILED": "Fallido",
  "reporting.state.EXPIRED": "Caducado",
  "reporting.state.CANCELLED": "Cancelado",
  "reporting.loadError": "Could not load reporting information",
  "reporting.submitError": "Could not generate the report",
  "reporting.requestError": "The request could not be completed. Your choices have been retained; try again.",
  "reporting.networkError": "The server could not be reached. Your choices have been retained; try again.",
  "reporting.request.invalid": "Check your reporting period, filters and selected columns, then try again.",
  "reporting.request.conflict": "This submission identifier was already used for different report choices. Start a new report.",
  "reporting.columns.stale": "Some selected columns are no longer available. Remove them and choose from the current catalog.",
  "reporting.jobs.limit": "You have reached the active-report limit. Wait for a report to finish, then try again.",
  "reporting.access.denied": "Your current OpenELIS access does not permit this report.",
  "reporting.access.scopeChanged": "Your access to the selected lab sections has changed. Review the report with your current access.",
  "reporting.access.noSections": "No accessible lab sections are available for this report.",
  "reporting.access.signIn": "Sign in to OpenELIS to continue.",
  "reporting.definition.changed": "The report definition has changed. Review the current report options before running again.",
  "reporting.definition.unavailable": "This report type is no longer available.",
  "reporting.tests.stale": "Some selected tests are no longer available. Review your test selection.",
  "reporting.status.invalid": "Choose an available result status.",
  "reporting.filters.unsupported": "Some requested filters are unavailable for this report. Review the current report options.",
  "reporting.filters.unavailable": "Some previous filters are unavailable for this report. Review the current filters before generating.",
  "reporting.job.generationFailed": "The CSV could not be generated. Your report request has been retained.",
  "reporting.job.outputUnavailable": "The server cannot save export files. Ask your administrator to make the export folder writable, then retry this report.",
  "reporting.job.expired": "This file has expired. Run the report again with a new reporting period.",
  "reporting.job.notReady": "This report is not ready to download yet.",
  "reporting.job.notFound": "This report could not be found.",
  "reporting.saved.library": "Shared reports",
  "reporting.saved.search": "Search shared reports",
  "reporting.saved.loading": "Loading shared reports…",
  "reporting.saved.loadError": "Could not load shared reports",
  "reporting.saved.empty": "No shared reports have been saved yet.",
  "reporting.saved.shared": "Available to everyone who can use reports.",
  "reporting.saved.open": "Abrir",
  "reporting.saved.save": "Save report",
  "reporting.saved.update": "Update shared report",
  "reporting.saved.copy": "Save a copy",
  "reporting.saved.delete": "Delete shared report",
  "reporting.saved.name": "Report name",
  "reporting.saved.confirmSave": "Save shared report",
  "reporting.saved.confirmDelete": "Eliminar",
  "reporting.saved.confirmUpdate": "Actualizar",
  "reporting.saved.cancel": "Cancelar",
  "reporting.saved.copyName": "Copia de {name}",
  "reporting.saved.created": "Saved as {name}.",
  "reporting.saved.updated": "Updated {name}.",
  "reporting.saved.freshDates": "Choose fresh dates before running this report.",
  "reporting.saved.deleteHelp": "Delete {name} from the shared report library? Existing generated files are retained.",
  "reporting.saved.updateHelp": "Replace {name} with the choices currently shown in the builder?",
  "reporting.saved.changed": "Someone changed this shared report after you opened it. Your choices are still here; reopen the current saved report or save a copy.",
  "reporting.saved.invalid": "Review the report choices before saving.",
  "reporting.saved.nameInvalid": "Enter a report name of 200 characters or fewer.",
  "reporting.saved.notFound": "This shared report is no longer available.",
  "reporting.saved.pageInvalid": "The shared report list request was invalid.",
  "accept.action.button": "Aceptar",
  "accessDenied.message": " No tienes acceso a este módulo, por favor contacta al administrador del sistema",
  "accessDenied.okButton": " Aceptar",
  "accessDenied.title": " Acceso denegado",
  "accession.entry": "Entrada de número de acceso",
  "activityReportByPanel": " Informe de actividad por panel",
  "activityReportByTest": " Informe de actividad por prueba",
  "activityReportByTestSection": " Informe de actividad por unidad de prueba",
  "add.age.range": "Agregar Otro Rango de Edad +",
  "add.aliquot": "Agregar alícuota",
  "add.new.dictionary.menu": " Agregar menú de diccionario nuevo",
  "address.search.label": "Búsqueda rápida de direcciones",
  "address.level.provinsi": "Provincia",
  "address.level.kabupaten": "Regency/City",
  "address.level.kecamatan": "Distrito",
  "address.level.kelurahan": "Village",
  "adjustment.button": "Ajustar la cantidad",
  "adjustment.newQuantity": "Nueva cantidad",
  "adjustment.notes": "Notas",
  "adjustment.notes.placeholder": "Proporcione detalles sobre este ajuste",
  "adjustment.reason": "Motivo del ajuste",
  "adjustment.reason.select": "Seleccione el motivo",
  "adjustment.success": "La cantidad del lote se ha ajustado correctamente",
  "adjustment.title": "Ajustar la cantidad del lote",
  "admin.dashboard.subtitle": "Elija un área de administración para configurar OpenELIS.",
  "admin.dashboard.title": "Panel de administración",
  "admin.formEntryConfig": "Configuraciones generales",
  "admin.programs.title": "Programas",
  "admin.programs.subtitle": "The initiatives that orders are filed under — each with a domain, one or more lab units, and an optional order-entry questionnaire.",
  "admin.programs.add": "Agregar programa",
  "admin.programs.search": "Search by name",
  "admin.programs.selector.new": "Nuevo programa",
  "admin.programs.row.expand.aria": "Edit program",
  "admin.programs.row.actions.aria": "Program actions",
  "admin.programs.list.column.name": "Nombre",
  "admin.programs.list.column.domain": "Dominio",
  "admin.programs.list.column.active": "Estado",
  "admin.programs.list.column.units": "Lab unit(s)",
  "admin.programs.list.status.active": "Activo",
  "admin.programs.list.status.inactive": "Inactivo",
  "admin.programs.list.filter.domain.label": "Dominio",
  "admin.programs.list.filter.domain.all": "Todos los dominios",
  "admin.programs.list.toggle.showDeactivated": "Mostrar desactivados",
  "admin.programs.action.deactivate": "Desactivar",
  "admin.programs.action.reactivate": "Reactivar",
  "admin.programs.deactivate.modal.title": "Deactivate this Program?",
  "admin.programs.deactivate.modal.body.noOrders": "\"{programName}\" has no orders and will simply stop appearing for new orders. You can reactivate it at any time from the Programs list.",
  "admin.programs.deactivate.modal.confirm": "Desactivar",
  "admin.programs.deactivate.modal.cancel": "Cancelar",
  "admin.programs.reactivate.success": "{programName} reactivated",
  "admin.programs.deactivate.success": "{programName} deactivated",
  "admin.programs.domain.confirm.heading": "Change Program Domain?",
  "admin.programs.domain.confirm.body": "Historical orders were evaluated against the {from} domain's rules. Changing to {to} is forward-looking: existing orders keep their program coding and are not re-coded, and the program will only be offered on {to} orders from now on.",
  "admin.programs.list.empty": "No programs match the current search and filters.",
  "admin.programs.basicInfo.labUnits.selectAll": "Select all",
  "admin.programs.basicInfo.labUnits.placeholder": "Type to filter lab units",
  "orderEntry.programPicker.empty": "No programs are currently active. An administrator can activate one under Admin › Programs.",
  "orderEntry.programPicker.empty.domain": "No {domain} programs are currently active. An administrator can activate one under Admin › Programs.",
  "admin.programs.basicInfo.programName.label": "Nombre del programa",
  "admin.programs.basicInfo.programName.placeholder": "e.g. HBV Antenatal Screening",
  "admin.programs.basicInfo.code.label": "Programme Code",
  "admin.programs.basicInfo.code.placeholder": "e.g. HBV_ANC",
  "admin.programs.basicInfo.code.invalid": "Use letters, digits, spaces, or underscores only.",
  "admin.programs.basicInfo.programName.tooLong": "Use at most {max} characters.",
  "admin.programs.basicInfo.labUnits.label": "Lab unit(s)",
  "admin.programs.basicInfo.showOnMicroCase.off": "Apagado",
  "admin.programs.basicInfo.showOnMicroCase.on": "Encendido",
  "admin.programs.basicInfo.showOnMicroCase.label": "Show on Microbiology case",
  "admin.programs.basicInfo.showOnMicroCase.helper": "Allow this Program on microbiology cases. New cases inherit it from the order; it does not change how work is routed.",
  "admin.programs.basicInfo.domain.label": "Dominio",
  "admin.programs.basicInfo.domain.required": "Es obligatorio ingresar un dominio",
  "admin.programs.editor.status.label": "Status:",
  "admin.programs.guidance.domain.toggle.show": "What does each Domain mean?",
  "admin.programs.guidance.domain.toggle.hide": "Hide",
  "admin.programs.guidance.domain.clinical": "Patient testing — form captures patient identifiers, provider, prior history.",
  "admin.programs.guidance.domain.environmental": "Compliance/surveillance sampling (water, food, air). No patient fields.",
  "admin.programs.guidance.domain.vector": "Specimen surveillance (mosquito, tick) — species, pool manifest.",
  "admin.programs.guidance.gui.emptyState.body": "No questions yet — add questions one at a time, or paste a Questionnaire in JSON mode.",
  "admin.programs.guidance.gui.emptyState.action": "Add First Question",
  "admin.programs.guidance.json.referenceCard.format": "Format: FHIR R4 Questionnaire",
  "admin.programs.guidance.json.referenceCard.allowedTypes": "— allowed item.type: {allowed}.",
  "admin.programs.questionnaire.mode.visualBuilder": "Visual Builder",
  "admin.programs.questionnaire.mode.json": "JSON",
  "admin.programs.questionnaire.question.text.label": "Question Text",
  "admin.programs.questionnaire.question.type.label": "Question Type",
  "admin.programs.questionnaire.question.addNew": "Add New Question",
  "admin.programs.questionnaire.question.actions.aria": "Question actions",
  "admin.programs.questionnaire.question.actions.delete": "Delete question",
  "admin.programs.questionnaire.answerOptions.section.title": "Answer options",
  "admin.programs.questionnaire.answerOptions.addOption": "Agregar opción",
  "admin.programs.questionnaire.answerOptions.deleteOption": "Delete option",
  "admin.programs.questionnaire.answerOptions.empty": "No options yet — add at least one so reception can pick a value.",
  "admin.programs.questionnaire.answerOptions.coded": "coded",
  "admin.programs.questionnaire.answerOptions.codedHelp": "Coded options come from a terminology and are shown read-only here. Edit them in JSON mode.",
  "admin.programs.questionnaire.preview.label": " Ejemplo",
  "admin.programs.questionnaire.preview.empty": "No questions yet — start adding questions to see the preview.",
  "admin.programs.questionnaire.preview.untitled": "(untitled)",
  "admin.programs.questionnaire.preview.boolean.example": "◯ Yes ◯ No",
  "admin.programs.questionnaire.preview.quantity.numberPlaceholder": "number",
  "admin.programs.questionnaire.preview.quantity.unit": "unit",
  "admin.programs.questionnaire.json.validate": "Validate JSON",
  "admin.programs.questionnaire.json.reformat": "Reformat",
  "admin.programs.questionnaire.json.validated": "Validated — {count} question(s)",
  "admin.programs.questionnaire.json.error.title": "Invalid Questionnaire",
  "admin.programs.questionnaire.json.error.resourceType": "resourceType must be \"Questionnaire\"",
  "admin.programs.questionnaire.json.error.itemArray": "item must be an array",
  "admin.programs.questionnaire.json.error.itemShape": "each item must have linkId, text, and type in [{allowed}]",
  "admin.programs.questionnaire.json.error.duplicateLinkId": "duplicate linkId \"{linkId}\" — each item must have a unique linkId",
  "admin.programs.guidance.json.referenceCard.advanced": "Advanced features (enableWhen, Quantity units via unit/unitOption, nested items) are edited here in JSON — the Visual Builder preserves them but does not surface them.",
  "admin.programs.basicInfo.domain.helper": "Controls where this program appears — reception only sees programs matching the order's domain.",
  "admin.programs.editor.status.noHardDelete": "No hard delete — deactivate preserves history.",
  "admin.programs.deactivate.modal.body": "\"{programName}\" will stop appearing in the order-entry Program picker for new orders. {orderCount, plural, one {Its # historical order keeps its program coding} other {Its # historical orders keep their program coding}} and all indicator counts are preserved. You can reactivate it at any time from the Programs list.",
  "admin.programs.deactivate.modal.body.unknownCount": "\"{programName}\" will stop appearing in the order-entry Program picker for new orders. Historical orders keep their program coding and all indicator counts are preserved. You can reactivate it at any time from the Programs list.",
  "admin.programs.questionnaire.question.unsupported": "This is a \"{type}\" item, which this builder does not edit. It is kept exactly as it is when you save. Edit it in JSON mode.",
  "admin.programs.questionnaire.question.type.boolean": "Yes / No",
  "admin.programs.questionnaire.question.type.choice": "Choice",
  "admin.programs.questionnaire.question.type.checkbox": "Checkbox",
  "admin.programs.questionnaire.question.type.integer": "Whole number",
  "admin.programs.questionnaire.question.type.decimal": "Decimal number",
  "admin.programs.questionnaire.question.type.date": "Fecha",
  "admin.programs.questionnaire.question.type.time": "Hora",
  "admin.programs.questionnaire.question.type.string": "Short text",
  "admin.programs.questionnaire.question.type.text": "Long text",
  "admin.programs.questionnaire.question.type.quantity": "Cantidad",
  "admin.programs.questionnaire.question.typeExample.boolean": "Yes/no answer. Example: \"First antenatal visit?\"",
  "admin.programs.questionnaire.question.typeExample.choice": "One option from a fixed list. Example: \"Specimen condition\".",
  "admin.programs.questionnaire.question.typeExample.checkbox": "Multiple options can be selected. Example: \"Symptoms present\".",
  "admin.programs.questionnaire.question.typeExample.integer": "Whole numbers only. Example: \"Gestational age (weeks)\".",
  "admin.programs.questionnaire.question.typeExample.decimal": "Numbers with decimals. Example: \"Maternal weight (kg)\".",
  "admin.programs.questionnaire.question.typeExample.date": "Calendar date. Example: \"Date of last menstrual period\".",
  "admin.programs.questionnaire.question.typeExample.time": "Time of day. Example: \"Time of sample collection\".",
  "admin.programs.questionnaire.question.typeExample.string": "Short free-text. Example: \"Provider name\".",
  "admin.programs.questionnaire.question.typeExample.text": "Long free-text. Example: \"Clinical notes\".",
  "admin.programs.questionnaire.question.typeExample.quantity": "A number plus a unit (e.g. \"Volume collected — 5 mL\"). The allowed unit(s) come from a FHIR extension set in JSON mode; a GUI-only Quantity accepts any unit.",
  "admin.config.logo.error.fileTooLarge": "La imagen es demasiado grande. El tamaño máximo es de 2 MB.",
  "admin.config.logo.formats": "Formatos: JPG, PNG, GIF (máx. 2 MB)",
  "admin.label": "Administración",
  "admin.labUnit.basicInfo.domain.clinical": "Clínico",
  "admin.labUnit.basicInfo.domain.environmental": "Medioambiental",
  "admin.labUnit.basicInfo.domain.label": "Dominio",
  "admin.labUnit.basicInfo.domain.vector": "Vector",
  "admin.labUnit.domain.confirm.body": "Las órdenes/resultados históricos se evaluaron con las reglas del dominio anterior. Las nuevas órdenes utilizarán las reglas del nuevo dominio.",
  "admin.labUnit.domain.confirm.heading": "¿Cambiar el dominio de la unidad de laboratorio?",
  "admin.labUnit.edit.select": "Seleccione la unidad de laboratorio",
  "admin.labUnit.edit.title": "Editar el dominio de la unidad de laboratorio",
  "admin.labUnit.list.filter.domain": "Filtrar por dominio",
  "admin.legacy": "Administración heredada",
  "button.back": "← Volver a la lista",
  "button.labUnit.add": "Agregar unidad de laboratorio",
  "button.labUnit.create": "Crear unidad de laboratorio",
  "button.labUnit.creating": "Creando...",
  "button.labUnit.tests.assign": "Asignar pruebas",
  "button.labUnit.tests.assign.confirm": "Asignar {count, plural, one {# prueba} other {# pruebas}}",
  "button.labUnit.tests.reassign": "Reasignar los elementos seleccionados ({count})",
  "button.labUnit.tests.reassign.confirm": "Reasignar {count, plural, one {# prueba} other {# pruebas}}",
  "configuration.labUnit.manage": "Gestión de la unidad de laboratorio",
  "error.labUnit.description.maxLength": "La descripción debe tener {max} caracteres como máximo",
  "error.labUnit.domain.required": "Es obligatorio introducir un dominio",
  "error.labUnit.list.load": "Error al cargar las unidades de laboratorio",
  "error.labUnit.name.duplicate": "El nombre de esta unidad de laboratorio ya existe",
  "error.labUnit.name.maxLength": "El nombre debe tener {max} caracteres como máximo",
  "error.request.unreadable": "Nothing was saved: the server did not accept one of the values sent. Check the form and try again.",
  "error.labUnit.name.required": "Es obligatorio introducir el nombre",
  "heading.labUnit.add": "Agregar una nueva unidad de laboratorio",
  "heading.labUnit.editing": "Edición: {name}",
  "heading.labUnit.filtered": "Mostrando {filtered} de {total} unidades de laboratorio",
  "heading.labUnit.management": "Gestión de la unidad de laboratorio",
  "heading.labUnit.subtitle": "Configure las unidades de laboratorio (secciones de laboratorio), la clasificación por ámbitos, la asignación de pruebas y el orden de visualización.",
  "heading.labUnit.total": "Total: {total} unidades de laboratorio",
  "helper.labUnit.description": "Breve descripción interna de esta unidad de laboratorio, para uso del personal del laboratorio",
  "helper.labUnit.domain": "Determina qué campos de entrada de órdenes y de recolección de muestras se aplican a las órdenes derivadas a esta unidad de laboratorio.",
  "helper.labUnit.name": "Introduzca un nombre único para esta unidad de laboratorio (por ejemplo, «Hematología», «Microbiología»)",
  "label.labUnit.actions": "Acciones",
  "label.labUnit.active": "Activo",
  "label.labUnit.description": "Descripción",
  "label.labUnit.displayOrder": "Posición",
  "label.labUnit.displayOrder.addHint": "Guarde primero esta unidad de laboratorio y, a continuación, configure su orden de visualización.",
  "label.labUnit.displayOrder.current": "Actual",
  "label.labUnit.displayOrder.intro": "Coloque esta unidad de laboratorio en los menús y listas desplegables de unidades de laboratorio de todo el sistema. Introduzca una posición y guarde los cambios; las unidades de laboratorio restantes se renumerarán automáticamente.",
  "label.labUnit.displayOrder.loading": "Cargando el orden de visualización...",
  "label.labUnit.displayOrder.saved": "Orden de visualización guardado",
  "label.labUnit.displayOrder.saveError": "No se ha podido guardar el orden de visualización",
  "label.labUnit.domain": "Dominio",
  "label.labUnit.filterStatus": "Filtrar por estado",
  "label.labUnit.list.loading": "Cargando unidades de laboratorio...",
  "label.labUnit.loading": "Cargando la unidad de laboratorio...",
  "label.labUnit.notFound": "This lab unit does not exist. Go back to the list to choose another.",
  "label.labUnit.editorLoadError": "The lab units could not be loaded. Refresh the page to try again.",
  "label.labUnit.name": " Nombre",
  "label.labUnit.nameInLocale": "Nombre ({language})",
  "error.labUnit.tests.action": "La acción de asignación de pruebas ha fallado",
  "error.labUnit.deactivate.failed": "The lab unit was not deactivated. Check the options and try again.",
  "error.labUnit.deactivate.destinationInactive": "The destination lab unit is inactive. Choose an active unit, or reactivate it first.",
  "heading.labUnit.tests.assign": "Asignar pruebas a esta unidad de laboratorio",
  "heading.labUnit.tests.reassign": "Reasignar pruebas",
  "label.labUnit.tests.assign.explain": "Las pruebas pertenecen a una única unidad de laboratorio. Al asignar una prueba aquí, esta se retira de su unidad de laboratorio actual (que aparece junto a cada prueba).",
  "label.labUnit.tests.assign.none": "No se han encontrado pruebas asignables.",
  "label.labUnit.tests.reassign.destination": "Unidad de laboratorio de destino",
  "label.labUnit.tests.reassign.explain": "La reasignación surte efecto de forma inmediata. Los nuevos pedidos se envían a la unidad de laboratorio de destino; los resultados ya procesados conservan sus datos originales.",
  "label.labUnit.tests.reassign.inactiveDestination": "This lab unit is inactive: the moved tests cannot be ordered until it is reactivated. Completed results keep their original data.",
  "label.labUnit.inactiveOption": "{name} (inactive)",
  "label.labUnit.tests.reassign.moving": "{count, plural, one {# test} many {# tests} other {# pruebas}} will be moved:",
  "message.labUnit.tests.assigned": "Pruebas asignadas a esta unidad de laboratorio.",
  "message.labUnit.tests.reassigned": "Las pruebas se han reasignado correctamente.",
  "placeholder.labUnit.tests.reassign.destination": "Seleccione el destino...",
  "placeholder.labUnit.tests.search": "Buscar pruebas...",
  "label.labUnit.section.assigned-tests": "Pruebas asignadas",
  "label.labUnit.section.basic-info": "Información básica",
  "label.labUnit.section.display-order": "Orden de visualización",
  "label.labUnit.status": "Estado",
  "label.labUnit.testCount": "Pruebas",
  "label.labUnit.tests.addHint": "Guarde primero esta unidad de laboratorio y, a continuación, asigne las pruebas.",
  "label.labUnit.tests.count": "{count, plural, one {# test assigned} many {# tests assigned} other {# pruebas asignadas}}",
  "label.labUnit.tests.loadError": "No se pueden cargar las pruebas asignadas",
  "label.labUnit.tests.loading": "Cargando las pruebas asignadas...",
  "label.labUnit.tests.none": "Aún no se han asignado pruebas a esta unidad de laboratorio.",
  "label.labUnit.tests.testName": " Nombre de la prueba",
  "message.labUnit.add.success": "La unidad de laboratorio se ha creado correctamente.",
  "message.labUnit.edit.success": "La unidad de laboratorio se ha guardado exitosamente.",
  "message.labUnit.noResults": "No se han encontrado unidades de laboratorio que se ajusten a sus criterios",
  "placeholder.labUnit.filter.domain": "Todos los dominios",
  "placeholder.labUnit.filter.status": "Todos los estados",
  "placeholder.labUnit.search": "Buscar unidades de laboratorio...",
  "sidenav.label.admin.labUnit.addingNew": "Agregar una nueva unidad de laboratorio",
  "sidenav.label.admin.labUnit.backToList": "← Todas las unidades de laboratorio",
  "sidenav.label.admin.labUnit.editing": "Edición: {name}",
  "sidenav.label.admin.labUnit.editingGeneric": "Edición de unidad de laboratorio",
  "sidenav.label.admin.labUnit.sectionsHelper": "Haga clic en una unidad de laboratorio para editar sus secciones",
  "sidenav.label.admin.labUnitManagement": "Editor de unidades de laboratorio",
  "warning.labUnit.deactivateInUse": "{count, plural, one {# active test is assigned to this lab unit. Deactivating hides it from ordering but keeps the assignment.} many {# active tests are assigned to this lab unit. Deactivating hides it from ordering but keeps the assignments.} other {# pruebas activas están asignadas a esta unidad de laboratorio. Desactivarla la oculta para las solicitudes pero mantiene las asignaciones.}}",
  "heading.labUnit.deactivate": "Deactivate lab unit",
  "button.labUnit.deactivate.confirm": "Deactivate lab unit",
  "label.labUnit.deactivate.loading": "Checking what this would affect…",
  "label.labUnit.deactivate.impact": "This lab unit currently holds:",
  "label.labUnit.deactivate.impact.tests": "{count} assigned tests ({active} active)",
  "label.labUnit.deactivate.impact.pending": "{count} pending analyses",
  "label.labUnit.deactivate.impact.historical": "{count} completed analyses (history is never removed)",
  "info.labUnit.deactivate.pending": "This lab unit stays on the worklists until its {count} pending analyses are completed.",
  "label.labUnit.deactivate.option": "What should happen to the assigned tests?",
  "label.labUnit.deactivate.option.keep": "Keep assignments — tests stay assigned, the unit stops taking new orders",
  "label.labUnit.deactivate.option.deactivateAll": "Deactivate all assigned tests as well",
  "label.labUnit.deactivate.option.reassign": "Reassign the tests to another lab unit first",
  "label.labUnit.deactivate.confirm": "Type DEACTIVATE to confirm",
  "admin.page.configuration.formEntryConfigMenu.button.add": "Agregar",
  "admin.page.configuration.formEntryConfigMenu.button.deactivate": "Desactivar",
  "admin.page.configuration.formEntryConfigMenu.button.exit": "Salir",
  "admin.page.configuration.formEntryConfigMenu.button.modify": "Modificar",
  "admin.page.configuration.formEntryConfigMenu.button.save": "Guardar",
  "admin.page.configuration.formEntryConfigMenu.description": "Descripción",
  "admin.page.configuration.formEntryConfigMenu.editRecord": "Editar registro",
  "admin.page.configuration.formEntryConfigMenu.name": "Nombre",
  "admin.page.configuration.formEntryConfigMenu.select": "Seleccionar",
  "admin.page.configuration.formEntryConfigMenu.value": "Valor",
  "admin.labelPresets.title": "Ajustes predefinidos de etiquetas",
  "admin.labelPresets.addButton": "Agregar preajuste",
  "admin.labelPresets.search.placeholder": "Buscar configuraciones predefinidas...",
  "admin.labelPresets.col.name": " Nombre",
  "admin.labelPresets.col.barcodeType": "Tipo de código de barras",
  "admin.labelPresets.col.dimensions": "Dimensiones",
  "admin.labelPresets.col.scope": "Ámbito de aplicación",
  "admin.labelPresets.col.status": "Estado",
  "admin.labelPresets.col.actions": "Acciones",
  "admin.labelPresets.systemTag": "Sistema",
  "admin.labelPresets.status.active": "Activo",
  "admin.labelPresets.status.inactive": "Inactivo",
  "admin.labelPresets.scope.order": "Orden",
  "admin.labelPresets.scope.sample": "Muestra",
  "admin.labelPresets.action.edit": "Editar",
  "admin.labelPresets.action.duplicate": "Duplicar",
  "admin.labelPresets.action.activate": "Activar",
  "admin.labelPresets.action.deactivate": "Desactivar",
  "admin.labelPresets.duplicateName": "Copia de {name}",
  "admin.labelPresets.duplicated": "Se ha duplicado el ajuste preestablecido",
  "admin.labelPresets.duplicateFailed": "No se ha podido duplicar",
  "admin.labelPresets.activated": "Preajuste activado",
  "admin.labelPresets.deactivated": "Preajuste desactivado",
  "admin.labelPresets.toggleFailed": "No se ha podido actualizar el estado",
  "admin.labelPresets.saveFailed": " Error al guardar",
  "admin.labelPresets.saveFailed.detail": "The server answered {status}: {message}",
  "admin.labelPresets.saveFailed.noResponse": "No response from the server. Check the connection and try again.",
  "error.labelpreset.fields.unique": "Each content field and each display position may be used only once per preset.",
  "error.labelpreset.field.required": "Every content field entry must name a field.",
  "admin.labelPresets.created": "Preset created",
  "admin.labelPresets.updated": "Preset updated",
  "admin.labelPresets.editor.titleAdd": "Agregar configuración predefinida de etiqueta",
  "admin.labelPresets.editor.titleEdit": "Editar preajuste de etiqueta",
  "admin.labelPresets.editor.section.basicInfo": "Información básica",
  "admin.labelPresets.editor.section.dimensions": "Dimensiones (mm)",
  "admin.labelPresets.editor.section.barcodeSettings": "Configuración de códigos de barras",
  "admin.labelPresets.editor.section.printScope": "Ámbito de impresión y cantidades",
  "admin.labelPresets.field.name": "Nombre del preajuste",
  "admin.labelPresets.field.isActive": "Activo",
  "admin.labelPresets.field.heightMm": "Altura (mm)",
  "admin.labelPresets.field.widthMm": "Ancho (mm)",
  "admin.labelPresets.field.barcodeType": "Tipo de código de barras",
  "admin.labelPresets.field.defaultPerOrder": "Cantidad predeterminada por orden",
  "admin.labelPresets.field.maxPerOrder": "Máximo por orden",
  "admin.labelPresets.field.defaultPerSample": "Cantidad predeterminada por muestra",
  "admin.labelPresets.field.maxPerSample": "Máximo por muestra",
  "admin.labelPresets.validation.name.required": "Es obligatorio ingresar el nombre",
  "admin.labelPresets.validation.name.toolong": "El nombre no debe superar los 120 caracteres",
  "admin.labelPresets.validation.dimension.range": "La dimensión debe estar comprendida entre 5 y 200 mm",
  "admin.labelPresets.validation.barcodeType.required": "Es obligatorio indicar el tipo de código de barras",
  "admin.labelPresets.validation.scope.required": "Debe seleccionarse al menos un ámbito de impresión (Orden o Muestra)",
  "admin.labelPresets.validation.max.lte": "El máximo debe ser mayor o igual que el valor predeterminado",
  "admin.labelPresets.editor.section.fields": "Content fields",
  "admin.labelPresets.fields.helper": "The fields printed above the barcode, in this order. Lab Number is always first.",
  "admin.labelPresets.fields.locked": "Always first",
  "admin.labelPresets.fields.required": "Required",
  "admin.labelPresets.fields.required.aria": "Required: {field}",
  "admin.labelPresets.fields.moveUp": "Move {field} up",
  "admin.labelPresets.fields.moveDown": "Move {field} down",
  "admin.labelPresets.fields.remove": "Eliminar «{field}»",
  "admin.labelPresets.fields.add.label": "Add a field",
  "admin.labelPresets.fields.add.placeholder": "Choose a field",
  "admin.labelPresets.fields.add.button": "Agregar",
  "admin.labelPresets.fields.allAdded": "Every available field is on this label.",
  "admin.labelPresets.fields.fitHint": "The {count, plural, one {selected field} other {# selected fields}} may not fit a {height} mm label; about {rows, plural, one {# row fits} other {# rows fit}} above the barcode. You can still save.",
  "admin.labelPresets.fields.position": "Position {position}",
  "admin.labelPresets.fieldKey.LAB_NUMBER": " Número de laboratorio",
  "admin.labelPresets.fieldKey.PATIENT_NAME": "Nombre del paciente",
  "admin.labelPresets.fieldKey.PATIENT_ID": " ID del paciente",
  "admin.labelPresets.fieldKey.PATIENT_DOB": "Fecha de nacimiento del paciente",
  "admin.labelPresets.fieldKey.PATIENT_SEX": " Sexo del paciente",
  "admin.labelPresets.fieldKey.SITE_ID": "ID del sitio",
  "admin.labelPresets.fieldKey.COLLECTION_DATETIME": "Fecha y hora de recolección",
  "admin.labelPresets.fieldKey.COLLECTED_BY": "Recolectado por",
  "admin.labelPresets.fieldKey.TESTS": "Pruebas",
  "admin.labelPresets.fieldKey.SPECIMEN_TYPE": "Tipo de muestra",
  "admin.labelPresets.fieldKey.BLOCK_ID": "ID del bloque",
  "admin.labelPresets.fieldKey.SLIDE_ID": "N.º de diapositiva",
  "admin.labelPresets.fieldKey.STAIN_TYPE": "Tipo de tinción",
  "admin.labelPresets.fieldKey.CASE_NUMBER": "Número de caso",
  "admin.labelPresets.fieldKey.STORAGE_LOCATION": "Ubicación de almacenamiento",
  "admin.labelPresets.fieldKey.EXPIRY_DATE": "Fecha de caducidad",
  "error.labelpreset.field.key.unknown": "Unknown content field.",
  "admin.labelPresets.siteWide.title": "Site-wide Barcode Settings",
  "admin.labelPresets.siteWide.scope": "Applies laboratory-wide",
  "admin.labelPresets.siteWide.prePrint.legend": "Pre-printed label numbers come from",
  "admin.labelPresets.siteWide.prePrint.orderEntry": "The same format and number pool as order entry",
  "admin.labelPresets.siteWide.prePrint.separate": "A separate pre-printed series",
  "admin.labelPresets.siteWide.prefix.label": "Prefijo",
  "admin.labelPresets.siteWide.prefix.helper": "Exactly 4 letters or digits. Pre-printed numbers start with this prefix, then the year and a sequence number.",
  "admin.labelPresets.siteWide.prefix.invalid": "The prefix must be exactly 4 letters or digits",
  "admin.labelPresets.siteWide.save": "Save settings",
  "admin.labelPresets.siteWide.saved": "Site-wide barcode settings saved",
  "admin.labelPresets.siteWide.saveFailed": "Site-wide barcode settings were not saved",
  "admin.labelPresets.siteWide.loadFailed": "The site-wide barcode settings could not be loaded. Reload the page to try again.",
  "error.sitesettings.barcode.prefix.format": "The pre-printed prefix must be exactly 4 letters or digits when a separate series is used",
  "advanced.search": "Búsqueda avanzada",
  "alert.expired.title": "Elementos caducados",
  "alert.expiring.title": "Caduca en breve",
  "alert.lowStock.title": "Alerta de existencias bajas",
  "alerts.acknowledge.button": "Confirmar",
  "alerts.acknowledge.comment": "Comentario sobre la resolución",
  "alerts.acknowledge.comment.placeholder": "Describa cómo se abordó esta alerta...",
  "alerts.acknowledge.comment.required": "Se requiere un comentario sobre la resolución en el caso de las alertas críticas",
  "alerts.acknowledge.error": "No se pudo confirmar la alerta",
  "alerts.acknowledge.success": "La alerta se ha confirmado correctamente",
  "alerts.acknowledge.title": "Confirmar alerta",
  "alerts.autoRefresh": "Actualización automática cada 60 segundos",
  "alerts.dashboard.title": "Panel de alertas",
  "alerts.empty": "No hay alertas que mostrar",
  "alerts.eqaDeadlineSummary.critical": "Crítico",
  "alerts.eqaDeadlineSummary.deadlineCount": "{count} próximos plazos",
  "alerts.eqaDeadlineSummary.subtitle": "Próximos plazos de presentación de la ECA, agrupados por proveedor",
  "alerts.eqaDeadlineSummary.title": "Resumen de los plazos de la ECA",
  "alerts.eqaDeadlineSummary.viewAll": "Consultar todos",
  "alerts.filter.myAlerts": "Mis alertas",
  "alerts.filter.search": "Buscar alertas...",
  "alerts.filter.severity": " Severidad",
  "alerts.filter.status": "Estado",
  "alerts.filter.type": "Tipo de alerta",
  "alerts.severity.critical": "Crítico",
  "alerts.severity.warning": "Advertencia",
  "alerts.status.acknowledged": "Confirmada",
  "alerts.status.open": "Abierta",
  "alerts.status.resolved": "Resuelto",
  "alerts.summary.critical": "Alertas críticas",
  "alerts.summary.eqaDeadlines": "Plazos de la ECA",
  "alerts.summary.sampleExpiration": "Muestras a punto de caducar",
  "alerts.summary.statOverdue": "Órdenes STAT vencidas",
  "alerts.summary.totalOpen": "Total de puestos vacantes",
  "alerts.table.actions": "Acciones",
  "alerts.table.created": "Creado",
  "alerts.table.message": "Mensaje",
  "alerts.table.severity": " Severidad",
  "alerts.table.status": "Estado",
  "alerts.table.type": "Tipo",
  "alerts.type.critical_result": "Critical Result",
  "alerts.type.equipment_failure": "Avería del equipo",
  "alerts.type.freezer_humidity": "Freezer Humidity",
  "alerts.type.freezer_offline": "Freezer Offline",
  "alerts.type.freezer_temperature": "Freezer Temperature",
  "alerts.type.inventory_low": "Low stock",
  "alerts.type.other": "Otros",
  "alerts.type.referral_critical_result": "Referral Critical Result",
  "alerts.type.referral_rejected": "Referral Rejected",
  "alerts.type.sample_tracking": "Sample Tracking",
  "alerts.type.critical_unacknowledged": "Crítica no confirmada",
  "alerts.type.eqa_deadline": "Plazo de la ECA",
  "alerts.type.eqa_submission_failed": "EQA Submission Failed",
  "alerts.type.microbiology_critical": "Crítico de microbiología",
  "alerts.type.required_by_deadline": "Obligatorio antes de la fecha límite",
  "alerts.type.sample_expiration": "Caducidad de las muestras",
  "alerts.type.stat_overdue": "STAT atrasado",
  "alerts.type.stat_upcoming": "STAT próximo",
  "aliquot": "Alícuota",
  "aliquot.analyses.count": "Análisis: {count}",
  "aliquot.id": "Identificador de alícuota",
  "aliquot.quantity": "Cantidad de la alícuota",
  "aliquot.quantity.not.balanced": "Cantidad no equilibrada para el tipo de muestra",
  "aliquot.save.error": "Se ha producido un error al guardar los datos de la división en alícuotas.",
  "aliquot.save.success": "Los datos de las alícuotas se han guardado exitosamente.",
  "aliquot.tests.not.assigned": "Pruebas no asignadas para este tipo de muestra",
  "aliquot.validation.errors": "Errores de validación",
  "aliquoting": "División en alícuotas",
  "aliquoting.section": "Sección de alícuotas",
  "all.label": "Todos",
  "all.tests.assigned": "Todas las pruebas asignadas",
  "allocated.to.aliquots": "Asignado a alícuotas",
  "analysis.count": "Recuento de análisis",
  "analysis.details": "Detalles del análisis",
  "analyzer.adoption.error.heldResults": "{record} still has held results from revision {revision}. Resolve them before adopting.",
  "analyzer.adoption.error.inactiveTest": "{record} is mapped to a test that is no longer active. Choose another test before adopting.",
  "analyzer.adoption.error.missingAnswers": "{record} needs a decision for each of its answers. Missing: {answers}.",
  "analyzer.adoption.error.missingDecisions": "Every record the newer revision keeps needs a decision. Missing: {records}.",
  "analyzer.adoption.error.notNewer": "Adoption moves an analyzer to a revision newer than revision {revision}.",
  "analyzer.adoption.error.revisionInactive": "Revision {revision} of this analyzer type is not active.",
  "analyzer.bridge.connection.httpStatus": "The Analyzer Bridge refused the request.",
  "analyzer.bridge.connection.invalidEvidence": "The Analyzer Bridge answered for a different analyzer or analyzer type.",
  "analyzer.bridge.connection.invalidRequest": "The request to the Analyzer Bridge was incomplete.",
  "analyzer.bridge.connection.notConfigured": "No Analyzer Bridge is configured for this server.",
  "analyzer.bridge.connection.reconcileRequired": "OpenELIS kept the analyzer's previous mapping, but the Analyzer Bridge may still be on the new one. Apply the mapping again when the Bridge is reachable to bring them back in step.",
  "analyzer.bridge.connection.referenceNotStored": "The Analyzer Bridge connection could not be saved with this analyzer.",
  "analyzer.bridge.connection.unreachable": "The Analyzer Bridge could not be reached.",
  "analyzer.mapping.error.catalogNotCurrent": "A mapped test or answer is no longer active in the test catalog. Choose another before confirming.",
  "analyzer.mapping.error.changedSinceLoaded": "This analyzer's mapping changed after this page was loaded. Reload the page to see the current mapping.",
  "analyzer.mapping.error.componentRequired": "{record} lands on a component of its test. Choose that component, or leave the record unresolved.",
  "analyzer.mapping.error.confirmBeforeApply": "Confirm the analyzer's current mapping before applying it.",
  "analyzer.mapping.error.recognitionChanged": "The analyzer type's control recognition changed after this page was loaded. Reload the page before confirming.",
  "analyzer.mapping.error.resultNotCurrent": "A mapped answer is no longer active for its test. Choose another answer.",
  "analyzer.mapping.error.testNotCurrent": "A mapped test is no longer active in the test catalog. Choose another test.",
  "analyzer.setup.assays.continue": "Continúe con la verificación",
  "analyzer.setup.assays.count": "{on} of {total} assays on",
  "analyzer.setup.assays.help": "Turn on the assays this instrument runs, as in its own host test code settings. Verify maps only the assays that are on. A result for an assay that is off is held, never lost.",
  "analyzer.setup.assays.loadError": "The analyzer's assays could not be loaded.",
  "analyzer.setup.assays.loading": "Loading assays",
  "analyzer.setup.assays.match.ambiguous": "Several tests in this lab's catalog match",
  "analyzer.setup.assays.match.bound": "Matches {name}",
  "analyzer.setup.assays.match.excluded": "Set not to be received",
  "analyzer.setup.assays.match.incompatible": "A test matches but cannot hold these results",
  "analyzer.setup.assays.match.noMatch": "No test in this lab's catalog",
  "analyzer.setup.assays.none": "This analyzer type declares no assays, so there is nothing to map. Results it sends are held as unknown tests and can be mapped from the held result.",
  "analyzer.setup.assays.saveError": "The assays could not be saved.",
  "analyzer.setup.assays.title": "Assays",
  "analyzer.setup.error.adoptToMove": "To move this analyzer to revision {revision}, adopt it from the analyzer type page.",
  "analyzer.setup.error.profileKept": "A configured analyzer keeps its analyzer type.",
  "analyzer.reset.error.profileAvailable": "This analyzer's type is still available. Adopt a newer revision to move it.",
  "analyzer.setup.connect.reset": "Reset analyzer type",
  "analyzer.setup.connect.reset.failed": "The analyzer type could not be reset. Try again.",
  "analyzer.action.activate": "Activar",
  "analyzer.action.add": "Agregar analizador",
  "analyzer.action.configureConnection": "Configurar la conexión",
  "analyzer.action.deactivate": "Desactivar",
  "analyzer.action.editSetup": "Editar configuración",
  "analyzer.action.qualityControl": "Control de calidad",
  "analyzer.action.reactivate": "Reactivar",
  "analyzer.bridgePairing.automatic": "OpenELIS pairs with the code it is configured with on its own. You can also enter the code here.",
  "analyzer.bridgePairing.cancel": "Cancelar",
  "analyzer.bridgePairing.code.label": "Pairing code",
  "analyzer.bridgePairing.error.certificateMismatch": "The Bridge answered for a different certificate than the one it presented, so OpenELIS did not pair with it.",
  "analyzer.bridgePairing.error.closed": "The Bridge is not accepting a pairing. Configure a new pairing code on the Bridge, restart it, and pair again.",
  "analyzer.bridgePairing.error.codeRequired": "Enter the pairing code.",
  "analyzer.bridgePairing.error.identity": "OpenELIS could not create or read its key for the Bridge.",
  "analyzer.bridgePairing.error.invalidAnswer": "The Bridge's answer could not be read.",
  "analyzer.bridgePairing.error.notConfigured": "No Analyzer Bridge address is configured for OpenELIS.",
  "analyzer.bridgePairing.error.refused": "The Bridge refused the pairing.",
  "analyzer.bridgePairing.error.unreachable": "OpenELIS could not reach the Analyzer Bridge.",
  "analyzer.bridgePairing.error.wrongCode": "The Bridge did not accept that code.",
  "analyzer.bridgePairing.pair": "Pair",
  "analyzer.bridgePairing.pairAgain": "Pair again",
  "analyzer.bridgePairing.paired.detail": "{url} · Bridge certificate {fingerprint} · paired {pairedAt}",
  "analyzer.bridgePairing.paired.title": "Paired with the Analyzer Bridge",
  "analyzer.bridgePairing.unpaired.subtitle": "Enter the pairing code the Bridge shows in its log, or the one it was configured with. Results wait in the Bridge until it is paired.",
  "analyzer.bridgePairing.unpaired.title": "The Analyzer Bridge is not paired",
  "analyzer.combinationName.notification": "La combinación de analizador y nombre de prueba del analizador debe ser única",
  "analyzer.fhirImport.error.importFailed": "Se ha producido un error al importar el paquete FHIR",
  "analyzer.fhirImport.error.invalidBundleType": "El tipo de paquete debe ser «transaction» o «batch»; se ha obtenido: {bundleType}",
  "analyzer.fhirImport.error.noObservations": "El paquete no contiene recursos de observación con resultados",
  "analyzer.deliveryIssues.attention.review": "Review undelivered results",
  "analyzer.deliveryIssues.attention.subtitle": "The Analyzer Bridge is holding results it could not deliver to OpenELIS.",
  "analyzer.deliveryIssues.attention.title": "{count, plural, one {# analyzer result was} other {# analyzer results were}} not delivered",
  "analyzer.deliveryIssues.column.actions": "Acciones",
  "analyzer.deliveryIssues.column.analyzer": "Analizador",
  "analyzer.deliveryIssues.column.detail": "Detalles",
  "analyzer.deliveryIssues.column.reason": "Motivo",
  "analyzer.deliveryIssues.column.received": "Recibido",
  "analyzer.deliveryIssues.column.status": "Estado",
  "analyzer.deliveryIssues.description": "Results the Analyzer Bridge received but has not delivered to OpenELIS. Retry sends a result again once its cause is fixed; Dismiss hides it and keeps it in the Bridge for audit.",
  "analyzer.deliveryIssues.dismiss": "Descartar",
  "analyzer.deliveryIssues.empty": "The Bridge has no undelivered results.",
  "analyzer.deliveryIssues.error.actionFailed": "The action could not be completed. Reload and try again.",
  "analyzer.deliveryIssues.error.bridgeInvalidResponse": "The Analyzer Bridge sent a response OpenELIS could not read.",
  "analyzer.deliveryIssues.error.incompleteList": "The Analyzer Bridge has more undelivered results than this view can load. Review the Bridge outbox directly.",
  "analyzer.deliveryIssues.error.bridgeNotConfigured": "OpenELIS has no Analyzer Bridge address configured.",
  "analyzer.deliveryIssues.error.bridgeRefused": "The Bridge refused this action ({reason}). Reload to see its current state.",
  "analyzer.deliveryIssues.error.bridgeUnreachable": "The Analyzer Bridge could not be reached.",
  "analyzer.deliveryIssues.error.invalidId": "This result reference is not valid.",
  "analyzer.deliveryIssues.loadFailed": "Undelivered results could not be loaded from the Analyzer Bridge.",
  "analyzer.deliveryIssues.loading": "Checking the Analyzer Bridge for undelivered results",
  "analyzer.deliveryIssues.reason.AMBIGUOUS_SOURCE": "More than one analyzer connection could own this message. Give each analyzer a distinct address, then retry.",
  "analyzer.deliveryIssues.reason.CONNECTION_TRANSPORT_MISMATCH": "The analyzer sent over a connection type its setup does not accept.",
  "analyzer.deliveryIssues.reason.OE_CONFIG_STATE": "OpenELIS declined the result because of its own setup. Fix the analyzer setup, then retry.",
  "analyzer.deliveryIssues.reason.OE_REJECTED": "OpenELIS rejected the result.",
  "analyzer.deliveryIssues.reason.OE_UNEXPECTED_REDIRECT": "OpenELIS answered with a redirect, so the result was not delivered. Check the Bridge's OpenELIS address.",
  "analyzer.deliveryIssues.reason.PARSE_NO_RESULTS": "The message contained no results to deliver.",
  "analyzer.deliveryIssues.reason.RENDER_ERROR": "The Bridge could not convert the message for OpenELIS.",
  "analyzer.deliveryIssues.reason.RETRY_EXHAUSTED": "OpenELIS stayed unreachable until every retry was used. The result is intact; retry once OpenELIS is reachable.",
  "analyzer.deliveryIssues.reason.UNPINNED_PROFILE": "The analyzer's connection has no analyzer type revision, so its results cannot be read.",
  "analyzer.deliveryIssues.reason.UNREGISTERED_SOURCE": "The sender matches no saved analyzer connection. Set up the analyzer, then retry.",
  "analyzer.deliveryIssues.reason.none": "OpenELIS has not accepted the result yet; the Bridge keeps retrying.",
  "analyzer.deliveryIssues.reason.unknown": "The Bridge could not deliver this result ({code}).",
  "analyzer.deliveryIssues.retry": "Reintentar",
  "analyzer.deliveryIssues.state.deadLettered": "Not delivered",
  "analyzer.deliveryIssues.state.retrying": "Retrying",
  "analyzer.deliveryIssues.title": "Undelivered analyzer results",
  "analyzer.deliveryIssues.unrecognizedSender": "Unrecognized sender {source}",
  "analyzer.importIssues.accession": "Número de acceso",
  "analyzer.importIssues.action": "Acción",
  "analyzer.importIssues.description": "Revise los eventos del Analizador microbiológico que no se hayan podido emparejar ni procesar. Los resultados retenidos se revisan en la lista de trabajo de resultados de cada Analizador.",
  "analyzer.importIssues.empty": "No hay incidencias relacionadas con fallos en los analizadores microbiológicos que requieran atención",
  "analyzer.importIssues.event": "Evento",
  "analyzer.importIssues.event.astQcFail": "Fallo en el control de calidad de AST",
  "analyzer.importIssues.event.astResultAvailable": "Resultado de la prueba AST disponible",
  "analyzer.importIssues.event.unknown": "Evento del Analizador ({code})",
  "analyzer.importIssues.events.description": "Corrija la asignación del analizador o la información del destino antes de que la fuente vuelva a enviar el resultado.",
  "analyzer.importIssues.events.title": "Eventos del Analizador bloqueados",
  "analyzer.importIssues.failure.astRunNotMatched": "No se ha encontrado ninguna ejecución de AST que coincida con los identificadores del Analizador y de la tarjeta.",
  "analyzer.importIssues.failure.processingFailed": "No se ha podido procesar el evento del Analizador.",
  "analyzer.importIssues.failure.unknown": "No se ha podido procesar el evento del Analizador ({code}).",
  "analyzer.importIssues.loadFailed": "No se han podido cargar los problemas de importación del Analizador",
  "analyzer.importIssues.loading": "Cargando los problemas de importación del analizador",
  "analyzer.importIssues.openMappings": "Abrir asignaciones",
  "analyzer.importIssues.openResults": "Abrir resultados del analizador",
  "analyzer.importIssues.reason": "Motivo del fallo",
  "analyzer.importIssues.received": "Recibido",
  "analyzer.importIssues.result": "Resultado",
  "analyzer.importIssues.source": "ID de origen",
  "analyzer.importIssues.staging.description": "Estas filas de resultados importadas requieren una configuración correcta del Analizador antes de su validación.",
  "analyzer.importIssues.staging.title": "Problemas con resultados en preparación",
  "analyzer.importIssues.target": "Referencia de destino",
  "analyzer.importIssues.test": "Prueba",
  "analyzer.importIssues.title": "Problemas con la importación del Analizador",
  "analyzer.fieldCreation.acceptedUnits.label": "Unidades aceptadas",
  "analyzer.fieldCreation.acceptedUnits.placeholder": "Seleccione las unidades aceptadas",
  "analyzer.fieldCreation.cancel": "Cancelar",
  "analyzer.fieldCreation.confirmation": "Tengo entendido que este campo estará disponible para su asignación inmediatamente después de su creación.",
  "analyzer.fieldCreation.create": "Crear campo",
  "analyzer.fieldCreation.createNew": "Crear un nuevo campo",
  "analyzer.fieldCreation.description.label": "Descripción (opcional)",
  "analyzer.fieldCreation.description.placeholder": "Introduzca la descripción del campo",
  "analyzer.fieldCreation.entityType.label": "Tipo de entidad",
  "analyzer.fieldCreation.entityType.placeholder": "Seleccione el tipo de entidad",
  "analyzer.fieldCreation.error.generic": "No se ha podido crear el campo",
  "analyzer.fieldCreation.error.title": "Error al crear el campo",
  "analyzer.fieldCreation.fieldName.label": "Nombre del campo",
  "analyzer.fieldCreation.fieldName.placeholder": "Introduzca el nombre del campo",
  "analyzer.fieldCreation.fieldType.label": "Tipo de campo",
  "analyzer.fieldCreation.fieldType.placeholder": "Seleccione el tipo de campo",
  "analyzer.fieldCreation.loincCode.label": "Código LOINC (opcional)",
  "analyzer.fieldCreation.loincCode.placeholder": "Introduzca el código LOINC",
  "analyzer.fieldCreation.modal.subtitle": "Cree un nuevo campo que esté disponible para su asignación de forma inmediata",
  "analyzer.fieldCreation.modal.title": "Crear un nuevo campo de OpenELIS",
  "analyzer.fieldCreation.success.message": "El campo ya está disponible para su asignación",
  "analyzer.fieldCreation.success.title": "El campo se ha creado correctamente",
  "analyzer.fieldCreation.validation.entityType.required": "Es obligatorio indicar el tipo de entidad",
  "analyzer.fieldCreation.validation.fieldName.required": "Es obligatorio rellenar el nombre del campo",
  "analyzer.fieldCreation.validation.unique": "Ya existe un campo con este nombre",
  "analyzer.fieldCreation.validation.units.required": "Los campos numéricos deben contener unidades válidas",
  "analyzer.filter.lifecycleStage.all": "Todas las etapas del ciclo de vida",
  "analyzer.filter.lifecycleStage.label": "Etapa del ciclo de vida",
  "analyzer.filter.status": "Estado",
  "analyzer.filter.status.all": "Todos los estados",
  "analyzer.filter.status.label": "Estado",
  "analyzer.filter.testUnit": " Unidad de prueba",
  "analyzer.filter.type": "Tipo de analizador",
  "analyzer.form.activeStatus": "Estado activo",
  "analyzer.form.activeStatus.description": "Active este analizador para la recopilación de datos",
  "analyzer.form.addTitle": "Agregar un nuevo Analizador",
  "analyzer.form.cancel": "Cancelar",
  "analyzer.form.communicationMode": "Modo de comunicación",
  "analyzer.form.communicationMode.analyzerInitiated": "Analizador → LIS (el analizador se conecta a OpenELIS)",
  "analyzer.form.communicationMode.both": "Bidireccional (en ambas direcciones)",
  "analyzer.form.communicationMode.help": "Quién inicia la conexión. La mayoría de los analizadores utilizan el protocolo «Analizador → LIS».",
  "analyzer.form.communicationMode.lisInitiated": "LIS → Analizador (OpenELIS se conecta al analizador)",
  "analyzer.form.createdBy": "Creado por",
  "analyzer.form.createdDate": "Fecha y hora de creación",
  "analyzer.form.defaults.error": "No se ha podido cargar la configuración predeterminada",
  "analyzer.form.defaults.loaded": "Se ha cargado la configuración predeterminada",
  "analyzer.form.defaults.loaded.subtitle": "Se ha cargado la plantilla para «{name}». Personalícela según sea necesario antes de guardarla.",
  "analyzer.form.editTitle": "Editar analizador",
  "analyzer.form.error.invalidCommunicationMode": "Modo de comunicación no válido: {value}. Valores válidos: {validValues}",
  "analyzer.form.error.invalidProtocolVersion": "Versión de protocolo no válida: {value}. Valores válidos: {validValues}",
  "analyzer.form.error.save": "No se ha podido guardar el analizador",
  "analyzer.form.error.unknown": "Se ha producido un error desconocido",
  "analyzer.form.fileProtocol.description": "Este analizador importa resultados desde archivos. Los ajustes de importación de archivos se configurarán tras guardar.",
  "analyzer.form.fileProtocol.title": "Protocolo de importación de archivos",
  "analyzer.form.identifierPattern": "Patrón de identificador",
  "analyzer.form.identifierPattern.helperText": "Patrón de expresión regular para identificar los identificadores de los mensajes entrantes con fines de enrutamiento",
  "analyzer.form.identifierPattern.placeholder": "p. ej., ^ABX\\^PENTRA.*",
  "analyzer.form.ipAddress": "Dirección IP",
  "analyzer.form.ipAddress.placeholder": "192.168.1.10",
  "analyzer.form.lastModified": "Fecha y hora de la última modificación",
  "analyzer.form.loadDefaultConfig": "Cargar perfil del analizador",
  "analyzer.form.loadDefaultConfig.helperText": "Configuración rápida mediante las plantillas de perfiles del Analizador integradas",
  "analyzer.form.loadDefaultConfig.placeholder": "Seleccione un perfil de analizador integrado",
  "analyzer.form.name": "Nombre del analizador",
  "analyzer.form.name.placeholder": "p. ej., Analizador de hematología 1",
  "analyzer.form.pluginType": "Tipo de complemento",
  "analyzer.form.pluginType.helperText": "El complemento del Analizador que se encargará de gestionar los mensajes entrantes",
  "analyzer.form.pluginType.placeholder": "Seleccione el tipo de complemento...",
  "analyzer.form.port": "Número de puerto",
  "analyzer.form.port.placeholder": "5000",
  "analyzer.form.protocolVersion": "Versión del protocolo",
  "analyzer.form.save": "Guardar",
  "analyzer.form.status": "Estado",
  "analyzer.form.status.helperText": "El estado cambia automáticamente en función del estado del analizador. Solo es posible anularlo manualmente para pasar a los estados INACTIVO, CONFIGURACIÓN o VALIDACIÓN.",
  "analyzer.form.subtitle": "Configure los parámetros de conexión del analizador y compruebe las unidades de prueba",
  "analyzer.form.success.save": "El analizador se ha guardado exitosamente",
  "analyzer.form.testConnection": "Probar conexión",
  "analyzer.form.testConnection.error": "Error de conexión",
  "analyzer.form.testUnits": "Asignación de la unidad de prueba",
  "analyzer.form.testUnits.helper": "Seleccione una o varias unidades de prueba para este analizador",
  "analyzer.form.testUnits.placeholder": "Seleccione las unidades de prueba...",
  "analyzer.form.type": "Tipo de analizador",
  "analyzer.form.type.helperText": "Seleccione el tipo de analizador reutilizable para esta conexión instalada.",
  "analyzer.form.type.invalidSelection": "Esa revisión del tipo de analizador no está disponible o está desactivada",
  "analyzer.form.type.loadError": "No se han podido cargar los tipos de Analizador",
  "analyzer.form.type.other": "Otros",
  "analyzer.form.type.placeholder": "Seleccione el tipo de analizador",
  "analyzer.form.type.revision": "{name}, revisión {revision} ({protocol})",
  "analyzer.form.validation.ipAddress.invalid": "Formato de dirección IP no válido",
  "analyzer.form.validation.name.required": "Es obligatorio indicar el nombre del analizador",
  "analyzer.form.validation.type.required": "Es necesario indicar el tipo de analizador",
  "analyzer.hl7.insertError": "Error de inserción de HL7",
  "analyzer.hl7.parseError": "Error de análisis de HL7",
  "analyzer.hl7.unknownAnalyzer": "No se ha podido identificar el analizador desde el MSH de HL7 (aplicación o instalación remitente)",
  "analyzer.list.subtitle": "Gestionar los analizadores de laboratorio y las asignaciones de campos",
  "analyzer.list.title": "Analizadores",
  "analyzer.lifecycle.activate.blockedMessage": "Complete these setup requirements before activating. Open Edit setup on this analyzer to verify its mappings and connection.",
  "analyzer.lifecycle.activate.blockedTitle": "El analizador no está listo",
  "analyzer.lifecycle.activate.cancel": "Cancel activation",
  "analyzer.lifecycle.activate.confirm": "Activate analyzer",
  "analyzer.lifecycle.activate.error": "The analyzer could not be activated.",
  "analyzer.lifecycle.activate.errorTitle": "Activation failed",
  "analyzer.lifecycle.activate.message": "Activate {name}? Its setup will be checked before it can be used.",
  "analyzer.lifecycle.activate.title": "Activate analyzer",
  "analyzer.lifecycle.deactivate.cancel": "Cancelar la desactivación",
  "analyzer.lifecycle.deactivate.confirm": "Desactivar el Analizador",
  "analyzer.lifecycle.deactivate.error": "No se ha podido desactivar el analizador.",
  "analyzer.lifecycle.deactivate.errorTitle": "La desactivación ha fallado",
  "analyzer.lifecycle.deactivate.message": "¿Desea desactivar «{name}»? Se interrumpirá su uso en tiempo de ejecución. Se conservarán su configuración y su historial, y podrá reactivarse más adelante.",
  "analyzer.lifecycle.deactivate.title": "Desactivar el Analizador",
  "analyzer.lifecycle.reactivate.blockedMessage": "Complete estos requisitos de configuración antes de reactivarlo. Abra Editar configuración en este analizador para verificar sus asignaciones y su conexión.",
  "analyzer.lifecycle.reactivate.blockedTitle": "El analizador no está listo",
  "analyzer.lifecycle.reactivate.cancel": "Cancelar la reactivación",
  "analyzer.lifecycle.reactivate.confirm": "Reactivar el analizador",
  "analyzer.lifecycle.reactivate.error": "No ha sido posible reactivar el analizador.",
  "analyzer.lifecycle.reactivate.errorTitle": "La reactivación ha fallado",
  "analyzer.lifecycle.reactivate.message": "¿Desea reactivar «{name}»? Se volverá a comprobar su configuración antes de que pueda utilizarse.",
  "analyzer.lifecycle.reactivate.title": "Reactivar el analizador",
  "analyzer.connection.choice.select": "Seleccione un valor",
  "analyzer.connection.field.apiToken": "Token de API",
  "analyzer.connection.field.connectionRole": "Función de conexión",
  "analyzer.connection.field.directory": "Directorio",
  "analyzer.connection.field.directory.help": "Directorio en el servidor de Analyzer Bridge",
  "analyzer.connection.field.enabled": "Activado",
  "analyzer.connection.field.filePattern": "Patrón de archivo",
  "analyzer.connection.field.filePattern.help": "Patrón de nombre de archivo supervisado por Analyzer Bridge",
  "analyzer.connection.field.host": "Host",
  "analyzer.connection.field.host.help": "The analyzer's IP address. Optional when the analyzer connects to the Analyzer Bridge. Leave it blank if the analyzer reaches the bridge through NAT or a proxy, and use the instrument system name instead.",
  "analyzer.connection.field.numberFormat": "Decimal separator in results",
  "analyzer.connection.numberFormat.comma": "Comma (12,5)",
  "analyzer.connection.numberFormat.point": "Point (12.5)",
  "analyzer.connection.field.port": "Puerto",
  "analyzer.connection.field.senderId": "Instrument system name",
  "analyzer.connection.field.senderId.help": "The name this instrument sends in its messages (ASTM H.5 or HL7 MSH-3), such as the GeneXpert System Name. Needed only when several analyzers share this port and address.",
  "analyzer.connection.field.serialPort": "Dispositivo serie",
  "analyzer.connection.field.transport": "Transporte",
  "analyzer.connection.field.unavailable": "Configuración de la conexión",
  "analyzer.connection.readiness.profileUnavailable": "This connection is pinned to {profileId} revision {revision}, which the Analyzer Bridge no longer has. Reset the analyzer type, then choose an available one to reconnect it. The analyzer keeps its name, lab units, connection and history.",
  "analyzer.connection.readiness.restoreFailed": "The Analyzer Bridge could not restart this connection. Activate it again; if it still fails, check the Bridge log.",
  "analyzer.connection.role.client": "Cliente",
  "analyzer.connection.role.server": "Servidor",
  "analyzer.connection.reference.configured": "Conexión de Bridge configurada",
  "analyzer.connection.reference.missing": "Es necesario configurar la conexión",
  "analyzer.connection.transport.RS-232": "Serie (RS-232)",
  "analyzer.connection.transport.TCP/IP": "Red (TCP/IP)",
  "analyzer.connection.validation.invalid": "Compruebe este valor.",
  "analyzer.connection.validation.required": "Este campo es obligatorio.",
  "analyzer.setup.close": "Cerrar la configuración del Analizador",
  "analyzer.setup.connect.address.required": "Ingrese la dirección del Analizador",
  "analyzer.activation.blocker.bridgeAcknowledgement": "Analyzer Bridge no ha confirmado esta configuración exacta.",
  "analyzer.activation.blocker.connection": "La configuración de la conexión está incompleta o no es válida.",
  "analyzer.activation.blocker.dataFlow": "Este tipo de analizador no admite el flujo de datos seleccionado.",
  "analyzer.activation.blocker.labUnit": "Asigne al menos una unidad de laboratorio activa.",
  "analyzer.activation.blocker.mappings": "Es necesario volver a verificar las asignaciones del Analizador.",
  "analyzer.activation.blocker.name": "Ingrese un nombre para el analizador.",
  "analyzer.activation.blocker.profile": "La revisión del tipo de analizador seleccionado no está disponible o ya no se corresponde con este analizador.",
  "analyzer.activation.blocker.recognition": "Es necesario volver a verificar el reconocimiento de los controles.",
  "analyzer.activation.blocker.transport": "Este tipo de analizador no admite el tipo de conexión seleccionado.",
  "analyzer.setup.connect.activation.active": "El analizador está activo",
  "analyzer.setup.connect.activation.activating": "Activando el analizador",
  "analyzer.setup.connect.activation.blockerUnknown": "La configuración del analizador aún no está lista para activarse.",
  "analyzer.setup.connect.activation.cancel": "Cancelar",
  "analyzer.setup.connect.activation.error": "No se ha podido comprobar el estado de funcionamiento del Analizador.",
  "analyzer.setup.connect.activation.finish": "Finalizar y activar",
  "analyzer.setup.connect.activation.loading": "Comprobación del estado de funcionamiento del analizador",
  "analyzer.setup.connect.activation.readiness": "Grado de preparación para la activación",
  "analyzer.setup.connect.activation.ready": "El analizador está listo para activarse",
  "analyzer.setup.connect.activation.saveChanges": "Guardar cambios",
  "analyzer.setup.connect.activation.saveLater": "Guardar y finalizar más tarde",
  "analyzer.setup.connect.activation.saving": "Guardando el analizador",
  "analyzer.setup.connect.activation.verifyMappings": "Verify mappings",
  "analyzer.setup.connect.analyzerAddress": "Dirección del analizador",
  "analyzer.setup.connect.check.analyzer.address.missing": "No analyzer address is saved, so the analyzer was not checked. Results arriving from the analyzer prove the connection works.",
  "analyzer.setup.connect.check.analyzer.host.unknown": "The analyzer address {host} could not be resolved, so the analyzer was not checked. Results arriving from the analyzer prove the connection works.",
  "analyzer.setup.connect.check.analyzer.reachable": "The Bridge reached the analyzer at {host}.",
  "analyzer.setup.connect.check.analyzer.unreachable": "The Bridge could not reach the analyzer at {host}. Analyzers that connect to the Bridge often cannot be reached from it (a firewall, NAT, or a hosted server). Results arriving from the analyzer prove the connection works.",
  "analyzer.setup.connect.check.connection.mode.unsupported": "Bridge no admite este modo de conexión.",
  "analyzer.setup.connect.check.directory.configuration.missing": "Ingrese el directorio de archivos del analizador antes de realizar la prueba.",
  "analyzer.setup.connect.check.directory.not.directory": "La ruta configurada no es un directorio.",
  "analyzer.setup.connect.check.directory.not.found": "No se ha encontrado el directorio configurado.",
  "analyzer.setup.connect.check.directory.not.readable": "Bridge no puede leer el directorio configurado.",
  "analyzer.setup.connect.check.directory.path.invalid": "La ruta del directorio configurada no es válida.",
  "analyzer.setup.connect.check.directory.ready": "El directorio ya está listo.",
  "analyzer.setup.connect.check.http.configuration.missing": "Ingrese la dirección web del analizador antes de realizar la prueba.",
  "analyzer.setup.connect.check.http.connection.error": "Bridge no ha podido conectarse a la dirección web del analizador.",
  "analyzer.setup.connect.check.http.input.verify.with.delivery": "This analyzer sends messages to the Bridge, so this connection must be verified by delivering a result.",
  "analyzer.setup.connect.check.http.interrupted": "La prueba de conexión web se ha interrumpido.",
  "analyzer.setup.connect.check.http.ready": "Se puede acceder a la dirección web del Analizador.",
  "analyzer.setup.connect.check.http.server.error": "La dirección web del Analizador ha devuelto un error del servidor.",
  "analyzer.setup.connect.check.http.timeout": "La dirección web del Analizador no respondió antes de que se agotara el tiempo de espera.",
  "analyzer.setup.connect.check.http.url.invalid": "La dirección web del Analizador no es válida.",
  "analyzer.setup.connect.check.listener.configuration.missing": "The shared Bridge listener is not configured. Ask the Bridge administrator to check its listener settings.",
  "analyzer.setup.connect.check.listener.endpoint.missing": "La dirección de escucha de Bridge no está configurada.",
  "analyzer.setup.connect.check.listener.not.listening": "El receptor de Bridge no acepta conexiones.",
  "analyzer.setup.connect.check.listener.port.in.use": "El puerto de escucha de Bridge configurado ya está en uso.",
  "analyzer.setup.connect.check.listener.profile.unsupported": "El perfil fijado no define un receptor Bridge compatible.",
  "analyzer.setup.connect.check.listener.ready": "El receptor de Bridge está listo.",
  "analyzer.setup.connect.check.listener.timeout": "El receptor de Bridge no respondió antes de que se agotara el tiempo de espera.",
  "analyzer.setup.connect.check.remote.astm.ready": "El analizador ha completado el protocolo de comunicación ASTM.",
  "analyzer.setup.connect.check.remote.astm.response.invalid": "El analizador ha devuelto una respuesta no válida al protocolo de establecimiento de comunicación ASTM.",
  "analyzer.setup.connect.check.remote.configuration.missing": "Compruebe la dirección del analizador y la configuración del destino de salida. Una sustitución opcional del puerto puede reemplazar el valor predeterminado del tipo de analizador o de Bridge.",
  "analyzer.setup.connect.check.remote.connection.error": "El Bridge no ha podido conectarse al Analizador.",
  "analyzer.setup.connect.check.remote.hl7.ready": "El analizador ha completado el proceso de establecimiento de conexión HL7.",
  "analyzer.setup.connect.check.remote.hl7.response.invalid": "El analizador ha devuelto una respuesta de establecimiento de conexión HL7 no válida.",
  "analyzer.setup.connect.check.remote.host.unknown": "No se ha podido resolver la dirección del Analizador.",
  "analyzer.setup.connect.check.remote.protocol.unsupported": "Este protocolo del analizador no admite pruebas de conexión remota.",
  "analyzer.setup.connect.check.remote.refused": "El analizador ha rechazado la conexión.",
  "analyzer.setup.connect.check.remote.timeout": "El analizador no respondió antes de que se agotara el tiempo de espera.",
  "analyzer.setup.connect.check.serial.configuration.missing": "Ingrese el dispositivo serie del analizador antes de realizar la prueba.",
  "analyzer.setup.connect.check.serial.not.found": "No se ha encontrado el dispositivo serie configurado.",
  "analyzer.setup.connect.check.serial.not.readable": "El Bridge no puede leer el dispositivo serie configurado.",
  "analyzer.setup.connect.check.serial.path.invalid": "La ruta del dispositivo serie configurada no es válida.",
  "analyzer.setup.connect.check.serial.ready": "El dispositivo serie del Analizador está listo.",
  "analyzer.setup.connect.checkKind.analyzer": "Analyzer (for information)",
  "analyzer.setup.connect.checkKind.directory": "Directorio",
  "analyzer.setup.connect.checkKind.http_endpoint": "Dirección web",
  "analyzer.setup.connect.checkKind.http_input": "Incoming analyzer messages",
  "analyzer.setup.connect.checkKind.listener": "Receptor de Bridge",
  "analyzer.setup.connect.checkKind.other": "Comprobación de la conexión",
  "analyzer.setup.connect.checkKind.remote_protocol": "Protocolo del Analizador",
  "analyzer.setup.connect.checkKind.serial_device": "Dispositivo serie",
  "analyzer.setup.connect.checkStatus.failed": "Se ha producido un error en la comprobación de la conexión.",
  "analyzer.setup.connect.checkStatus.missing_configuration": "La configuración de la conexión está incompleta.",
  "analyzer.setup.connect.checkStatus.passed": "La comprobación de la conexión se ha superado.",
  "analyzer.setup.connect.checkStatus.skipped": "This check could not be run.",
  "analyzer.setup.connect.checkStatus.timed_out": "Se ha agotado el tiempo de espera de la comprobación de conexión.",
  "analyzer.setup.connect.configureEndpoint": "Configure el Analizador para que utilice",
  "analyzer.setup.connect.dataFlow": "Flujo de datos",
  "analyzer.setup.connect.dataFlow.resultsOnly": "Solo resultados",
  "analyzer.setup.connect.dataFlow.twoWay": "Bidireccional",
  "analyzer.setup.connect.destination": "Destination: {host}, port {port}",
  "analyzer.setup.connect.destinationRemediation": "Check the analyzer address, destination port, listening service and network access, then test again.",
  "analyzer.setup.connect.listenerPort": "Bridge listener port: {port}",
  "analyzer.setup.connect.portSource": "Port selected from: {source}",
  "analyzer.setup.connect.portSource.override": "Connection override",
  "analyzer.setup.connect.portSource.profile": "Analyzer type default",
  "analyzer.setup.connect.portSource.bridge": "Bridge default",
  "analyzer.setup.connect.directory": "Directorio de archivos del Analizador",
  "analyzer.setup.connect.directory.required": "Ingrese el directorio de archivos del analizador",
  "analyzer.setup.connect.error": "No se han podido guardar ni realizar pruebas con los ajustes de conexión.",
  "analyzer.setup.connect.evidence": "Evidencia de conexión",
  "analyzer.setup.connect.loadError": "No se ha podido cargar la conexión del Analizador guardada.",
  "analyzer.setup.connect.loading": "Cargando la conexión del analizador",
  "analyzer.setup.connect.outcome.failure": "Error de conexión",
  "analyzer.setup.connect.outcome.missing_configuration": "La configuración de la conexión está incompleta",
  "analyzer.setup.connect.outcome.success": "Conexión lista",
  "analyzer.setup.connect.outcome.timeout": "Se ha agotado el tiempo de espera de la conexión",
  "analyzer.setup.connect.port": "Puerto del Analizador",
  "analyzer.setup.connect.port.invalid": "Ingrese un puerto desde 1 hasta 65535",
  "analyzer.setup.connect.sourceAddress": "Dirección de origen del Analizador",
  "analyzer.setup.connect.test": "Probar conexión",
  "analyzer.setup.connect.testing": "Probando la conexión",
  "analyzer.setup.connect.title": "Conectarse",
  "analyzer.setup.connect.useResultsOnly": "Usar «Solo resultados»",
  "analyzer.setup.instrument.continue": "Continuar con los ensayos",
  "analyzer.setup.instrument.labUnits": "Unidades de laboratorio",
  "analyzer.setup.instrument.labUnits.placeholder": "Seleccione las unidades de laboratorio",
  "analyzer.setup.instrument.labUnits.required": "Seleccione al menos una unidad de laboratorio",
  "analyzer.setup.instrument.name": "Nombre del analizador",
  "analyzer.setup.instrument.name.required": "Ingrese un nombre para el analizador",
  "analyzer.setup.instrument.notListed": "¿No aparece su instrumento en la lista?",
  "analyzer.setup.instrument.saveError": "No se ha podido guardar el analizador. Inténtelo de nuevo.",
  "analyzer.setup.instrument.saving": "Guardando el analizador",
  "analyzer.setup.instrument.summary": "Datos de los instrumentos guardados",
  "analyzer.setup.step.edit": "Editar {step}",
  "analyzer.setup.instrument.type": "Tipo de analizador",
  "analyzer.setup.instrument.type.helper": "Choose the listed type for your instrument, even if it will only send results. Whether it sends results only or also receives orders is set later, in Connect.",
  "analyzer.setup.instrument.type.placeholder": "Buscar tipos de analizadores",
  "analyzer.setup.instrument.type.required": "Seleccione un tipo de analizador",
  "analyzer.setup.instrument.typeOption": "{name} · {manufacturer} · {protocol} · revisión {revision}",
  "analyzer.setup.instrument.title": "Instrumento",
  "analyzer.setup.steps": "Pasos para la configuración del Analizador",
  "analyzer.setup.title": "Configurar un nuevo analizador",
  "analyzer.setup.title.named": "Set up {name}",
  "analyzer.setup.verify.confirm": "Confirm the mappings below to continue.",
  "analyzer.setup.verify.noAssays": "No assay is on for this instrument. Turn on the assays it runs in Assays.",
  "analyzer.setup.verify.unresolved": "{count, plural, one {# record or value} other {# records or values}} of the assays that are on still need mapping. Map them below, or turn the assay off in Assays if this instrument does not run it.",
  "analyzer.setup.verify.continue": "Continuar con la conexión",
  "analyzer.setup.verify.selecting": "Aplicando las correspondencias...",
  "analyzer.setup.verify.selectionError": "No se han podido aplicar las asignaciones revisadas. Vuelva a cargar Verificar e inténtelo de nuevo.",
  "analyzer.setup.verify.loading": "Cargando la verificación de la asignación",
  "analyzer.setup.verify.summary": "Asignaciones revisadas para esta configuración",
  "analyzer.setup.verify.summary.stale": "Mappings need to be verified again",
  "analyzer.setup.verify.title": "Verificar",
  "analyzer.navigation.analyzerTypes": "Tipos de analizadores",
  "analyzer.navigation.analyzers": "Analizadores",
  "analyzer.navigation.analyzersList": "Lista de analizadores",
  "analyzer.navigation.fieldMappings": "Asignaciones de campos",
  "analyzer.navigation.qc": "Control de calidad",
  "analyzer.navigation.qcDashboard": "Panel de CC",
  "analyzer.navigation.qcAlerts": "Alertas e incumplimientos de QC",
  "analyzer.navigation.qcCorrectiveActions": "Acciones correctivas",
  "analyzerType.action.deactivate": "Desactivar",
  "analyzerType.action.editMappings": "Ver asignaciones predeterminadas",
  "analyzerType.action.history": "Consultar historial",
  "analyzerType.action.reactivate": "Reactivar",
  "analyzerType.action.updateShared": "Actualizar compartido",
  "analyzerType.adoption.adopted": "Revision {revision} adopted. Confirm the mapping below, then apply it to switch this analyzer.",
  "analyzerType.adoption.blocked.heldResults": "{code} still has held results from revision {revision}. Resolve them before adopting.",
  "analyzerType.adoption.blocked.inactiveTest": "Mapped to a test that is no longer active. Choose another test.",
  "analyzerType.adoption.blocked.reviewHeld": "Revisar los resultados retenidos",
  "analyzerType.adoption.bucket.blocked": "Blocked",
  "analyzerType.adoption.bucket.blocked.help": "Adoption waits until these are resolved.",
  "analyzerType.adoption.bucket.changed": "Changed",
  "analyzerType.adoption.bucket.changed.help": "The newer revision proposes something else for these. Keep the current choice or use the new default.",
  "analyzerType.adoption.bucket.needs_mapping": "Requiere asignación",
  "analyzerType.adoption.bucket.needs_mapping.help": "New in this revision, or no longer carried over. Map them now or leave them for later.",
  "analyzerType.adoption.bucket.retired": "No longer sent",
  "analyzerType.adoption.bucket.retired.help": "Revision {revision} no longer sends these, so their mappings are dropped.",
  "analyzerType.adoption.bucket.unchanged": "Unchanged",
  "analyzerType.adoption.bucket.unchanged.help": "These carry over as they are.",
  "analyzerType.adoption.changed.current": "Current: {name}",
  "analyzerType.adoption.changed.newDefault": "New default: {name}",
  "analyzerType.adoption.error.save": "The adoption could not be saved",
  "analyzerType.adoption.keepCurrent": "Keep current",
  "analyzerType.adoption.notice.subtitle": "This analyzer keeps receiving on revision {from} until you save this, confirm it and apply it.",
  "analyzerType.adoption.notice.title": "Adopting revision {revision}",
  "analyzerType.adoption.save": "Save as revision {revision}",
  "analyzerType.adoption.title": "Adopt revision {revision} of {name}",
  "analyzerType.adoption.useNewDefault": "Use new default",
  "analyzerType.affectedAnalyzers.heading": "{count, plural, one {Analyzer using this type} many {Analyzers using this type} other {Analizadores que usan este tipo}}",
  "analyzerType.affectedAnalyzers.adopt": "Adopt revision {revision}",
  "analyzerType.affectedAnalyzers.verify": "Verify saved mapping",
  "analyzerType.actions.ariaLabel": "Acciones de «{name}»",
  "analyzerType.button.create": "Crear perfil",
  "analyzerType.button.cancel": "Cancelar",
  "analyzerType.button.duplicate": "Duplicar perfil",
  "analyzerType.button.publish": "Publicar perfil",
  "analyzerType.button.startUpdate": "Iniciar actualización",
  "analyzerType.column.actions": "Acciones",
  "analyzerType.column.protocol": "Protocolo",
  "analyzerType.column.resultsMapped": "Resultados asignados",
  "analyzerType.column.status": "Estado",
  "analyzerType.column.testsMapped": "Pruebas asignadas",
  "analyzerType.column.type": "Tipo de analizador",
  "analyzerType.column.usedBy": "Utilizado por",
  "analyzerType.dataFlow.resultsOnly": "Solo resultados",
  "analyzerType.dataFlow.twoWay": "Bidireccional",
  "analyzerType.duplicate.lineage.subtitle": "El nuevo perfil se basa en la revisión {revision} de {name}. Los cambios posteriores no modifican el perfil original ni sus Analizadores.",
  "analyzerType.duplicate.lineage.title": "Nuevo perfil con linaje conservado",
  "analyzerType.draft.created.subtitle": "El borrador se guarda en Analyzer Bridge. Debe estar completado y validado antes de que pueda publicarse para la configuración del Analizador.",
  "analyzerType.draft.created.title": "Se ha creado un borrador del perfil",
  "analyzerType.draft.loading": "Cargando el borrador del perfil",
  "analyzerType.draft.publish.ready.subtitle": "{name} cuenta con una identidad propia y exclusiva de Bridge y conserva su linaje original.",
  "analyzerType.draft.publish.ready.title": "Listo para publicar",
  "analyzerType.draft.publish.review.subtitle": "Revise y guarde el comportamiento de reconocimiento de controles para «{name}» antes de publicarlo.",
  "analyzerType.draft.publish.review.title": "Completar la revisión del perfil",
  "analyzerType.draft.update.loading": "Cargando el borrador de actualización del perfil",
  "analyzerType.draft.update.subtitle": "El tipo de analizador compartido no sufrirá cambios hasta que este borrador se haya completado y publicado. Los analizadores existentes permanecerán vinculados a sus revisiones actuales.",
  "analyzerType.draft.update.title": "Se ha creado un borrador de actualización del perfil",
  "analyzerType.empty.subtitle": "Modifique la búsqueda o los filtros para ver otros tipos de analizadores.",
  "analyzerType.empty.title": "No se ha encontrado ningún tipo de analizador que coincida",
  "analyzerType.explainer.subtitle": "Los analizadores idénticos pueden compartir un mismo tipo. Duplique un tipo cuando un analizador requiera un comportamiento diferente; desactive los tipos en lugar de eliminar su historial.",
  "analyzerType.explainer.title": "Configuración del analizador reutilizable",
  "analyzerType.error.nameUnique": "Los nombres de perfil deben ser únicos",
  "analyzerType.field.connectionTest": "Permite realizar pruebas de conexión",
  "analyzerType.field.dataFlow": "Flujo de datos",
  "analyzerType.field.fileFormat": "Formato de archivo",
  "analyzerType.field.filePattern": "Patrón de nombre de archivo",
  "analyzerType.field.manufacturer": "Fabricante",
  "analyzerType.field.model": "Modelo",
  "analyzerType.field.newProfileName": "Nuevo nombre de perfil",
  "analyzerType.field.profileName": "Nombre del perfil",
  "analyzerType.field.protocol": "Protocolo",
  "analyzerType.field.resultColumn": "Columna «Resultado»",
  "analyzerType.field.sampleColumn": "Columna de identificación de muestras",
  "analyzerType.field.sourceProfile.placeholder": "Seleccione un tipo de analizador",
  "analyzerType.field.sourceProfile": "Tipo de analizador de fuente",
  "analyzerType.field.testColumn": "Columna de prueba de código",
  "analyzerType.filter.all": "Todos",
  "analyzerType.filter.mapping": "Estado de la asignación",
  "analyzerType.filter.protocol": "Protocolo",
  "analyzerType.filter.showDeactivated": "Mostrar desactivados",
  "analyzerType.filter.source": "Creado",
  "analyzerType.history.action.created": "Creado",
  "analyzerType.history.action.deactivated": "Desactivado",
  "analyzerType.history.action.duplicated": "Duplicado",
  "analyzerType.history.action.reactivated": "Reactivado",
  "analyzerType.history.action.shipped": "Incluido de fábrica",
  "analyzerType.history.action.updated": "Actualizado",
  "analyzerType.history.actor": "Modificado por",
  "analyzerType.history.change": "Cambio",
  "analyzerType.history.loading": "Cargando el historial de perfiles",
  "analyzerType.history.revisionValue": "Revisión {revision}",
  "analyzerType.history.revision": "Revisión",
  "analyzerType.history.status": "Estado",
  "analyzerType.history.time": "Modificado el",
  "analyzerType.lineage": "Derivado de {profileId}, revisión {revision}",
  "analyzerType.loading": "Cargando tipos de analizadores",
  "analyzerType.mapping.complete": "Totalmente asignado",
  "analyzerType.mapping.count": "{mapped} / {total} · {percent}%",
  "analyzerType.mapping.countWithExcluded": "{mapped} / {total} · {percent}% · {excluded} marcado como «No recibir»",
  "analyzerType.mapping.incomplete": "Requiere asignación",
  "analyzerType.mapping.notApplicable": "No procede",
  "analyzerType.mapping.notStarted": "Sin asignar",
  "analyzerType.mappingEditor.applyToAnalyzer": "Apply mappings and retry held results",
  "analyzerType.mappingEditor.appliedToAnalyzer": "Current mappings applied to this analyzer. Eligible held results were retried.",
  "analyzerType.mappingEditor.error.applyToAnalyzer": "Could not apply mappings to this analyzer.",
  "analyzerType.mappingEditor.alias": "Alias: {alias}",
  "analyzerType.mappingEditor.confirm": "Confirmar las asignaciones y el reconocimiento de controles",
  "analyzerType.mappingEditor.confirmation.by": "Confirmado por {actor} el {date}",
  "analyzerType.mappingEditor.confirmation.current": "Confirmación actual",
  "analyzerType.mappingEditor.confirmation.stale": "La confirmación ha caducado",
  "analyzerType.mappingEditor.confirmation.summary.current": "Actual",
  "analyzerType.mappingEditor.confirmation.summary.stale": "Desactualizada",
  "analyzerType.mappingEditor.confirmation.summary.unconfirmed": "Sin confirmar",
  "analyzerType.mappingEditor.confirmation.unconfirmed": "Sin confirmar",
  "analyzerType.mappingEditor.confirmation": "Confirmación",
  "analyzerType.mappingEditor.confirmed": "Se han confirmado las asignaciones y el reconocimiento de los controles",
  "analyzerType.mappingEditor.error.confirm": "La confirmación ha fallado",
  "analyzerType.mappingEditor.error.load": "No se han podido cargar las asignaciones de tipo de Analizador",
  "analyzerType.mappingEditor.error.route": "Se requiere un analizador o una revisión de tipo de analizador válidos",
  "analyzerType.mappingEditor.error.save": "No se han podido guardar las asignaciones",
  "analyzerType.mappingEditor.excludeResult.short": "No recibir",
  "analyzerType.mappingEditor.excludeResult": "No recibir {value}",
  "analyzerType.mappingEditor.callComponentPicker": "Call result for {code} goes to",
  "analyzerType.mappingEditor.componentPicker": "OpenELIS component for {code}",
  "analyzerType.mappingEditor.componentPicker.required": "Choose the component this record lands on.",
  "analyzerType.mappingEditor.componentPicker.placeholder": "Choose a component",
  "analyzerType.mappingEditor.excludeTest": "No recibir {code}",
  "analyzerType.mappingEditor.translationOf": "Translation of {value}",
  "analyzerType.mappingEditor.partial": "{count} unresolved mappings. You can confirm and connect; affected results will be saved for correction before use.",
  "analyzerType.mappingEditor.incomplete": "Corrija las selecciones de pruebas o resultados no disponibles antes de la confirmación.",
  "analyzerType.mappingEditor.loading": "Cargando las asignaciones de tipos del Analizador",
  "analyzerType.mappingEditor.normalized": "Identidad normalizada",
  "analyzerType.mappingEditor.observed": "Observado en los resultados retenidos",
  "analyzerType.mappingEditor.recognition.heading": "Reconocimiento de los resultados de los controles",
  "analyzerType.mappingEditor.recognition.none": "Este tipo de analizador declara explícitamente que la interfaz no transmite resultados de control.",
  "analyzerType.mappingEditor.resultPicker.placeholder": "Elija un resultado de OpenELIS",
  "analyzerType.mappingEditor.resultPicker": "Resultado de OpenELIS para {value}",
  "analyzerType.mappingEditor.tests.none": "This analyzer type declares no tests, so there is nothing to map. Its author can add tests to a new revision of the type.",
  "analyzerType.mappingEditor.results.empty": "Esta prueba no tiene opciones de resultado activas",
  "analyzerType.mappingEditor.results.heading": "Resultados - {name}",
  "analyzerType.mappingEditor.results.loading": "Cargando las opciones de resultados",
  "analyzerType.mappingEditor.results.openCatalog": "Agregue opciones de resultados en el Catálogo de pruebas",
  "analyzerType.mappingEditor.results.testFirst": "Seleccione una prueba de OpenELIS antes de asignar sus resultados",
  "analyzerType.mappingEditor.reason.result.ambiguous": "Not mapped: several answers for this test carry this value's code. Choose one.",
  "analyzerType.mappingEditor.reason.result.incompatible": "Not mapped: no answer for this test can hold this value.",
  "analyzerType.mappingEditor.reason.result.no_match": "Not mapped: no answer for this test carries this value's code.",
  "analyzerType.mappingEditor.reason.test.ambiguous": "Not mapped: several tests in this lab's catalog carry its code. Choose one.",
  "analyzerType.mappingEditor.reason.test.incompatible": "Not mapped: a test in this lab's catalog carries its code but cannot hold these results.",
  "analyzerType.mappingEditor.reason.test.no_match": "Not mapped: no test in this lab's catalog carries its code.",
  "analyzerType.mappingEditor.results": "Resultados asignados",
  "analyzerType.mappingEditor.return": "Volver",
  "analyzerType.mappingEditor.save": "Guardar asignación",
  "analyzerType.mappingEditor.saved": "Asignaciones guardadas",
  "analyzerType.mappingEditor.own.title": "This analyzer's own mapping",
  "analyzerType.mappingEditor.own.subtitle": "Changes here apply only to this analyzer. They take effect when you confirm the mapping and apply it.",
  "analyzerType.mappingEditor.defaults.title": "Defaults for new analyzers",
  "analyzerType.mappingEditor.defaults.subtitle": "This is what a new analyzer of this type would start with, matched by standard codes against the current catalog. Nothing here is saved; each analyzer keeps its own mapping.",
  "analyzerType.mappingEditor.origin.override": "Editado",
  "analyzerType.mappingEditor.changes.heading": "Review changes before saving",
  "analyzerType.mappingEditor.changes.save": "Guardar cambios",
  "analyzerType.mappingEditor.changes.none": "Nothing has changed since the last save.",
  "analyzerType.mappingEditor.changes.row": "{from} a {to}",
  "analyzerType.mappingEditor.sourceCode": "Código del analizador",
  "analyzerType.mappingEditor.state.bound": "Asignado",
  "analyzerType.mappingEditor.state.excluded": "No recibir",
  "analyzerType.mappingEditor.state.unresolved": "Requiere asignación",
  "analyzerType.mappingEditor.subtitle": "{protocol} · revisión {revision}",
  "analyzerType.mappingEditor.suggestion": "Coincidencia sugerida: {name}",
  "analyzerType.mappingEditor.summary": "Resumen de asignaciones",
  "analyzerType.mappingEditor.testPicker.placeholder": "Buscar por nombre, código o LOINC",
  "analyzerType.mappingEditor.testPicker": "Prueba de OpenELIS para {code}",
  "analyzerType.mappingEditor.tests.heading": "Correspondencias entre pruebas y resultados",
  "analyzerType.mappingEditor.tests.help": "Revise cada código de analizador de forma independiente. Asigne dicho código a una prueba activa de OpenELIS o exclúyalo explícitamente.",
  "analyzerType.mappingEditor.tests": "Pruebas asignadas",
  "analyzerType.mappingEditor.title": "Asignaciones de {name}",
  "analyzerType.mappingEditor.unsaved": "Cambios de asignación sin guardar",
  "analyzerType.mappingEditor.useSuggestion": "Utilice la prueba recomendada",
  "analyzerType.modal.deactivate.subtitle": "Los analizadores existentes y el historial de revisiones siguen vinculados. Este perfil ya no estará disponible para la configuración de nuevos analizadores.",
  "analyzerType.modal.deactivate.title": "Desactivar {name}",
  "analyzerType.modal.history.title": "Historial de {name}",
  "analyzerType.modal.reactivate.subtitle": "Este perfil volverá a estar disponible para la configuración de nuevos analizadores. Los analizadores existentes seguirán asociados a las revisiones que se les hayan asignado.",
  "analyzerType.modal.reactivate.title": "Reactivar {name}",
  "analyzerType.modal.update.subtitle": "Esto inicia una nueva revisión inmutable a partir de la revisión {revision}. {count, plural, one {# analizador permanece anclado a su revisión actual.} other {# analizadores permanecen anclados a sus revisiones actuales.}}",
  "analyzerType.modal.update.title": "Actualizar {name}",
  "analyzerType.notification.action.error.subtitle": "Intente volver a realizar la acción del perfil.",
  "analyzerType.notification.action.error": "La acción relacionada con el perfil ha fallado",
  "analyzerType.notification.create.success": "Perfil creado",
  "analyzerType.notification.deactivate.success": "Perfil desactivado",
  "analyzerType.notification.duplicate.success": "Perfil duplicado",
  "analyzerType.notification.update.success": "Perfil actualizado",
  "analyzerType.notification.loadError.subtitle": "Compruebe la conexión de Analyzer Bridge y vuelva a intentarlo.",
  "analyzerType.notification.catalogIssues": "Some analyzer profiles could not be loaded",
  "analyzerType.notification.catalogIssues.subtitle": "The Analyzer Bridge set these files aside and serves every other profile. Fix or remove each file, then restart the Bridge.",
  "analyzerType.notification.loadError": "No se han podido cargar los tipos de analizador",
  "analyzerType.notification.reactivate.success": "Perfil reactivado",
  "analyzerType.page.subtitle": "Las configuraciones reutilizables que hay detrás de sus analizadores.",
  "analyzerType.page.title": "Tipos de analizadores",
  "analyzerType.protocol.file": "Archivo plano",
  "analyzerType.recognition.none.affirmation": "Confirmo que esta interfaz no transmite los resultados de control",
  "analyzerType.recognition.none.subtitle": "Publique este perfil únicamente cuando la interfaz del Analizador no envíe resultados de control. Los perfiles que transmiten controles requieren reglas de reconocimiento explícitas.",
  "analyzerType.recognition.none.title": "No se realiza el reconocimiento automático de los resultados de los controles",
  "analyzerType.recognition.condition.add": "Agregar condición",
  "analyzerType.recognition.condition.fieldValue": "Valor de {source}",
  "analyzerType.recognition.condition.new": "Nueva condición de reconocimiento",
  "analyzerType.recognition.condition.prefixValue": "Prefijo de identificación de muestras",
  "analyzerType.recognition.condition.remove": "Eliminar condición",
  "analyzerType.recognition.condition.select.placeholder": "Elija una condición",
  "analyzerType.recognition.condition.select": "Nueva condición",
  "analyzerType.recognition.condition.sourceContains": "{source} contiene",
  "analyzerType.recognition.condition.sourceEquals": "{source} igual a",
  "analyzerType.recognition.condition.specimenPrefix": "El número de identificación de la muestra comienza por",
  "analyzerType.recognition.condition.summary.configuredPattern": "El identificador de la muestra coincide con un patrón configurado",
  "analyzerType.recognition.condition.summary.contains": "{source} contiene {value}",
  "analyzerType.recognition.condition.summary.equals": "{source} igual a {value}",
  "analyzerType.recognition.condition.summary.startsWith": "{source} comienza con {value}",
  "analyzerType.recognition.condition.summary.unknown": "Reconocimiento de los resultados de los controles",
  "analyzerType.recognition.error.load": "No se ha podido cargar el reconocimiento de controles.",
  "analyzerType.recognition.error.save": "No se ha podido guardar el reconocimiento de controles.",
  "analyzerType.recognition.error.title": "Es necesario prestar atención al reconocimiento de los controles",
  "analyzerType.recognition.heading": "Reconocimiento de los resultados de los controles",
  "analyzerType.recognition.loading": "Cargando el reconocimiento de controles",
  "analyzerType.recognition.mode.none": "Esta interfaz no transmite los resultados de los controles",
  "analyzerType.recognition.mode.none.short": "Sin reconocimiento de resultados de control",
  "analyzerType.recognition.mode.rules": "Identifique los controles que cumplan estas condiciones",
  "analyzerType.recognition.mode.rules.short": "Reconocimiento de control basado en reglas",
  "analyzerType.recognition.mode.unconfigured.short": "Control recognition not configured",
  "analyzerType.recognition.mode.unconfigured": "No control recognition rules are configured. Control results may not be identified automatically.",
  "analyzerType.recognition.mode": "¿Cómo identifica esta interfaz los resultados de los controles?",
  "analyzerType.recognition.rules.help": "Un resultado se considera de control cuando se cumple cualquiera de las condiciones.",
  "analyzerType.recognition.save": "Guardar el reconocimiento de controles",
  "analyzerType.recognition.saved": "Reconocimiento de control guardado",
  "analyzerType.recognition.source.specimenId": "N.º de identificación de la muestra",
  "analyzerType.revision": "revisión {revision}",
  "analyzerType.search.label": "Buscar tipos de analizadores",
  "analyzerType.search.placeholder": "Buscar por nombre, fabricante o modelo",
  "analyzerType.source.shipped": "Incluido de fábrica",
  "analyzerType.source.site": "Creado en el sitio",
  "analyzerType.status.active": "Activo",
  "analyzerType.status.inactive": "Desactivado",
  "analyzerType.summary.ariaLabel": "Resumen de los tipos de analizadores",
  "analyzerType.summary.deactivated": "Desactivado",
  "analyzerType.summary.inUse": "En uso",
  "analyzerType.summary.needsAttention": "Requiere atención",
  "analyzerType.summary.total": "Tipos de analizadores",
  "analyzerType.usedBy": "{count, plural, =0 {No está en uso} one {# analizador} other {# analizadores}}",
  "analyzer.navigation.qcControlLots": "Lotes de control",
  "analyzer.navigation.qcRuleConfig": "Configuración de reglas",
  "analyzer.page.addButton": "Agregar analizador",
  "analyzer.page.hierarchy.list": "Lista de analizadores",
  "analyzer.page.hierarchy.mappings": "Asignaciones de campos",
  "analyzer.page.hierarchy.root": "Analizadores",
  "analyzer.page.title": "Analizadores",
  "analyzer.plugin.missing": "Falta el complemento",
  "analyzer.qc.alerts.message": "Las funciones de alertas e infracciones estarán disponibles próximamente.",
  "analyzer.qc.alerts.title": "Alertas e incumplimientos de QC",
  "analyzer.qc.corrective.message": "Las funciones relacionadas con las acciones correctivas estarán disponibles próximamente.",
  "analyzer.qc.corrective.title": "Acciones correctivas",
  "analyzer.qc.placeholder.message": "Las funciones de control de calidad estarán disponibles próximamente.",
  "analyzer.qc.placeholder.title": "Control de calidad",
  "analyzer.action.viewResults": "Consultar resultados",
  "analyzer.results.held.assayNotEnabled": "This assay is off in the analyzer's setup, so its result was held. Turn it on in the setup's Assays step if this instrument runs it; the result is retried when the mapping is applied.",
  "analyzer.results.held.code": "Código del analizador: {code}",
  "analyzer.results.held.enableAssay": "Turn the assay on",
  "analyzer.results.held.instrumentNote": "Instrument note: {note}",
  "analyzer.results.held.otherRevision": "Sent under revision {revision} of this analyzer's profile, which reads this test differently from the revision now in force. Rerun the sample.",
  "analyzer.results.instrumentReported": "Instrument reported",
  "analyzer.results.instrumentReported.assay": "Assay: {assay}",
  "analyzer.results.instrumentReported.assayVersion": "Assay: {assay}, version {version}",
  "analyzer.results.instrumentReported.flag": "Flag: {flag}",
  "analyzer.results.instrumentReported.operator": "Operator: {operator}",
  "analyzer.results.failedRun.dismiss": "Dismiss as failed run",
  "analyzer.results.failedRun.dismissed": "The failed run is recorded on the order and its test stays open for the repeat.",
  "analyzer.results.failedRun.error": "The failed run could not be dismissed",
  "analyzer.results.held.qcTargetMissing": "This control reported an answer, but its test and control level have no QC target to judge it against. Set the expected answer, then apply the analyzer's mapping to retry it.",
  "analyzer.results.held.setQcTarget": "Set QC target",
  "analyzer.results.held.reviewMapping": "Revisar la asignación del analizador",
  "analyzer.results.sampleFlags": "Analyzer flags: {flags}",
  "analyzer.results.held.subtitle": "Los resultados retenidos no se pueden aceptar. Cada uno indica qué hacer: revisar la asignación de este analizador o descartar una ejecución fallida para que su prueba quede abierta para la repetición.",
  "analyzer.results.held.tag": "Retenido",
  "analyzer.results.held.title": "{count, plural, one {# analyzer result needs attention} many {# analyzer results need attention} other {# resultados de analizador requieren atención}}",
  "analyzer.qualitativeMapping.isDefault": "Por defecto",
  "analyzer.qualitativeMapping.mappings": "Asignaciones de valores",
  "analyzer.qualitativeMapping.noValues": "No hay valores del Analizador disponibles para la asignación",
  "analyzer.qualitativeMapping.openelisCode.placeholder": "Seleccione el código de OpenELIS",
  "analyzer.qualitativeMapping.subtitle": "Asignar valores cualitativos a {fieldName}",
  "analyzer.qualitativeMapping.title": "Mapeo cualitativo de valores",
  "analyzer.qualitativeMapping.validation.error": "Error de Validación",
  "analyzer.qualitativeMapping.validation.error.subtitle": "Le rogamos que corrija los errores que figuran a continuación",
  "analyzer.qualitativeMapping.validation.noDefault": "Sin valor por defecto",
  "analyzer.qualitativeMapping.validation.noDefault.subtitle": "Se debe marcar al menos una asignación como predeterminada",
  "analyzer.qualitativeMapping.validation.openelisCode.required": "Se requiere el código OpenELIS",
  "analyzer.query.button": "Analizador de consultas",
  "analyzer.query.cancel": "Cancelar",
  "analyzer.query.modal.logs": "Registros de conexión",
  "analyzer.query.modal.noLogs": "Aún no hay registros.",
  "analyzer.query.modal.progress": "Avances",
  "analyzer.query.modal.state": "Estado",
  "analyzer.query.modal.subtitle": "Recuperar los campos disponibles del Analizador",
  "analyzer.query.modal.title": "Analizador de consultas",
  "analyzer.query.progress": "{percent}% completado",
  "analyzer.search.label": "Buscar",
  "analyzer.search.placeholder": "Buscar analizadores...",
  "analyzer.attention.review": "Revisar los resultados retenidos",
  "analyzer.attention.subtitle": "Asigne las pruebas o los valores de resultados desconocidos antes de utilizar estos resultados en el ámbito clínico.",
  "analyzer.attention.tag": "Requiere atención",
  "analyzer.attention.title.many": "{count} analizadores tienen resultados retenidos",
  "analyzer.attention.title.one": "{name} tiene resultados retenidos",
  "analyzer.stat.active": "Activo",
  "analyzer.stat.inactive": "Inactivo",
  "analyzer.stat.needsAttention": "Requiere atención",
  "analyzer.stat.setup": "En «Configuración»",
  "analyzer.stat.total": "Total de analizadores",
  "analyzer.stats.active": "Analizadores activos",
  "analyzer.stats.inactive": "Analizadores inactivos",
  "analyzer.stats.total": "Total de analizadores",
  "analyzer.status.active": "Activo",
  "analyzer.status.deleted": "Eliminado",
  "analyzer.status.error_pending": "Error pendiente",
  "analyzer.status.inactive": "Inactivo",
  "analyzer.status.offline": "Sin conexión",
  "analyzer.status.setup": "Configuración",
  "analyzer.status.validation": "Validación",
  "analyzer.success.save": "El analizador se ha guardado exitosamente",
  "analyzer.table.actions": "Acciones",
  "analyzer.table.connection": "Conexión",
  "analyzer.table.header.connection": "Conexión",
  "analyzer.table.header.lastModified": "Última modificación",
  "analyzer.table.header.name": " Nombre",
  "analyzer.table.header.status": "Estado",
  "analyzer.table.header.testUnits": "Unidades de laboratorio",
  "analyzer.table.header.type": "Tipo de analizador",
  "analyzer.table.lastModified": "Última modificación",
  "analyzer.table.name": " Nombre",
  "analyzer.table.status": "Estado",
  "analyzer.table.testUnits": "Unidades de prueba",
  "analyzer.table.type": "Tipo",
  "analyzer.table.type.loading": "Cargando el tipo de analizador",
  "analyzer.table.type.unavailable": "Tipo de analizador no disponible",
  "analyzer.testUnits.count": "{count, plural, one {# unit} many {# units} other {# unidades}}",
  "analyzer.testConnection.bridge.healthCheckFailed": "No se puede acceder al punto final de estado de Bridge en {url}: {detail}",
  "analyzer.testConnection.bridge.httpStatus": "Bridge devolvió el código de estado HTTP {status}",
  "analyzer.testConnection.bridge.notConfigured": "Bridge no está configurado",
  "analyzer.testConnection.bridge.unparseableResponse": "Bridge ha devuelto una respuesta que no se puede analizar.",
  "analyzer.testConnection.bridge.unreachable": "No se puede acceder a Bridge: {detail}",
  "analyzer.testConnection.close": "Cerrar",
  "analyzer.testConnection.logs": "Registros de conexión",
  "analyzer.testConnection.requestBuildFailed": "No se ha podido generar la solicitud: {detail}",
  "analyzer.testConnection.success": "Conexión establecida con éxito",
  "analyzer.testConnection.tcp.bridgeNotConfigured": "El puente no está configurado, por lo que no es posible comprobar la accesibilidad del Analizador",
  "analyzer.testConnection.testAgain": "Volver a realizar la prueba",
  "analyzer.testConnection.testing": "Prueba de la conexión...",
  "analyzer.testConnection.title": "Prueba de la conexión",
  "analyzer.testMapping.activeMappings": "{count} asignaciones activas",
  "analyzer.testMapping.analyzerInfo": "Información sobre el analizador",
  "analyzer.testMapping.analyzerName": "Nombre del analizador",
  "analyzer.testMapping.analyzerType": "Tipo de analizador",
  "analyzer.testMapping.appliedMappings": "Correspondencias aplicadas",
  "analyzer.testMapping.entityPreview": "Vista previa de entidades de OpenELIS",
  "analyzer.testMapping.errors": "Errores",
  "analyzer.testMapping.loading": "Se está procesando la vista previa...",
  "analyzer.testMapping.messageInput": "Muestra de mensaje ASTM",
  "analyzer.testMapping.messageInput.counter": "{current} / {max} caracteres",
  "analyzer.testMapping.messageInput.helper": "Introduzca un mensaje de muestra conforme a la norma ASTM para ver cómo se interpretará",
  "analyzer.testMapping.messageInput.placeholder": "H|\\^&|||PSM^Micro^2.0|...",
  "analyzer.testMapping.messageInput.required": "Muestra de mensaje ASTM *",
  "analyzer.testMapping.noResults": "Aún no hay resultados de vista previa. Introduzca un mensaje de muestra conforme a la norma ASTM y haga clic en «Vista previa de la asignación».",
  "analyzer.testMapping.parsedFields": "Campos analizados",
  "analyzer.testMapping.parsedFields.astmRef": "Referencia ASTM",
  "analyzer.testMapping.parsedFields.fieldName": "Nombre del campo",
  "analyzer.testMapping.parsedFields.interpretation": "Interpretación",
  "analyzer.testMapping.parsedFields.mappedTo": "Asignado a",
  "analyzer.testMapping.parsedFields.rawValue": "Valor bruto",
  "analyzer.testMapping.pluginConfigSnapshot": "Instantánea de la configuración del complemento",
  "analyzer.testMapping.previewOptions": "Opciones de vista previa",
  "analyzer.testMapping.previewOptions.detailedParsing": "Mostrar los pasos detallados del análisis sintáctico",
  "analyzer.testMapping.previewOptions.validateAll": "Valide todas las asignaciones",
  "analyzer.testMapping.results": "Vista previa de los resultados",
  "analyzer.testMapping.saveTestCase": "Guardar como caso de prueba",
  "analyzer.testMapping.submit": "Vista previa de la asignación",
  "analyzer.testMapping.subtitle": "Vea una vista previa de cómo se interpretarán los mensajes de muestra de la norma ASTM",
  "analyzer.testMapping.testAnother": "Pruebe con otro mensaje",
  "analyzer.testMapping.title": "Asignaciones de campos de prueba",
  "analyzer.testMapping.validation.invalidFormat": "Formato de mensaje ASTM no válido",
  "analyzer.testMapping.validation.messageRequired": "Es obligatorio introducir el mensaje ASTM",
  "analyzer.testMapping.validation.messageTooLarge": "El mensaje ASTM supera el tamaño máximo de 10 KB",
  "analyzer.testMapping.warnings": "Advertencias",
  "analyzer.unitMapping.analyzerUnit": "Unidad de origen (Analizador)",
  "analyzer.unitMapping.analyzerUnit.helper": "Unidad indicada por el analizador",
  "analyzer.unitMapping.conversionFactor": "Factor de conversión",
  "analyzer.unitMapping.conversionFactor.helper": "Factor de conversión de «{from}» a «{to}» (por ejemplo, 0,0555 para pasar de mg/dL a mmol/L)",
  "analyzer.unitMapping.openelisUnit": "Unidad de destino (OpenELIS)",
  "analyzer.unitMapping.openelisUnit.helper": "Unidad canónica utilizada en OpenELIS",
  "analyzer.unitMapping.openelisUnit.placeholder": "Seleccione la unidad de destino",
  "analyzer.unitMapping.rejectIfMismatch": "Rechazar si las unidades no coinciden",
  "analyzer.unitMapping.rejectIfMismatch.helper": "Rechazar los mensajes si las unidades no coinciden y no se proporciona ningún factor de conversión",
  "analyzer.unitMapping.subtitle": "Configure la asignación de unidades para {fieldName}",
  "analyzer.unitMapping.title": "Asignación de unidades",
  "analyzer.unitMapping.validation.analyzerUnit.required": "Es necesario indicar la unidad de origen",
  "analyzer.unitMapping.validation.conversionFactor.invalid": "El factor de conversión debe ser un número positivo",
  "analyzer.unitMapping.validation.conversionFactor.required": "El factor de conversión es necesario cuando las unidades son diferentes",
  "analyzer.unitMapping.validation.error": "Error de Validación",
  "analyzer.unitMapping.validation.error.subtitle": "Le rogamos que corrija los errores que figuran a continuación",
  "analyzer.unitMapping.validation.openelisUnit.required": "Es necesario indicar la unidad de destino",
  "analyzerTestName.header.analyzerName": "Analizador - Nombre de la prueba del analizador",
  "analyzerTestName.modal.add.heading": "Agregar el nombre de la prueba del analizador",
  "analyzerTestName.modal.update.heading": "Actualizar el nombre de la prueba del Analizador",
  "assigned.cytopathologist.label": "CitoPatólogo Asignado",
  "assigned.pathologist.label": "Patólogo asignado",
  "assigned.technician.label": "Técnico asignado",
  "audittrail.table.heading.action": " Acción",
  "audittrail.table.heading.identifier": " Identificador",
  "audittrail.table.heading.item": " Elemento",
  "audittrail.table.heading.newvalue": " Valor nuevo",
  "audittrail.table.heading.oldvalue": " Valor anterior",
  "audittrail.table.heading.time": "Hora",
  "audittrail.table.heading.user": " Usuario",
  "audittrail.table.title.patientResults": "Resultados de los pacientes",
  "availabletests.title": "Pruebas Disponibles",
  "back.action.button": "Atrás",
  "banner.menu.administration": "Administración",
  "banner.menu.alerts": "Alertas",
  "banner.menu.alerts.tooltip": "Panel de alertas y garantía de calidad",
  "banner.menu.aliquot": "Alícuota",
  "banner.menu.aliquot.tooltip": "Alícuota de muestra",
  "banner.menu.billing": "Facturación",
  "banner.menu.billing.tooltip": "Facturación",
  "banner.menu.createDouble": "Entrada Doble",
  "banner.menu.createInitial": "Entrada Inicial",
  "banner.menu.eorders": "Órdenes entrantes",
  "banner.menu.eqa": "ECA",
  "banner.menu.eqa.distribution": "Distribuciones de ECA",
  "banner.menu.eqa.distribution.tooltip": "Crear y gestionar distribuciones de ECA",
  "banner.menu.eqa.management": "Programas de ECA",
  "banner.menu.eqa.management.tooltip": "Crear y gestionar programas de evaluación externa de la calidad (ECA)",
  "banner.menu.eqa.mgmt": "Gestión de la ECA",
  "banner.menu.eqa.mgmt.distributions": "Distribuciones",
  "banner.menu.eqa.mgmt.distributions.tooltip": "Crear y gestionar distribuciones de ECA",
  "banner.menu.eqa.mgmt.participants": "Participantes",
  "banner.menu.eqa.mgmt.participants.tooltip": "Gestionar la inscripción de la organización en los programas de ECA",
  "banner.menu.eqa.mgmt.programs": "Programas",
  "banner.menu.eqa.mgmt.programs.tooltip": "Crear y gestionar programas de evaluación externa de la calidad (ECA)",
  "banner.menu.eqa.mgmt.results": "Resultados y análisis",
  "banner.menu.eqa.mgmt.results.tooltip": "Recopilación de resultados de la ECA y análisis estadístico",
  "banner.menu.eqa.mgmt.tooltip": "Gestionar los programas de ECA, los participantes y las distribuciones",
  "banner.menu.eqa.tests": "Pruebas de ECA",
  "banner.menu.eqa.tests.myPrograms": "Mis programas de ECA",
  "banner.menu.eqa.tests.myPrograms.tooltip": "Gestionar la autoinscripción en programas externos de ECA",
  "banner.menu.eqa.tests.orders": "Órdenes",
  "banner.menu.eqa.tests.orders.tooltip": "Consultar y gestionar las órdenes de pruebas de evaluación externa de la calidad (ECA)",
  "banner.menu.eqa.tests.tooltip": "Órdenes de pruebas de ECA e inscripción en el programa",
  "banner.menu.eqa.tooltip": "Garantía de calidad externa",
  "banner.menu.generic.sample": "Muestra genérica",
  "banner.menu.generic.sample.edit": " Editar orden",
  "banner.menu.generic.sample.import": "Importar muestras",
  "banner.menu.generic.sample.order": "Crear orden",
  "banner.menu.generic.sample.results": "Ingresar resultados",
  "banner.menu.help": "Ayuda",
  "banner.menu.help.about": "Tutoriales en video",
  "banner.menu.help.contact": "Notas de lanzamiento",
  "banner.menu.help.documents": "Documentación de procesos",
  "banner.menu.help.formDBS": "Formulario DBS",
  "banner.menu.help.formVL": "Formulario VL",
  "banner.menu.help.usermanual": "Manual de usuario",
  "banner.menu.home": "Inicio",
  "banner.menu.inventory": "Inventario",
  "banner.menu.inventory.catalog": "Gestionar el catálogo",
  "banner.menu.inventory.dashboard": "Panel",
  "banner.menu.inventory.list": "Elementos en stock",
  "banner.menu.inventory.reports": "Informes",
  "banner.menu.nonconformity": "No conforme",
  "banner.menu.nonconformity.correctiveActions": "Acciones correctivas",
  "banner.menu.nonconformity.dashboard": "Todos los NCE",
  "banner.menu.nonconformity.report": "Reportar evento no conforme",
  "banner.menu.nonconformity.view": "Ver nuevos eventos no conformes",
  "banner.menu.patient": "Paciente",
  "banner.menu.patient.Create": "Estudio",
  "banner.menu.patient.addOrEdit": "Agregar/Editar paciente",
  "banner.menu.patient.merge": "Fusionar paciente",
  "banner.menu.patient.merge.tooltip": "Fusionar los expedientes duplicados de los pacientes",
  "banner.menu.patientConsult": "Ver",
  "banner.menu.patientEdit": "Editar",
  "banner.menu.patienthistory": "Historial del paciente",
  "banner.menu.printBarcode": "Código de barras",
  "banner.menu.referredOut": "Referido",
  "banner.menu.report.validation.backlog": "Validación Retrasada",
  "banner.menu.reports": "Informes",
  "banner.menu.reports.routine": "Rutina",
  "banner.menu.reports.study": "Estudio",
  "banner.menu.results": "Resultados",
  "banner.menu.results.CobasIntegra400": "Bioquímica: Cobas Integra 400+",
  "banner.menu.results.FacsCalibur": "Inmunología: FacsCalibur",
  "banner.menu.results.FacsCantoII": "Inmunología: FacsCantoII",
  "banner.menu.results.FacsPrestoanalyzer": "Inmunología: FacsPresto",
  "banner.menu.results.Fullyanalyzer": "Bioquímica: Importador de analizador Fully",
  "banner.menu.results.GeneXpertAnalyzer": "GeneXpertAnalyzer",
  "banner.menu.results.GeneXpertanalyzer": "GeneXpertFileAnalyzer",
  "banner.menu.results.PocH100iAnalyzer": "PocH100iAnalyze",
  "banner.menu.results.SysmeXT": "Hematología: SysmeXT 2000i",
  "banner.menu.results.SysmexXNLAnalyzer": "Analizador SysmexXNL",
  "banner.menu.results.SysmexXNLanalyzer": "Analizador SysmexXNL",
  "banner.menu.results.SysmexXPAnalyzer": "SysmexXPAnalyzer",
  "banner.menu.results.SysmexXPanalyzer": "Analizador SysmexXP",
  "banner.menu.results.accession": "Por orden",
  "banner.menu.results.analyzer": "Analizador",
  "banner.menu.results.cobasc111analyzer": "Bioquímica: Cobas C111",
  "banner.menu.results.genexpertanalyzer": "GeneXpert",
  "banner.menu.results.logbook": "Por unidad",
  "banner.menu.results.mindrayanalyzer": "Mindray",
  "banner.menu.results.order.programmes": "Programas de órdenes",
  "banner.menu.results.patient": "Por paciente",
  "banner.menu.results.quantstudio3analyzer": "QuantStudio 3",
  "banner.menu.results.status": "Por prueba, fecha o estado",
  "banner.menu.results.sysmexanalyzer": "Hematología: Sysmex XT 2000 i",
  "banner.menu.results.sysmexxtanalyzer": "Hematología: Importador de analizador Sysmex XT",
  "banner.menu.results.taqman48dbsanalyzer": "Virología: Cobas TaqMan48 DNA PCR",
  "banner.menu.results.testdate": "Por fecha de prueba",
  "banner.menu.results.unified": "Ingreso de resultados",
  "banner.menu.results.unified.tooltip": "Lista de trabajo unificada para el ingreso de resultados",
  "banner.menu.results.weber": "Weber 4000",
  "banner.menu.resultvalidation": "Validación",
  "banner.menu.resultvalidation.bacteria": "Bacterias",
  "banner.menu.resultvalidation.bench": "Por Banco",
  "banner.menu.resultvalidation.biochemistry": "Bioquímica",
  "banner.menu.resultvalidation.cytobacteriology": "Citobacteriología",
  "banner.menu.resultvalidation.dnapcr": "PCR de ADN",
  "banner.menu.resultvalidation.ecbu": "ECBU",
  "banner.menu.resultvalidation.endocrinologie": "Endocrinología",
  "banner.menu.resultvalidation.genotyping": "Genotipificación",
  "banner.menu.resultvalidation.hemato-immunology": "Hemato-Inmunología",
  "banner.menu.resultvalidation.hematology": "Hematología",
  "banner.menu.resultvalidation.immunology": "Inmunología",
  "banner.menu.resultvalidation.immunology.Haiti": "Inmunología-Virología",
  "banner.menu.resultvalidation.immunologyHematology": "Inmunología - Hematología",
  "banner.menu.resultvalidation.liquidBio": "Biología Líquida",
  "banner.menu.resultvalidation.malaria": "Malaria",
  "banner.menu.resultvalidation.molecularBio": "Biología Molecular",
  "banner.menu.resultvalidation.mycobacteriology": "Micobacteriología",
  "banner.menu.resultvalidation.mycology": "Micología",
  "banner.menu.resultvalidation.parasitology": "Parasitología",
  "banner.menu.resultvalidation.serology": "Serología",
  "banner.menu.resultvalidation.serology-immunology": "Serología-Inmunología",
  "banner.menu.resultvalidation.viralload": "Carga Viral",
  "banner.menu.resultvalidation.virology": "Virología",
  "banner.menu.resultvalidation_routine": "Rutina",
  "banner.menu.resultvalidation_study": "Estudio",
  "banner.menu.sample": "Orden",
  "banner.menu.sample.shipment": "Envío de muestras",
  "banner.menu.sampleAdd": "Agregar orden",
  "banner.menu.sampleBatchEntry": "Entrada de órdenes por lote",
  "banner.menu.sampleConsult": "Consultar",
  "banner.menu.sampleCreate": "Estudio",
  "banner.menu.sampleEdit": "Editar orden",
  "banner.menu.sampleManagement": "Gestión de muestras",
  "banner.menu.sampleManagement.tooltip": "Menú de gestión de muestras",
  "banner.menu.storage": "Almacenamiento",
  "banner.menu.storage.tooltip": "Gestión del almacenamiento de muestras",
  "banner.menu.study.eorders": "Órdenes Electrónicas",
  "banner.menu.workplan": "Plan de trabajo",
  "banner.menu.workplan.batch": "Batch Workplan",
  "banner.menu.workplan.batch.tooltip": "Batch Workplan",
  "banner.menu.workplan.bench": "Por unidad",
  "banner.menu.workplan.panel": "Por panel",
  "banner.menu.workplan.priority": "Por prioridad",
  "banner.menu.workplan.test": "Por tipo de prueba",
  "banner.menu.workplan.unit": "Por sección de prueba",
  "barcode.additionalInvalidLevels.message": "El código de barras contiene niveles que van más allá de la parte válida. Solo se rellenan automáticamente los niveles válidos.",
  "barcode.additionalInvalidLevels.warning": "Se han detectado niveles no válidos adicionales",
  "barcode.autoOpenForm": "Abrir el formulario de ubicación con una jerarquía válida",
  "barcode.debounce.warning": "Por favor, espere antes de escanear otro Código de barras",
  "barcode.error": "Código de barras no válido",
  "barcode.firstMissingLevel": "Primer nivel que falta: {level}",
  "barcode.format": "Formato de Código de Barras",
  "barcode.header": " Código(s) de barras",
  "barcode.invalidFormat": "Formato de Código de Barras no válido. Se esperaba: ROOM-DEVICE o ROOM-DEVICE-SHELF-RACK-POSITION",
  "barcode.label.block": "Etiqueta de bloque",
  "barcode.label.freezer": "Etiqueta para el congelador",
  "barcode.label.helper.text": "Ingrese valores en: mm",
  "barcode.label.order": "Etiqueta de orden",
  "barcode.label.slide": "Etiqueta de la diapositiva",
  "barcode.label.specimen": "Etiqueta de muestra",
  "barcode.label.info.blockCaseNumber": "Número de caso del bloque",
  "barcode.label.info.blockId": "ID del bloque",
  "barcode.label.info.blockNumber": "Número de bloque",
  "barcode.label.info.boxid": "ID de caja",
  "barcode.label.info.caseNumber": "Número de caso",
  "barcode.label.info.collectedBy": "Recolectado por",
  "barcode.label.info.collectionDate": "Fecha de recolección",
  "barcode.label.info.collectionDateTime": "Fecha y hora de recolección",
  "barcode.label.info.created": "Creado",
  "barcode.label.info.destination": "Destino",
  "barcode.label.info.expiryDate": "Fecha de caducidad",
  "barcode.label.info.labNumber": "Número de acceso",
  "barcode.label.info.patientDobFull": "Fecha de nacimiento del paciente",
  "barcode.label.info.patientId": " ID del paciente",
  "barcode.label.info.patientName": "Nombre del paciente",
  "barcode.label.info.patientSexFull": " Sexo del paciente",
  "barcode.label.info.samplecount": "Muestras",
  "barcode.label.info.siteId": "ID del sitio",
  "barcode.label.info.slideId": "N.º de diapositiva",
  "barcode.label.info.slideNumber": "Número de diapositiva",
  "barcode.label.info.specimenType": "Tipo de muestra",
  "barcode.label.info.stainType": "Tipo de tinción",
  "barcode.label.info.storageLocation": "Ubicación de almacenamiento",
  "barcode.label.info.temperature": "Temperatura",
  "barcode.label.info.tests": "Pruebas",
  "barcode.labels.order.row": "Etiquetas de orden",
  "barcode.labels.running.total": "Total acumulado",
  "barcode.labels.sample.row": "Etiquetas de muestra para la muestra {sampleNumber}",
  "barcode.labels.section.title": "Cantidades de etiquetas",
  "barcode.locationNotFound": "No se ha encontrado la ubicación",
  "barcode.notification.save": "Las Configuraciones de Código de Barras han sido guardadas.",
  "barcode.partialMatch": "Coincidencia parcial: algunos componentes son válidos",
  "barcode.print.button": "Imprimir",
  "barcode.print.labels.title": "Labels for this order",
  "barcode.print.all.button": "Print all",
  "barcode.print.all.saved": "Prints every label saved with this order at its saved quantity.",
  "barcode.print.all.legacy": "Prints {orderCount, plural, one {# order label} other {# order labels}} and {specimenCount, plural, one {# label} other {# labels}} per specimen.",
  "barcode.print.col.label": "Etiqueta",
  "barcode.print.col.accession": "Número de acceso",
  "barcode.print.col.info": "Additional Info",
  "barcode.print.col.quantity": "Number to Print",
  "barcode.print.quantity.for": "Number of labels to print for {label}",
  "barcode.print.size": "{height} × {width} mm",
  "barcode.print.max.hint": "Up to {max}",
  "barcode.print.max.total": "Up to {max} in total, counting earlier prints",
  "barcode.print.row.button": "Print {label}",
  "error.labels.quantity.max": "A quantity above the preset maximum needs the label override.",
  "error.labels.quantity.min": "Print at least one label.",
  "barcode.print.dialog.quantityFor": "Cantidad a imprimir para «{label}»",
  "barcode.print.dialog.title": "Imprimir etiquetas",
  "barcode.print.done": "Hecho",
  "barcode.print.later": "Omitir — Imprimir más tarde",
  "barcode.print.preprint": "Preimprimir Códigos de Barras",
  "barcode.print.preprint.button": "Preimprimir Etiquetas",
  "barcode.print.preprint.note": " NOTA: Si se agrega una instalación y/o muestra y prueba, se imprimirá en CADA etiqueta",
  "barcode.print.skip": "Saltar",
  "barcode.print.title": "Imprimir Etiquetas de Código de Barras",
  "barcode.ready": "Listo para escanear",
  "barcode.scan": "Escanear código de barras",
  "barcode.scan.error": "No se ha encontrado la orden",
  "barcode.scan.placeholder": "Escanee el código de barras o ingrese el número de laboratorio...",
  "barcode.scan.success": "La orden se ha cargado correctamente",
  "barcode.scanning": "Escaneando...",
  "barcode.scanOrType": "Escanee el código de barras o introduzca la ubicación",
  "barcode.success": "Se ha encontrado la ubicación",
  "barcode.validHierarchyPrefilled": "Niveles jerárquicos válidos rellenados previamente",
  "barcode.validation.altPrefix": "La entrada debe ser alfanumérica y tener una longitud máxima de 4 caracteres.",
  "barcode.validationFailed": "Error en la validación del Código de barras",
  "barcodeconfiguration.browse.title": " Configuración de códigos de barras",
  "breadcrumb.home": "Inicio",
  "breadcrumb.caseView": "Vista del caso",
  "breadcrums.admin.managment": "Gestión de Administración",
  "calendar.management.title": "Gestión del calendario",
  "calendar.management.description": "Gestione los días festivos y la configuración de fines de semana para el cálculo del tiempo de respuesta (TAT) en horario laboral",
  "calendar.management.addHoliday": "Agregar día festivo",
  "calendar.management.editHoliday": "Editar día festivo",
  "calendar.management.deleteConfirm": "¿Está seguro de que desea eliminar este día festivo?",
  "calendar.management.holidayName": "Nombre de la festividad",
  "calendar.management.date": "Fecha",
  "calendar.management.recurring": "Recurrente",
  "calendar.management.annual": "Anual",
  "calendar.management.oneTime": "Único",
  "calendar.management.active": "Activo",
  "calendar.management.inactive": "Inactivo",
  "calendar.management.weekend": "Fin de semana",
  "calendar.management.weekendDays": "Días del fin de semana (excluidos del tiempo de trabajo)",
  "calendar.management.weekendSaved": "Se ha guardado la configuración de fin de semana",
  "calendar.management.importCsv": "Importar CSV",
  "calendar.management.exportCsv": "Exportar CSV",
  "calendar.management.importPreview": "Vista previa de la importación",
  "calendar.management.year": "Año",
  "calendar.management.noHolidays": "No hay días festivos configurados para {year}. Haga clic en «Agregar día festivo» para empezar.",
  "calendar.management.duplicateDate": "Ya existe un día festivo para esta fecha",
  "calendar.management.imported": "{count} días festivos importados",
  "calendar.management.skipped": "{count} días festivos no disfrutados",
  "calendar.management.holidayCount": "{count} días festivos configurados para {year}",
  "calendar.management.saveError": "Error al guardar el día festivo",
  "calendar.management.loadError": "Error al cargar los días festivos",
  "calendar.management.save": "Guardar",
  "calendar.management.cancel": "Cancelar",
  "calendar.management.actions": "Acciones",
  "calendar.management.status": "Estado",
  "calendar.management.column.date": "Fecha",
  "calendar.management.column.holidayName": "Nombre de la festividad",
  "calendar.management.column.recurring": "Recurrente",
  "calendar.management.column.status": "Estado",
  "calendar.management.column.actions": "Acciones",
  "calendar.management.day.sun": "Domingo",
  "calendar.management.day.mon": "Lunes",
  "calendar.management.day.tue": "Martes",
  "calendar.management.day.wed": "Miércoles",
  "calendar.management.day.thu": "Jueves",
  "calendar.management.day.fri": "Viernes",
  "calendar.management.day.sat": "Sábado",
  "calendar.management.chooseFile": "Seleccione un archivo CSV",
  "calendar.management.csvColumns": "Columnas: date, name, recurring (true/false)",
  "calendar.management.rowsFound": "{count} filas encontradas",
  "calendar.management.column.csvDate": "Fecha",
  "calendar.management.column.csvName": " Nombre",
  "calendar.management.column.csvRecurring": "Recurrente",
  "calendar.management.importing": "Importando...",
  "caseView.action.discard": "Descartar cambios",
  "caseView.action.saveDraft": "Guardar borrador",
  "caseView.action.showDeactivated": "Mostrar desactivados",
  "caseView.banner.unsavedChanges": "Este caso tiene cambios sin guardar. ¿Deseas abandonar la página y perderlos?",
  "caseView.badge.deactivated": "Desactivado",
  "caseView.badge.notApplicable": "N/A",
  "caseView.badge.readOnly": "Solo lectura",
  "caseView.label.assignedStaff": "{role}: {name}",
  "caseView.label.caseProgress": "Evolución del caso",
  "caseView.label.caseSummary": "Resumen del caso",
  "caseView.label.numberedSection": "{number}. {title}",
  "caseView.label.notRecorded": "— no registrado",
  "caseView.label.unsavedChanges": "Cambios no guardados",
  "caseView.locked.awaitingStage": "Disponible una vez que el caso alcance la etapa {stage}",
  "caseView.locked.prerequisite": "Disponible una vez que se completen los pasos anteriores de este caso",
  "column.qc.accession": "Muestra de control QC",
  "column.qc.detail": "Detalle",
  "column.qc.result": "Resultado",
  "column.qc.test": "Prueba",
  "column.qc.type": "Tipo",
  "compliance.dashboard.chart.comparison.title": "Comparación de centros — Porcentaje de cumplimiento en el periodo actual",
  "compliance.dashboard.chart.drilldown.title": "Desglose por centro — Tendencias por parámetro",
  "compliance.dashboard.chart.trend.title": "Tendencias de la tasa de cumplimiento — Todos los centros",
  "compliance.dashboard.descriptive.excluded": "Parámetros descriptivos excluidos del gráfico de tendencias",
  "compliance.dashboard.drilldown.placeholder": "Seleccione un sitio…",
  "compliance.dashboard.empty": "No hay datos que se ajusten a los filtros seleccionados",
  "compliance.dashboard.export.pdf": "Exportar a PDF",
  "compliance.dashboard.filter.allStandards": "Todos los estándares",
  "compliance.dashboard.filter.dateRange": "Rango de fechas",
  "compliance.dashboard.filter.dateRangeEnd": "Fecha de finalización",
  "compliance.dashboard.filter.drilldownSite": "Desglose por centro",
  "compliance.dashboard.filter.sites": "Sitios de muestreo",
  "compliance.dashboard.filter.sites.placeholder": "Todos los sitios",
  "compliance.dashboard.filter.standard": "Norma de cumplimiento",
  "compliance.dashboard.kpi.complianceRate": "Índice de cumplimiento",
  "compliance.dashboard.kpi.exceedances": "Total de rebasamientos",
  "compliance.dashboard.kpi.sitesMonitored": "Sitios objeto de seguimiento",
  "compliance.dashboard.kpi.totalOrders": "Total de órdenes",
  "compliance.dashboard.loading.comparison": "Cargando la comparación…",
  "compliance.dashboard.loading.drilldown": "Cargando el desglose…",
  "compliance.dashboard.loading.exceedances": "Cargando los valores de superación…",
  "compliance.dashboard.loading.generating": "Generando…",
  "compliance.dashboard.loading.trend": "Cargando las tendencias…",
  "compliance.dashboard.lowData": "Datos insuficientes (< 3 órdenes)",
  "compliance.dashboard.status.fail": "FAIL",
  "compliance.dashboard.table.col.date": "Fecha",
  "compliance.dashboard.table.col.labNumber": "N.º de laboratorio",
  "compliance.dashboard.table.col.parameter": "Parámetro",
  "compliance.dashboard.table.col.result": "Resultado",
  "compliance.dashboard.table.col.site": "Sitio",
  "compliance.dashboard.table.col.status": "Estado",
  "compliance.dashboard.table.col.threshold": "Umbral",
  "compliance.dashboard.table.exceedances.title": "Resumen de los valores que superan los límites",
  "compliance.dashboard.title": "Panel de cumplimiento medioambiental",
  "error.referOut.emailFormat": "Introduzca una dirección de correo electrónico válida (por ejemplo, lab@example.org).",
  "error.referOut.handoffRequiredForDispatch": "Es obligatorio indicar la fecha y la hora de entrega para poder realizar el envío.",
  "error.referOut.maxLength": "Máximo de {max} caracteres.",
  "error.referOut.phoneFormat": "Introduzca un número de teléfono válido con el prefijo del país (por ejemplo, +62 812 3456 7890).",
  "error.referOut.referringLabRequired": "Seleccione un laboratorio de referencia.",
  "error.validation.qc.ackFailed": "No se ha podido registrar la confirmación del CC. Inténtelo de nuevo.",
  "holding.time.exceeded.message": "Se ha superado el tiempo máximo de retención establecido en el procedimiento operativo estándar (SOP) para: {tests}",
  "holding.time.exceeded.note": "ADVERTENCIA: Se ha introducido el resultado tras haberse superado el tiempo máximo de retención establecido en el procedimiento operativo estándar (SOP).",
  "holding.time.exceeded.title": "Se ha superado la hora de espera",
  "label.button.edit.details": "Editar detalles",
  "label.expand.poolDetails": "Ver más detalles sobre el grupo",
  "label.pool.collapse": "Ocultar especímenes individuales",
  "label.pool.expand": "Mostrar especímenes individuales",
  "label.pool.expansion.next": "Siguiente",
  "label.pool.expansion.page": "Página {page} de {total}",
  "label.pool.expansion.prev": "Anterior",
  "label.pool.expansion.title": "Especímenes de {animal} ({count})",
  "label.qc.fail": "Fallido",
  "label.qc.pass": "Aprobado",
  "label.referOut.action.dispatch": "Enviar",
  "label.referOut.action.edit": "Editar",
  "label.referOut.action.referOut": "Referir",
  "label.referOut.action.save": "Guardar referencia",
  "label.referOut.action.view": "Consultar",
  "label.referOut.column.actions": "Acciones",
  "label.referOut.column.referringLab": "Laboratorio de Referencia",
  "label.referOut.column.sampleId": "N.º de muestra",
  "label.referOut.column.sampleType": " Tipo de muestra",
  "label.referOut.column.status": "Estado de la subcontratación",
  "label.referOut.column.tests": "Pruebas",
  "label.referOut.dispatch.error": "No se ha podido tramitar la derivación.",
  "label.referOut.dispatch.notSaved": "Guarde la remisión antes de enviarla.",
  "label.referOut.dispatch.success": "Se ha enviado la referencia.",
  "label.referOut.empty.subtitle": "Las muestras aparecerán aquí una vez que se hayan guardado. Guarde primero el pedido para remitir las muestras.",
  "label.referOut.empty.title": "No hay muestras disponibles para su remisión",
  "label.referOut.field.agreementReference": "Referencia del acuerdo",
  "label.referOut.field.cocContactEmail": "Correo electrónico del contacto para la cadena de custodia",
  "label.referOut.field.cocContactEmail.placeholder": "lab@example.org",
  "label.referOut.field.cocContactName": "Nombre de la persona de contacto de la cadena de custodia",
  "label.referOut.field.cocContactPhone": "Teléfono de contacto de la cadena de custodia",
  "label.referOut.field.cocContactPhone.placeholder": "+62 812 3456 7890",
  "label.referOut.field.expectedReturnDate": "Fecha prevista de devolución",
  "label.referOut.field.handoffDate": "Fecha de entrega",
  "label.referOut.field.handoffDatetime": "Fecha y hora de la entrega",
  "label.referOut.field.handoffTime": "Hora de entrega",
  "label.referOut.field.handoffTime.placeholder": "HH:mm",
  "label.referOut.field.notes": "Notas",
  "label.referOut.field.referringLab": "Laboratorio de Referencia",
  "label.referOut.field.referringLab.placeholder": "Seleccione un laboratorio de referencia",
  "label.referOut.save.error": "No se ha podido guardar la referencia.",
  "label.referOut.save.success": "Se ha guardado la referencia.",
  "label.referOut.section.description": "Envíe las muestras a un laboratorio externo. Cada muestra incluye todos los metadatos relativos a la cadena de custodia.",
  "label.referOut.section.title": "Referir / Subcontratar",
  "label.referOut.status.cancelled": "Cancelado",
  "label.referOut.status.closed": "Cerrado",
  "label.referOut.status.completed": "Completado",
  "label.referOut.status.dispatched": "Enviado",
  "label.referOut.status.draft": "Borrador",
  "label.referOut.status.inProgress": "En progreso",
  "label.referOut.status.notReferred": "Interno",
  "label.referOut.status.received": "Recibido",
  "label.referOut.status.rejected": "Rechazado",
  "label.referOut.status.requested": "Solicitado",
  "label.referOut.status.resultsReturned": "Resultados obtenidos",
  "label.referOut.field.reason": "Motivo",
  "label.referOut.field.reason.placeholder": "Select a reason (optional)",
  "label.referOut.action.referOutAll": "Refer out all in-house samples",
  "label.referOut.status.pendingSave": "Pending save",
  "label.referOut.staged.success": "Staged for {count} sample(s). The referral is saved with this step's Save.",
  "order.status.referredOut": "Referido",
  "order.referral.partial": "{referred} of {total} tests referred to {lab}",
  "order.referral.fully": "All {total} tests referred to {lab}",
  "label.sampleKind.blank": "BLANCO",
  "label.sampleKind.client": "Muestra de cliente",
  "label.sampleKind.control": "CONTROL",
  "label.sampleKind.duplicate": "DUPLICADO",
  "label.sampleKind.qc": "CC",
  "label.validation.qc.ack.checkbox": "He revisado los fallos de CC y he evaluado su impacto en la liberación de los resultados",
  "label.validation.qc.ack.heading": "Confirmación obligatoria",
  "label.validation.qc.banner.subtitle": "Revise y confirme a continuación antes de liberar los resultados.",
  "label.validation.qc.banner.title": "Fallos de CC detectados: {count} muestra(s) de CC no cumplieron los criterios de aceptación",
  "label.validation.qc.failedSamples": "Muestras que no superaron el CC",
  "label.validation.qc.justification": "Justificación",
  "label.validation.checkBeforeRelease": "Verificar antes de liberar",
  "label.validation.triage.filterLabel": "Filtrar por señal",
  "label.validation.filter.all": "Todos",
  "label.validation.filter.needsReview": "Es necesario revisarlo",
  "label.validation.filter.nce": "NCE",
  "label.validation.filter.qcFail": "Fallo de CC",
  "label.validation.filter.modified": "Modificado",
  "label.validation.filter.ackPending": "Confirmación pendiente",
  "label.validation.search.box": "Número de laboratorio",
  "label.validation.search.rangeHint": "A range: A..B, or A.. for A onwards",
  "label.validation.search.fromDate": "Desde",
  "label.validation.search.toDate": "Hasta",
  "label.validation.search.loadError": "The validation queue could not be loaded.",
  "label.validation.filter.critical": "Crítico",
  "label.validation.filter.abnormal": "Anormal",
  "label.validation.lane.clear": "Limpiar",
  "label.validation.lane.needsReview": "Es necesario revisarlo",
  "label.validation.signal.nce": "NCE abierto",
  "label.validation.signal.qcFail": "Fallo de CC",
  "label.validation.signal.modified": "Modificado",
  "label.validation.signal.ackPending": "Confirmación pendiente",
  "label.validation.signal.nonconforming": "No conforme",
  "label.validation.signal.critical": "Crítico",
  "label.validation.review.result": "Resultado",
  "label.validation.review.units": "Unidades",
  "label.validation.review.normalRange": "Rango de referencia",
  "label.validation.review.criticalRange": "Rango crítico",
  "label.validation.review.method": "Método",
  "label.validation.review.analyzer": "Analizador",
  "label.validation.review.performedAt": "Performed at",
  "label.validation.review.enteredBy": "Introducido por",
  "label.validation.review.enteredDate": "Registrado el",
  "label.validation.review.collected": "Recolectado",
  "label.validation.review.qc": "CC",
  "label.validation.review.qc.PASS": "CC aprobado",
  "label.validation.review.qc.FAIL": "CC fallido",
  "label.validation.review.notRecorded": "No se ha registrado",
  "label.validation.review.beforeRelease": "Antes de publicarlo, compruebe lo siguiente:",
  "label.validation.review.components": "Componentes",
  "label.validation.review.component": "Componente",
  "label.validation.review.flag": "Indicador",
  "label.validation.review.primary": "Principal",
  "label.validation.review.reference": "Referencia",
  "label.validation.review.notes": "Notas",
  "label.validation.review.notes.summary": "{count} notas",
  "label.validation.review.notes.empty": "Aún no hay notas",
  "label.validation.review.notes.add": "Nota de validación",
  "label.validation.review.notes.placeholder": "Agregue una nota de validación…",
  "label.validation.review.notes.visibility": "Visibilidad",
  "label.validation.review.notes.internal": "Interno",
  "label.validation.review.notes.external": "Enviar con el resultado",
  "label.validation.review.notes.externalWarning": "Esta nota aparecerá en el informe del paciente.",
  "label.validation.review.notes.contextHint": "Contexto: Validación (registrada automáticamente).",
  "label.validation.review.notes.context.result": "Nota sobre el resultado",
  "label.validation.review.modify.reason": "Motivo de la modificación",
  "label.validation.review.modify.reasonRequired": "Es necesario indicar un motivo para modificar un resultado.",
  "label.validation.review.modify.newValue": "Nuevo resultado",
  "label.validation.review.modify.notEditable": "Este tipo de resultado se edita en la página «Introducción de resultados».",
  "label.validation.review.qcSection": "CC",
  "label.validation.review.reagents.followUp": "Los lotes de reactivos y de control para este análisis se revisan en la página de introducción de Resultados.",
  "label.validation.review.action.release": "Validar y liberar",
  "label.validation.review.action.modify": "Modificar el resultado",
  "label.validation.review.action.saveModification": "Guardar los cambios",
  "label.validation.review.action.cancel": "Cancelar",
  "label.validation.review.action.refer": "Referir esta prueba",
  "label.validation.review.release.qcAckFirst": "Confirme el fallo de CC que se indica a continuación antes de liberar.",
  "label.validation.review.error.notAwaitingValidation": "Este resultado ha cambiado desde que se cargó la página. Recargue la página y vuelva a consultarlo.",
  "label.validation.review.error.qcAcknowledgmentRequired": "Los fallos de CC de este lote deben confirmarse antes de la liberación.",
  "label.validation.review.error.modificationReasonRequired": "Es necesario indicar un motivo para modificar un resultado.",
  "label.validation.review.error.modifyRoleRequired": "Su rol no le permite modificar los resultados.",
  "label.validation.review.error.resultRequired": "Introduzca un valor de resultado antes de guardar.",
  "label.validation.review.error.invalidResult": "El resultado está incompleto; compruebe el valor calificado.",
  "label.validation.review.error.generic": "No se ha podido completar la acción.",
  "label.validation.review.success.released": "El resultado ha sido validado y liberado.",
  "label.validation.review.success.accepted": "Component validated. The test is released once its other components are validated.",
  "label.validation.review.success.modified": "Se ha modificado el resultado. Permanece en la cola de validación.",
  "esig.context.validateSingle": "Validar y liberar «{test}» para el número de laboratorio {accession}",
  "label.validation.bulk.releaseAllClear": "Liberar todos sin alertas ({count})",
  "label.validation.bulk.heading": "Liberar todos los resultados sin alertas",
  "label.validation.bulk.bodyClear": "{count, plural, one {This # result is} other {These # results are}} in the Clear lane: in range, no recorded QC failure, no non-conformity, not modified, not critical. A result that stops being clear before the release is skipped.",
  "label.validation.bulk.bodyEsig": "Releasing commits one e-signature for the whole set.",
  "label.validation.bulk.disabled": "La liberación masiva está desactivada para este laboratorio.",
  "label.validation.emptyState.signals": "{count} results in this queue carry something to check before release.",
  "label.validation.emptyState.signalsDetail": "Most common: {signals}.",
  "label.validation.emptyState.noReference": "{count} results are for tests with no reference value recorded in the test catalogue, so they cannot be judged as normal.",
  "label.validation.emptyState.noReferenceHint": "Record an expected normal value for these tests in the Test Catalogue to let their results clear.",
  "label.validation.emptyState.rangeNotApplied": "{count} results had no reference range applied because patient sex or age is not recorded. Review them one by one, or record the missing value on the patient.",
  "label.validation.emptyState.queueEmpty": "Nothing is waiting for validation.",
  "label.validation.release.scope": "Clearance checks the reference range, result flags, non-conformities, edits after save and critical acknowledgment, and stops any result with a recorded quality-control failure. It does not confirm that quality control was performed.",
  "label.validation.bulk.none": "No hay resultados sin alertas para liberar.",
  "label.validation.bulk.column.accession": "Número de laboratorio",
  "label.validation.bulk.success": "{count} resultado(s) sin alertas liberado(s).",
  "label.validation.bulk.partial": "{released} liberados; se omitieron {skipped} porque ya no estaban sin alertas.",
  "label.validation.bulk.error.bulkReleaseDisabled": "La liberación masiva está desactivada para este laboratorio.",
  "label.validation.bulk.error.qcAcknowledgmentRequired": "Los fallos de CC de este lote deben confirmarse antes de la liberación.",
  "label.validation.bulk.error.nothingReleased": "Ninguno de los resultados seleccionados sigue sin alertas; no se liberó nada.",
  "label.validation.bulk.error.generic": "No se ha podido completar la liberación masiva.",
  "label.validation.review.action.review": "Revisar →",
  "esig.context.releaseAllClear": "Liberar {count} resultado(s) aptos para {accession}",
  "instructions.validation.bulk.release": "Cuando está activada, la página de validación ofrece la opción «Liberar todos los aptos», que libera únicamente los resultados del carril «Apto» (dentro del rango, sin fallo de CC registrado, sin señales) mediante una única firma electrónica. Desactívela para que sea necesario liberar cada resultado de forma individual tras su revisión.",
  "instructions.validation.retest.note": "Cuando esta opción esté activada, un validador que envíe un resultado para repetir la prueba deberá escribir una nota para el equipo de ensayo.",
  "label.validation.review.action.retest": "Envíelo para repetir la prueba",
  "label.validation.review.action.reject": "Rechazar (registrar NCE)",
  "label.validation.review.retest.note": "Nota para el banco",
  "label.validation.review.retest.noteRequired": "Se requiere una nota para enviar un resultado para repetir la prueba.",
  "label.validation.review.retest.hint": "El resultado vuelve a la fase de «Introducción de resultados» y el proceso se reinicia en el nivel 1.",
  "label.validation.review.reject.hint": "Al rechazar se registra un evento no conforme; complete el formulario para registrarlo.",
  "label.validation.review.reject.disabled": "En este laboratorio no se aplica el rechazo de resultados.",
  "label.validation.review.error.stale": "Este resultado ha sido modificado por {who} en {when}. Se está recargando la cola…",
  "label.validation.review.error.retestNoteRequired": "Se requiere una nota para enviar un resultado para repetir la prueba.",
  "label.validation.review.error.rejectionDisabled": "En este laboratorio no se aplica el rechazo de resultados.",
  "label.validation.review.success.retest": "El resultado se ha enviado para repetir la prueba.",
  "label.validation.review.success.rejected": "Se rechazó el resultado; se registró el evento no conforme.",
  "label.validation.bulk.error.stale": "La cola ha cambiado mientras usted la revisaba. Recargando…",
  "label.validation.autoValidated.toggle": "Incluir validados automáticamente",
  "label.validation.autoValidated.heading": "Resultados validados automáticamente ({count})",
  "label.validation.autoValidated.tag": "Validado automáticamente",
  "label.validation.autoValidated.empty": "No hay resultados validados automáticamente para este número de acceso.",
  "label.validation.autoValidated.hint": "Liberado al ingresar el resultado sin un validador; se muestra solo para revisión.",
  "label.validation.autoValidated.releasedOn": "Liberado el",
  "label.validation.signal.rangeNotApplied": "Range not applied",
  "result.rangeNotApplied.sexMissing": "Reference range not applied: patient sex not recorded",
  "result.rangeNotApplied.ageMissing": "Reference range not applied: patient age not recorded",
  "result.rangeNotApplied.sexAndAgeMissing": "Reference range not applied: patient sex and age not recorded",
  "laporanHasil.action.generatePdf": "Generar PDF",
  "laporanHasil.action.regeneratePdf": "Vuelva a generar el PDF",
  "laporanHasil.col.actions": "Acciones",
  "laporanHasil.col.collectionDate": "Fecha de recolección",
  "laporanHasil.col.compliance": "Cumplimiento normativo",
  "laporanHasil.col.labNumber": " Número de laboratorio",
  "laporanHasil.col.lastGenerated": "Última generación",
  "laporanHasil.col.site": "Sitio",
  "laporanHasil.col.standard": "Estándar",
  "laporanHasil.col.tests": "Pruebas",
  "laporanHasil.detail.ambientTemp": "Temperatura ambiente",
  "laporanHasil.detail.collectionDateTime": "Fecha y hora de recolección",
  "laporanHasil.detail.collectionMethod": "Método de recolección",
  "laporanHasil.detail.complianceSummary": "Resumen de cumplimiento",
  "laporanHasil.detail.conditions": "Condiciones de recolección",
  "laporanHasil.detail.gps": "GPS",
  "laporanHasil.detail.labAnalyst": "Analista de laboratorio",
  "laporanHasil.detail.labManager": "Responsable de laboratorio",
  "laporanHasil.detail.parameter": "Parámetro",
  "laporanHasil.detail.ppNo": "N.º de PP",
  "laporanHasil.detail.preservation": "Conservación",
  "laporanHasil.detail.result": "Resultado",
  "laporanHasil.detail.signatures": "Firmas",
  "laporanHasil.detail.site": "Sitio",
  "laporanHasil.detail.siteInfo": "Información del Sitio",
  "laporanHasil.detail.standard": "Estándar",
  "laporanHasil.detail.status": "Estado",
  "laporanHasil.detail.threshold": "Umbral",
  "laporanHasil.detail.waterTemp": "Temperatura del agua",
  "laporanHasil.detail.weather": "Clima",
  "laporanHasil.empty": "No se han encontrado órdenes que se ajusten a los filtros seleccionados.",
  "laporanHasil.error": "No se ha podido cargar el informe. Inténtelo de nuevo.",
  "laporanHasil.filter.all": "Todos",
  "laporanHasil.filter.allSites": "Todos los sitios",
  "laporanHasil.filter.allStandards": "Todos los estándares",
  "laporanHasil.filter.complianceStatus": "Estado de cumplimiento",
  "laporanHasil.filter.dateFrom": "Desde fecha",
  "laporanHasil.filter.dateTo": "Hasta fecha",
  "laporanHasil.filter.generated": "Generado",
  "laporanHasil.filter.generationStatus": "Estado de la generación",
  "laporanHasil.filter.notGenerated": "Aún no se ha generado",
  "laporanHasil.filter.samplingSite": "Punto de muestreo",
  "laporanHasil.filter.standard": "Norma de cumplimiento",
  "laporanHasil.loading": "Cargando el informe de cumplimiento...",
  "laporanHasil.status.borderline": "Límite",
  "laporanHasil.status.compliant": "Conforme",
  "laporanHasil.status.ineligible": "No hay ninguna norma asociada",
  "laporanHasil.status.nonCompliant": "No conforme",
  "laporanHasil.status.none": "–",
  "laporanHasil.subtitle": "Generar certificados de cumplimiento para las órdenes ambientales validadas",
  "laporanHasil.tile.generated": "Generado",
  "laporanHasil.tile.ineligible": "No cumple los requisitos",
  "laporanHasil.tile.ineligible.desc": "No validado o sin norma asociada",
  "laporanHasil.tile.notGenerated": "Aún no se ha generado",
  "laporanHasil.title": "Informe de cumplimiento",
  "lhu.amendment.error.generic": "No se ha podido volver a generar el informe. Inténtelo de nuevo.",
  "lhu.amendment.modal.description": "Va a volver a emitir el LHU correspondiente al número de laboratorio {labNumber}. El informe reemitido se identificará como una modificación del certificado publicado anteriormente.",
  "lhu.amendment.modal.heading": "Reemisión de la LHU con enmienda",
  "lhu.amendment.modal.submit": "Reemitir y descargar PDF",
  "lhu.amendment.reason.helper": "Indique el motivo por el que se modifica el informe original (requisito para el cumplimiento de la norma ISO 17025, apartado 7.8.8).",
  "lhu.amendment.reason.label": "Motivo de la modificación",
  "lhu.amendment.reason.placeholder": "Por ejemplo: resultado de pH incorrecto — el instrumento no estaba calibrado",
  "lhu.amendment.reason.required": "Es obligatorio indicar el motivo de la modificación",
  "lhu.amendment.reissue": "Reemitir con modificación",
  "lhu.amendment.submitting": "Reemitiendo…",
  "nce.close.error": "No se ha podido cerrar NCE",
  "nce.close.success": "El NCE se ha cerrado correctamente",
  "nce.correctiveAction.error": "No se ha podido actualizar el estado de NCE",
  "nce.correctiveAction.success": "El NCE pasó a Acción correctiva",
  "notificationtrigger.activetriggers.heading": "Desencadenantes activos",
  "notificationtrigger.activetriggers.subtitle": "Cada fila controla un tipo de evento de notificación. Seleccione «Activo» para activarlo. La configuración del canal y del destinatario solo se aplica cuando el desencadenante está activado.",
  "notificationtrigger.channel.email": "Correo Electrónico",
  "notificationtrigger.channel.sms": "SMS",
  "notificationtrigger.channel.whatsapp": "WhatsApp",
  "notificationtrigger.template.disallowed": "This message type cannot include {fields}. Use the merge fields listed under the template.",
  "notificationtrigger.column.channels": "Canales",
  "notificationtrigger.column.enabled": "Activado",
  "notificationtrigger.column.eventcode": "Código del evento",
  "notificationtrigger.column.override": "Sustitución por unidad de laboratorio",
  "notificationtrigger.column.recipients": "Destinatarios",
  "notificationtrigger.column.trigger": "Disparador",
  "notificationtrigger.config.subtitle": "Active o desactive los desencadenantes de las notificaciones, seleccione los canales de envío y configure los tipos de destinatarios para cada evento.",
  "notificationtrigger.config.title": "Configuración de los desencadenantes de notificaciones",
  "notificationtrigger.disabled.hint": "Active este disparador para configurar sus canales y destinatarios.",
  "notificationtrigger.override.comingsoon": "La sustitución por unidad de laboratorio aún no está disponible.",
  "notificationtrigger.override.configure": "Configurar",
  "notificationtrigger.recipient.coccontact": "Contacto del CoC",
  "notificationtrigger.recipient.orderingprovider": "Proveedor solicitante",
  "notificationtrigger.recipient.submittinguser": "Usuario que envía la solicitud",
  "notificationtrigger.referralout.defaultoff": "Por defecto, está desactivado — debe activarse de forma explícita.",
  "notificationtrigger.referralout.description": "Se envía cuando se remite una muestra a un laboratorio externo.",
  "notificationtrigger.referralout.firesoncenote": "Se envía una notificación por cada referencia guardada. Si una orden incluye referencias a dos laboratorios diferentes, se envían dos notificaciones.",
  "notificationtrigger.referralout.name": "Referencia externa",
  "notificationtrigger.sentmessages.action.resend": "Reenviar",
  "notificationtrigger.sentmessages.action.viewlog": "Consultar registro",
  "notificationtrigger.sentmessages.channel.failed": "falló",
  "notificationtrigger.sentmessages.channel.sent": "Enviado",
  "notificationtrigger.sentmessages.column.actions": "Acciones",
  "notificationtrigger.sentmessages.column.channels": "Canales",
  "notificationtrigger.sentmessages.column.datetime": "Fecha / Hora",
  "notificationtrigger.sentmessages.column.recipient": "Destinatario",
  "notificationtrigger.sentmessages.column.reference": "Referencia",
  "notificationtrigger.sentmessages.column.status": "Estado",
  "notificationtrigger.sentmessages.column.type": "Tipo",
  "notificationtrigger.sentmessages.count": "{count} de {total} mensajes",
  "notificationtrigger.sentmessages.empty.heading": "Aún no se ha enviado ninguna notificación.",
  "notificationtrigger.sentmessages.filter.status.all": "Todos los estados",
  "notificationtrigger.sentmessages.filter.status.failed": "Fallido",
  "notificationtrigger.sentmessages.filter.status.label": "Estado",
  "notificationtrigger.sentmessages.filter.status.sent": "Enviado",
  "notificationtrigger.sentmessages.filter.type.all": "Todos los tipos",
  "notificationtrigger.sentmessages.filter.type.label": "Tipo",
  "notificationtrigger.sentmessages.heading": "Mensajes enviados",
  "notificationtrigger.sentmessages.resend.disclaimer": "Al reenviar el mensaje, se repiten los bytes del mensaje original y la dirección del destinatario. Para enviarlo a una dirección diferente, edite el historial del paciente y genere un nuevo evento.",
  "notificationtrigger.sentmessages.resend.failure": "El reenvío ha fallado. Consulte los registros del servidor para obtener más detalles.",
  "notificationtrigger.sentmessages.resend.success": "Se ha reenviado la notificación.",
  "notificationtrigger.sentmessages.status.failed": "Fallido",
  "notificationtrigger.sentmessages.status.sent": "Enviado",
  "notificationtrigger.sentmessages.subtitle": "Todos los mensajes salientes enviados por OpenELIS, independientemente del tipo de desencadenante y del canal.",
  "notificationtrigger.sentmessages.viewlog.channels": "Resultados del canal",
  "notificationtrigger.sentmessages.viewlog.column.attempts": "Intentos",
  "notificationtrigger.sentmessages.viewlog.column.channel": "Canal",
  "notificationtrigger.sentmessages.viewlog.column.error": "Error",
  "notificationtrigger.sentmessages.viewlog.column.status": "Estado",
  "notificationtrigger.sentmessages.viewlog.heading": "Registro de notificaciones",
  "notificationtrigger.sentmessages.viewlog.message": "Cuerpo del mensaje",
  "notificationtrigger.sentmessages.viewlog.subject": "Asunto",
  "notificationtrigger.status.new": "NUEVO",
  "notificationtrigger.subcontractdispatched.description": "Se envía cuando una muestra se ha enviado físicamente al laboratorio receptor.",
  "notificationtrigger.subcontractdispatched.name": "Subcontratación enviada",
  "notificationtrigger.tabs.sentmessages": "Mensajes enviados",
  "notificationtrigger.tabs.sentmessages.placeholder": "Mensajes enviados: disponible en una próxima versión.",
  "notificationtrigger.tabs.templates": "Plantillas",
  "notificationtrigger.tabs.templates.placeholder": "Editor de plantillas: estará disponible en una próxima versión.",
  "notificationtrigger.tabs.triggers": "Desencadenantes",
  "notificationtrigger.templates.body.help": "Texto libre con campos de combinación. Esta plantilla no está gestionada por i18n; edítela directamente.",
  "notificationtrigger.templates.body.label": "Cuerpo del mensaje",
  "notificationtrigger.templates.button.reset": "Restablecer los valores predeterminados",
  "notificationtrigger.templates.button.save": "Guardar plantilla",
  "notificationtrigger.templates.channel.help": "Cada canal tiene sus propios campos de plantilla. Cambie de canal para editarlos por separado.",
  "notificationtrigger.templates.channel.label": "Canal",
  "notificationtrigger.templates.heading": "Configuración de la plantilla de notificación",
  "notificationtrigger.templates.mergefields.heading": "Campos de fusión disponibles",
  "notificationtrigger.templates.mergefields.help": "Los campos que aparecen a continuación son específicos del evento «{eventCode}». Haga clic en un campo para insertarlo en la posición del cursor.",
  "notificationtrigger.templates.mergefields.optionalnote": "Si no se ha establecido [expectedReturn] en la referencia, se muestra en blanco — sin que se produzca ningún error.",
  "notificationtrigger.templates.preview.label": "Vista previa renderizada",
  "notificationtrigger.templates.referralout.description": "Se envía al contacto del cliente (Proveedor solicitante) y/o al personal interno (Usuario que envía la solicitud) cuando se guarda una referencia.",
  "notificationtrigger.templates.subcontractdispatched.description": "Se envía al contacto responsable del CoC del laboratorio receptor y al cliente cuando se envía físicamente una muestra al laboratorio receptor.",
  "notificationtrigger.templates.subject.label": "Asunto",
  "notificationtrigger.templates.subtitle": "Redacte plantillas de mensajes para cada tipo de evento de notificación. Las plantillas consisten en texto libre con campos de fusión.",
  "order.clinicalInfo.helper": "Contexto opcional para orientar la selección de pruebas y la elaboración de informes; no se registra como diagnóstico confirmado.",
  "order.complete.processing.description": "{labNumber} Ahora se encuentra en estado «{status}» y aparecerá en la lista de trabajo de identificación de vectores V-03.",
  "order.complete.processing.description.plain": "{labNumber} ahora se encuentra en estado «En proceso» y aparecerá en la lista de trabajo de identificación de vectores V-03.",
  "order.complete.processing.title": "Orden completada — En proceso",
  "order.context.poolOf": "Pool de {count} {animal}",
  "order.paymentStatus.helper": "Cómo se gestionará el pago de esta orden.",
  "order.priority.helper": "RUTINA: plazo de tramitación habitual. STAT: tramitar de inmediato.",
  "order.referral.sampleType.ambiguous": "En esta orden referida se solicitó {items}, pero no fue posible determinar automáticamente el tipo de muestra. Seleccione a continuación un tipo de muestra y elija las pruebas solicitadas.",
  "order.requester.section.helper": "Seleccione la instalación que solicitó las pruebas y al proveedor responsable.",
  "panel.domain.clinical": "Clínico",
  "panel.domain.environmental": "Medioambiental",
  "panel.domain.eqa": "EQA",
  "panel.domain.vector": "Vector",
  "panel.filter.domain": "Dominio",
  "panel.organism.flea": "Pulga",
  "panel.organism.fly": "Volar",
  "panel.organism.mosquito": "Mosquito",
  "panel.organism.rodent": "Roedor",
  "panel.organism.selectPlaceholder": "Seleccione un grupo de organismos",
  "panel.organism.tick": "Marca",
  "patient.search.section.helper": "Busque por cualquier combinación de campos. Los nombres coinciden de forma exacta o por sus primeras letras. La opción «Búsqueda externa» consulta el Registro de Clientes y requiere, como mínimo, un nombre y una fecha de nacimiento.",
  "placeholder.validation.qc.justification": "Obligatorio (máximo 500 caracteres)",
  "provider.add.new": "+ Agregar un nuevo proveedor «{name}»",
  "providerTitle.abbreviation": "Abreviatura",
  "providerTitle.add": "Añadir título",
  "providerTitle.confirm.activate": "¿Activar \"{title}\"?",
  "providerTitle.confirm.activate.body": "Se volverá a ofrecer al elegir el título de un proveedor.",
  "providerTitle.confirm.deactivate": "¿Desactivar \"{title}\"?",
  "providerTitle.confirm.deactivate.body": "Ya no se ofrecerá para nuevas selecciones. Él/Los {count} proveedor/es que ya lo tienen lo conservan.",
  "providerTitle.duplicate": "\"{value}\" ya está en la lista",
  "providerTitle.edit": "Editar título",
  "providerTitle.edit.warning": "Cambiar un título modifica cómo se muestra en todos los proveedores que lo utilizan.",
  "providerTitle.empty": "Aún no hay títulos de proveedores configurados.",
  "providerTitle.filter.status": "Estado",
  "providerTitle.filter.status.active": "Activo",
  "providerTitle.filter.status.all": "Todos",
  "providerTitle.filter.status.inactive": "Inactivo",
  "providerTitle.inUse": "En uso",
  "providerTitle.search": "Buscar títulos",
  "providerTitle.sortOrder": "Orden de clasificación",
  "providerTitle.summary": "{total} título(s): {active} activo(s), {inactive} inactivo(s).",
  "providerTitle.title": "Título",
  "providerTitle.titles": "Títulos de proveedores",
  "provider.email.field": "Correo Electrónico del Proveedor",
  "provider.fax.field": "Fax del proveedor",
  "provider.title.field": "Título",
  "provider.title.inName": "Eso parece un título. Considere moverlo al campo de título para que las listas se ordenen por apellido.",
  "provider.title.filter": "Filtrar por título",
  "provider.title.filter.all": "Todos los títulos",
  "provider.title.placeholder": "Seleccione un título...",
  "provider.firstName.field": "Primer Nombre",
  "provider.lastName.field": "Apellido",
  "provider.new.helper": "Se creará como nuevo proveedor cuando se guarde esta orden.",
  "provider.new.tag": "Nuevo",
  "provider.no.match": "No se ha encontrado ningún proveedor que se ajuste a su búsqueda.",
  "provider.phone.field": "Teléfono",
  "qc.add.blank": "+ CC de blanco",
  "qc.add.control": "+ CC de control",
  "qc.add.duplicate": "+ CC de duplicado",
  "qc.collect.inheritsFromParent": "Detalles de la recolección heredados de la muestra principal",
  "qc.expectedValue.placeholder": "p. ej., 50.0",
  "qc.samples.label": "Muestras de CC:",
  "qc.samples.numericOnly": "Actualmente, el CC solo es compatible con pruebas cuyos resultados sean numéricos. Las pruebas seleccionadas están codificadas: elija una prueba numérica para aplicar el CC.",
  "qc.samples.thresholdsMissing": "Configure los umbrales de CC para «{tests}» en «Administración» → «Configuración de pruebas» antes de agregar muestras de CC.",
  "qc.status.current": "Estado de CC actual",
  "qc.status.failed.warning.message": "Los lotes que no superan el control de calidad (CC) se excluyen de las pruebas y del stock disponible para su uso.",
  "qc.status.failed.warning.title": "Este lote no se podrá utilizar",
  "qc.status.new": "Nuevo estado de CC",
  "qc.status.notes": "Notas de CC",
  "qc.status.notes.placeholder": "Motivo del resultado de CC, prueba realizada o referencia",
  "qc.type.blank": "CC: Blanco",
  "qc.type.control": "CC: Control",
  "qc.type.duplicate": "CC: Duplicado",
  "referral.accept.error": "No se ha podido aceptar el resultado. Inténtelo de nuevo.",
  "referral.action.accept": "Aceptar",
  "referral.action.acceptToAnalysis": "Aceptar el análisis",
  "referral.action.clearFilters": "Limpiar filtros",
  "referral.action.enterResult": "Ingresar resultado",
  "referral.action.markLost": "Marcar como perdido",
  "referral.action.notifyReferenceLab": "Notifique al Laboratorio de Referencia",
  "referral.action.openResultEntry": "Abrir en «Entrada de resultados»",
  "referral.action.reject": " Rechazar",
  "referral.banner.filterToStuck": "Mostrar solo las atascadas",
  "referral.banner.stuckReferralsSubtitle": "{count} referencia(s) llevan más de {threshold} día(s) en un laboratorio de referencia.",
  "referral.banner.stuckReferralsTitle": "Se han detectado referencias bloqueadas",
  "referral.box.cannotReconcileMessage": "No se puede conciliar la caja: {count} muestras aún están pendientes de conciliación de resultados. Consulte Resultados del Laboratorio de Referencia.",
  "referral.box.viewBlockedReferrals": "Consultar los resultados del Laboratorio de Referencia",
  "referral.breadcrumb.referenceLabResults": "Resultados del Laboratorio de Referencia",
  "referral.chip.ariaLabel": "Vista de resultados del Laboratorio de Referencia",
  "referral.chip.history": "Historial",
  "referral.chip.outstanding": "Pendientes",
  "referral.chip.returned": "Devuelto — requiere una acción",
  "referral.column.actions": "Acciones",
  "referral.column.boxId": "ID de caja",
  "referral.column.closedDate": "Fecha de cierre",
  "referral.column.daysOutstanding": "Días pendientes",
  "referral.column.daysTotal": "Total de días",
  "referral.column.labNumber": " Número de laboratorio",
  "referral.column.outcome": "Resultado",
  "referral.column.patient": "Paciente",
  "referral.column.priority": " Prioridad",
  "referral.column.referenceLab": "Laboratorio de Referencia",
  "referral.column.requestor": "Solicitante original",
  "referral.column.resultSummary": "Resumen de resultados",
  "referral.column.returnedDate": "Fecha de devolución",
  "referral.column.sentDate": "Fecha de Envío",
  "referral.column.status": "Estado",
  "referral.column.tests": "Prueba(s)",
  "referral.expand.criticalBadge": "CRITICAL",
  "referral.expand.detail.ageYears": "{years, plural, one {# year} many {# years} other {# años}}",
  "referral.expand.detail.boxId": "ID de caja",
  "referral.expand.detail.boxReceivedDate": "Recibido en el Laboratorio de Referencia",
  "referral.expand.detail.collected": "Recolectado",
  "referral.expand.detail.currentStatus": "Estado actual",
  "referral.expand.detail.daysOutstanding": "Días pendientes",
  "referral.expand.detail.dispatched": "Enviado",
  "referral.expand.detail.fhirTask": "Tarea FHIR",
  "referral.expand.detail.labNumber": " Número de laboratorio",
  "referral.expand.detail.patient": "Paciente",
  "referral.expand.detail.priority": " Prioridad",
  "referral.expand.detail.referenceLab": "Laboratorio de Referencia",
  "referral.expand.detail.requestor": "Solicitante original",
  "referral.expand.detail.sampleType": "Tipo de muestra",
  "referral.expand.detail.tests": "Pruebas",
  "referral.expand.noResultPayload": "El Laboratorio de Referencia no ha facilitado ningún resultado estructurado.",
  "referral.expand.originalOrderContext": "Contexto de la orden original",
  "referral.expand.outcomeDetail": "Detalles del resultado",
  "referral.expand.receptionAction": "Acción de acogida",
  "referral.expand.receptionHint": "Revise a continuación el resultado devuelto y, luego, seleccione «Aceptar» para incorporarlo al historial del paciente o «Rechazar» si el resultado no se puede utilizar.",
  "referral.expand.referenceLabTransit": "Transporte a laboratorios de referencia",
  "referral.expand.result": "Resultado",
  "referral.expand.statusDetail": "Detalles del estado",
  "referral.filter.allPriorities": "Todas las prioridades",
  "referral.filter.allRefLabs": "Todos los laboratorios de referencia",
  "referral.filter.dateRange": "Rango de fechas",
  "referral.filter.daysOutstandingBucket": "Días pendientes",
  "referral.filter.daysOutstandingBucket.stuck": "Atascado (más de {threshold} días)",
  "referral.filter.priority": " Prioridad",
  "referral.filter.referenceLab": "Laboratorio de Referencia",
  "referral.markLost.cancelButton": "Cancelar",
  "referral.markLost.confirmButton": "Marcar como extraviado",
  "referral.markLost.description": "Esto marca la referencia como perdida en tránsito y la elimina de «Pendientes». El equipo clínico deberá volver a recolectar la muestra y volver a referirla.",
  "referral.markLost.modalTitle": "Marcar la referencia como perdida",
  "referral.markLost.reasonLabel": "Motivo",
  "referral.markLost.reasonPlaceholder": "Por ejemplo: el servicio de mensajería ha realizado la confirmación de la pérdida. La caja nunca llegó al Laboratorio de Referencia.",
  "referral.markLost.reasonRequired": "Es necesario indicar el motivo.",
  "referral.metric.outstanding": "Pendientes",
  "referral.metric.reconciledToday": "Se ha conciliado hoy",
  "referral.metric.rejectedThisWeek": "Rechazado esta semana",
  "referral.metric.returned": "Devuelto — requiere una acción",
  "referral.notification.accepted": "El resultado se ha incorporado a la historia clínica del paciente.",
  "referral.notification.rejected": "Resultado rechazado. Se ha notificado al médico para que vuelva a recolectar la muestra.",
  "referral.notify.errorRetry": "No se ha podido notificar al Laboratorio de Referencia. Inténtelo de nuevo.",
  "referral.notify.toast": "Se ha informado al Laboratorio de Referencia.",
  "referral.page.title": "Resultados del Laboratorio de Referencia",
  "referral.reject.cancelButton": "Cancelar",
  "referral.reject.confirmButton": "Rechazar y notificarlo al médico",
  "referral.reject.description": "Al rechazar, se cierra definitivamente la prueba de origen y se notifica al médico que debe volver a recolectar la muestra y referirla de nuevo.",
  "referral.reject.error": "No se ha podido rechazar el resultado. Inténtelo de nuevo.",
  "referral.reject.modalTitle": "Rechazar el resultado devuelto",
  "referral.reject.reason.clotted": "Coagulada",
  "referral.reject.reason.damagedContainer": "Contenedor dañado",
  "referral.reject.reason.hemolyzed": "Hemolizado",
  "referral.reject.reason.insufficientVolume": "Volumen insuficiente",
  "referral.reject.reason.mislabeled": "Mal etiquetado",
  "referral.reject.reason.other": "Otros",
  "referral.reject.reason.temperatureDeviation": "Desviación de temperatura",
  "referral.reject.reason.wrongSampleType": "Tipo de muestra incorrecto",
  "referral.reject.reasonLabel": "Motivo",
  "referral.reject.reasonTextLabel": "Detalles",
  "referral.reject.reasonTextPlaceholder": "Explique por qué no se puede utilizar este resultado obtenido.",
  "referral.reject.reasonTextRequired": "Se requieren más detalles.",
  "referral.reject.warningTitle": "Esta acción no se puede deshacer",
  "referral.result.interp.Abnormal": "Anormal",
  "referral.result.interp.Critical": "Crítico",
  "referral.result.interp.Normal": "Normal",
  "referral.status.cancelled": "Cancelado",
  "referral.status.completed": "Resultado obtenido",
  "referral.status.draft": "Borrador",
  "referral.status.inProgress": "En progreso en el Laboratorio de Referencia",
  "referral.status.received": "En el Laboratorio de Referencia",
  "referral.status.reconciled": "Conciliado",
  "referral.status.rejected": "Rechazado por el Laboratorio de Referencia",
  "referral.status.requested": "Enviado — a la espera de ser aceptado",
  "referral.table.count": "{count, plural, =0 {Sin derivaciones} one {# derivación} other {# derivaciones}}",
  "referral.table.history.title": "Historial",
  "referral.table.outstanding.title": "Referencias pendientes",
  "referral.table.returned.title": "Devuelto — requiere una acción",
  "referral.tag.manuallyEntered": "Ingresado manualmente",
  "reports.tat.title": "Informe de tiempos de respuesta",
  "reports.tat.description": "Analice los tiempos de respuesta de los laboratorios en las distintas fases del flujo de trabajo",
  "reports.tat.generateReport": "Generar Reporte",
  "reports.tat.clearFilters": "Limpiar filtros",
  "reports.tat.segment.orderToCollection": "De la orden a la recolección",
  "reports.tat.segment.collectionToReceipt": "De la recolección a la recepción",
  "reports.tat.segment.receiptToTesting": "De la recepción al inicio de las pruebas",
  "reports.tat.segment.receiptToResult": "De la recepción a la entrada de resultados",
  "reports.tat.segment.receiptToValidation": "Desde la recepción hasta la Validación",
  "reports.tat.segment.resultToValidation": "De la entrada de resultados a la validación",
  "reports.tat.segment.overall": "Tiempo de respuesta total",
  "reports.tat.calendarTime": "Tiempo calendario",
  "reports.tat.workingTime": "Tiempo de trabajo",
  "reports.tat.workingTimeInfo": "Modo «Tiempo de trabajo»: se excluyen {weekendDays} y {holidayCount} días festivos en el rango de fechas seleccionado",
  "reports.tat.configuredWeekends": "fines de semana establecidos",
  "reports.tat.noHolidaysWarning": "No hay días festivos configurados. Configure los días festivos en «Administración» > «Gestión del calendario».",
  "reports.tat.manageCalendar": "Gestionar el calendario",
  "reports.tat.totalResults": "Resultados totales",
  "reports.tat.meanTat": "Tiempo de respuesta medio (TAT)",
  "reports.tat.medianTat": "TAT mediana",
  "reports.tat.percentile90": "percentil 90",
  "reports.tat.minTat": "TAT mínimo",
  "reports.tat.maxTat": "Tiempo de respuesta máximo",
  "reports.tat.stdDeviation": "Desviación estándar",
  "reports.tat.distribution": "Distribución TAT",
  "reports.tat.breakdownBy": "Desglose por",
  "reports.tat.clickRowHint": "Haga clic en una fila para consultar los resultados individuales",
  "reports.tat.summary": "Resumen",
  "reports.tat.detailList": "Lista detallada",
  "reports.tat.trends": " Tendencias",
  "reports.tat.noResults": "No se encontraron resultados para los filtros seleccionados. Intente ajustar el intervalo de fechas o los criterios de filtrado.",
  "reports.tat.insufficientData": "Datos insuficientes",
  "reports.tat.loadError": "Se ha producido un error al cargar los datos del informe",
  "reports.tat.dateRange": "Rango de fechas",
  "reports.tat.labUnit": "Unidad de laboratorio",
  "reports.tat.testPanel": "Prueba / Panel",
  "reports.tat.priority.all": "Todos",
  "reports.tat.priority.routine": "Rutina",
  "reports.tat.priority.stat": "STAT",
  "reports.tat.priority.asap": "ASAP",
  "reports.tat.sampleType": " Tipo de muestra",
  "reports.tat.orderingSite": "Sitio solicitante",
  "reports.tat.priority": " Prioridad",
  "reports.tat.includeCancelled": "Incluir canceladas/rechazadas",
  "reports.tat.export": " Exportar",
  "reports.tat.exportCsv": "Exportar CSV",
  "reports.tat.exportPdf": "Exportar a PDF",
  "reports.tat.labNumber": " Número de laboratorio",
  "reports.tat.patient": "Paciente",
  "reports.tat.test": "Prueba",
  "reports.tat.orderCreated": "Orden creada",
  "reports.tat.collected": "Recopilado",
  "reports.tat.received": "Recibido",
  "reports.tat.testingStarted": "Se han iniciado las pruebas",
  "reports.tat.resultEntered": "Resultado introducido",
  "reports.tat.validated": "Validado",
  "reports.tat.selectedTat": "TAT seleccionado",
  "reports.tat.overallTat": "Plazo de tramitación total",
  "reports.tat.columns": "Columnas",
  "reports.tat.rowsPerPage": "Filas por página",
  "reports.tat.showing": "Mostrando {from}-{to} de {total} Resultados",
  "reports.tat.trend": "Tendencias",
  "reports.tat.aggregation": "Agregación",
  "reports.tat.daily": "Diario",
  "reports.tat.weekly": "Semanal",
  "reports.tat.monthly": "Mensual",
  "reports.tat.compareBy": "Comparar por",
  "reports.tat.showVolume": "Mostrar volumen de órdenes",
  "reports.tat.mean": "Media",
  "reports.tat.median": "Mediana",
  "reports.tat.notApplicable": "N/A",
  "reports.tat.dateRangeFrom": "Rango de fechas (Desde)",
  "reports.tat.dateRangeTo": "Rango de fechas (hasta)",
  "reports.tat.tatSegment": "Segmento TAT",
  "reports.tat.metrics": "Métricas",
  "reports.tat.compareNone": "Ninguno",
  "reports.tat.comparePriority": " Prioridad",
  "reports.tat.column.labNumber": " Número de laboratorio",
  "reports.tat.column.test": "Prueba",
  "reports.tat.column.labUnit": "Unidad de laboratorio",
  "reports.tat.column.priority": " Prioridad",
  "reports.tat.column.ordered": "Ordenado",
  "reports.tat.column.collected": "Recolectado",
  "reports.tat.column.received": "Recibido",
  "reports.tat.column.started": "Iniciado",
  "reports.tat.column.resulted": "Con resultado",
  "reports.tat.column.validated": "Validado",
  "reports.tat.column.selectedTat": "TAT seleccionado",
  "reports.tat.column.overallTat": "Tiempo de respuesta total",
  "reports.tat.column.name": " Nombre",
  "reports.tat.column.count": "Recuento",
  "reports.tat.column.mean": "Media",
  "reports.tat.column.median": "Mediana",
  "reports.tat.column.p90": "Percentil 90",
  "reports.tat.column.max": "Máx.",
  "reports.tat.home": "Inicio",
  "reports.tat.all": "Todos",
  "reports.tat.preset.today": "Hoy",
  "reports.tat.preset.7days": "Últimos 7 días",
  "reports.tat.preset.30days": "Últimos 30 días",
  "reports.tat.preset.90days": "Últimos 90 días",
  "reports.tat.preset.thisMonth": "Este mes",
  "reports.tat.preset.lastMonth": "El mes pasado",
  "reports.tat.preset.thisQuarter": "Este trimestre",
  "button.cancel": "Cancelar",
  "button.activate": "Activar",
  "button.adjust": "Ajustar",
  "button.deactivate": "Desactivar",
  "button.dispose": "Desechar",
  "button.edit": "Editar",
  "button.generate": "Generar",
  "button.label.genarateReport": "Generar Reporte",
  "button.label.loadnext": "Cargar Siguiente Lote",
  "button.label.loadprevious": "Cargar Lote Anterior",
  "button.label.showHidePram": "Mostrar/Ocultar Parámetros del Reporte",
  "button.record": "Récord",
  "button.save": "Guardar",
  "button.save.draft": "Guardar borrador",
  "button.save.next": "Guardar y Siguiente",
  "button.save.stay": "Guardar",
  "button.send": "Enviar",
  "button.update": "Actualizar",
  "calculatedTests": " Pruebas calculadas",
  "catalog.item.activate.success": "El elemento del catálogo se ha activado correctamente",
  "catalog.item.category": " Categoría",
  "catalog.item.code": "Código",
  "catalog.item.code.hint": "Identificador estable utilizado por las integraciones. Déjalo en blanco y generaremos uno a partir del nombre, como PAR-500MG-001.",
  "catalog.item.code.locked": "El código se bloquea una vez guardado para que las integraciones y las referencias existentes sigan funcionando.",
  "catalog.item.code.placeholder": "Dejar en blanco para generar automáticamente a partir del nombre",
  "catalog.item.code.preview": "Se guardará como {code}",
  "catalog.item.compatibleAnalyzers": "Analizadores compatibles",
  "catalog.item.deactivate.confirm.button": "Desactivar",
  "catalog.item.deactivate.confirm.message": "¿Está seguro de que desea desactivar «{itemName}»?",
  "catalog.item.deactivate.confirm.title": "Confirmar la desactivación",
  "catalog.item.deactivate.implications.1": "Este elemento ya no aparecerá en las listas de elementos activos",
  "catalog.item.deactivate.implications.2": "Se seguirá pudiendo acceder a los lotes existentes de este elemento",
  "catalog.item.deactivate.implications.3": "Puede reactivar este elemento más adelante si fuera necesario.",
  "catalog.item.deactivate.implications.title": "Consecuencias:",
  "catalog.item.deactivate.label": "Desactivar elemento",
  "catalog.item.deactivate.success": "El elemento se ha desactivado correctamente",
  "catalog.item.error.saveGeneric": "Error al guardar un elemento del catálogo",
  "catalog.item.error.stabilityRequired": "Se requiere la estabilidad después de la apertura para los reactivos",
  "catalog.item.form.title.add": "Agregar un nuevo elemento al catálogo",
  "catalog.item.form.title.edit": "Editar elemento del catálogo",
  "catalog.item.lowStockThreshold": "Umbral de existencias bajas",
  "catalog.item.manufacturer": "Fabricante",
  "catalog.item.minimumStock": "Nivel mínimo de existencias",
  "catalog.item.name": "Nombre del elemento",
  "catalog.item.reorderLevel": "Nivel de reposición",
  "catalog.item.reorderQuantity": "Cantidad de reposición",
  "catalog.item.save.error": "Error al guardar un elemento del catálogo",
  "catalog.item.save.success": "El elemento del catálogo se ha guardado exitosamente",
  "catalog.item.stabilityAfterOpening": "Estabilidad tras la apertura (días)",
  "catalog.item.status": "Estado",
  "catalog.item.storageRequirements": "Requisitos de almacenamiento",
  "catalog.item.testTypes": "Tipo de prueba",
  "catalog.item.testsPerCartridge": "Pruebas por cartucho",
  "catalog.item.testsPerKit": "Pruebas por kit",
  "catalog.item.units": "Unidades",
  "catalog.search.placeholder": "Buscar por nombre o código de elemento",
  "choose.availablepanel": " Elegir panel disponible",
  "coldStorage.action.createSuccess": "La acción correctiva se ha creado correctamente",
  "coldStorage.action.retractSuccess": "La acción correctiva se ha retirado correctamente",
  "coldStorage.action.updateSuccess": "La acción correctiva se ha actualizado correctamente",
  "coldStorage.actions": "Acciones",
  "coldStorage.activated": "activado",
  "coldStorage.addDevicesMessage": "Por favor, agregue dispositivos en «Gestión de dispositivos» para configurar los umbrales de temperatura.",
  "coldStorage.addNewDevice": "Agregar un nuevo dispositivo",
  "coldStorage.alert.acknowledged": "La alerta se ha confirmado correctamente",
  "coldStorage.alert.actionFailed": "No se ha podido {action} la alerta {alertId}",
  "coldStorage.alert.equipment": "Avería del equipo",
  "coldStorage.alert.equipment.description": "Alertas por averías en los equipos o problemas de conectividad",
  "coldStorage.alert.inventory": "Alertas de existencias",
  "coldStorage.alert.inventory.description": "Alertas por niveles bajos de existencias o gestión de existencias",
  "coldStorage.alert.resolved": "La alerta se ha resuelto correctamente",
  "coldStorage.alert.saveFailed": "No se han podido guardar las preferencias de notificaciones: ",
  "coldStorage.alert.saveSuccess": "Las preferencias de notificación se han guardado exitosamente. Cada tipo de alerta utilizará los métodos de notificación que se le hayan configurado.",
  "coldStorage.alert.temperature": "Alertas de temperatura y humedad",
  "coldStorage.alert.temperature.description": "Alertas que se activan cuando la temperatura o la humedad relativa de una unidad sale de su rango configurado",
  "coldStorage.alert.type": "Tipo de alerta",
  "coldStorage.alertConfiguration": "Configuración de alertas",
  "coldStorage.autoEscalate": "Escalar automáticamente las alertas sin resolver",
  "coldStorage.button.delete": "Eliminar",
  "coldStorage.configuredDevices": "Dispositivos configurados",
  "coldStorage.correctiveAction.column.actionId": "ID de acción",
  "coldStorage.correctiveAction.column.created": "Creado",
  "coldStorage.correctiveAction.column.lastUpdatedBy": "Última actualización realizada por",
  "coldStorage.correctiveAction.column.performedBy": "Realizado por",
  "coldStorage.correctiveAction.edited": "Editado",
  "coldStorage.correctiveAction.status.cancelled": "Cancelado",
  "coldStorage.correctiveAction.status.completed": "Completado",
  "coldStorage.correctiveAction.status.inProgress": "En progreso",
  "coldStorage.correctiveAction.status.pending": "Pendiente",
  "coldStorage.correctiveAction.status.retracted": "Retirado",
  "coldStorage.correctiveAction.type.calibration": "Calibración",
  "coldStorage.correctiveAction.type.calibration.description": "Calibración de equipos o sensores",
  "coldStorage.correctiveAction.type.equipmentRepair": "Reparación de equipos",
  "coldStorage.correctiveAction.type.equipmentRepair.description": "Reparación o sustitución de equipos",
  "coldStorage.correctiveAction.type.itemReorder": "Reposición de elementos",
  "coldStorage.correctiveAction.type.itemReorder.description": "Reposición de elementos en stock",
  "coldStorage.correctiveAction.type.maintenance": "Mantenimiento",
  "coldStorage.correctiveAction.type.maintenance.description": "Realización de tareas de mantenimiento",
  "coldStorage.correctiveAction.type.other": "Otros",
  "coldStorage.correctiveAction.type.other.description": "Otras acciones correctivas o acciones personalizadas",
  "coldStorage.correctiveAction.type.sampleRelocation": "Traslado de muestras",
  "coldStorage.correctiveAction.type.sampleRelocation.description": "Traslado de muestras a otra ubicación",
  "coldStorage.correctiveAction.type.temperatureAdjustment": "Ajuste de la temperatura",
  "coldStorage.correctiveAction.type.temperatureAdjustment.description": "Ajuste de la configuración de la temperatura",
  "coldStorage.criticalThreshold": "Umbral crítico (°C)",
  "coldStorage.dashboard.acknowledge": "Reconocer",
  "coldStorage.dashboard.activeAlerts": "Alertas activas ({count})",
  "coldStorage.dashboard.column.currentTemp": "Temperatura actual",
  "coldStorage.dashboard.column.currentTemp2": "Temperatura de la sonda 2",
  "coldStorage.dashboard.column.device": "Dispositivo",
  "coldStorage.dashboard.column.duration": "Duración",
  "coldStorage.dashboard.column.humidity": "Humedad",
  "coldStorage.dashboard.column.lastReading": "Última lectura",
  "coldStorage.dashboard.column.location": "Ubicación",
  "coldStorage.dashboard.column.severity": "Severidad",
  "coldStorage.dashboard.column.started": "Iniciado",
  "coldStorage.dashboard.column.targetTemp": "Temperatura objetivo",
  "coldStorage.dashboard.column.temperature": "Temperatura",
  "coldStorage.dashboard.column.unitId": "Identificador de la unidad",
  "coldStorage.dashboard.column.unitName": "Nombre de la unidad",
  "coldStorage.dashboard.criticalAlertSubtitle": "{count} unidad(es) de almacenamiento que presentan variaciones críticas de temperatura",
  "coldStorage.dashboard.criticalAlertTitle": "ALERTA CRÍTICA",
  "coldStorage.dashboard.deviceTypeFilter": "Tipo de dispositivo",
  "coldStorage.dashboard.kpi.critical": "Alertas críticas",
  "coldStorage.dashboard.kpi.normal": "Estado normal",
  "coldStorage.dashboard.kpi.totalUnits": "Total de unidades de almacenamiento",
  "coldStorage.dashboard.kpi.warnings": "Advertencias",
  "coldStorage.dashboard.lastUpdate": "Última actualización: {time}",
  "coldStorage.dashboard.loadingUnits": "Cargando unidades de almacenamiento…",
  "coldStorage.dashboard.noActiveAlerts": "No hay alertas activas",
  "coldStorage.dashboard.noUnitsFound": "No se han encontrado unidades de almacenamiento.",
  "coldStorage.dashboard.online": "En línea",
  "coldStorage.dashboard.refresh": "Actualizar",
  "coldStorage.dashboard.refreshing": "Actualizando",
  "coldStorage.dashboard.refreshingEllipsis": "Actualizando...",
  "coldStorage.dashboard.searchLabel": "Buscar por ID de unidad o por nombre",
  "coldStorage.dashboard.statusFilter": "Estado",
  "coldStorage.dashboard.storageUnitsTitle": "Unidades de almacenamiento",
  "coldStorage.dashboard.subtitle": "Control de la temperatura en tiempo real y cumplimiento normativo",
  "coldStorage.dashboard.systemStatus": "Estado del sistema: {status}",
  "coldStorage.dashboard.tab.correctiveActions": "Acciones correctivas",
  "coldStorage.dashboard.tab.dashboard": "Panel",
  "coldStorage.dashboard.tab.historicalTrends": "Tendencias históricas",
  "coldStorage.dashboard.tab.reports": "Informes",
  "coldStorage.dashboard.tab.settings": "Configuración",
  "coldStorage.dashboard.viewAlertDetails": "Consultar los detalles de la alerta",
  "coldStorage.deactivated": "desactivado",
  "coldStorage.description": "Descripción",
  "coldStorage.device.activate": "Activar dispositivo",
  "coldStorage.device.activateMessage": "Al activar este dispositivo, se habilitarán las funciones de supervisión y recopilación de datos.",
  "coldStorage.device.changeStatus": "Modificar el estado del dispositivo",
  "coldStorage.device.changeStatusOf": "Modifique el estado de «{name}»:",
  "coldStorage.device.created": "El dispositivo se ha creado correctamente",
  "coldStorage.device.createdSuccess": "El dispositivo «{name}» se ha creado correctamente.",
  "coldStorage.device.deactivate": "Desactivar el dispositivo",
  "coldStorage.device.deactivateMessage": "Si desactiva este dispositivo, se interrumpirá la supervisión y la recopilación de datos. Los datos históricos se conservarán.",
  "coldStorage.device.delete": "Eliminar dispositivo",
  "coldStorage.device.deleteConfirm": "¿Está seguro de que desea eliminar «{name}»?",
  "coldStorage.device.deleteWarning": "De este modo, el dispositivo quedará marcado como inactivo y se eliminará de la supervisión activa. Los datos históricos se conservarán.",
  "coldStorage.device.deleted": "El dispositivo «{name}» se ha eliminado correctamente.",
  "coldStorage.device.deviceStatus": "Estado del dispositivo",
  "coldStorage.device.edit": "Editar dispositivo",
  "coldStorage.device.id": "Identificador del dispositivo",
  "coldStorage.device.ipAddress": "Dirección IP",
  "coldStorage.device.port": "Puerto",
  "coldStorage.device.protocol": "Protocolo",
  "coldStorage.device.registerCount": "Registros por valor",
  "coldStorage.device.registerCount.help": "1 para un valor de 16 bits; 2 para un valor de 32 bits que abarca dos registros",
  "coldStorage.device.roomFacility": "Sala/Instalación",
  "coldStorage.device.rs485": "RS-485 semidúplex (opcional)",
  "coldStorage.device.rs485.delayAfter": "Retardo tras la transmisión (ms)",
  "coldStorage.device.rs485.delayBefore": "Retardo antes de la transmisión (ms)",
  "coldStorage.device.rs485.mode": "Habilitar la sincronización de activación del controlador RS-485",
  "coldStorage.device.rs485.rtsActiveHigh": "RTS activo alto durante la transmisión",
  "coldStorage.device.rs485.rxDuringTx": "Mantenga el receptor activado durante la transmisión",
  "coldStorage.device.rs485.termination": "Terminación de bus activada",
  "coldStorage.device.secondProbe": "Segunda sonda de temperatura (opcional)",
  "coldStorage.device.secondProbe.offset": "Temperatura base 2 (°C)",
  "coldStorage.device.secondProbe.offsetHelp": "Desplazamiento de la base para la segunda sonda",
  "coldStorage.device.secondProbe.register": "Registro de temperatura 2",
  "coldStorage.device.secondProbe.registerHelp": "Dirección de registro Modbus para una segunda sonda de temperatura independiente. Sus lecturas se registran y se representan gráficamente; las alertas de umbral se activan desde la primera sonda.",
  "coldStorage.device.secondProbe.scale": "Escala de temperatura 2",
  "coldStorage.device.secondProbe.scaleHelp": "Factor de escala (por ejemplo, 0,1 para dividir entre 10)",
  "coldStorage.device.statusChanged": "El dispositivo «{name}» se ha {status} con éxito",
  "coldStorage.device.type": "Tipo",
  "coldStorage.device.updated": "El dispositivo se ha actualizado correctamente",
  "coldStorage.device.wordOrder": "Orden de las palabras",
  "coldStorage.device.wordOrder.bigEndian": "Big-endian (la palabra más significativa primero)",
  "coldStorage.device.wordOrder.help": "Orden de los dos registros en un valor de 32 bits; se ignora al leer un solo registro",
  "coldStorage.device.wordOrder.littleEndian": "Little endian (la palabra menos significativa primero)",
  "coldStorage.deviceHistory.averageMetric": "{metric} de media",
  "coldStorage.deviceHistory.column.acknowledgedPerformedBy": "Reconocido / Realizado por",
  "coldStorage.deviceHistory.column.date": "Fecha",
  "coldStorage.deviceHistory.column.eventId": "ID de evento",
  "coldStorage.deviceHistory.column.eventType": "Tipo de evento",
  "coldStorage.deviceHistory.column.summaryTitle": "Resumen / Título",
  "coldStorage.deviceHistory.column.time": "Hora",
  "coldStorage.deviceHistory.correctiveActions": "Acciones correctivas",
  "coldStorage.deviceHistory.dataPoints": "Puntos de datos",
  "coldStorage.deviceHistory.exportCsv": "Exportar CSV",
  "coldStorage.deviceHistory.loadingEvents": "Cargando el historial de eventos...",
  "coldStorage.deviceHistory.loadingTemperature": "Cargando datos de temperatura...",
  "coldStorage.deviceHistory.maxMetric": "Máx. {metric}",
  "coldStorage.deviceHistory.metric": "Métrica:",
  "coldStorage.deviceHistory.minMetric": "Mín. {metric}",
  "coldStorage.deviceHistory.noEventsFound": "No se han encontrado eventos.",
  "coldStorage.deviceHistory.noTemperatureData": "No hay datos de temperatura disponibles para el rango de tiempo seleccionado.",
  "coldStorage.deviceHistory.searchEvents": "Buscar eventos",
  "coldStorage.deviceHistory.searchPlaceholder": "Buscar por ID de evento, resumen o usuario...",
  "coldStorage.deviceHistory.tab.eventHistory": "Historial de eventos",
  "coldStorage.deviceHistory.tab.temperatureTrends": "Tendencias de la temperatura",
  "coldStorage.deviceHistory.timeRange": "Rango de tiempo:",
  "coldStorage.deviceHistory.title": "Historial de dispositivos - {name} ({id})",
  "coldStorage.deviceHistory.totalAlerts": "Total de alertas",
  "coldStorage.deviceHistory.totalEvents": "Total de eventos",
  "coldStorage.email": "Correo Electrónico",
  "coldStorage.emailSmsNotifications": "Notificaciones por Correo Electrónico y SMS",
  "coldStorage.error.createAction": "No se ha podido crear la acción correctiva. Inténtelo de nuevo.",
  "coldStorage.error.createDevice": "No se ha podido crear el dispositivo: ",
  "coldStorage.error.createRoom": "No se ha podido crear la sala: ",
  "coldStorage.error.deleteDevice": "No se ha podido eliminar el dispositivo: ",
  "coldStorage.error.loadActions": "No se han podido cargar las acciones correctivas. Inténtelo de nuevo.",
  "coldStorage.error.loadAuditTrail": "No se ha podido cargar el Registro de Auditoría",
  "coldStorage.error.loadAuditTrailDetail": "Se ha producido un error inesperado al cargar los registros de auditoría.",
  "coldStorage.error.loadDevices": "No se han podido cargar los dispositivos: ",
  "coldStorage.error.loadExcursions": "No se ha podido cargar el historial de excursiones",
  "coldStorage.error.loadExcursionsDetail": "Se ha producido un error inesperado al cargar las excursiones.",
  "coldStorage.error.loadFailed": "No se han podido cargar los datos de monitorización de las cámaras frigoríficas.",
  "coldStorage.error.loadLocations": "No se han podido cargar las ubicaciones: ",
  "coldStorage.error.loadUsers": "No se ha podido cargar la lista de usuarios. Inténtelo de nuevo más tarde.",
  "coldStorage.error.noCurrentUser": "No se ha podido identificar al usuario actual. Por favor, vuelva a iniciar sesión.",
  "coldStorage.error.retractAction": "No se ha podido anular la acción correctiva. Inténtelo de nuevo.",
  "coldStorage.error.saveThreshold": "No se ha podido guardar la configuración de umbrales: ",
  "coldStorage.error.toggleStatus": "No se ha podido cambiar el estado del dispositivo: ",
  "coldStorage.error.updateAction": "No se ha podido actualizar la acción correctiva. Inténtelo de nuevo.",
  "coldStorage.error.updateDevice": "No se ha podido actualizar el dispositivo: ",
  "coldStorage.error.updateFailed": "No se han podido actualizar los datos del almacén frigorífico",
  "coldStorage.escalationDelay": "Retraso en la escalación (minutos)",
  "coldStorage.escalationDelayHelper": "Tiempo de espera antes de escalar una alerta sin resolver",
  "coldStorage.escalationRules": "Reglas de escalado",
  "coldStorage.filter.activeOnly": "Solo activos",
  "coldStorage.filter.all": "Todos los dispositivos",
  "coldStorage.filter.inactiveOnly": "Solo inactivos",
  "coldStorage.footer": "Supervisión de cámaras frigoríficas v2.1.0 | Cumple con las directrices de CAP, CLIA, la FDA y la OMS | Gestión de datos conforme a la HIPAA",
  "coldStorage.granularNotificationControl": "Control detallado de las notificaciones",
  "coldStorage.granularNotificationControlDesc": "Configure las notificaciones por Correo Electrónico y SMS para cada tipo de alerta de forma independiente. Active los métodos de notificación que desee para cada categoría específica de alerta.",
  "coldStorage.howNotificationsWork": "Cómo funcionan las notificaciones",
  "coldStorage.howNotificationsWorkDesc": "Cuando se active una alerta (superación del umbral de temperatura, avería de un equipo, etc.), el sistema:",
  "coldStorage.loadingDevices": "Cargando dispositivos...",
  "coldStorage.loadingPrefs": "Cargando las preferencias de notificaciones...",
  "coldStorage.name": " Nombre",
  "coldStorage.noConfigFound": "No se ha encontrado ninguna configuración",
  "coldStorage.noDevicesConfigured": "No hay dispositivos configurados",
  "coldStorage.notification.createRecord": "Crear un registro de alerta en el sistema (visible en el Panel)",
  "coldStorage.notification.logAttempt": "Registre el intento de notificación a efectos del Registro de Auditoría",
  "coldStorage.notification.sendEmail": "Enviar notificaciones por CORREO ELECTRÓNICO si está activada esta opción (a los destinatarios configurados)",
  "coldStorage.notification.sendSms": "Enviar notificaciones por SMS si están activadas (a los números de teléfono configurados)",
  "coldStorage.pollInterval": "Intervalo de sondeo (segundos)",
  "coldStorage.reports.column.action": "Acción",
  "coldStorage.reports.column.details": "Detalles",
  "coldStorage.reports.column.excursionId": "N.º de excursión",
  "coldStorage.reports.column.freezer": "Congelador",
  "coldStorage.reports.column.freezerId": "N.º de identificación del congelador",
  "coldStorage.reports.column.startTime": "Hora de inicio",
  "coldStorage.reports.column.temperatureRange": "Rango de temperatura",
  "coldStorage.reports.column.timestamp": "Marca de tiempo",
  "coldStorage.reports.column.user": "Usuario",
  "coldStorage.reports.downloadReport": "Descargar el informe «{format}»",
  "coldStorage.reports.endDate": "Fecha de finalización",
  "coldStorage.reports.excursionHistory": "Historial de variaciones de temperatura",
  "coldStorage.reports.exportFormat": "Formato de exportación",
  "coldStorage.reports.footer": "Supervisión de cámaras frigoríficas v2.1.0 | Conforme a las normas CAP, CLIA, FDA y OMS | Gestión de datos conforme a la HIPAA",
  "coldStorage.reports.freezer": "Congelador",
  "coldStorage.reports.generateReport": "Generar Reporte",
  "coldStorage.reports.loadingAudit": "Cargando entradas de auditoría…",
  "coldStorage.reports.loadingExcursions": "Cargando excursiones…",
  "coldStorage.reports.noAuditActivity": "No se han encontrado actividades de auditoría para los filtros seleccionados.",
  "coldStorage.reports.noAuditMatch": "No se han encontrado entradas de auditoría que coincidan con su búsqueda.",
  "coldStorage.reports.noExcursions": "No hay excursiones disponibles según los filtros seleccionados.",
  "coldStorage.reports.regulatoryCompliance": "Cumplimiento normativo",
  "coldStorage.reports.regulatoryComplianceDesc": "Los informes se ajustan a las directrices del CAP (Colegio de Patólogos de Estados Unidos), la CLIA (Enmiendas para la Mejora de los Laboratorios Clínicos), la FDA (Administración de Alimentos y Medicamentos) y la OMS (Organización Mundial de la Salud) en materia de almacenamiento a temperatura controlada.",
  "coldStorage.reports.reportType": "Tipo de informe",
  "coldStorage.reports.searchAuditTrail": "Buscar registro de auditoría...",
  "coldStorage.reports.startDate": "Fecha de inicio",
  "coldStorage.reports.tab.auditTrail": "Registro de Auditoría",
  "coldStorage.reports.tab.excursions": "Variaciones de temperatura",
  "coldStorage.reports.title": "Informes reglamentarios",
  "coldStorage.room.addNew": "Agregar una nueva sala",
  "coldStorage.room.create": "Crear sala",
  "coldStorage.room.created": "La sala se ha creado correctamente",
  "coldStorage.room.description": "Descripción",
  "coldStorage.room.descriptionPlaceholder": "Introduzca la descripción de la sala (opcional)",
  "coldStorage.room.name": "Nombre de la sala",
  "coldStorage.room.namePlaceholder": "Introduzca el nombre de la sala (p. ej., «Almacén del laboratorio A»)",
  "coldStorage.saveNotificationPrefs": "Guardar preferencias de notificaciones",
  "coldStorage.saveThresholdConfig": "Guardar la configuración de umbrales",
  "coldStorage.saving": "Guardando...",
  "coldStorage.search.placeholder": "Buscar por ID de dispositivo o nombre",
  "coldStorage.selectType": "Seleccione el tipo",
  "coldStorage.sms": "SMS",
  "coldStorage.status": "Estado",
  "coldStorage.status.active": "ACTIVO",
  "coldStorage.status.inactive": "INACTIVO",
  "coldStorage.status.noData": "No hay datos",
  "coldStorage.status.offline": "Sin conexión",
  "coldStorage.status.unknown": "Desconocido",
  "coldStorage.supervisorEmail": "Correo Electrónico del supervisor",
  "coldStorage.supervisorEmailHelper": "Dirección de Correo Electrónico a la que enviar las alertas de nivel superior",
  "coldStorage.supervisorEmailPlaceholder": "supervisor@lab.com",
  "coldStorage.targetTemperature": "Temperatura objetivo (°C)",
  "coldStorage.threshold.saveSuccess": "La configuración del umbral se ha guardado exitosamente",
  "coldStorage.thresholdConfiguration": "Configuración de los umbrales de temperatura",
  "coldStorage.trends.averageMetric": "{metric} de media",
  "coldStorage.trends.axis.humidity": "Humedad (%)",
  "coldStorage.trends.axis.temperature": "Temperatura (°C)",
  "coldStorage.trends.axis.temperature2": "Temperatura - Sonda 2 (°C)",
  "coldStorage.trends.maxMetric": "Máx. {metric}",
  "coldStorage.trends.metric": "Métrica",
  "coldStorage.trends.metric.humidity": "Humedad",
  "coldStorage.trends.metric.temperature": "Temperatura",
  "coldStorage.trends.metric.temperature2": "Temperatura (sonda 2)",
  "coldStorage.trends.minMetric": "Mín. {metric}",
  "coldStorage.usingDefaults": "Se utilizarán los ajustes predeterminados de notificación. Guarde para crear la configuración.",
  "coldStorage.validation.error": "Error de Validación",
  "coldStorage.validation.retractionReason": "Indique el motivo del retiro",
  "coldStorage.validation.selectActionType": "Seleccione un tipo de acción",
  "coldStorage.validation.selectDevice": "Seleccione un dispositivo, por favor",
  "coldStorage.validation.selectRoom": "Seleccione una sala o ubicación para el dispositivo",
  "coldStorage.warningThreshold": "Umbral de alerta (°C)",
  "collect.addSample.button": "Agregar muestra",
  "collect.assign.addToSample": "Agregar a la muestra existente",
  "collect.assign.button": "Asignar pruebas",
  "collect.assign.description": "Asigne las pruebas solicitadas a los tubos de muestra",
  "collect.assign.newSample": "Crear una nueva muestra",
  "collect.assign.newSampleHelp": "Seleccione el tipo de muestra para el nuevo tubo",
  "collect.assign.noExisting": "No hay muestras disponibles",
  "collect.assign.title": "Asignación de Pruebas",
  "collect.multiSampleExample.description": "Cuando se requieren varios tipos de muestras",
  "collect.multiSampleExample.result": "Crea tubos independientes para cada tipo",
  "collect.multiSampleExample.title": "Ejemplo de recolección de varias muestras",
  "collect.noSampleYet": "Aún no se han recolectado muestras",
  "collect.noCompatibleSampleTypes": "No sample type is set up for this test in the test catalog",
  "collect.noTestsOrdered": "No se han solicitado pruebas",
  "collect.noTestsWarning.subtitle": "Agregue las muestras con las pruebas en el paso 1 antes de continuar",
  "collect.noTestsWarning.title": "No hay pruebas que recolectar",
  "collect.requestedTests.info": "Pruebas solicitadas para esta orden",
  "collect.requestedTests.title": "Pruebas solicitadas",
  "collect.sample.assignedTests": "Pruebas asignadas",
  "collect.sample.collectionConditions": "Condiciones de recolección",
  "collect.sample.collectionConditions.placeholder": "Indique cualquier condición especial...",
  "collect.sample.collectionDate": "Fecha de recolección",
  "collect.sample.collectionMethod": "Método de recolección",
  "collect.addTests.title": "Añadir pruebas o paneles",
  "collect.addTests.helper": "Añada una prueba solicitada por el médico después de ingresar la orden, o una que solo sea adecuada con el espécimen en mano.",
  "collect.consentRequired.title": "Se requiere consentimiento informado",
  "collect.consentRequired.subtitle": "Este laboratorio requiere que se registre el consentimiento antes de proceder con una extracción.",
  "sample.holdingLimit": "Tiempo de retención: {limit}",
  "sample.holdingLimit.testBy": "analizar antes del {deadline}",
  "env.sample.receivedAtLab": "Recibido en el laboratorio",
  "collect.sample.specimenOrigin": "Origen del espécimen",
  "collect.sample.temperature": "Temperatura de la muestra",
  "collect.sample.temperature.placeholder": "p. ej., 4 °C",
  "collect.sample.collectionDate.helper": "De forma predeterminada es la fecha de hoy; corríjala si la muestra se recolectó antes",
  "collect.sample.collectionTime": "Hora de recolección",
  "collect.sample.collector": "Recolector",
  "collect.sample.header": "Muestra {number}",
  "collect.sample.labPerformedSampling": "Muestreo realizado en el laboratorio",
  "collect.sample.nce.link": "Reportar evento no conforme",
  "collect.sample.noTests": "No hay pruebas asignadas a esta muestra",
  "collect.sample.printLabels": "Imprimir etiquetas",
  "collect.printMoreLabels.helper": "Drew more than expected, or need a different sample type? Use Add Sample, then print its labels from the sample card or the Labels section.",
  "collect.sample.quantity": "Cantidad",
  "collect.sample.receivedAtLab": "Recibido en el laboratorio",
  "collect.sample.receivedAtLab.helper": "Compruebe si se ha recibido la muestra en el laboratorio",
  "collect.sample.receivedDate": "Fecha de recepción",
  "collect.sample.receivedTime": "Hora de recepción",
  "collect.sample.remove": "Eliminar muestra",
  "collect.samples.title": "Muestras",
  "collect.table.compatibleTypes": "Tipos de muestras compatibles",
  "collect.table.sampleAssignments": "Asignaciones de muestras",
  "collect.table.testPanel": "Prueba/Panel",
  "heading.informedConsent.sectionTitle": "Consentimiento informado",
  "heading.informedConsent.auditRecord": "Registro de auditoría de consentimientos",
  "label.informedConsent.consentGiven": "El paciente ha firmado el consentimiento.",
  "label.informedConsent.formReference": "N.º de referencia del formulario de consentimiento:",
  "label.informedConsent.recordedBy": "Registrado por",
  "label.informedConsent.recordedAt": "Registrado el",
  "label.informedConsent.statusTag": "Consentimiento registrado",
  "label.informedConsent.notRecorded": "No se ha registrado",
  "placeholder.informedConsent.formReference": "p. ej., CF-2026-00123",
  "placeholder.informedConsent.recordedBy": "p. ej., el Dr. Smith",
  "error.informedConsent.formReferenceMaxLength": "La referencia del formulario de consentimiento debe tener 100 caracteres como máximo",
  "error.informedConsent.formReferenceInvalidChars": "Solo se permiten letras, números, guiones y espacios",
  "coldstorage.label.dashboard": "Panel de control de almacenamiento en frío",
  "collection.date": "Fecha de recolección",
  "collector": "Recolector",
  "collector.label": "Recolector",
  "column.actions": "Acciones",
  "column.name.accept": "Aceptar",
  "column.name.analyzerResult": "Resultado del Analizador",
  "column.name.currentResult": "Resultado Actual",
  "column.name.ignore": "Ignorar",
  "column.name.normalRange": "Rango Normal",
  "column.name.notes": "Notas",
  "column.name.pastNotes": "Notas Anteriores",
  "column.name.qcDetail": "Detalle",
  "column.name.qcStatus": "Estado del QC",
  "column.name.reject": "Rechazar",
  "column.name.result": "Resultado",
  "column.name.retest": "Repetir Prueba",
  "column.name.sampleInfo": "Información de la Muestra",
  "column.name.sampleKind": "Tipo de muestra",
  "column.name.save": "Guardar",
  "column.name.statusPerRegulation": "Estado — Según el Reglamento",
  "column.name.testDate": "Fecha de Prueba",
  "column.name.testId": "ID de Prueba",
  "column.name.testName": "Nombre de la Prueba",
  "column.name.uncertainty": "U (k=2)",
  "common.codeGenerator.error.invalidCode": "El código debe contener al menos una letra, un dígito o un guion bajo.",
  "common.properties.title": "Propiedades comunes",
  "configuration.batch.test.reassignment": "Reasignación y cancelación masiva de pruebas",
  "configuration.method": "Administrar Métodos",
  "configuration.method.create": "Crear Nuevo Método",
  "configuration.testCatalog.tests.explain": "Create, edit, rename, activate and set the orderability of tests, with their ranges, result options, methods and labels",
  "configuration.testCatalog.panels.explain": "Create and edit panels, assign their tests and set their display order",
  "configuration.testCatalog.sampleTypes.explain": "Create and edit sample types, assign tests and set their display order",
  "configuration.testCatalog.labUnits.explain": "Create and edit lab units and assign their tests",
  "configuration.testCatalog.import.explain": "Load tests, panels, sample types and lab units from CSV files",
  "configuration.testCatalog.methods.explain": "Add methods; a new method becomes active once a test uses it",
  "configuration.selectList.add": "Agregar lista de selección de resultados",
  "configuration.selectList.add.alert": "Para cambiar la ortografía de las entradas actuales de la lista de resultados, use Renombrar opciones de lista de resultados existentes",
  "configuration.selectList.add.explain": "use para crear lista de selección de resultados para resultados de pruebas",
  "configuration.selectList.rename": "Renombrar opciones de lista de resultados existentes",
  "configuration.selectList.rename.explain": "Renombrar opciones de lista de resultados existentes",
  "configuration.test.activate": "Activar/Desactivar pruebas",
  "configuration.test.activate.explain": "Use para activar o desactivar una prueba existente.",
  "configuration.test.catalog": "Ver Catálogo de Pruebas",
  "configuration.test.catalog.explain": "Ver el catálogo actual de pruebas",
  "configuration.test.orderable": "Habilitar/deshabilitar capacidad de ordenar prueba",
  "configuration.test.orderable.explain": "Las pruebas que se pueden ordenar pueden solicitarse en la admisión. Si no son ordenables, solo pueden solicitarse como resultado de un reflejo",
  "configuration.testCatalog.uom.explain": "List units of measure and correct their names, codes and UCUM codes",
  "configuration.uom.title": "Units of Measure",
  "configuration.uom.explain": "Units that numeric results are reported in. A unit can also be created while editing a test.",
  "configuration.uom.add": "Add Unit",
  "configuration.uom.edit": "Edit Unit",
  "configuration.uom.empty": "No units of measure match",
  "method.modal.edit.heading": "Edit Method",
  "configuration.method.create.duplicate": "A method with this name already exists. Use a different name.",
  "configuration.panel.assign": "Asignación de Pruebas",
  "configuration.panel.assign.explain": "Seleccione pruebas para reasignar a un panel diferente haciendo clic en el nombre de la prueba; se muestran bajo su panel asignado actualmente.",
  "configuration.panel.confirmation.explain": "Este panel no estará activo hasta que se le asigne al menos una prueba.",
  "configuration.panel.create": "Crear Nuevo Panel",
  "configuration.panel.create.duplicate": "Se encontró un tipo de panel existente con el mismo nombre. Por favor cancele o use un nombre diferente.",
  "configuration.panel.order": "Establecer Orden de Paneles",
  "configuration.panel.order.explain": "Ordene los paneles haciendo clic en un tipo y arrastrándolo al orden correcto.",
  "configuration.panel.order.explain.limits": "Solo se pueden ordenar paneles con pruebas asignadas. Para nuevos paneles, asigne pruebas antes de ordenar.",
  "configuration.sampleType.assign.explain": "Seleccione pruebas para reasignar a un tipo de muestra diferente haciendo clic en el nombre de la prueba; se muestran bajo su tipo de muestra asignado actualmente.",
  "configuration.sampleType.assign.new.type": "Asignar a tipo de muestra",
  "configuration.sampleType.confirmation.explain": "Este tipo de muestra no estará activo hasta que se le asigne al menos una prueba.",
  "configuration.sampleType.create": "Crear Nuevo Tipo de Muestra",
  "configuration.sampleType.create.duplicate": "Se encontró un tipo de muestra existente con el mismo nombre. Por favor cancele o use un nombre diferente.",
  "configuration.sampleType.manage": "Administrar Tipos de Muestra",
  "configuration.sampleType.manage.explain": "Use para crear, establecer orden de visualización o asignar pruebas a tipos de muestra",
  "configuration.sampleType.order": "Establecer Orden de Tipos de Muestra",
  "configuration.sampleType.order.explain": "Ordene los tipos de muestra haciendo clic en un tipo y arrastrándolo al orden correcto.",
  "configuration.sampleType.order.explain.limits": "Solo se pueden ordenar tipos de muestra con pruebas asignadas. Para nuevos tipos, asigne pruebas antes de ordenar.",
  "configuration.selectList.assign.description": "La nueva entrada puede asignarse a pruebas o guardarse sin asignación. Seleccione una o más pruebas para asignación y luego ajuste el orden de visualización. Si la nueva entrada debe ser el valor de rango normal para la prueba seleccionada, marque la casilla etiquetada 'Normal'. Si se desea que el técnico ingrese texto con la selección de resultados para calificar aún más los resultados, marque la casilla etiquetada 'Calificable'. Por ejemplo; si las opciones son una lista de organismos y la última opción es 'Otro', entonces el usuario podría ingresar un organismo que no esté en la lista.",
  "configuration.selectList.assign.header": "Asignar nueva selección de resultados a prueba",
  "configuration.selectList.assign.new": "Nueva opción de lista de selección",
  "configuration.selectList.confirmChange": "El valor normal se cambiará de %oldvalue% a %newvalue%, ¿está seguro de que desea continuar?",
  "configuration.selectList.description": "Ingrese tanto en inglés como en francés para la nueva opción de selección. Si no conoce la traducción, el término ingresado se usará para ambos idiomas.",
  "configuration.selectList.header": "Crear nueva opción de selección de resultados",
  "configuration.test.management.ocl": "Importación de conceptos OCL",
  "configuration.test.management.organization": "Organización de Pruebas",
  "configuration.test.modify.tab.configuration": "Configuración",
  "configuration.test.modify.tab.compliance": "Umbrales de cumplimiento",
  "configuration.test.modify.filter.instruction": "Seleccione un tipo de muestra o una sección de prueba para visualizar las pruebas.",
  "configuration.test.modify.filter.noTestsFound": "No se encontraron pruebas que coincidan con los criterios seleccionados.",
  "configuration.test.modify.filter.selectToBegin": "Seleccione un tipo de muestra o una sección de pruebas para comenzar a consultar los resultados.",
  "configuration.testUnit.assign.new.unit": "Asignar a sección de prueba",
  "configuration.testUnit.confirmation.explain": "Esta unidad de prueba no estará activa hasta que se le asigne al menos una prueba.",
  "configuration.testUnit.create": "Crear Nueva Unidad de Prueba",
  "configuration.testUnit.create.duplicate": "Se encontró una unidad de prueba existente con el mismo nombre. Por favor cancele o use un nombre diferente.",
  "configuration.testUnit.order": "Establecer Orden de Unidades de Prueba",
  "configuration.testUnit.order.explain": "Ordene las unidades de laboratorio haciendo clic en una unidad y arrastrándola al orden correcto.",
  "configuration.testUnit.order.explain.limits": "Solo se pueden ordenar secciones de prueba con pruebas asignadas. Para nuevas secciones, asigne pruebas antes de ordenar.",
  "heading.sampleType.management": "Editor de tipos de muestra",
  "heading.sampleType.subtitle": "Configure los tipos de muestras, el orden de visualización, las asociaciones de pruebas y la clasificación de dominios.",
  "heading.sampleType.editing": "Edición: {name}",
  "label.sampleType.domain": "Dominio de la muestra",
  "label.domain.CLINICAL": "Clínico",
  "label.domain.ENVIRONMENTAL": "Medioambiental",
  "label.domain.VECTOR": "Vector",
  "label.sampleType.domain.clinical": "Clínico",
  "label.sampleType.domain.environmental": "Ambiental",
  "label.sampleType.domain.helper": "Determina en qué modo de flujo de trabajo (clínico o ambiental) aparece este tipo de muestra.",
  "label.sampleType.filterDomain": "Filtrar por dominio",
  "label.sampleType.testCount": "Pruebas",
  "label.sampleType.actions": "Acciones",
  "label.sampleType.status": "Estado",
  "placeholder.sampleType.search": "Buscar tipos de muestras...",
  "placeholder.sampleType.filter.domain": "Todos los dominios",
  "button.sampleType.add": "Agregar tipo de muestra",
  "configuration.uom.create": "Crear Nuevas Unidades de Medida",
  "configure.labNumber.title": "Gestión de Números de Laboratorio",
  "confirmation.rename": "Confirme los cambios realizados anteriormente.",
  "currentests.title": "Pruebas Actuales",
  "cytology.label.cellabnomality": "Anomalía de células epiteliales",
  "cytology.label.confirmSelect": "Si seleccionas esta opción, toda la información de diagnóstico actual será eliminada",
  "cytology.label.dashboard": "Tablero de Citología",
  "cytology.label.glandular": "Glandular",
  "cytology.label.negative": "Negativo para lesión intraepitelial o malignidad",
  "cytology.label.neoplastic": "Variaciones celulares no neoplásicas",
  "cytology.label.organisms": "Organismos",
  "cytology.label.other": "Otros tumores malignos",
  "cytology.label.otherResult": "Otro resultado de diagnóstico",
  "cytology.label.reactive": "Cambios celulares reactivos",
  "cytology.label.review": "En espera de revisión citopatológica",
  "cytology.label.specimen": "Adecuación de la muestra",
  "cytology.label.squamous": "Escamoso",
  "cytology.label.title": "Citología",
  "cytology.status.completed": "Completado",
  "cytology.status.preparingSlides": "Preparing slides",
  "cytology.status.readyForCytopathologist": "Ready for Cytopathologist",
  "cytology.status.screening": "Screening",
  "dashboard.avg.turn.around.label": "Tiempo promedio de respuesta",
  "dashboard.avg.turn.around.reception.to.result.label": "Tiempo medio desde la recepción hasta el resultado",
  "dashboard.avg.turn.around.reception.to.validation.label": "Tiempo medio desde la recepción a la validación",
  "dashboard.avg.turn.around.result.to.validation.label": "Tiempo medio desde el resultado hasta la validación",
  "dashboard.avg.turn.around.subtitle.label": " Recepción a validación",
  "dashboard.complete.orders.label": "Órdenes completadas hoy",
  "dashboard.in.progress.label": "En progreso",
  "dashboard.in.progress.subtitle.label": "Esperando entrada de resultados",
  "dashboard.metrics.loadFailed": "Dashboard counts could not be loaded.",
  "dashboard.partially.completed.label": "Completadas parcialmente hoy",
  "dashboard.partially.completed.subtitle.label": "A la espera de las pruebas pendientes",
  "dashboard.rejected.orders": "Órdenes rechazadas",
  "dashboard.turn.around.label": "Retraso en el tiempo de respuesta",
  "dashboard.turn.around.subtitle.label": "Más de 96 horas",
  "dashboard.unprints.results.label": "Resultados no impresos",
  "dashboard.user.orders.label": "Órdenes ingresadas por usuarios",
  "dashboard.user.orders.today.label": "Órdenes ingresadas por usuario hoy",
  "dashboard.user.ordersEntered": "Orders Entered",
  "dashboard.validation.ready.label": "Listo para validación",
  "dashboard.validation.ready.subtitle.label": "Esperando revisión",
  "dataexport.status.actions": "Acciones",
  "dataexport.status.attempt.duration": "Duración",
  "dataexport.status.attempt.endTime": "Hora de finalización",
  "dataexport.status.attempt.startTime": "Hora de inicio",
  "dataexport.status.attempt.status": "Estado",
  "dataexport.status.duration.ms": "{value} ms",
  "dataexport.status.duration.s": "{value} s",
  "dataexport.status.empty": "No hay ningún suscriptor FHIR configurado. Configure «org.openelisglobal.fhir.subscriber» en el archivo «common.properties» y reinicie el servidor para registrar uno.",
  "dataexport.status.endpoint": "Punto final",
  "dataexport.status.failed24h": "Fallidos / Total (24 h)",
  "dataexport.status.failed24hValue": "{failed} / {total}",
  "dataexport.status.intervalMin": "Intervalo de reintento",
  "dataexport.status.intervalValue": "{value} min",
  "dataexport.status.lastAttempt": "Último intento",
  "dataexport.status.lastRefreshed": "Última actualización",
  "dataexport.status.lastStatus": "Último estado",
  "dataexport.status.lastSuccess": "Último éxito",
  "dataexport.status.loadingAttempts": "Cargando el historial de intentos…",
  "dataexport.status.never": "Nunca",
  "dataexport.status.noAttempts": "Aún no se ha realizado ningún intento",
  "dataexport.status.placeholderDash": "—",
  "dataexport.status.refresh": "Actualizar",
  "dataexport.status.retry": "Inténtelo de nuevo ahora",
  "dataexport.status.retryInFlight": "Activando…",
  "dataexport.status.title": "Estado de la exportación de datos FHIR",
  "datasubmission.siteid": " ID del sitio",
  "database.clean": "Limpieza de bases de datos",
  "database.clean.button": "Limpiar la base de datos",
  "database.clean.confirm.message": "¿Está seguro de que desea limpiar la base de datos? Esto eliminará todos los datos de pacientes y pruebas.",
  "database.clean.confirm.title": "Confirmar la limpieza de la base de datos",
  "database.clean.confirm.warning": "¡Esta acción no se puede deshacer!",
  "database.clean.error": "No se ha podido limpiar la base de datos.",
  "database.clean.not.training": "La limpieza de la base de datos solo está disponible en las instalaciones de formación.",
  "database.clean.success": "La base de datos se ha limpiado correctamente.",
  "database.clean.warning": "Esto eliminará de forma definitiva todos los datos de pacientes, datos de muestras y resultados de la base de datos.",
  "date.created": "Fecha de creación",
  "datepicker.future.notAllowed": "The date cannot be in the future.",
  "datepicker.past.notAllowed": "The date cannot be in the past.",
  "datepicker.placeholder.dmy": "dd/mm/aaaa",
  "datepicker.placeholder.mdy": "mm/dd/aaaa",
  "delete.error.msg": "Error al eliminar",
  "delete.success.msg": "Eliminado correctamente",
  "description.active": " Si la prueba está activa, puede solicitarse en el formulario de órdenes o como parte de un algoritmo de prueba. Si no está activa, no puede solicitarse ni formar parte de un algoritmo de prueba",
  "description.ageRange": " Si el rango de edad (en meses) afecta los valores dados, se especificará aquí",
  "description.name": " El nombre de la prueba tal como aparecerá en OpenELIS. Se muestra en inglés y francés",
  "description.normalRange": " Cualquier resultado numérico dentro de este rango es lo esperado en una persona sana",
  "description.note": " n/a significa no disponible. El valor no está especificado",
  "description.orderable": " Si una prueba está activa y ordenable, puede solicitarse en un formulario de órdenes. Si está activa pero no es ordenable, solo se realizará si es reflejada desde otra prueba",
  "description.panel": " Si esta prueba forma parte de un panel de pruebas, el panel se nombrará aquí",
  "description.referenceValue": " Valor de selección para una persona sana. Solo se aplica a listas selectas",
  "description.reportName": " El nombre de la prueba tal como aparecerá en los informes. Se muestra en inglés y francés",
  "description.resultLimits": " Límites de resultados normales y válidos para pruebas numéricas. Los valores pueden depender de la edad y el sexo del paciente",
  "description.resultType": " Tipo de resultado para esta prueba:",
  "description.resultType.alphanumeric": " A - Alfanumérico:",
  "description.resultType.alphanumericDesc": " Acepta números o texto en una caja de texto. No se evaluará como normal o válido",
  "description.resultType.cascadingMultiSelectList": " C - Lista multiselección en cascada:",
  "description.resultType.cascadingMultiSelectListDesc": " Similar a multiselección pero el usuario podrá seleccionar varios grupos desde la lista desplegable",
  "description.resultType.kind": " Tipo de resultado para esta prueba:",
  "description.resultType.multiSelectList": " M - Lista multiselección:",
  "description.resultType.multiSelectListDesc": " El usuario podrá seleccionar uno o más valores de una lista desplegable. No se especificará valor de referencia",
  "description.resultType.numeric": " N - Numérico:",
  "description.resultType.numericDesc": " Acepta solo resultados numéricos en una caja de texto. Los resultados pueden evaluarse como dentro o fuera del rango normal o válido",
  "description.resultType.selectList": " D - Lista selecta:",
  "description.resultType.selectListDesc": " El usuario podrá seleccionar de una lista desplegable. El valor normal se especificará como valor de referencia",
  "description.resultType.textArea": " R - Texto libre:",
  "description.resultType.textAreaDesc": " Acepta hasta 200 caracteres en un área de texto. No se evaluará como normal o válido",
  "description.sampleType": " Tipo de muestra en la que se puede realizar la prueba. Si el técnico puede seleccionar el tipo de muestra después de haberla ordenado, se marcará como usuario",
  "description.selectValues": " Solo se especifica para resultados de lista selecta, multiselección o lista multiselección en cascada. Estas son las selecciones disponibles que verá el usuario. Si se marca como 'calificable', el usuario podrá ingresar información adicional en una caja de texto",
  "description.sex": " Si el sexo del paciente afecta los valores dados, se especificará aquí",
  "description.significantDigits": " Número de cifras significativas para resultados numéricos. Los resultados ingresados se redondearán o rellenarán según el número correcto. El rango normal también se mostrará con el número correcto de cifras significativas",
  "description.testUnit": " Sección del laboratorio que realiza la prueba. También se conoce como unidad de prueba",
  "description.uom": " Unidad de medida para la prueba. Usualmente aplica solo a resultados numéricos o alfanuméricos",
  "description.validRange": " Cualquier resultado numérico fuera de este rango indica que la prueba puede no haberse realizado correctamente",
  "dictionary.category.isActive": " Está activo",
  "dictionary.category.label": "Categoría del diccionario",
  "dictionary.category.localAbbreviation": " Abreviatura local",
  "dictionary.category.name": " Categoría",
  "dictionary.dictEntry": " Entrada del diccionario",
  "dictionary.label.modify": "Menú de edición",
  "dictionary.loincCode": "Código LOINC",
  "dictionary.loincCode.help": "Ingrese identificador LOINC estándar",
  "dictionary.loincCode.helpText": "Identificador estándar de observación de laboratorio",
  "dictionary.loincCode.invalid": "Formato LOINC inválido (se esperaba: 12345-6 o LP12345-6)",
  "dictionary.loincCode.placeholder": "ej. 12345-6",
  "dictionary.menu.deactivate.fail": " Error al desactivar menú de diccionario",
  "dictionary.menu.deactivate.success": " Menú de diccionario desactivado con éxito",
  "dictionary.modal.add.heading": "Agregar diccionario",
  "dictionary.modal.edit.heading": "Editar diccionario",
  "dictionary.number.label": "Número de diccionario",
  "disposal.button": "Eliminar lote",
  "disposal.notes": "Notas sobre la eliminación",
  "disposal.notes.placeholder": "Facilite detalles sobre la eliminación (método de eliminación, testigo, etc.)",
  "disposal.reason": "Motivo de la baja",
  "disposal.reason.select": "Seleccione el motivo",
  "disposal.success": "Lote eliminado correctamente",
  "disposal.title": "Eliminar lote",
  "disposal.warning.message": "Esta acción no se puede deshacer. El lote quedará marcado como dado de baja y se eliminará del inventario activo.",
  "disposal.warning.title": "Advertencia",
  "emergencyContactInfo.title": "Información de Contacto de Emergencia",
  "english.current": "INGLÉS actual",
  "english.label": "Inglés",
  "enterText.label": " Ingresar texto restante",
  "eorder.allInfo": " Toda la información",
  "eorder.button.editOrder": " Editar orden",
  "eorder.button.enterOrder": " Ingresar orden",
  "eorder.buttons": " ",
  "eorder.date.end": " Fecha de finalización",
  "eorder.date.start": " Fecha de inicio",
  "eorder.facility.requesting": " Instalación solicitante",
  "eorder.header": " Buscar solicitudes de prueba entrantes",
  "eorder.id.national": " ID nacional",
  "eorder.id.subjectNumber": " Número de sujeto",
  "eorder.instructions.enter1": " Solicitudes de prueba coincidentes con la búsqueda - En el",
  "eorder.instructions.enter2": " menú, agregue un número de laboratorio y seleccione",
  "eorder.instructions.enter3": " para aceptar la orden tal cual, o seleccione",
  "eorder.instructions.enter4": " para hacer cambios",
  "eorder.labNumber": " Número de laboratorio",
  "eorder.labnumber.referring": " Número de laboratorio de referencia",
  "eorder.name.first": "Nombre",
  "eorder.name.last": "Apellido",
  "eorder.passport.number": " Número de pasaporte",
  "eorder.priority": " Prioridad",
  "eorder.requestDate": " Fecha de solicitud",
  "eorder.search.noresults": " No hay órdenes electrónicas",
  "eorder.search1.text": " Buscar por apellido, número de identificación nacional, número de laboratorio del laboratorio de referencia o número de pasaporte",
  "eorder.search2.text": " Buscar por fecha y estado. Introduzca el rango de fechas para las solicitudes de prueba. Esto buscará por la fecha de la remisión o la fecha de solicitud electrónica",
  "eorder.searchValue": " Valor de búsqueda",
  "eorder.status": "Estado",
  "eorder.test.name": " Nombre de la prueba",
  "eqa.action.deactivate": "Desactivar",
  "eqa.action.edit": "Editar",
  "eqa.action.enterResults": "Introducir resultados",
  "eqa.action.enterViewResults": "Introducir/Consultar resultados",
  "eqa.action.reactivate": "Reactivar",
  "eqa.action.viewOrder": "Consultar pedido",
  "eqa.action.viewResults": "Consultar resultados",
  "eqa.admin.addProgram": "Agregar programa",
  "eqa.admin.col.actions": "Acciones",
  "eqa.admin.col.category": " Categoría",
  "eqa.admin.col.frequency": "Frecuencia",
  "eqa.admin.col.participants": "Participantes inscritos",
  "eqa.admin.col.programName": "Nombre del programa",
  "eqa.admin.col.provider": "Proveedor",
  "eqa.admin.delete": "Eliminar",
  "eqa.admin.form.addHeading": "Agregar un nuevo programa de EQA",
  "eqa.admin.form.category.placeholder": "Seleccione una categoría",
  "eqa.admin.form.description.placeholder": "Descripción y objetivos del programa...",
  "eqa.admin.form.editHeading": "Editar el programa EQA",
  "eqa.admin.form.frequency.placeholder": "Seleccione la frecuencia",
  "eqa.admin.form.name.placeholder": "p. ej., cultivo y prueba de sensibilidad de la TB",
  "eqa.admin.form.provider.placeholder": "Nombre de la organización que gestiona el programa",
  "eqa.admin.form.subtitle": "Inscríbase en un nuevo programa de evaluación externa de la calidad",
  "eqa.admin.programs.subtitle": "Gestionar los programas de evaluación de la calidad (EQA) y los proveedores inscritos",
  "eqa.admin.programs.title": "Programas de EQA",
  "eqa.admin.provider.placeholder": "p. ej., la WHO, los CDC, el CAP",
  "eqa.admin.subtitle": "Gestionar los programas de EQA",
  "eqa.admin.tab.participants": "Participantes",
  "eqa.admin.tab.userManagement": "Gestión de Usuarios",
  "eqa.admin.tile.acrossAllPrograms": "En todos los programas",
  "eqa.admin.tile.activePrograms": "Programas activos",
  "eqa.admin.tile.canManageEqa": "Puede gestionar la EQA",
  "eqa.admin.tile.enrolledParticipants": "Participantes inscritos",
  "eqa.admin.tile.systemUsers": "Usuarios del sistema",
  "eqa.admin.tile.totalParticipants": "Número total de participantes",
  "eqa.admin.tile.totalPrograms": "{count} programas en total",
  "eqa.admin.title": "Administración del programa",
  "eqa.admin.userManagement.placeholder": "La gestión de usuarios estará disponible próximamente.",
  "eqa.column.actions": "Acciones",
  "eqa.deadline.label": "Fecha límite para la realización de las pruebas",
  "eqa.distribution.action.continue": "Continuar",
  "eqa.distribution.action.ship": "Barco",
  "eqa.distribution.action.track": "Pista",
  "eqa.distribution.action.viewReport": "Ver informe",
  "eqa.distribution.advance": "Estado de avance",
  "eqa.distribution.backToDashboard": "Atrás «Distribuciones»",
  "eqa.distribution.barcodes": "Generar códigos de barras",
  "eqa.distribution.col.actions": "Acciones",
  "eqa.distribution.col.deadline": "Fecha límite",
  "eqa.distribution.col.participants": "Participantes",
  "eqa.distribution.col.program": " Programa",
  "eqa.distribution.col.responses": "Respuestas",
  "eqa.distribution.col.round": "Redondo",
  "eqa.distribution.col.samples": "Muestras",
  "eqa.distribution.col.shipmentId": "N.º de envío",
  "eqa.distribution.col.status": "Estado",
  "eqa.distribution.create": "Crear distribución",
  "eqa.distribution.createError": "No se ha podido crear la distribución.",
  "eqa.distribution.createShipment": "Crear un nuevo envío",
  "eqa.distribution.createSuccess": "La distribución se ha creado correctamente.",
  "eqa.distribution.dashboard.subtitle": "Distribuir las muestras de evaluación de la calidad externa (EQA) a los laboratorios participantes",
  "eqa.distribution.dashboard.title": "Distribución de EQA",
  "eqa.distribution.deadline": "Fecha límite de presentación",
  "eqa.distribution.detail.title": "Detalles de la distribución",
  "eqa.distribution.empty": "No se han encontrado distribuciones",
  "eqa.distribution.filter.allShipments": "Todos los envíos",
  "eqa.distribution.filter.program": "Filtrar por programa",
  "eqa.distribution.filter.status": "Filtrar por estado",
  "eqa.distribution.list.title": "Distribuciones de EQA",
  "eqa.distribution.manageParticipants": "Gestionar participantes",
  "eqa.distribution.name": "Nombre de la distribution",
  "eqa.distribution.name.placeholder": "Por ejemplo, 1.ª ronda: Química 2026",
  "eqa.distribution.network.active": "Participantes activos",
  "eqa.distribution.network.active.sub": "Matriculados actualmente",
  "eqa.distribution.network.responseRate": "Índice medio de respuesta",
  "eqa.distribution.network.responseRate.sub": "Últimos 4 trimestres",
  "eqa.distribution.network.subtitle": "Resumen de los laboratorios participantes inscritos",
  "eqa.distribution.network.title": "Red de participantes",
  "eqa.distribution.network.total": "Número total de participantes",
  "eqa.distribution.network.total.sub": "En todos los países",
  "eqa.distribution.participants": "Organizaciones participantes",
  "eqa.distribution.participants.min": "Se requieren al menos dos organizaciones participantes",
  "eqa.distribution.participants.none": "Todavía no hay ningún laboratorio inscrito activamente en este programa.",
  "eqa.distribution.participants.select": "Seleccione organizaciones",
  "eqa.distribution.program": "Programa EQA",
  "eqa.distribution.program.select": "Seleccione un programa",
  "eqa.distribution.responseRate": "índice de respuesta",
  "eqa.distribution.shipments.subtitle": "Realice un seguimiento de las muestras de control de calidad externo (EQA) distribuidas y de las respuestas de los participantes",
  "eqa.distribution.shipments.title": "Envíos de EQA",
  "eqa.distribution.shipped": "Enviado",
  "eqa.distribution.status.completed": "Completado",
  "eqa.distribution.status.draft": "Borrador",
  "eqa.distribution.status.prepared": "Preparado",
  "eqa.distribution.status.shipped": "Enviado",
  "eqa.distribution.step.confirmation": "Confirmación",
  "eqa.distribution.step.details": "Programa y detalles",
  "eqa.distribution.step.participants": "Participantes",
  "eqa.distribution.summary.completed": "Completado",
  "eqa.distribution.summary.completed.sub": "Todas las respuestas recibidas",
  "eqa.distribution.summary.draft": "Envíos de borradores",
  "eqa.distribution.summary.draft.sub": "Estar preparado",
  "eqa.distribution.summary.participants": "Participantes",
  "eqa.distribution.summary.participants.sub": "Matriculado",
  "eqa.distribution.summary.shipped": "Enviado",
  "eqa.distribution.summary.shipped.sub": "A la espera de respuestas",
  "eqa.enrollment.allStatuses": "Todos los estados",
  "eqa.enrollment.alreadyEnrolled": "Ya está matriculado",
  "eqa.enrollment.alreadyEnrolledCount": "{count} organización(es) ya inscritas",
  "eqa.enrollment.confirmWithdraw": "Confirmar la retirada",
  "eqa.enrollment.created.success": "La inscripción en el programa se ha realizado correctamente",
  "eqa.enrollment.deactivated": "Inscripción en el programa desactivada",
  "eqa.enrollment.description": "Descripción",
  "eqa.enrollment.district": "Distrito",
  "eqa.enrollment.editing": "Edición: {name}",
  "eqa.enrollment.empty": "No se han encontrado inscripciones para este programa",
  "eqa.enrollment.enroll": "Inscribir",
  "eqa.enrollment.enrollParticipant": "Inscribir a un participante",
  "eqa.enrollment.enrollSelected": "Inscribir a los seleccionados",
  "eqa.enrollment.enrollmentDate": "Fecha de inscripción",
  "eqa.enrollment.error": "The enrollment was not saved. Try again.",
  "eqa.enrollment.labUnits": "Unidades de laboratorio",
  "eqa.enrollment.new": "Nueva inscripción en programa de ECA",
  "eqa.enrollment.organizationCode": "Código de organización",
  "eqa.enrollment.organizationName": "Nombre de la organización",
  "eqa.enrollment.panels": "Paneles",
  "eqa.enrollment.programName": "Nombre del programa",
  "eqa.enrollment.programName.placeholder": "Introduzca el nombre del programa",
  "eqa.enrollment.provider": "Proveedor",
  "eqa.enrollment.provider.placeholder": "Introduzca el nombre del proveedor",
  "eqa.enrollment.reactivate": "Reactivar",
  "eqa.enrollment.reactivated": "Se ha reactivado la inscripción en el programa",
  "eqa.enrollment.save": "Guardar inscripción",
  "eqa.enrollment.saveChanges": "Guardar cambios",
  "eqa.enrollment.searchOrgs": "Buscar organizaciones...",
  "eqa.enrollment.searchPlaceholder": "Buscar por nombre o código de la organización...",
  "eqa.enrollment.selectLabUnits": "Seleccione las unidades de laboratorio...",
  "eqa.enrollment.selectOrg": "Seleccione una organización...",
  "eqa.enrollment.selectOrgsPrompt": "Seleccione las organizaciones en las que desea inscribirse",
  "eqa.enrollment.selectPanels": "Seleccione los paneles...",
  "eqa.enrollment.selectProgram": "Seleccione un programa",
  "eqa.enrollment.selectProgramPrompt": "Seleccione un programa para consultar las inscripciones",
  "eqa.enrollment.selectTests": "Seleccione las pruebas...",
  "eqa.enrollment.selected": "seleccionado",
  "eqa.enrollment.status": "Estado",
  "eqa.enrollment.status.active": "Activo",
  "eqa.enrollment.status.suspended": "Suspendido",
  "eqa.enrollment.status.withdrawn": "Retirado",
  "eqa.enrollment.success": "La inscripción se ha realizado correctamente",
  "eqa.enrollment.suspend": "Suspender",
  "eqa.enrollment.tests": "Pruebas",
  "eqa.enrollment.thisLab": "Este laboratorio",
  "eqa.enrollment.updated.success": "La inscripción en el programa se ha actualizado correctamente",
  "eqa.enrollment.withdraw": "Retirar",
  "eqa.enrollment.withdrawReason": "Motivo de la baja",
  "eqa.enrollment.withdrawReasonPlaceholder": "Indique el motivo por el que se retira a este participante...",
  "eqa.filter.allPriorities": "Todas las prioridades",
  "eqa.filter.allPrograms": "Todos los programas",
  "eqa.filter.allStatuses": "Todos los estados",
  "eqa.filter.eqaOnly": "Únicamente muestras de EQA",
  "eqa.filter.priority": " Prioridad",
  "eqa.filter.program": " Programa",
  "eqa.filter.status": "Estado",
  "eqa.management.action.enterResults": "Introducir resultados",
  "eqa.management.action.submit": "Enviar",
  "eqa.management.bulkUpload": "Resultados de la carga masiva",
  "eqa.management.col.accession": "N.º de acceso",
  "eqa.management.col.actions": "Acciones",
  "eqa.management.col.deadline": "Fecha límite",
  "eqa.management.col.progress": "Avances",
  "eqa.management.col.provider": "Proveedor/Programa",
  "eqa.management.col.sampleId": "N.º de muestra",
  "eqa.management.col.status": "Estado",
  "eqa.management.daysLeft": "días que quedan",
  "eqa.management.distributions.title": "Distribuciones",
  "eqa.management.filter.allSamples": "Todas las muestras",
  "eqa.management.overdue": "Atrasado",
  "eqa.management.participants.subtitle": "Gestionar la inscripción de la organización en los programas de ECA",
  "eqa.management.participants.title": "Participantes",
  "eqa.management.performance.onTime": "Presentación dentro del plazo establecido",
  "eqa.management.performance.participation": "Tasa de participación",
  "eqa.management.performance.participation.sub": "Todos los programas en los que está matriculado",
  "eqa.management.performance.subtitle": "Los indicadores de rendimiento del programa EQA de su laboratorio",
  "eqa.management.performance.title": "Resumen de resultados",
  "eqa.management.performance.zScore": "Puntuación Z media",
  "eqa.management.performance.zScore.sub": "Dentro del rango aceptable",
  "eqa.management.programs.subtitle": "Gestionar los programas distribuidos por este laboratorio",
  "eqa.management.programs.title": "Programas de ECA",
  "eqa.management.results.title": "Resultados y análisis",
  "eqa.management.samples.empty": "No se han encontrado muestras de EQA",
  "eqa.management.samples.subtitle": "Gestionar las muestras de EQA recibidas y enviar los resultados",
  "eqa.management.samples.title": "Muestras de EQA",
  "eqa.management.status.completed": "Completado",
  "eqa.management.status.completed.sub": "Listo para enviar",
  "eqa.management.status.inProgress": "En progreso",
  "eqa.management.status.inProgress.sub": "Pruebas en progreso",
  "eqa.management.status.in_progress": "En progreso",
  "eqa.management.status.overdue": "Atrasado",
  "eqa.management.status.pending": "Pendiente",
  "eqa.management.status.pending.sub": "Aún no se ha iniciado",
  "eqa.management.status.submitted": "Enviado",
  "eqa.management.status.submitted.sub": "Resultados enviados",
  "eqa.management.subtitle": "Recibir y gestionar muestras de control de calidad EQA procedentes de proveedores externos",
  "eqa.management.title": "Gestión de la EQA",
  "eqa.management.viewPerformance": "Consultar resultados",
  "eqa.myProgram.helperText": "Al seleccionar una inscripción, se rellenan automáticamente las pruebas y los paneles",
  "eqa.myProgram.label": "Mi inscripción en el programa",
  "eqa.myProgram.prePopulated.subtitle": "{tests} Pruebas y paneles de «{panels}» preseleccionados en el momento de la inscripción",
  "eqa.myProgram.prePopulated.title": "Pruebas/paneles preconfigurados",
  "eqa.myProgram.select": "Seleccione la matrícula para rellenar automáticamente las pruebas...",
  "eqa.myPrograms.action.deactivate": "Desactivar",
  "eqa.myPrograms.action.edit": "Editar",
  "eqa.myPrograms.action.reactivate": "Reactivar",
  "eqa.myPrograms.description": "Descripción",
  "eqa.myPrograms.enrollButton": "Inscribirse en el programa",
  "eqa.myPrograms.enrollInProgram": "Inscribirse en el programa",
  "eqa.myPrograms.labUnits": "Unidad(es) de laboratorio",
  "eqa.myPrograms.panels": "Paneles",
  "eqa.myPrograms.programName": "Nombre del programa",
  "eqa.myPrograms.provider": "Proveedor",
  "eqa.myPrograms.search.placeholder": "Buscar programas...",
  "eqa.myPrograms.status": "Estado",
  "eqa.myPrograms.status.active": "Activo",
  "eqa.myPrograms.status.inactive": "Inactivo",
  "eqa.myPrograms.subtitle": "Programas en los que participa este laboratorio",
  "eqa.myPrograms.testMapping": "Asignación de pruebas (opcional)",
  "eqa.myPrograms.testMappingHint": "Seleccione las pruebas y los paneles que se rellenarán automáticamente en la sección «Introducción de pedidos» cuando se seleccione este programa",
  "eqa.myPrograms.tests": "Pruebas",
  "eqa.myPrograms.title": "Mis programas de ECA",
  "eqa.order.deadline": "Fecha límite para la presentación de resultados",
  "eqa.order.form.title": "Información sobre las muestras de ECA",
  "eqa.order.participantId": "N.º de identificación del participante",
  "eqa.order.priority": "Prioridad de ECA",
  "eqa.order.programme": "Programa",
  "eqa.order.provider": "Proveedor",
  "eqa.order.providerSampleId": "N.º de identificación de la muestra del proveedor",
  "eqa.orders.completedThisMonth": "Completados este mes",
  "eqa.orders.enterNewTest": "Introducir una nueva prueba de EQA",
  "eqa.orders.inProgress": "En progreso",
  "eqa.orders.overdue": "Atrasado",
  "eqa.orders.pending": "Pendiente",
  "eqa.orders.search.placeholder": "Buscar por número de laboratorio o por programa...",
  "eqa.participant.id": "N.º de identificación del participante",
  "eqa.priority.critical": "Crítico",
  "eqa.priority.label": " Prioridad",
  "eqa.priority.standard": "Estándar",
  "eqa.priority.urgent": "Urgente",
  "eqa.program.activate": "Activar",
  "eqa.program.active": "Activo",
  "eqa.program.addProgram": "Agregar programa",
  "eqa.program.cancel": "Cancelar",
  "eqa.program.create": "Crear programa",
  "eqa.program.createTitle": "Crear un programa de evaluación de la calidad externa (EQA)",
  "eqa.program.deactivate": "Desactivar",
  "eqa.program.description": "Descripción",
  "eqa.program.description.placeholder": "Describa el programa de garantía de calidad externa (EQA)...",
  "eqa.program.edit": "Editar programa",
  "eqa.program.editTitle": "Editar el programa EQA",
  "eqa.program.empty": "No se han encontrado programas de ECA",
  "eqa.program.inactive": "Inactivo",
  "eqa.program.label": "Programa EQA",
  "eqa.program.management.title": "Gestión del programa EQA",
  "eqa.program.name": "Nombre del programa",
  "eqa.program.name.placeholder": "Por ejemplo, pruebas de competencia en química",
  "eqa.program.name.required": "Es obligatorio indicar el nombre del programa",
  "eqa.program.provider.required": "Es obligatorio indicar el proveedor",
  "eqa.program.participantCount": "Participantes inscritos",
  "eqa.program.provider": "Proveedor",
  "eqa.program.required": "Es obligatorio indicar el programa de EQA al registrar una muestra de EQA.",
  "eqa.program.save": "Guardar programa",
  "eqa.program.select": "Seleccione un programa de EQA",
  "eqa.program.status": "Estado",
  "eqa.program.tests": "Pruebas asignadas",
  "eqa.program.tests.assign": "Asignar pruebas",
  "eqa.program.tests.select": "Seleccione las pruebas que desee asignar",
  "eqa.provider.label": "Organización proveedora de EQA",
  "eqa.provider.sampleId": "N.º de identificación de la muestra del proveedor",
  "eqa.provider.select": "Seleccione un proveedor de EQA",
  "eqa.results.acceptable": "Aceptable",
  "eqa.results.batch.import": "Importación por lotes",
  "eqa.results.col.deadline": "Fecha límite",
  "eqa.results.col.labNumber": " Número de laboratorio",
  "eqa.results.col.priority": " Prioridad",
  "eqa.results.col.programme": "Programa",
  "eqa.results.col.provider": "Proveedor",
  "eqa.results.col.status": "Estado",
  "eqa.results.import.confirm": "Confirmar importación",
  "eqa.results.import.errors": "{count} algunas filas presentaban errores",
  "eqa.results.import.success": "{count} Los resultados se han importado correctamente",
  "eqa.results.import.upload": "Cargar archivo CSV",
  "eqa.results.manual.entry": "Introducción manual de resultados",
  "eqa.results.mean": "Media",
  "eqa.results.minimum.participants": "Se requiere un mínimo de 5 participantes para el análisis estadístico",
  "eqa.results.noResults": "No se han encontrado resultados de pruebas de EQA.",
  "eqa.results.organization": "Organización",
  "eqa.results.organization.select": "Seleccione una organización",
  "eqa.results.participant.count": "Número de participantes",
  "eqa.results.performance": "Rendimiento",
  "eqa.results.questionable": "Cuestionable",
  "eqa.results.report.downloading": "Descargando el informe...",
  "eqa.results.report.generate": "Generar Reporte",
  "eqa.results.search.placeholder": "Buscar por número de laboratorio, programa o proveedor...",
  "eqa.results.standardDeviation": "Desviación estándar",
  "eqa.results.statistics": "Estadísticas",
  "eqa.results.submit": "Enviar resultado",
  "eqa.results.test": "Prueba",
  "eqa.results.test.select": "Seleccione una prueba",
  "eqa.results.title": "Resultados y análisis de la EQA",
  "eqa.results.unacceptable": "Inaceptable",
  "eqa.results.value": "Valor del resultado",
  "eqa.results.zscore": "Puntuación Z",
  "eqa.sample.badge": "ECA",
  "eqa.sample.checkbox": "Muestra de ECA",
  "eqa.sample.checkbox.helper": "Compruebe si se trata de una muestra del programa de garantía de calidad externa",
  "eqa.sample.demographics.disabled": "Se han desactivado los datos demográficos para las muestras de EQA",
  "eqa.sample.patient.readonly.body": "Los campos demográficos del paciente se configuran automáticamente para las muestras de ECA y no se pueden editar.",
  "eqa.sample.patient.readonly.title": "Muestra de ECA: información del paciente bloqueada",
  "eqa.section.title": "Detalles de la muestra de EQA",
  "eqa.status.active": "Activo",
  "eqa.status.completed": "Completado",
  "eqa.status.inProgress": "En progreso",
  "eqa.status.inactive": "Inactivo",
  "eqa.status.inprogress": "En progreso",
  "eqa.status.overdue": "Atrasado",
  "eqa.status.pending": "Pendiente",
  "eqa.submission.audit": "Registro de Auditoría de envíos",
  "eqa.submission.date": "Fecha de presentación",
  "eqa.submission.error": "El envío no se ha realizado correctamente",
  "eqa.submission.fhir": "Enviar a través de FHIR",
  "eqa.submission.fhir.description": "Envíe los resultados a un proveedor externo de evaluación de la calidad (EQA) a través de FHIR R4",
  "eqa.submission.late.approve": "Aprobar la presentación fuera de plazo",
  "eqa.submission.late.justification": "Justificación por la presentación fuera de plazo",
  "eqa.submission.late.justification.placeholder": "Indique el motivo del retraso en la presentación...",
  "eqa.submission.late.supervisor": "ID de usuario del supervisor",
  "eqa.submission.late.warning": "El plazo de presentación ya ha vencido. Se requiere la aprobación del supervisor.",
  "eqa.submission.method": "Método de presentación",
  "eqa.submission.success": "Los resultados se han enviado correctamente",
  "eqa.submission.title": "Envío de resultados",
  "eqa.tests.action.enterResults": "Introducir resultados",
  "eqa.tests.action.viewOrder": "Consultar pedido",
  "eqa.tests.action.viewResults": "Consultar resultados",
  "eqa.tests.dateEntered": "Fecha de registro",
  "eqa.tests.deadline": "Fecha límite",
  "eqa.tests.enterNew": "Introducir una nueva prueba de EQA",
  "eqa.tests.labNumber": " Número de laboratorio",
  "eqa.tests.orders.subtitle": "Pedidos de pruebas de competencia para este laboratorio",
  "eqa.tests.orders.title": "Pedidos de EQA",
  "eqa.tests.priority": " Prioridad",
  "eqa.tests.program": "Programa de ECA",
  "eqa.tests.provider": "Proveedor",
  "eqa.tests.searchPlaceholder": "Buscar por número de acceso, programa o proveedor...",
  "eqa.tests.status": "Estado",
  "eqa.tests.status.completed": "Completado",
  "eqa.tests.status.inProgress": "En progreso",
  "eqa.tests.status.overdue": "Atrasado",
  "eqa.tests.status.pending": "Pendiente",
  "eqa.tests.summary.completedThisMonth": "Completados este mes",
  "eqa.tests.summary.inProgress": "En progreso",
  "eqa.tests.summary.overdue": "Atrasado",
  "eqa.tests.summary.pending": "Pendiente",
  "eqa.validation.deadline.required": "Es obligatorio indicar la fecha límite para la realización de las pruebas",
  "eqa.validation.program.required": "Es obligatorio el programa EQA",
  "eqa.validation.provider.required": "Es obligatorio contar con una organización proveedora de EQA",
  "error.add.edited.msg": "Error al editar/agregar",
  "error.barcode.dimension.positive": "La dimensión de la etiqueta debe ser un número positivo",
  "error.barcode.labelcount.default.lte.max": "El número de etiquetas predeterminado no debe superar el máximo establecido para este tipo de etiqueta.",
  "error.delete.msg": "Error al eliminar",
  "error.duplicate.calculationname": " Nombre de cálculo duplicado o error al guardar",
  "error.fetch.boxDetails": "No se han podido recuperar los detalles de la caja",
  "error.fetch.boxes": "No se han podido recuperar las cajas de envío",
  "error.fetch.facilities": "No se han podido recuperar las instalaciones",
  "error.fetch.unassignedSamples": "No se han podido recuperar las muestras sin asignar",
  "error.field.required": "Este campo es obligatorio",
  "error.import.patient": " Error al importar paciente a OpenELIS",
  "error.invalid.email": " Correo electrónico inválido",
  "error.invalidcredentials": "El nombre de usuario o la contraseña son incorrectos",
  "error.locale.format": "Formato no válido. Utilice: en, fr, es o en-US, fr-CA, etc.",
  "error.no.patient.data": " No hay datos de paciente para importar",
  "error.nonconform.report": " Por favor ingrese un valor",
  "error.report.csv.date": " Por favor seleccione tipo de fecha.",
  "error.report.csv.study": " Por favor seleccione tipo de estudio.",
  "error.report.status": " Error al generar el informe",
  "error.report.linkIncomplete": "El enlace no indica qué {0} abrir, por lo que no se puede mostrar el informe. Selecciónelo de las listas de informes en su lugar.",
  "error.report.linkIncomplete.title": "Este enlace de informe está incompleto",
  "error.required.destination": "Es necesario indicar la instalación de destino",
  "error.results.loadFailed": "No se ha podido cargar la lista de trabajo de resultados",
  "error.results.loadFailed.detail": "Esta no es una lista de tareas vacía: la solicitud ha fallado, por lo que no se muestra ninguna tarea pendiente aquí. Inténtelo de nuevo y avise a un administrador si sigue fallando.",
  "error.results.precision": "Esta prueba muestra el resultado con {0} decimales. Introduzca el valor con esa precisión; de lo contrario, el valor registrado y el valor mostrado no coincidirán.",
  "error.results.staleSave": "Este resultado ha sido actualizado por {0} en {1}; actualice la página para ver el valor más reciente",
  "error.results.save.noResponse": "The result was not saved because the server did not respond. Check the connection and try again.",
  "error.order.staleSave": "This order was updated by {0} at {1}. Refresh to see the latest version, then make your change again.",
  "error.patient.staleSave": "This patient was updated by {0} at {1}. Refresh to see the latest version, then make your change again.",
  "error.testCatalog.staleSave": "This test was updated by {0} at {1}. Refresh to see the latest version, then make your change again.",
  "error.testCatalog.storage.invalidField": "{field}: this value is not accepted. Choose a listed condition, use zero or more for durations, and keep text within its length.",
  "error.staleSave.section": "Someone else changed this after you opened it. Nothing was saved. Refresh to see the latest version, then make your change again.",
  "error.load.failed": "No se pudo cargar esta lista. Recargue para intentarlo de nuevo.",
  "error.save.failed": "Error al guardar",
  "error.save.msg": " Error al guardar",
  "error.save.order": "Se ha producido un error al guardar la orden",
  "error.save.patient": " Error al guardar paciente",
  "error.title": "Error",
  "errorBoundary.reload": "Recargar",
  "errorBoundary.route.patientResultsViewer.message": "Se ha producido un error al mostrar los resultados de este paciente. Recargue la página para volver a intentarlo.",
  "errorBoundary.route.patientResultsViewer.title": "No se han podido cargar los resultados del paciente",
  "errorBoundary.route.resultsSearch.message": "Se ha producido un error en la página de Resultados. Recargue la página para volver a intentarlo.",
  "errorBoundary.route.resultsSearch.title": "No se han podido cargar los resultados",
  "errorBoundary.route.modifyOrder.message": "Something went wrong on the modify order page. Reload to try again.",
  "errorBoundary.route.modifyOrder.title": "Modify order could not be loaded",
  "errorBoundary.route.orderEntry.message": "Algo salió mal en la página de ingreso de órdenes. Recargue para intentarlo de nuevo.",
  "errorBoundary.route.orderEntry.title": "No se pudo cargar el ingreso de órdenes",
  "errorBoundary.route.samplePatientEntry.message": "Se ha producido un error en la página de introducción de datos de muestra. Recargue la página para volver a intentarlo.",
  "errorBoundary.route.samplePatientEntry.title": "No se ha podido cargar la entrada de muestra",
  "errorBoundary.route.storage.message": "Se ha producido un error en esta página. Recargue la página para volver a intentarlo o utilice el menú para ir a otra sección.",
  "errorBoundary.route.storage.title": "No se ha podido cargar el almacenamiento",
  "errorBoundary.route.analyzers.message": "Se ha producido un error al cargar esta página. Recargue para intentarlo de nuevo.",
  "errorBoundary.route.analyzers.title": "No se ha podido cargar el módulo del Analizador",
  "errorBoundary.route.analyzerResults.message": "Se ha producido un error al cargar los resultados. Recargue la página para volver a intentarlo.",
  "errorBoundary.route.analyzerResults.title": "No se han podido cargar los resultados del Analizador",
  "serverReconnect.title": "Can't reach the server",
  "serverReconnect.retryIn": "Trying again in {seconds} s",
  "serverReconnect.trying": "Trying again now…",
  "serverReconnect.tryNow": "Try now",
  "errors.no.sample": "Seleccione la muestra adecuada para cada prueba.",
  "errors.requester.org.or.requestor.required": "Ingrese al menos una opción entre Organización solicitante o Contacto del solicitante.",
  "esig.button.certify": "Certificar y continuar",
  "esig.button.reject": " Rechazar",
  "esig.button.saveAndSign": "Guardar",
  "esig.button.saveModification": "Guardar",
  "esig.button.sign": "Firmar",
  "esig.button.validate": "Validar",
  "esig.certification.acknowledge": "He leído y comprendo la declaración anterior",
  "esig.certification.intro": "Antes de poder utilizar firmas electrónicas, debe certificar que su firma electrónica tiene el mismo valor jurídico que su firma manuscrita.",
  "esig.error.disabled": "Las firmas electrónicas no están habilitadas",
  "esig.error.generic": "Se ha producido un error",
  "esig.error.invalidCredentials": "Credenciales no válidas",
  "esig.error.keycloakNotSupported": "La autenticación mediante Keycloak aún no es compatible con las firmas electrónicas",
  "esig.error.loadingStatus": "No se ha podido cargar el estado de la firma",
  "esig.error.mustAcknowledge": "Debe aceptar la declaración de certificación",
  "esig.error.passwordRequired": "Se requiere una contraseña",
  "esig.error.rejectionReasonRequired": "Es obligatorio indicar el motivo de rechazo",
  "esig.error.title": "Error",
  "esig.error.usernameRequired": "Se requiere un nombre de usuario",
  "esig.info.fullAuth": "Esta es su primera firma en esta sesión. Introduzca su nombre de usuario y contraseña para autenticarse.",
  "esig.info.legalBinding": "Al introducir sus datos de acceso, está creando una firma electrónica legalmente vinculante, de conformidad con el título 21 del CFR, parte 11.",
  "esig.info.passwordOnly": "Tiene una sesión de firma activa. Introduzca su contraseña para continuar.",
  "esig.label.context": "Acción:",
  "esig.label.meaning": "Significado de la firma:",
  "esig.label.password": "Contraseña",
  "esig.label.rejectionReason": "Motivo de rechazo",
  "esig.label.signingAs": "Firmando como: {userName}",
  "esig.label.username": "Nombre de usuario",
  "esig.meaning.authored": "Autoría",
  "esig.meaning.modified": "Modificado",
  "esig.meaning.rejected": "Rechazado",
  "esig.meaning.validatedAndReleased": "Validado y liberado",
  "esig.placeholder.password": "Introduzca su contraseña para confirmar",
  "esig.placeholder.rejectionReason": "Indique el motivo del rechazo",
  "esig.placeholder.username": "Introduzca su nombre de usuario",
  "esig.title.certification": "Certificación de la firma electrónica",
  "esig.title.signature": "Firma electrónica",
  "example": " Ejemplo",
  "external.id": "Identificador externo",
  "external.referrals.report": "Informe de referencias externas",
  "externalReferredOutTests.title": "Informe de referencias externas",
  "externalconnections.active": "Activo",
  "externalconnections.add.title": "Agregar conexión externa",
  "externalconnections.authtype": "Tipo de autenticación",
  "externalconnections.authtype.basic.password": "Contraseña",
  "externalconnections.authtype.basic.username": "Nombre de usuario",
  "externalconnections.browse.title": "Conexiones externas",
  "externalconnections.deactivate.success": "Las conexiones externas se han desactivado correctamente.",
  "externalconnections.description": "Descripción",
  "externalconnections.edit.title": "Editar conexión externa",
  "externalconnections.name": " Nombre",
  "externalconnections.name.placeholder": "Introduzca el nombre de la conexión",
  "externalconnections.programmedconnection": "Tipo de conexión",
  "externalconnections.save.success": "La conexión externa se ha guardado exitosamente.",
  "externalconnections.search": "Buscar conexiones externas",
  "externalconnections.search.placeholder": "Buscar por nombre o tipo",
  "externalconnections.select": "Seleccionar",
  "externalconnections.uri": "URI",
  "externalconnections.uri.placeholder": "Por ejemplo: https://server:port",
  "false.label": "Falso",
  "field.active": " Activo/No activo",
  "field.ageRange": " Rango de edad",
  "field.dictionaryValues": " Valores del diccionario",
  "field.loinc": "LOINC",
  "field.name": " Nombre",
  "field.normalRange": " Rango normal",
  "field.note": " Nota",
  "field.orderable": " Ordenable/No ordenable",
  "field.panel": "Panel",
  "field.referenceValue": " Valor de referencia",
  "field.reportName": " Nombre en informe",
  "field.resultLimits": " Límites de resultado",
  "field.resultType": " Tipo de resultado",
  "field.sampleType": " Tipo de muestra",
  "field.select.testSection": "Seleccione la Sección de Prueba",
  "field.selectValues": " Valores seleccionables",
  "field.sex": "Sexo",
  "field.significantDigits": " Cifras significativas",
  "field.testSection": "Sección de Prueba",
  "field.testUnit": " Unidad de prueba",
  "field.uom": " Unidad de medida",
  "field.validRange": " Rango válido",
  "file.import.configuration.active": "Activo",
  "file.import.configuration.analyzer": "Analizador",
  "file.import.configuration.analyzer.emptyState": "No hay ningún complemento de importación de archivos instalado",
  "file.import.configuration.analyzer.placeholder": "Seleccione un analizador",
  "file.import.configuration.cancel": "Cancelar",
  "file.import.configuration.columnMappings": "Asignaciones de columnas",
  "file.import.configuration.columnMappings.helperText": "Asignación JSON de columnas CSV a campos de OpenELIS (por ejemplo, {\"Sample_ID\": \"sampleId\", \"Result\": \"result\"})",
  "file.import.configuration.delimiter": "Delimitador",
  "file.import.configuration.delimiter.helperText": "Carácter delimitador del archivo CSV (por defecto: coma)",
  "file.import.configuration.error.save": "No se ha podido guardar la configuración de importación del archivo",
  "file.import.configuration.error.unknown": "Se ha producido un error desconocido",
  "file.import.configuration.fileFormat": "Formato de archivo",
  "file.import.configuration.fileFormat.placeholder": "Seleccione el formato de archivo",
  "file.import.configuration.filePattern": "Patrón de archivo",
  "file.import.configuration.filePattern.helperText": "Patrón «Glob» para la búsqueda de archivos (por ejemplo, *.csv, results_*.txt)",
  "file.import.configuration.hasHeader": "Tiene fila de encabezado",
  "file.import.configuration.importDirectory": "Directorio de importación",
  "file.import.configuration.importDirectory.helperText": "Directorio en el que se deben supervisar los nuevos archivos",
  "file.import.configuration.importDirectory.placeholder": "/data/import",
  "file.import.configuration.save": "Guardar",
  "file.import.configuration.success.created": "La configuración de importación de archivos se ha creado correctamente",
  "file.import.configuration.success.updated": "La configuración de la importación de archivos se ha actualizado correctamente",
  "file.import.configuration.title.add": "Agregar configuración de importación de archivos",
  "file.import.configuration.title.edit": "Editar la configuración de importación de archivos",
  "file.import.configuration.validation.analyzerId.required": "Es necesario disponer de un analizador",
  "file.import.configuration.validation.columnMappings.invalid": "Formato JSON no válido para las asignaciones de columnas",
  "file.import.configuration.validation.importDirectory.required": "Es necesario indicar un directorio de importación",
  "fileImport.format.csv": "CSV",
  "fileImport.format.excel": "Excel",
  "fileImport.format.tsv": "TSV",
  "filters.label": "Filtros",
  "freezer.alert.detail.acknowledge": "Reconocer",
  "freezer.alert.detail.acknowledgedAt": "Reconocido en",
  "freezer.alert.detail.acknowledgedBy": "Reconocido por",
  "freezer.alert.detail.acknowledgmentNotes": "Notas de reconocimiento",
  "freezer.alert.detail.actions": "Acciones tomadas",
  "freezer.alert.detail.close": "Cerrar",
  "freezer.alert.detail.correctiveAction": "Acciones correctivas",
  "freezer.alert.detail.correctiveActionDescription": "Descripción",
  "freezer.alert.detail.correctiveActionFailed": "No se ha podido registrar la acción correctiva",
  "freezer.alert.detail.correctiveActionType": "Tipo de acción",
  "freezer.alert.detail.delete": "Eliminar alerta",
  "freezer.alert.detail.deleteConfirm": "¿Desea eliminar esta alerta de forma definitiva?",
  "freezer.alert.detail.deleteFailed": "No se ha podido eliminar la alerta",
  "freezer.alert.detail.deletePermanently": "Eliminar definitivamente",
  "freezer.alert.detail.deleteWarning": "La hora de inicio, la severidad, el acuse de recibo y las notas se eliminan sin dejar registro de auditoría y no se pueden recuperar.",
  "freezer.alert.detail.freezer": "Congelador",
  "freezer.alert.detail.id": "ID de alerta",
  "freezer.alert.detail.logCorrectiveAction": "Registrar las acciones correctivas",
  "freezer.alert.detail.message": "Mensaje",
  "freezer.alert.detail.method": "Método",
  "freezer.alert.detail.notes": "Notas",
  "freezer.alert.detail.notesPlaceholder": "Agregue notas sobre esta alerta...",
  "freezer.alert.detail.notifications": "Notificaciones enviadas",
  "freezer.alert.detail.overview": "Resumen de la alerta",
  "freezer.alert.detail.recipient": "Destinatario",
  "freezer.alert.detail.resolutionNotes": "Notas sobre la resolución",
  "freezer.alert.detail.resolve": "Resolver",
  "freezer.alert.detail.resolvedAt": "Resuelto el",
  "freezer.alert.detail.resolvedBy": "Resuelto por",
  "freezer.alert.detail.sentAt": "Enviado el",
  "freezer.alert.detail.severity": " Severidad",
  "freezer.alert.detail.startTime": "Hora de inicio",
  "freezer.alert.detail.status": "Estado",
  "freezer.alert.detail.summary": "Resumen",
  "freezer.alert.detail.takenAt": "Tomada en",
  "freezer.alert.detail.takenBy": "Tomada por",
  "freezer.alert.detail.title": "Detalles de la alerta",
  "freezer.alert.severity.critical": "Crítico",
  "freezer.alert.severity.warning": "Advertencia",
  "freezer.alert.status.acknowledged": "Reconocido",
  "freezer.alert.status.closed": "Cerrado",
  "freezer.alert.status.escalated": "Escalado",
  "freezer.alert.status.open": "Abierto",
  "freezer.alert.status.resolved": "Resuelto",
  "freezer.nav.corrective": "Acciones correctivas",
  "freezer.nav.corrective.tooltip": "Gestionar las acciones correctivas",
  "freezer.nav.dashboard": "Panel",
  "freezer.nav.dashboard.tooltip": "Consultar el panel de control de la supervisión de las cámaras frigoríficas",
  "freezer.nav.reports": "Informes",
  "freezer.nav.reports.tooltip": "Generar informes sobre el almacenamiento en frío",
  "freezer.nav.settings": "Configuración",
  "freezer.nav.settings.tooltip": "Configurar los ajustes del almacenamiento en frío",
  "freezer.nav.trends": "Tendencias históricas",
  "freezer.nav.trends.tooltip": "Consulte las tendencias de las temperaturas a lo largo del tiempo",
  "french.current": "FRANCÉS actual",
  "french.label": "Francés",
  "from.title": "Desde",
  "genericSample.edit.success": "La muestra se ha actualizado correctamente",
  "genericSample.edit.success.accession": "Accession Number: {accessionNumber}",
  "genericSample.edit.title": "Editar muestra",
  "genericSample.field.by": "Por",
  "genericSample.field.count": "#",
  "genericSample.field.date": "Fecha",
  "genericSample.field.from": "Desde",
  "genericSample.field.id": "ID",
  "genericSample.field.labPersonReceived": "Se ha recibido el personal de laboratorio",
  "genericSample.field.project": "Proyecto",
  "genericSample.field.storageLocation": "N.º y ubicación del congelador de almacenamiento",
  "genericSample.field.type": "Tipo",
  "genericSample.notebook.selection.title": "Selección de cuadernos (opcional)",
  "genericSample.order.error.labNoRequired": "Por favor, genere un número de laboratorio antes de guardar.",
  "genericSample.order.generateLabNo": "Generar número de laboratorio",
  "genericSample.order.labNo.placeholder": "Haga clic en «Generar número de laboratorio» para crear",
  "genericSample.order.success.details": "Detalles de la muestra",
  "genericSample.order.success.message": "Se ha creado correctamente una orden de muestra con el número de laboratorio: {accessionNumber}",
  "genericSample.order.title": "Recibir una muestra",
  "gps.accuracy.display": "Precisión de{accuracy}m",
  "gps.accuracy.warning.message": "La precisión del GPS es de {accuracy}m, lo que supera el umbral requerido de {required}m. Le recomendamos que vuelva a registrar la ubicación desde una posición más adecuada.",
  "gps.accuracy.warning.title": "Advertencia sobre la precisión del GPS",
  "gps.button.clear": "Limpiar",
  "gps.button.getting.location": "Obteniendo la ubicación...",
  "gps.button.location.captured": "Ubicación registrada",
  "gps.button.use.my.location": "Utilizar mi ubicación",
  "gps.collapse": "Ocultar la sección de GPS",
  "gps.config.accuracy.helper": "Precisión máxima aceptable del GPS en metros. Establezca este valor en 0 para desactivar la comprobación de la precisión.",
  "gps.config.accuracy.label": "Precisión requerida (metros)",
  "gps.config.enabled.description": "Cuando se active esta opción, aparecerán campos de coordenadas GPS en el flujo de trabajo de «Introducción de pedidos» para registrar las ubicaciones de recogida de muestras.",
  "gps.config.enabled.label": "Activar coordenadas GPS",
  "gps.config.error.load": "No se ha podido cargar la configuración del GPS",
  "gps.config.save.error": "No se ha podido guardar la configuración del GPS",
  "gps.config.save.success": "La configuración del GPS se ha guardado exitosamente",
  "gps.config.saving": "Guardando...",
  "gps.config.section.general": "Configuración del GPS",
  "gps.config.timeout.helper": "Tiempo máximo de espera para obtener la ubicación por GPS, en segundos.",
  "gps.config.timeout.label": "Tiempo de espera (segundos)",
  "gps.config.title": "Configuración de las coordenadas GPS",
  "gps.config.unsaved.changes": "Tiene cambios sin guardar. ¿Está seguro de que desea salir?",
  "gps.config.unsaved.subtitle": "Recuerde guardar los cambios antes de salir de esta página.",
  "gps.config.unsaved.title": "Cambios sin guardar",
  "gps.config.validation.accuracy.negative": "La precisión requerida no puede ser negativa",
  "gps.config.validation.accuracy.too.high": "La precisión requerida no puede superar los 10 000 metros",
  "gps.config.validation.timeout.too.high": "El tiempo de espera no puede superar los 120 segundos",
  "gps.config.validation.timeout.too.low": "El tiempo de espera debe ser de al menos 1 segundo",
  "gps.coordinates.captured.via": "Imagen obtenida a través de {method}",
  "gps.coordinates.current": "Coordenadas actuales",
  "gps.error.not.supported": "Este navegador no es compatible con el GPS",
  "gps.error.permission.denied": "El acceso al GPS ha sido denegado. Active los permisos de ubicación e inténtelo de nuevo.",
  "gps.error.position.unavailable": "No se dispone de la posición GPS. Por favor, compruebe la configuración de ubicación de su dispositivo.",
  "gps.error.timeout": "Se ha agotado el tiempo de espera de la solicitud de GPS. Inténtelo de nuevo.",
  "gps.error.title": "Error de GPS",
  "gps.error.unknown": "Se ha producido un error desconocido del GPS. Por favor, inténtelo de nuevo.",
  "gps.info.description": "Las coordenadas GPS registran la ubicación geográfica en la que se recogió la muestra. Esto contribuye a la vigilancia epidemiológica y a la elaboración de mapas de enfermedades.",
  "gps.info.title": "Coordenadas GPS",
  "gps.latitude.helper": "Grados norte (+) o sur (-), entre -90 y 90",
  "gps.latitude.invalid": "La latitud debe estar comprendida entre -90 y 90 grados",
  "gps.latitude.label": "Latitud",
  "gps.latitude.placeholder": "p. ej., -1,286389",
  "gps.longitude.helper": "Grados al este (+) o al oeste (-), entre -180 y 180",
  "gps.longitude.invalid": "La longitud debe estar comprendida entre -180 y 180 grados",
  "gps.longitude.label": "Longitud",
  "gps.longitude.placeholder": "p. ej., 36,817223",
  "gps.manual.entry.off": "Apagado",
  "gps.manual.entry.on": "Encendido",
  "gps.manual.entry.title": "Introduzca las coordenadas manualmente",
  "gps.manual.entry.toggle": "Introducción manual de coordenadas",
  "gps.not.captured": "No se ha registrado",
  "gps.section.description": "Indique la ubicación geográfica en la que se recogió esta muestra con fines de seguimiento epidemiológico",
  "gps.section.title": "Ubicación de la recogida (GPS)",
  "gps.status.captured": "Capturado",
  "gps.status.optional": "Opcional",
  "gps.tile.collapse": "Ocultar la sección de GPS",
  "gps.tile.expand": "Despliegue esta sección para agregar las coordenadas GPS",
  "gps.warning.partial.coordinates": "Para que una ubicación sea válida, deben indicarse tanto la latitud como la longitud.",
  "header.ID": "ID",
  "header.assign": " Asignar",
  "header.cancel.test": " Cancelar prueba",
  "header.formname": " Nombre del formulario",
  "header.icon.help": "Ayuda",
  "header.icon.lang": "Idioma",
  "header.icon.menu.close": "Cerrar menú",
  "header.icon.menu.open": "Abrir menú",
  "header.icon.menu.pin": "Anclar menú",
  "header.icon.menu.unpin": "Desanclar menú",
  "header.icon.notifications": "Notificaciones",
  "header.icon.search": "Buscar",
  "header.icon.user": " Usuario",
  "header.label.ARV": " ARV-Inicial",
  "header.label.EID": " Diagnóstico para niños con DBS-PCR",
  "header.label.changeLab": "Seleccionar laboratorio",
  "header.label.followup": " ARV-Seguimiento",
  "header.label.intialFollowup": " ARV -->Inicial-Seguimiento-VL",
  "header.label.logout": "Cerrar sesión",
  "header.label.nonconformityByDate": " Informe de no conformidad por fecha",
  "header.label.selectLab": "Seleccionar Laboratorio",
  "header.label.selectlocale": "Seleccionar idioma",
  "header.label.specialRequest": " Solicitud especial",
  "header.label.study.ciexport": " Exportar archivo CSV por fecha",
  "header.label.study.vlloadtrends": " Informe de exportación de tendencias de carga viral",
  "header.label.version": "Versión",
  "header.reject": " Rechazar",
  "header.rejection.reason": " Motivo de rechazo",
  "header.results.recorded": " Resultados registrados",
  "hide.aliquoting": "Ocultar el proceso de división en alícuotas",
  "holder.choose.availabletest": " Elegir prueba disponible",
  "home.dashboard.title": "Panel",
  "home.label": "Inicio",
  "immunohistochemistry.label.addreport": "Agregar informe",
  "immunohistochemistry.label.averageChrom": "Promedio de Señales del Cromosoma 17 por núcleo",
  "immunohistochemistry.label.averageHer2": "Promedio de HER2 por núcleo",
  "immunohistochemistry.label.cellIntensity": "Intensidad. Puntuación Allred",
  "immunohistochemistry.label.cellPercent": "Porcentaje de células que muestran tinción nuclear con",
  "immunohistochemistry.label.dashboard": "Tablero de Inmunohistoquímica",
  "immunohistochemistry.label.her2Assesment": "La evaluación de proteína HER 2 es",
  "immunohistochemistry.label.her2Pattern": "Patrón de tinción CerbB2/HER 2",
  "immunohistochemistry.label.her2ScoreOf": "con una puntuación de",
  "immunohistochemistry.label.historicalDiagnosis": "Diagnóstico Histológico",
  "immunohistochemistry.label.ihcRatio": "Proporción de Señales Her2/neu a Cromosoma 17",
  "immunohistochemistry.label.ihcScore": "Puntuación IHC (Cerb2)",
  "immunohistochemistry.label.mibName": "MiB 1(ki-67) (Índice de Proliferación)",
  "immunohistochemistry.label.molecularType": "Subtipo Molecular",
  "immunohistochemistry.label.numberOfCancer": "Número de núcleos cancerosos",
  "immunohistochemistry.label.outOf8": "de 8",
  "immunohistochemistry.label.report": "Informe",
  "immunohistochemistry.label.reports": "Informes",
  "immunohistochemistry.label.review": "En espera de revisión de inmunohistoquímica",
  "immunohistochemistry.label.title": "Inmunohistoquímica",
  "immunohistochemistry.label.tumorCells": "de células tumorales positivas (punto de corte 20%)",
  "immunohistochemistry.status.completed": "Completado",
  "immunohistochemistry.status.inProgress": "En progreso",
  "immunohistochemistry.status.readyPathologist": "Listo para el patólogo",
  "import.autoGenerated": "Generado automáticamente",
  "import.created": "Creado",
  "import.error.failed": "La importación ha fallado",
  "import.error.importFile": "No se ha podido importar el archivo",
  "import.error.selectFile": "Seleccione primero un archivo",
  "import.error.validateFile": "No se ha podido realizar la validación del archivo",
  "import.error.validateFirst": "Por favor, valide primero el archivo y corrija los errores que haya.",
  "import.error.validationFailed": "La validación ha fallado. Por favor, compruebe los errores que se indican a continuación.",
  "import.failed": "Error en la importación",
  "import.failedCount": "Fallido",
  "import.header.collectionDate": "Fecha de recolección",
  "import.header.errorMessage": "Mensaje de error",
  "import.header.field": "Campo",
  "import.header.from": "Desde",
  "import.header.labNo": " Número de laboratorio",
  "import.header.quantity": "Cantidad",
  "import.header.row": "Fila",
  "import.header.sampleType": " Tipo de muestra",
  "import.header.samplesToCreate": "Muestras que debe crear",
  "import.importing": "Importando...",
  "import.invalidRows": "Filas no válidas",
  "import.selectFile": "Seleccione un archivo",
  "import.status.invalid": "No válido",
  "import.status.valid": "Válido",
  "import.success": "Importación realizada con éxito",
  "import.totalRows": "Total de filas",
  "import.totalSamplesToCreate": "Total de muestras que se van a crear",
  "import.uploadFile": "Subir archivo",
  "import.uploadFileDesc": "Subir un archivo CSV o Excel ({types})",
  "import.validRows": "Filas válidas",
  "import.validating": "Validando...",
  "import.validationStatus": "Estado de la validación",
  "input.error.same.panel.type": "Se encontró un tipo de panel existente con el mismo nombre. Por favor cancele o use un nombre diferente.",
  "input.placeholder.labNo": " Ingrese número de laboratorio",
  "input.placeholder.patientFirstName": " Ingrese nombre del paciente",
  "input.placeholder.patientId": " Ingrese ID del paciente",
  "input.placeholder.patientLastName": " Ingrese apellido del paciente",
  "input.placeholder.prevLabNumber": " Ingrese número de laboratorio previo",
  "input.placeholder.providerEmail": " Ingrese correo del solicitante",
  "input.placeholder.providerFax": " Ingrese fax del solicitante",
  "input.placeholder.providerWorkPhone": " Ingrese teléfono del solicitante",
  "input.placeholder.provisionalClinicalDiagnosis": "Introduzca el diagnóstico clínico provisional",
  "input.placeholder.requesterFirstName": " Ingrese nombre del solicitante",
  "input.placeholder.requesterLastName": " Ingrese apellido del solicitante",
  "input.placeholder.searchTestName": "Buscar «testName» aquí",
  "input.placeholder.selectPanel": " Seleccione tipo de panel",
  "input.placeholder.selectPriority": " Seleccione prioridad",
  "input.placeholder.selectTest": "Seleccione tipo de prueba",
  "input.placeholder.selectTestSection": " Seleccione unidad de prueba",
  "instructions.copy.labnum": "Copiar Número de Laboratorio",
  "instructions.order.entry.eqa.enabled": "Cuando se active esta opción, aparecerá una casilla de selección en la pantalla de entrada de órdenes que permitirá al personal marcar una muestra como muestra de evaluación externa de la calidad (ECA). Los datos demográficos del paciente se rellenarán automáticamente con «N/A» y quedarán bloqueados.",
  "instructions.order.entry.requester": "Cuando se activa esta opción, los campos «Buscar solicitante», «Nombre del solicitante» y «Apellido del solicitante» pasan a ser obligatorios en la pantalla «Agregar orden». Cuando se desactiva (configuración predeterminada), los tres campos son opcionales.",
  "instructions.test.activation": "Pruebas Activas: una casilla marcada indica una prueba ya activa. Para activar una prueba, marque la casilla; para desactivar, desmarque la casilla. Cualquier tipo de muestra sin una prueba activa existente se desactiva y aparece al final, bajo 'Tipos de Muestra Inactivos'. Si se activa una de las pruebas, el tipo de muestra se activará.",
  "instructions.test.activation.confirm": "Verifique que estos sean los cambios que desea realizar. Si son correctos, guarde. Si no son correctos, use el botón de retroceso para hacer los cambios correctos",
  "instructions.test.activation.sort": "Orden de Visualización: Listas de tipos de muestra que tienen pruebas recién activadas. Ordene las pruebas para indicar cómo se mostrarán en la pantalla de entrada de pedidos. El orden se puede hacer arrastrando elementos a la posición deseada.",
  "instructions.test.order": "Las pruebas con marcas son ordenables, aquellas sin marcas no lo son. Cambie las marcas para cambiar el estado. Para que una prueba pueda solicitarse en la admisión, debe estar activa y ser ordenable. Las pruebas que están activas pero no son ordenables solo pueden solicitarse como parte de un reflejo de prueba.",
  "invalid.json": " JSON no válido",
  "inventory.add.button": "Agregar un nuevo lote",
  "inventory.addItem.button": "Agregar elemento al catálogo",
  "inventory.consume.error.noLots": "No hay stock disponible para {name} ({code})",
  "inventory.consume.error.noLotsAwaitingQc": "No hay stock con CC aprobado para {name} ({code}): {count} lote(s) con stock están pendientes de CC. Marque el CC como aprobado para utilizarlos.",
  "inventory.consume.error.noLotsQcFailed": "No hay stock utilizable para {name} ({code}): {count} lote(s) con stock no superaron el control de calidad",
  "inventory.consume.error.noLotsQuarantined": "No usable stock for {name} ({code}): {count} lot(s) with stock are quarantined",
  "inventory.dashboard.title": "Panel de inventario",
  "inventory.export.button": " Exportar",
  "inventory.filter.all": "Todos",
  "inventory.filter.status": "Filtrar por estado",
  "inventory.item.error.duplicateCode": "Ya existe un ítem de inventario con el código \"{code}\".",
  "inventory.item.error.codeGenerationExhausted": "No se pudo encontrar un código libre para el prefijo \"{prefix}\". Ingrese un código manualmente.",
  "inventory.list.title": "Ítems de inventario",
  "inventory.lot.error.duplicateBarcode": "El código de barras \"{barcode}\" ya está asignado al lote {lotNumber}",
  "inventory.lot.search.placeholder": "Buscar por nombre de ítem, número de lote o código de barras",
  "inventory.metrics.expired": "Caducado",
  "inventory.metrics.expiringSoon": "Caduca en breve",
  "inventory.metrics.lowStock": "Existencias escasas",
  "inventory.metrics.totalLots": "Total de lotes",
  "inventory.tab.catalog": "Catálogo",
  "inventory.tab.dashboard": "Panel",
  "inventory.tab.reports": "Informes",
  "inventory.title": "Gestión de existencias",
  "label.action": " Acción",
  "labNumber.format.current": "Formato Actual",
  "labNumber.format.new": "Nuevo Formato",
  "labNumber.prefix": "Prefijo",
  "labNumber.type": "Tipo de Número de Laboratorio",
  "labNumber.usePrefix": "Usar Prefijo",
  "label.actions": "Acciones",
  "label.active": "Activo",
  "label.actualTestName": " Nombre real de la prueba",
  "label.add": "Agregar",
  "label.add.notification": " Agregar notificación emergente al usuario",
  "label.all": "Todos",
  "label.analysisNotStarted": "Análisis no iniciado",
  "label.any": " Cualquiera",
  "label.audittrail": " Número de laboratorio",
  "label.audittrail.Reports": "Informes de auditoría",
  "label.audittrail.labNo.invalidaccessionnumber": " Número de acceso inválido",
  "label.audittrail.labNo.missing": " ¡El número de laboratorio es obligatorio!",
  "label.audittrailreport.nextvisitdate": " Fecha de próxima visita",
  "label.audittrailreport.priority": " Prioridad",
  "label.audittrailreport.program": " Programa",
  "label.audittrailreport.receiveddate": "Fecha de recepción",
  "label.audittrailreport.requestdate": " Fecha de solicitud",
  "label.audittrailreport.requester": " Solicitante",
  "label.audittrailreport.requester.firstname": " Nombre del solicitante",
  "label.audittrailreport.requester.lastname": " Apellido del solicitante",
  "label.audittrailreport.sitename": " Nombre del sitio",
  "label.autoFilledFromServer": "Rellenado automáticamente desde el servidor",
  "label.barcode": " Código de barras",
  "label.barcode.labelsets": " Número de juegos de etiquetas",
  "label.barcode.orderlabel": " Número de etiquetas de orden por juego",
  "label.barcode.specimenlabel": " Número de etiquetas de muestra por juego",
  "label.barcode.totallabel": " Total de etiquetas para imprimir",
  "label.button.action": " Acción",
  "label.button.add": "Agregar",
  "label.button.add.question": "Agregar nueva pregunta",
  "label.button.cancel": "Cancelar",
  "label.button.close": "Cerrar",
  "label.button.changepassword": "Cambiar contraseña",
  "label.button.clear": "Limpiar",
  "label.button.confirm": "Confirmar",
  "label.button.confirmAction": "Confirmar acción",
  "label.button.confirmDelete": "Confirmar eliminación",
  "label.button.confirmTitle": "¿Estás seguro?",
  "label.button.delete": "Eliminar",
  "label.button.descritpion": "Descripción",
  "label.button.edit": "Editar",
  "label.button.activate": "Activar",
  "label.button.deactivate": "Desactivar",
  "label.button.exit": "Salir",
  "label.button.externalsearch": "Búsqueda externa",
  "label.button.field": "Campo",
  "label.button.finish": "Finalizar",
  "label.button.finished": "Finalizado",
  "label.button.generatePrintableVersion": "Generar versión imprimible",
  "label.button.import": "Importar",
  "label.button.login": "Iniciar Sesión",
  "label.button.login.sso": "Inicio de Sesión Único",
  "label.button.newEntry": "Nueva entrada",
  "label.button.ok": "Aceptar",
  "label.button.previous": "Anterior",
  "label.button.range": "Rango",
  "label.button.remove": "Eliminar",
  "label.button.remove.report": "Remover Reporte",
  "label.button.remove.slide": "Remover Lámina",
  "label.button.reset": "Restablecer",
  "label.button.sample": "Muestra",
  "label.button.save": "Guardar",
  "label.button.saveconfig": "Guardar configuración",
  "label.button.search": "Buscar",
  "label.button.select": "Seleccionar",
  "label.button.select.pathologist": "Seleccionar patólogo",
  "label.button.select.status": "Seleccionar estado",
  "label.button.select.technician": "Seleccionar técnico",
  "label.button.select.test": "Seleccionar prueba",
  "label.button.start": "Iniciar",
  "label.button.submit": "Enviar",
  "label.button.update": "Actualizar",
  "label.button.uploadfile": "Subir archivo",
  "label.button.validate": "Validar",
  "label.button.viewReport": "Ver informe",
  "label.cancel": "Cancelar",
  "label.cancel.test.no.replace": "Cancelar prueba para los números de laboratorio seleccionados, no asignar una nueva prueba",
  "label.checkedWillBeModified": "Los números de laboratorio marcados serán modificados",
  "label.clear": "Limpiar filtros",
  "label.content": "Contenido de la etiqueta",
  "label.confirm": "Confirmar",
  "label.created.samples": "Muestras creadas",
  "label.critical.range": "Rango crítico",
  "label.currentTest": "Prueba actual",
  "label.days": "días",
  "label.default.result": "Resultado predeterminado",
  "label.delete": "Eliminar",
  "label.description": "Descripción",
  "label.edit": "Editar",
  "label.electronic.orders": "Órdenes electrónicas",
  "label.equals": " igual a",
  "label.error": "Error",
  "label.existing.methods": "Métodos existentes",
  "label.existing.test.sets": "Conjuntos de pruebas existentes",
  "label.filters.mycases": " Mis casos",
  "label.filters.status": "Estado",
  "label.field.required": "Este campo es obligatorio",
  "label.status": "Estado",
  "label.form.searchby": "Buscar por",
  "label.id": "ID",
  "label.import.errors": "Errores de importación",
  "label.inactive": "Inactivo",
  "label.inactive.methods": "Métodos inactivos. Asignar pruebas para activar.",
  "label.includeInactiveTests": "Incluir pruebas inactivas",
  "label.inside.normalrange": " está dentro del rango normal",
  "label.lastPrinted": "Última impresión: {date} {time} por {user}",
  "label.loading": "Cargando",
  "label.required": "obligatorio",
  "label.loinc": "LOINC",
  "label.management.title": "Gestión de etiquetas",
  "label.no": "No",
  "label.no.options.available": "No hay opciones disponibles",
  "label.none": "Ninguno (sin filtro)",
  "label.notValidated": "No validado",
  "label.notequals": " no es igual a",
  "label.order.labNrPrefix": "Número de laboratorio",
  "label.order.patientPrefix": "Paciente",
  "label.order.scan.text": "Escanear O Ingresar Manualmente O",
  "label.orderable": "Ordenable",
  "label.outside.normalrange": " está fuera del rango normal",
  "label.page.patientHistory": "Historial del paciente",
  "label.preview.data": "Datos de vista previa",
  "label.print": "Imprimir etiqueta",
  "label.print.error": "Se ha producido un error al generar la etiqueta. Inténtelo de nuevo.",
  "label.print.error.popupBlocked": "Se ha bloqueado una ventana emergente. Por favor, permita las ventanas emergentes en este sitio web para poder imprimir etiquetas.",
  "label.print.openDirectly": "Abrir las etiquetas en una pestaña nueva",
  "label.print.generating": "Generando...",
  "label.print.success": "La etiqueta se ha impreso correctamente",
  "label.print.description": "Imprimir etiquetas para órdenes y muestras",
  "label.print.helper": "Seleccione el tipo y la cantidad de etiquetas que desea imprimir",
  "label.print.success.count": "Se han impreso correctamente {count} etiquetas",
  "label.print.title": "Imprimir etiquetas",
  "label.printAll": "Imprimir todas las etiquetas",
  "label.printAll.success": "Todas las etiquetas se han impreso correctamente",
  "label.printConfirmation.message": "¿Imprimir la etiqueta de {name}{code}?",
  "label.printConfirmation.title": "Imprimir etiqueta",
  "label.printHistory": "Historial de impresiones",
  "label.printHistory.byUser": "Por {user}",
  "label.printHistory.count": "{count} etiquetas",
  "label.printHistory.loading": "Cargando el historial de impresión...",
  "label.printHistory.never": "Nunca se ha impreso",
  "label.printHistory.unknownUser": "Desconocido",
  "label.printHistory.viewAll": "Consultar historial",
  "label.printLabel": "Imprimir etiqueta",
  "label.program": "Programa",
  "label.qualifiers": "Calificadores",
  "label.quantity": "Cantidad",
  "label.readonly": "Solo lectura",
  "label.reference.value": "Valor de referencia",
  "label.refertest.referencelab": " Enviar prueba a un laboratorio de referencia",
  "label.rejectedByBiologist": "Rechazado por biólogo",
  "label.rejectedByTechnician": "Rechazado por técnico",
  "label.remove": "Eliminar",
  "label.replaceWith": "Reemplazar con",
  "label.report.byNationalId": "Por ID nacional / Número de identificación de salud único",
  "label.reporting.range": "Rango de informe",
  "label.result.order": "Orden de resultados",
  "label.resultSelectList": "Lista de selección de resultados",
  "label.results.actions": "Acciones",
  "label.results.anotherUser": "otro usuario",
  "label.results.date": "Fecha de prueba",
  "label.results.domain": "Clínico",
  "label.results.domain.env": "Calidad del agua",
  "label.results.domain.vector": "Vigilancia de vectores",
  "label.results.edit": "Editar",
  "label.results.inReviewBy": "En proceso de revisión por parte de {0}",
  "label.results.labUnit": "Unidad de laboratorio",
  "label.results.load": "Cargar resultados",
  "label.results.loading": "Loading results...",
  "label.results.range": "Rango de referencia",
  "label.results.range.env": "Límite reglamentario",
  "label.results.range.vector": "Interpretación",
  "label.results.reflexTriggered": "Se han agregado pruebas reflejas y calculadas para:",
  "label.results.refresh": "Actualizar",
  "label.results.result": "Resultado",
  "label.results.resultFor": "Resultado para «{0}»",
  "label.results.retry": "Inténtelo de nuevo",
  "label.results.save": "Guardar",
  "label.results.search": "Buscar por número de laboratorio",
  "label.results.searchByPatient": "Buscar por paciente",
  "label.results.selectAnotherPatient": "Seleccione otro paciente",
  "label.results.selectedPatient": "Paciente seleccionado",
  "label.results.selectedPatient.none": "Ninguno",
  "label.results.status": "Estado",
  "label.results.status.all": "Todos",
  "label.results.subject": "Muestra / Paciente",
  "label.results.subject.env": "Muestra / Sitio",
  "label.results.subject.vector": "Muestra / Trampa",
  "label.results.table.caption": "Lista de trabajo de resultados",
  "label.results.test": "Prueba",
  "label.results.titer.placeholder": "p. ej., 1:10",
  "label.results.method": "Método",
  "label.results.analyzer": "Analizador",
  "label.results.analyzer.none": "No procede de un instrumento",
  "label.results.fromAnalyzer": "desde el Analizador",
  "label.results.methodAnalyzerHint": "«Método» se refiere al tipo de Analizador; «Analizador» se refiere al instrumento concreto.",
  "label.results.expandRow": "Desplegar fila",
  "label.results.collapseRow": "Ocultar fila",
  "label.results.referredOut": "Referido",
  "label.results.notes": "Notas",
  "label.results.note.context": "Contexto",
  "label.results.note.context.entry": "Entrada",
  "label.results.note.context.modification": "Modificación",
  "label.results.note.context.auto": "Se ajusta automáticamente desde lo que esté haciendo.",
  "label.results.note.visibility": "Visibilidad",
  "label.results.note.internal": "Solo en Laboratorio",
  "label.results.note.external": "Enviar con el resultado",
  "label.results.note.analysisLevel": "Nivel de análisis",
  "label.results.note.externalWarning": "Esta nota aparecerá en el informe del paciente.",
  "label.results.note.placeholder": "Agregue una nota…",
  "label.results.dilution.measured": "Valor medido",
  "label.results.dilution.factor": "Factor de dilución",
  "label.results.dilution.reported": "Valor comunicado: {0}",
  "label.results.saveHint": "Al guardar, se registra su firma electrónica. La confirmación de valores críticos nunca bloquea el guardado.",
  "label.results.flag.normal": "Normal",
  "label.results.flag.abnormal": "Anormal",
  "label.results.flag.critical": "Crítico",
  "label.results.flag.invalid": "No válido",
  "label.results.sample": "Muestra",
  "label.results.flag": "Bandera",
  "label.results.order.clinician": "Médico que solicita la prueba",
  "label.results.order.phone": "Teléfono",
  "label.results.order.site": "Sitio solicitante",
  "label.results.order.priority": " Prioridad",
  "label.results.order.collection": "Recolección",
  "label.results.section.program": "Información sobre el programa",
  "label.results.program.name": " Programa",
  "label.results.program.eqa": "EQA",
  "label.results.program.readonly": "Los campos del programa son de solo lectura aquí; edítelos en la orden original.",
  "label.results.section.storage": "Almacenamiento y eliminación de muestras",
  "label.results.storage.location": "Ubicación",
  "label.results.storage.position": "Posición",
  "label.results.storage.notes": "Notas",
  "label.results.storage.unassigned": "No hay asignación de almacenamiento",
  "label.results.storage.assignLocation": "Asignar ubicación",
  "label.results.storage.moveLocation": "Mover a la ubicación",
  "label.results.program.capturedData": "Datos del programa",
  "label.results.sampleStatus.title": "Estado de la muestra",
  "label.results.sampleStatus.volume": "Volumen: quedan {0} de {1} · estado {2}.",
  "label.results.sampleStatus.noVolume": "Estado {0}.",
  "label.results.sampleStatus.available": "disponible",
  "label.results.sampleStatus.usedUp": "agotado (consumido)",
  "label.results.sampleStatus.disposed": "eliminado",
  "label.results.sampleStatus.recordUse": "Registrar cantidad utilizada",
  "label.results.sampleStatus.markUsedUp": "Marcar como agotado",
  "label.results.sampleStatus.startDisposal": "Iniciar la eliminación",
  "label.results.sampleStatus.amountUsed": "Cantidad utilizada en esta prueba",
  "label.results.sampleStatus.record": "Registrar",
  "label.results.sampleStatus.recordHint": "Disminuye el volumen restante: la muestra no se desecha hasta que se agote o se marque explícitamente como agotada.",
  "label.results.sampleStatus.usedUpNote": "La muestra se ha agotado y se ha incorporado a la cola del proceso de eliminación. En el registro de eliminación se indica quién, cuándo y el método utilizado.",
  "label.results.sampleStatus.disposalReason": "Motivo de eliminación",
  "label.results.sampleStatus.disposalMethod": "Método de eliminación",
  "label.results.sampleStatus.disposalNotes": "Notas",
  "label.results.sampleStatus.confirmDisposal": "Confirmar la eliminación",
  "label.results.sampleStatus.updateFailed": "The sample status was not updated because the server did not respond. Check the connection and try again.",
  "label.results.sampleStatus.reason.expired": "Caducado",
  "label.results.sampleStatus.reason.contaminated": "Contaminado",
  "label.results.sampleStatus.reason.patient_request": "Solicitud del paciente",
  "label.results.sampleStatus.reason.testing_complete": "Prueba completada",
  "label.results.sampleStatus.reason.other": "Otro",
  "label.results.sampleStatus.method.autoclave": "Autoclave para residuos biológicos peligrosos",
  "label.results.sampleStatus.method.neutralization": "Neutralización química",
  "label.results.sampleStatus.method.incineration": "Incineración",
  "label.results.sampleStatus.method.other": "Otro",
  "label.results.sampleStatus.footnote": "El uso parcial registra la cantidad consumida en relación con el volumen restante del elemento de muestra; el agotamiento total (o «Marcar como agotado») activa la eliminación.",
  "label.results.section.reagents": "Reactivos, CC y controles",
  "label.results.reagents.summary.analyzer": "lote indicado por el Analizador",
  "label.results.reagents.summary.manual": "captura manual",
  "label.results.reagents.mode.analyzer": "modo de captura: según el Analizador",
  "label.results.reagents.mode.manual": "modo de captura: manual (opcional)",
  "label.results.reagents.analyzerNote": "Informado por {0} en su carga útil de resultados — solo lectura.",
  "label.results.reagents.lotsUsed": "Lotes de reactivos utilizados",
  "label.results.reagents.noneLinked": "No hay reactivos asociados a esta prueba; los enlaces se configuran en el Catálogo de pruebas.",
  "label.results.reagents.noLots": "No hay lotes disponibles en stock para este reactivo.",
  "label.results.reagents.perTest": "{0} {1} por prueba",
  "label.results.reagents.fefo": "Se recomienda el método FEFO",
  "label.results.reagents.expires": "Exp {0} ·",
  "label.results.reagents.remaining": "{0} {1} restante",
  "label.results.reagents.quantityUsed": "Cantidad utilizada",
  "label.results.reagents.recordUse": "Registrar uso",
  "label.results.reagents.recorded": "Se registraron {0} {1}; consumo FEFO distribuido entre los lotes.",
  "label.results.reagents.recordFailed": "No se ha podido registrar el uso de reactivos.",
  "label.results.reagents.amountInvalid": "La cantidad utilizada debe ser un número positivo.",
  "label.results.reagents.consumeNote": "Al registrar el uso, se reduce el stock (FEFO) y se registra una operación de consumo vinculada a este análisis.",
  "label.results.control.title": "Resultado del control",
  "label.results.control.noneConfigured": "No se han configurado lotes de control para esta prueba y este Analizador.",
  "label.results.control.viewResults": "Consultar los resultados del control",
  "label.results.control.capture.controlLine": "Control line",
  "label.results.control.capture.valid": "Válido",
  "label.results.control.capture.invalid": "No válido",
  "label.results.control.capture.kitLot": "Kit lot",
  "label.results.control.capture.outcome": "Resultado",
  "label.results.control.capture.lot": "Lote de control",
  "label.results.control.capture.measured": "Valor medido",
  "label.results.control.capture.expected": "Valor esperado",
  "label.results.control.capture.uncertainty": "Incertidumbre (±)",
  "label.results.control.capture.record": "Record control result",
  "label.results.control.capture.recorded": "Control result recorded.",
  "label.results.control.capture.recordedBlocked": "Control result recorded. Reporting is blocked for covered results until a passing repeat is recorded.",
  "label.results.control.capture.blockedHint": "A failing control blocks reporting for covered results — a repeat run is expected.",
  "label.results.control.capture.noBenchLots": "No bench control lot is configured for this test — add one under QC → Control Lots before recording a quantitative control.",
  "label.results.control.capture.incomplete": "Complete the control result fields before recording.",
  "label.results.control.capture.failed": "Recording the control result failed.",
  "label.results.dilution.title": "Dilución",
  "label.results.section.attachments": "Archivos adjuntos",
  "label.results.attachments.summary": "{0} archivo(s)",
  "label.results.attachments.none": "ninguno",
  "label.results.attachments.empty": "Aún no hay archivos adjuntos en esta orden.",
  "label.results.attachments.add": "Agregar archivo adjunto",
  "label.results.attachments.tooLarge": "El archivo supera el límite de 10 MB.",
  "label.results.attachments.uploadFailed": "Error al cargar el archivo: PDF, JPG, PNG o TIFF de hasta 10 MB.",
  "label.results.attachments.resultsScope": "Resultados",
  "label.results.attachments.orderScope": "Entrada de órdenes",
  "label.results.attachments.view": "Consultar",
  "label.results.attachments.download": "Descargar",
  "label.results.section.interpretation": "Interpretación",
  "label.results.interpretation.summary": "introduzca el texto mediante una regla o de forma libre",
  "label.results.interpretation.ruleFired": "regla activada ({0}) · apertura automática",
  "label.results.interpretation.autoOpen": "regla activada · apertura automática",
  "label.results.interpretation.ruleBanner": "Coincidencia con la regla (configurada en la prueba): el valor introducido, «{0}», se encuentra dentro de «{1}». Elija una categoría para aplicar su texto de interpretación y, a continuación, edítelo según sea necesario.",
  "label.results.interpretation.match": "coincide con el valor",
  "label.results.interpretation.freeText": "Interpretación (texto libre)",
  "label.results.interpretation.footnote": "La interpretación puede establecerse mediante una regla configurada en la prueba (los grupos categóricos, que se asocian automáticamente al valor) o mediante texto libre. El texto de la regla es una sugerencia no vinculante hasta que se aplique o se edite. Al guardarlo, se envía junto con el resultado al informe.",
  "label.results.nce.disposition": "Disposición de los resultados",
  "label.results.nce.disposition.hint": "Se aplica en el momento de enviar el NCE. La derivación a otro servicio es una acción que se realiza en una línea aparte, no una resolución.",
  "label.results.nce.disposition.none": "Ninguno",
  "label.results.nce.disposition.none.detail": "Presente el NCE sin modificar el resultado.",
  "label.results.nce.disposition.cancel": "Cancelar el resultado",
  "label.results.nce.disposition.cancel.detail": "Anulado. No se ha indicado ningún valor. Es habitual en los NCE preanalíticos.",
  "label.results.nce.disposition.reject": "Rechazar + motivo",
  "label.results.nce.disposition.reject.detail": "Limpia el valor y registra el motivo. Se aplica al guardar su firma electrónica.",
  "label.results.nce.disposition.retest": "Repetir Prueba",
  "label.results.nce.disposition.retest.detail": "Ordena que se vuelva a realizar la misma prueba con esta muestra; la repetición aparece como pendiente.",
  "label.results.nce.disposition.rejectArmed": "Rechazo activado en la fila: guarde (firma electrónica) para aplicarlo.",
  "label.results.nce.disposition.cancelled": "Resultado anulado.",
  "label.results.nce.disposition.retested": "Se ha solicitado una repetición de la prueba.",
  "label.results.critical.range": "Crítico",
  "label.results.critical.banner.title": "Valor crítico: se requiere la notificación al médico",
  "label.results.critical.banner.notify": "The responsible clinician must be notified. Record that on the Alerts dashboard and log the call below.",
  "label.results.critical.acknowledge": "Reconozco",
  "label.results.critical.acknowledged": "Reconocido",
  "label.results.critical.comment": "Comentario de reconocimiento",
  "label.results.critical.comment.placeholder": "Por ejemplo: se ha informado al médico por teléfono",
  "label.results.section.history": "Historial (este análisis)",
  "label.results.history.summary": "{0} eventos",
  "label.results.history.summary.unloaded": "revisiones · estado · repeticiones",
  "label.results.history.when": "Cuando",
  "label.results.history.event": "Evento",
  "label.results.history.detail": "Detalle",
  "label.results.history.by": "Por",
  "label.results.history.event.CREATED": "Creado",
  "label.results.history.event.STATUS": "Estado",
  "label.results.history.event.RESULT": "Resultado",
  "label.results.history.event.NOTE": " Nota",
  "label.results.history.event.RETEST": "Repetir Prueba",
  "label.results.history.event.REFLEX": "Refleja",
  "label.results.history.event.OTHER": "Evento",
  "label.results.history.empty": "Aún no se han registrado eventos para este análisis.",
  "label.results.history.footnote": "Este análisis incluye únicamente: revisiones, cambios de estado, repeticiones de pruebas, correcciones, notas y entradas de auditoría. Las tendencias de los pacientes se recogen en la historia clínica; las reglas de Westgard, en el panel de CC.",
  "label.results.nce.report": "Reportar no conformidad",
  "label.results.reject.result": "Rechazar el resultado",
  "label.results.reject.reason": "Motivo de rechazo",
  "label.results.reject.hint": "Al guardar con un rechazo, se limpia el valor, se registra el motivo y se marca el análisis como «Rechazado técnicamente».",
  "label.results.referral.refer": "Referir esta prueba",
  "label.results.referral.editing": "Referencia pendiente: editar",
  "label.results.referral.organization": "Laboratorio de referencia",
  "label.results.referral.reason": "Motivo de referencia",
  "label.results.referral.date": "Fecha de referencia",
  "label.results.referral.reportDate": "Reference lab report date",
  "label.results.referral.hint": "La referencia queda registrada cuando guarde esta fila y se transfiere al Panel de Referencias.",
  "label.results.referral.cancel": "Descartar",
  "label.results.referral.incomplete": "Choose the reference laboratory and the referral reason, or discard the referral, before saving this row.",
  "label.results.section.aliquots": "Alícuotas",
  "label.results.aliquots.summary": "{0} alícuotas",
  "label.results.aliquots.summary.unloaded": "lista · crear",
  "label.results.aliquots.labNo": " Número de laboratorio",
  "label.results.aliquots.quantity": "Cantidad",
  "label.results.aliquots.createdDate": "Creado",
  "label.results.aliquots.empty": "Aún no hay alícuotas para este elemento de la muestra.",
  "label.results.aliquots.count": "Número de alícuotas",
  "label.results.aliquots.totalQuantity": "Cantidad total a transferir",
  "label.results.aliquots.notes": "Notas",
  "label.results.aliquots.create": "Preparar alícuotas",
  "label.results.aliquots.created": "Se han creado las alícuotas.",
  "label.results.aliquots.failed": "No se han podido crear alícuotas.",
  "label.results.aliquots.remaining": "Cantidad restante del elemento principal",
  "label.results.history.event.REFERRAL": "Remitido",
  "label.results.history.event.NCE": "No conformidad",
  "label.results.history.event.CRITICAL_ACK": "Critical acknowledged",
  "label.results.history.event.INVALID_CONFIRMED": "Outside valid range confirmed",
  "label.results.alert.critical.title": "Critical result",
  "label.results.alert.critical.defaultMessage": "This is a critical result. Notify the responsible clinician according to your laboratory procedure.",
  "label.results.alert.invalid.title": "Value outside the valid range",
  "label.results.alert.invalid.body": "This value is outside the valid range for this test ({low} to {high}). Check it before saving.",
  "label.results.alert.correct": "Correct the value",
  "label.results.alert.keepValue": "Keep this value",
  "label.results.alert.confirmAndSave": "Confirm and save",
  "label.results.alert.acknowledgeAndSave": "Acknowledge and save",
  "label.results.callback.logged": "Callback logged",
  "label.results.referenceZone": "Referencia y contexto",
  "label.results.layoutRemembered": "Se guarda la disposición",
  "label.results.resetLayout": "Restablecer diseño",
  "label.results.section.orderInfo": "Información de la orden",
  "label.results.sampleType": "Tipo de muestra",
  "label.results.testDate": "Fecha de prueba",
  "label.results.receivedDate": "Recibido",
  "label.results.technician": "Técnico",
  "label.routine.Reports": "Informes rutinarios",
  "label.sample.types.activate": "Los siguientes tipos de muestra se activarán:",
  "label.sample.types.deactivate": "Los siguientes tipos de muestra se desactivarán porque no tienen pruebas:",
  "label.save": "Guardar",
  "label.saving": "Guardando...",
  "label.search.available.targetest": " Buscar pruebas disponibles",
  "label.search.availablepanel": " Buscar panel disponible",
  "label.search.labno.family": " Buscar por número de laboratorio o apellido",
  "label.search.patient": "Buscar Paciente",
  "label.select": "Seleccionar",
  "label.select.dateRange": " Seleccionar el rango de fechas para el informe",
  "label.select.list.options": "Opciones de lista de selección",
  "label.selectTestSectionCatalog": "Seleccionar sección de prueba para ver el catálogo de esa sección",
  "label.sex.dependent": "Dependiente del sexo",
  "label.shortCode": "Código corto",
  "label.shortCode.error.invalidChars": "Un código corto solo puede contener letras, números, guiones y guiones bajos",
  "label.shortCode.error.maxLength": "El código corto debe tener 10 caracteres como máximo",
  "label.shortCode.error.network": "No se ha podido verificar la unicidad. Por favor, compruébelo manualmente.",
  "label.shortCode.error.save": "Error al guardar el código abreviado: {error}",
  "label.shortCode.error.startChar": "El código corto debe iniciar con una letra o un número",
  "label.shortCode.helper": "Máximo 10 caracteres: alfabéticos, numéricos, guiones y guiones bajos",
  "label.shortCode.optional.helper": "Opcional (el código se utilizará si tiene ≤10 caracteres). Máximo 10 caracteres, alfanuméricos con guiones o guiones bajos",
  "label.shortCode.required.helper": "Es obligatorio cuando el código tiene más de 10 caracteres. Máximo 10 caracteres, alfanuméricos con guiones o guiones bajos.",
  "label.shortCode.update.success": "El código corto se ha actualizado correctamente",
  "label.shortCodeRequired": "Se requiere un código abreviado para la impresión de etiquetas. Por favor, configure primero el código abreviado en el formulario «Editar».",
  "label.shortCodeWarning": "Si cambia el código corto, las etiquetas existentes dejarán de ser válidas.",
  "label.showChildren": "Mostrar Elementos Hijos",
  "label.study.Reports": "Informes de estudio",
  "label.test.name": " Nombre de la prueba",
  "label.test.activate": "Las siguientes pruebas se activarán:",
  "label.test.add": " Agregar prueba a la orden",
  "label.test.batch.cancel.finish": "Esto es irreversible.",
  "label.test.batch.cancel.start": "Has seleccionado cancelar la prueba",
  "label.test.batch.no.change.finish": "pruebas no serán cambiadas.",
  "label.test.batch.replace.start": "Los siguientes",
  "label.test.deactivate": "Las siguientes pruebas se desactivarán:",
  "label.test.display.order": "Orden de visualización de pruebas",
  "label.test.order.confirm": "Verificar: Habilitar/deshabilitar capacidad de ordenar prueba",
  "label.test.activation.confirm": "Verify: Activate/deactivate tests",
  "label.test.orderable": "Las siguientes pruebas podrán solicitarse desde el formulario de pedido.",
  "label.test.results": " Resultados de prueba",
  "label.test.resultsData": " Datos de resultados de prueba",
  "label.test.unorderable": "Las siguientes pruebas no podrán solicitarse en el formulario de pedido. Solo podrán solicitarse como prueba reflejada.",
  "label.testActivate": "Activación de Prueba",
  "label.testName": "Nombres de pruebas",
  "label.text.generate": "generar",
  "label.total.tests": "Total de Pruebas",
  "label.type": "Tipo de etiqueta",
  "label.type.order": "Etiqueta de orden",
  "label.type.pool": "Grupo de {count} {animal}",
  "label.type.sample": "Etiqueta de muestra",
  "label.unit": "Unidad",
  "label.user.notestsection": " El usuario actual no tiene una unidad de laboratorio asignada. Por favor contacte al administrador",
  "label.validation.errors": "Errores de validación",
  "label.validation.results": "Resultados de la validación",
  "label.view": "Consultar",
  "label.viewtestCatalog": "Catálogo de pruebas",
  "label.warning": "Advertencia",
  "label.yes": "Sí",
  "labno.alt.prefix.instruction": "Prefijo para etiquetas de código de barras preimpresas (4 caracteres):",
  "labno.alt.prefix.note": " NOTA: Si este prefijo ya ha sido utilizado, la numeración continuará desde el último número generado.",
  "labno.alt.prefix.use": "Utilice el mismo formato de número de acceso y grupo de números disponibles que en la generación de órdenes.",
  "language.select.label": "Español",
  "legend.search.availabletests": " Buscar entre las pruebas disponibles",
  "loading": "Cargando",
  "loading.boxes": "Cargando cajas...",
  "loading.description": "Cargando",
  "location.collection.title": "Ubicación de recogida",
  "location.environmentalConditions": "Condiciones ambientales",
  "location.environmentalConditions.placeholder": "p. ej., 25 °C, cielo despejado",
  "location.gps.error": "No se ha podido obtener la ubicación",
  "location.gps.getCurrent": "Obtener la ubicación actual",
  "location.gps.getting": "Obteniendo la ubicación...",
  "location.gps.latitude": "Latitud GPS",
  "location.gps.longitude": "Longitud GPS",
  "location.gps.notSupported": "Su navegador no admite la geolocalización",
  "location.gps.permissionDenied": "Se ha denegado el permiso de ubicación",
  "location.gps.timeout": "Se ha agotado el tiempo de espera de la solicitud de ubicación",
  "location.gps.unavailable": "No hay información disponible sobre la ubicación",
  "location.helper": "La jerarquía de ubicaciones (Región / Distrito / Ciudad) utiliza el sistema existente de estructura de ubicaciones. Los perfiles de flujo de trabajo medioambiental permiten que algunas filas no estén etiquetadas, con el fin de ofrecer conjuntos de filas más sencillos o más breves para su configuración, según sea necesario.",
  "location.requesterReference": "Referencia del solicitante",
  "location.requesterReference.placeholder": "p. ej., método 524.2 de la EPA",
  "location.select.placeholder": "Seleccionar «{levelName}»...",
  "location.siteDescription": "Descripción del punto de recogida",
  "location.siteDescription.placeholder": "p. ej., punto de captación del suministro municipal de agua",
  "locale.active": "Activo",
  "locale.add": "Agregar idioma",
  "locale.add.title": "Agregar idioma",
  "locale.code": "Código de configuración regional",
  "locale.code.helper": "p. ej., en, fr, es, pt",
  "locale.create.success": "El idioma se ha creado correctamente",
  "locale.delete.confirm.message": "¿Está seguro de que desea eliminar este idioma? Esta acción no se puede deshacer.",
  "locale.delete.confirm.title": "Eliminar idioma",
  "locale.delete.error": "No se ha podido eliminar el idioma",
  "locale.delete.fallback.error": "No es posible eliminar el idioma de reserva. Establezca primero otro idioma como idioma de reserva.",
  "locale.delete.success": "El idioma se ha eliminado correctamente",
  "locale.displayName": "Nombre para mostrar",
  "locale.displayName.helper": "p. ej., English, Français, Español",
  "locale.edit.title": "Editar idioma",
  "locale.fallback": "Reserva",
  "locale.fallback.error": "No se ha podido configurar el idioma de reserva",
  "locale.fallback.success": "Se ha actualizado el idioma de reserva",
  "locale.management.description": "Gestione los idiomas admitidos para las traducciones de metadatos.",
  "locale.management.title": "Gestión de idiomas",
  "locale.setFallback": "Establecer como idioma de reserva",
  "locale.sortOrder": "Orden de clasificación",
  "locale.status": "Estado",
  "locale.update.success": "El idioma se ha actualizado correctamente",
  "log.submitting.aliquot.data": "Envío de datos de alícuotas:",
  "log.submitting.aliquot.data2": "Envío de datos de alícuotas (JSON):",
  "logging.management.apply": "Aplicar nivel de registro",
  "logging.management.description": "Modifique el nivel de registro del backend en tiempo de ejecución. Esto resulta útil para depurar problemas sin necesidad de reiniciar el servidor. Los cambios surten efecto de inmediato, pero no se conservan tras reiniciar el servidor.",
  "logging.management.label": "Configuración del registro",
  "logging.management.level": "Nivel de registro",
  "logging.management.logger": "Nombre del registrador",
  "logging.management.logger.helper": "p. ej., org.openelisglobal, root",
  "logging.management.success": "El nivel de registro se ha establecido en «{level}» para «{logger}»",
  "login.account.disabled": "Cuenta Deshabilitada",
  "login.account.locked": "Cuenta Bloqueada",
  "login.complexity.message": "La contraseña debe:",
  "login.complexity.message.1": "Debe tener al menos 7 caracteres",
  "login.complexity.message.2": "Puede contener letras mayúsculas y minúsculas o números",
  "login.complexity.message.3": "Debe contener al menos uno de los siguientes caracteres: *, $, #, !",
  "login.complexity.message.4": "No debe contener ningún otro carácter",
  "login.complexity.new.message": "La nueva contraseña debe:",
  "login.complexity.new.message.1": "No debe ser igual a la contraseña actual",
  "login.error.account.disable": "Su cuenta ha sido deshabilitada. Póngase en contacto con el administrador del sistema.",
  "login.error.password.current.incorrect": "La Contraseña Actual que ha introducido es incorrecta. Inténtelo de nuevo.",
  "login.error.password.expired": "Su contraseña ha caducado. Póngase en contacto con el administrador del sistema.",
  "login.error.update.message": "No se ha podido actualizar la contraseña. Inténtelo de nuevo.",
  "login.login.": "Repetir Contraseña",
  "login.login.current.password": "Contraseña Actual",
  "login.login.first": "Primer Nombre",
  "login.login.last": "Apellido",
  "login.login.name": "Nombre de Usuario",
  "login.login.new.password": "Nueva Contraseña",
  "login.login.password": "Contraseña",
  "login.login.repeat.password": "Repetir Contraseña",
  "login.msg.password": "Contraseña",
  "login.msg.password.missing": "Se requiere una contraseña",
  "login.msg.username": "Nombre de usuario",
  "login.msg.username.missing": "Se requiere un nombre de usuario",
  "login.notice.message": "Aviso: El acceso a este servicio es solo para personal autorizado. Si no tienes la autorización expresa del administrador, debes salir ahora. Esta organización prohíbe el acceso no autorizado, la divulgación, duplicación, modificación, desvío, destrucción, pérdida, mal uso o robo de su información.",
  "login.password.expired.date": "Fecha de Expiración de Contraseña",
  "login.password.expired.date.placeholder": "(dd/mm/aaaa)",
  "login.redirecting.sso": "Se le redirigirá al Inicio de Sesión Único...",
  "login.subtitle": "Iniciar sesión",
  "login.timeout": "Tiempo de Espera de Usuario (minutos)",
  "login.timeout.placeholder": "Ingresar en ms",
  "login.title": "Iniciar sesión",
  "lot.barcode": " Código de barras",
  "lot.barcode.assign": "Este lote aún no tiene código de barras. Ingrese uno ahora; se bloquea una vez guardado.",
  "lot.barcode.hint": "Dejar en blanco para generar uno a partir del código de ítem y el número de lote.",
  "lot.barcode.locked": "El código de barras se bloquea una vez guardado para que las etiquetas impresas sigan funcionando.",
  "lot.barcode.placeholder": "Dejar en blanco para generar automáticamente",
  "lot.barcode.placeholder.assign": "Ingrese un código de barras",
  "lot.calculatedExpiry": "Fecha de vencimiento calculada",
  "lot.currentQuantity": "Cantidad actual",
  "lot.dateOpened": "Fecha de apertura",
  "lot.details.no.movements": "No hay movimientos registrados para este lote",
  "lot.details.no.transactions": "No se han registrado transacciones para este lote",
  "lot.details.no.usage": "No hay historial de uso para este lote",
  "lot.details.section.basic": "Información básica",
  "lot.details.section.dates": "Fechas importantes",
  "lot.details.section.movements": "Historial de movimientos",
  "lot.details.section.quantities": "Cantidades",
  "lot.details.section.storage": "Ubicación de almacenamiento",
  "lot.details.section.transactions": "Historial de transacciones",
  "lot.details.section.usage": "Historial de uso",
  "lot.details.tab.info": "Información",
  "lot.details.tab.transactions": "Transacciones",
  "lot.details.tab.usage": "Historial de uso",
  "lot.details.title": "Detalles del lote",
  "lot.details.view": "Consultar detalles",
  "lot.expirationDate": "Fecha de caducidad",
  "lot.form.title.add": "Recibir nuevo lote de inventario",
  "lot.form.title.edit": "Editar lote de inventario",
  "lot.initialQuantity": "Cantidad inicial",
  "lot.label.print": "Imprimir etiqueta",
  "lot.label.print.failed": "No se pudo generar la etiqueta. Por favor, inténtalo de nuevo.",
  "lot.number": "Número de lote",
  "lot.number.hint": "Identificador estable para este lote. Déjelo en blanco y generaremos uno a partir del código de ítem y la fecha de hoy.",
  "lot.number.placeholder": "Dejar en blanco para generar automáticamente",
  "lot.qcStatus.FAILED": "Fallido",
  "lot.qcStatus.PASSED": "Aprobado",
  "lot.qcStatus.PENDING": "Pendiente",
  "lot.qcStatus.QUARANTINED": "En cuarentena",
  "lot.qcStatus.hint": "Los lotes no se pueden usar para pruebas hasta que el control de calidad (CC) se marque como Aprobado.",
  "lot.qcStatus": "Estado del CC",
  "lot.receiptDate": "Fecha de recepción",
  "lot.save.error": "Error al guardar el lote",
  "lot.save.error.locationAfterCreate": "El lote fue creado, pero falló la asignación de su ubicación de almacenamiento. Presione Guardar nuevamente para reintentar solo la asignación y evitar que el lote se reciba dos veces. {reason}",
  "lot.save.success": "El lote se ha guardado exitosamente",
  "lot.selectItem": "Seleccione un elemento del catálogo",
  "lot.selectLocation": "Seleccione la ubicación de almacenamiento",
  "lot.status": "Estado",
  "lot.status.ACTIVE": "Activo",
  "lot.status.CONSUMED": "Consumido",
  "lot.status.DISPOSED": "Desechado",
  "lot.status.EXPIRED": "Caducado",
  "lot.status.IN_USE": "En uso",
  "lot.status.QUARANTINED": "En cuarentena",
  "lot.storageLocation": "Ubicación de almacenamiento",
  "manage.testing.algorithms.add.reflex.tests": "Administrar Algoritmos de Pruebas y Pruebas de Reflejo",
  "master.lists.page": "Página de Listas Maestras",
  "master.lists.page.analyzer": "Menú de Nombres de Pruebas del Analizador",
  "master.lists.page.barcode": "Configuración de Códigos de Barras",
  "master.lists.page.batchtest": "Reasignación y Cancelación de Pruebas por Lotes",
  "master.lists.page.external.connections": "Menú de Conexiones Externas",
  "master.lists.page.field": "Configuración de Validación de Campos",
  "master.lists.page.list": "Plugins de Lista",
  "master.lists.page.menu": "Configuración de Menú",
  "master.lists.page.notification": "Configuración de Notificación de Pruebas",
  "master.lists.page.order.entry": "Configuración de Entrada de Órdenes",
  "master.lists.page.org": "Menú de Organización",
  "master.lists.page.patient": "Configuración de Entrada de Pacientes",
  "master.lists.page.printed": "Configuración de Reportes Impresos",
  "master.lists.page.provider": "Proveedor",
  "master.lists.page.report.result": "Configuración de Reporte de Resultados",
  "master.lists.page.result": "Configuración de Entrada de Resultados",
  "master.lists.page.site": "Información del Sitio",
  "master.lists.page.test.management": "Gestión de Pruebas",
  "master.lists.page.user": "Gestión de Usuarios",
  "master.lists.page.work.plan": "Configuración de Plan de Trabajo",
  "menu.accession.validation": "Por orden",
  "menu.accession.validation.range": "Por rango de números de orden",
  "menu.billing.active": "Menú de Facturación Activo",
  "menu.billing.address": "URL de Facturación",
  "menu.billing.title": "Gestión de Menú de Facturación",
  "menu.genericSample": "Muestra genérica",
  "menu.genericSample.edit": " Editar orden",
  "menu.genericSample.import": "Importar",
  "menu.genericSample.order": "Orden",
  "menu.global.title": "Gestión de Menú Global",
  "menu.label.filter": "Filtros:",
  "menu.label.filter.active": "Solo Activos",
  "menu.label.filter.admin": "Solo Administrador",
  "menu.label.filter.role": "Por Roles de Unidad de Laboratorio",
  "menu.nonconform.active": "Menú de No Conformidad Activo",
  "menu.nonconform.title": "Gestión de Menú de No Conformidad",
  "menu.patient.active": "Menú de Paciente Activo",
  "menu.patient.title": "Gestión de Menú de Paciente",
  "menu.results.range": "Por rango de números de orden",
  "menu.sidenav.active": "Navegación Lateral Activa",
  "menu.study.active": "Menú de Estudio Activo",
  "menu.study.title": "Gestión de Menú de Estudio",
  "menu.validation.date": "Por fecha",
  "message.method.activation": "Esta unidad de método no estará activa hasta que se le haya asignado al menos una prueba.",
  "message.propertiesupdate.success": "Las propiedades se han actualizado correctamente",
  "method.browse.title": "Sección de Método",
  "method.methodName": "Nombre del Método",
  "method.modal.add.heading": "Agregar nuevo método",
  "modal.add.method": "Agregar nuevo método",
  "move.back": "Retroceder",
  "move.to.aliquot": "Pasar a la alícuota",
  "new.patient.label": "Nuevo paciente",
  "next.action.button": "Siguiente",
  "nextLabel.action.button": "Siguiente etiqueta",
  "no.aliquots": "No hay alícuotas disponibles",
  "no.analysis.found": "No se han encontrado análisis",
  "no.data.found": " No se encontraron datos",
  "no.option": "No",
  "noTestsFound.matching": " No se encontraron pruebas que coincidan",
  "nonconform.add.new.date": " Agregar nueva fecha",
  "nonconform.corrective.action": " Acción correctiva planeada o recomendada:",
  "nonconform.corrective.actionType": " Tipo de acción",
  "nonconform.corrective.comment": " Comentarios",
  "nonconform.corrective.control": " Control preventivo o concurrente planeado o recomendado:",
  "nonconform.corrective.title": " Acción correctiva de eventos no conformes",
  "nonconform.date.completed": " Fecha completada",
  "nonconform.date.discussion.nce": " Fecha de discusión con personal de NCE",
  "nonconform.date.event": " Fecha del evento",
  "nonconform.description.nce": " Descripción del NCE",
  "nonconform.field.date": " Fecha NCE",
  "nonconform.field.reporting.data": " Fecha de informe",
  "nonconform.goToNceForm": " Ir al formulario de reporte NCE",
  "nonconform.lab.componenet.nce": " Componente de laboratorio donde ocurrió el NCE",
  "nonconform.label.highseverity": " 9 = severidad muy alta – se requiere acción inmediata",
  "nonconform.label.lowseverity": " 1 = severidad muy baja – no se requiere acción inmediata",
  "nonconform.label.prescibernamesite": " Nombre y sitio del prescriptor",
  "nonconform.label.proposed.action": " Acción propuesta",
  "nonconform.label.reportingunit": " Unidad informante",
  "nonconform.label.suspected.cause.nce": " Causa sospechada del NCE",
  "nonconform.nce.concurrent.control.action": " acción de control concurrente",
  "nonconform.nce.number": " Número NCE",
  "nonconform.nce.preventive.action": " acción preventiva",
  "nonconform.nce.resolution": " Resolución NCE",
  "nonconform.nce.resolution.description": " ¿Fueron las acciones correctivas y preventivas/concurrentes eficaces para resolver el evento no conforme y prevenir que se repita?",
  "nonconform.nce.turnaround.time": " Tiempo de respuesta",
  "nonconform.order.save.fail": " Error al guardar",
  "nonconform.order.save.success": " Guardado exitoso",
  "nonconform.person.reporting.different": " Nombre de quien informa (si es distinto)",
  "nonconform.person.responsible": " Persona responsable",
  "nonconform.report": " Informar evento no conforme (NCE)",
  "nonconform.report.field.date": " Fecha del informe",
  "nonconform.severity.score": " Puntuación de severidad",
  "nonconform.view.comments": "Comentarios",
  "nonconform.view.corrective.action.description": " Descripción de la acción correctiva a tomar",
  "nonconform.view.event.date": " Fecha del evento",
  "nonconform.view.event.description": " Descripción del evento",
  "nonconform.view.lab.component": " Componente de laboratorio",
  "nonconform.view.nce.category": " Categoría NCE",
  "nonconform.view.nce.likely.occur": " ¿Qué tan probable es que el NCE ocurra de nuevo?",
  "nonconform.view.nce.severity": " Severidad",
  "nonconform.view.nce.type": " Tipo NCE",
  "nonconform.view.preventive.description": " Descripción de la acción correctiva a tomar",
  "nonconform.view.report": " Ver nuevo evento no conforme",
  "nonconform.view.reporting.person": " Persona que informa",
  "nonconform.view.severe.consequences": " ¿Qué tan graves son las consecuencias o impacto del NCE?",
  "nonconform.view.specimen": " Muestra(s)",
  "nce.attachment.dropzone": "Arrastre y suelte los archivos aquí o haga clic para subirlos",
  "nce.attachment.error.maxFiles": "Se permite un máximo de {maxFiles} archivos",
  "nce.attachment.error.size": "El tamaño del archivo supera el límite máximo de {maxSize}",
  "nce.attachment.error.type": "Tipo de archivo no permitido. Tipos admitidos: {types}",
  "nce.attachment.error.upload": "Error al subir el archivo",
  "nce.attachment.files": "archivos",
  "nce.attachment.hint": "(Opcional: un máximo de {maxFiles} archivos, de 10 MB cada uno)",
  "nce.attachment.uploading": "Cargando...",
  "nce.category.administrative": "Administrativo",
  "nce.category.analytical": "Analítico",
  "nce.category.postanalytical": "Pós-analítico",
  "nce.category.preanalytical": "Preanalítico",
  "nce.field.attachments": "Archivos adjuntos",
  "nce.field.notes": "Notas",
  "nce.field.description.placeholder": "Describa lo que ocurrió, cuándo se detectó y cualquier contexto relevante...",
  "nce.field.immediateAction": "Acción adoptada de inmediato",
  "nce.field.immediateAction.placeholder": "Medidas correctivas adoptadas de inmediato...",
  "nce.field.linkedItems": "Muestras/resultados relacionados",
  "nce.field.severity": " Severidad",
  "nce.field.title": "Título",
  "nce.field.title.placeholder": "Breve descripción del evento...",
  "nce.severity.critical": "Crítico",
  "nce.severity.critical.description": "Riesgo para la seguridad del paciente, incumplimiento normativo",
  "nce.severity.major": "Mayor",
  "nce.severity.major.description": "Repercusiones significativas en materia de calidad o en el funcionamiento",
  "nce.severity.minor": "Menor",
  "nce.severity.minor.description": "Impacto limitado, fácil de corregir",
  "nce.severity.low": "Bajo",
  "nce.severity.low.description": "Impacto mínimo; no se requieren acciones correctivas",
  "nce.status.open": "Abierto",
  "nce.status.underInvestigation": "En fase de investigación",
  "nce.tree.empty": "No se han encontrado pedidos. Busque un número de laboratorio para comenzar.",
  "nce.tree.loading": "Cargando órdenes...",
  "nce.tree.order": "Orden",
  "nce.tree.search": "Filtrar por prueba o muestra...",
  "nce.tree.selected": "{sampleCount} muestras, resultados de «{resultCount}» seleccionados",
  "nce.trigger.order_cancellation": "La cancelación de un pedido puede requerir documentación de NCE",
  "nce.trigger.partial_sample_rejection": "El rechazo parcial de una muestra requiere documentación de NCE",
  "nce.trigger.pathology_rejection": "El rechazo de un caso de Patología puede requerir documentación de la NCE",
  "nce.trigger.premature_disposal": "La eliminación prematura podría requerir documentación relativa a las NCE",
  "nce.trigger.qc_invalidation": "Para invalidar el QC es necesario presentar la documentación del NCE",
  "nce.trigger.referral_rejection": "El rechazo de una referencia requiere documentación de la NCE",
  "nce.trigger.result_rejection_no_retest": "El rechazo de un resultado sin repetir la prueba requiere documentación de la NCE",
  "nce.trigger.result_rejection_retest": "El rechazo de un resultado con repetición de la prueba puede requerir documentación de la NCE",
  "nce.trigger.sample_rejection": "Rechazar muestra requiere documentación de la NCE",
  "nce.trigger.test_cancel_no_results": "La cancelación de una prueba puede requerir documentación del NCE",
  "nce.trigger.test_cancel_with_results": "Para cancelar una prueba con resultados es necesario presentar la documentación de NCE",
  "nce.type.calibration_failure": "Error de calibración",
  "nce.type.communication_failure": "Fallo de comunicación",
  "nce.type.contamination": "Contaminación",
  "nce.type.documentation_error": "Error en la documentación",
  "nce.type.equipment_malfunction": "Avería del equipo",
  "nce.type.labeling_error": "Error de etiquetado",
  "nce.type.patient_id_mismatch": "Discrepancia en el ID del paciente",
  "nce.type.policy_violation": "Incumplimiento de las normas",
  "nce.type.procedure_deviation": "Desviación del procedimiento",
  "nce.type.qc_failure": "Fallo en el QC",
  "nce.type.reagent_issue": "Problema con los reactivos",
  "nce.type.report_delay": "Informe sobre el retraso",
  "nce.type.report_distribution_error": "Informe sobre un error de distribución",
  "nce.type.requisition_incomplete": "Solicitud incompleta",
  "nce.type.resource_shortage": "Escasez de recursos",
  "nce.type.result_interpretation_error": "Error en la interpretación de los resultados",
  "nce.type.sample_collection_error": "Error en la recogida de muestras",
  "nce.type.staff_competency_issue": "Cuestión relativa a la competencia del personal",
  "nce.type.storage_error": "Error de almacenamiento",
  "nce.type.system_error": "Error del sistema",
  "nce.type.training_gap": "Déficit formativo",
  "nce.type.transcription_error": "Error de transcripción",
  "nce.type.transport_issue": "Problema de transporte",
  "nce.type.request_form_error": "Error en el formulario de solicitud de solicitudes",
  "nce.type.equipment_failure": "Avería del equipo",
  "nce.type.procedure_error": "Error de procedimiento",
  "nce.type.calibration_error": "Error de calibración",
  "nce.type.cross_contamination": "Contaminación cruzada",
  "nce.type.result_transcription_error": "Error de transcripción del resultado",
  "nce.type.report_delivery_error": "Notificar un error de entrega de informes",
  "nce.type.critical_value_not_reported": "No se ha facilitado el valor crítico",
  "nce.type.delayed_result": "Resultado retrasado",
  "nce.type.result_amendment": "Modificación de los resultados",
  "nce.type.training_issue": "Cuestión relativa a la formación",
  "nce.button.createNce": "Crear NCE",
  "nce.button.skip": "Saltar",
  "nce.creating": "Creación de NCE...",
  "nce.description.placeholder": "Describa el incidente no conforme...",
  "nce.error.create.failed": "No se ha podido crear el NCE",
  "nce.error.severity.required": "Es obligatorio indicar la severidad",
  "nce.trigger.mandatory.message": "Debe crear un NCE antes de continuar con esta acción.",
  "nce.trigger.mandatory.title": "Se requiere NCE",
  "nce.trigger.order_cancellation.message": "La cancelación de un pedido puede requerir la presentación de documentación que acredite que se ha producido un incidente no conforme.",
  "nce.trigger.order_cancellation.title": "Cancelación de un pedido - NCE",
  "nce.trigger.partial_sample_rejection.message": "El rechazo parcial de una muestra requiere la documentación de un incidente no conforme.",
  "nce.trigger.partial_sample_rejection.title": "Rechazo parcial de la muestra: se requiere un NCE",
  "nce.trigger.pathology_rejection.message": "El rechazo de un caso de Patología puede requerir la documentación de un incidente no conforme.",
  "nce.trigger.pathology_rejection.title": "Rechazo por motivos de patología - NCE",
  "nce.trigger.premature_disposal.message": "Una eliminación prematura puede requerir la documentación de un incidente no conforme.",
  "nce.trigger.premature_disposal.title": "Eliminación prematura - NCE",
  "nce.trigger.qc_invalidation.message": "La anulación del QC requiere la documentación de un incidente no conforme.",
  "nce.trigger.qc_invalidation.title": "Anulación del QC: se requiere un NCE",
  "nce.trigger.referral_rejection.message": "El rechazo de una referencia requiere la documentación de un hecho no conforme.",
  "nce.trigger.referral_rejection.title": "Rechazo de la referencia: se requiere el NCE",
  "nce.trigger.result_rejection_no_retest.message": "El rechazo de un resultado sin repetir la prueba requiere la documentación de un incidente no conforme.",
  "nce.trigger.result_rejection_no_retest.title": "Rechazo del resultado: se requiere NCE",
  "nce.trigger.result_rejection_retest.message": "El rechazo de un resultado con repetición de la prueba puede requerir la documentación de un incidente no conforme.",
  "nce.trigger.result_rejection_retest.title": "Rechazo de resultados - NCE",
  "nce.trigger.sample_rejection.message": "El rechazo de una muestra requiere la documentación de un caso no conforme.",
  "nce.trigger.sample_rejection.title": "Rechazo de muestra: se requiere NCE",
  "nce.trigger.test_cancel_no_results.message": "La cancelación de una prueba puede requerir la presentación de documentación que acredite la existencia de un hecho no conforme.",
  "nce.trigger.test_cancel_no_results.title": "Cancelación de una prueba - NCE",
  "nce.trigger.test_cancel_with_results.message": "La anulación de una prueba con resultados ya obtenidos requiere la documentación de un incidente de no conformidad.",
  "nce.trigger.test_cancel_with_results.title": "Cancelar una prueba: se requiere el NCE",
  "nce.admin.trigger.config.title": "Configuración del disparador NCE",
  "nce.admin.trigger.config.description": "Configure cuándo se crean automáticamente o se solicitan los eventos no conformes.",
  "nce.admin.trigger.behaviors.title": "Comportamientos de activación",
  "nce.admin.rejection.mappings.title": "Asignaciones de motivos de rechazo",
  "nce.admin.rejection.mappings.description": "Asignar los motivos de rechazo a las categorías NCE para su cumplimentación automática.",
  "nce.trigger.behavior.mandatory": "Obligatorio",
  "nce.trigger.behavior.prompted": "A instancias de",
  "nce.trigger.behavior.disabled": "Desactivado",
  "nce.trigger.column.type": "Tipo de gatillo",
  "nce.trigger.column.description": "Descripción",
  "nce.trigger.column.behavior": "Comportamiento",
  "nce.trigger.column.active": "Activo",
  "nce.trigger.type.sampleRejection": "Rechazo de muestras",
  "nce.trigger.type.resultRejection": "Rechazo del resultado",
  "nce.trigger.type.qaEvent": "Evento de control de calidad",
  "nce.trigger.type.manual": "Manual",
  "nce.trigger.update.success": "Se ha actualizado la configuración del disparador",
  "nce.trigger.update.error": "No se ha podido actualizar la configuración del disparador",
  "nce.mapping.add": "Agregar asignación",
  "nce.mapping.edit": "Editar asignación",
  "nce.mapping.column.rejectionReason": "Motivo de rechazo",
  "nce.mapping.column.category": " Categoría NCE",
  "nce.mapping.column.type": " Tipo NCE",
  "nce.mapping.column.severity": "Severidad predeterminada",
  "nce.mapping.column.active": "Activo",
  "nce.mapping.noData": "No se han configurado asignaciones de rechazo",
  "nce.mapping.validation.error": "Es obligatorio indicar el motivo de rechazo y la categoría del rechazo",
  "nce.mapping.save.success": "El mapeo se ha guardado exitosamente",
  "nce.mapping.active": "Activo",
  "nce.field.category": " Categoría",
  "nce.field.type": "Tipo",
  "nce.select.category": "Seleccione una categoría",
  "nce.select.type": "Seleccione un tipo",
  "nce.error.dateOfEvent.required": "Es obligatorio indicar la fecha del evento",
  "nce.error.reportingUnit.required": "Es obligatorio indicar la unidad informante.",
  "nce.error.description.required": "Es obligatorio ingresar una descripción",
  "nce.error.suspectedCauses.required": "Es necesario indicar las causas presuntas",
  "nce.error.proposedAction.required": "Es necesario llevar a cabo la acción propuesta",
  "nce.error.category.required": "Es obligatorio indicar la categoría",
  "nce.attachment.saveFirst": "Guarde el evento NCE para habilitar los archivos adjuntos",
  "nce.attachment.error.noEvent": "Por favor, guarde primero el evento NCE antes de subir los archivos adjuntos",
  "nce.attachment.download": "Descargar",
  "nce.attachment.delete": "Eliminar",
  "requester.add.new.restricted": "Su administrador ha desactivado la opción de agregar una nueva organización.",
  "requester.add.new.restricted.organization.contact": "El administrador ha desactivado la opción de ingresar los datos de contacto de una nueva organización. Busque una organización ya existente en el campo de arriba.",
  "requester.add.new.restricted.provider": "Su administrador ha desactivado la posibilidad de agregar un nuevo proveedor.",
  "requester.add.new.restricted.provider.contact": "El administrador ha desactivado la posibilidad de ingresar los datos de contacto de un nuevo proveedor. Busque un proveedor ya existente en la sección superior.",
  "requester.add.new.restricted.requestor": "Su administrador ha desactivado la posibilidad de agregar un nuevo solicitante. Busque un solicitante ya existente en la parte superior.",
  "requester.contact.search": "Buscar solicitantes",
  "requester.contact.search.helper": "Busque a la persona de contacto que ha solicitado estas pruebas o ingrese una nueva a continuación. Es obligatorio rellenar al menos uno de los campos «Organización solicitante» o «Solicitante».",
  "requester.organization.add.new": "+ Agregar una nueva organización «{name}»",
  "requester.organization.email": "Correo Electrónico de la organización",
  "requester.organization.fax": "Fax de la organización",
  "requester.organization.new.helper": "Se creará como una nueva organización cuando se guarde esta orden.",
  "requester.organization.new.tag": "Nuevo",
  "requester.organization.no.match": "No se ha encontrado ninguna organización que coincida.",
  "requester.organization.phone": "Teléfono de la organización",
  "requester.organization.search": "Búsqueda de la organización solicitante",
  "requestor.add.new": "+ Agregar un nuevo solicitante: «{name}»",
  "requestor.add.new.restricted": "Su administrador ha desactivado la posibilidad de agregar un nuevo solicitante.",
  "requestor.department": "Departamento",
  "requestor.email": "Correo Electrónico",
  "requestor.fax": "Fax",
  "requestor.firstName": "Primer Nombre",
  "requestor.lastName": "Apellido",
  "requestor.name": "Nombre del solicitante",
  "requestor.name.placeholder": "Ingrese el nombre del solicitante",
  "requestor.new.helper": "Se creará como nuevo solicitante cuando se guarde esta orden.",
  "requestor.new.tag": "Nuevo",
  "requestor.no.match": "No se ha encontrado ningún solicitante que coincida.",
  "requestor.phone": "Teléfono",
  "requestor.search.helper": "Escriba al menos 2 caracteres para activar la búsqueda automática.",
  "result.compliance.fail": "FAIL",
  "result.compliance.pass": "PASS",
  "result.pool.filter.allLots": "Todos los lotes",
  "result.pool.filter.allPools": "Todas las piscinas",
  "result.pool.filter.clear": "Limpiar filtro",
  "result.pool.filter.count": "Mostrando {shown} de los {total} resultados",
  "result.pool.filter.lot": "Filtrar por lote",
  "result.pool.filter.pool": "Filtrar por piscina",
  "result.pool.intake": "Piscina de captación",
  "result.pool.subpool": "Subgrupo «{n}»",
  "result.vectorPool.label": "Grupo de {count} {animal}",
  "results.uncertainty.column.label": "U (k=2)",
  "results.uncertainty.validation.negative": "La incertidumbre debe ser un número no negativo.",
  "results.uncertainty.value.prefix": "±",
  "sample.fallback.name": "Muestra",
  "sample.priority.ASAP": "ASAP",
  "sample.priority.FUTURE_STAT": "STAT futuro",
  "sample.priority.ROUTINE": "Rutina",
  "sample.priority.STAT": "STAT (Urgente)",
  "sample.priority.TIMED": "Programado",
  "sample.referToReferenceLab.helper": "Marque si esta muestra debe analizarse en un laboratorio de referencia externo.",
  "sampleAcceptance.action.moveDown": "Bajar",
  "sampleAcceptance.action.moveUp": "Subir",
  "sampleAcceptance.banner.resampledFrom": "Se trata de una versión de sustitución creada a partir de un remuestreo de la muestra n.º{id}.",
  "sampleAcceptance.banner.resampledFrom.title": "Muestra de sustitución",
  "sampleAcceptance.banner.resampledTo": "Esta muestra fue rechazada y se volvió a tomar. Orden de sustitución: {accession}.",
  "sampleAcceptance.banner.resampledTo.title": "Remuestreado",
  "sampleAcceptance.button.addItem": "Agregar elemento",
  "sampleAcceptance.col.active": "Activo",
  "sampleAcceptance.col.label": "Etiqueta",
  "sampleAcceptance.col.order": "Orden",
  "sampleAcceptance.col.statusForDomain": "Estado de este dominio",
  "sampleAcceptance.domain.all": "Todos los dominios",
  "sampleAcceptance.domain.clinical": "Clínico",
  "sampleAcceptance.domain.environmental": "Medioambiental",
  "sampleAcceptance.domain.vector": "Vector",
  "sampleAcceptance.enforcement.help": "La aplicación de las normas se establece por dominio, no por unidad de laboratorio; un empleado de recepción puede estar adscrito a varias unidades de laboratorio.",
  "sampleAcceptance.enforcement.label": "Aplicación de la lista de comprobación — {domain}",
  "sampleAcceptance.enforcement.mandatory": "Obligatorio: bloquear el paso 3 hasta que esté completado",
  "sampleAcceptance.enforcement.off": "Desactivado: ocultar la lista de comprobación",
  "sampleAcceptance.enforcement.optional": "Opcional: registrar, pero no bloquear",
  "sampleAcceptance.gate.blocked": "La aceptación en la admisión es obligatoria para este dominio: debe aceptarse cada muestra (o notificarse un NCE o realizarse un nuevo muestreo) antes de que esta orden pueda continuar.",
  "sampleAcceptance.labWide.heading": "Elementos aplicables a todo el laboratorio (se aplican salvo que un dominio los anule)",
  "sampleAcceptance.labWide.inherited": "Elementos de ámbito de laboratorio: heredados (alternativa activa)",
  "sampleAcceptance.labWide.superseded": "Elementos de todo el laboratorio: sustituidos aquí (editar desde «Todos los dominios»)",
  "sampleAcceptance.notify.enforcementSaved": "Aplicación actualizada",
  "sampleAcceptance.notify.itemAdded": "Se ha agregado un elemento a la lista de comprobación",
  "sampleAcceptance.notify.itemSaved": "Se ha guardado el elemento de la lista de comprobación",
  "sampleAcceptance.notify.recordFailed": "No se ha podido registrar la aceptación",
  "sampleAcceptance.notify.rejectFailed": "No se ha podido rechazar",
  "sampleAcceptance.notify.resampleFailed": "No se ha podido volver a muestrear",
  "sampleAcceptance.ownItems.empty": "Aún no hay elementos; este dominio usa la lista general del laboratorio que figura a continuación.",
  "sampleAcceptance.ownItems.heading": "Elementos de {domain}",
  "sampleAcceptance.qa.accepted.success": "Se ha registrado la aceptación",
  "sampleAcceptance.qa.answer.fail": "Fallo",
  "sampleAcceptance.qa.answer.na": "N/A",
  "sampleAcceptance.qa.answer.pass": "Aprobado",
  "sampleAcceptance.qa.button.accept": "Aceptar muestra",
  "sampleAcceptance.qa.button.reject": " Rechazar",
  "sampleAcceptance.qa.button.resample": "Remuestrear",
  "sampleAcceptance.qa.context.collected": "Recolectado",
  "sampleAcceptance.qa.context.longTransit": "Tránsito prolongado — usted decide",
  "sampleAcceptance.qa.context.note": "El tránsito se muestra únicamente a título informativo; no realiza ninguna calificación automática. Lista activa: {domain}.",
  "sampleAcceptance.qa.context.received": "Recibido",
  "sampleAcceptance.qa.context.transit": "Tiempo de tránsito",
  "sampleAcceptance.qa.empty": "No se ha configurado ninguna lista de comprobación de aceptación para este dominio.",
  "sampleAcceptance.qa.failHint": "Esta muestra no ha superado las comprobaciones: notifique un NCE o vuelva a tomar una muestra en lugar de aceptarla.",
  "sampleAcceptance.qa.failHint.reject": "This sample has failed checks. Report an NCE or reject it instead of accepting.",
  "sampleAcceptance.qa.noSample": "Guarde la recolección para realizar la aceptación en la admisión de esta muestra.",
  "sampleAcceptance.qa.note.label": "Nota (opcional)",
  "sampleAcceptance.qa.note.placeholder": "Opcional: indique cualquier condición observada",
  "sampleAcceptance.qa.status.accepted": "Aceptado",
  "sampleAcceptance.qa.status.pending": "Pendiente",
  "sampleAcceptance.qa.status.rejected": "Rechazado",
  "sampleAcceptance.qa.status.review": "Revisión",
  "sampleAcceptance.qa.subtitle": "Complete la lista de comprobación de aceptación de esta muestra",
  "sampleAcceptance.qa.subtitle.rejected": "Esta muestra fue rechazada y se volvió a tomar una muestra; solo lectura.",
  "sampleAcceptance.qa.subtitle.rejectedEqa": "This sample was rejected — read-only.",
  "sampleAcceptance.qa.subtitle.rejectedVector": "Esta captura ha sido rechazada — solo lectura.",
  "sampleAcceptance.qa.title": "Aceptación en la admisión",
  "sampleAcceptance.reject.commit": "Confirmar rechazo",
  "sampleAcceptance.reject.comment.label": "Comentario (opcional)",
  "sampleAcceptance.reject.info": "Rechace esta captura por ser inservible. No es posible volver a recolectarla, por lo que no se creará ninguna orden de reposición.",
  "sampleAcceptance.reject.info.eqa": "Reject this proficiency-testing sample. PT material cannot be recollected, so no replacement order is created.",
  "sampleAcceptance.reject.reason.label": "Motivo (prellenado desde los elementos no superados — editable)",
  "sampleAcceptance.reject.reason.required": "Es necesario indicar un motivo",
  "sampleAcceptance.reject.success": "Muestra rechazada.",
  "sampleAcceptance.reject.title": "Rechazar — {labNumber}",
  "sampleAcceptance.resample.commit": "Confirmar remuestreo",
  "sampleAcceptance.resample.info": "Rechace esta muestra y cree una nueva orden de recolección para volver a recolectarla. Se notificará al solicitante.",
  "sampleAcceptance.resample.reason.label": "Motivo (prellenado desde los elementos no superados — editable)",
  "sampleAcceptance.resample.reason.required": "Es necesario indicar un motivo",
  "sampleAcceptance.resample.success": "Se ha creado el remuestreo: nueva orden {accession}. Se ha notificado al solicitante.",
  "sampleAcceptance.resample.title": "Remuestrear: {labNumber}",
  "sampleAcceptance.review.col.eligibility": "Elegibilidad",
  "sampleAcceptance.review.col.labNo": "N.º de laboratorio",
  "sampleAcceptance.review.col.sampleType": "Tipo de muestra",
  "sampleAcceptance.review.col.transit": "Tránsito",
  "sampleAcceptance.review.noSamples": "Aún no hay muestras recolectadas para revisar.",
  "sampleAcceptance.review.subtitle": "Seleccione una muestra para completar su lista de comprobación de aceptación",
  "sampleAcceptance.review.title": "Aceptación en la admisión",
  "sampleAcceptance.status.active": "Activo",
  "sampleAcceptance.status.inactive": "Inactivo",
  "sampleAcceptance.status.inheritedActive": "Activo (heredado)",
  "sampleAcceptance.status.superseded": "Sustituido",
  "sampleAcceptance.title": "Lista de comprobación para la aceptación de muestras",
  "sidenav.label.admin.nceTriggerConfig": "Configuración del disparador",
  "sidenav.label.admin.nceCategoryType": "Categorías y tipos",
  "sidenav.label.admin.nceConfig": "Configuración de NCE",
  "nce.admin.categorytype.title": "Configuración de categorías y tipos de NCE",
  "nce.admin.categorytype.description": "Gestión de las categorías y los tipos disponibles para los eventos no conformes.",
  "nce.admin.tab.categories": "Categorías",
  "nce.admin.tab.types": "Tipos",
  "nce.admin.category.add": "Agregar categoría",
  "nce.admin.category.edit": "Editar categoría",
  "nce.admin.category.name.required": "Es obligatorio introducir el nombre de la categoría",
  "nce.admin.category.save.success": "La categoría se ha guardado exitosamente",
  "nce.admin.category.save.error": "No se ha podido guardar la categoría",
  "nce.admin.type.add": "Agregar tipo",
  "nce.admin.type.edit": "Editar tipo",
  "nce.admin.type.validation.error": "Es obligatorio indicar el nombre y la categoría",
  "nce.admin.type.save.success": "El tipo se ha guardado exitosamente",
  "nce.admin.type.save.error": "No se ha podido guardar el tipo",
  "nce.admin.column.name": " Nombre",
  "nce.admin.column.displayKey": "Tecla de pantalla",
  "nce.admin.column.typesCount": "Recuento de tipos",
  "nce.admin.column.category": " Categoría",
  "nce.admin.column.actions": "Acciones",
  "nce.admin.field.name": " Nombre",
  "nce.admin.field.displayKey": "Clave de visualización (para i18n)",
  "nce.admin.field.displayKey.helper": "Opcional. Se utiliza para las traducciones.",
  "nce.admin.field.category": " Categoría",
  "nce.admin.delete.confirm.title": "Confirmar eliminación",
  "nce.admin.delete.confirm.message": "¿Está seguro de que desea eliminar «{name}»? Esta acción no se puede deshacer.",
  "nce.admin.delete.success": "Se ha eliminado correctamente",
  "nce.inline.title": "Reportar evento no conforme",
  "nce.inline.context": "CONTEXTO (Rellenado automáticamente)",
  "nce.dashboard.title": "Todos los NCE",
  "nce.dashboard.subtitle": "Todos los NCE abiertos en el laboratorio",
  "nce.button.reportNce": "Reportar NCE",
  "nce.search.placeholder": "Buscar NCE...",
  "nce.filter.allStatus": "Todos los estados",
  "nce.filter.allCategories": "Todas las categorías",
  "nce.filter.allSeverities": "Todas las severidades",
  "nce.filter.clearAll": "Limpiar todo",
  "nce.summary.critical": "Crítico",
  "nce.summary.major": "Mayor",
  "nce.summary.minor": "Menor",
  "nce.summary.overdue": "Atrasado",
  "nce.tag.overdue": "Atrasado",
  "nce.tab.eventDetails": "Detalles del evento",
  "nce.tab.investigation": "Investigación",
  "nce.tab.capa": "CAPA",
  "nce.tab.history": "Historial",
  "nce.field.suspectedCauses": "Causas presuntas",
  "nce.field.proposedAction": " Acción propuesta",
  "nce.field.trigger": "Disparador",
  "nce.capReason.time_24h": "{count} samples linked — capped at 24h window",
  "nce.capReason.count_50": "{count} samples linked — capped at 50 most recent",
  "nce.capa.noItems": "Aún no se han registrado acciones correctivas ni preventivas.",
  "nce.capa.dueDate": "Due Date",
  "nce.history.noItems": "No hay historial disponible.",
  "nce.history.system": "Sistema",
  "nce.action.acknowledge": "Confirmar",
  "nce.action.assignTo": "Asignar a",
  "nce.action.addNote": "Agregar nota",
  "nce.action.close": "Cerrar NCE",
  "nce.action.startCorrectiveAction": "Iniciar las acciones correctivas",
  "nce.link.duplicate.warning": "Estas muestras ya están vinculadas a este NCE",
  "nce.list.empty": "No se han encontrado NCE que se ajusten a sus criterios.",
  "nce.modal.addNote": "Agregar nota",
  "nce.modal.addNoteDescription": "Agregue una nota a NCE {nceNumber}",
  "nce.modal.notePlaceholder": "Escriba su nota...",
  "nce.modal.assign": "Asignar NCE",
  "nce.modal.assignDescription": "Asignar el NCE «{nceNumber}» a un usuario",
  "nce.modal.selectUser": "Seleccionar usuario",
  "nce.modal.searchUser": "Buscar un usuario...",
  "nce.assign.selectUser": "Seleccione un usuario al que asignar",
  "nce.assign.success": "El NCE se ha asignado correctamente",
  "nce.assign.error": "No se ha podido asignar el NCE",
  "nce.acknowledge.success": "El NCE se ha confirmado correctamente",
  "nce.acknowledge.error": "No se ha podido confirmar el NCE",
  "nce.note.empty": "Ingrese una nota, por favor",
  "nce.note.success": "La nota se ha agregado correctamente.",
  "nce.note.error": "No se ha podido agregar la nota",
  "nce.attachment.downloadError": "No se ha podido descargar el archivo adjunto",
  "nce.attachment.viewError": "No se ha podido consultar el archivo adjunto",
  "not.available": "No disponible",
  "not.specified": "No especificado",
  "notAuthenticated": " No autenticado",
  "notebook.attachments.title": "Archivos adjuntos",
  "notebook.attachments.uploadPrompt": "Haga clic aquí para subir archivos",
  "notebook.auditTrail.action.archived": "Archivado",
  "notebook.auditTrail.action.created": "Creado",
  "notebook.auditTrail.action.finalized": "Finalizado",
  "notebook.auditTrail.action.locked": "Bloqueado",
  "notebook.auditTrail.action.submitted": "Enviado",
  "notebook.auditTrail.action.updated": "Actualizado",
  "notebook.auditTrail.comingSoon": "La función de Registro de Auditoría estará disponible en breve.",
  "notebook.auditTrail.none.subtitle": "No se han encontrado entradas en el Registro de Auditoría correspondientes a este cuaderno.",
  "notebook.auditTrail.none.title": "No hay registro de Auditoría disponible",
  "notebook.auditTrail.title": "Registro de Auditoría",
  "notebook.button.edit": "Editar",
  "notebook.button.editResults": "Editar resultados",
  "notebook.button.enterResults": "Ingresar resultados",
  "notebook.button.newLabNotebook": "Proyecto",
  "notebook.button.view": "Consultar",
  "notebook.comments.add.button": "Agregar comentario",
  "notebook.comments.add.label": "Agregue un comentario",
  "notebook.comments.none.subtitle": "Aún no se ha agregado ningún comentario.",
  "notebook.comments.none.title": "Sin comentarios",
  "notebook.comments.title": "Comentarios",
  "notebook.error.notAssigned": "No está asignado a este proyecto",
  "notebook.heading.allEntries": "Todas las entradas",
  "notebook.heading.notebooks": "Proyectos",
  "notebook.icon.edit": "Editar",
  "notebook.instruments.title": "Instrumentos",
  "notebook.label.addpage": "Agregar página",
  "notebook.label.author": "Autor",
  "notebook.label.basicinfo": "Información básica",
  "notebook.label.content": "Contenido principal",
  "notebook.label.dashboard": "Panel de cuadernos",
  "notebook.label.drafts": "Borradores",
  "notebook.label.entry": "Anotación en el cuaderno",
  "notebook.label.entryFiles": "Archivos de entrada",
  "notebook.label.instanceEntry": "Entrada de instancia de cuaderno",
  "notebook.label.entryTags": "Etiquetas de la entrada",
  "notebook.label.experimentDoc": "Documentación del experimento",
  "notebook.label.experimentType": "Tipo de experimento",
  "notebook.label.filter.types": "Tipos de experimentos",
  "notebook.label.finalized": "Finalizado esta semana",
  "notebook.label.formEntry": "Introducción de datos en el formulario del cuaderno",
  "notebook.label.objective": "Objetivo",
  "notebook.label.pages": "Páginas de flujos de trabajo",
  "notebook.label.pending": "Pendiente de revisión",
  "notebook.label.project": "Proyecto",
  "notebook.label.project.title": "Título del proyecto",
  "notebook.label.projectFiles": "Archivos del proyecto",
  "notebook.label.projectTags": "Etiquetas del proyecto",
  "notebook.label.protocol": "Identificador del protocolo",
  "notebook.label.questionnaire": "Cuestionario",
  "notebook.label.sampleManagement": "Gestión de muestras",
  "notebook.label.status": "Estado",
  "notebook.label.technician": "Técnico",
  "notebook.label.title": "Título de la entrada",
  "notebook.label.total": "Total de entradas",
  "notebook.page.completed": "Completado",
  "notebook.page.content": "Contenido:",
  "notebook.page.instructions": "Instrucciones:",
  "notebook.page.markComplete": "Marcar como completado",
  "notebook.page.modal.add.errorRequired": "El título y el contenido son obligatorios.",
  "notebook.page.modal.add.title": "Agregar una nueva página",
  "notebook.page.modal.content.label": "Contenido",
  "notebook.page.modal.edit.title": "Editar página",
  "notebook.page.modal.instructions.label": "Instrucciones",
  "notebook.page.modal.title.label": "Título",
  "notebook.page.title": "Cuaderno",
  "notebook.pages.none.subtitle": "Haga clic aquí para agregar páginas",
  "notebook.pages.none.title": "No se han agregado páginas",
  "notebook.project.definition.form.title": "Formulario de definición del proyecto",
  "notebook.project.entry.form.title": "Formulario de entrada del proyecto",
  "notebook.results.modal.title": "Resultados de {accession}",
  "notebook.results.noAccession": "No hay ningún número de acceso disponible para esta muestra",
  "notebook.results.none.subtitle": "No se encontraron resultados para el número de acceso facilitado.",
  "notebook.results.none.title": "No se encontraron resultados",
  "notebook.results.title": "Resultados",
  "notebook.sample.result.dateCreated": "Fecha de creación",
  "notebook.samples.available": "Muestras disponibles",
  "notebook.samples.none.subtitle": "Buscar muestras por paciente o Número de acceso",
  "notebook.samples.none.subtitle.selected": "Haga clic aquí para agregar muestras",
  "notebook.samples.none.title": "No hay muestras disponibles",
  "notebook.samples.none.title.selected": "No se han seleccionado muestras",
  "notebook.samples.resultsRecorded": "Resultados registrados:",
  "notebook.samples.selected": "Muestras seleccionadas",
  "notebook.search.byAccession": "Buscar por número de acceso",
  "notebook.search.byPatient": "Buscar por Paciente",
  "notebook.select.label": "Seleccionar cuaderno",
  "notebook.select.none": "None - default fields only",
  "notebook.select.optional": "Select a notebook (optional)",
  "notebook.status.archived": "Entrada del archivo",
  "notebook.status.assignment.title": "Estado y asignación",
  "notebook.status.draft": "Guardar borrador",
  "notebook.status.finalized": "Finalizar la inscripción",
  "notebook.status.locked": "Acceso con llave",
  "notebook.status.metadata.title": "Estado y metadatos",
  "notebook.status.submitted": "Enviar para su revisión",
  "notebook.tab.attachments": "Archivos adjuntos",
  "notebook.tab.auditTrail": "Registro de Auditoría",
  "notebook.tab.comments": "Comentarios",
  "notebook.tab.content": "Contenido",
  "notebook.tab.entryDetails": "Detalles de la entrada",
  "notebook.tab.metadata": "Metadatos",
  "notebook.tab.results": "Resultados",
  "notebook.tab.samples": "Muestras",
  "notebook.tab.workflow": "Flujo de trabajo",
  "notebook.table.header.entries": "Entradas",
  "notebook.tag.placeholder": "Ingrese las etiquetas",
  "notebook.tags.add": "Agregar etiqueta",
  "notebook.tags.modal.add.errorRequired": "Es obligatorio ingresar una etiqueta.",
  "notebook.tags.modal.add.label": "Etiqueta",
  "notebook.tags.modal.add.title": "Agregar una nueva etiqueta",
  "notebook.tags.title": "Etiquetas",
  "notebook.validation.content.required": "El contenido principal es obligatorio.",
  "notebook.validation.objective.required": "Es obligatorio indicar el objetivo.",
  "notebook.validation.project.required": "Es necesario presentar un proyecto.",
  "notebook.validation.protocol.required": "Es necesario indicar el ID del protocolo.",
  "notebook.validation.title.required": "Es obligatorio indicar el título.",
  "notebook.validation.type.required": "Es obligatorio indicar el «Tipo de experimento».",
  "notification.error": "Error",
  "notification.info": "Información",
  "notification.invalid.confirm.password": "La contraseña ingresada no coincide con la contraseña anterior.",
  "notification.invalid.loginName": "Por favor ingrese solo valores alfanuméricos sin espacios.",
  "notification.invalid.name": "Por favor ingrese solo valores alfanuméricos.",
  "notification.invalid.password": "Por favor ingrese una contraseña de acuerdo a las instrucciones.",
  "notification.login.generic.error": "Error al intentar iniciar sesión",
  "notification.login.syntax.error": "Error al intentar iniciar sesión - No se pudo analizar la respuesta a JSON",
  "notification.organization.post.delete.success": "Organización desactivada correctamente.",
  "notification.organization.post.internetAddress": "Ingrese una URL válida de la organización.",
  "notification.organization.post.save.success": "Información de la organización agregada correctamente.",
  "notification.organization.post.success": "Información de la organización actualizada correctamente.",
  "notification.password.change.fail": "Cambio de contraseña fallido",
  "notification.password.change.success": "Contraseña cambiada exitosamente",
  "notification.response.syntax.error": "Error - No se pudo analizar la respuesta a JSON",
  "notification.resultSelectList.post.save.success": "Lista de selección de resultados guardada con éxito.",
  "notification.resultSelectList.post.update.success": "Lista de selección de resultados actualizada con éxito.",
  "notification.slideover.button.hideread": "Ocultar leídos",
  "notification.slideover.button.markallasread": "Marcar todos como leídos",
  "notification.slideover.button.markasread": "Marcar como leído",
  "notification.slideover.button.reload": "Recargar",
  "notification.slideover.button.showread": "Mostrar leídos",
  "notification.slideover.button.subscribe": "Suscribirse en este Dispositivo",
  "notification.slideover.button.subscribe.fail": "Error al suscribir",
  "notification.slideover.button.subscribe.success": "Suscrito exitosamente",
  "notification.slideover.button.unsubscribe": "Desuscribirse",
  "notification.slideover.button.unsubscribe.fail": "Error al desuscribir",
  "notification.slideover.button.unsubscribe.success": "Desuscrito exitosamente",
  "notification.slideover.empty.header": "Estás al día",
  "notification.sliderover.empty.message": "No tienes notificaciones en este momento.",
  "notification.success": "Éxito",
  "notification.title": "Mensaje de notificación",
  "notification.user.add.success": "User information added successfully.",
  "notification.user.post.delete.success": "Usuario Desactivado Exitosamente.",
  "notification.user.post.save.success": "Información de Usuario Agregada Exitosamente.",
  "notification.user.update.success": "User information updated successfully.",
  "notify.error": "Usuario y Mensaje son requeridos",
  "notify.main.title": "Notificar Usuario",
  "notify.message": "Mensaje",
  "notify.user.by": "Usuario a notificar",
  "notify.user.success.notification": "Notificación enviada exitosamente",
  "of": "de",
  "openreports.activity.title": "Informes de actividad",
  "openreports.aggregate.title": "Informes agregados",
  "openreports.all.test.summary.title": "Resumen del informe de pruebas",
  "openreports.all.tests.aggregate": "Resumen de todas las pruebas",
  "openreports.hiv.aggregate": "Resumen de pruebas de VIH",
  "openreports.management.title": "Informes de gestión",
  "openreports.mgt.nonconformity.date": " Informe de no conformidad por fecha",
  "openreports.mgt.nonconformity.section": " Informe de no conformidad por unidad y motivo",
  "openreports.mgt.rejection": "Informe de rechazo",
  "openreports.patient.EID.version1": "EID Versión 1",
  "openreports.patient.EID.version2": "EID Versión 2",
  "openreports.patient.VL.version1": "VL Versión Nacional",
  "openreports.patientTestStatus": "Informe de estado del paciente",
  "openreports.patientreports.title": "Reporte de Estado del Paciente",
  "openreports.stat.aggregate": "Informe de estadísticas",
  "order.accept": "Aceptar",
  "order.accept.error": "No se ha podido aceptar la orden",
  "order.additionalInfo": "Información Adicional",
  "order.additionalInfo.helper": "Notas opcionales sobre esta orden",
  "order.clinicalInfo": "Información clínica",
  "order.continue": "Continuar",
  "order.current.time": "Hora actual (hh:mm)",
  "order.dashboard.empty": "No se han encontrado órdenes",
  "order.dashboard.title": "Panel de órdenes",
  "order.department.label": "sala/departamento/unidad:",
  "order.diagnosis.helper": "Diagnóstico provisional: sirve de guía para la selección de pruebas. No se registra como diagnóstico confirmado.",
  "order.diagnosis.placeholder": "Ingrese el diagnóstico o las notas clínicas",
  "order.entry.setup": "Configuración de entrada de órdenes por lote",
  "order.external": "Externo",
  "order.facility": "Instalación",
  "order.filter.priority": "Filtrar por prioridad",
  "order.filter.status": "Filtrar por estado",
  "order.fixIssue": "Solucionar el problema",
  "order.form.label": "Formulario:",
  "order.form.select": "Seleccionar formulario",
  "order.generate.barcode": "Generar código de barras y guardar",
  "order.generate.barcode.history": "Número de acceso utilizado anteriormente",
  "order.if.other.label": "si es otro, especificar:",
  "order.invalid.requester.name.label": "nombre de solicitante inválido",
  "order.invalid.site.name": "Nombre del sitio inválido",
  "order.labNumber": " Número de laboratorio",
  "order.labNumber.generate": "Generar número de laboratorio",
  "order.labNumber.helper": "Identificador único de esta orden",
  "order.attachment.action.delete": "Eliminar archivo adjunto",
  "order.attachment.action.download": "Descargar archivo adjunto",
  "order.attachment.action.view": "Consultar archivo adjunto",
  "order.attachment.column.actions": "Acciones",
  "order.attachment.column.fileName": "Nombre del archivo",
  "order.attachment.column.fileSize": "Tamaño",
  "order.attachment.column.fileType": "Tipo",
  "order.attachment.column.uploadedAt": "Subido el",
  "order.attachment.delete.confirm.body": "¿Está seguro de que desea eliminar «{fileName}»? Esta acción no se puede deshacer.",
  "order.attachment.delete.confirm.title": "Eliminar archivo adjunto",
  "order.attachment.delete.failed": "No se ha podido eliminar el archivo adjunto. Inténtelo de nuevo.",
  "order.attachment.dropzone": "Arrastre y suelte los archivos aquí, o haga clic para buscar",
  "order.attachment.empty": "Aún no hay archivos adjuntos.",
  "order.attachment.saveFirst": "Save the order to add attachments.",
  "order.attachment.error.maxFiles": "Puede adjuntar un máximo de {maxFiles} archivos.",
  "order.attachment.error.size": "Cada archivo debe tener un tamaño igual o inferior a {maxSize}.",
  "order.attachment.error.type": "Tipos de archivo admitidos: {types}",
  "order.attachment.heading": "Archivos adjuntos",
  "order.attachment.hint": "Opcional. Hasta {maxFiles} archivos, de 10 MB cada uno. Formatos admitidos: PDF, JPG, PNG, TIFF.",
  "order.attachment.upload.failed": "No se han podido cargar uno o varios archivos adjuntos.",
  "order.labNumber.placeholder": "Ingrese o genere un número de laboratorio",
  "order.label.add": "Agregar orden",
  "order.label.modify": "Modificar orden",
  "order.legend.EDTATube": "Tubo EDTA",
  "order.legend.commonFields": "Campos comunes",
  "order.legend.configureBarcode": "Configurar entrada de código de barras",
  "order.legend.dryBloodSpot": "Mancha de sangre seca",
  "order.legend.dryTube": "Tubo seco",
  "order.legend.facility": "Instalación",
  "order.legend.onDemand": "Bajo demanda",
  "order.legend.optionalFields": "Campos obligatorios",
  "order.legend.patient": "Información del paciente",
  "order.legend.preDemand": "Preimpreso",
  "order.legend.sample": "Muestra",
  "order.legend.selectMethod": "Seleccionar método",
  "order.legend.siteName": "Nombre del sitio",
  "order.legend.specimen.collected": "Muestra recolectada",
  "order.legend.tests": "Pruebas",
  "order.legend.viralLoadTest": "Prueba de carga viral",
  "order.lastUpdated": "Última actualización",
  "order.load.error": "No se ha podido cargar la orden",
  "order.location": "Ubicación",
  "order.new": "Nueva Orden",
  "order.payment.status.label": "Estado de pago del paciente:",
  "order.paymentStatus": "Estado del pago",
  "order.previousLabNumber": "Número de laboratorio",
  "order.previousLabNumber.placeholder": "Ingrese el número de laboratorio previo, si procede",
  "order.printLabels": "Imprimir etiquetas",
  "order.printLabels.info": "Imprimir códigos de barras para esta orden",
  "order.priority": " Prioridad",
  "order.progress": "Avances",
  "order.provisionalDiagnosis": "Diagnóstico provisional",
  "order.received.time": "Hora de recepción (hh:mm)",
  "order.reception.time": "Hora de recepción (hh:mm) :",
  "order.remember.site.and.requester.label": "Recordar sitio y solicitante",
  "order.readonly.message": "Esta orden se encuentra en modo de solo lectura.",
  "order.requester": " Solicitante",
  "order.requester.email.label": "Correo electrónico del solicitante:",
  "order.requester.fax.label": "Número de fax del solicitante:",
  "order.requester.firstName.label": "Nombre del solicitante:",
  "order.requester.lastName.label": "Apellido del solicitante:",
  "order.requester.phone.label": "Teléfono del solicitante:",
  "order.requester.provisionalDiagnosis.label": "Diagnóstico clínico provisional:",
  "order.result.reporting.heading": "REPORTE DE RESULTADOS",
  "order.sampleCategory": "Categoría de muestra",
  "order.sampleCategory.helper": "Seleccione la categoría de la muestra que desea recoger",
  "order.sampling.performed.label": "Muestreo realizado para análisis:",
  "order.search.requester.label": "Buscar solicitante",
  "order.saveStatus.error": " Error al guardar",
  "order.saveStatus.saved": "Guardado",
  "order.saveStatus.saving": "Guardando...",
  "order.saveStatus.unsaved": "Cambios no guardados",
  "order.save.blocked": "La orden no se ha guardado",
  "order.save.notPersisted": "El servidor aceptó la orden pero no guardó muestras para ella. Verifique la orden antes de continuar.",
  "order.save.incomplete": "Por favor, agregue un paciente (o centro de toma de muestras) y al menos un tipo de muestra antes de guardar.",
  "order.save.incomplete.fields": "Añada {fields} antes de guardar.",
  "order.save.incomplete.and": "y",
  "order.save.requirements.title": "Required before saving",
  "order.save.requirement.labNumber": "un número de laboratorio",
  "order.save.requirement.patient": "un paciente",
  "order.save.requirement.samplingSite": "un sitio de muestreo",
  "order.save.requirement.collectionSite": "un sitio de extracción",
  "order.save.requirement.requesterOrRequestor": "a requesting organisation or requestor",
  "order.sample.missingTests": "Sample {sampleNumber} has a sample type but no test. Add a test or remove the sample before saving.",
  "order.sample.missingTests.named": "Sample {sampleNumber}: {sampleType} has no test. Add a test or remove the sample before saving.",
  "order.save.requirement.sampleType": "al menos un tipo de muestra",
  "order.save.requirement.site": "un establecimiento solicitante",
  "order.save.requirement.patientSex": "the patient sex",
  "order.save.requirement.patientBirthDate": "the patient date of birth",
  "order.save.requirement.nationalId": "the patient national ID",
  "order.save.requirement.validEmail": "a valid email address",
  "order.requestDate": "Fecha de orden",
  "order.nextVisitDate": " Fecha de próxima visita",
  "order.sampleHandling": "Manejo de muestras",
  "sampleAcceptance.qa.button.continueWithTesting": "Continuar con las pruebas",
  "sampleAcceptance.qa.continueWithTesting.reason": "¿Por qué se está probando esta muestra a pesar de la verificación fallida?",
  "sampleAcceptance.qa.continueWithTesting.record": "Registrar y continuar",
  "order.eqaSample": "Muestra de evaluación externa de la calidad (ECA)",
  "order.noPatient": "Esta orden no tiene paciente",
  "order.noPatient.reason": "Motivo de la solicitud sin un paciente",
  "order.noPatient.reason.eqa": "Muestra de evaluación externa de la calidad",
  "order.noPatient.warning.title": "Los resultados no se evaluarán frente a un intervalo de referencia",
  "order.noPatient.warning.subtitle": "Sin un paciente no hay edad ni sexo para seleccionar un intervalo de referencia, por lo que los resultados de esta orden no se marcarán como normales o anormales.",
  "order.noPatient.butPatientChosen": "Hay un paciente adjunto a esta orden, por lo que no se registrará la decisión de ausencia de paciente.",
  "order.rangeNotApplied.warning.title": "Some results will not be checked against a reference range",
  "order.rangeNotApplied.warning.subtitle": "Patient sex or age is not recorded, and these tests have ranges that depend on it: {tests}. Their results will need review before release.",
  "order.rangeNotApplied.warning.reportNce": "Reportar NCE",
  "order.eqa.program": "Programa de ECA",
  "order.eqa.providerSampleId": "N.º de identificación de la muestra del proveedor",
  "order.eqa.deadline": "Fecha límite de presentación",
  "order.eqa.priority": "Prioridad de ECA",
  "order.rememberSiteAndRequester": "Recordar este establecimiento y solicitante para mi próxima orden",
  "order.testLocationCode": "Toma de muestra realizada en",
  "order.testLocationCode.other": "Otros",
  "order.testLocationCode.otherLabel": "Si es otro, especifique",
  "provider.fax.invalid": "Ingrese un número de fax válido, solo dígitos y + ( ) -.",
  "provider.email.invalid": "Ingrese una dirección de correo electrónico válida, por ejemplo lab@example.org.",
  "order.save.requirement.provider": "un proveedor solicitante",
  "order.save.requirement.testsPerSample": "al menos una prueba o panel en cada muestra",
  "order.saved.draft": "Borrador guardado",
  "order.saved.title": "Se ha guardado la orden {labNumber}",
  "order.saved.next": "Siguiente: {step}",
  "order.search.placeholder": "Buscar órdenes...",
  "order.search.site.name": "Buscar nombre del sitio",
  "order.send.toAnalyzer": "Enviar al Analizador",
  "order.send.modal.title": "Enviar la orden al Analizador",
  "order.send.modal.confirm": "Enviar",
  "order.send.modal.cancel": "Cancelar",
  "order.send.modal.analyzerLabel": "Analizador de objetivos",
  "order.send.modal.accession": "N.º de registro: {accession}",
  "order.send.modal.noAnalyzers": "No hay ningún analizador configurado para el envío iniciado desde el LIS.",
  "order.send.success": "Orden enviado",
  "order.send.error": "No se ha podido tramitar el pedido",
  "order.send.unknownError": "Error desconocido en el puente",
  "order.send.missingAccession": "El pedido no tiene número de acceso con el que se pueda relacionar el resultado.",
  "order.site.name": "Nombre del sitio:",
  "order.step.collect": "Recolectar",
  "order.step.complete": "Completado",
  "order.step.enter": " Ingresar orden",
  "order.step.label": "Etiquetar y almacenar",
  "order.step.patient.info": "Información del paciente",
  "order.step.program.selection": "Selección de programa",
  "order.step.qa": "Revisión de calidad",
  "order.step.prepare": "Prepare Samples",
  "order.step.sampleCheck": "Sample check",
  "order.step.notStarted": "Aún no se ha iniciado",
  "order.step.done": "Hecho",
  "order.step.doneAt": "Done {time}",
  "order.step.toDo": "{count} to do",
  "order.step.ready": "Ready",
  "order.nav.saveExit": "Save and exit",
  "order.nav.saveNext": "Save and next",
  "order.nav.saveFinish": "Save and finish",
  "order.nav.discard.title": "Discard unsaved changes?",
  "order.nav.discard.body": "Unsaved changes on this page will be lost ({samples} samples, {tests} tests).",
  "order.nav.discard.order": "Discard order",
  "order.nav.discard.changes": "Descartar cambios",
  "order.continue.heading": "To continue to {step}",
  "order.continue.count": "{count} items needed to continue",
  "order.continue.countOne": "1 item needed to continue",
  "order.continue.item.patient": "Select or create the patient",
  "order.continue.item.labNumber": "Add a lab number",
  "order.continue.item.nationalId": "Enter the patient's National ID",
  "order.continue.item.patientSex": "Choose the patient's sex",
  "order.continue.item.birthDate": "Enter the patient's date of birth",
  "order.continue.item.sampleType": "Add at least one sample type",
  "order.continue.item.provider": "Add the requesting provider",
  "order.continue.item.noTests": "Sample {number}: choose at least one test",
  "order.continue.item.noTestsOnSample": "{sample} has no tests. Add them on Enter Order or remove the sample",
  "errors.samples.with.no.tests": "A sample has no tests. Add tests on Enter Order or remove the sample.",
  "order.continue.item.collectionTime": "Collection date and time for {sample}",
  "order.continue.item.consent": "Record consent",
  "order.continue.item.acceptance": "Answer the sample acceptance checklist",
  "order.status.entered": "Entered",
  "order.status.samplesPrepared": "Samples prepared",
  "order.status.readyForTesting": "Ready for testing",
  "order.status.cancelled": "Cancelado",
  "order.status.complete": "Completado",
  "order.cancelled.notice": "This order was cancelled: {reason}",
  "order.cancelled": "This order is already cancelled",
  "order.notFound": "No se ha encontrado la orden",
  "order.cancel.reasonRequired": "A reason for cancelling is required",
  "order.cancel.complete": "Order entry is finished; this order can no longer be cancelled here",
  "order.cancel.inProgress": "Testing has started on this order; it can no longer be cancelled here",
  "order.release.prepareIncomplete": "Prepare Samples is not complete",
  "order.release.reasonRequired": "Reason for releasing before every sample is accepted",
  "order.finish.title": "Order {labNo} complete",
  "order.finish.subtitle": "Order entry is finished. Results can be entered as they arrive.",
  "order.finish.backToOrders": "Back to orders",
  "order.finish.awaiting": "Still awaiting a sample: {tests}",
  "order.sampleCheck.release": "Release for testing",
  "order.sampleCheck.return": "Return to Prepare Samples",
  "order.sampleCheck.proceedReason": "Reason for releasing before every sample is accepted",
  "order.sampleCheck.notAcceptedYet": "Not accepted yet: {samples}. Answers count once you press Accept sample.",
  "order.sampleCheck.released": "Order {labNo} released for testing",
  "order.sampleCheck.disabled.incomplete": "Prepare Samples is not complete. Open it and finish the samples first.",
  "order.dashboard.cancelOrder": "Cancel order",
  "order.dashboard.cancel.reason": "Reason for cancelling",
  "order.dashboard.cancel.reasonOther": "Describe the reason",
  "order.dashboard.cancel.other": "Otros",
  "order.dashboard.cancel.confirm": "Cancel order {labNo}?",
  "order.dashboard.cancel.body": "Its tests are cancelled and its samples are voided. Nothing is deleted.",
  "order.dashboard.cancelled": "Order {labNo} cancelled",
  "order.dashboard.filter.cancelled": "Cancelado",
  "order.dashboard.open": "Abrir",
  "order.samples.printLabels": "Imprimir etiquetas",
  "order.samples.notStored": "Not stored",
  "storage.noSamples": "Add a sample above to store it.",
  "common.discard": "Descartar",
  "common.stay": "Stay",
  "order.start.new": "Iniciar una nueva orden",
  "order.submit.labNumber": "Envíe con el número de laboratorio",
  "order.submit.success": "La orden se ha enviado correctamente",
  "order.submit.success.labNumber": "Lab Number: {labNumber}",
  "order.submitted.success.msg": "El pedido se ha enviado correctamente",
  "order.summary.accessionNumber": "Número de acceso",
  "order.summary.collectionDate": "Fecha de recolección",
  "order.dashboard.status.all": "Todos los estados",
  "order.dashboard.status.inProgress": "En progreso",
  "order.dashboard.status.pendingQa": "Awaiting sample check",
  "order.dashboard.status.completed": "Completado",
  "order.dashboard.status.hasReferred": "Has referred tests",
  "order.dashboard.status.referredOut": "Referido",
  "order.dashboard.priority.all": "Todas las prioridades",
  "order.dashboard.priority.stat": "STAT",
  "order.dashboard.priority.asap": "ASAP",
  "order.dashboard.priority.timed": "Programado",
  "order.dashboard.priority.routine": "Rutina",
  "order.summary.patientName": "Nombre del paciente",
  "order.summary.sampleType": " Tipo de muestra",
  "order.summary.title": "Resumen del pedido",
  "order.test.request.heading": "Solicitud de prueba",
  "order.title": "ORDEN",
  "ordertests.title": " Solicitar pruebas",
  "organization.add.placeholder": "Valores alfanuméricos",
  "organization.add.placeholder.active": "S o N",
  "organization.add.placeholder.internetAddress": "https://orgname.com",
  "organization.add.placeholder.parent": "Organización superior",
  "organization.add.title": "Agregar organización",
  "organization.city": " Ciudad",
  "organization.clia.number": "Número CLIA",
  "organization.edit.title": "Editar organización",
  "organization.internetaddress": "Dirección de Internet",
  "organization.isActive": "Está activa",
  "organization.main.title": "Gestión de organizaciones",
  "organization.next": "Página siguiente",
  "organization.organizationName": "Nombre de la organización",
  "organization.parent": "Org superior",
  "organization.previous": "Página anterior",
  "organization.search.byorgname": "Buscar por nombre de organización",
  "organization.search.parent.name": "Nombres de organizaciones superiores",
  "organization.search.placeHolder": "Buscar por nombre de organización...",
  "organization.select": "Seleccionar",
  "organization.short.CI": "Prefijo de la organización",
  "organization.streetAddress": "Dirección postal",
  "organization.type.CI": "Tipo de actividad",
  "organization.type.CI.description": "Tipo de actividad: Descripción",
  "organization.type.CI.name": "Tipo de actividad: Nombre",
  "organization.type.CI.select": "Tipo de actividad: Seleccionar",
  "otherMalignant.placeholder": " Otro maligno",
  "page.breadcrumb.separator": " > ",
  "page.title.back": "Atrás",
  "pagination.backward": " Página anterior",
  "pagination.forward": " Página siguiente",
  "pagination.item": "{min}-{max}",
  "pagination.item-range": " {min}-{max} de {total} elementos",
  "pagination.items-on-page": "{count} {count, plural, one {item} other {items}} on this page",
  "pagination.items-per-page": " Elementos por página",
  "pagination.itemsPerPage": "Elementos por página:",
  "pagination.nextPage": "Página siguiente",
  "pagination.page": " página {page}",
  "pagination.page-number": " Número de página",
  "pagination.page-range": "de {total} {total, plural, one {página} other {páginas}}",
  "pagination.previousPage": "Página anterior",
  "panel.existing": "Paneles Existentes",
  "panel.existing.inactive": "Paneles Inactivos (Asigne pruebas para activar)",
  "panel.new": "Nuevo Panel",
  "panel.panelName": "Nombre del Panel",
  "pathology.action.addCassette": "Add cassette",
  "pathology.action.addSlide": "Add slide",
  "pathology.action.deactivateBlock": "Deactivate block {designation}",
  "pathology.action.deactivateCassette": "Deactivate cassette {designation}",
  "pathology.action.deactivateSlide": "Deactivate slide {barcode}",
  "pathology.action.printCassetteLabels": "Print all cassette labels",
  "pathology.action.printSlideLabels": "Print all slide labels",
  "pathology.badge.cassetteCount": "{count, plural, one {# cassette} other {# cassettes}}",
  "pathology.badge.openRequestCount": "{count} open",
  "pathology.badge.openRequests": "Open requests: {names}",
  "pathology.badge.openRequestsMore": "Open requests: {names} and {count} more",
  "pathology.badge.slideCount": "{count, plural, one {# slide} other {# slides}}",
  "pathology.banner.transitionsLater": "Stage transitions arrive in a later release. Set the stage here for now.",
  "pathology.empty.noReports": "No reports yet. Complete the findings and conclusion to generate one.",
  "pathology.empty.stageNotRecorded": "OpenELIS does not record work at this stage yet. The case can still be moved through it.",
  "pathology.error.designationConflict": "Another save changed this case at the same moment. Reload the case and try again.",
  "pathology.label.addslide": "Agregar diapositiva(s)",
  "pathology.label.block": "Bloque",
  "pathology.label.block.number": "Número de bloque",
  "pathology.label.blocks": "Bloques",
  "pathology.label.case": "Pathology Case",
  "pathology.label.caseTitle": "Pathology Case {labNumber}",
  "pathology.label.casesInProgress": "Casos en progreso",
  "pathology.label.cassette": "Cassette",
  "pathology.label.cassettes": "Cassettes",
  "pathology.label.complete": "Completado",
  "pathology.label.conclusion": "Conclusión",
  "pathology.label.dashboard": "Panel de patología",
  "pathology.label.deactivating": "Deactivating",
  "pathology.label.designationPending": "Assigned on save",
  "pathology.label.grossexam": "Examen macroscópico",
  "pathology.label.location": "Ubicación",
  "pathology.label.microexam": "Examen microscópico",
  "pathology.label.newCassette": "New cassette {position}",
  "pathology.label.newSlide": "New slide {position}",
  "pathology.label.parentBlock": "Cut from block",
  "pathology.label.printlabel": "Imprimir etiqueta",
  "pathology.label.refer": "Referir a inmunohistoquímica",
  "pathology.label.release": "Listo para liberar",
  "pathology.label.report": "Reporte de Patología",
  "pathology.label.request": "Solicitudes",
  "pathology.label.requests": "Solicitudes adicionales de patología",
  "pathology.label.review": "En espera de revisión patológica",
  "pathology.label.slide": "Diapositiva",
  "pathology.label.slide.add.number": "Número de láminas a agregar",
  "pathology.label.slide.number": "número de diapositiva",
  "pathology.label.slides": "Diapositivas",
  "pathology.label.stage": "Etapa",
  "pathology.label.techniques": "Técnicas utilizadas",
  "pathology.label.textconclusion": "Conclusión de texto",
  "pathology.label.title": "Patología",
  "pathology.label.view": "Ver archivo",
  "pathology.locked.nothingToPrint": "No saved labels to print yet",
  "pathology.locked.reasonRequired": "Give a reason before deactivating",
  "pathology.locked.releaseNoPathologist": "A pathologist must be assigned before the case can be released",
  "pathology.locked.releaseNoTechnician": "A technician must be assigned before the case can be released",
  "pathology.locked.saveBeforeDeactivate": "Save or discard your changes before deactivating",
  "pathology.locked.slideNeedsBlock": "Pick the block this slide was cut from",
  "pathology.locked.slideNeedsSavedBlock": "Save a cassette before adding a slide",
  "pathology.locked.stageDisabled": "Not tracked at this laboratory",
  "pathology.modal.deactivateBlockHeading": "Deactivate block {designation}?",
  "pathology.modal.deactivateBody": "The record is kept and stays available under Show deactivated. Cassettes, blocks and slides are never deleted.",
  "pathology.modal.deactivateCassetteHeading": "Deactivate cassette {designation}?",
  "pathology.modal.deactivateFailed": "The deactivation was refused. Reload the case and try again.",
  "pathology.modal.deactivateSlideHeading": "Deactivate slide {barcode}?",
  "pathology.section.caseInfo": "Case Information",
  "pathology.section.findings": "Findings & Conclusion",
  "pathology.section.review": "Pathologist Review",
  "pathology.stage.accessioned": "Registrada",
  "pathology.stage.completed": "Completado",
  "pathology.stage.coverslipping": "Montaje y CC",
  "pathology.stage.decalcification": "Descalcificación",
  "pathology.stage.embedding": "Inclusión",
  "pathology.stage.grossing": "Macroscopía",
  "pathology.stage.microtomy": "Microtomía",
  "pathology.stage.processing": "Procesamiento",
  "pathology.stage.readyPathologist": "Listo para el patólogo",
  "pathology.stage.staining": "Coloración",
  "pathology.stage.underReview": "En revisión por el patólogo",
  "pathology.toast.blockDeactivated": "Block {designation} deactivated",
  "pathology.toast.cassetteDeactivated": "Cassette {designation} deactivated",
  "pathology.toast.slideDeactivated": "Slide {barcode} deactivated",
  "patient.address.camp": "Campamento/Comune",
  "patient.address.fokontany": "Fokontany",
  "patient.address.hamletOrLot": "Caserío / Lote",
  "patient.address.healthdistrict": "Distrito",
  "patient.address.healthregion": "Región",
  "patient.address.province": "Provincia",
  "patient.address.street": "Calle",
  "patient.address.town": "Ciudad",
  "patient.age.days": "Días",
  "patient.age.months": "Meses",
  "patient.age.years": "Edad/Años",
  "patient.alias": "Alias",
  "patient.dataSourceName": "Nombre de Fuente de Datos",
  "patient.dob": "Fecha de nacimiento",
  "patient.dob.future": "Date of birth cannot be in the future.",
  "patient.validation.contactEmailInvalid": "Enter a valid email address for the contact.",
  "patient.validation.dobInvalid": "Enter a valid date of birth.",
  "patient.validation.dobOrAgeRequired": "Enter a date of birth or an age in years, months or days.",
  "patient.validation.emailInvalid": "Enter a valid email address.",
  "patient.validation.nationalIdRequired": "Enter the national ID.",
  "patient.validation.sexRequired": "Select the patient's sex.",
  "patient.eduction": "Educación",
  "patient.emergency.additional.camp": "Ingresar campamento/comuna",
  "patient.emergency.additional.district": "Ingresar distrito",
  "patient.emergency.additional.education": "Ingresar educación",
  "patient.emergency.additional.maritalstatus": "Ingresar estado civil",
  "patient.emergency.additional.nationnality": "Ingresar nacionalidad",
  "patient.emergency.additional.othernationality": "Ingresar otra nacionalidad",
  "patient.emergency.additional.region": "Ingresar región",
  "patient.emergency.additional.street": "Ingresar calle",
  "patient.emergency.additional.town": "Ingresar ciudad",
  "patient.emergency.email": "Ingresar correo electrónico del contacto de emergencia",
  "patient.emergency.firstname": "Ingresar nombre del contacto de emergencia",
  "patient.emergency.lastname": "Ingresar apellido del contacto de emergencia",
  "patient.emergency.phone": "Ingresar número de teléfono del contacto de emergencia",
  "patient.externalId": "ID Nacional",
  "patient.female": "Femenino",
  "patient.first.name": "Nombre",
  "patient.gender": "Género",
  "patient.gps.latitude": "Latitud GPS",
  "patient.gps.latitude.placeholder": "p. ej., -18.879190 (rango de -90 a 90)",
  "patient.gps.longitude": "Longitud GPS",
  "patient.gps.longitude.placeholder": "p. ej., 47.507905 (rango de -180 a 180)",
  "patient.id": "Id del paciente",
  "patient.information.age": "Ingresar edad",
  "patient.information.days": "Ingresar días",
  "patient.information.email": "Ingrese el Correo Electrónico del Paciente",
  "patient.information.firstname": "Ingresar nombre del paciente",
  "patient.information.healthid": "Ingresar identificador de salud único",
  "patient.information.lastname": "Ingresar apellido del paciente",
  "patient.information.months": "Ingresar meses",
  "patient.information.nationalid": "Ingresar identificador nacional",
  "patient.information.primaryphone": "Ingresar número principal del paciente",
  "patient.label": "Paciente",
  "patient.label.additionalInfo": "Información Adicional",
  "patient.label.age": "Edad",
  "patient.label.customNotes": "Notas personalizadas",
  "patient.label.diseaseProgramme": "Programa de enfermedades objetivo",
  "patient.label.occupation": "Profesión",
  "patient.label.contactphone": "Teléfono de contacto:{PHONE_FORMAT}",
  "patient.label.email": "Correo Electrónico",
  "patient.label.info": "Información del paciente",
  "patient.label.modify": "Agregar o modificar paciente",
  "patient.label.name": "Nombre",
  "patient.label.nopatientid": "No hay información del paciente disponible",
  "patient.label.primaryphone": "Teléfono principal:{PHONE_FORMAT}",
  "patient.label.sex": "Sexo",
  "patient.last.name": "Apellido",
  "phone.format.international.label": "Internacional",
  "phone.format.local.label": "Local",
  "patient.male": "Masculino",
  "patient.maritalstatus": "Estado civil",
  "patient.merge.activeOrders": "Órdenes activas",
  "patient.merge.address": "Dirección",
  "patient.merge.addressesDiffer": "La dirección es diferente: {primary} frente a {secondary}",
  "patient.merge.auditEntries": "Entradas de auditoría (se conservará el paciente original)",
  "patient.merge.back": "Atrás",
  "patient.merge.cancelButton": "Cancelar",
  "patient.merge.clinicalSummary": "Resumen clínico",
  "patient.merge.confirmButton": "Confirmar fusión",
  "patient.merge.confirmCheckbox": "Entiendo que esta acción no se puede revertir y he comprobado que se están fusionando los pacientes correctos",
  "patient.merge.confirmMerge": "Confirmar la fusión de pacientes",
  "patient.merge.conflictNote": "(Se utilizarán los datos demográficos del paciente principal)",
  "patient.merge.conflictingInfo": "Se ha detectado información contradictoria",
  "patient.merge.contactInfo": "Datos de contacto",
  "patient.merge.county": "Condado/Estado",
  "patient.merge.dataToConsolidate": "Datos que deben consolidarse",
  "patient.merge.demographics": "Datos demográficos",
  "patient.merge.dob": "Fecha de nacimiento",
  "patient.merge.email": "Correo Electrónico",
  "patient.merge.emailsDiffer": "El Correo Electrónico es diferente: {primary} frente a {secondary}",
  "patient.merge.error.alreadyMerged": "El paciente ya se ha fusionado",
  "patient.merge.error.executionFailed": "La ejecución de la fusión ha fallado",
  "patient.merge.error.noPermission": "Solo los administradores globales pueden fusionar pacientes",
  "patient.merge.error.patientNotFound": "No se ha encontrado al paciente",
  "patient.merge.error.samePatient": "No es posible fusionar un paciente consigo mismo",
  "patient.merge.error.selectBoth": "Seleccione a ambos pacientes para continuar",
  "patient.merge.error.selectPrimary": "Seleccione, por favor, qué paciente debe figurar como paciente principal en el expediente.",
  "patient.merge.error.validationFailed": "La validación de la fusión ha fallado",
  "patient.merge.externalIds": "Identificadores externos",
  "patient.merge.gender": "Sexo",
  "patient.merge.identifiers": "Identificadores",
  "patient.merge.identifiersToPreserve": "Identificadores que deben conservarse (ambos pacientes)",
  "patient.merge.mergeSummary": "Resumen de la fusión",
  "patient.merge.mergingFrom": "Fusión desde",
  "patient.merge.mergingLabel": "Fusión",
  "patient.merge.name": " Nombre",
  "patient.merge.nationalId": "ID Nacional",
  "patient.merge.nationalIds": "ID Nacional",
  "patient.merge.nextStep": "Siguiente paso",
  "patient.merge.noIdentifiers": "No se han registrado identificadores",
  "patient.merge.noPatientSelected": "No se ha seleccionado ningún paciente",
  "patient.merge.notRecorded": "No se ha registrado",
  "patient.merge.orders": "Órdenes",
  "patient.merge.ordersCount": "{count} ({active} activo)",
  "patient.merge.patientId": " ID del paciente",
  "patient.merge.patientIds": "ID del paciente",
  "patient.merge.patientResults": "Resultados de los pacientes",
  "patient.merge.phone": "Teléfono",
  "patient.merge.phonesDiffer": "Los números de teléfono son diferentes: {primary} frente a {secondary}",
  "patient.merge.postalCode": "Código postal",
  "patient.merge.primaryLabel": "Principal",
  "patient.merge.primaryPatient": "Paciente principal",
  "patient.merge.reason": "Motivo de la fusión (obligatorio)",
  "patient.merge.reasonPlaceholder": "Indique el motivo por el que se fusionan estos historiales clínicos...",
  "patient.merge.recordsReassigned": "{count} registros reasignados",
  "patient.merge.samples": "Muestras",
  "patient.merge.searchDifferent": "Buscar otro paciente",
  "patient.merge.selectFirstPatient": "Seleccione el primer paciente",
  "patient.merge.selectPrimaryDescription": "¿Qué paciente debería constituir el expediente principal?",
  "patient.merge.selectPrimaryRecord": "Seleccione el expediente clínico principal del paciente",
  "patient.merge.selectSecondPatient": "Seleccione el segundo paciente",
  "patient.merge.step.compare": "Seleccionar «Principal»",
  "patient.merge.step.confirm": "Confirmar fusión",
  "patient.merge.step.select": "Seleccionar pacientes",
  "patient.merge.streetAddress": "Dirección postal",
  "patient.merge.success": "La fusión de pacientes se ha completado correctamente",
  "patient.merge.successMessage": "El paciente {mergedId} se ha fusionado con el paciente {primaryId}. ID de auditoría: {auditId}",
  "patient.merge.testResults": " Resultados de prueba",
  "patient.merge.title": "Fusionar historiales clínicos de pacientes",
  "patient.merge.totalContacts": "Contactos",
  "patient.merge.totalRelations": "Relaciones",
  "patient.merge.totalResults": "Resultados totales",
  "patient.merge.totalSamples": "Muestras",
  "patient.merge.town": "Ciudad/Pueblo",
  "patient.merge.tryDifferentSearch": "Pruebe a modificar sus criterios de búsqueda o a utilizar otros identificadores de pacientes.",
  "patient.merge.warning.dataLink": "Todos los datos futuros se vincularán al paciente principal. El paciente no seleccionado se marcará como fusionado e inactivo.",
  "patient.merge.warning.irreversible": "Esta acción NO SE PUEDE deshacer. Todos los datos se consolidarán de forma permanente.",
  "patient.merge.warning.samePatient": "Se ha seleccionado el mismo paciente",
  "patient.merge.warning.samePatientDescription": "Ha seleccionado al mismo paciente para ambos registros. Seleccione dos pacientes diferentes para fusionarlos.",
  "patient.natioanalid": "ID Nacional",
  "patient.nationalid": "ID Nacional",
  "patient.nationality": "Nacionalidad",
  "patient.nationality.other": "Especificar otra nacionalidad",
  "patient.photo.active.camera": "Haga clic para activar la cámara",
  "patient.photo.add": "Agregar foto",
  "patient.photo.browse": "Haga clic aquí para explorar los archivos",
  "patient.photo.camera.permission.denied": "Se ha denegado el permiso de acceso a la cámara. Por favor, compruebe la configuración de su navegador.",
  "patient.photo.cancel": "Cancelar",
  "patient.photo.capture": "Hacer una foto",
  "patient.photo.captured": "Fotografía tomada:",
  "patient.photo.change": "Cambiar imagen",
  "patient.photo.confirm": "Confirmar",
  "patient.photo.dragndrop": "Arrastre y suelte una imagen aquí",
  "patient.photo.error.fileTooLarge": "La imagen es demasiado grande. El tamaño máximo es de 2 MB.",
  "patient.photo.formats": "Formatos: JPG, PNG (máx. 2 MB)",
  "patient.photo.import": "Importar",
  "patient.photo.label": "Fotografía del paciente",
  "patient.photo.modal.heading": "Seleccione una fotografía del paciente",
  "patient.photo.modal.options": "Opciones para seleccionar imágenes",
  "patient.photo.preview": "Vista previa:",
  "patient.photo.preview.alt": "Vista previa de la fotografía del paciente",
  "patient.photo.preview.captured.alt": "Fotografía del paciente tomada",
  "patient.photo.retake": "Repetir",
  "patient.photo.start.camera": "Iniciar la cámara",
  "patient.photo.take": "Haga una foto",
  "patient.photo.view": "Consultar foto",
  "patient.idDoc.title": "Documentos de identidad",
  "patient.idDoc.addDocument": "Agregar documento",
  "patient.idDoc.selectImage": "Seleccione una imagen",
  "patient.idDoc.documentType": "Tipo de documento",
  "patient.idDoc.description": "Descripción",
  "patient.idDoc.description.placeholder": "Ingrese la descripción del documento",
  "patient.idDoc.category.nationalId": "ID Nacional",
  "patient.idDoc.category.insuranceCard": "Tarjeta del seguro",
  "patient.idDoc.category.other": "Otros",
  "patient.idDoc.view": "Consultar",
  "patient.idDoc.edit": "Editar",
  "patient.idDoc.delete": "Eliminar",
  "patient.idDoc.remove": "Eliminar",
  "patient.idDoc.pending": "Sin guardar",
  "patient.idDoc.empty": "No se han subido documentos de identificación",
  "patient.idDoc.viewDocument": "Consultar documento",
  "patient.idDoc.editDocument": "Editar documento",
  "patient.idDoc.confirmDelete": "Eliminar documento",
  "patient.idDoc.deleteWarning": "¿Está seguro de que desea eliminar este documento? Esta acción no se puede deshacer.",
  "patient.idDoc.upload": "Subir",
  "patient.idDoc.dragndrop": "Arrastre y suelte un archivo aquí",
  "patient.idDoc.browse": "o haga clic para explorar los archivos",
  "patient.idDoc.formats": "Formatos: JPEG, PNG, PDF (máx. 10 MB)",
  "patient.idDoc.useCamera": "Utilizar la cámara",
  "patient.idDoc.pdfSelected": "Documento PDF seleccionado",
  "patient.idDoc.error.invalidFormat": "Formato de archivo no válido. Formatos aceptados: JPEG, PNG, PDF.",
  "patient.idDoc.error.fileTooLarge": "El archivo es demasiado grande. El tamaño máximo es de 10 MB.",
  "patient.prev.lab.no": "Número de laboratorio",
  "patient.report.associated.name": "Reporte de Paciente Asociado",
  "patient.report.collection.name": "Reporte de Paciente ARV Recolectado",
  "patient.search.nopatient": " No se encontraron pacientes que coincidan con los términos de búsqueda",
  "patient.st.number": "N.º ST",
  "patient.subject.number": "Número de identificación de salud único",
  "patient.yrs": "años",
  "patientcontact.person.email": "Correo electrónico del contacto",
  "patientcontact.person.firstname": "Nombre del contacto",
  "patientcontact.person.lastname": "Apellido del contacto",
  "placeholder.accession.number": "Introduzca el número de acceso.",
  "print.barcode": "Imprimir Código de Barras",
  "process.testAdd.pressNext.ageRangeSelectiong": "Presione el botón Siguiente ¡La selección de Rango de Edad no es obligatoria!",
  "process.testAdd.pressNext.selectGroupDictionary": "Presione el botón Siguiente ¡La selección de la Lista de Diccionario de Grupo no es obligatoria!",
  "program.name.label": "Nombre del programa",
  "project.ARVFollowupStudy.name": "ARV de Seguimiento",
  "project.ARVStudies.name": "ARV",
  "project.ARVStudy.name": "ARV Inicial",
  "project.EIDStudy.name": "EID",
  "project.IndeterminateStudy.name": "Indeterminado",
  "project.RTNStudy.name": "RTN",
  "project.Recency.name": "Pruebas de Reciente Infección",
  "project.SequencingStudy.name": "Secuenciación",
  "project.SpecialRequestStudy.name": "Solicitud Especial",
  "project.VLStudy.name": "VL",
  "project.add.subtitle": "Agregar Proyecto",
  "project.add.title": "Agregar Proyecto",
  "project.browse.title": "Proyecto",
  "project.completedDate": "Fecha de Finalización",
  "project.desc.short": "Descripción del Proyecto",
  "project.description": "Descripción del Proyecto",
  "project.edit.subtitle": "Editar Proyecto",
  "project.edit.title": "Editar Proyecto",
  "project.external.reference": "Referencia Externa",
  "provider.browse.title": " Gestión de proveedores",
  "provider.email": "Correo Electrónico",
  "provider.fax": "Fax",
  "provider.isActive": " Está activo",
  "provider.modal.add.heading": "Agregar proveedor",
  "provider.modal.update.heading": "Actualizar proveedor",
  "provider.providerFirstName": " Nombre del proveedor",
  "provider.providerLastName": " Apellido del proveedor",
  "provider.search": " Buscar proveedor",
  "provider.search.placeholder": " Buscar nombre del proveedor...",
  "provider.select": " Seleccionar proveedor",
  "provider.telephone": " Teléfono",
  "qa.checklist.incomplete": "La lista de comprobación de control de calidad está incompleta",
  "qa.checklist.instructions": "Todas las comprobaciones necesarias deben estar completadas antes de enviarlo",
  "qa.checklist.samplingSiteCorrect": "La información del sitio sobre los puntos de muestreo es correcta",
  "qa.checklist.title": "Lista de comprobación de control de calidad",
  "qa.summary.noSamples": "No hay muestras que revisar",
  "qa.summary.noTests": "No se ha seleccionado ninguna prueba",
  "qa.summary.order": "Detalles de la orden",
  "qa.summary.panel": "Panel",
  "qa.summary.patient": "Información del paciente",
  "qa.summary.poolOf": "Pool de {count} {animal}",
  "qa.summary.samples": "Resumen de muestra",
  "qa.summary.samplingSite": "Sitio de muestreo",
  "qa.summary.siteCode": "Código del sitio",
  "qa.summary.siteName": " Nombre del sitio",
  "qc.comments.add": "Agregar comentario",
  "qc.comments.empty": "Aún no hay comentarios",
  "qc.comments.placeholder": "Introduzca un comentario de QC...",
  "qc.comments.title": "Comentarios de QC",
  "qc.expectedValue": "Valor esperado",
  "qc.frequency.compliance": "Indicadores de cumplimiento",
  "qc.frequency.config": "Configuración de la frecuencia de control de QC",
  "qc.frequency.daily": "Startup del día",
  "qc.frequency.everyHours": "Cada N horas",
  "qc.frequency.everySamples": "Cada N muestras",
  "qc.frequency.manual": "Solo disparo manual",
  "qc.frequency.notConfigured": "No está configurado",
  "qc.frequency.perShift": "Por turno",
  "qc.frequency.save": "Guardar configuración",
  "qc.frequency.type": "Tipo de frecuencia",
  "qc.frequency.value": "Valor de frecuencia",
  "qc.leveyJennings.mean": "Media",
  "qc.leveyJennings.minus2SD": "-2 SD",
  "qc.leveyJennings.minus3SD": "-3 DE",
  "qc.leveyJennings.noData": "No hay datos de QC disponibles",
  "qc.leveyJennings.plus2SD": "+2 SD",
  "qc.leveyJennings.plus3SD": "+3 SD",
  "qc.leveyJennings.title": "Gráfico de control de Levey-Jennings",
  "qc.notes": "Notas de QC",
  "qc.notes.placeholder": "Introduzca las notas y observaciones de QC",
  "qc.parentSample": "Muestra para padres",
  "qc.signature.comment": "Comentario (opcional)",
  "qc.signature.comment.placeholder": "Agregue un comentario...",
  "qc.signature.ipAddress": "Dirección IP",
  "qc.signature.noSignatures": "Aún no hay firmas",
  "qc.signature.sign": "Firmar el informe",
  "qc.signature.signedAt": "Fecha de firma",
  "qc.signature.success": "El informe se ha firmado correctamente",
  "qc.signature.title": "Firmas electrónicas",
  "qc.signature.userId": "ID de usuario",
  "qc.status": "Estado del CC",
  "qc.status.failed": "Fallido",
  "qc.status.notRequired": "No es obligatorio",
  "qc.status.passed": "Aprobado",
  "qc.status.pending": "Pendiente de QC",
  "qc.status.select": "Seleccione el estado de CC",
  "qc.status.update.button": "Actualizar el estado del CC",
  "qc.status.update.success": "El estado de CC se ha actualizado correctamente",
  "qc.status.update.title": "Actualizar el estado del CC",
  "qc.status.warning.message": "Si marca este lote como «Fallido», se impedirá su uso hasta que se actualice el estado del CC.",
  "qc.status.warning.title": "Aviso de fallo en el CC",
  "qc.westgard.noViolations": "No se han detectado infracciones",
  "qc.westgard.rule.disabled": "Desactivado",
  "qc.westgard.rule.enabled": "Activado",
  "qc.westgard.rules": "Reglas de Westgard",
  "qc.westgard.rules.description": "Configurar la evaluación del QC con múltiples reglas de Westgard",
  "qc.westgard.violations": "Infracciones",
  "quantity": "Cantidad",
  "quantity.balanced": "Cantidad equilibrada",
  "quantity.not.balanced": "La cantidad no cuadra",
  "quick.entry.accession.number": "Número de acceso",
  "referTest.referralLabel": " Enviar prueba a un laboratorio de referencia",
  "referral.button.labSearch": "Buscar Referencias Por Número de Laboratorio",
  "referral.button.patientSearch": "Buscar Paciente",
  "referral.button.unitTestSearch": "Buscar Referencias Por Unidad(es) y Prueba(s)",
  "referral.date.end": "Fecha Final (dd/mm/aaaa)",
  "referral.date.start": "Fecha de inicio (dd/mm/aaaa)",
  "referral.emptyState": "No se han encontrado referencias que se ajusten a los filtros seleccionados.",
  "referral.error": "No hay referencias que coincidan con los criterios",
  "referral.input": "Escanear o Ingresar Manualmente",
  "referral.label.institute": "Instituto",
  "referral.label.reason": "Motivo de referencia",
  "referral.label.referredOutTests": "Pruebas referidas",
  "referral.label.sentdate": "Fecha de envío",
  "referral.label.testmethod": "Métodos",
  "referral.label.testtoperform": "Prueba a realizar",
  "referral.main.button": "Buscar Referencias Por Paciente",
  "referral.matching.search": "Pruebas Referidas que Coinciden con la Búsqueda",
  "referral.out.head": "Referencias",
  "referral.out.note": "Nota: si busca por fecha de resultado, solo aparecerán pruebas con resultados.",
  "referral.out.request": "Resultados por fecha / prueba / tipo de fecha de unidad:",
  "referral.print.selected.patient.reports": "Imprimir Reportes de Pacientes Seleccionados",
  "referral.print.selected.patient.reports.selectall.button": "Seleccionar Todos",
  "referral.print.selected.patient.reports.selectnone.button": "Seleccionar Ninguno",
  "referral.result.labNumber": "Resultados Por Número de Laboratorio",
  "referral.result.referenceRange": "Rango de referencia",
  "referral.search": "Buscar",
  "referral.search.column.analysisId": "AnalysisId",
  "referral.search.column.referenceLab": "Laboratorio de Referencia",
  "referral.search.column.resultDate": "Fecha del Resultado",
  "referral.search.column.sentDate": "Fecha de Envío",
  "referral.test": "Prueba(s)",
  "referral.testresult.pastnote": "Notas anteriores",
  "referral.units": "Unidad(es)",
  "referrer.label": "Referente",
  "reflexTests": " Pruebas reflejas",
  "reject.action.button": "Rechazar",
  "reject.order.sample.notification": "Estás rechazando una muestra. Esta muestra será rechazada y no aparecerá en los planes de trabajo una vez guardada; no se podrán ingresar resultados para esta orden.",
  "remaining.quantity": "Cantidad restante:",
  "remove.aliquot": "Eliminar la alícuota",
  "report.enter.labNumber.headline": "Generar un informe o rango de informes por número de orden / número de laboratorio",
  "report.enter.patient.headline": "Generar todos los informes para un cliente",
  "report.enter.patient.headline.description": "Busca al paciente mediante el número de laboratorio anterior, el ID del paciente (que puede ser el número de identificación de salud único o el ID nacional) u otros campos.",
  "report.enter.site.headline": "Generar informes por sitio",
  "report.labe.byLabNumber": " Informe por número de laboratorio",
  "report.labe.byPatient": " Informe por paciente",
  "report.labe.date": " Informe por fecha",
  "report.labe.site": " Informe por sitio",
  "report.label.site.dateType": "Tipo de fecha",
  "report.label.site.onlyResults": "Solo informes con resultados",
  "report.patient.site.description": "Generar informes por fecha de resultado o por fecha de orden. La fecha de resultado mostrará solo informes con resultados. Si seleccionas solo informes con resultados, no se generarán los informes donde todas las pruebas estén en progreso.",
  "report.patient.title.final": "Results: final report",
  "report.patient.title.partial": "Results: partial report",
  "report.patient.labDirector": "Lab director",
  "report.patient.block.order": "Orden",
  "report.patient.block.dates": "Dates",
  "report.patient.siteWard": "Site / ward",
  "report.patient.completed": "Completado",
  "report.patient.completed.pending": "Not yet complete",
  "report.patient.contactTracing.indexName": "Contact tracing index name",
  "report.patient.contactTracing.indexRecordNumber": "Contact tracing index record number",
  "report.patient.samples": "Muestras",
  "report.patient.sample.number": "#",
  "report.patient.sample.condition": "Condition",
  "report.patient.sample.rejected": "Rejected: {0}",
  "report.patient.sample.notRecorded": "No se ha registrado",
  "report.patient.strip.collected": "Collected {0}",
  "report.patient.strip.collectedFirst": "Collected {0} (first of {1} samples)",
  "report.patient.result.sampleRejected": "Sample rejected",
  "report.patient.result.rejected": "Rechazado",
  "report.patient.col.sample": "Smp",
  "report.patient.col.completed": "Completado",
  "report.patient.flag.low": "L",
  "report.patient.flag.high": "H",
  "report.patient.flag.criticalLow": "LL",
  "report.patient.flag.criticalHigh": "HH",
  "report.patient.flag.abnormal": "*",
  "report.patient.flag.referred": "R",
  "report.patient.flag.confirm": "C",
  "report.patient.legend": "Legend",
  "report.patient.legend.high": "above normal",
  "report.patient.legend.low": "below normal",
  "report.patient.legend.critical": "critical",
  "report.patient.legend.referred": "referred, result pending",
  "report.patient.legend.confirm": "confirmation test",
  "report.patient.notAccredited": "Not within the laboratory's accredited scope",
  "report.patient.awaitingValidation": "Awaiting validation",
  "report.patient.performedBy": "Realizado por {0}",
  "report.patient.accred.notesLine": "Tests on this report are accredited by: {0}.",
  "report.patient.callback.line": "Callback: {0}, {1}, by {2}. {3}.",
  "report.patient.callback.more": "(+{0} earlier attempts)",
  "report.patient.callback.confirmed": "Read back confirmed",
  "report.patient.callback.noReadback": "Reached, no read-back",
  "report.patient.callback.unreachable": "Unable to reach",
  "report.patient.corrected.line": "Corrected report. Replaces the report issued {0}. Change: {1}.",
  "report.patient.corrected.seeReplaced": "See the replaced report",
  "report.patient.version": "Version {0}.",
  "report.patient.comments": "General comments",
  "report.patient.releasedBy": "Validated and released by",
  "report.patient.endOfReport": "End of report",
  "report.patient.issued": "Issued",
  "report.patient.page": "Page",
  "report.select.site": "Seleccionar Sitio",
  "report.select.studttype": " Seleccione tipo de estudio",
  "reporting.label.testName": "Nombre de Prueba para Informes",
  "reports.auditTrail": "Registro de Auditoría",
  "reports.systemAuditTrail": "Registro de Auditoría del sistema",
  "reports.button": "Generar Reporte",
  "reports.dateRange": "Rango de fechas",
  "reports.endDate": " Fecha de finalización",
  "reports.error.dateRangeRequired": "Para este tipo de informe es obligatorio indicar un intervalo de fechas",
  "reports.error.generationFailed": "No se ha podido generar el informe. Inténtelo de nuevo.",
  "reports.error.invalidDate": "Fecha inválida",
  "reports.error.invalidDateRange": "La fecha de finalización debe ser posterior a la fecha de inicio",
  "reports.error.unknownExportFormat": "Formato de exportación desconocido",
  "reports.error.unknownReportType": "Tipo de informe desconocido",
  "reports.export": " Exportar",
  "reports.export.byDate": "Exportar por Fecha",
  "reports.export.byDate_routine": "Reporte CSV Rutinario",
  "reports.export.general": "Exportación General",
  "reports.export.specific": "Exportación de Datos de Carga Viral",
  "reports.export.valid": "Válido",
  "reports.export.whonet": " Informe WHONET",
  "reports.followupRequired.byLocation": "Seguimiento Requerido",
  "reports.format": "Formato de exportación",
  "reports.format.select": "Seleccione el formato",
  "reports.generate.title": "Generar informe de inventario",
  "reports.generating": "Generando...",
  "reports.generation.success": "El informe se ha generado y descargado correctamente",
  "reports.groupByLocation": "Agrupar por ubicación de almacenamiento",
  "reports.groupByType": "Agrupar por tipo de elemento",
  "reports.grouping": "Opciones de agrupación",
  "reports.help.description": "Utilice estos informes para analizar los datos de su inventario:",
  "reports.help.tip1": "Utilice rangos de fechas para el análisis de tendencias",
  "reports.help.tip2": "Agrupe por tipo o ubicación para obtener una visión más clara",
  "reports.help.tip3": "Exportar a Excel para un análisis más detallado",
  "reports.help.title": "Consejos sobre informes",
  "reports.includeExpired": "Incluir los lotes caducados",
  "reports.includeInactive": "Incluir elementos inactivos",
  "reports.info.message": "Seleccione a continuación el tipo de informe y las opciones. La generación de los informes puede tardar unos instantes.",
  "reports.info.title": "Generación de informes",
  "reports.label.cistudyexport": " Informe general",
  "reports.label.indicator": "Indicador",
  "reports.label.indicator.performance": "Rendimiento de Sección",
  "reports.label.referred.out": "Informe de pruebas referidas",
  "reports.label.trends": " Tendencias",
  "reports.menu.covid": "Reporte de Covid",
  "reports.nonConformity.byDate.report": "Por Fecha",
  "reports.nonConformity.byLabno.report": "Por Número de Laboratorio",
  "reports.nonConformity.bySectionReason.report": "Por Unidad y Razón",
  "reports.nonConformity.bySectionReason.title": "Reporte de No Conformidad por Unidad y Razón",
  "reports.nonConformity.menu": "Reportes de No Conformidad",
  "reports.nonConformity.notification.report": "Notificación de No Conformidad",
  "reports.nonConformity.notification.report.instructions": "Si se selecciona un servicio, se imprimirán las notificaciones de no conformidad que aún no se han impreso. Si no hay servicios listados, todas las notificaciones ya han sido impresas. Ingresar un número de laboratorio imprimirá una notificación incluso si ya ha sido impresa. No es necesario elegir un servicio.",
  "reports.options": "Opciones de filtro",
  "reports.patient.ARV.version1": "ARV-Versión",
  "reports.patient.ARV.version1 ": "ARV-Versión 1",
  "reports.patient.ARVFollowup.version1": "ARV Seguimiento Versión 1",
  "reports.patient.ARVFollowup.version2": "ARV Seguimiento Versión 2",
  "reports.patient.ARVInitial.version1": "ARV Inicial Versión 1",
  "reports.patient.ARVInitial.version2": "ARV Inicial Versión 2",
  "reports.patient.Indeterminate.location": "Indeterminado por Servicio",
  "reports.patient.Indeterminate.version1": "Indeterminado Versión 1",
  "reports.patient.Indeterminate.version2": "Indeterminado Versión 2",
  "reports.startDate": " Fecha de inicio",
  "reports.type": "Tipo de informe",
  "reports.type.expirationForecast": "Previsión de vencimiento",
  "reports.type.expirationForecast.description": "Elementos que caducan dentro del rango de fechas especificado",
  "reports.type.lotTraceability": "Trazabilidad de los lotes",
  "reports.type.lotTraceability.description": "Trazabilidad completa de los movimientos y el uso de los lotes",
  "reports.type.lowStock": "Alerta de existencias bajas",
  "reports.type.lowStock.description": "Elementos cuyo nivel de existencias se encuentra actualmente por debajo del mínimo",
  "reports.type.select": "Seleccione el tipo de informe",
  "reports.type.stockLevels": "Informe sobre los niveles de existencias",
  "reports.type.stockLevels.description": "Niveles actuales de existencias de todos los elementos en stock",
  "reports.type.transactionHistory": "Historial de transacciones",
  "reports.type.transactionHistory.description": "Todas las transacciones dentro del rango de fechas",
  "reports.type.usageTrends": "Tendencias de uso",
  "reports.type.usageTrends.description": "Patrones de uso y tendencias de consumo a lo largo del tiempo",
  "request.samesite.order": " Realizar orden en el mismo sitio",
  "requester.label": "Solicitante",
  "required.invalidtext": "Este campo es obligatorio",
  "result.acceptasis.warning": "Los resultados ya no estarán disponibles.\nMarcar esta casilla indica que aceptas los resultados sin condiciones.\nUsos esperados:\n\n1. La prueba se ha repetido y el resultado es el mismo.\n2. No hay resultado para la prueba pero no deseas cancelarla.\n3. El resultado fue cambiado y el técnico quiere dar la opción al biólogo de agregar una nota durante la validación explicando el motivo del cambio.\nEn cualquier caso, deja una nota explicando por qué estás tomando esta acción.\n",
  "result.acceptasis.trigger": "Aceptar",
  "result.acceptasis.reason.label": "Motivo de la aceptación incondicional",
  "result.acceptasis.reason.placeholder": "Obligatorio — p. ej., se ha repetido la prueba dos veces con el mismo resultado, o no se dispone de ningún resultado",
  "result.acceptasis.confirm": "Confirme su aceptación",
  "result.acceptasis.cancel": "Cancelar",
  "result.acceptasis.committed": "Aceptado",
  "result.acceptasis.undo": "Deshacer",
  "result.entry.error.accessionRequired": "Ingrese un número de laboratorio",
  "result.entry.error.title": "Error",
  "result.entry.info.title": "Información",
  "result.entry.label": "Entrada de resultados",
  "result.entry.noResults": "No se ha encontrado ninguna muestra correspondiente al número de acceso {accessionNumber}",
  "result.entry.noTestsFound": "No se han encontrado pruebas con resultados pendientes para el Número de acceso {accessionNumber}",
  "result.entry.results.accessionNumber": "Número de acceso",
  "result.entry.results.sampleCount": "Muestras",
  "result.entry.results.testCount": "Pruebas",
  "result.entry.results.title": "Pruebas con resultados pendientes",
  "result.entry.saveSuccess": "Resultado guardado en {testName}",
  "result.entry.search.accessionLabel": "Número de acceso",
  "result.entry.search.accessionPlaceholder": "Ingresar Número de acceso...",
  "result.entry.search.button": "Buscar",
  "result.entry.search.searching": "Buscar...",
  "result.entry.search.title": "Buscar por Número de Acceso",
  "result.entry.success.title": "Éxito",
  "result.entry.table.action": " Acción",
  "result.entry.table.header.sampleId": "N.º de muestra",
  "result.entry.table.header.sampleType": " Tipo de muestra",
  "result.entry.table.header.testCount": "Pruebas",
  "result.entry.table.noSamples": "No se han encontrado muestras con resultados de pruebas.",
  "result.entry.table.noTests": "No se han realizado pruebas con esta muestra",
  "result.entry.table.result": "Resultado",
  "result.entry.table.resultPlaceholder": "Introduzca el resultado",
  "result.entry.table.save": "Guardar",
  "result.entry.table.saving": "Guardando...",
  "result.entry.table.status": "Estado",
  "result.entry.table.testName": " Nombre de la prueba",
  "result.entry.table.testsTitle": "Pruebas ({count})",
  "result.entry.title": "Entrada de resultados",
  "result.noTestsFound": "No se encontraron pruebas apropiadas.",
  "result.nonconforming.item": "La muestra o la orden no cumplen o la prueba ha sido rechazada",
  "result.outOfValidRange.msg": " El valor ingresado (campo rojo) está fuera del rango permitido para ese registro. Por favor verifica el valor",
  "result.notNumeric.msg": "{test}: \"{value}\" is not a number. Enter a plain decimal or scientific notation such as 1.5e5 or 1.5 x 10^5, then save again.",
  "result.reject.warning": " Rechazar el resultado eliminará permanentemente los resultados de la prueba",
  "result.report.queue.size": "Tamaño de la Cola:",
  "result.search.noresult": " No se encontraron resultados",
  "resultreporting.browse.title": "Configuración de Reporte de Resultados",
  "resultreporting.config.url": "URL del sitio al que se enviarán los resultados. Por ejemplo http://192.168.56.101/someSite",
  "resultreporting.config.url.placeholder": "https://orgname.com/someSite",
  "results.label.refer": "Referir prueba a un laboratorio de referencia",
  "routine.reports": "Informes rutinarios",
  "rulebuilder.error.invalidNumeric": "Valor numérico inválido",
  "rulebuilder.error.invalidTest": "Prueba inválida",
  "rulebuilder.label.add.externaltrigger": " Agregar mensaje externo \"activado por\"",
  "rulebuilder.label.add.internaltrigger": " Agregar mensaje interno \"activado por\"",
  "rulebuilder.label.addAction": "Agregar acción",
  "rulebuilder.label.addCondition": "Agregar condición",
  "rulebuilder.label.addExternalNote": "Agregar nota externa",
  "rulebuilder.label.addInternalNote": "Agregar nota interna",
  "rulebuilder.label.addPopup": "Agregar ventana emergente",
  "rulebuilder.label.addRule": "Agregar regla",
  "rulebuilder.label.addRuleConditions": "Agregar condiciones de regla de reflejo",
  "rulebuilder.label.confirmDelete": "¿Estás seguro de que quieres desactivar esta regla?",
  "rulebuilder.label.dictValue": "Valor del diccionario",
  "rulebuilder.label.noSuggestions": "No hay sugerencias disponibles",
  "rulebuilder.label.numericValue": "Valor numérico",
  "rulebuilder.label.numericValue2": "Valor numérico 2",
  "rulebuilder.label.overallOptions": "Opción general",
  "rulebuilder.label.perfomActions": "Realizar las siguientes acciones",
  "rulebuilder.label.relation": "Relación",
  "rulebuilder.label.removeAction": "Eliminar acción",
  "rulebuilder.label.removeCondition": "Eliminar condición",
  "rulebuilder.label.removeRule": "Desactivar regla",
  "rulebuilder.label.rule": "Regla",
  "rulebuilder.label.ruleDetails": "Consultar regla",
  "rulebuilder.label.ruleName": "Nombre de la regla",
  "rulebuilder.label.searchTest": "Buscar prueba",
  "rulebuilder.label.selectSample": "Seleccionar muestra",
  "rulebuilder.label.textValue": "Valor de texto",
  "rulebuilder.label.toggleRule": "Alternar regla",
  "sample.accession.number": "N.º de registro de la muestra",
  "sample.add.action": "Agregar muestra",
  "sample.collection.date": "Fecha de recolección",
  "sample.collection.method": "Método de recolección",
  "sample.collection.method.placeholder": "por ejemplo, punción venosa, muestra capilar, tubo",
  "sample.collection.time": "Hora de recolección",
  "sample.currentDate": "Fecha actual",
  "sample.requiredBy": "Exigido por",
  "sample.specimen.origin": "Origen de la muestra (Laboratorio de Referencia)",
  "sample.specimen.origin.placeholder": "Nombre del laboratorio remitente",
  "sample.temperature": "Temperatura de la muestra",
  "sample.temperature.placeholder": "p. ej., a temperatura ambiente, con hielo, refrigerado",
  "sample.entry.available.tests": "Pruebas Disponibles",
  "sample.entry.nextVisit.date": "Fecha de la próxima visita",
  "sample.entry.panels": "Paneles",
  "sample.entry.project.patient.and.testName": "Nombre/Código del paciente {br} Nombre de la prueba",
  "sample.entry.project.testName": "Nombre de la prueba",
  "sample.entry.search.barcode": "Imprimir códigos de barras para órdenes existentes",
  "sample.id": "N.º de muestra",
  "sample.item.info": "Información sobre la muestra",
  "sample.items.for.accession": "Elementos de muestra del número de laboratorio:",
  "sample.label.accessionNumber": "Número de acceso",
  "sample.label.collectionDate": "Fecha de recolección",
  "sample.label.dept": "Sala/Departamento/Unidad",
  "sample.label.facility": "Instalación de referencia",
  "sample.label.labnumber": "Número de laboratorio",
  "sample.label.labnumber.generate": "Generar",
  "sample.label.labnumber.new": "Nuevo Número de Laboratorio",
  "sample.labnumber.reassign.button": "Reasignar número de laboratorio",
  "sample.labnumber.reassign.confirm": "Reasignar",
  "sample.labnumber.reassign.current": "Número de laboratorio actual",
  "sample.labnumber.reassign.heading": "Reasignar número de laboratorio",
  "sample.labnumber.reassign.pending": "Esta muestra se reasignará a «{number}» cuando guarde los cambios.",
  "sample.labnumber.reassign.pending.title": "Pendiente de reasignación del número de laboratorio",
  "sample.labnumber.reassign.undo": "Deshacer",
  "sample.labnumber.reassign.warning": "La reasignación modifica de forma permanente el número de laboratorio de esta muestra. Las etiquetas, los informes y las referencias existentes al número actual ya no coincidirán con él. Realice esta acción únicamente para corregir una muestra mal etiquetada.",
  "sample.label.noorder": "La Orden No Existe",
  "sample.label.orderdate": "Fecha de orden",
  "sample.label.orderpanel": "Ordenar Paneles",
  "sample.label.requester": "Solicitante",
  "sample.label.search.Order": "Buscar Orden",
  "sample.label.search.labnumber": "Buscar por Número de Acceso",
  "sample.label.search.patient": "Buscar por Paciente",
  "sample.label.typeOfSample": " Tipo de muestra",
  "sample.label.types": "Tipo de muestra",
  "sample.management.action.clearSelection": "Limpiar selección",
  "sample.management.action.createAliquot": "Crear alícuota",
  "sample.management.action.selectAllAliquots": "Seleccionar todas las alícuotas",
  "sample.management.action.selectAllParents": "Seleccionar todas las muestras de origen",
  "sample.management.addTests.button": "Agregar pruebas",
  "sample.management.addTests.error.addFailed": "No se han podido agregar las pruebas. Por favor, inténtelo de nuevo.",
  "sample.management.addTests.error.loadSampleTypes": "Error al cargar los tipos de muestra",
  "sample.management.addTests.error.loadTests": "Se ha producido un error al cargar las Pruebas Disponibles",
  "sample.management.addTests.error.noEligibleSamples": "No es posible agregar pruebas: todas las muestras seleccionadas se han dispensado por completo",
  "sample.management.addTests.error.noTests": "Seleccione al menos una prueba",
  "sample.management.addTests.modal.add": "Agregar pruebas",
  "sample.management.addTests.modal.addCount": "Agregar {count} prueba(s)",
  "sample.management.addTests.modal.adding": "Agregando...",
  "sample.management.addTests.modal.aliquotsIncluded": "alícuota(s) incluida(s)",
  "sample.management.addTests.modal.bulkAliquotNote": "Se agregarán pruebas a todas las muestras seleccionadas, incluidas las alícuotas.",
  "sample.management.addTests.modal.cancel": "Cancelar",
  "sample.management.addTests.modal.noEligibleSamples": "No hay muestras válidas",
  "sample.management.addTests.modal.noTestsAvailable": "No hay pruebas disponibles para este tipo de muestra.",
  "sample.management.addTests.modal.noTestsSelected": "No se ha seleccionado ninguna prueba",
  "sample.management.addTests.modal.panels": "Paneles",
  "sample.management.addTests.modal.searchTestsPlaceholder": "Buscar pruebas...",
  "sample.management.addTests.modal.selectSampleType": " Tipo de muestra",
  "sample.management.addTests.modal.selectSampleTypeFirst": "Seleccione un tipo de muestra para consultar los paneles y las pruebas disponibles.",
  "sample.management.addTests.modal.selectSampleTypePlaceholder": "Seleccione un tipo de muestra...",
  "sample.management.addTests.modal.selectTests": "Seleccionar pruebas",
  "sample.management.addTests.modal.selectTestsPlaceholder": "Buscar y seleccionar pruebas...",
  "sample.management.addTests.modal.selectedTests": "Pruebas seleccionadas",
  "sample.management.addTests.modal.subtitle": "Agregue pruebas a {count} muestra(s) seleccionada(s)",
  "sample.management.addTests.modal.tests": "Pruebas",
  "sample.management.addTests.modal.title": "Agregar pruebas a la muestra",
  "sample.management.addTests.resultItem": "{sampleId}: se ha agregado {added}",
  "sample.management.addTests.resultItem.withSkipped": "{sampleId}: se ha agregado {added}; se ha omitido {skipped}",
  "sample.management.addTests.success": "{count} prueba(s) agregada(s) correctamente",
  "sample.management.addTests.successDetailed": "{count} prueba(s) agregada(s) a {samples} muestra(s): {details}",
  "sample.management.addTests.successDetailedWithSkipped": "{added} prueba(s) agregada(s) a {samples} muestra(s), {skipped} omitida(s): {details}",
  "sample.management.addTests.successWithSkipped": "{added} prueba(s) agregada(s), {skipped} omitida(s) (ya ordenadas)",
  "sample.management.addTests.title": "Agregar pruebas",
  "sample.management.addTests.warning.dispensedSamples": "{count} muestra(s) no tienen volumen restante y se omitirán. Se agregarán pruebas a {eligible} muestra(s) elegible(s).",
  "sample.management.addTests.warning.dispensedSamples.title": "Se excluyen las muestras dispensadas",
  "sample.management.aliquot.error.createFailed": "No se ha podido crear la alícuota. Por favor, inténtelo de nuevo.",
  "sample.management.aliquot.error.numberOfAliquotsInvalid": "El número de alícuotas debe estar comprendido entre 1 y 100",
  "sample.management.aliquot.error.quantityExceedsRemaining": "La cantidad solicitada ({requested}) supera la cantidad restante ({remaining})",
  "sample.management.aliquot.error.quantityPerAliquotTooSmall": "La cantidad por alícuota ({quantityPerAliquot}) sería inferior al mínimo (0,001)",
  "sample.management.aliquot.error.quantityPositive": "La cantidad debe ser superior a 0",
  "sample.management.aliquot.error.quantityRequired": "Es necesario indicar la cantidad",
  "sample.management.aliquot.error.title": "Error",
  "sample.management.aliquot.modal.cancel": "Cancelar",
  "sample.management.aliquot.modal.create": "Crear alícuota",
  "sample.management.aliquot.modal.createMultiple": "Crear {count} alícuotas",
  "sample.management.aliquot.modal.creating": "Creando...",
  "sample.management.aliquot.modal.notesLabel": "Notas (opcional)",
  "sample.management.aliquot.modal.notesPlaceholder": "Agregue cualquier nota sobre esta alícuota...",
  "sample.management.aliquot.modal.numberOfAliquotsHelper": "Ingrese el número de alícuotas de igual volumen que desea crear (1-100)",
  "sample.management.aliquot.modal.numberOfAliquotsLabel": "Número de alícuotas",
  "sample.management.aliquot.modal.parentInfo": "Información de la muestra de origen",
  "sample.management.aliquot.modal.preview": "Vista previa",
  "sample.management.aliquot.modal.previewText": "Creando {count} alícuotas con {quantityEach} {unit} cada una",
  "sample.management.aliquot.modal.quantityHelper": "Introduzca la cantidad que desea transferir en {unit}",
  "sample.management.aliquot.modal.quantityLabel": "Cantidad a transferir",
  "sample.management.aliquot.modal.quantityPlaceholder": "Ingrese la cantidad",
  "sample.management.aliquot.modal.subtitle": "Cree una alícuota desde la muestra {externalId}",
  "sample.management.aliquot.modal.title": "Crear alícuota",
  "sample.management.aliquot.modal.totalQuantityHelper": "Ingrese la cantidad total que desea repartir entre todas las alícuotas en {unit}",
  "sample.management.aliquot.modal.totalQuantityLabel": "Cantidad total a transferir",
  "sample.management.aliquot.success": "Se ha creado correctamente la alícuota {externalId}. Realice la búsqueda de nuevo para ver los resultados actualizados.",
  "sample.management.aliquot.successMultiple": "Se han creado correctamente {count} alícuotas ({externalIds}). Realice la búsqueda de nuevo para ver los resultados actualizados.",
  "sample.management.breadcrumb.title": "Gestión de muestras",
  "sample.management.cancelTest.error": "No se ha podido cancelar la prueba. Inténtelo de nuevo.",
  "sample.management.cancelTest.success": "La prueba «{testName}» se ha cancelado correctamente",
  "sample.management.description": "Buscar y gestionar muestras, crear alícuotas y agregar pruebas",
  "sample.management.error.title": "Error",
  "sample.management.hierarchy.aliquotOf": "Alícuota de «{parent}»",
  "sample.management.hierarchy.aliquots": "alícuotas",
  "sample.management.noResults.subtitle": "No se han encontrado elementos para el número de acceso: {accessionNumber}",
  "sample.management.noResults.title": "No se encontraron resultados",
  "sample.management.results.accessionNumber": "Número de acceso",
  "sample.management.results.aliquots": "alícuotas",
  "sample.management.results.aliquotsSelected": "alícuotas",
  "sample.management.results.item": "Elemento",
  "sample.management.results.items": "elementos",
  "sample.management.results.selected": "Seleccionado",
  "sample.management.results.title": "Elementos de muestra",
  "sample.management.results.totalCount": "Total de muestras",
  "sample.management.search.error.general": "Se ha producido un error al cargar los resultados de muestra. Inténtelo de nuevo.",
  "sample.management.search.label": "Buscar muestras",
  "sample.management.search.loading": "Buscando...",
  "sample.management.search.placeholder": "Ingresar Número de Acceso para realizar la búsqueda...",
  "sample.management.search.title": "Buscar muestras",
  "sample.management.status.allVolumeDispensed": "Volumen total dispensado",
  "sample.management.status.available": "Disponible",
  "sample.management.status.consumed": "Consumido",
  "sample.management.status.inUse": "En uso",
  "sample.management.status.unknown": "Desconocido",
  "sample.management.success.title": "Éxito",
  "sample.management.table.cancelTest": " Cancelar prueba",
  "sample.management.table.cancelling": "Cancelando...",
  "sample.management.table.header.externalId": "N.º de muestra",
  "sample.management.table.header.hierarchy": "Jerarquía",
  "sample.management.table.header.originalQuantity": "Cantidad original",
  "sample.management.table.header.quantity": "Cantidad original",
  "sample.management.table.header.remainingQuantity": "Cantidad restante",
  "sample.management.table.header.sampleType": " Tipo de muestra",
  "sample.management.table.header.status": "Estado",
  "sample.management.table.header.tests": "Pruebas",
  "sample.management.table.noResults": "No hay elementos de muestra que mostrar. Utilice el buscador de arriba para encontrar muestras.",
  "sample.management.table.noTests": "No se han solicitado pruebas para esta muestra",
  "sample.management.table.orderedDate": "Ordenado",
  "sample.management.table.orderedTests": "Pruebas ordenadas ({count})",
  "sample.management.title": "Gestión de muestras",
  "sample.panel.label.text": "Buscar panel disponible",
  "sample.panel.placeholder": "Elegir panel disponible",
  "sample.panel.search.error.msg": "No se encontró ningún panel que coincida",
  "sample.quantity.label": "Cantidad",
  "sample.receivedDate": "Fecha de recepción",
  "sample.reject.label": "Rechazar muestra",
  "sample.reject.reason.choose": "Choose a rejection reason",
  "sample.reject.reason.label": "Motivo de rechazo",
  "sample.reject.reasonRequired": "Choose a rejection reason.",
  "sample.remove.action": "Eliminar muestra",
  "sample.requestDate": "Fecha de Solicitud",
  "sample.search.nosample": "No se ha encontrado ninguna muestra correspondiente al número de acceso facilitado.",
  "sample.search.panel.legend.text": "Buscar a través de los paneles disponibles",
  "sample.search.scanner.instructions": "Escanear o ingresar manualmente. Para un solo informe, deja el cuadro a la derecha vacío",
  "sample.search.scanner.instructions.highaccession": "Para un solo informe, deja el cuadro a la derecha vacío",
  "sample.search.scanner.instructions2": "Escanear o ingresar manualmente.",
  "sample.search.title": "Buscar muestra",
  "sample.select.type": "Seleccionar tipo de muestra",
  "sample.type": "Tipo de muestra",
  "sample.type.and.test.sort.order": "Orden de tipo de muestra y prueba",
  "sample.type.helper": "Seleccione un tipo de muestra; los paneles y las pruebas disponibles se actualizarán tras la selección.",
  "sample.uom.label": "Unidad de medida de la muestra",
  "sample.voided.title": "La muestra se ha anulado",
  "sampleManagement.actions": "Acciones",
  "sampleManagement.addTests.button": "Agregar pruebas",
  "sampleManagement.addTests.cancel": "Cancelar",
  "sampleManagement.addTests.duplicate": "Ya se ha solicitado la prueba para «{sampleId}»",
  "sampleManagement.addTests.error": "Error al añadir pruebas",
  "sampleManagement.addTests.incompatible": "Prueba no compatible con el tipo de muestra ({sampleType})",
  "sampleManagement.addTests.selectSamples": "Seleccione una o varias muestras para agregar pruebas",
  "sampleManagement.addTests.selectTests": "Seleccione la(s) prueba(s) que desee agregar",
  "sampleManagement.addTests.skipped": "Se han omitido uno o varios duplicados de «{count}»",
  "sampleManagement.addTests.submit": "Agregar pruebas",
  "sampleManagement.addTests.success": "{count} Las pruebas se han agregado correctamente",
  "sampleManagement.addTests.title": "Agregar pruebas a las muestras",
  "sampleManagement.aliquot.button": "Crear alícuota",
  "sampleManagement.aliquot.cancel": "Cancelar",
  "sampleManagement.aliquot.error": "Error al crear una alícuota",
  "sampleManagement.aliquot.error.concurrentModification": "Otro usuario ha modificado esta muestra. Actualice la página e inténtelo de nuevo.",
  "sampleManagement.aliquot.error.insufficientQuantity": "No se puede realizar la subdivisión en alícuotas: el valor solicitado «{requested}» supera el valor restante «{remaining}».",
  "sampleManagement.aliquot.error.noRemainingQuantity": "Se ha dispensado todo el volumen: no queda cantidad disponible para la división en alícuotas",
  "sampleManagement.aliquot.notes": "Notas (opcional)",
  "sampleManagement.aliquot.notesPlaceholder": "Agregue notas sobre esta alícuota...",
  "sampleManagement.aliquot.parentExternalId": "ID externo del padre",
  "sampleManagement.aliquot.parentLabel": "Muestra para padres",
  "sampleManagement.aliquot.quantityPlaceholder": "Introduzca la cantidad...",
  "sampleManagement.aliquot.quantityToTransfer": "Cantidad a transferir",
  "sampleManagement.aliquot.remainingQuantity": "Cantidad restante",
  "sampleManagement.aliquot.submit": "Crear alícuota",
  "sampleManagement.aliquot.success": "Se ha creado correctamente la alícuota «{externalId}».",
  "sampleManagement.aliquot.title": "Crear alícuota",
  "sampleManagement.aliquot.unit": "Unidad",
  "sampleManagement.aliquot.validation.exceeds": "La cantidad supera la cantidad restante",
  "sampleManagement.aliquot.validation.min": "La cantidad debe ser de al menos 0,001",
  "sampleManagement.aliquot.validation.required": "Es necesario indicar la cantidad que se va a transferir",
  "sampleManagement.clearSelection": "Limpiar selección",
  "sampleManagement.hierarchy.children": "Alícuotas:",
  "sampleManagement.hierarchy.collapse": "Ocultar la jerarquía",
  "sampleManagement.hierarchy.expand": "Despliegar la jerarquía",
  "sampleManagement.hierarchy.level": "Nivel{level}",
  "sampleManagement.hierarchy.parent": "Padre:",
  "sampleManagement.notification.refreshResults": "Se han actualizado los resultados",
  "sampleManagement.results.children": "Alícuotas",
  "sampleManagement.results.collectionDate": "Fecha de recolección",
  "sampleManagement.results.count": "{count} se han encontrado muestras",
  "sampleManagement.results.externalId": "Identificador externo",
  "sampleManagement.results.originalQuantity": "Cantidad original",
  "sampleManagement.results.parent": "Padre",
  "sampleManagement.results.remainingQuantity": "Cantidad restante",
  "sampleManagement.results.sampleType": " Tipo de muestra",
  "sampleManagement.results.status": "Estado",
  "sampleManagement.results.tests": "Pruebas",
  "sampleManagement.results.title": "Resultados de la búsqueda",
  "sampleManagement.search.button": "Buscar",
  "sampleManagement.search.error": "Error al buscar muestras",
  "sampleManagement.search.label": "Buscar por Número de Acceso",
  "sampleManagement.search.loading": "Buscar...",
  "sampleManagement.search.noResults": "No se han encontrado muestras con este número de acceso",
  "sampleManagement.search.placeholder": "Ingresar Número de acceso...",
  "sampleManagement.selectSamples": "Seleccione una o varias muestras",
  "sampleManagement.selectedCount": "{count} seleccionado",
  "sampleManagement.test.name": " Nombre de la prueba",
  "sampleManagement.test.orderedDate": "Fecha de orden",
  "sampleManagement.test.status": "Estado",
  "sampleManagement.test.status.CANCELLED": "Cancelado",
  "sampleManagement.test.status.COMPLETED": "Completado",
  "sampleManagement.test.status.IN_PROGRESS": "En progreso",
  "sampleManagement.test.status.ORDERED": "Pedido",
  "sampleManagement.title": "Gestión de muestras",
  "sampleManagement.validation.accessionNumberRequired": "Es necesario indicar el número de acceso",
  "sampleManagement.validation.parentSampleRequired": "Es obligatorio indicar el elemento de muestra principal",
  "sampleManagement.validation.samplesRequired": "Debe seleccionarse al menos una muestra",
  "sampleManagement.validation.testsRequired": "Debe seleccionarse al menos una prueba",
  "sampleType.existing": "Tipos de Muestra Existentes",
  "sampleType.existing.inactive": "Tipos de Muestra Inactivos. Asigne pruebas para activar.",
  "sampleType.new": "Nuevo Tipo de Muestra",
  "sampleType.typeName": "Nombre del Tipo de Muestra",
  "save.aliquot.changes": "Guardar los cambios en las alícuotas",
  "save.config.success.msg": "Configuración actualizada correctamente",
  "save.order.success.msg": "La entrada de la orden de muestra se ha guardado correctamente",
  "save.success": " Guardado exitosamente",
  "saving": "Guardando...",
  "search.by.dictionary.entry": " Buscar por entrada de diccionario",
  "search.label": "Buscar",
  "search.label.accession": "Ingresar Número de Acceso",
  "search.label.analysis": "Seleccionar Estado de Análisis",
  "search.label.collectiondate": "Ingresar Fecha de Recolección",
  "search.label.fromaccession": "Desde Número de Acceso",
  "search.label.loadnext": "Cargar siguientes 99 registros comenzando por Número de Laboratorio",
  "search.label.receiveddate": "Ingresar Fecha de Recepción",
  "search.label.sample": "Seleccionar Estado de Muestra",
  "search.label.test": "Seleccionar Nombre de Prueba",
  "search.label.testdate": "Ingresar Fecha de Prueba",
  "search.label.testunit": "Seleccionar Unidad de Prueba",
  "search.label.toaccession": "Hasta Número de Acceso",
  "search.patient.label": "Buscar paciente",
  "search.placeholder": "Buscar...",
  "searchTests.label": " Buscar prueba disponible",
  "searchTests.legend": " Buscar entre las pruebas disponibles",
  "searchindexmanagement.description": "El índice de búsqueda se actualiza automáticamente cuando se agregan o modifican datos. Si necesita actualizar manualmente el índice de búsqueda, haga clic en el botón Iniciar Reindexación. Esto puede tomar algún tiempo.",
  "searchindexmanagement.label": "v",
  "searchindexmanagement.reindex": "Iniciar Reindexación",
  "searchindexmanagement.reindex.error": "Error en la reindexación",
  "searchindexmanagement.reindex.success": "Reindexación completada exitosamente",
  "select.aliquot": "Seleccione una alícuota",
  "select.datarange.label": "El rango de fechas es para cuando se realizaron las referencias",
  "select.dateRange": "Selecciona el rango de fechas para el resumen del informe de pruebas",
  "select.default.option.label": "Elige una opción",
  "select.end.date.referredTests": "Fecha de fin (dd/mm/aaaa)",
  "select.labUnits": "Selecciona la(s) unidad(es) de laboratorio para las que deseas crear la prueba, puedes seleccionar tantas como quieras",
  "select.label.analyser": "Seleccionar analizador",
  "select.priority.tests": "Selecciona la prioridad de las pruebas que deseas mostrar",
  "select.program": "Seleccionar Programa",
  "select.referral.centre": "Centro de referencia o laboratorio",
  "select.referral.centre.is.required": "Se requiere centro de referencia o laboratorio",
  "select.start.date.referredTests": "Fecha de inicio (dd/mm/aaaa)",
  "select.timeFrame": "Selecciona los períodos de tiempo para los que deseas generar los informes",
  "select.timeFrame.Note": "NOTA: todas las fechas y horas se basan en la hora de recepción. Por ejemplo: una prueba recibida el 31 de enero a las 11:59 pm y resultada el 1 de febrero a las 9:30 am se mostrará como fuera del horario normal en enero",
  "select.year.report": "Selecciona el año para el que deseas generar los informes",
  "selectListRenameEntry.selectList": "Entrada de Renombrado de Lista de Selección",
  "selectListRenameEntry.selectListEdit": "Edición de Entrada de Renombrado de Lista de Selección",
  "selectReportValues.title": " Seleccionar valores del informe",
  "selectResult.title": " Seleccionar resultado",
  "serial.config.active.label": "Activo",
  "serial.config.baudRate.label": "Velocidad de transmisión",
  "serial.config.connect.button": "Conectarse",
  "serial.config.connect.error": "Error al conectarse al puerto serie",
  "serial.config.connect.success": "El puerto serie se ha conectado correctamente",
  "serial.config.create.title": "Crear una configuración de puerto serie",
  "serial.config.dataBits.label": "Bits de datos",
  "serial.config.disconnect.button": "Desconectar",
  "serial.config.disconnect.error": "Error al desconectar el puerto serie",
  "serial.config.disconnect.success": "El puerto serie se ha desconectado correctamente",
  "serial.config.edit.title": "Editar la configuración del puerto serie",
  "serial.config.flowControl.label": "Control de flujo",
  "serial.config.flowControl.none": "Ninguno",
  "serial.config.form.legend": "Configuración del puerto serie",
  "serial.config.parity.even": "Incluso",
  "serial.config.parity.label": "Paridad",
  "serial.config.parity.mark": "Mark",
  "serial.config.parity.none": "Ninguno",
  "serial.config.parity.odd": "Extraño",
  "serial.config.parity.space": "Espacio",
  "serial.config.portName.label": "Nombre del puerto",
  "serial.config.save.error": "Error al guardar la configuración del puerto serie",
  "serial.config.save.success": "La configuración del puerto serie se ha guardado exitosamente",
  "serial.config.status.label": "Estado de la conexión",
  "serial.config.stopBits.label": "Bits de parada",
  "serial.config.validation.analyzerId.required": "Es necesario indicar el ID del Analizador",
  "serial.config.validation.baudRate.invalid": "La velocidad de transmisión debe estar comprendida entre 9600 y 115 200",
  "serial.config.validation.dataBits.invalid": "Los bits de datos deben ser 7 u 8",
  "serial.config.validation.portName.required": "Es obligatorio indicar el nombre del puerto",
  "server.error.msg": "Oops, error del servidor, por favor contacta al administrador",
  "common.retry": "Inténtelo de nuevo",
  "show.aliquoting": "Mostrar alicuotado",
  "showing": "Mostrando",
  "breadcrumb.label.addOrder": " Agregar orden",
  "sidenav.label.admin": "Administración",
  "sidenav.label.admin.backToMainMenu": "Volver al menú principal",
  "sidenav.label.admin.barcodeconfiguration": " Configuración de códigos de barras",
  "sidenav.label.admin.labelPresets": "Ajustes predefinidos de etiquetas",
  "sidenav.label.admin.commonproperties": "Propiedades de la aplicación",
  "sidenav.label.admin.eqaProgram": "Gestión del programa ECA",
  "sidenav.label.admin.formEntry.menustatementconfig": "Configuración de declaración de menú",
  "sidenav.label.admin.formEntry.nonconformityconfig": "Configuración de no conformidad",
  "sidenav.label.admin.formEntry.patientconfig": "Configuración de entrada de pacientes",
  "sidenav.label.admin.formEntry.PrintedReportsconfig": "Configuración de informes impresos",
  "sidenav.label.admin.formEntry.resultConfig": "Configuración de entrada de resultados",
  "sidenav.label.admin.formEntry.sampleEntryconfig": "Configuración de entrada de órdenes",
  "sidenav.label.admin.formEntry.siteBranding": "Identidad visual del sitio",
  "sidenav.label.admin.formEntry.siteInfoconfig": "Información del sitio",
  "sidenav.label.admin.formEntry.validationconfig": "Configuración de validación",
  "sidenav.label.admin.formEntry.Workplanconfig": "Configuración de plan de trabajo",
  "sidenav.label.admin.labNumber": "Gestión de números de laboratorio",
  "sidenav.label.admin.localization": "Localización",
  "sidenav.label.admin.menu": "Configuración de Menú",
  "sidenav.label.admin.menu.billing": "Configuración de Menú de Facturación",
  "sidenav.label.admin.menu.global": "Configuración de Menú Global",
  "sidenav.label.admin.menu.nonconform": "Configuración de Menú de No Conformidad",
  "sidenav.label.admin.menu.patient": "Configuración de Menú de Paciente",
  "sidenav.label.admin.menu.study": "Configuración de Menú de Estudio",
  "sidenav.label.admin.organizationmgt": "Gestión de organizaciones",
  "sidenav.label.admin.testmgt": "Configuración de pruebas de reflejo",
  "sidenav.label.admin.testmgt.calculated": "Gestión de pruebas de valor calculado",
  "sidenav.label.admin.testmgt.testCatalogEditor": "Editor del catálogo de pruebas",
  "sidenav.label.admin.testCatalog": "Gestión del catálogo de pruebas",
  "sidenav.label.admin.testCatalog.backToList": "← Todas las pruebas",
  "sidenav.label.admin.testCatalog.sectionsHelper": "Haga clic en una prueba para editar sus secciones",
  "sidenav.label.admin.testCatalog.editing": "Edición: {name}",
  "sidenav.label.admin.testCatalog.editingGeneric": "Edición de prueba",
  "label.testCatalog.editor": "Editor del catálogo de pruebas",
  "label.testCatalog.editor.empty": "Haga clic en una prueba para editar sus secciones",
  "label.testCatalog.editor.empty.helper": "Abra una prueba de la lista del Catálogo de pruebas para editarla.",
  "label.testCatalog.editor.loadError": "No se ha podido cargar esta prueba. Inténtelo de nuevo.",
  "label.testCatalog.editor.saveAsNew": "Guardar como nueva prueba…",
  "label.testCatalog.editor.save.pending": "La función de guardar estará disponible en cuanto se publiquen los editores de secciones.",
  "label.testCatalog.editor.clone.pending": "La opción «Guardar como nueva prueba» estará disponible una vez que se publiquen las secciones del editor.",
  "label.testCatalog.section.pending": "El editor de esta sección se incluirá en una versión posterior.",
  "label.testCatalog.section.basic-info": "Información básica",
  "label.testCatalog.section.sample-results": "Muestra y resultados",
  "label.testCatalog.section.methods": "Métodos",
  "label.testCatalog.section.ranges": "Rangos",
  "label.testCatalog.section.qc-targets": "Objetivos de CC",
  "label.testCatalog.section.storage": "Almacenamiento de muestras",
  "label.testCatalog.section.panels": "Paneles",
  "label.testCatalog.entity.panels": "Editor de paneles",
  "note.panel.domainUpgrade": "El dominio de un panel se establece en el propio panel; no se deduce de los tipos de muestra que usan sus pruebas.",
  "note.panel.domainLaterPhase": "Un panel cuyas pruebas abarcan tipos de muestra de otro dominio se marca como «Dominio mixto».",
  "label.panel.list.description": "Conjuntos ordenados de pruebas; los tipos de muestra se derivan de las pruebas que los componen",
  "label.panel.list.empty": "No hay paneles que coincidan con los filtros actuales.",
  "label.panel.search": "Buscar por nombre o por LOINC",
  "button.panel.add": "Agregar panel",
  "label.panel.col.name": "Nombre del Panel",
  "label.panel.col.tests": "Pruebas",
  "label.panel.col.domain": "Dominio",
  "label.panel.list.mixedDomain": "Dominio mixto",
  "label.panel.list.mixedDomain.detail": "Tipos de muestra fuera del dominio de este panel: {sampleTypes}",
  "label.panel.col.sampleTypes": "Tipos de muestra (derivados)",
  "label.panel.col.status": "Estado",
  "label.panel.backToList": "Volver a la lista",
  "label.panel.notFound": "This panel does not exist or could not be loaded. Go back to the list to choose another.",
  "title.panel.new": "Nuevo Panel",
  "label.panel.name": "Nombre del Panel",
  "placeholder.panel.name": "Por ejemplo: Estudio de la anemia",
  "label.panel.domain": "Dominio",
  "helper.panel.domainGuard": "A este panel solo se pueden agregar pruebas de dominio «{domain}».",
  "helper.panel.loincIsIdentifier": "El código LOINC del panel sirve como identificador del mismo.",
  "note.panel.sampleTypesDerived": "Los tipos de muestras se derivan de las pruebas incluidas en este panel.",
  "label.panel.description": "Descripción",
  "label.panel.active": "Activo",
  "helper.panel.needsTest": "Agregue al menos una prueba antes de que se pueda activar este panel.",
  "error.panel.save": "No se ha podido guardar el panel. Compruebe los campos y vuelva a intentarlo.",
  "error.panel.nameRequired": "Es obligatorio indicar el nombre del Panel.",
  "error.panel.nameTooLong": "A panel name has at most 20 characters.",
  "error.panel.descriptionTooLong": "A description has at most 60 characters.",
  "error.panel.nameDuplicate": "Another panel already uses this name. Enter a different name.",
  "error.panel.domainConflict": "This panel cannot be filed under {domain}: {count, plural, one {# of its tests belongs} other {# of its tests belong}} to another domain ({tests}).",
  "helper.panel.domainConflict.remedy": "Change the domain of those tests in the Test Catalog, or remove them from this panel, then save again.",
  "error.panel.tests.domainConflict": "Not saved: {tests} {count, plural, one {is} other {are}} not in this panel's domain ({domain}). Only {domain}-domain tests can be added.",
  "error.panel.tests.activeNeedsTest": "Not saved: an active panel needs at least one test. Keep a test, or deactivate the panel in Basic Info first.",
  "error.panel.tests.inactive": "Not saved: {tests} {count, plural, one {is} other {are}} inactive. Only active tests can be added to a panel.",
  "error.panel.tests.loadFailed": "The panel's tests could not be loaded, so nothing can be saved yet. Retry to load them again.",
  "error.testCatalog.panels.domainConflict": "This test cannot join {panelName}: the panel is filed under {panelDomain} and the test under {testDomain}.",
  "error.testCatalog.panels.activeNeedsTest": "Not saved: {panels} would be left with no tests while active. Deactivate {count, plural, one {that panel} other {those panels}} first, or keep this test in {count, plural, one {it} other {them}}.",
  "success.panel.created": "Panel created. It stays inactive until at least one test is assigned to it.",
  "error.panel.create.invalid": "The panel could not be created. Fill in every required field, including a LOINC code.",
  "label.panel.section.basic-info": "Información básica",
  "label.panel.section.tests": "Pruebas",
  "label.panel.section.terminology": "Terminología",
  "label.panel.section.localization": "Localización",
  "label.panel.localization.intro": "Edite las traducciones por idioma del nombre de este panel. Los campos sin traducir se mostrarán en inglés. Gestione todas las traducciones desde la página de administración «Gestión de traducciones».",
  "label.panel.localization.empty": "Este panel no contiene campos de nombre que se puedan localizar.",
  "label.panel.localization.loadError": "No se han podido cargar las traducciones de este panel.",
  "label.panel.localization.field.name": "Nombre del Panel",
  "sidenav.label.admin.panel.editing": "Edición del panel: {name}",
  "sidenav.label.admin.panel.sectionsHelper": "Haga clic en un panel para editar sus secciones",
  "sidenav.label.admin.panel.addingNew": "Agregar un nuevo panel",
  "label.panel.testsCount": "pruebas",
  "label.panel.addTest": "Agregar una prueba",
  "label.panel.tests.filterBySampleType": "Filtrar por tipo de muestra",
  "label.panel.tests.filterBySampleType.all": "Todos los tipos de muestras",
  "placeholder.panel.addTest": "Buscar por nombre o código…",
  "helper.panel.membershipSync": "Los cambios en la composición del panel mantienen sincronizada la lista de paneles de la entrada de órdenes.",
  "label.panel.col.order": "Orden",
  "label.panel.col.testName": " Nombre de la prueba",
  "label.panel.col.code": "Código",
  "label.panel.moveUp": "Subir",
  "label.panel.moveDown": "Bajar",
  "empty.panel.tests": "Aún no hay pruebas; utilice el buscador de arriba para agregar la primera.",
  "helper.panel.loincRouting": "Además, se trata de una clave de enrutamiento en tiempo real: las órdenes electrónicas FHIR asocian los paneles mediante este código en el momento de la admisión. El LOINC principal permanece en el panel para la visualización de la lista y la introducción de órdenes.",
  "label.panel.terminology.primary": "Primaria",
  "label.panel.terminology.empty": "Aún no hay correspondencias terminológicas. La correspondencia LOINC es el identificador del panel.",
  "label.panel.terminology.saved": "Se han guardado las correspondencias terminológicas.",
  "label.panel.terminology.saveInvalid": "Algunas asignaciones no son válidas. Compruebe la fuente, el código y si hay duplicados.",
  "label.panel.terminology.codeTooLong": "Not saved: the code {code} is longer than {max} characters.",
  "label.panel.terminology.loincTooLong": "Not saved: {code} is not a LOINC code. A LOINC code has at most 10 characters.",
  "label.panel.terminology.saveError": "No se han podido guardar las correspondencias terminológicas.",
  "note.panel.positionShared": "El campo «position» establece el valor de «panel_item.sort_order», el mismo campo que se edita en la sección «Paneles» del lado de la prueba.",
  "label.testCatalog.section.labels": "Etiquetas",
  "label.testCatalog.section.terminology": "Terminología",
  "label.testCatalog.labels.col.preset": "Preajuste",
  "label.testCatalog.labels.col.defaultQty": "Cantidad por defecto",
  "label.testCatalog.labels.col.maxQty": "Cantidad máxima",
  "label.testCatalog.labels.col.allowOverride": "Permitir la sustitución",
  "label.testCatalog.labels.col.actions": "Acciones",
  "label.testCatalog.labels.addLabelType": "Agregar tipo de etiqueta",
  "label.testCatalog.labels.addLabelType.placeholder": "Seleccione una configuración predefinida de etiqueta…",
  "label.testCatalog.labels.empty": "No hay tipos de etiquetas configurados. Agregue plantillas de etiquetas para que se sugieran automáticamente al solicitar esta prueba.",
  "label.testCatalog.labels.loadError": "No se ha podido cargar la configuración de etiquetas para esta prueba.",
  "label.testCatalog.labels.saved": "Se ha guardado la configuración de la etiqueta",
  "label.testCatalog.labels.saveError": "No se ha podido guardar la configuración de la etiqueta.",
  "label.testCatalog.labels.unsaved": "Tiene cambios en las etiquetas que no se han guardado. Haga clic en «Guardar» para aplicarlos.",
  "label.testCatalog.labels.maxLtDefault": "La cantidad máxima debe ser mayor o igual a la cantidad por defecto.",
  "label.testCatalog.labels.allowOverride.label": "Permitir la modificación en el ingreso de la orden",
  "label.testCatalog.labels.generationSettings": "Configuración para generar etiquetas",
  "label.testCatalog.labels.remove.action": "Eliminar",
  "label.testCatalog.labels.remove.title": "Eliminar tipo de etiqueta",
  "label.testCatalog.labels.remove.confirm": "Eliminar",
  "label.testCatalog.labels.remove.body": "¿Desea eliminar «{name}» de la configuración de etiquetas de esta prueba?",
  "label.testCatalog.section.reagents": "Reactivos",
  "label.testCatalog.section.analyzers": "Analizadores",
  "label.testCatalog.section.alerts": "Alertas",
  "label.testCatalog.section.accreditation": "Accreditation",
  "label.testCatalog.accreditation.add": "Add accreditation",
  "label.testCatalog.accreditation.added": "Accreditation added",
  "label.testCatalog.accreditation.removed": "Accreditation removed",
  "label.testCatalog.accreditation.empty": "This test is not accredited by any body.",
  "label.testCatalog.accreditation.selectBody": "Choose an accrediting body",
  "label.testCatalog.accreditation.remove": "Remove accreditation",
  "label.testCatalog.accreditation.remove.body": "Remove this test from {body}? Its logo will stop appearing on reports that contain only this test.",
  "label.testCatalog.accreditation.manageLink": "Manage accrediting bodies and expiry dates",
  "label.testCatalog.accreditation.loadError": "Accreditation could not be loaded.",
  "label.testCatalog.accreditation.saveError": "The accreditation could not be added.",
  "label.testCatalog.accreditation.deleteError": "The accreditation could not be removed.",
  "label.testCatalog.section.reflex-calc": "Reflejos y cálculos",
  "label.testCatalog.section.localization": "Localización",
  "label.testCatalog.section.display-order": "Orden de visualización",
  "label.sampleType.section.basic-info": "Información básica",
  "label.sampleType.section.associated-tests": "Pruebas relacionadas",
  "label.sampleType.section.terminology": "Terminología",
  "label.sampleType.section.localization": "Localización",
  "label.sampleType.localization.intro": "Edite las traducciones por idioma del nombre de este tipo de muestra. Los campos sin traducir se mostrarán en Inglés. Gestione todas las traducciones desde la página de administración «Gestión de traducciones».",
  "label.sampleType.localization.empty": "Este tipo de muestra no tiene campos de nombre localizables.",
  "label.sampleType.localization.loadError": "No se han podido cargar las traducciones para este tipo de muestra.",
  "label.sampleType.localization.field.name": "Nombre del Tipo de Muestra",
  "label.sampleType.terminology.intro": "Asigne a este tipo de muestra los códigos de terminología estándar para garantizar la interoperabilidad.",
  "label.sampleType.terminology.empty": "Aún no hay correspondencias terminológicas.",
  "label.sampleType.terminology.saved": "Se han guardado las correspondencias terminológicas.",
  "label.sampleType.terminology.saveError": "No se han podido guardar las correspondencias terminológicas.",
  "label.sampleType.terminology.saveInvalid": "Algunas asignaciones no son válidas. Compruebe la fuente, el código y si hay duplicados.",
  "label.sampleType.terminology.addHint": "Guarde primero este tipo de muestra y, a continuación, agregue las correspondencias terminológicas.",
  "label.sampleType.localization.addHint": "Guarde primero este tipo de muestra y, a continuación, edite sus traducciones.",
  "label.sampleType.name": " Nombre",
  "label.sampleType.section.display-order": "Orden de visualización",
  "label.sampleType.section.disposal": "Eliminación",
  "label.sampleType.displayOrder": "Posición en el menú «Tipo de muestra»",
  "label.sampleType.displayOrder.intro": "Coloque este tipo de muestra en el menú «Tipo de muestra» de la entrada de órdenes. Introduzca una posición o utilice las flechas y, a continuación, guarde los cambios: se renumerarán todos los tipos de muestra.",
  "label.sampleType.displayOrder.current": "Este tipo de muestra",
  "label.sampleType.displayOrder.loading": "Cargando tipos de muestras...",
  "label.sampleType.displayOrder.saved": "Se ha actualizado el orden de visualización.",
  "label.sampleType.displayOrder.saveError": "No se ha podido actualizar el orden de visualización.",
  "label.sampleType.displayOrder.addHint": "Guarde primero este tipo de muestra y, a continuación, establezca su posición en el menú.",
  "label.sampleType.disposalInstructions": "Instrucciones de eliminación",
  "label.sampleType.disposal.intro": "Orientaciones de referencia en formato de texto libre para la eliminación de este tipo de muestra. Las instrucciones oficiales y estructuradas se recogen en la sección «Almacenamiento» de cada prueba y en el procedimiento de eliminación de muestras.",
  "label.sampleType.disposal.placeholder": "Por ejemplo: esterilizar en autoclave antes de su eliminación como residuos biopeligrosos",
  "label.sampleType.disposal.loading": "Cargando las instrucciones de eliminación...",
  "label.sampleType.disposal.saved": "Se han guardado las instrucciones de eliminación.",
  "label.sampleType.disposal.saveError": "No se han podido guardar las instrucciones de eliminación.",
  "label.sampleType.disposal.addHint": "Guarde primero este tipo de muestra y, a continuación, agregue las instrucciones de eliminación.",
  "label.sampleType.tests.manageIntro": "Pruebas relacionadas con este tipo de muestra. Busque en el catálogo para agregar más enlaces o eliminar los existentes. Este mismo enlace también se puede gestionar desde la sección «Información básica» de una prueba en el Catálogo de pruebas.",
  "label.sampleType.tests.search": "Buscar pruebas",
  "label.sampleType.tests.searchPlaceholder": "Buscar por nombre de la prueba...",
  "label.sampleType.tests.filterBySampleType": "Filtrar por tipo de muestra",
  "label.sampleType.tests.filterBySampleType.all": "Cualquiera de los tipos de muestra",
  "label.sampleType.tests.pick": "Prueba para agregar",
  "label.sampleType.tests.pickPlaceholder": "Seleccione una prueba...",
  "label.sampleType.tests.add": "Agregar prueba",
  "label.sampleType.tests.addError": "No se ha podido vincular la prueba a este tipo de muestra.",
  "label.sampleType.tests.domainMismatch": "This test belongs to another domain than this sample type, so it cannot use it.",
  "label.sampleType.tests.remove": "Eliminar prueba",
  "helper.sampleType.name": "Enter a unique name for this sample type (e.g., \"Serum\", \"Whole Blood\")",
  "helper.sampleType.description": "Provide a description of this sample type for lab staff reference",
  "label.sampleType.active": "Activo",
  "label.sampleType.description": "Descripción",
  "label.sampleType.tests.removeError": "No se ha podido desvincular la prueba.",
  "label.sampleType.tests.removeLastOfActive": "Not unlinked: this is the only sample type of an active test, which could then not be ordered. Give the test another sample type or deactivate it first.",
  "label.sampleType.tests.loading": "Cargando las pruebas relacionadas...",
  "label.sampleType.tests.none": "No hay pruebas asociadas a este tipo de muestra.",
  "message.sampleType.add.success": "Sample type saved successfully.",
  "message.sampleType.edit.success": "El tipo de muestra se ha actualizado correctamente.",
  "heading.sampleType.add": "Add New Sample Type",
  "button.sampleType.create": "Create Sample Type",
  "button.sampleType.creating": "Creando...",
  "heading.sampleType.filtered": "Showing {filtered} of {total} sample types",
  "heading.sampleType.total": "Total: {total} sample types",
  "label.sampleType.tests.addHint": "Save this sample type first, then associate tests from the test configuration.",
  "message.sampleType.noResults": "No sample types found matching your criteria",
  "error.sampleType.create.invalidName": "This name contains characters that are not allowed, such as HTML tags. Remove them and try again.",
  "error.sampleType.create.invalid": "The sample type was not created. Check the fields and try again.",
  "error.sampleType.create.duplicateName": "A sample type with this name already exists.",
  "error.sampleType.create.duplicateDescription": "Another sample type in this domain already has this description.",
  "error.sampleType.update.description.409": "Another sample type in this domain already has this description.",
  "error.sampleType.update.abbreviation.409": "Another sample type in this domain already uses this abbreviation.",
  "error.sampleType.update.abbreviation.400": "The abbreviation has at most 10 characters.",
  "error.sampleType.update.whonetCode.400": "The WHONET code has at most 5 characters.",
  "error.sampleType.update.description.400": "The description has at most 40 characters.",
  "error.sampleType.nameTooLong": "A new sample type name has at most 40 characters.",
  "label.sampleType.loading": "Cargando el tipo de muestra...",
  "label.sampleType.notFound": "This sample type does not exist. Go back to the list to choose another.",
  "label.sampleType.editorLoadError": "The sample types could not be loaded. Refresh the page to try again.",
  "stock.status.pendingQc": "Pendiente de CC",
  "stock.status.qcFailed": "CC fallido",
  "stock.status.quarantined": "En cuarentena",
  "label.sampleType.whonetCode": "Código de muestra de WHONET",
  "helper.sampleType.whonetCode": "Código introducido en el campo SPECIMEN_TYPE de WHONET (máximo 5 caracteres).",
  "label.sampleType.whonetReturn": "Volver a la vista previa de WHONET",
  "warning.sampleType.deactivateInUse": "{count} pruebas activas usan este tipo; no se podrán ordenar mientras esté inactivo.",
  "note.sampleType.associatedTests.viewOnly": "Solo lectura: la muestra de un análisis forma parte de su identidad. Para realizar un análisis con este tipo de muestra, cree una variante de muestra en el Catálogo de pruebas.",
  "sidenav.label.admin.sampleType.backToList": "← Todos los tipos de muestras",
  "sidenav.label.admin.sampleType.editing": "Edición: {name}",
  "sidenav.label.admin.sampleType.editingGeneric": "Edición del tipo de muestra",
  "sidenav.label.admin.sampleType.sectionsHelper": "Haga clic en un tipo de muestra para editar sus secciones",
  "sidenav.label.admin.sampleType.addingNew": "Agregar un nuevo tipo de muestra",
  "label.testCatalog.localization.locale": "Configuración regional",
  "label.testCatalog.localization.intro": "Edite las traducciones por idioma del nombre de esta prueba y del nombre que aparecerá en los informes. Los campos sin traducir se mostrarán en Inglés. Gestione todas las traducciones desde la página de administración «Gestión de traducciones».",
  "label.testCatalog.localization.unsaved": "Tiene cambios en la traducción que no se han guardado. Haga clic en «Guardar» para aplicarlos.",
  "label.testCatalog.localization.loadError": "No se han podido cargar las traducciones para esta prueba.",
  "label.testCatalog.localization.empty": "Esta prueba no contiene campos de nombre que se puedan traducir.",
  "label.testCatalog.localization.saved": "Traducción guardada",
  "label.testCatalog.localization.saveError": "No se ha podido guardar la traducción.",
  "label.testCatalog.localization.fallbackRequired": "The English value is what every screen shows when no translation exists, so it cannot be blank.",
  "label.testCatalog.localization.field.name": " Nombre de la prueba",
  "label.testCatalog.localization.field.reportingName": "Nombre para la presentación de informes",
  "label.testCatalog.localization.fallback.en": "Reserva (en)",
  "label.testCatalog.localization.fallback.tooltip": "Se muestra el valor en Inglés porque no hay ninguna traducción configurada para «{locale}».",
  "label.testCatalog.reflexCalc.loadError": "No se han podido cargar los enlaces cruzados de reflejos y cálculos para esta prueba.",
  "label.testCatalog.reflexCalc.reflex.heading": " Pruebas reflejas",
  "label.testCatalog.reflexCalc.reflex.helper": "Reglas que solicitan automáticamente pruebas adicionales en función de los resultados de esta prueba. Gestiónelas en «Listas maestras» → «Reglas de reflejo».",
  "label.testCatalog.reflexCalc.reflex.col.rule": "Nombre de la regla",
  "label.testCatalog.reflexCalc.reflex.col.trigger": "Condición de activación",
  "label.testCatalog.reflexCalc.reflex.col.reflexTests": "Pruebas reflejas solicitadas",
  "label.testCatalog.reflexCalc.reflex.empty": "No hay reglas de reflejo configuradas. Las reglas de reflejo se gestionan en «Listas maestras» → «Reglas de reflejo».",
  "label.testCatalog.reflexCalc.reflex.manage": "Gestionar reglas de reflejo",
  "label.testCatalog.reflexCalc.calc.heading": "Resultados calculados",
  "label.testCatalog.reflexCalc.calc.helper": "Fórmulas que utilizan los resultados de esta prueba o que generan esta prueba como resultado. Gestiónelas en «Listas maestras» → «Resultados calculados».",
  "label.testCatalog.reflexCalc.calc.feedsInto": "Esta prueba se integra en",
  "label.testCatalog.reflexCalc.calc.calculatedBy": "Esta prueba se calcula mediante",
  "label.testCatalog.reflexCalc.calc.col.name": "Nombre de la fórmula",
  "label.testCatalog.reflexCalc.calc.col.formula": "Fórmula",
  "label.testCatalog.reflexCalc.calc.col.output": "Prueba de salida",
  "label.testCatalog.reflexCalc.calc.empty": "Ninguno",
  "label.testCatalog.reflexCalc.calc.feedsInto.empty": "Esta prueba no influye en ningún resultado calculado. Los cálculos se gestionan en «Listas maestras» → «Valores calculados».",
  "label.testCatalog.reflexCalc.calc.calculatedBy.empty": "Esta prueba no se calcula desde otras pruebas. Los cálculos se gestionan en «Listas maestras» → «Valores calculados».",
  "label.testCatalog.reflexCalc.calc.manage": "Gestionar resultados calculados",
  "label.testCatalog.alerts.addRule": "Agregar regla",
  "label.testCatalog.alerts.empty": "No hay reglas de alerta configuradas. Agregue una regla para notificar a los destinatarios cuando los resultados cumplan una condición.",
  "label.testCatalog.alerts.loadError": "No se han podido cargar las reglas de alerta para esta prueba.",
  "label.testCatalog.alerts.saved": "Regla de alerta guardada",
  "label.testCatalog.alerts.saveError": "No se ha podido guardar la regla de alerta.",
  "label.testCatalog.alerts.saveRefused": "The alert rule was refused. The name, value and custom email hold at most 100 characters, the custom phone 20, and the role must be one that can be notified.",
  "label.testCatalog.alerts.deleted": "Se ha eliminado la regla de alerta",
  "label.testCatalog.alerts.deleteError": "No se ha podido eliminar la regla de alerta.",
  "label.testCatalog.alerts.nameRequired": "Es obligatorio indicar el nombre de la regla.",
  "label.testCatalog.alerts.valueRequired": "Se requiere un valor específico para el desencadenador «Valor específico».",
  "label.testCatalog.alerts.col.name": " Nombre",
  "label.testCatalog.alerts.col.trigger": "Disparador",
  "label.testCatalog.alerts.col.channels": "Canales",
  "label.testCatalog.alerts.col.ack": "Se requiere confirmación",
  "label.testCatalog.alerts.col.enabled": "Activado",
  "label.testCatalog.alerts.col.actions": "Acciones",
  "label.testCatalog.alerts.trigger.ALL": "Todos los resultados",
  "label.testCatalog.alerts.trigger.ABNORMAL": "Anormal",
  "label.testCatalog.alerts.trigger.CRITICAL": "Crítico",
  "label.testCatalog.alerts.trigger.SPECIFIC_VALUE": "Valor específico",
  "label.testCatalog.alerts.trigger.COMPLIANCE_BREACH": "Incumplimiento normativo",
  "label.testCatalog.alerts.edit.action": "Editar",
  "label.testCatalog.alerts.delete.action": "Eliminar",
  "label.testCatalog.alerts.delete.title": "Eliminar regla de alerta",
  "label.testCatalog.alerts.delete.confirm": "Eliminar",
  "label.testCatalog.alerts.delete.body": "¿Desea eliminar la regla de alerta «{name}»?",
  "label.testCatalog.alerts.modal.addTitle": "Agregar regla de alerta",
  "label.testCatalog.alerts.modal.editTitle": "Editar regla de alerta",
  "label.testCatalog.alerts.field.name": "Nombre de la regla",
  "label.testCatalog.alerts.field.trigger": "Avisar cuando el resultado sea:",
  "label.testCatalog.alerts.field.specificValue": "Valor específico",
  "label.testCatalog.alerts.field.channels": "Canales de notificación",
  "label.testCatalog.alerts.field.recipients": "Destinatarios",
  "label.testCatalog.alerts.field.ackRequired": "Exigir acuse de recibo",
  "label.testCatalog.alerts.channel.sms": "SMS",
  "label.testCatalog.alerts.channel.email": "Correo Electrónico",
  "label.testCatalog.alerts.recipient.physician": "Médico que prescribe",
  "label.testCatalog.alerts.recipient.patient": "Paciente",
  "label.testCatalog.alerts.recipient.facility": "Instalación de referencia",
  "label.testCatalog.alerts.recipient.customPhone": "Teléfono personalizado",
  "label.testCatalog.alerts.recipient.customEmail": "Correo Electrónico personalizado",
  "label.testCatalog.alerts.recipient.roleId": "Notificar a los usuarios con ese rol",
  "label.testCatalog.alerts.recipient.rolePlaceholder": "Seleccione un rol",
  "label.testCatalog.reagents.col.name": "Nombre del reactivo",
  "label.testCatalog.reagents.col.usage": "Tipo de uso",
  "label.testCatalog.reagents.col.qty": "Cantidad por prueba",
  "label.testCatalog.reagents.col.stock": "Nivel de existencias",
  "label.testCatalog.reagents.col.actions": "Acciones",
  "label.testCatalog.reagents.empty": "No hay reactivos vinculados. Vincule los reactivos del inventario para realizar un seguimiento del consumo por prueba.",
  "label.testCatalog.reagents.loadError": "No se han podido cargar los reactivos para esta prueba.",
  "label.testCatalog.reagents.linkButton": "Vincular reactivo",
  "label.testCatalog.reagents.linkError": "No se ha podido vincular uno o varios reactivos. Inténtelo de nuevo.",
  "label.testCatalog.reagents.modal.title": "Vincular reactivos",
  "label.testCatalog.reagents.modal.linkSelected": "Vincular seleccionados",
  "label.testCatalog.reagents.modal.select.label": "Reactivos",
  "label.testCatalog.reagents.modal.select.placeholder": "Seleccione los reactivos que desee vincular",
  "label.testCatalog.reagents.modal.allLinked": "Todos los reactivos disponibles ya están asociados a esta prueba.",
  "label.testCatalog.reagents.unitPlaceholder": "Unidad",
  "label.testCatalog.reagents.updated": "Se ha actualizado el reactivo",
  "label.testCatalog.reagents.saveError": "No se han podido guardar los cambios.",
  "label.testCatalog.reagents.unitTooLong": "A unit can have at most 50 characters.",
  "label.testCatalog.reagents.unsaved": "Tiene cambios en los reactivos que no se han guardado. Haga clic en «Guardar» para aplicarlos.",
  "label.testCatalog.reagents.retry": "Inténtelo de nuevo",
  "label.testCatalog.reagents.unlink.action": "Desvincular",
  "label.testCatalog.reagents.unlink.title": "Desvincular reactivo",
  "label.testCatalog.reagents.unlink.confirm": "Desvincular",
  "label.testCatalog.reagents.unlink.body": "¿Desea desvincular «{name}» de esta prueba? Los resultados existentes vinculados a este reactivo no se verán afectados.",
  "label.testCatalog.reagents.unlinked": "Reactivo desvinculado",
  "label.testCatalog.reagents.unlinkError": "No se ha podido desvincular el reactivo. Inténtelo de nuevo.",
  "label.testCatalog.basicInfo.name": " Nombre",
  "label.testCatalog.basicInfo.name.helper": "El nombre que se muestra está traducido; puede editarlo en la sección «Localización».",
  "label.testCatalog.basicInfo.reportingName": "Nombre para la presentación de informes",
  "label.testCatalog.basicInfo.labUnit": "Unidad de laboratorio",
  "label.testCatalog.basicInfo.labUnit.inactive": "{name} (inactive)",
  "label.testCatalog.basicInfo.labUnit.inactiveHelp": "This lab unit is inactive, so the test cannot be ordered. Saving keeps it inactive; reactivate it in Lab Unit Management.",
  "label.testCatalog.basicInfo.createInactiveHint": "La prueba se crea como «inactiva». Configure sus secciones y, a continuación, actívela para que sea ordenable.",
  "sidenav.label.environmental.compliance.tooltip": "Panel de cumplimiento medioambiental",
  "site.search.helper": "Escriba al menos 2 caracteres para activar la búsqueda automática. Es obligatorio para redirigir los resultados al sitio solicitante.",
  "storage.skipped.title": "Almacenamiento omitido para {count} muestra(s)",
  "test.qc.blankThreshold": "Umbral del blanco",
  "test.qc.recoveryWindowPct": "Margen de recuperación (%)",
  "test.qc.rpdThreshold": "Umbral de RPD (%)",
  "test.qc.thresholds.description": "Umbrales opcionales para la evaluación del CC ambiental y de vectores. Déjelo en blanco si no procede.",
  "test.qc.thresholds.heading": "Umbrales de aceptación del CC",
  "title.testCatalog.createTest": "Crear una nueva prueba",
  "label.testCatalog.testName": "Nombre de la prueba",
  "label.testCatalog.testCode": "Código de prueba",
  "label.testCatalog.domain": "Dominio",
  "label.testCatalog.specimenType": "Tipo de muestra",
  "label.testCatalog.basicInfo.sampleTypes": "Tipos de muestra",
  "helper.testCatalog.basicInfo.sampleTypesMulti": "Seleccione todas las muestras en las que se va a realizar esta prueba. La configuración se aplica a todas ellas.",
  "error.testCatalog.basicInfo.sampleTypeRequired": "Seleccione al menos un tipo de muestra.",
  "error.testCatalog.basicInfo.sampleTypeDomain": "El dominio de este tipo de muestra no coincide con el dominio de la prueba.",
  "label.testCatalog.list.sampleTypesSummary": "{first} +{n}",
  "label.testCatalog.override.col.sampleType": "Muestra",
  "label.testCatalog.override.shared": "Todas las muestras (compartidas)",
  "notice.testCatalog.intake.awaitingSpecimen": "A la espera de la muestra: esta prueba se realiza con varias muestras; resuélvalo en el momento de la recolección.",
  "tag.testCatalog.finding.noSampleTypeLink": "No hay enlace de tipo «muestra»",
  "error.testCatalog.codeExists": "Ya existe una prueba con este código.",
  "error.testCatalog.description.inUse": "Ya hay otra prueba que utiliza esta descripción. Las descripciones deben ser únicas; modifíquela y vuelva a guardarla.",
  "notification.testCatalog.testCreated": "Se ha creado la prueba «{name}». Complete su configuración en las secciones de la izquierda.",
  "label.testCatalog.basicInfo.code": "Código",
  "label.testCatalog.basicInfo.description": "Descripción",
  "label.testCatalog.basicInfo.domain": "Dominio",
  "label.testCatalog.basicInfo.domain.CLINICAL": "Clínico",
  "label.testCatalog.basicInfo.domain.ENVIRONMENTAL": "Ambiental",
  "label.testCatalog.basicInfo.domain.VECTOR": "Vector",
  "label.testCatalog.basicInfo.domainModal.title": "¿Cambiar el dominio de prueba?",
  "label.testCatalog.basicInfo.domainModal.body": "¿Desea cambiar el dominio de esta prueba a {domain}? Esto afecta a la forma en que se clasifica la prueba en el catálogo.",
  "label.testCatalog.basicInfo.amr": "Prueba de vigilancia de la resistencia a los antimicrobianos (AMR)",
  "label.testCatalog.basicInfo.active": "Activo",
  "label.testCatalog.basicInfo.status": "Estado",
  "label.testCatalog.basicInfo.orderable": "Ordenable",
  "label.testCatalog.basicInfo.saved": "Se ha guardado la información básica.",
  "error.testCatalog.basicInfo.labUnitInactive": "That lab unit is inactive. Choose an active unit, or reactivate it in Lab Unit Management first.",
  "error.testCatalog.create.refused": "The test was not created: a sample type or the lab unit cannot be used. Check them and try again.",
  "error.testCatalog.basicInfo.invalidValue": "Basic info was not saved: one of the values cannot be stored. Correct the highlighted field.",
  "error.testCatalog.basicInfo.timeHolding": "Enter a whole number of minutes, or leave blank.",
  "error.testCatalog.basicInfo.qcThreshold": "Enter a number of 0 or more (up to 5 decimal places), or leave blank.",
  "label.testCatalog.sampleResults.saved": "Se han guardado la muestra y los resultados.",
  "label.testCatalog.sampleResults.empty": "Aún no hay componentes de resultados. Agregue uno para definir cómo se recogen los resultados de esta prueba.",
  "label.testCatalog.sampleResults.newComponent": "(nuevo componente)",
  "label.testCatalog.sampleResults.code": "Código del componente",
  "label.testCatalog.sampleResults.isPrimary": "Componente principal",
  "label.testCatalog.sampleResults.showOnReport": "Mostrar en el informe del paciente",
  "label.testCatalog.sampleResults.label": "Etiqueta del componente",
  "label.testCatalog.sampleResults.resultType": " Tipo de resultado",
  "label.testCatalog.sampleResults.resultType.N": "Numérico",
  "label.testCatalog.sampleResults.resultType.none": "No se ha seleccionado ningún tipo de resultado",
  "label.testCatalog.sampleResults.preview.noType": "Seleccione un tipo de resultado de entre los que figuran más arriba para ver cómo introducirán los técnicos dicho resultado.",
  "label.testCatalog.sampleResults.resultType.D": "Lista de selección única (diccionario)",
  "label.testCatalog.sampleResults.resultType.R": "Texto libre",
  "label.testCatalog.sampleResults.resultType.M": "Lista de selección múltiple",
  "label.testCatalog.sampleResults.resultType.C": "Selección múltiple en cascada",
  "label.testCatalog.sampleResults.resultType.T": "Título",
  "label.testCatalog.sampleResults.resultType.A": "Alfa (texto validado)",
  "label.testCatalog.sampleResults.resultType.group.primary": "Común",
  "label.testCatalog.sampleResults.resultType.group.advanced": "Tipos avanzados / heredados",
  "label.testCatalog.sampleResults.resultType.showAdvanced": "Tipos avanzados / heredados",
  "label.testCatalog.sampleResults.resultType.hideAdvanced": "Ocultar tipos avanzados / heredados",
  "label.testCatalog.sampleResults.resultTypeDesc.N": "Un valor medido acompañado de una unidad (p. ej., 12,3 g/dL).",
  "label.testCatalog.sampleResults.resultTypeDesc.D": "Un valor seleccionado desde un conjunto fijo (por ejemplo, «Detectado» / «No detectado»).",
  "label.testCatalog.sampleResults.resultTypeDesc.R": "Un comentario o una descripción en texto.",
  "label.testCatalog.sampleResults.resultTypeDesc.M": "Uno o varios valores de una lista; no hay un único valor de referencia.",
  "label.testCatalog.sampleResults.resultTypeDesc.C": "Opciones agrupadas; seleccione varios grupos.",
  "label.testCatalog.sampleResults.resultTypeDesc.T": "Una relación de dilución como, por ejemplo, 1:10 o 1:20 (habitual en Serología).",
  "label.testCatalog.sampleResults.resultTypeDesc.A": "Texto alfanumérico validado (un código o un valor codificado breve).",
  "label.testCatalog.sampleResults.preview": "Vista previa de la introducción de resultados",
  "label.testCatalog.sampleResults.previewHelper": "Esto es lo que verá un técnico al introducir este resultado.",
  "label.testCatalog.sampleResults.purpose": "Defina qué datos debe registrar un técnico en esta prueba y cómo se interpretan los resultados.",
  "label.testCatalog.sampleResults.labelRequired": "Cada componente del resultado debe tener una etiqueta para que se pueda guardar.",
  "label.testCatalog.sampleResults.resultTypeRequired": "Seleccione un tipo de resultado para «{component}» antes de guardar.",
  "label.testCatalog.sampleResults.mostTestsOneResult": "La mayoría de las pruebas arrojan un único resultado. Agregue un componente únicamente si dicha prueba proporciona varios valores (por ejemplo, un diferencial).",
  "label.testCatalog.sampleResults.displayOrder": "Orden de visualización",
  "label.testCatalog.sampleResults.uom": " Unidad de medida",
  "label.testCatalog.sampleResults.uom.none": "(ninguno)",
  "label.testCatalog.sampleResults.uom.addNew": "＋ Agregar una nueva unidad…",
  "label.testCatalog.sampleResults.uom.newName": "Nombre para mostrar",
  "label.testCatalog.sampleResults.uom.newCode": "Código",
  "label.testCatalog.sampleResults.uom.newUcum": "Código UCUM",
  "label.testCatalog.sampleResults.uom.newDescription": "Descripción",
  "label.testCatalog.sampleResults.uom.saveNew": "Crear unidad",
  "label.testCatalog.sampleResults.significantDigits": " Cifras significativas",
  "label.testCatalog.sampleResults.significantDigits.helper": "Número de dígitos que se deben mantener después de la coma decimal al introducir un resultado numérico. Déjelo en blanco si no desea que se redondee.",
  "admin.testCatalog.sampleResults.lod.label": "LOD",
  "admin.testCatalog.sampleResults.loq.label": "LOQ",
  "admin.testCatalog.sampleResults.lod.helper": "Límite de detección (opcional)",
  "admin.testCatalog.sampleResults.loq.helper": "Límite de cuantificación (opcional)",
  "error.testCatalog.sampleResults.valueTooLong": "{component}: a value is longer than its field allows (label 255, code 50, default result and option value 80; interpretation text 255, match 80, severity and color 20 characters).",
  "error.testCatalog.sampleResults.unitUnknown": "{component}: that unit of measure does not exist.",
  "error.testCatalog.sampleResults.activeNeedsComponent": "Not saved: an active test needs at least one result component. Keep a component, or deactivate the test in Basic Info first.",
  "error.testCatalog.sampleResults.lodGtLoq": "El LOD no puede ser mayor que el LOQ.",
  "error.testCatalog.sampleResults.detectionLimitNegative": "Los límites de detección deben ser cero o mayores.",
  "admin.testCatalog.qcTargets.section.label": "Objetivos de CC",
  "admin.testCatalog.qcTargets.intro": "Los objetivos de control contra los cuales el módulo de ingreso de resultados evalúa cada ejecución de CC. Ingréselos una sola vez aquí para que los técnicos solo tengan que introducir el valor medido.",
  "admin.testCatalog.qcTargets.column.level": "Nivel de control",
  "admin.testCatalog.qcTargets.column.expected": "Valor esperado",
  "admin.testCatalog.qcTargets.column.uncertainty": "Incertidumbre (±)",
  "admin.testCatalog.qcTargets.column.unit": "Unidad",
  "admin.testCatalog.qcTargets.column.overrides": "Sustituciones por lote",
  "admin.testCatalog.qcTargets.column.status": "Estado",
  "admin.testCatalog.qcTargets.column.actions": "Acciones",
  "admin.testCatalog.qcTargets.level.low": "Bajo",
  "admin.testCatalog.qcTargets.level.normal": "Normal",
  "admin.testCatalog.qcTargets.level.high": "Alto",
  "admin.testCatalog.qcTargets.expectedOutcome.label": "Resultado esperado",
  "admin.testCatalog.qcTargets.expectedOutcome.placeholder": "Elija el resultado esperado",
  "admin.testCatalog.qcTargets.addTarget": "Añadir objetivo",
  "admin.testCatalog.qcTargets.addOverride": "Añadir sustitución por lote",
  "admin.testCatalog.qcTargets.lot.label": "Lote de control",
  "admin.testCatalog.qcTargets.lot.placeholder": "Buscar lotes de control...",
  "admin.testCatalog.qcTargets.lot.emptyLink": "No se encontraron lotes — gestione los lotes en la administración de lotes de CC",
  "admin.testCatalog.qcTargets.overrides.none": "Sin sustituciones por lote",
  "admin.testCatalog.qcTargets.overrides.count": "{count, plural, one {# lot override} many {# lot overrides} other {# sustituciones por lote}}",
  "admin.testCatalog.qcTargets.empty.level": "No hay un objetivo configurado — los técnicos ingresan los valores al momento de la captura",
  "admin.testCatalog.qcTargets.helper.precedence": "Al ingresar resultados, el formulario de control se completa automáticamente con la excepción de lote si existe, o de lo contrario con el valor predeterminado del nivel.",
  "admin.testCatalog.qcTargets.showDeactivated": "Mostrar desactivados",
  "admin.testCatalog.qcTargets.deactivate": "Desactivar",
  "admin.testCatalog.qcTargets.reactivate": "Reactivar",
  "admin.testCatalog.qcTargets.edit": "Editar objetivo",
  "admin.testCatalog.qcTargets.done": "Hecho",
  "admin.testCatalog.qcTargets.saved": "Objetivos de CC guardados.",
  "admin.testCatalog.qcTargets.loadError": "No se pudieron cargar los objetivos de CC.",
  "error.testCatalog.qcTargets.uncertaintyNegative": "La incertidumbre debe ser un número no negativo.",
  "error.testCatalog.qcTargets.required": "Cada objetivo activo necesita un valor esperado y una incertidumbre, o un resultado esperado.",
  "label.testCatalog.sampleResults.defaultResult": "Resultado predeterminado",
  "label.testCatalog.sampleResults.defaultResult.none": "No default",
  "label.testCatalog.sampleResults.allowMultiple": "Permitir varias lecturas",
  "label.testCatalog.sampleResults.options": "Opciones de lista de selección",
  "label.testCatalog.sampleResults.options.empty": "Aún no se ha definido ninguna opción. Agregue al menos una opción para que se pueda introducir este resultado.",
  "label.testCatalog.sampleResults.option.value": "Valor",
  "label.testCatalog.sampleResults.option.sortOrder": "Orden de clasificación",
  "label.testCatalog.sampleResults.option.sortOrder.helper": "Las opciones se muestran a los técnicos en orden ascendente: los números más bajos aparecen en primer lugar.",
  "label.testCatalog.sampleResults.option.normal": "Normal",
  "label.testCatalog.sampleResults.option.qualifiable": "Qualifiable",
  "error.testCatalog.sampleResults.duplicateOption": "{component} lists {options} more than once. Remove the extra row so result entry offers each option once.",
  "label.testCatalog.sampleResults.addOption": "Agregar opción",
  "label.testCatalog.sampleResults.addCustomOption": "Agregar una opción personalizada",
  "label.testCatalog.sampleResults.searchDictionary": "Buscar valores del diccionario…",
  "label.testCatalog.sampleResults.removeOption": "Eliminar opción",
  "label.testCatalog.sampleResults.interpretations": "Interpretaciones",
  "label.testCatalog.sampleResults.interpretations.empty": "No hay interpretaciones definidas. Agregue una para adjuntar una orientación o un indicador de Severidad a un resultado.",
  "label.testCatalog.sampleResults.interp.valueMatch": "Coincidencia de valor",
  "label.testCatalog.sampleResults.interp.selectValue": "Elija un valor…",
  "label.testCatalog.sampleResults.interp.numericHint": "p. ej., >140, 90-140, =0",
  "label.testCatalog.sampleResults.interp.text": "Interpretación",
  "label.testCatalog.sampleResults.interp.severity": " Severidad",
  "label.testCatalog.sampleResults.addInterpretation": "Agregar interpretación",
  "label.testCatalog.sampleResults.removeInterpretation": "Eliminar la interpretación",
  "label.testCatalog.sampleResults.severity.NORMAL": "Normal",
  "label.testCatalog.sampleResults.severity.ABNORMAL": "Anormal",
  "label.testCatalog.sampleResults.severity.CRITICAL": "Crítico",
  "label.testCatalog.sampleResults.actions": "Acciones",
  "label.testCatalog.sampleResults.addComponent": "Agregar componente",
  "label.testCatalog.sampleResults.removeComponent": "Eliminar componente",
  "label.testCatalog.sampleResults.moveUp": "Subir el componente",
  "label.testCatalog.sampleResults.moveDown": "Desplazar el componente hacia abajo",
  "label.testCatalog.sampleResults.copyFrom": "Copiar la configuración de la prueba",
  "label.testCatalog.sampleResults.copyFrom.placeholder": "Seleccione una prueba…",
  "label.testCatalog.sampleResults.copyFromButton": "Copiar desde la prueba",
  "label.testCatalog.sampleResults.copyConfirm.title": "Replace this test's result configuration?",
  "label.testCatalog.sampleResults.copyConfirm.body": "Every result component, select-list option and interpretation of this test will be replaced with those of {source}. Nothing changes until you click Save. Once saved, the replacement cannot be undone.",
  "label.testCatalog.sampleResults.copyConfirm.confirm": "Replace configuration",
  "label.testCatalog.sampleResults.copyStaged": "Configuration copied from {source}, not saved yet",
  "label.testCatalog.sampleResults.copyStaged.helper": "Click Save to replace this test's configuration with it, or discard it to keep the current one.",
  "label.testCatalog.sampleResults.copyDiscard": "Discard copied configuration",
  "label.testCatalog.sampleResults.copyEmpty": "{source} has no result configuration to copy.",
  "label.testCatalog.sampleResults.copyLoadError": "The configuration of {source} could not be loaded.",
  "label.testCatalog.sampleResults.copied": "Configuración copiada.",
  "label.testCatalog.ranges.activated": "Prueba activada.",
  "label.testCatalog.ranges.ackModal.title": "¿Activar con lagunas en la cobertura?",
  "label.testCatalog.ranges.ackModal.confirm": "Reconocer y activar",
  "label.testCatalog.ranges.ackModal.warning": "Esta prueba presenta lagunas en los rangos de referencia.",
  "label.testCatalog.ranges.ackModal.body": "Los siguientes intervalos de edad no tienen rango de referencia; por lo tanto, los resultados correspondientes no pueden compararse con ningún rango. Confirme para activarlos de todos modos.",
  "label.testCatalog.ranges.male": "Masculino",
  "label.testCatalog.ranges.female": "Femenino",
  "label.testCatalog.ranges.gapRange": "{from} – {to}",
  "label.testCatalog.ranges.days": "días",
  "label.testCatalog.ranges.months": "meses",
  "label.testCatalog.ranges.years": "años",
  "label.testCatalog.ranges.noUpperLimit": "sin límite máximo",
  "label.testCatalog.ranges.noLowerLimit": "sin límite mínimo",
  "label.testCatalog.ranges.both": "Ambos",
  "label.testCatalog.ranges.add": "Agregar rango",
  "label.testCatalog.ranges.empty": "Aún no se han definido los rangos de referencia.",
  "label.testCatalog.ranges.saved": "Se han guardado los rangos de referencia.",
  "label.testCatalog.ranges.loadError": "No se han podido cargar los rangos de referencia.",
  "label.testCatalog.ranges.col.component": "Componente",
  "label.testCatalog.ranges.allComponents": "Todos los componentes",
  "label.testCatalog.ranges.col.sex": "Sexo",
  "label.testCatalog.ranges.col.age": " Rango de edad",
  "label.testCatalog.ranges.col.normal": "Normal",
  "label.testCatalog.ranges.col.critical": "Crítico",
  "label.testCatalog.ranges.col.valid": "Válido",
  "label.testCatalog.ranges.col.actions": "Acciones",
  "label.testCatalog.ranges.anyAge": "Cualquier edad",
  "label.testCatalog.ranges.coverage.title": "Validación de la cobertura",
  "label.testCatalog.ranges.coverage.gapsHeading": "Intervalos de edad sin cubrir:",
  "label.testCatalog.ranges.coverage.gapWithComponent": "{range} — {component}",
  "label.testCatalog.ranges.coverage.status.COMPLETE": "Totalmente cubierto",
  "label.testCatalog.ranges.coverage.status.GAP": "Presenta lagunas",
  "label.testCatalog.ranges.coverage.status.OVERLAP": "Tiene solapamientos",
  "label.testCatalog.ranges.coverage.status.EMPTY": "Sin rangos",
  "label.testCatalog.ranges.modal.titleAdd": "Agregar rango de referencia",
  "label.testCatalog.ranges.modal.titleEdit": "Editar rango de referencia",
  "label.testCatalog.ranges.modal.sex": "Se aplica a",
  "label.testCatalog.ranges.modal.component": "Componente de resultado",
  "label.testCatalog.ranges.modal.component.all": "Todos los componentes",
  "label.testCatalog.ranges.modal.ageUnit": "Unidad de edad",
  "label.testCatalog.ranges.modal.minAge": "Desde la edad",
  "label.testCatalog.ranges.modal.maxAge": "Hasta la edad (en blanco = sin límite máximo)",
  "label.testCatalog.ranges.modal.lowNormal": "Mínimo normal",
  "label.testCatalog.ranges.modal.highNormal": "Máximo normal",
  "label.testCatalog.ranges.modal.lowCritical": "Mínimo crítico",
  "label.testCatalog.ranges.modal.highCritical": "Máximo crítico",
  "label.testCatalog.ranges.modal.lowValid": "Mínimo válido",
  "label.testCatalog.ranges.modal.highValid": "Máximo válido",
  "label.testCatalog.ranges.modal.lowReporting": "Reporting low",
  "label.testCatalog.ranges.modal.highReporting": "Reporting high",
  "error.testCatalog.ranges.reportingInverted": "Reporting low must not be above reporting high.",
  "label.testCatalog.ranges.modal.ageError": "«Hasta la edad» debe ser mayor que «Desde la edad».",
  "label.testCatalog.ranges.modal.boundsError": "Los límites deben anidarse de forma ascendente: mínimo válido ≤ mínimo crítico ≤ mínimo normal ≤ máximo normal ≤ máximo crítico ≤ máximo válido.",
  "label.testCatalog.storage.saved": "Se ha guardado el almacenamiento de muestras.",
  "label.testCatalog.storage.loadError": "No se han podido cargar los ajustes de almacenamiento de muestras.",
  "label.testCatalog.storage.history.view": "Consultar historial de cambios",
  "label.testCatalog.storage.history.title": "Almacenamiento de muestras — Historial de cambios",
  "label.testCatalog.storage.history.loadError": "No se ha podido cargar el historial de cambios.",
  "label.testCatalog.storage.history.empty": "No se han registrado cambios.",
  "label.testCatalog.storage.history.filter": "Filtrar por campo",
  "label.testCatalog.storage.history.col.changedAt": "Modificado el",
  "label.testCatalog.storage.history.col.changedBy": "Modificado por",
  "label.testCatalog.storage.history.col.field": "Campo",
  "label.testCatalog.storage.history.col.old": " Valor anterior",
  "label.testCatalog.storage.history.col.new": " Valor nuevo",
  "label.testCatalog.storage.storageHeading": "Almacenamiento",
  "label.testCatalog.storage.disposalHeading": "Eliminación",
  "label.testCatalog.storage.handlingHeading": "Manipulación especial",
  "label.testCatalog.storage.condition": "Condiciones de almacenamiento",
  "label.testCatalog.storage.conditionCustom": "Condición personalizada",
  "label.testCatalog.storage.duration": "Plazo máximo de conservación",
  "label.testCatalog.storage.durationUnit": "Unidad de duración",
  "label.testCatalog.storage.stabilityNotes": "Notas sobre la estabilidad",
  "label.testCatalog.storage.protectFromLight": "Proteger de la luz",
  "label.testCatalog.storage.doNotFreeze": "No congelar",
  "label.testCatalog.storage.doNotRefrigerate": "No refrigerar",
  "label.testCatalog.storage.disposalMethod": "Método de eliminación",
  "label.testCatalog.storage.disposalTimeframe": "Plazo de eliminación",
  "label.testCatalog.storage.disposalUnit": "Unidad de tiempo",
  "label.testCatalog.storage.specialInstructions": "Instrucciones especiales",
  "label.testCatalog.storage.overrideRestricted": "Restringir la anulación de la duración del almacenamiento",
  "label.testCatalog.storage.none": "— Ninguno —",
  "label.testCatalog.storage.condition.AMBIENT": "Temperatura ambiente / temperatura de la habitación",
  "label.testCatalog.storage.condition.CONTROLLED_ROOM_TEMPERATURE": "Temperatura ambiente controlada (20-25 °C)",
  "label.testCatalog.storage.condition.COOL_ROOM": "Cámara fría (8–15 °C)",
  "label.testCatalog.storage.condition.COLD_ROOM": "Cámara frigorífica (2–8 °C)",
  "label.testCatalog.storage.condition.REFRIGERATED": "Refrigerado (2–8 °C)",
  "label.testCatalog.storage.condition.FROZEN": "Congelado (−20 °C)",
  "label.testCatalog.storage.condition.DEEP_FROZEN": "Ultracongelado (−70 °C)",
  "label.testCatalog.storage.condition.ULTRA_LOW_FREEZER": "Congelador de temperatura ultrabaja (−80 °C)",
  "label.testCatalog.storage.condition.WARM_INCUBATOR": "Incubadora con temperatura controlada (35–37 °C)",
  "label.testCatalog.storage.disposal.INCINERATION": "Incineración",
  "label.testCatalog.storage.disposal.AUTOCLAVE": "Autoclave",
  "label.testCatalog.storage.disposal.CHEMICAL_DISINFECTION": "Desinfección química",
  "label.testCatalog.storage.disposal.BIOHAZARD": "Residuos biopeligrosos",
  "label.testCatalog.storage.disposal.SHARPS_CONTAINER": "Contenedor para objetos punzantes",
  "label.testCatalog.storage.disposal.SEWER": "Eliminación por alcantarillado / desagüe",
  "label.testCatalog.storage.disposal.RETURN_TO_SENDER": "Devolver al remitente",
  "label.testCatalog.storage.disposal.ARCHIVE": "Archivo a largo plazo",
  "label.testCatalog.storage.disposal.STANDARD": "Residuos comunes",
  "label.testCatalog.storage.unit.hours": "horas",
  "label.testCatalog.storage.unit.days": "días",
  "label.testCatalog.storage.unit.weeks": "semanas",
  "label.testCatalog.storage.unit.months": "meses",
  "label.testCatalog.analyzers.infoCard": "Los analizadores se asocian a esta prueba en la pantalla de configuración del analizador. Esta lista es de solo lectura.",
  "label.testCatalog.analyzers.empty": "Aún no se ha asignado ningún analizador a esta prueba.",
  "label.testCatalog.analyzers.loadError": "No se han podido cargar los analizadores para esta prueba.",
  "label.testCatalog.analyzers.col.analyzer": "Analizador",
  "label.testCatalog.analyzers.col.testName": "Nombre de la prueba del Analizador",
  "label.testCatalog.displayOrder.pickSampleType": "Tipo de muestra",
  "label.testCatalog.displayOrder.intro": "Reorganice el orden en que aparecen las pruebas dentro de un tipo de muestra. El orden se guarda automáticamente.",
  "label.testCatalog.displayOrder.empty": "No se ha asignado ninguna prueba a este tipo de muestra.",
  "label.testCatalog.displayOrder.loadError": "No se ha podido cargar el orden de visualización.",
  "label.testCatalog.displayOrder.saved": "Se ha guardado el orden de visualización.",
  "label.testCatalog.displayOrder.currentTest": "This test",
  "label.testCatalog.displayOrder.moveUp": "Subir",
  "label.testCatalog.displayOrder.moveDown": "Bajar",
  "label.testCatalog.displayOrder.col.position": "Posición",
  "label.testCatalog.displayOrder.col.test": "Prueba",
  "label.testCatalog.displayOrder.dragHandle": "Arrastre para cambiar el orden",
  "label.testCatalog.terminology.intro": "Asigne a esta prueba los códigos terminológicos estándar para garantizar la interoperabilidad.",
  "vector.collectedVolume.helper": "Número de organismos en este grupo, por ejemplo, el número de mosquitos.",
  "vector.complete.animal": "Animal",
  "vector.complete.cancel": "Cancelar",
  "vector.complete.details.collectionDate": "Fecha de recolección",
  "vector.complete.details.collectionSite": "Punto de recogida",
  "vector.complete.details.collector": "Recolector",
  "vector.complete.details.lifecycleStage": "Etapa del ciclo de vida",
  "vector.complete.details.tests": "Pruebas",
  "vector.complete.details.title": "Detalles de la orden",
  "vector.complete.details.trapType": "Tipo de trampa",
  "vector.complete.labNumber": " Número de laboratorio",
  "vector.complete.newOrder": "Nueva orden de vectores",
  "vector.complete.quantity": "Cantidad",
  "vector.complete.quantity.value": "{count} organismos",
  "vector.complete.status": "Estado",
  "vector.complete.status.processing": "En proceso",
  "vector.lifecycleStage.helper": "Etapa de desarrollo del organismo recolectado.",
  "vector.order.collectionContext.helper": "Opcional: registra las condiciones ecológicas en el momento de la recolección (bionomía).",
  "vector.order.collectionDate.heading": "Fecha de recolección",
  "vector.order.collectionDate.helper": "Fecha en la que se recolectó físicamente el lote en el campo. Se aplica a todas las muestras de esta orden.",
  "vector.order.site.add.new": "+ Agregar nuevo sitio \"{name}\"",
  "vector.order.site.add.new.restricted": "Su administrador ha desactivado la posibilidad de agregar un nuevo sitio de muestreo.",
  "vector.order.site.new.helper": "Se creará como un nuevo punto de muestreo cuando se guarde esta orden.",
  "vector.order.site.new.tag": "Nuevo",
  "vector.order.site.no.match": "No se ha encontrado ningún sitio que coincida.",
  "vector.pool.noTests": "No se han registrado pruebas",
  "vector.pool.summary": "Grupo de {count} {animal}",
  "vector.trapCount.helper": "Número de trampas colocadas — se utiliza junto con el número de noches para calcular la densidad por noche-trampa.",
  "vector.trapNights.helper": "Número de noches en las que las trampas estuvieron activas. Déjelo en blanco si no se registró el esfuerzo.",
  "vector.trapType.helper": "Método o dispositivo de captura utilizado: seleccione primero un tipo de muestra.",
  "vectorDec.actionBar.assigned": "{assigned}/{total} asignados · {pools} grupos",
  "vectorDec.button.back": "Atrás",
  "vectorDec.button.discard": "Descartar",
  "vectorDec.button.previewGrouping": "Vista previa de la agrupación",
  "vectorDec.button.savePools": "Guardar grupos",
  "vectorDec.button.splitIndividuals": "Dividir en individuos →",
  "vectorDec.button.splitIndividuals.tooltip": "Preparación rápida: una muestra por grupo",
  "vectorDec.button.view": "Consultar",
  "vectorDec.col.children": "Muestras hijas",
  "vectorDec.col.positiveTest": "Prueba positiva",
  "vectorDec.col.results": "Resultados",
  "vectorDec.col.status": "Estado",
  "vectorDec.empty": "No hay tareas de deconvolución.",
  "vectorDec.error.initiateFailed": "No se ha podido iniciar la deconvolución.",
  "vectorDec.error.loadWorklist": "No se ha podido cargar la lista de trabajo de deconvolución.",
  "vectorDec.error.minPoolCount": "El número de grupos debe ser, como mínimo, de 2.",
  "vectorDec.error.noAssignedSpecimens": "Arrastre al menos una muestra a un grupo antes de guardar.",
  "vectorDec.error.noParent": "No hay ningún «SampleItem» principal disponible para dividir.",
  "vectorDec.error.poolFloorByType": "El lote tiene {types} tipos de muestra ({names}): se requiere un mínimo de {types} grupos para la distribución aleatoria.",
  "vectorDec.error.unassignedSpecimens": "{count} Las muestras aún no están asignadas. Asigne todas las muestras antes de guardar.",
  "vectorDec.field.howManyPools": "¿Cuántos grupos?",
  "vectorDec.field.notes": "Notas",
  "vectorDec.field.organismsPerPool": "Organismos por muestra",
  "vectorDec.field.poolCount": "Número de piscinas",
  "vectorDec.field.strategy": "Método de asignación",
  "vectorDec.filter.all": "Todos",
  "vectorDec.filter.status": "Filtrar por estado",
  "vectorDec.heading.preview": "Agrupación de grupos propuesta",
  "vectorDec.heading.split": "División en subgrupos",
  "vectorDec.heading.worklist": "Deconvolución de grupos",
  "vectorDec.individualMode.badge": "Modo individual",
  "vectorDec.locationOverride.help": "Sustituya el sitio de recolección heredado para subgrupos individuales. Utilice esta opción cuando un mismo lote se haya recolectado en varios sitios.",
  "vectorDec.locationOverride.inherit": "Heredar desde el lote (por defecto)",
  "vectorDec.locationOverride.notes": "Notas sobre las alícuotas",
  "vectorDec.locationOverride.site": "Sitio de recolección",
  "vectorDec.locationOverride.title": "Ubicación de recolección por subgrupo (opcional)",
  "vectorDec.message.success": "{count} subgrupos creados ({labRange}), {orders} órdenes de prueba en cola. Estado → Deconvolución en progreso.",
  "vectorDec.message.successIndividual": "{count} alícuotas individuales creadas ({labRange}), {orders} órdenes de prueba en cola. Estado → Deconvolución en progreso. La confirmación de esporozoítos VR-07 se activará con los positivos confirmados.",
  "vectorDec.parent.label": "Padre",
  "vectorDec.parent.quantity": "Cantidad: {qty}",
  "vectorDec.preview.body": "{count} grupos utilizando «{strategy}». Arrastre las muestras entre los grupos para realizar los ajustes antes de guardar.",
  "vectorDec.preview.empty": "No hay muestras",
  "vectorDec.preview.organisms": "Organismos",
  "vectorDec.preview.poolN": "Grupo {n}",
  "vectorDec.preview.poolWithSpecies": "Grupo {n}: {species}",
  "vectorDec.preview.specimenCount": "{count, plural, one {# specimen} many {# specimens} other {# especímenes}}",
  "vectorDec.preview.title": "Agrupación propuesta",
  "vectorDec.preview.unassigned": "{count, plural, =0 {Todos los especímenes asignados} one {# no asignado} other {# no asignados}}",
  "vectorDec.preview.unassignedHint": "{count} sin asignar: permanecen en el grupo original.",
  "vectorDec.reflexPreview.copiedTag": "COPIED",
  "vectorDec.reflexPreview.eagerTag": "EAGER",
  "vectorDec.reflexPreview.heading": "↪ Las reglas de reflejo se activarán en las tiradas de salvación",
  "vectorDec.reflexPreview.parentTests": "Órdenes de prueba principales ({test}): volver a ejecutarlas en cada orden secundaria",
  "vectorDec.reflexPreview.screeningPanel": "panel de selección",
  "vectorDec.reflexPreview.tipSplitIndividuals": "Consejo: Divida la muestra en muestras individuales para poder activar también «{rules}»; estas reglas solo se aplican a muestras agrupadas que contengan un único organismo.",
  "vectorDec.results.positive": "({count} +)",
  "vectorDec.setup.distribution": "{specimens} especímenes → ~{perPool} por grupo{remainder, plural, =0 {} other {, resto +1 al primero {remainder}}}",
  "vectorDec.status.complete": "Deconvolución completada",
  "vectorDec.status.confirmed": "Confirmado",
  "vectorDec.status.inProgress": "En progreso",
  "vectorDec.status.pending": "Se requiere revisión",
  "vectorDec.strategy.manual": "Asignar manualmente: arrastre y suelte las muestras en los grupos",
  "vectorDec.strategy.manual.hint": "Arrastre y suelte usted mismo las muestras en los grupos",
  "vectorDec.strategy.manual.title": "Asignar manualmente",
  "vectorDec.strategy.random": "Asignar al azar: distribuir las muestras de manera uniforme entre los grupos",
  "vectorDec.strategy.random.hint": "Distribuya las muestras de manera uniforme entre los grupos",
  "vectorDec.strategy.random.title": "Asignar al azar",
  "vectorDec.strategy.species": "Subgrupo automático por especie: agrupación de muestras afines",
  "vectorDec.strategy.species.hint": "Agrupar las muestras por especie — es necesario que las muestras incluyan la identificación de la especie",
  "vectorDec.strategy.species.title": "Subgrupo automático por especie",
  "vectorDec.totalOrganisms": "Total de organismos",
  "vectorDec.warning.exceedsParent.body": "Se solicitaron {total} organismos en los grupos hijos, pero el grupo padre tiene {parent}. El sistema creará igualmente {total} hijos.",
  "vectorDec.warning.exceedsParent.title": "El total supera la cantidad del elemento principal",
  "vectorId.batch.selectedCount": "{count, plural, one {# specimen selected} many {# specimens selected} other {# especímenes seleccionados}}",
  "vectorId.bloodMeal.add": "Agregar panel a la orden",
  "vectorId.bloodMeal.added": "Se agregó el Panel de identificación de ingesta de sangre a las órdenes de prueba de la muestra.",
  "vectorId.bloodMeal.addedSub": "Procedencia: manual (sugerencia aceptada por el técnico de laboratorio). Según BR-V03-014.",
  "vectorId.bloodMeal.alreadyAttached": "El panel de ingesta de sangre ya está adjunto ({skipped} pruebas).",
  "vectorId.bloodMeal.body": "Solicite el panel de identificación de la sangre ingerida por el mosquito para determinar la especie huésped de la que se alimentó esta muestra.",
  "vectorId.bloodMeal.bulkAdd": "Agregar panel a todos ({count})",
  "vectorId.bloodMeal.bulkAddedSub": "Panel de ingesta de sangre procesado para {count} muestras.",
  "vectorId.bloodMeal.bulkBody": "Agregue el «Panel de identificación de sangre de mosquitos» a cada muestra seleccionada para que el laboratorio pueda identificar de qué vertebrado se alimentaron los mosquitos.",
  "vectorId.bloodMeal.bulkSummary": "Panel de ingesta de sangre: {added} agregadas, {skipped} ya adjuntas, {rejected} rechazadas.",
  "vectorId.bloodMeal.bulkTitle": "Se han detectado hembras alimentadas con sangre ({count} muestras)",
  "vectorId.bloodMeal.dismiss": "Descartar",
  "vectorId.bloodMeal.error.add": "No se ha podido agregar el panel de identificación de la dieta sanguínea de los mosquitos.",
  "vectorId.bloodMeal.error.dismiss": "No se ha podido registrar el descarte.",
  "vectorId.bloodMeal.title": "Se ha detectado una hembra que se ha alimentado de sangre",
  "vectorId.bulk.applyToCount": "Aplicar a {count} muestras",
  "vectorId.bulk.heading": "Aplicar identificadores de especies de forma masiva",
  "vectorId.bulk.notice.body": "Los campos de detalles moleculares (gen diana, ensayo, número de acceso) no se copian de forma global; regístrelos individualmente para cada muestra.",
  "vectorId.bulk.notice.title": "No se han copiado los campos específicos de cada muestra",
  "vectorId.button.bulkApply": "🔖 Aplicación masiva ({count})",
  "vectorId.button.cancel": "Cancelar",
  "vectorId.button.close": "▲ Cerrar",
  "vectorId.button.confirm": "Confirmar",
  "vectorId.button.confirmAll": "✓ Confirme para todos los vectores",
  "vectorId.button.confirmResult": "✓ Confirmar: {test}",
  "vectorId.button.hideResults": "Ocultar resultados",
  "vectorId.button.identify": "▼ Identificar",
  "vectorId.button.reviewResults": "Revisar resultados ({n})",
  "vectorId.button.save": "Guardar datos de identificación",
  "vectorId.button.splitPool": "↗ Dividir",
  "vectorId.col.collectionDate": "Fecha de recolección",
  "vectorId.col.decon": "Decon",
  "vectorId.col.decon.help": "Estado de la deconvolución: si se han introducido los resultados de los grupos y los subgrupos están esperando revisión.",
  "vectorId.col.idStatus": "Estado de la identificación",
  "vectorId.col.lotId": "N.º de lote",
  "vectorId.col.organismGroup": "Grupo",
  "vectorId.col.progress": "Avances",
  "vectorId.col.site": "Sitio de muestreo",
  "vectorId.completion.body": "{positive} de {total} subgrupos confirmados ({pct}%)",
  "vectorId.completion.body.confirmed": "{total} vectores confirmados",
  "vectorId.completion.body.partial": "Se ha confirmado para todos los vectores de este grupo:",
  "vectorId.completion.heading": "Deconvolución completada",
  "vectorId.completion.heading.confirmed": "Resultado confirmado",
  "vectorId.completion.heading.partial": "Resultados parcialmente confirmados",
  "vectorId.completion.tag": "Deconvolución completada",
  "vectorId.completion.tag.confirmed": "Confirmado",
  "vectorId.completion.tag.partial": "Parcialmente confirmado",
  "vectorId.confidence.confirmed": "Confirmado",
  "vectorId.confidence.presumptive": "Presuntivo",
  "vectorId.distribution.confirmed": "{count} confirmados",
  "vectorId.distribution.heading": "Distribución de las especies",
  "vectorId.distribution.notIdentified": "{count} sin identificar",
  "vectorId.distribution.notYet": "Aún no se ha identificado",
  "vectorId.distribution.presumptive": "{count} presuntivos",
  "vectorId.empty": "No hay lotes en esta cola.",
  "vectorId.error.accessionFormat": "Formato de número de acceso de GenBank: 1-2 letras seguidas de 5-8 dígitos (p. ej., MW123456).",
  "vectorId.error.confidenceRequired": "Se requiere el nivel de confianza.",
  "vectorId.error.loadSpecimens": "No se han podido cargar las muestras de este lote.",
  "vectorId.error.loadWorklist": "No se ha podido cargar la lista de tareas.",
  "vectorId.error.methodRequired": "Es necesario un método de identificación.",
  "vectorId.error.notesTooLong": "Las notas deben tener una extensión máxima de 500 caracteres.",
  "vectorId.error.requiredFields": "Es necesario indicar la especie, el método y el nivel de confianza.",
  "vectorId.error.saveFailed": "No se ha podido guardar la identificación.",
  "vectorId.error.speciesRequired": "Es obligatorio indicar la especie.",
  "vectorId.filter.complete": "Completado",
  "vectorId.filter.complete.sub": "Se han identificado todas las muestras.",
  "vectorId.filter.decon": "Deconvolución",
  "vectorId.filter.decon.sub": "Se han introducido los resultados del grupo; se está a la espera de la decisión del técnico sobre si dividirlo o confirmarlo.",
  "vectorId.filter.label": "Estado",
  "vectorId.filter.notstarted": "No se ha iniciado",
  "vectorId.filter.notstarted.sub": "Recibidos: 0 muestras identificadas.",
  "vectorId.filter.partialid": "Identificación parcial",
  "vectorId.filter.partialid.sub": "Identificación en progreso.",
  "vectorId.filter.pending": "Pendiente",
  "vectorId.filter.pending.sub": "Todos los lotes que no están completos, incluidos los grupos de muestras cuyos resultados están esperando revisión por parte de los técnicos.",
  "vectorId.form.assayName": "Nombre del ensayo",
  "vectorId.form.assayName.placeholder": "RT-PCR multiplex",
  "vectorId.form.confidence": "Confianza",
  "vectorId.form.genbankAccession": "N.º de acceso en GenBank",
  "vectorId.form.genbankAccession.placeholder": "MW123456",
  "vectorId.form.lifecycleStage": "Etapa del ciclo de vida",
  "vectorId.form.linkedResult": "Enlace al resultado del análisis de patógenos",
  "vectorId.form.linkedResultPlaceholder": "Seleccione un resultado de este lote…",
  "vectorId.form.method": "Método",
  "vectorId.form.molecularDetails": "🔬 Detalles moleculares",
  "vectorId.form.notes": "Notas",
  "vectorId.form.physState": "Estado fisiológico",
  "vectorId.form.select": "Seleccionar…",
  "vectorId.form.species": "Especies",
  "vectorId.form.speciesPlaceholder": "Buscar un género o una especie…",
  "vectorId.form.targetGene": "Gen diana",
  "vectorId.form.targetGene.placeholder": "COI, ITS2, ADN ribosómico 28S",
  "vectorId.heading.worklist": "Lista de trabajo para la identificación de vectores",
  "vectorId.loading": "Cargando…",
  "vectorId.message.bulkSuccess": "Identificación aplicada a {count} muestras.",
  "vectorId.message.saveSuccess": "Se ha guardado la identificación.",
  "vectorId.method.both": "Morfológico + Molecular",
  "vectorId.method.molecular": "Molecular",
  "vectorId.method.morphological": "Morfológico",
  "vectorId.notif.confirmAll.error": "No se ha podido confirmar el resultado. Por favor, inténtelo de nuevo.",
  "vectorId.notif.confirmAll.success": "Se ha confirmado el resultado para todos los vectores de este grupo.",
  "vectorId.notif.deconNeeded.body": "Se ha introducido un resultado para este grupo. Divídalo en subgrupos para realizar más pruebas o confirme que el resultado es válido para todos los vectores.",
  "vectorId.notif.deconNeeded.bodyWithTest": "Ya se dispone del resultado de una de las pruebas. Divídalo en subgrupos para realizar más pruebas o confirme si el resultado es válido para todos los vectores.",
  "vectorId.notif.deconNeeded.title": "Resultado del grupo esperando revisión",
  "vectorId.physState.blood_fed": "Alimentado de sangre",
  "vectorId.physState.gravid": "Grávida",
  "vectorId.physState.half_gravid": "Semigrávida",
  "vectorId.physState.unfed": "Sin comer",
  "vectorId.physState.unknown": "Desconocido / no evaluado",
  "vectorId.resplit.heading": "Split: {label}",
  "vectorId.search.placeholder": "Buscar lotes…",
  "vectorId.specimen.col.confidence": "Confianza",
  "vectorId.specimen.col.idStatus": "Estado de la identificación",
  "vectorId.specimen.col.label": "Muestra",
  "vectorId.specimen.col.labNo": " Número de laboratorio",
  "vectorId.specimen.col.poolOrSpecimen": "Grupo / Muestra",
  "vectorId.specimen.col.species": "Especies",
  "vectorId.specimen.confirmed": "Confirmado",
  "vectorId.specimen.count": "Muestras",
  "vectorId.specimen.empty": "No hay muestras para este lote.",
  "vectorId.specimen.label": "Muestra n.º{n}",
  "vectorId.specimen.notIdentified": "Sin identificar",
  "vectorId.specimen.presumptive": "Presuntivo",
  "vectorId.status.complete": "Completado",
  "vectorId.status.inProgress": "En progreso",
  "vectorId.status.notStarted": "No se ha iniciado",
  "vectorId.tag.deconComplete": "Completado",
  "vectorId.tag.deconInProgress": "Deconvolución en progreso",
  "vectorId.tag.deconNeeded": "⚠ Revisar resultado",
  "vectorId.tag.subPoolPending": "{count} subgrupo con resultados",
  "vectorId.tree.organisms": "{count, plural, one {# organism} many {# organisms} other {# organismos}}",
  "vectorReport.density.bySite": "Densidad por sitio y período",
  "vectorReport.density.effortNotRecorded": "Esfuerzo no registrado",
  "vectorReport.density.period": "Período",
  "vectorReport.density.perTrapNight": "Densidad (por trampa-noche)",
  "vectorReport.density.pools": "Grupos",
  "vectorReport.density.site": "Sitio",
  "vectorReport.density.specimens": "Muestras",
  "vectorReport.density.title": "Recuento de muestras por sitio",
  "vectorReport.density.trapNights": "Noches-trampa",
  "vectorReport.description": "Índices de vigilancia calculados desde los registros de capturas de vectores, las identificaciones de especies y los resultados relativos a los patógenos",
  "vectorReport.empty": "No hay datos para el ámbito seleccionado.",
  "vectorReport.exportPdf": "Exportar a PDF",
  "vectorReport.fieldMap.description": "Reordene, oculte, renombre o asigne etiquetas de portal a las métricas que se muestran en el «Asistente de introducción manual».",
  "vectorReport.fieldMap.hidden": "Oculto",
  "vectorReport.fieldMap.label": "Etiqueta",
  "vectorReport.fieldMap.metric": "Métrica",
  "vectorReport.fieldMap.order": "Orden",
  "vectorReport.fieldMap.portalTag": "Etiqueta del portal",
  "vectorReport.fieldMap.title": "Mapa de campos de introducción manual",
  "vectorReport.fieldMap.visibility": "Visibilidad",
  "vectorReport.fieldMap.visible": "Visible",
  "vectorReport.fieldMap.visibleLabel": "Visible en el asistente de introducción manual",
  "vectorReport.filter.allSites": "Todos los sitios",
  "vectorReport.filter.apply": "Aplicar",
  "vectorReport.filter.dateRange": "Rango de fechas",
  "vectorReport.filter.from": "Desde",
  "vectorReport.filter.site": "Sitio de muestreo",
  "vectorReport.filter.to": "Hasta",
  "vectorReport.freshness": "Actualidad de los datos",
  "vectorReport.freshness.as": "Datos a fecha de {time}",
  "vectorReport.freshness.unknown": "desconocido",
  "vectorReport.generated": "Generado:",
  "vectorReport.home": "Inicio",
  "vectorReport.loadError": "No se han podido cargar los indicadores de vigilancia. Inténtelo de nuevo.",
  "vectorReport.manualEntry.confirmBody": "¿Desea registrar una instantánea de auditoría de las cifras de esta semana ({periodStart} – {periodEnd})? El reenvío de los datos de una semana se registra como una entrada independiente.",
  "vectorReport.manualEntry.confirmSubmit": "Confirmar",
  "vectorReport.manualEntry.copied": "Copiado en el portapapeles",
  "vectorReport.manualEntry.copy": "Copiar valor",
  "vectorReport.manualEntry.empty": "No hay métricas configuradas para este periodo",
  "vectorReport.manualEntry.loading": "Cargando las cifras de la semana...",
  "vectorReport.manualEntry.lowConfidence": "Confianza reducida (deconvolución de grupos por debajo del 95 %)",
  "vectorReport.manualEntry.markSubmitted": "Marcar semana como enviada",
  "vectorReport.manualEntry.submitError": "No se ha podido registrar el envío",
  "vectorReport.manualEntry.submitted": "Semana enviada",
  "vectorReport.manualEntry.title": "Asistente para la introducción manual de datos",
  "vectorReport.manualEntry.week": "Semana de referencia",
  "vectorReport.mir.classic": "MIR (clásico)",
  "vectorReport.mir.observed": "Tasa de infección (observada)",
  "vectorReport.mir.pathogen": "Patógeno",
  "vectorReport.mir.positivePools": "Grupos con resultados positivos",
  "vectorReport.mir.resolution": "Resolución positiva",
  "vectorReport.mir.species": "Especies",
  "vectorReport.mir.sporozoite": "Tasa de esporozoitos",
  "vectorReport.mir.sporozoiteNote": "El nivel de confianza disminuye cuando la resolución de la deconvolución de grupos es inferior al 95 %.",
  "vectorReport.mir.title": "Tasa mínima de infección por especie",
  "vectorReport.mir.totalSpecimens": "Total de muestras",
  "vectorReport.mir.withheld": "No revelado",
  "vectorReport.positivity.notConfigured": "La clasificación de positividad no está configurada para esta implementación, por lo que no se dispone de las cifras relativas a la tasa de infección, la positividad y los esporozoitos. Configure la relevancia de los resultados en el Catálogo de pruebas para activarlas.",
  "vectorReport.positivity.pathogen": "Patógeno",
  "vectorReport.positivity.pct": "Positividad",
  "vectorReport.positivity.poolsPositive": "Grupos positivos",
  "vectorReport.positivity.poolsTested": "Grupos analizados",
  "vectorReport.positivity.title": "Positividad para patógenos",
  "vectorReport.positivity.unrecognized": "Algunos resultados presentan un valor de significación que no corresponde a ninguna de las clasificaciones reconocidas (POSITIVO, NEGATIVO o INDETERMINADO) y, por ello, se excluyen del recuento de resultados positivos. Consulte el Catálogo de pruebas para que estos resultados puedan incluirse en el recuento.",
  "vectorReport.prompt": "Seleccione un rango de fechas y un sitio; a continuación, haga clic en «Aplicar» para consultar los índices de vigilancia.",
  "vectorReport.qc.detail": "{passed} de {total} análisis superados",
  "vectorReport.qc.passed": "Análisis superados",
  "vectorReport.qc.passRate": "Índice de aprobados",
  "vectorReport.qc.title": "Índice de aprobación del CC",
  "vectorReport.qc.total": "Total de análisis",
  "vectorReport.species.genus": "Género",
  "vectorReport.species.pct": "Proporción",
  "vectorReport.species.species": "Especies",
  "vectorReport.species.specimens": "Muestras",
  "vectorReport.species.title": "Distribución de las especies",
  "vectorReport.sporozoite.title": "Tasa de esporozoitos (Anopheles)",
  "vectorReport.title": "Vigilancia de vectores",
  "vfs.abj": "ABJ (Índice de ausencia de larvas)",
  "vfs.abj.target.below": "✗ La tasa de ABJ está por debajo del objetivo del 95 % fijado por el Ministerio de Salud (Kemenkes)",
  "vfs.abj.target.met": "✓ ABJ cumple el objetivo del 95 % fijado por el Ministerio de Salud (Kemenkes)",
  "vfs.bi": "Índice de Breteau (por cada 100 viviendas)",
  "vfs.ci": "Índice de contenedores (CI)",
  "vfs.containersExamined": "Contenedores examinados",
  "vfs.containersPositive": "Contenedores positivos",
  "vfs.err.containersExceeded": "No se puede superar el número de contenedores inspeccionados.",
  "vfs.err.examinedMin": "Debe ser ≥ 1 cuando se introduzcan datos sobre las larvas.",
  "vfs.err.housesExceeded": "No se puede superar el número de viviendas inspeccionadas.",
  "vfs.err.negative": "No puede ser negativo.",
  "vfs.err.populationMin": "Debe ser ≥ 1 al introducir los datos de la fase pupal.",
  "vfs.hi": "Índice de viviendas (HI)",
  "vfs.housesExamined": "Viviendas inspeccionadas",
  "vfs.housesPositive": "Viviendas positivas",
  "vfs.indices.title": "Índices calculados (vista previa)",
  "vfs.larval.title": "Estudio de larvas — Modo C",
  "vfs.populationAtRisk": "Población en situación de riesgo",
  "vfs.ppi": "Pupas por persona (PPI)",
  "vfs.pupaeCount": "Recuento de pupas",
  "vfs.pupal.title": "Estudio sobre las pupas — Modo D",
  "vfs.surveyMethod": "Método de estudio",
  "vfs.surveyMethod.placeholder": "Elige una opción",
  "warning.testCatalog.noLoinc": "Esta prueba no tiene código LOINC. No es posible importar a ella los resultados del Analizador ni de las Órdenes Electrónicas.",
  "warning.testCatalog.duplicateLoinc": "{testName} también utiliza el código LOINC {code}. Los resultados que se reciben con este código se asignan únicamente a una prueba (la primera coincidencia); es posible que los resultados se envíen a la prueba equivocada.",
  "label.testCatalog.terminology.col.source": "Fuente",
  "label.testCatalog.terminology.col.code": "Código",
  "label.testCatalog.terminology.col.displayName": "Nombre para mostrar",
  "label.testCatalog.terminology.displayName.placeholder": "Por ejemplo, glucosa [masa/volumen] en suero o plasma",
  "label.testCatalog.terminology.col.relationship": "Relación",
  "label.testCatalog.terminology.col.appliesTo": "Se aplica a",
  "label.testCatalog.terminology.appliesTo.test": "Prueba completa",
  "label.testCatalog.terminology.col.actions": "Acciones",
  "label.testCatalog.terminology.source": "Fuente terminológica",
  "label.testCatalog.terminology.code": "Código",
  "label.testCatalog.terminology.relationship": "Relación",
  "label.testCatalog.terminology.addMapping": "Agregar asignación",
  "label.testCatalog.terminology.remove": "Eliminar la asignación",
  "label.testCatalog.terminology.empty": "Aún no hay correspondencias terminológicas.",
  "label.testCatalog.terminology.loadError": "No se han podido cargar las correspondencias terminológicas.",
  "label.testCatalog.terminology.saved": "Se han guardado las correspondencias terminológicas.",
  "error.testCatalog.terminology.duplicate": "El código «{source}» {code} ya existe para esta prueba.",
  "error.testCatalog.terminology.invalid": "No se han podido guardar las asignaciones: compruebe si hay algún código duplicado, una fuente desconocida o una relación no válida.",
  "error.testCatalog.terminology.tooLong": "A code holds at most 80 characters and a display name 255.",
  "label.testCatalog.terminology.rel.none": "— Ninguno —",
  "label.testCatalog.terminology.rel.SAME_AS": "Lo mismo que",
  "label.testCatalog.terminology.rel.BROADER_THAN": "Más amplio que",
  "label.testCatalog.terminology.rel.NARROWER_THAN": "Más estrecho que",
  "label.testCatalog.panels.intro": "Administrar a qué paneles pertenece esta prueba y su posición dentro de cada uno de ellos.",
  "label.testCatalog.panels.addToPanel": "Agregar al panel",
  "label.testCatalog.panels.col.panel": "Panel",
  "label.testCatalog.panels.col.position": "Posición",
  "label.testCatalog.panels.col.actions": "Acciones",
  "label.testCatalog.panels.position": "Posición",
  "label.testCatalog.panels.remove": "Eliminar del panel",
  "label.testCatalog.panels.remove.confirm.heading": "¿Desea eliminar la prueba del panel?",
  "label.testCatalog.panels.remove.confirm.body": "Esta prueba se eliminará de {panel}. Seguirá apareciendo en el catálogo y en cualquier otro panel. Podrá volver a agregarla más adelante.",
  "label.testCatalog.panels.moveUp": "Mover más arriba",
  "label.testCatalog.panels.moveDown": "Mover más abajo",
  "label.testCatalog.panels.viewOrder": "Ver el orden de las pruebas de este panel",
  "label.testCatalog.panels.orderContext": "Pruebas incluidas en este panel (por orden):",
  "label.testCatalog.panels.empty": "Esta prueba aún no forma parte de ningún panel.",
  "label.testCatalog.panels.loadError": "No se han podido cargar las afiliaciones a los paneles.",
  "label.testCatalog.panels.saved": "Se han guardado las afiliaciones a los paneles.",
  "label.testCatalog.panels.createPanel": "Crear Nuevo Panel",
  "label.testCatalog.panels.createPanelHint": "Introduzca un nombre para crear un panel y agregue esta prueba al mismo. El tipo de muestra, los módulos de ordenación y otros ajustes se configurarán más adelante en el Editor de paneles.",
  "notification.testCatalog.panels.created": "Se ha creado el panel «{name}» y se ha agregado esta prueba. Configúrelo con más detalle en el Editor de paneles.",
  "label.search": "Buscar",
  "label.testCatalog.list": "Catálogo de pruebas",
  "label.testCatalog.list.search": "Buscar por nombre de la prueba",
  "label.testCatalog.list.col.status": "Estado",
  "label.testCatalog.list.filter.allDomains": "Todos los dominios",
  "label.testCatalog.list.filter.allStatus": "Todos los estados",
  "label.testCatalog.list.filter.inactive": "Inactivo",
  "label.testCatalog.list.coverageIncomplete": "Cobertura incompleta",
  "label.testCatalog.list.filter.amr": "AMR",
  "label.testCatalog.list.filter.anyAmr": " Cualquiera",
  "label.testCatalog.list.filter.amrOnly": "Solo AMR",
  "label.testCatalog.list.filter.nonAmr": "No AMR",
  "label.testCatalog.list.filter.sampleType": " Tipo de muestra",
  "label.testCatalog.list.filter.allSampleTypes": "Todos los tipos de muestras",
  "label.testCatalog.list.filter.allLabUnits": "All lab units",
  "label.testCatalog.list.amrTag": "AMR",
  "label.testCatalog.list.noLoinc": "Sin LOINC",
  "label.testCatalog.list.filter.issuesOnly": "Solo pruebas con problemas",
  "label.testCatalog.list.health.banner": "{count} pruebas presentan problemas de configuración ({errors} errores · {warnings} advertencias)",
  "label.testCatalog.list.health.show": "Mostrar",
  "label.testCatalog.activation.incomplete.heading": "La prueba aún no se puede activar",
  "label.testCatalog.activation.incomplete.body": "Resuelva los siguientes antes de que se pueda activar esta prueba:",
  "label.testCatalog.list.col.sampleType": " Tipo de muestra",
  "button.testCatalog.newTest": "Nueva prueba",
  "button.testCatalog.editRelated": "Editar conjuntamente las pruebas relacionadas",
  "button.testCatalog.editRelatedFromEditor": "Editar pruebas relacionadas…",
  "label.testCatalog.editor.noRelated": "No hay ninguna prueba relacionada que comparta el nombre de esta prueba.",
  "label.testCatalog.editor.createSaveFirst.title": "Guarde primero la prueba",
  "label.testCatalog.editor.createSaveFirst": "Rellene la información básica y guarde los datos. Esta sección estará disponible una vez creada la prueba.",
  "label.testCatalog.editingNTests": "Editando {count} pruebas",
  "label.testCatalog.perTestIdentity": "Datos de identificación y LOINC (por prueba)",
  "state.testCatalog.differsAcrossTests": "Varía según las pruebas",
  "button.testCatalog.setAllTo": "Establecer todos en estos valores",
  "label.testCatalog.group.rangesSaved": "Rangos de referencia guardados en {count} pruebas.",
  "label.testCatalog.group.storageIntro": "Edite el almacenamiento y la manipulación una sola vez; al guardar, los campos que modifique se aplicarán a todas las pruebas seleccionadas y los demás campos se mantendrán como están en cada prueba.",
  "label.testCatalog.group.storageDiffer": "These fields are not the same on every selected test: {fields}. The form shows the first test's values; a field you leave unchanged keeps each test's own value.",
  "button.testCatalog.removeFromSet": "Eliminar de este conjunto",
  "label.testCatalog.group.rangesIntro": "Edite los rangos de referencia una sola vez; al guardar, se aplicarán a todas las pruebas seleccionadas. La identificación y el código LOINC se mantienen para cada prueba.",
  "label.testCatalog.group.rangesDiffer": "Los rangos actuales de las pruebas seleccionadas no son idénticos. Al guardar, se establecerán todos en los valores que se indican a continuación.",
  "label.testCatalog.group.rangesLoadError": "The current ranges of {tests} could not be loaded, so nothing can be applied yet. Retry to load them again.",
  "label.testCatalog.ranges.table.sex": "Se aplica a",
  "label.testCatalog.ranges.table.age": " Rango de edad",
  "label.testCatalog.ranges.table.normal": "Normal (bajo / alto)",
  "label.testCatalog.list.filters": "Filtros",
  "label.testCatalog.list.filters.count": "Filtros ({count})",
  "label.testCatalog.list.error": "No se ha podido cargar el catálogo de pruebas. Ajuste los filtros o recargue la página para intentarlo de nuevo.",
  "label.testCatalog.list.empty": "No hay pruebas que se ajusten a los filtros actuales.",
  "sidenav.label.admin.testmgt.ManageMethod": "Gestionar método",
  "sidenav.label.admin.testmgt.reflex": "Gestión de pruebas de reflejo",
  "sidenav.label.admin.usermgt": "Gestión de usuarios",
  "sideNav.label.arvfollowup1": "Seguimiento ARV Versión 1",
  "sideNav.label.arvfollowup2": "Seguimiento ARV Versión 2",
  "sideNav.label.arvreports1": "ARV Inicial Versión 1",
  "sideNav.label.arvreports2": "ARV Inicial Versión 2",
  "sideNav.label.arvversion1": "ARV-Versión 1",
  "sideNav.label.associatedpatientreport": "Informe de pacientes asociados",
  "sideNav.label.audittrail": "Auditoría",
  "sidenav.label.barcode": " Código de barras",
  "sidenav.label.batchorder": " Ingreso por lotes",
  "sideNav.label.bypaneltype": "Por tipo de panel",
  "sideNav.label.bytesttype": "Por tipo de prueba",
  "sideNav.label.byunit": "Por unidad",
  "sideNav.label.collectedarvpatientreports": "Informe de pacientes ARV recolectados",
  "sidenav.label.cytology": "Citología",
  "sidenav.label.cytology.dashboard": "Panel",
  "sideNav.label.delayedvalidation": "Validación retrasada",
  "sidenav.label.editorder": " Editar orden",
  "sideNav.label.eidreports1": "EID Versión 1",
  "sideNav.label.eidreports2": "EID Versión 2",
  "sideNav.label.exportcsvfile": "Exportar archivo CSV rutinario",
  "sideNav.label.followuprequired": "Seguimiento requerido",
  "sideNav.label.generalreport": "Informe general",
  "sideNav.label.hivtestsummary": "Resumen de pruebas de VIH",
  "sidenav.label.immunochem": "Inmunohistoquímica",
  "sidenav.label.immunochem.dashboard": "Panel",
  "sidenav.label.incomingorder": "Órdenes Electrónicas",
  "sideNav.label.intermediatebyservice": "Intermedio por servicio",
  "sideNav.label.intermediatereport1": "Intermedio Versión 1",
  "sideNav.label.intermediatereport2": "Intermedio Versión 2",
  "sidenav.label.inventory": "Inventario",
  "sidenav.label.inventory.management": "Gestión de existencias",
  "sidenav.label.inventory.management.tooltip": "Gestionar los elementos de inventario, los lotes y los niveles de existencias",
  "sidenav.label.inventory.tooltip": "Gestión de existencias de reactivos, kits y material de consumo",
  "sideNav.label.laporanHasil": "Informe de cumplimiento",
  "sideNav.label.noncomformitynotification": "Notificación de no conformidad",
  "sideNav.label.noncomformityreportsbydate": "Por fecha",
  "sideNav.label.noncomformityreportsbylabno": "Por número de laboratorio",
  "sideNav.label.noncomformityreportsbyunit": "Por unidad y razón",
  "sidenav.label.notebook": "Cuaderno",
  "sidenav.label.add.order": " Agregar orden",
  "sidenav.label.clinical.order": "Agregar orden clínica",
  "sidenav.label.environmental.compliance": "Panel de cumplimiento normativo",
  "sidenav.label.environmental.order": "Agregar orden ambiental",
  "sidenav.label.vector.order": "Agregar orden de vectores",
  "sidenav.label.order": "Orden",
  "sidenav.label.order.collect": "Recolectar muestra",
  "sidenav.label.order.dashboard": "Panel",
  "sidenav.label.order.enter": " Ingresar orden",
  "sidenav.label.order.label": "Etiquetar y almacenar",
  "sidenav.label.order.qa": "Revisión de aseguramiento de la calidad",
  "sidenav.label.order.prepare": "Prepare Samples",
  "sidenav.label.order.sampleCheck": "Sample check",
  "sidenav.label.pathology": "Patología",
  "sidenav.label.pathology.dashboard": "Panel",
  "sideNav.label.referredtestreport": "Informe de pruebas referidas",
  "sideNav.label.rejectionreport": "Informe de rechazo",
  "sidenav.label.reports": "Informes",
  "sidenav.label.reports.routine": "Rutina",
  "sidenav.label.reports.study": "Estudio",
  "sidenav.label.results": "Resultados",
  "sidenav.label.results.byrange": "Por rango de números de laboratorio",
  "sidenav.label.results.order": "Por orden",
  "sidenav.label.results.patient": "Por paciente",
  "sidenav.label.results.testdate": "Por fecha de prueba",
  "sidenav.label.results.unit": "Por unidad",
  "sideNav.label.sectionperformance": "Rendimiento de la sección",
  "sideNav.label.specialrequest": "Solicitud especial",
  "sidenav.label.statisticsreport": "Informe de estadísticas",
  "sidenav.label.statusreport": "Informe de estado del paciente",
  "sidenav.label.storage.coldstorage": "Supervisión de las cámaras frigoríficas",
  "sidenav.label.storage.coldstorage.tooltip": "Supervise la temperatura y la humedad de los congeladores y frigoríficos",
  "sidenav.label.storage.management": "Gestión del almacenamiento",
  "sidenav.label.storage.management.tooltip": "Gestionar ubicaciones y dispositivos de almacenamiento",
  "sidenav.label.testsummary": "Resumen de todas las pruebas",
  "sidenav.label.validation": "Validación",
  "sidenav.label.validation.order": "Buscar por orden",
  "sidenav.label.validation.routine": "Rutina",
  "sidenav.label.validation.study": "Estudio",
  "sidenav.label.validation.testdate": "Buscar por fecha de prueba",
  "sideNav.label.viralloaddataexport": "Exportación de datos de carga viral",
  "sideNav.label.vlversionnational": "VL versión nacional",
  "sidenav.label.workplan": "Plan de trabajo",
  "sidenav.label.workplan.panel": "Por tipo de panel",
  "sidenav.label.workplan.priority": "Por prioridad",
  "sidenav.label.workplan.test": "Por tipo de prueba",
  "sidenav.label.workplan.unit": " Por unidad",
  "sideNav.title.activityreport": "Informe de actividad",
  "sidenav.title.aggregatereport": "Informes agregados",
  "sideNav.title.arvreports": "Informes ARV",
  "sideNav.title.associatedpatientreport": "Informe de pacientes asociados",
  "sideNav.title.audittrail": "Auditoría",
  "sideNav.title.collectedarvpatientreports": "Informe de pacientes ARV recolectados",
  "sideNav.title.delayedvalidation": "Validación retrasada",
  "sideNav.title.eidreports": "Informes EID",
  "sideNav.title.environmentalReports": "Informes medioambientales",
  "sideNav.title.exportbydate": "Exportar por fecha",
  "sideNav.title.exportcsvfile": "Exportar archivo CSV rutinario",
  "sideNav.title.indicator": "Indicador",
  "sideNav.title.intermediatereport": "Informe intermedio",
  "sideNav.title.noncomformityreports": "Informes de no conformidad",
  "sideNav.title.referredtestreport": "Informe de pruebas referidas",
  "sideNav.title.rejectionreport": "Informe de rechazo",
  "sideNav.title.specialrequest": "Solicitud especial",
  "sideNav.title.tatreport": "Tiempo de respuesta",
  "sideNav.title.vectorIdentification": "Identificación de vectores",
  "sideNav.title.vlreport": "Informe VL",
  "sideNav.label.audittrail.orderEvents": "Eventos de órdenes",
  "sideNav.label.audittrail.systemEvents": "Eventos del sistema",
  "sidenav.label.addorder": " Agregar orden",
  "sidenav.label.admin.sampleTypeManagement": "Editor de tipos de muestra",
  "sideNav.label.qa": "Quality Assurance",
  "sideNav.label.qa.overview": "QA Overview",
  "sideNav.label.qa.qc": "Statistical QC",
  "sideNav.label.qa.qc.dashboard": "Panel de CC",
  "sideNav.label.qa.qc.alerts": "Alertas de CC",
  "sideNav.label.qa.qc.controlLots": "QC Lot Management",
  "sideNav.label.qa.qc.ruleConfig": "Configuración de reglas",
  "sideNav.label.qa.qc.reagentQc": "Reagent QC",
  "sideNav.label.qa.qc.manualQc": "Analyzer Manual QC",
  "sideNav.label.qa.qi": "Quality Indicators",
  "sideNav.label.qa.qi.dashboard": "QI Dashboard",
  "sideNav.label.qa.qi.config": "QI Configuration",
  "qa.qiConfig.subtitle": "Set per-indicator target and action thresholds, enable or disable indicators, and override thresholds for specific test sections.",
  "qa.qiConfig.column.overrides": "Overrides",
  "qa.qiConfig.field.enabled": "Track this indicator",
  "qa.qiConfig.field.target": "Target",
  "qa.qiConfig.field.action": "Action threshold",
  "qa.qiConfig.field.category": "Test section",
  "qa.qiConfig.editor.title": "Editar {indicator}",
  "qa.qiConfig.editor.defaults": "Default thresholds",
  "qa.qiConfig.editor.overrides": "Per-section overrides",
  "qa.qiConfig.editor.usesDefault": "Test sections without an override use the indicator default.",
  "qa.qiConfig.editor.noOverrides": "No overrides — every test section uses the default.",
  "qa.qiConfig.editor.addOverride": "Add section override",
  "qa.qiConfig.editor.autoNce": "When the month-to-date value breaches the action threshold, a non-conforming event is created automatically (one per indicator per month).",
  "qa.qiConfig.indicator.tat": "Average Turnaround Time",
  "qa.qiConfig.indicator.rejection": "Rejection Rate",
  "qa.qiConfig.indicator.amendment": "Amendment Rate",
  "qa.qiConfig.indicator.nce": "NCE Pulse",
  "qa.qiConfig.indicator.callback": "Critical Callback Compliance",
  "qa.qiConfig.validation.required": "Both target and action thresholds are required.",
  "qa.qiConfig.validation.range": "Thresholds must be between 0 and 100.",
  "qa.qiConfig.validation.direction": "Target and action threshold are in the wrong order for this indicator.",
  "qa.qiConfig.validation.category": "Choose a test section for each override.",
  "qa.qiConfig.validation.duplicateCategory": "A test section can only be overridden once.",
  "qa.qiConfig.confirmDisableTitle": "Disable this indicator?",
  "qa.qiConfig.confirmDisableBody": "This will hide the dashboard tile, suppress new alerts, and stop auto-generated NCEs for this indicator. Historical data is preserved. Continue?",
  "qa.qiConfig.saveFailed": "Could not save QI configuration.",
  "sideNav.label.qa.qms": "QMS & Improvement",
  "sideNav.label.qa.qms.esigLog": "Electronic Signature Log",
  "sideNav.label.qa.qms.capaRegister": "CAPA Register",
  "sideNav.label.qa.qms.accreditation": "Accreditation",
  "qa.qms.capaRegister.subtitle": "Every corrective and preventive action across all non-conforming events, with due dates and status.",
  "qa.qms.capaRegister.tile.dueThisWeek": "Due This Week",
  "qa.qms.capaRegister.tile.completed": "Completed (90d)",
  "qa.qms.capaRegister.filter.assignee": "Assignee",
  "qa.qms.capaRegister.filter.from": "Due Date (From)",
  "qa.qms.capaRegister.filter.to": "Due Date (To)",
  "qa.qms.capaRegister.column.correctiveAction": "Corrective / Preventive Action",
  "qa.qms.capaRegister.column.assignee": "Person Responsible",
  "qa.qms.capaRegister.status.open": "Abierto",
  "qa.qms.capaRegister.status.overdue": "Atrasado",
  "qa.qms.capaRegister.status.completed": "Completado",
  "qa.qms.capaRegister.error": "The CAPA register could not be loaded.",
  "qa.qms.accreditation.title": "Test Accreditation",
  "qa.qms.accreditation.subtitle": "Accrediting bodies and per-test enrollment. Drives the accreditation logos on patient reports and the inspector-readiness answer.",
  "qa.qms.accreditation.error": "Accreditation data could not be loaded.",
  "qa.qms.accreditation.actionError": "The change could not be saved.",
  "qa.qms.accreditation.tile.total": "Bodies",
  "qa.qms.accreditation.inForce": "In force: {names}",
  "qa.qms.accreditation.bodies.title": "Accrediting Bodies",
  "qa.qms.accreditation.bodies.add": "Add body",
  "qa.qms.accreditation.body.column.logo": "Logo",
  "qa.qms.accreditation.body.column.expiresOn": "Expires",
  "qa.qms.accreditation.status.ACTIVE": "Activo",
  "qa.qms.accreditation.status.EXPIRING": "Expiring soon",
  "qa.qms.accreditation.status.EXPIRED": "Caducado",
  "qa.qms.accreditation.status.INACTIVE": "Inactivo",
  "qa.qms.accreditation.body.modal.addTitle": "Add Accrediting Body",
  "qa.qms.accreditation.body.modal.editTitle": "Edit Accrediting Body",
  "qa.qms.accreditation.body.edit": "Edit body",
  "qa.qms.accreditation.body.delete": "Delete body",
  "qa.qms.accreditation.body.field.codeHelper": "2–16 characters: capitals, digits and hyphens. Cannot be changed later.",
  "qa.qms.accreditation.body.field.expiresOn": "Accreditation expires",
  "qa.qms.accreditation.body.field.visibilityMode": "Show the logo on a report when",
  "qa.qms.accreditation.visibility.ANY_ACCREDITED_TEST": "Any accredited test is on the report",
  "qa.qms.accreditation.visibility.PERCENTAGE": "A percentage of the report's tests are accredited",
  "qa.qms.accreditation.body.field.thresholdPct": "Threshold (%)",
  "qa.qms.accreditation.body.field.logo": "Logo (PNG or JPEG, at least 64×64 pixels, up to 500 KB)",
  "qa.qms.accreditation.body.logo.remove": "Remove logo",
  "qa.qms.accreditation.body.required": "Code, name and expiry date are required.",
  "qa.qms.accreditation.body.saveError": "The accrediting body could not be saved.",
  "qa.qms.accreditation.body.logoError": "The logo could not be uploaded. Use a PNG or JPEG of at least 64×64 pixels and no more than 500 KB.",
  "qa.qms.accreditation.body.delete.title": "Delete Accrediting Body",
  "qa.qms.accreditation.body.delete.body": "Delete {name}? This cannot be undone.",
  "qa.qms.accreditation.body.delete.blocked": "Cannot delete — {count} test accreditations reference this body. Remove them first.",
  "qa.qms.accreditation.enrollments.title": "Enrolled Tests",
  "qa.qms.accreditation.enrollments.add": "Enroll tests",
  "qa.qms.accreditation.enrollment.column.body": "Accrediting Body",
  "qa.qms.accreditation.enrollment.column.effectiveFrom": "Effective From",
  "qa.qms.accreditation.enrollment.column.expires": "Body Expires",
  "qa.qms.accreditation.enrollment.remove": "Remove enrollment",
  "qa.qms.accreditation.eqa.title": "EQA Coverage of Accredited Scope",
  "qa.qms.accreditation.eqa.subtitle": "ISO 15189 §7.7 asks whether every test you claim as accredited takes part in external quality assessment. This compares accredited scope against active EQA enrollments.",
  "qa.qms.accreditation.eqa.column.scope": "Tests in Scope",
  "qa.qms.accreditation.eqa.column.covered": "Covered by EQA",
  "qa.qms.accreditation.eqa.column.gaps": "Gaps",
  "qa.qms.accreditation.eqa.noGaps": "Full coverage",
  "qa.qms.accreditation.eqa.gapsMore": "{names} and {count} more",
  "qa.qms.accreditation.eqa.error": "EQA coverage could not be loaded.",
  "qa.qms.accreditation.filter.body": "Accrediting body",
  "qa.qms.accreditation.filter.test": "Test: {name}",
  "qa.qms.accreditation.enroll.modal.title": "Enroll Tests",
  "qa.qms.accreditation.enroll.field.effectiveFrom": "Effective from (optional)",
  "qa.qms.accreditation.enroll.required": "Select an accrediting body and at least one test.",
  "qa.qms.accreditation.enroll.failed": "The enrollment was rejected.",
  "qa.qms.accreditation.enrollment.delete.title": "Remove Enrollment",
  "qa.qms.accreditation.enrollment.delete.body": "Remove {test} from {body}?",
  "qa.qms.esigLog.subtitle": "Every electronic signature recorded in the system — who signed what, when, and why.",
  "qa.qms.esigLog.column.signer": "Signer",
  "qa.qms.esigLog.column.subject": "Asunto",
  "qa.qms.esigLog.filter.subjectType": "Subject Type",
  "qa.qms.esigLog.filter.apply": "Apply Filters",
  "qa.qms.esigLog.export.confirm.title": "Export without filters?",
  "qa.qms.esigLog.export.confirm.body": "No filters are applied, so this exports every signature in the selected date range (up to 10,000 rows).",
  "qa.qms.esigLog.meaning.AUTHORED": "Elaborado",
  "qa.qms.esigLog.meaning.VALIDATED_AND_RELEASED": "Validated & Released",
  "qa.qms.esigLog.meaning.REJECTED": "Rechazado",
  "qa.qms.esigLog.error": "Unable to load the signature log. Please try again.",
  "qa.qi.dashboard.subtitle": "Five quality indicators including the optional Critical Callback Compliance opt-in.",
  "qa.qi.dashboard.window.label": "Reporting window",
  "qa.qi.dashboard.window.7d": "Rolling 7 days",
  "qa.qi.dashboard.window.30d": "Rolling 30 days",
  "qa.qi.dashboard.window.90d": "Rolling 90 days",
  "qa.qi.dashboard.window.ytd": "Year to date",
  "qa.qi.dashboard.lastRecomputed": "Last recomputed: {time}",
  "qa.qi.dashboard.viewDetail": "View detail",
  "qa.qi.dashboard.tileInfo": "What does this tile measure?",
  "qa.qi.disabled.toast.title": "Indicator disabled",
  "qa.qi.disabled.toast.message": "This quality indicator is disabled in QI Configuration; its detail page is unavailable.",
  "qa.qi.dashboard.tile.tat.label": "Average TAT",
  "qa.qi.dashboard.tile.tat.tooltip": "Average turnaround time from sample receipt to result validation, across all completed test orders in the reporting window.",
  "qa.qi.dashboard.tile.tat.vsPriorDays": "vs prior {days} days",
  "qa.qi.dashboard.tile.tat.vsPriorPeriod": "vs prior period",
  "qa.qi.dashboard.tile.tat.secondary": "Across {count, plural, one {# lab unit} other {# lab units}} · Slowest: {unit} ({tat})",
  "qa.qi.dashboard.tile.tat.empty": "No completed test orders in this window.",
  "qa.qi.dashboard.tile.tat.error": "Turnaround data is unavailable.",
  "qa.qi.dashboard.tile.rejection.label": "Rejection Rate",
  "qa.qi.dashboard.tile.amendment.label": "Amendment Rate",
  "qa.qi.dashboard.tile.ncePulse.label": "NCE Pulse",
  "qa.qi.dashboard.tile.ncePulse.tooltip": "Critical non-conforming events not yet acknowledged, as of now. A current count, not a trend.",
  "qa.qi.dashboard.tile.ncePulse.criticalPending": "critical pending",
  "qa.qi.dashboard.tile.ncePulse.inCorrectiveAction": "{count} in corrective action",
  "qa.qi.dashboard.tile.ncePulse.error": "NCE data is unavailable.",
  "qa.qi.dashboard.tile.amendment.tooltip": "Results corrected after their patient report went out, as a share of results released in the reporting window.",
  "qa.qi.dashboard.tile.amendment.vsPriorDays": "vs prior {days} days",
  "qa.qi.dashboard.tile.amendment.vsPriorPeriod": "vs prior period",
  "qa.qi.dashboard.tile.amendment.secondary": "{amended} amended of {released} released",
  "qa.qi.dashboard.tile.amendment.empty": "No results released in this window.",
  "qa.qi.dashboard.tile.amendment.error": "Amendment data is unavailable.",
  "qa.qi.dashboard.tile.rejection.tooltip": "Tests rejected at results entry or validation, as a share of tests started in the reporting window.",
  "qa.qi.dashboard.tile.rejection.vsPriorDays": "vs prior {days} days",
  "qa.qi.dashboard.tile.rejection.vsPriorPeriod": "vs prior period",
  "qa.qi.dashboard.tile.rejection.secondary": "{rejected} rejected of {total} started",
  "qa.qi.dashboard.tile.rejection.empty": "No tests started in this window.",
  "qa.qi.dashboard.tile.rejection.error": "Rejection data is unavailable.",
  "qa.qi.dashboard.tile.thresholds": "Target {target} · action {action}",
  "qa.qi.amendment.title": "Amendment Rate — Detail",
  "qa.qi.amendment.subtitle": "Results corrected after their patient report went out.",
  "qa.qi.amendment.column.amendedAt": "Amended at",
  "qa.qi.amendment.column.priorValue": "Prior value",
  "qa.qi.amendment.column.currentValue": "Current value",
  "qa.qi.amendment.column.amendedBy": "Amended by",
  "qa.qi.amendment.column.releasedAt": "Released at",
  "qa.qi.amendment.column.timeToAmend": "Time to amend",
  "qa.qi.amendment.rate.label": "Amendment rate",
  "qa.qi.amendment.trend.empty": "No trend data in this window.",
  "qa.qi.amendment.breakdown.title": "By test",
  "qa.qi.amendment.breakdown.column.rate": "Rate",
  "qa.qi.rejection.title": "Rejection Rate — Detail",
  "qa.qi.rejection.subtitle": "Tests rejected at results entry, with the recorded rejection reason.",
  "qa.qi.rejection.column.rejectedAt": "Rejected at",
  "qa.qi.rejection.column.rejectedBy": "Rejected by",
  "qa.qi.rejection.heatmap.title": "Heatmap: ordering location × test section",
  "qa.qi.rejection.heatmap.section": "Test section",
  "qa.qi.rejection.heatmap.unknown": "Unknown location",
  "qa.qi.rejection.heatmap.unknownSection": "Unknown section",
  "qa.qi.rejection.heatmap.legend": "Cells colored by rate against the lab's thresholds: green ≤ {target}%, amber in between, red ≥ {action}%. Hover a cell for rejected / started counts.",
  "qa.qi.rejection.rate.label": "Rejection rate",
  "qa.qi.rejection.reasons.title": "By reason (Pareto)",
  "qa.qi.rejection.reasons.column.percent": "% of rejections",
  "qa.qi.rejection.reasons.column.cumulative": "Cumulative %",
  "qa.qi.rejection.reasons.donut.label": "Rejections",
  "qa.qi.rejection.reasons.insight": "Top {count} of {total} reasons account for {percent}% of rejections — addressing {reason} first has the biggest impact.",
  "qa.qi.rejection.breakdown.other": "Other ({count} tests)",
  "qa.qi.rejection.list.title": "Individual rejections",
  "qa.qi.amendment.list.title": "Individual amendments",
  "qa.qi.callback.button": "Log callback",
  "qa.qi.callback.banner.title": "Critical results need a clinician callback",
  "qa.qi.callback.banner.subtitle": "{count, plural, one {# saved critical result on this page has no callback logged — read-back required (TJC NPSG.02.03.01).} other {# saved critical results on this page have no callback logged — read-back required (TJC NPSG.02.03.01).}}",
  "qa.qi.callback.modal.title": "Log critical callback",
  "qa.qi.callback.field.recipientName": "Person notified",
  "qa.qi.callback.field.recipientName.placeholder": "Name of clinician or ward contacted",
  "qa.qi.callback.field.status": "Callback outcome",
  "qa.qi.callback.status.CONFIRMED": "Confirmed with read-back",
  "qa.qi.callback.status.REACHED_NO_READBACK": "Reached, no read-back",
  "qa.qi.callback.status.UNABLE_TO_REACH": "Unable to reach",
  "qa.qi.callback.save.success": "Callback logged",
  "qa.qi.callback.save.fail": "Failed to log callback",
  "qa.qi.callback.title": "Critical Callback Compliance — Detail",
  "qa.qi.callback.subtitle": "Released critical results and whether each was phoned to a clinician with read-back inside the callback target window.",
  "qa.qi.callback.distribution.title": "Time-to-acknowledge distribution",
  "qa.qi.callback.distribution.0-5": "0–5 min",
  "qa.qi.callback.distribution.5-15": "5–15 min",
  "qa.qi.callback.distribution.15-30": "15–30 min",
  "qa.qi.callback.distribution.30-60": "30–60 min",
  "qa.qi.callback.distribution.over60": "60+ min",
  "qa.qi.callback.distribution.noAck": "No ack",
  "qa.qi.callback.failures.title": "Failures ({count}) by reason",
  "qa.qi.callback.failures.overTarget": "Over target",
  "qa.qi.callback.failures.unableToReach": "Unable to reach",
  "qa.qi.callback.failures.noReadback": "No read-back recorded",
  "qa.qi.callback.failures.noCallback": "No callback recorded",
  "qa.qi.callback.list.title": "Critical results in window",
  "qa.qi.callback.rate.label": "Callback compliance (read-back within {minutes} min)",
  "qa.qi.callback.status.notLogged": "Not logged",
  "qa.qi.callback.column.status": "Callback status",
  "qa.qi.callback.column.timeToCallback": "Time to callback",
  "qa.qi.callback.column.loggedBy": "Logged by",
  "qa.qi.dashboard.tile.callback.label": "Critical Callback Compliance",
  "qa.qi.dashboard.tile.callback.tooltip": "Released critical results with a confirmed read-back callback within the lab's callback target window. Opt-in — enable in QI Configuration. Compliance is recomputed from current critical ranges.",
  "qa.qi.dashboard.tile.callback.secondary": "{confirmed} of {critical} critical results acknowledged within target",
  "qa.qi.dashboard.tile.callback.vsPriorDays": "vs prior {days} days",
  "qa.qi.dashboard.tile.callback.vsPriorPeriod": "vs prior period",
  "qa.qi.dashboard.tile.callback.empty": "No critical results in this window.",
  "qa.qi.dashboard.tile.callback.error": "Callback data is unavailable.",
  "qa.qi.dashboard.tile.callback.disabled": "Not enabled — turn on in QI Configuration.",
  "qa.empty.callback.title": "No critical results in this window",
  "qa.empty.callback.subhead": "Released critical results appear here with their callback documentation status.",
  "qa.overview.rejection.caption": "rejected at results entry (30d)",
  "qa.overview.rejection.ofStarted": "{rejected} of {total} started",
  "qa.overview.callback.caption": "critical read-back compliance (30d)",
  "qa.overview.callback.ofCritical": "{confirmed} of {critical} confirmed",
  "qa.overview.callback.none": "no critical results in window",
  "qa.overview.week.confirmedCount": "{count} confirmed",
  "qa.overview.amendment.caption": "amended after report (30d)",
  "qa.overview.amendment.ofReleased": "{amended} of {released} released",
  "qa.future.subtitle": "Future feature — design exists; build not yet scheduled.",
  "qa.future.questionLabel": "The question this feature answers",
  "qa.future.whyLabel": "Why it matters",
  "qa.future.readDesignDoc": "Read design doc on GitHub",
  "qa.future.reagentQc.question": "Has this reagent lot been verified before we use it on patients?",
  "qa.future.reagentQc.summary": "Per-lot QC frequency tracking. Before a new reagent lot is used clinically, the system requires documented verification samples comparing the new lot against the old lot or a peer-comparison reference.",
  "qa.future.reagentQc.why": "Without lot verification, a bad reagent lot can ruin a week of patient results before anyone notices. Most labs do this informally today; shipping it as a system feature catches the cases where the informal process fails.",
  "qa.future.manualQc.question": "Did the technician run a daily control on this instrument today, and did it pass?",
  "qa.future.manualQc.summary": "Daily PASS/FAIL log per instrument. Different instruments have different daily checks; the system holds them all to one shape: a daily PASS/FAIL log with a signer, a timestamp, and a block on instrument use if FAIL.",
  "qa.future.manualQc.why": "The first thing an inspector asks when they walk into a lab is 'show me your daily QC log for this instrument.' A signed log per instrument per day, every day. Forgetting it is what fails inspections.",
  "qa.overview.subtitle": "Daily snapshot for the QA Officer",
  "qa.overview.comingSoon": "Coming soon",
  "qa.overview.section.attention": "Attention Required",
  "qa.overview.section.thisWeek": "This Week",
  "qa.overview.section.pillars": "Pillar Status",
  "qa.overview.section.activity": "Recent Activity",
  "qa.overview.section.inspector": "Inspector readiness — five ISO 15189 quality questions",
  "qa.overview.attention.criticalNce": "Critical NCEs pending acknowledgment",
  "qa.overview.attention.criticalResults": "Critical results in last 24 hours",
  "qa.overview.attention.overdueCapas": "Overdue CAPAs",
  "qa.overview.attention.qcViolations": "QC violations in last 24 hours",
  "qa.overview.attention.effectivenessReview": "CAPA effectiveness reviews due",
  "qa.overview.attention.eqaDue": "EQA submissions due in next 14 days",
  "qa.overview.attention.nceSla": "NCEs nearing acknowledgment SLA",
  "qa.overview.tile.criticalCallback": "Critical Callback",
  "qa.overview.week.newNces": "New NCEs",
  "qa.overview.week.ncesResolved": "NCEs resolved",
  "qa.overview.week.capasCompleted": "CAPAs completed",
  "qa.overview.week.qcViolations": "QC violations",
  "qa.overview.week.criticalResults": "Critical results",
  "qa.overview.week.eqaSubmissions": "EQA submissions",
  "qa.overview.week.auditEntries": "Audit log entries",
  "qa.overview.week.signatureEvents": "Signature events",
  "qa.overview.inspector.q1": "Are runs in control?",
  "qa.overview.inspector.q2": "How did EQA perform last cycle?",
  "qa.overview.inspector.q3": "Are QIs on target?",
  "qa.overview.inspector.q4": "Open critical NCEs?",
  "qa.overview.inspector.q5": "Accreditation status?",
  "qa.overview.inspector.q1.answer": "{inControl} of {total} instruments in control (30d)",
  "qa.overview.inspector.q3.answer": "Avg TAT {tat} vs prior 30d",
  "qa.overview.inspector.q4.answer": "{count} critical NCEs pending acknowledgment",
  "qa.overview.inspector.q5.answer": "{active} of {total} in force, {expiring} expiring, {expired} expired",
  "qa.overview.inspector.q5.noData": "No accrediting bodies configured",
  "qa.overview.week.severityBreakdown": "{critical} critical · {major} major · {minor} minor",
  "qa.overview.week.overdueCount": "{count} overdue",
  "qa.overview.week.currentlyOpen": "currently open",
  "qa.overview.pillar.qc.text": "{inControl} of {total} instruments in control",
  "qa.overview.pillar.qc.noData": "No QC data yet",
  "qa.overview.pillar.qi.text": "Avg TAT {tat}",
  "qa.overview.pillar.qi.noData": "No TAT data yet",
  "qa.overview.pillar.qi.disabled": "Not currently tracked",
  "qa.overview.pillar.qms.text": "{critical} critical pending · {capa} in corrective action",
  "qa.overview.activity.viewAudit": "View full audit trail",
  "qa.overview.activity.empty": "No activity in the last 24 hours",
  "qa.empty.activity.subhead": "Attested actions across all pillars appear here as they happen.",
  "qa.empty.attention.title": "Nothing needs attention right now",
  "qa.empty.attention.subhead": "Critical NCEs, overdue CAPAs, and QC violations surface here when they occur.",
  "qa.empty.amendment.title": "No amendments in this window",
  "qa.empty.amendment.subhead": "Amendments appear here when a released result is corrected.",
  "qa.empty.rejection.title": "No rejections in this window",
  "qa.empty.rejection.subhead": "Rejections appear here when a test is rejected at results entry or validation.",
  "qa.empty.capaRegister.title": "No CAPAs match these filters",
  "qa.empty.capaRegister.subhead": "Corrective and preventive actions appear here as they are recorded against non-conforming events.",
  "qa.empty.accreditation.bodies.title": "No accrediting bodies yet",
  "qa.empty.accreditation.bodies.subhead": "Add the bodies that accredit this laboratory to start tracking per-test accreditation.",
  "qa.empty.accreditation.enrollments.title": "No enrollments match these filters",
  "qa.empty.accreditation.enrollments.subhead": "Enroll tests under an accrediting body to show its logo on patient reports.",
  "qa.empty.accreditation.eqa.title": "Nothing to compare yet",
  "qa.empty.accreditation.eqa.subhead": "Once tests are enrolled under an accrediting body, their EQA coverage is compared here.",
  "qa.empty.esigLog.title": "No signatures in this window",
  "qa.empty.esigLog.subhead": "Signatures appear here as results are authored and validated. Try a wider date range or fewer filters.",
  "qa.empty.tat.title": "No results in this window",
  "qa.empty.tat.subhead": "Turnaround times appear here as test orders are completed and validated. Try a different date range.",
  "qa.empty.sparse.labUnits": "{count, plural, one {# lab unit} other {# lab units}} this period",
  "qa.overview.activity.yesterday": "Yesterday {time}",
  "qa.overview.activity.esig": "{actor} {meaning} {record}",
  "qa.overview.activity.meaning.AUTHORED": "authored results for",
  "qa.overview.activity.meaning.VALIDATED_AND_RELEASED": "validated & released",
  "qa.overview.activity.meaning.REJECTED": "rejected",
  "qa.overview.activity.qc": "QC alert: {rule} ({severity}) on {instrument}",
  "qa.overview.activity.nce.CREATED": "{actor} reported {nce}",
  "qa.overview.activity.nce.ACKNOWLEDGED": "{actor} acknowledged {nce}",
  "qa.overview.activity.nce.ASSIGNED": "{actor} assigned {nce}",
  "qa.overview.activity.nce.NOTE_ADDED": "{actor} added a note to {nce}",
  "qa.overview.activity.nce.STATUS_CHANGED": "{actor} updated the status of {nce}",
  "qa.overview.activity.nce.CORRECTIVE_ACTION": "{actor} updated corrective action on {nce}",
  "qa.overview.activity.nce.RESOLVED": "{actor} resolved {nce}",
  "qa.overview.activity.nce.UPDATED": "{actor} updated {nce}",
  "sidenav.title.statusreport": "Informe de estado del paciente",
  "systemAudit.filter.startDate": " Fecha de inicio",
  "systemAudit.filter.endDate": " Fecha de finalización",
  "systemAudit.filter.entityType": "Tipo de entidad",
  "systemAudit.filter.action": " Acción",
  "systemAudit.filter.search": "Buscar",
  "systemAudit.filter.export": "Exportar CSV",
  "systemAudit.table.heading.time": "Hora",
  "systemAudit.table.heading.entityType": "Tipo de entidad",
  "systemAudit.table.heading.entityId": "Identificador de entidad",
  "systemAudit.table.heading.action": " Acción",
  "systemAudit.table.heading.user": " Usuario",
  "systemAudit.table.heading.changes": "Cambios",
  "systemAudit.noResults": "No se han encontrado eventos del sistema que se ajusten a los filtros indicados.",
  "systemAudit.filter.all": "Todos",
  "systemAudit.filter.user": " Usuario",
  "systemAudit.filter.searchText": "Buscar",
  "systemAudit.filter.searchText.placeholder": "Buscar por ID de entidad...",
  "systemAudit.filter.exportPdf": "Exportar a PDF",
  "systemAudit.filter.selectedPatient": "Paciente seleccionado",
  "systemAudit.filter.selectedPatient.none": "Ninguno",
  "systemAudit.filter.selectPatient": "Seleccione un paciente",
  "systemAudit.filter.selectAnotherPatient": "Seleccione otro paciente",
  "systemAudit.action.insert": "Insertar",
  "systemAudit.action.update": "Actualizar",
  "systemAudit.action.delete": "Eliminar",
  "site.branding.cancel": "Cancelar",
  "site.branding.color.format.error": "Formato de color no válido. Utilice un color CSS válido (por ejemplo, #0f62fe)",
  "site.branding.color.hex.label": "Código de color hexadecimal",
  "site.branding.colorPicker.helperText": "Ingrese cualquier color CSS (por ejemplo, #0f62fe, blue, rgb(15, 98, 254))",
  "site.branding.colorPicker.placeholder": "#0f62fe o blue",
  "site.branding.confirm.remove": "Eliminar el logotipo",
  "site.branding.confirm.remove.message": "¿Está seguro de que desea eliminar este logotipo y volver al logotipo predeterminado de OpenELIS?",
  "site.branding.current.logo": "Logotipo actual",
  "site.branding.description": "Personalice la identidad visual de su organización, incluidos los logotipos y los colores",
  "site.branding.error.remove": "Se ha producido un error al eliminar el archivo del logotipo.",
  "site.branding.favicon": "Favicon",
  "site.branding.favicon.description": "Icono que aparece en las pestañas y los marcadores del navegador",
  "site.branding.file.format.error": "Formato de archivo no compatible. Utilice, por favor, PNG, SVG o JPG/JPEG",
  "site.branding.file.pending": "Archivo seleccionado: haga clic en «Guardar cambios» para subirlo",
  "site.branding.file.size.error": "El tamaño del archivo supera el límite de 2 MB",
  "site.branding.formats": "Formatos: PNG, SVG, JPG (máx. 2 MB)",
  "site.branding.header.color": "Color del encabezado",
  "site.branding.header.color.description": "Color de fondo de la barra de encabezado de la aplicación",
  "site.branding.header.logo": "Logotipo de cabecera",
  "site.branding.header.logo.description": "Logotipo que aparece en la esquina superior izquierda del encabezado de la aplicación",
  "site.branding.login.logo": "Logotipo de la página para iniciar sesión",
  "site.branding.login.logo.description": "Logotipo que aparece en la página para iniciar sesión",
  "site.branding.login.using.header.logo": "Uso del logotipo del encabezado en la página para iniciar sesión",
  "site.branding.logo.upload.success": "El logotipo se ha subido correctamente",
  "site.branding.no.logo": "Sin logotipo personalizado (se utiliza el predeterminado)",
  "site.branding.preview": "Vista previa",
  "site.branding.primary.color": "Color primario",
  "site.branding.primary.color.description": "Color de los botones principales, los elementos de menú activos y los enlaces",
  "site.branding.remove.favicon": "Eliminar el favicon",
  "site.branding.remove.header.logo": "Eliminar el logotipo del encabezado",
  "site.branding.remove.login.logo": "Eliminar el logotipo de inicio de sesión",
  "site.branding.remove.logo": "Eliminar el logotipo",
  "site.branding.reset.confirmation": "¿Está seguro de que desea restablecer toda la imagen de marca a los valores predeterminados de OpenELIS? Esto eliminará todos los logotipos y colores personalizados.",
  "site.branding.reset.error": "Se ha producido un error al restablecer la configuración de marca a los valores predeterminados.",
  "site.branding.reset.success": "La configuración de la marca se ha restablecido correctamente a los valores predeterminados.",
  "site.branding.reset.to.defaults": "Restablecer la imagen de marca predeterminada",
  "site.branding.save": "Guardar cambios",
  "site.branding.save.error": "Error al guardar la configuración de la imagen de marca",
  "site.branding.save.success": "La configuración de la marca se ha guardado exitosamente",
  "site.branding.secondary.color": "Color secundario",
  "site.branding.secondary.color.description": "Color para los botones secundarios, los bordes y los estados inactivos",
  "site.branding.section.colors": "Colores",
  "site.branding.section.logos": "Logotipos",
  "site.branding.title": "Identidad visual del sitio",
  "site.branding.unsaved.changes": "Tiene cambios sin guardar. ¿Desea guardarlos, descartarlos o cancelar?",
  "site.branding.unsaved.changes.warning": "Tiene cambios sin guardar. Haga clic en «Guardar» para aplicarlos.",
  "site.branding.upload.favicon": "Subir el favicon",
  "site.branding.upload.header.logo": "Subir el logotipo de cabecera",
  "site.branding.upload.login.logo": "Subir el logotipo para iniciar sesión",
  "site.branding.upload.logo": "Subir logotipo",
  "site.branding.use.header.logo.for.login": "Utilice el mismo logotipo que el de la cabecera",
  "siteInfo.description.default.barcode": "Indique el número predeterminado de etiquetas de código de barras que se imprimirán con cada orden y muestra.",
  "siteInfo.description.dimensions": "Indique las dimensiones que deben tener las etiquetas de código de barras al imprimirse.",
  "siteInfo.description.elements": "Marque la casilla junto a los elementos opcionales que deben aparecer en las etiquetas de código de barras de la orden y la muestra.",
  "siteInfo.description.max.barcode": "Indique el número máximo de etiquetas de código de barras que se pueden imprimir por cada orden o muestra. Una vez alcanzado el máximo, el usuario no podrá imprimir más etiquetas.",
  "siteInfo.elements.mandatory": "Elementos Obligatorios",
  "siteInfo.elements.optional": "Elementos Opcionales",
  "siteInfo.section.altAccession": "Número de acceso preimpreso en código de barras",
  "siteInfo.section.elements": " Elementos de la etiqueta de código de barras",
  "siteInfo.section.number": " Número de etiquetas predeterminado",
  "siteInfo.section.size": "Dimensiones de la etiqueta de código de barras",
  "siteInfo.title.default.barcode": "Etiquetas de Código de Barras Predeterminadas",
  "siteInfo.title.default.barcode.block": "Bloque",
  "siteInfo.title.default.barcode.height": "Altura",
  "siteInfo.title.default.barcode.order": "Orden",
  "siteInfo.title.default.barcode.order.none": "Ninguno",
  "siteInfo.title.default.barcode.slide": "Portaobjetos",
  "siteInfo.title.default.barcode.specimen": "Muestra",
  "siteInfo.title.default.barcode.freezer": "Congelador",
  "siteInfo.title.default.barcode.width": "Ancho",
  "siteInfo.title.max.barcode": "Número Máximo de Etiquetas de Código de Barras",
  "started.date": "Fecha de inicio",
  "status": "Estado",
  "status.in.progress": "En progreso",
  "status.unknown": "Desconocido",
  "stillThere.message": " La sesión de usuario está por expirar. Haz clic en cualquier parte para seguir conectado.",
  "stillThere.title": " ¿Sigues ahí?",
  "stock.available": "Disponible",
  "stock.level": "Nivel de existencias",
  "stock.status": "Estado de existencias",
  "stock.status.expired": "Caducado",
  "stock.status.expiring": "A punto de caducar",
  "stock.status.expiringIn": "Próximo a caducar ({days} d)",
  "stock.status.inStock": "En stock",
  "stock.status.lowStock": "Existencias escasas",
  "stock.status.outOfStock": "Agotado",
  "storage.active": "Activo",
  "storage.add.device": "Agregar dispositivo",
  "storage.add.location": "Ubicación",
  "storage.add.location.option": "Agregar ubicación...",
  "storage.add.new.device": "Agregar un nuevo dispositivo",
  "storage.add.rack": "Agregar rack",
  "storage.add.box": "Agregar caja",
  "storage.add.room": "Agregar sala",
  "storage.add.shelf": "Agregar estante",
  "storage.allAssigned.title": "Todas las muestras asignadas",
  "storage.assign.button": "Asignar ubicación",
  "storage.assign.title": "Asignar ubicación de almacenamiento",
  "storage.assigned": "Asignado",
  "storage.assigned.by": "Asignado por",
  "storage.assigned.date": "Fecha de asignación",
  "storage.barcode.scan.placeholder": "Escanear el código de barras o Ingresar Manualmente",
  "storage.bulk.move.auto.assigned": "Cargos asignados automáticamente (editables)",
  "storage.bulk.move.preview": "Vista previa de la transferencia masiva",
  "storage.cannotDelete.hasAssignments": "No se puede eliminar «{entityType}» «{name}»: tiene una o varias muestras asignadas a «{count}».",
  "storage.cannotDelete.hasChildren": "No se puede eliminar «{entityType}» «{name}»: contiene uno o varios archivos {count} {childType}(s)",
  "storage.capacity.calculated": "Calculado",
  "storage.capacity.manual": "Límite manual",
  "storage.capacity.undetermined.tooltip": "No se puede realizar el cálculo de la capacidad: algunas ubicaciones secundarias carecen de capacidades definidas",
  "storage.capacity.warning": "{location} {percentage}% de su capacidad está ocupada. Considere la posibilidad de utilizar un almacenamiento alternativo.",
  "storage.code.change.acknowledge": "Entiendo y deseo continuar con el cambio de código",
  "storage.code.change.warning": "Advertencia",
  "storage.code.change.warning.message": "Si modifica el código, las etiquetas impresas anteriormente para esta ubicación dejarán de ser válidas.",
  "storage.confirm.add.device": "¿Desea crear un nuevo dispositivo «{name}»?",
  "storage.conditionNotes": "Notas sobre el estado",
  "storage.conditionNotes.placeholder": "Ingrese cualquier nota sobre las condiciones de almacenamiento...",
  "storage.confirm.delete": "Confirmar eliminación",
  "storage.create.room.error": "No se ha podido crear la sala: {error}",
  "storage.create.room.success": "Se ha creado correctamente la sala «{name}»",
  "storage.current.location": "Ubicación actual",
  "storage.currentLocation": "Ubicación actual",
  "storage.delete.admin.only": "Solo los administradores globales pueden eliminar ubicaciones",
  "storage.delete.are.you.sure": "¿Está seguro de que desea eliminar",
  "storage.delete.cannot.be.undone": "Esta acción no se puede deshacer.",
  "storage.delete.cascade.confirm": "Confirmar la eliminación en cascada",
  "storage.delete.cascade.confirmation.checkbox": "Confirmo que deseo eliminar esta ubicación y todas sus ubicaciones secundarias. Todas las muestras quedarán sin asignar. Esta acción no se puede deshacer.",
  "storage.delete.cascade.summary": "Esto eliminará {childCount} {childType}(s) y desasignará {sampleCount} muestra(s). ¿Está seguro de que desea continuar?",
  "storage.delete.cascade.warning": "Advertencia sobre la eliminación en cascada",
  "storage.delete.checking": "Comprobando las restricciones...",
  "storage.delete.confirmation.checkbox": "Confirmo que deseo eliminar esta ubicación. Esta acción no se puede deshacer.",
  "storage.delete.constraints.title": "No se puede eliminar",
  "storage.delete.device": "Eliminar dispositivo",
  "storage.delete.error": "No se ha podido eliminar la ubicación",
  "storage.delete.location": "Eliminar ubicación",
  "storage.delete.rack": "Eliminar rack",
  "storage.delete.room": "Eliminar sala",
  "storage.delete.shelf": "Eliminar estante",
  "storage.device.code": "Código",
  "storage.device.communicationProtocol": "Protocolo de comunicación",
  "storage.device.communicationProtocol.helper": "Protocolo utilizado para la comunicación entre dispositivos (p. ej., BACnet)",
  "storage.device.ipAddress": "Dirección IP",
  "storage.device.ipAddress.helper": "Dirección IPv4 o IPv6 para equipos conectados a la red",
  "storage.device.label": "Dispositivo",
  "storage.device.name": " Nombre",
  "storage.device.placeholder": "Seleccione o escriba para crear un dispositivo...",
  "storage.device.port": "Puerto",
  "storage.device.port.helper": "Número de puerto (1-65535) para la comunicación",
  "storage.device.room": "Habitación",
  "storage.device.type": "Tipo",
  "storage.edit.device": "Editar dispositivo",
  "storage.edit.error.loadLocation": "No se ha podido cargar la ubicación",
  "storage.edit.error.saveFailed": " Error al guardar",
  "storage.edit.error.saveHttp": "Error al guardar (HTTP {status})",
  "storage.edit.rack": "Editar rack",
  "storage.edit.room": "Editar Sala de montaje",
  "storage.edit.shelf": "Editar estantería",
  "storage.edit.selectParent": "Seleccione «{parent}»",
  "storage.editbox.error.loadBox": "No se ha podido cargar el recuadro",
  "storage.editbox.selectRack": "Seleccione un estante",
  "storage.box.capacity": "Capacidad",
  "storage.box.gridSize": "Tamaño de la cuadrícula",
  "storage.box.rows": "Filas",
  "storage.box.columns": "Columnas",
  "storage.box.preset": "Ajuste predeterminado de dimensiones",
  "storage.box.preset.select": "Seleccione las dimensiones",
  "storage.error.location.inactive": "No se puede asignar a una ubicación inactiva",
  "storage.error.name.duplicate": "Ya existe un «{entityType}» con este nombre en la ubicación principal seleccionada.",
  "storage.error.position.occupied": "El puesto ya está ocupado",
  "storage.expanded.capacityLimit": "Límite de capacidad",
  "storage.expanded.createdBy": "Creado por",
  "storage.expanded.createdDate": "Fecha de creación",
  "storage.expanded.description": "Descripción",
  "storage.expanded.lastModifiedBy": "Última modificación realizada por",
  "storage.expanded.lastModifiedDate": "Fecha de la última modificación",
  "storage.expanded.notAvailable": "N/A",
  "storage.expanded.positionSchemaHint": "Sugerencia sobre el esquema de posiciones",
  "storage.expanded.temperatureSetting": "Ajuste de la temperatura",
  "storage.filter.by.locations": "Filtrar por ubicaciones",
  "storage.filter.by.locations.placeholder": "Filtrar por ubicaciones...",
  "storage.filter.device": "Filtrar por dispositivo",
  "storage.filter.room": "Filtrar por habitación",
  "storage.filter.status": "Filtrar por estado",
  "storage.hierarchical.path": "Ruta de ubicación",
  "storage.inline.add.device": "Agregar un nuevo dispositivo",
  "storage.inline.add.rack": "Agregar un nuevo rack",
  "storage.inline.add.room": "Agregar una nueva habitación",
  "storage.inline.add.shelf": "Agregar una nueva estantería",
  "storage.location": "Ubicación",
  "storage.location.active": "Activo",
  "storage.location.add.button": "Agregar ubicación",
  "storage.location.add.title": "Agregar ubicación de almacenamiento",
  "storage.location.current": "Ubicación de almacenamiento",
  "storage.location.code": "Código",
  "storage.location.code.helper": "Máximo 10 caracteres, alfanuméricos con guiones o guiones bajos",
  "storage.location.description": "Descripción",
  "storage.location.label": "Ubicación de almacenamiento",
  "storage.location.name": "Nombre de la ubicación",
  "storage.location.skipped": "Almacenamiento omitido",
  "storage.location.tempMax": "Temperatura máxima",
  "storage.location.tempMin": "Temperatura mínima",
  "storage.location.type": "Tipo de ubicación",
  "storage.location.unassigned": "Sin asignar",
  "storage.location.notAssigned": "No asignado",
  "storage.location.move": "Mover ubicación de almacenamiento",
  "storage.location.assign": "Asignar ubicación de almacenamiento",
  "storage.manageLocation.error.saveFailed": " Error al guardar",
  "storage.manageLocation.error.selectTarget": "Seleccione un dispositivo, un estante, un rack o una caja antes de guardar",
  "storage.nav.box": "Caja",
  "storage.nav.device": "Dispositivo",
  "storage.nav.room": "Sala",
  "storage.nav.shelf": "Estante",
  "storage.picker.currentLocation": "Ubicación actual",
  "storage.picker.heading.assignLocation": "Asignar ubicación de almacenamiento",
  "storage.picker.heading.move": "Mover ítem",
  "storage.picker.newLocation": "Nueva ubicación",
  "storage.picker.notes": "Notas",
  "storage.picker.orBrowse": "O seleccionar nivel por nivel",
  "storage.picker.position.optional": "Posición (opcional)",
  "storage.picker.select": "Seleccione «{level}»",
  "storage.picker.selectDeviceType": "Seleccionar tipo de dispositivo",
  "storage.picker.addNewLevel": "Agregar un nuevo {level}",
  "storage.picker.inlineCreate.heading": "Crear un nuevo {level}",
  "storage.picker.inlineCreate.error.title": "No se ha podido crear la ubicación",
  "storage.picker.inlineCreate.error": "No se ha podido crear la ubicación",
  "storage.picker.occupant.identifier": " Identificador",
  "storage.picker.occupant.heading": " Elemento",
  "storage.picker.occupant.status": "Estado",
  "storage.picker.occupant.type": "Tipo",
  "storage.picker.storageLocation": "Ubicación de almacenamiento",
  "storage.metrics.active": "Activo",
  "storage.metrics.disposed": "Desechados",
  "storage.metrics.total.samples": "Número total de elementos de la muestra",
  "storage.mode.autocomplete": "Búsqueda con autocompletado",
  "storage.mode.barcode": "Escaneo de códigos de barras",
  "storage.mode.cascading": "Menús desplegables en cascada",
  "storage.move.button": "Mover muestra de muestra",
  "storage.move.reason.label": "Motivo del traslado",
  "storage.nav.boxes": "Cajas",
  "storage.nav.boxes.tooltip": "Gestionar cajas de almacenamiento",
  "storage.nav.dashboard": "Panel de almacenamiento",
  "storage.nav.devices": "Dispositivos",
  "storage.nav.devices.tooltip": "Gestionar dispositivos de almacenamiento",
  "storage.nav.locations": "Ubicaciones",
  "storage.nav.locations.tooltip": "Gestionar ubicaciones de almacenamiento",
  "storage.nav.racks": "Racks",
  "storage.nav.racks.tooltip": "Gestionar racks de almacenamiento",
  "storage.nav.rooms": "Salas",
  "storage.nav.rooms.tooltip": "Gestionar salas de almacenamiento",
  "storage.nav.sample.items": "Muestra de elementos",
  "storage.nav.sample.items.tooltip": "Consultar y gestionar las muestras almacenadas",
  "storage.nav.samples": "Elementos de muestra",
  "storage.nav.samples.tooltip": "Consultar y gestionar las muestras almacenadas",
  "storage.nav.shelves": "Estantes",
  "storage.nav.shelves.tooltip": "Gestionar los estantes de almacenamiento",
  "storage.no.data": "No hay datos disponibles",
  "storage.occupancy": "Ocupación",
  "storage.position.label": "Cargo",
  "storage.rack.device": "Dispositivo",
  "storage.rack.dimensions": "Dimensiones",
  "storage.rack.label": "Estantería",
  "storage.rack.placeholder": "Seleccione o escriba para crear un rack...",
  "storage.rack.room": "Habitación",
  "storage.rack.shelf": "Estantería",
  "storage.room.code": "Código",
  "storage.room.devices": "Dispositivos",
  "storage.room.label": "Habitación",
  "storage.room.name": " Nombre",
  "storage.room.placeholder": "Seleccione o escriba para crear una sala...",
  "storage.room.samples": "Muestras",
  "storage.sampleitem.id": "ID del artículo de muestra",
  "storage.search.boxes.placeholder": "Buscar cajas por etiqueta o código...",
  "storage.search.devices.placeholder": "Buscar por nombre o código del dispositivo...",
  "storage.search.location.minLength": "Continúe escribiendo, al menos 2 caracteres",
  "storage.search.location.searching": "Buscando...",
  "storage.search.location.error": "No se pudieron buscar las ubicaciones. Por favor, inténtelo de nuevo.",
  "storage.search.location.noResults": "Ninguna ubicación de almacenamiento coincide con \"{query}\"",
  "storage.search.placeholder": "Buscar por número de muestra o ubicación...",
  "storage.search.racks.placeholder": "Buscar por etiqueta de rack...",
  "storage.search.rooms.placeholder": "Buscar por nombre o código de sala...",
  "storage.search.lots.placeholder": "Buscar por número de lote, código de barras, ítem o ubicación...",
  "storage.search.samples.placeholder": "Buscar por número de muestra o ubicación...",
  "storage.search.shelves.placeholder": "Buscar por etiqueta de estante...",
  "storage.select.location": "Seleccione una ubicación",
  "storage.selectSample": "Seleccionar muestra",
  "storage.shelf.device": "Dispositivo",
  "storage.shelf.label": "Estantería",
  "storage.shelf.placeholder": "Seleccione o escriba para crear una estantería...",
  "storage.shelf.room": "Habitación",
  "storage.status": "Estado",
  "storage.status.disposed": "Eliminada",
  "storage.success.assigned": "La muestra se ha asignado correctamente a la ubicación de almacenamiento",
  "storage.success.moved": "La muestra se ha trasladado a la nueva ubicación correctamente",
  "storage.tab.ariaLabel": "Pestañas de gestión de almacenamiento",
  "storage.tab.dashboard": "Panel",
  "storage.tab.inventoryLots": "Lotes de inventario",
  "storage.tab.samples": "Elementos de muestra",
  "storage.target.location": "Ubicación del objetivo",
  "storage.unassigned.title": "Muestras sin asignar",
  "storage.skipAssignment": "No es necesario almacenarlas: las muestras se procesarán de inmediato",
  "success.add.edited.msg": "Agregado/editado correctamente",
  "success.delete.msg": "Eliminado correctamente",
  "success.import.patient": " Paciente importado exitosamente",
  "success.report.status": " Informe generado con éxito",
  "success.save.msg": " Guardado exitosamente",
  "success.save.patient": " Paciente guardado exitosamente",
  "systemuser.firstName": "Nombre del Usuario del Sistema",
  "systemuser.isActive": "Está Activo",
  "systemuser.lastName": "Apellido del Usuario del Sistema",
  "systemuser.loginName": "Nombre de Inicio de Sesión del Usuario del Sistema",
  "systemuser.role": "Roles",
  "systemuserrole.apply": "Aplicar",
  "systemuserrole.allLabUnits.confirm.body": "Switching this row to All Lab Units removes these lab unit permissions. The All Lab Units row starts with no permissions ticked.",
  "systemuserrole.allLabUnits.confirm.noPermissions": "no permissions ticked",
  "systemuserrole.allLabUnits.confirm.primary": "Replace permissions",
  "systemuserrole.allLabUnits.confirm.title": "Replace lab unit permissions?",
  "systemuserrole.allLabUnits.exclusive.error": "All Lab Units cannot be combined with individual lab units. Nothing was saved.",
  "systemuserrole.allLabUnits.exclusive.info": "All Lab Units cannot be combined with individual lab units: selecting it replaces every lab-unit-specific permission.",
  "systemuserrole.copypermissions": "Copiar Permisos De Usuario",
  "systemuserrole.copypermissions.placeholder": "Copiar Permisos de Usuario",
  "systemuserrole.instruction.1": "Hay dos tipos de Roles. Roles Globales que se establecen para toda la aplicación y Roles de Unidad de Laboratorio que se pueden establecer para todas las Unidades de Laboratorio o para Unidades específicas.",
  "systemuserrole.instruction.2": "Los Roles Globales disponibles son: Administrador Global (Acceso a todas las Funciones de Administración), Auditoría (Acceso a toda la Auditoría), Administrador de Cuentas de Usuario (tiene acceso a todas las funciones de administración de cuentas de usuario, pero no a otras funciones de administración).",
  "systemuserrole.instruction.3": "Los Roles de Unidad de Laboratorio son: Recepción (Acceso a las pestañas de Orden, Paciente y No Conformidad), Resultados (Acceso a las pestañas de Plan de Trabajo, No Conformidad y Resultados), Validación (Acceso a las pestañas de Validación y No Conformidad), Informes (Acceso a la pestaña de Informes excepto exportación CSV solo disponible para Administradores Globales).",
  "systemuserrole.instruction.4": "Para asignar Roles de Unidad de Laboratorio, seleccione todas las unidades de laboratorio o la unidad específica del menú desplegable y seleccione los roles que desea establecer.",
  "systemuserrole.instruction.5": "También puede usar la función Copiar Permisos para copiar los permisos de un usuario existente. Asegúrese de haber completado toda la información anterior e ingrese el nombre de usuario cuyos permisos desea copiar en el cuadro y haga clic en aplicar.",
  "systemuserrole.newpermissions": "Agregar Nuevo Permiso",
  "systemuserrole.rmpermissions": "Eliminar Permiso",
  "systemuserrole.roles.global": "Roles Globales",
  "systemuserrole.roles.labunit": "Roles de Unidad de Laboratorio",
  "test.add.copy.name": "Copiar del Nombre de la Prueba",
  "test.antimicrobialResistance": "Resistencia Antimicrobiana",
  "test.description.active": "Si la prueba está activa, puede solicitarse en el formulario de pedido o como parte de un algoritmo de prueba. Si no está activa, no puede solicitarse ni ser parte de un algoritmo de prueba",
  "test.description.name": "El nombre de la prueba como aparecerá dentro de openELIS. Se requieren tanto inglés como francés",
  "test.description.orderable": "Si una prueba está activa y es ordenable, puede solicitarse en un formulario de pedido. Si está activa pero no es ordenable, solo se realizará si se refleja desde otra prueba",
  "test.description.panel": "Si esta prueba es parte de un panel de pruebas, el panel puede agregarse aquí. Es posible, pero no usual, que una prueba esté en más de un panel",
  "test.description.reportName": "El nombre de la prueba como aparecerá en los informes. Se requieren tanto inglés como francés. Si el Nombre y el nombre de informe son iguales, haga clic en el botón para copiar el nombre",
  "test.description.testSection": "La sección de prueba en la que se realizará la prueba",
  "test.description.uom": "Unidad de medida para la prueba. Esto generalmente solo se aplica a tipos de resultados numéricos o alfanuméricos",
  "test.field.active": "Activo",
  "test.field.orderable": "Ordenable",
  "test.inLabOnly": "Solo en Laboratorio",
  "test.modify.en": "en",
  "test.modify.fr": "fr",
  "test.modify.header.modify": "¡Por favor Seleccione la Prueba a Modificar!",
  "test.modify.header.test": "Prueba",
  "test.name": " Nombre de la prueba",
  "test.notifyResults": "Notificar al Paciente de los Resultados",
  "test.section": "Sección de Prueba",
  "test.section.label": "Sección de prueba",
  "test.show.guide": "Mostrar guía",
  "testcalculation.label.calculation": "Cálculo",
  "testcalculation.label.finalresult": "Resultado final",
  "testcalculation.label.insertOperation": "Insertar operación",
  "testcalculation.label.integer": "Entero",
  "testcalculation.label.mathFucntion": "Función matemática",
  "testcalculation.label.name": "Nombre del cálculo",
  "testcalculation.label.patientAttribute": "Atributo del paciente",
  "testcalculation.label.searchNumericTest": "Buscar prueba numérica",
  "testcalculation.label.selectDictionaryValue": "Seleccionar valor del diccionario",
  "testcalculation.label.testResult": "Resultado de la prueba",
  "testcalculation.label.textValue": "Valor de texto",
  "testCatalog.header.ageRange": "Rango de edad",
  "testCatalog.header.criticalRange": "Rango crítico",
  "testCatalog.header.field": "Campo",
  "testCatalog.header.gender": "Sexo",
  "testCatalog.header.normalRange": "Rango Normal",
  "testCatalog.header.reportingRange": "Rango de informe",
  "testCatalog.header.validRange": "Rango válido",
  "testCatalog.header.value": "Valor",
  "admin.testCatalog.methods.title": "Métodos",
  "admin.testCatalog.methods.column.name": "Nombre del Método",
  "admin.testCatalog.methods.column.code": "Código",
  "admin.testCatalog.methods.column.default": "Por defecto",
  "admin.testCatalog.methods.column.effectiveDate": "Fecha de entrada en vigor",
  "admin.testCatalog.methods.column.actions": "Acciones",
  "admin.testCatalog.methods.action.edit": "Editar",
  "admin.testCatalog.methods.action.remove": "Eliminar",
  "admin.testCatalog.methods.btn.linkMethod": "+ Vincular método",
  "admin.testCatalog.methods.btn.createMethod": "+ Crear Nuevo Método",
  "admin.testCatalog.methods.btn.copyFromTest": "Copiar desde una prueba",
  "admin.testCatalog.methods.modal.link.title": "Vincular método",
  "admin.testCatalog.methods.modal.link.selectPlaceholder": "Seleccione un método para vincular",
  "admin.testCatalog.methods.modal.link.noAvailable": "Todos los métodos activos ya están vinculados",
  "admin.testCatalog.methods.inline.nameEnglish": "Nombre del Método (Inglés)",
  "admin.testCatalog.methods.inline.nameFrench": "Nombre del Método (en francés)",
  "admin.testCatalog.methods.inline.code": "Código abreviado",
  "admin.testCatalog.methods.inline.codeHint": "De 3 a 10 caracteres alfanuméricos en mayúsculas, sin espacios",
  "admin.testCatalog.methods.inline.createAndLink": "Crear y vincular",
  "admin.testCatalog.methods.copyFromTest.label": "Copiar métodos de la prueba",
  "admin.testCatalog.methods.copyFromTest.placeholder": "Seleccione la prueba de origen",
  "admin.testCatalog.methods.effectiveDate.label": "Fecha de entrada en vigor",
  "admin.testCatalog.methods.default.label": "Establecer como predeterminado",
  "admin.testCatalog.methods.error.duplicateLink": "Este método ya está vinculado a la prueba",
  "admin.testCatalog.methods.error.codeFormat": "El código debe constar de entre 3 y 10 caracteres alfanuméricos en mayúsculas, sin espacios.",
  "admin.testCatalog.methods.error.effectiveDateRequired": "Es obligatorio indicar la fecha de entrada en vigor",
  "admin.testCatalog.methods.error.duplicateCode": "A method with this code already exists. Enter a different code.",
  "admin.testCatalog.methods.error.duplicateName": "A method with this name already exists. Use a different name, or link the existing method.",
  "admin.testCatalog.methods.error.invalidRequest": "The request was refused. Check the fields and try again.",
  "admin.testCatalog.methods.error.server": "The server could not complete the request. Try again.",
  "admin.testCatalog.methods.error.removeFailed": "The method could not be removed. It is still linked; try again.",
  "admin.testCatalog.methods.linked": "Method linked.",
  "admin.testCatalog.methods.created": "Method created and linked.",
  "admin.testCatalog.methods.copied": "From {source}: {count, plural, one {# method} other {# methods}} copied.",
  "admin.testCatalog.methods.copyNothing": "No methods copied: {source} has no methods that are not already linked to this test.",
  "admin.testCatalog.methods.empty": "No hay métodos vinculados. Utilice «+ Vincular método» o «+ Crear Nuevo Método» para agregar uno.",
  "testnotification.bcc": "CCO",
  "testnotification.instructionis.variables.body": "[testName] : Nombre de la prueba para la que es",
  "testnotification.instructionis.variables.body.0": "[testResult] : Resultado de la prueba",
  "testnotification.instructionis.variables.header": "Lista de variables:",
  "testnotification.instructions.body": "Cuando se crea una notificación, primero verificará si hay una plantilla de mensaje definida para el destinatario/tipo de mensaje.",
  "testnotification.instructions.body.0": "Si no existe, usará el mensaje predeterminado de la prueba.",
  "testnotification.instructions.body.1": "Si eso no existe, usará el mensaje predeterminado del sistema.",
  "testnotification.instructions.body.2": "Las variables serán reemplazadas por sus valores correspondientes en el cuerpo del mensaje y en el asunto.",
  "testnotification.instructions.body.3": "Las variables siempre deben incluir los corchetes y no deben tener espacios en blanco.",
  "testnotification.instructions.header": "Instrucciones:",
  "testnotification.messagetemplate": "Mensaje",
  "testnotification.options": "Mensajes Individuales",
  "testnotification.patient.email": "Correo Electrónico del Paciente",
  "testnotification.patient.sms": "v",
  "testnotification.patiententry.header": "Reporte de Resultados",
  "testnotification.patiententry.info": "Si OpenELIS no puede conectarse al receptor de los resultados transmitidos, los pondrá en cola. Una cola grande y creciente es una señal de que se deben tomar medidas de solución de problemas, incluyendo contactar al receptor.",
  "testnotification.provider.email": "Correo Electrónico del Proveedor",
  "testnotification.provider.sms": "SMS del Proveedor",
  "testnotification.subjecttemplate": "Asunto",
  "testnotification.systemdefault.template": "Mensaje Predeterminado del Sistema",
  "testnotification.testdefault.editIcon": "Editar Notificación de Prueba",
  "testnotification.testdefault.template": "Mensaje Predeterminado para la Prueba",
  "testnotificationconfig.browse.title": "Configuración de Notificación de Pruebas",
  "tests.not.assigned": "Pruebas no asignadas",
  "testsection.testSectionName": "Nombre de la Sección de Prueba",
  "testUnit.existing": "Unidades de Prueba Existentes",
  "testUnit.existing.inactive": "Unidades de Prueba Inactivas. Asigne pruebas para activar.",
  "testUnit.new": "Nueva Unidad de Prueba",
  "text.length.max": " La longitud del texto no debe ser mayor de 200",
  "title.notestfoundmatching": " No se encontraron pruebas que coincidan",
  "to.title": "Hasta",
  "tooltip.banner.menu.generic.sample.results": "Ingrese los resultados de las pruebas de las muestras genéricas",
  "tooltip.banner.menu.workplan.batch": "Batch Workplan",
  "total.quantity": "Cantidad total",
  "transaction.date": "Fecha",
  "transaction.quantity": "Cantidad",
  "transaction.type": "Tipo",
  "transaction.user": " Usuario",
  "true.label": "Verdadero",
  "unifiedSystemUser.add.user": "Agregar Usuario",
  "unifiedSystemUser.browser.button.add": "Agregar Nuevo Usuario",
  "unifiedSystemUser.browser.search": "Buscar Por Nombres de Usuario",
  "unifiedSystemUser.browser.search.placeholder": "Buscar Por Nombres de Usuario...",
  "unifiedSystemUser.browser.title": "Gestión de Usuarios",
  "unifiedSystemUser.edit.user": "Modificar Usuario",
  "unifiedSystemUser.select": "Seleccionar",
  "unknown.section": "Sección desconocida",
  "unknown.test": "Prueba desconocida",
  "uom.browse.title": "Unidad de Medida",
  "uom.create.heading.confirmation": "Confirmación",
  "uom.existing": "Unidad de Medida Actual",
  "uom.existing.inactive": "Unidad de Medida Inactiva. Asigne pruebas a esta Unidad de Medida para activarla.",
  "uom.new": "Crear una nueva Unidad de Medida",
  "uom.new.added": "Se agregará una nueva Unidad de Medida",
  "uom.notification.duplicate": "La Unidad de Medida ya existe",
  "uom.notification.save": "Nueva Unidad de Medida ha sido guardada.",
  "uom.uomName": "Nombre de la Unidad de Medida",
  "training.installation.message": "Instalación de formación",
  "translation.edit.title": "Editar traducciones",
  "translation.export": "Exportar CSV",
  "translation.export.success": "Las traducciones se han exportado correctamente",
  "translation.fallback": "Valor alternativo (inglés)",
  "translation.management.description": "Consultar y editar las traducciones de los metadatos.",
  "translation.management.title": "Gestión de la traducción",
  "translation.missing": "Faltante",
  "translation.search": "Buscar traducciones...",
  "translation.selectLocale": "Seleccione el idioma",
  "translation.showMissing": "Mostrar únicamente los que faltan",
  "translation.stats.title": "Progreso de la traducción",
  "translation.stats.total": "Número total de entradas: {count}",
  "translation.update.error": "No se ha podido actualizar la traducción",
  "translation.update.success": "La traducción se ha actualizado correctamente",
  "translation.value": "Traducción",
  "usage.analysisId": "ID del análisis",
  "usage.date": "Fecha de uso",
  "usage.error.quantityPositive": "La cantidad debe ser superior a 0",
  "usage.fefo.note": "La cantidad se deduce del lote aprobado por control de calidad con fecha de caducidad más próxima (FEFO) de este ítem, que puede no ser el lote del que abrió esto.",
  "usage.item": " Elemento",
  "usage.notes": "Notas",
  "usage.notes.placeholder": "Agregue cualquier nota sobre este uso",
  "usage.quantityUsed": "Cantidad utilizada",
  "usage.quantityUsed.helper": "Introduzca el número de unidades consumidas",
  "usage.record.button": "Registrar uso",
  "usage.record.error": "Error al registrar el uso",
  "usage.record.success": "El uso se ha registrado correctamente",
  "usage.record.title": "Registrar el uso del inventario",
  "usage.testResultId": "Identificador del resultado de la prueba (opcional)",
  "usage.testResultId.placeholder": "Enlace al resultado de la prueba para la trazabilidad",
  "user.select.instruction": "Seleccione un Usuario para Modificar o Desactivar. Puede establecer un Filtro, Buscar usuarios o Agregar un Usuario con los controles en la parte superior.",
  "validation.accept.all": " Guardar todos los resultados",
  "validation.accept.normal": " Guardar todo lo normal",
  "validation.field.required": "Este campo es obligatorio",
  "validation.ignore.all": " Ignorar todos los resultados",
  "validation.label.nonconform": "= La muestra u orden no cumple o la prueba ha sido rechazada",
  "validation.legend.qcHold": "= A quality control covering this result failed; the non-conformity is still open",
  "validation.qcHold.tooltip": "A control run for this test in this lab unit failed. Review the non-conformity before releasing this result.",
  "validation.password.match": "Las contraseñas deben coincidir",
  "validation.password.minLength": "La contraseña debe tener al menos 7 caracteres.",
  "validation.password.notSameAsOld": "La nueva contraseña no debe ser igual que la anterior.",
  "validation.password.specialChar": "La contraseña debe contener al menos un carácter especial (*, $, #, !) y únicamente letras, números o dichos caracteres.",
  "validation.no.records.display": "No hay registros que mostrar",
  "validation.reject.all": " Rehacer todas las pruebas",
  "validation.save.error": " Los resultados han sido validados exitosamente",
  "validation.save.success": " Los resultados han sido validados exitosamente",
  "validation.search.noresult": " No se encontraron resultados para validar",
  "validation.search.noresult.analyser": " No se encontraron resultados desde:",
  "vl.arvRegimen": "Tratamiento ARV",
  "vl.durationOnARV": "Duración del tratamiento con ARV (meses)",
  "vl.durationOnARV.placeholder": "Ingrese los meses de tratamiento",
  "vl.indication": "Indicaciones para la prueba de VL",
  "vl.lastVLDate": "Fecha del último resultado de VL",
  "vl.lastVLResult": "Último resultado de VL (copias/ml)",
  "vl.lastVLResult.placeholder": "p. ej., 150",
  "vl.pregnancyStatus": "Estado del embarazo / Lactancia",
  "workplan.batch.action.activate": "Activar",
  "workplan.batch.action.archive": "Archivar",
  "workplan.batch.action.complete": "Completado",
  "workplan.batch.batches": "Batches",
  "workplan.batch.batches.empty": "No batches found",
  "workplan.batch.column.actions": "Acciones",
  "workplan.batch.column.count": "Pruebas",
  "workplan.batch.column.created": "Creado",
  "workplan.batch.column.method": "Método",
  "workplan.batch.column.name": "Batch",
  "workplan.batch.column.sampleType": "Tipo de muestra",
  "workplan.batch.column.status": "Estado",
  "workplan.batch.column.test": "Prueba",
  "workplan.batch.column.unit": "Unidad",
  "workplan.batch.create": "Create batch ({count})",
  "workplan.batch.create.error": "Batch could not be created",
  "workplan.batch.create.success": "Batch created",
  "workplan.batch.pending.empty": "No pending tests found",
  "workplan.batch.pendingTests": "Pending Tests",
  "workplan.batch.refresh": "Actualizar",
  "workplan.batch.selectPage": "Select page",
  "workplan.batch.selectTest": "Seleccione «{accessionNumber}»",
  "workplan.batch.status.ACTIVE": "Activo",
  "workplan.batch.status.ARCHIVED": "Archivado",
  "workplan.batch.status.COMPLETED": "Completado",
  "workplan.batch.status.DRAFT": "Borrador",
  "workplan.batch.status.error": "Batch status could not be updated",
  "workplan.batch.status.success": "Batch status updated",
  "workplan.batch.tabs": "Batch workplan tabs",
  "workplan.batch.title": "Batch Workplan",
  "workplan.page.title": "Plan de trabajo {0}",
  "workplan.panel.selection.error.msg": "Este es un mensaje válido",
  "workplan.panel.title": "Plan de trabajo por panel",
  "workplan.panel.types": "Tipo de panel",
  "workplan.print": "Imprimir plan de trabajo",
  "workplan.priority.list": "Prioridad",
  "workplan.priority.title": "Plan de trabajo por prioridad",
  "workplan.run": "Obtener plan de trabajo",
  "workplan.test.title": "Plan de trabajo por prueba",
  "workplan.test.types": "Tipo de prueba",
  "workplan.title": "Plan de trabajo",
  "workplan.unit.title": "Plan de trabajo por unidad",
  "workplan.unit.types": "Tipo de unidad",
  "yes.option": "Sí",
  "shipment.module.title": "Gestión de envíos",
  "shipment.breadcrumb": "Envío de muestras",
  "shipment.nav.dashboard": "Panel",
  "shipment.nav.createBox": "Crear caja",
  "shipment.nav.receiveBox": "Recibir caja",
  "shipment.dashboard.title": "Panel de envíos",
  "shipment.dashboard.description": "Gestionar las cajas de envío y realizar el seguimiento de las muestras referidas",
  "shipment.dashboard.tabs.shipments": "Envíos",
  "shipment.dashboard.tabs.unassigned": "Pruebas sin asignar",
  "shipment.tab.boxes": "Cajas de envío",
  "shipment.tab.unassignedSamples": "Muestras sin asignar",
  "shipment.label.boxId": "ID de caja",
  "shipment.label.createdDate": "Fecha de creación",
  "shipment.label.daysUnassigned": "Días sin asignar",
  "shipment.label.destination": "Destino",
  "shipment.label.priority": " Prioridad",
  "shipment.label.referralTest": "Prueba de referencia",
  "shipment.label.sampleCount": "Número de muestras",
  "shipment.label.state": "Estado",
  "shipment.label.tests": "Pruebas",
  "shipment.filter.state": "Filtrar por estado",
  "shipment.filter.facility": "Filtrar por instalación",
  "shipment.action.addSelected": "Agregar los elementos seleccionados",
  "shipment.action.addToBox": "Agregar a la caja",
  "shipment.action.cancelReferral": "Cancelar la referencia",
  "shipment.action.confirmRejection": "Confirmar el rechazo",
  "shipment.action.createBox": "Crear una nueva caja",
  "shipment.action.markAsLost": "Marcar como perdido",
  "shipment.action.printManifest": "Imprimir manifiesto",
  "shipment.action.rejectSample": "Rechazar muestra",
  "shipment.action.saveAndMarkReady": "Guardar y marcar como «Listo para enviar»",
  "shipment.action.saveBox": "Cuadre de ahorro",
  "shipment.action.saveDraft": "Guardar como borrador",
  "shipment.action.scanSample": "Escanear muestra",
  "shipment.box.addSample": "Agregar muestra",
  "shipment.box.addSampleDescription": "Seleccione las muestras que desee agregar a esta caja de envío",
  "shipment.box.addSamples": "Agregar muestras",
  "shipment.box.details": "Detalles de la caja",
  "shipment.box.autoGenerate": "Generar automáticamente",
  "shipment.box.capacity": "Capacidad",
  "shipment.box.capacityValue": "{capacity} muestras",
  "shipment.box.create": "Crear caja",
  "shipment.box.createDescription": "Cree una nueva caja de envío para las muestras referidas",
  "shipment.box.created": "Fecha de creación: ",
  "shipment.box.createdBy": "Creado por:",
  "shipment.box.createdDate": "Fecha de creación",
  "shipment.box.destination": "Destino",
  "shipment.box.downloadLabel": "Descargar etiqueta",
  "shipment.box.downloadManifest": "Descargar el manifiesto",
  "shipment.box.generateLabel": "Generar etiqueta",
  "shipment.box.generateManifest": "Generar manifiesto",
  "shipment.box.id": "ID de caja: ",
  "shipment.box.labelDownloaded": "La etiqueta se ha descargado correctamente",
  "shipment.box.labelPrefix": "Prefijo de la etiqueta",
  "shipment.box.labelPrefixHelper": "Lo configura el administrador en «Configuración del sitio»",
  "shipment.box.manifest": "Manifiesto",
  "shipment.box.manifestDownloaded": "El manifiesto se ha descargado correctamente",
  "shipment.box.noSamples": "Esta caja aún no contiene ninguna muestra",
  "shipment.box.noUnassignedSamples": "No se han encontrado muestras sin asignar para esta instalación",
  "shipment.box.notes": "Notas",
  "shipment.box.notesPlaceholder": "Ingrese aquí cualquier instrucción especial de manipulación o nota...",
  "shipment.box.number": "Número de caja",
  "shipment.box.readyConfirmation": "¿Está seguro de que desea marcar esta caja como lista para enviar?",
  "shipment.box.readySampleCount": "Esta caja contiene {count} muestra(s)",
  "shipment.box.readyToSend": "Marcar como «Listo para enviar»",
  "shipment.box.reconcile": "Conciliar",
  "shipment.box.removeSample": "Eliminar muestra",
  "shipment.box.removeSampleConfirmation": "¿Está seguro de que desea eliminar esta muestra de la caja?",
  "shipment.box.resendManifest": "Reenviar el manifiesto",
  "shipment.box.sampleCount": "Número de muestras",
  "shipment.box.sampleProgress": "{added} / {capacity} (quedan {remaining})",
  "shipment.box.samplesAdded": "Se han agregado muestras",
  "shipment.box.samplesSelected": "{count} Muestra(s) seleccionada(s)",
  "shipment.box.scanExisting": "Escanear existente",
  "shipment.box.scanExistingId": "Escanee o ingrese el ID de caja existente",
  "shipment.box.scanExistingIdPlaceholder": "Escanee el código de barras o ingrese el ID de la caja",
  "shipment.box.sendBox": "Enviar caja",
  "shipment.box.sendConfirmation": "¿Está seguro de que desea enviar esta caja?",
  "shipment.box.sendSampleCount": "Esta caja contiene {count} muestra(s) que se marcarán como enviadas",
  "shipment.box.state": "Estado",
  "shipment.box.summary": "Resumen",
  "shipment.box.temperature": "Requisitos de temperatura",
  "shipment.box.title": "Caja {boxId}",
  "shipment.box.useExistingId": "Modo de identificación de caja",
  "shipment.dashboard.boxNotFound": "No se ha encontrado ninguna caja con el ID «{boxId}». Pruebe a filtrar la lista.",
  "shipment.dashboard.scanBoxPlaceholder": "Busque o escanee el ID de la caja (pulse Intro para navegar)",
  "shipment.error.addSample": "No se ha podido agregar la muestra a la caja",
  "shipment.error.assignToBox": "No se ha podido asignar la muestra a la caja",
  "shipment.error.boxFull": "La caja está llena. No se pueden agregar más muestras.",
  "shipment.error.boxNotEmpty": "La caja debe contener al menos una muestra",
  "shipment.error.boxNotFound": "No se ha encontrado la caja",
  "shipment.error.cancelReferral": "No se ha podido cancelar la referencia",
  "shipment.error.confirmReception": "No se ha podido realizar la confirmación de la recepción",
  "shipment.error.createBox": "No se ha podido crear la caja de envío",
  "shipment.error.exceedsCapacity": "No se pueden agregar muestras «{requested}». Solo hay disponibles ranuras «{available}».",
  "shipment.error.fetchBox": "No se ha podido obtener la información de la caja",
  "shipment.error.fetchBoxes": "No se han podido recuperar las cajas disponibles",
  "shipment.error.generateLabel": "Error al generar la etiqueta de envío",
  "shipment.error.generateManifest": "Error al generar el manifiesto",
  "shipment.error.invalidState": "Estado de la caja no válido para esta operación",
  "shipment.error.markAsLost": "No se ha podido marcar la muestra como perdida",
  "shipment.error.markReady": "No se ha podido marcar la caja como lista para ser enviada",
  "shipment.error.noDestinationFacility": "No se ha especificado ninguna instalación de destino para esta muestra",
  "shipment.error.noReferralId": "No hay ningún ID de referencia disponible para esta muestra",
  "shipment.error.noSampleSelected": "Seleccione al menos una muestra",
  "shipment.error.partialReception": "Se han producido errores en algunas actualizaciones de estado de muestra. Inténtelo de nuevo.",
  "shipment.error.partialSampleAdd": "Solo se añadieron {added} de {total} muestras a la caja. Se dejó como borrador para que pueda añadir el resto.",
  "shipment.error.reasonRequired": "Indique el motivo, por favor",
  "shipment.error.reconcile": "Error al conciliar la caja",
  "shipment.error.removeSample": "No se ha podido eliminar la muestra de la caja",
  "shipment.error.sampleAlreadyAssigned": "Esta muestra ya está asignada a una caja",
  "shipment.error.sampleAlreadyInBox": "La muestra ya se encuentra en la caja",
  "shipment.error.sampleNotFound": "No se ha encontrado la muestra",
  "shipment.error.saveFailed": "Error al guardar",
  "shipment.error.searchFailed": "No se ha podido buscar la muestra. Inténtelo de nuevo.",
  "shipment.error.selectBox": "Seleccione una caja",
  "shipment.error.sendBox": "No se ha podido enviar la caja",
  "shipment.filter.clear": "Limpiar filtros",
  "shipment.filter.dateFrom": "Desde fecha",
  "shipment.filter.dateTo": "Hasta fecha",
  "shipment.filter.referenceLab": "Laboratorio de Referencia",
  "shipment.label.addedDate": "Agregar fecha",
  "shipment.label.position": "Cargo",
  "shipment.label.samples": "Muestras",
  "shipment.label.shippingLabel": "ETIQUETA DE ENVÍO",
  "shipment.manifest.generated": "Generado:",
  "shipment.manifest.number": "#",
  "shipment.manifest.recallExpired": "Ya no es posible solicitar la recuperación del manifiesto (se ha superado el plazo de 7 días desde el envío)",
  "shipment.manifest.regenerationExpired": "La regeneración del manifiesto ya no está disponible (se ha superado el límite de 24 horas desde el envío)",
  "shipment.manifest.serviceLocation": "Ubicación del servicio:",
  "shipment.manifest.specimenBarcodes": "Códigos de barras de muestra",
  "shipment.manifest.title": "Manifiesto de embarque",
  "shipment.manifest.totalSamples": "Total de muestras:",
  "shipment.modal.addToBox.existingBox": "Agregar a una caja existente",
  "shipment.modal.addToBox.mode": "Seleccione una opción",
  "shipment.modal.addToBox.newBox": "Crear una nueva caja",
  "shipment.modal.addToBox.newBoxInfo.message": "Se le redirigirá para que cree una nueva caja para esta muestra",
  "shipment.modal.addToBox.newBoxInfo.title": "Crear una nueva caja",
  "shipment.modal.addToBox.noDraftBoxes.message": "No se han encontrado cajas en borrador para este destino. Se creará una nueva caja.",
  "shipment.modal.addToBox.noDraftBoxes.title": "No hay cajas en borrador disponibles",
  "shipment.modal.addToBox.selectBox": "Seleccionar caja",
  "shipment.modal.addToBox.title": "Agregar muestra a la caja",
  "shipment.modal.cancelReferral.reason": "Motivo de la cancelación",
  "shipment.modal.cancelReferral.reasonPlaceholder": "Explique por qué se cancela esta referencia...",
  "shipment.modal.cancelReferral.title": "Cancelar la referencia",
  "shipment.modal.cancelReferral.warning.message": "Esta acción cancelará definitivamente la referencia y no se podrá deshacer.",
  "shipment.modal.cancelReferral.warning.title": "Advertencia",
  "shipment.modal.createBox.cancel": "Cancelar",
  "shipment.modal.createBox.submit": "Crear",
  "shipment.modal.createBox.title": "Crear un nuevo cuadro",
  "shipment.modal.markAsLost.reason": "Motivo por el que se ha marcado como perdido",
  "shipment.modal.markAsLost.reasonPlaceholder": "Le ruego que explique por qué se ha marcado esta muestra como perdida...",
  "shipment.modal.markAsLost.title": "Marcar muestra como perdida",
  "shipment.modal.markAsLost.warning.message": "Esta acción marcará de forma permanente la muestra como perdida y no se podrá deshacer.",
  "shipment.modal.markAsLost.warning.title": "Advertencia",
  "shipment.modal.rejectSample": "Rechazar muestra",
  "shipment.modal.rejectSampleMessage": "¿Está seguro de que desea rechazar la muestra {accession}?",
  "shipment.nav.referenceLabResults": "Resultados del Laboratorio de Referencia",
  "shipment.nav.reports": "Informes",
  "shipment.nav.settings": "Configuración",
  "shipment.notification.boxCreated": "La caja se ha creado correctamente",
  "shipment.notification.boxReadyToSend": "Caja marcada como «Lista para enviar»",
  "shipment.notification.boxReconciled": "La caja se ha conciliado correctamente",
  "shipment.notification.boxSent": "La caja se ha enviado correctamente",
  "shipment.notification.error": "Se ha producido un error: {message}",
  "shipment.notification.partialSamplesAdded": "Solo se han añadido muestras de {added} y {total}. Se ha alcanzado la capacidad máxima del buzón (no se ha añadido {notAdded}).",
  "shipment.notification.receptionComplete": "El envío se ha recibido correctamente",
  "shipment.notification.referralCancelled": "La referencia se ha cancelado correctamente",
  "shipment.notification.sampleAdded": "Muestra {accessionNumber} añadida con {testCount, plural, one {# prueba} other {# pruebas}}",
  "shipment.notification.sampleAssignedToBox": "La muestra se ha asignado correctamente a la caja",
  "shipment.notification.sampleMarkedAsLost": "Muestra marcada como perdida",
  "shipment.notification.sampleRejected": "Muestra {accession} rechazada: {reason}",
  "shipment.notification.sampleRemoved": "Muestra eliminada de la caja",
  "shipment.notification.samplesAdded": "{count, plural, one {# sample added to box} many {# samples added to box} other {# muestras añadidas a la caja}}",
  "shipment.notification.samplesRemovedDueToCapacity": "{removed} muestra(s) eliminada(s) debido a la reducción de capacidad.",
  "shipment.reception.acceptSample": "Aceptar muestra",
  "shipment.reception.applyToAll": "Aplicar el estado a todos...",
  "shipment.reception.awaitingAcceptance": "A la espera de su aceptación",
  "shipment.reception.confirmMessage": "¿Confirma la recepción de {count} muestra(s)?",
  "shipment.reception.confirmReception": "Confirmar recepción",
  "shipment.reception.damaged": "Dañado",
  "shipment.reception.description": "Escanee el código de barras de la caja para recibir y verificar las muestras",
  "shipment.reception.enterBoxId": "Ingrese un ID de caja",
  "shipment.reception.generalNotes": "Notas generales",
  "shipment.reception.generalNotesPlaceholder": "Ingrese las notas generales de recepción",
  "shipment.reception.importError": "Error al importar envíos desde un servidor remoto",
  "shipment.reception.importFromFhir": "Importar desde FHIR",
  "shipment.reception.importResult": "{count, plural, =0 {No se encontraron nuevos envíos} one {1 envío importado} other {{count} envíos importados}}",
  "shipment.reception.incomingBoxes": "Envíos entrantes",
  "shipment.reception.leaked": "Con fuga",
  "shipment.reception.markAllMissing": "Marcar todas como faltantes",
  "shipment.reception.markAllReceived": "Marcar todas como recibidas",
  "shipment.reception.missing": "Faltante",
  "shipment.reception.noIncomingBoxes": "No hay envíos entrantes. Haga clic en «Importar desde FHIR» para comprobar si hay nuevos envíos.",
  "shipment.reception.notes": "Notas",
  "shipment.reception.notesPlaceholder": "Ingrese notas si es necesario",
  "shipment.reception.notesRequired": "Es necesario adjuntar notas en el caso de las muestras que no se hayan recibido en buen estado",
  "shipment.reception.notesRequiredPlaceholder": "Obligatorio: describa el problema",
  "shipment.reception.openBox": "Abrir",
  "shipment.reception.originFacility": "Desde",
  "shipment.reception.pending": "Pendiente",
  "shipment.reception.pendingAcceptance": "Muestras pendientes de aceptación",
  "shipment.reception.received": "Recibido",
  "shipment.reception.referralOrder": "Orden de referencia",
  "shipment.reception.rejected": "Rechazado",
  "shipment.reception.sampleCountSummary": "{accepted} aceptadas / {expected} esperadas",
  "shipment.reception.sampleNotFound": "No se ha encontrado la muestra «{accessionNumber}» en esta caja.",
  "shipment.reception.sampleScanned": "Se ha registrado la muestra «{accessionNumber}» como recibida",
  "shipment.reception.sampleVerification": "Verificación de muestras",
  "shipment.reception.scanBox": "ID de caja / Código de barras",
  "shipment.reception.scanBoxPlaceholder": "Escanee o ingrese el código de barras de la caja",
  "shipment.reception.scanButton": "Escanear caja",
  "shipment.reception.scanSample": "Escanear el ID de la muestra",
  "shipment.reception.scanSampleButton": "Registrar entrada de muestra",
  "shipment.reception.scanSamplePlaceholder": "Escanee o ingrese el número de laboratorio de la muestra",
  "shipment.reception.shipped": "Enviado",
  "shipment.reception.specimen": "Muestra",
  "shipment.reception.status": "Estado de la recepción",
  "shipment.reception.title": "Recibir el envío",
  "shipment.reception.unresolved": "No hay órdenes que coincidan",
  "shipment.rejection.damaged": "Dañado",
  "shipment.rejection.expired": "Caducado",
  "shipment.rejection.insufficientVolume": "Volumen insuficiente",
  "shipment.rejection.other": "Otros",
  "shipment.rejection.reason": "Motivo de rechazo",
  "shipment.rejection.wrongType": "Tipo de muestra incorrecto",
  "shipment.report.contents": "Contenido",
  "shipment.report.description": "Genera y exporta informes de envíos por caja, fecha, destino o Laboratorio de Referencia",
  "shipment.report.export.excel": "Exportar a Excel",
  "shipment.report.export.pdf": "Exportar a PDF",
  "shipment.report.generate": "Generar Reporte",
  "shipment.report.noResults": "No se han encontrado registros de envíos que se ajusten a los filtros seleccionados",
  "shipment.report.receivedDate": "Fecha de recepción",
  "shipment.report.receivedStatus": "Estado de recepción",
  "shipment.report.receiver": "Receptor",
  "shipment.report.receivingUser": "Usuario receptor",
  "shipment.report.sender": "Remitente",
  "shipment.report.sentDate": "Fecha de Envío",
  "shipment.report.title": "Informes de envíos",
  "shipment.report.totalBoxes": "Total de cajas",
  "shipment.report.totalSamples": "Total de muestras",
  "shipment.sample.accessionNumber": "Número de acceso",
  "shipment.sample.multipleMatches": "Hay varias muestras que coinciden: seleccione cuál desea agregar",
  "shipment.sample.remove": "Eliminar",
  "shipment.sample.search": "Buscar muestra por número de laboratorio",
  "shipment.sample.searchPlaceholder": "Escanee o ingrese el número de acceso",
  "shipment.sample.status": "Estado",
  "shipment.sample.type": " Tipo de muestra",
  "shipment.settings.administration": "Administración",
  "shipment.settings.boxLabelSection": "Configuración de la etiqueta de la caja",
  "shipment.settings.description": "Configurar los ajustes del módulo de envíos",
  "shipment.settings.fhirConfig": "Opciones de asignación FHIR",
  "shipment.settings.fhirConfigDesc": "Configure la asignación de SupplyDelivery y los tipos de recipientes de muestra para la interoperabilidad FHIR",
  "shipment.settings.fhirConfigNote": "La asignación FHIR se configura a través de las Propiedades de la aplicación. Póngase en contacto con su administrador del sistema para realizar cambios.",
  "shipment.settings.fhirConfigSaveError": "Error al guardar la configuración de asignación FHIR",
  "shipment.settings.fhirConfigSaved": "Se ha guardado la configuración de asignación FHIR",
  "shipment.settings.fhirContainerType": "Tipo de recipiente para muestras (SNOMED CT)",
  "shipment.settings.fhirDisplayName": "Nombre para mostrar",
  "shipment.settings.fhirNonConformity": "Códigos de no conformidad (SNOMED CT)",
  "shipment.settings.fhirSnomedCode": "Código SNOMED CT",
  "shipment.settings.manageFacilities": "Gestionar el registro de instalaciones",
  "shipment.settings.manageFacilitiesDesc": "Agregar, editar o eliminar destinos de laboratorios de referencia",
  "shipment.settings.manageUsers": "Gestionar usuarios",
  "shipment.settings.manageUsersDesc": "Configure las cuentas de usuario y las funciones para el módulo de envíos",
  "shipment.settings.prefixHelperText": "Prefijo utilizado al generar nuevos identificadores de caja (por ejemplo: BOX, SHIP, LAB)",
  "shipment.settings.prefixPlaceholder": "BOX",
  "shipment.settings.prefixPreview": "Vista previa: {preview}",
  "shipment.settings.prefixRequired": "Es obligatorio introducir el prefijo de la etiqueta de la caja",
  "shipment.settings.prefixSaveError": "Error al guardar el prefijo de la etiqueta de la caja",
  "shipment.settings.prefixSaved": "El prefijo de la etiqueta de la caja se ha guardado exitosamente",
  "shipment.settings.siteOrgDescription": "Seleccione la organización que representa a este laboratorio. Solo se importarán de los servidores FHIR remotos los envíos destinados a dicha organización.",
  "shipment.settings.siteOrgLabel": "Este laboratorio",
  "shipment.settings.siteOrgSaveError": "Error al guardar la organización del sitio",
  "workflow.clinical": "Clínico",
  "workflow.environmental": "Medio ambiente / Otros",
  "provider.name": "Nombre del proveedor",
  "provider.name.placeholder": "Ingrese el nombre del proveedor",
  "provider.phone": "Teléfono del proveedor",
  "provider.search.helper": "Ingrese el nombre o el número de teléfono del proveedor y pulse «Buscar».",
  "site.search": "Buscar sitio",
  "site.name": " Nombre del sitio",
  "site.name.placeholder": "Ingrese el nombre del sitio",
  "site.location": "Ubicación",
  "site.type": "Tipo",
  "site.department": "Departamento / Servicio / Unidad",
  "site.department.selectFirst": "Seleccione primero la instalación...",
  "site.department.choose": "Seleccione un departamento...",
  "site.department.none": "No hay subunidades disponibles",
  "sample.filterByLabUnit": "Filtrar por unidad de laboratorio",
  "sample.allLabUnits": "Todos los números de laboratorio",
  "sample.orderPanels": "Ordenar Paneles",
  "sample.orderTests": " Solicitar pruebas",
  "sample.referToReferenceLab": "Referir prueba a un laboratorio de referencia",
  "sample.optional.info": "Las pruebas pueden esperar: «Guardar y salir» conserva la orden sin ellas. «Guardar y siguiente» requiere al menos una prueba en cada muestra.",
  "panel.search.placeholder": " Elegir panel disponible",
  "test.search.placeholder": " Elegir prueba disponible",
  "test.timeHolding": "Tiempo máximo de retención según el procedimiento operativo estándar (minutos)",
  "select.regimen": "Seleccione un tratamiento...",
  "select": "Seleccionar...",
  "generating": "Generando...",
  "label.order": "Etiqueta de orden",
  "label.sample": "Etiqueta de muestra",
  "label.slide": "Etiqueta de la diapositiva",
  "label.block": "Etiqueta de bloque",
  "label.freezer": "Etiqueta para el congelador",
  "environmental.coming.soon": "Flujo de trabajo medioambiental",
  "environmental.location.info": "En esta sección estarán disponibles los campos de jerarquía de ubicaciones (Región/Distrito/Ciudad-Aldea) y los datos de localización por GPS.",
  "env.collectionConditions.title": "Condiciones de recolección predeterminadas",
  "env.collectionConditions.subtitle": "Se han aplicado los valores por defecto a todas las muestras de este lote.",
  "env.collectionMethod": "Método de recolección",
  "env.waterTemp": "Temperatura del agua (°C)",
  "env.ambientTemp": "Temperatura ambiente (°C)",
  "env.weather": "Clima",
  "env.preservationMethod": "Método de conservación",
  "env.preservationMethod.placeholder": "p. ej., acidificación con HNO₃, refrigerador a 4 °C",
  "env.fieldNotes": "Notas de campo",
  "env.fieldNotes.placeholder": "Introduzca las observaciones de campo...",
  "env.sample.manifest.title": "Manifiesto por muestra",
  "env.sample.manifest.subtitle": "una fila = una muestra física",
  "env.sample.container": "Contenedor",
  "env.sample.gpsLat": "Latitud GPS",
  "env.sample.gpsLat.placeholder": "p. ej., -6,2088",
  "env.sample.gpsLng": "Longitud GPS",
  "env.sample.gpsLng.placeholder": "p. ej., 106,8456",
  "env.sample.samplingSite": "Punto de muestreo",
  "env.sample.useOrderSite": "Use order site {site}",
  "order.microPreview.site": "Site: {site}",
  "env.sample.locationDetails": "Detalles de la ubicación",
  "env.sample.locationDetails.placeholder": "p. ej., entrada, orilla...",
  "env.sample.collected": "Recolectado",
  "env.sample.duplicate": "Muestra duplicada",
  "env.sample.addRow": "+ Agregar una fila de muestra",
  "env.sample.total": "Total: {count} {count, plural, one {muestra} other {muestras}} en este lote",
  "env.sample.testsAndPanels": "Pruebas y paneles",
  "env.sample.tests.required": "obligatorio",
  "env.complianceStandards.title": "Normas de cumplimiento aplicables",
  "env.complianceStandards.subtitle": "Seleccione las normas reglamentarias que se aplican a esta orden.",
  "env.complianceStandards.label": "Normas de cumplimiento",
  "env.complianceStandards.placeholder": "Seleccione las normas...",
  "env.complianceStandards.empty": "No hay normas de cumplimiento activas configuradas. Agréguelas en «Administración» → «Normas de cumplimiento».",
  "order.dashboard.samplingSite": "Sitio de muestreo",
  "order.search.placeholder.env": "Buscar por nombre del sitio o número de laboratorio...",
  "order.filter.dateFrom": "Desde",
  "order.filter.dateTo": "Hasta",
  "program.placeholder": "Escriba para filtrar o seleccione de la lista",
  "program.helper": "Escriba para filtrar o seleccione de la lista. Al seleccionar un programa, se mostrarán a continuación sus campos específicos de «Información adicional de la orden».",
  "patient.externalSearch": "Búsqueda externa",
  "patient.results": "Resultados de los pacientes",
  "patient.id.helper": "Introduzca el número de sujeto, el ID Nacional o el número ST.",
  "patient.id.placeholder": " Ingrese ID del paciente",
  "patient.lastName.placeholder": " Ingrese apellido del paciente",
  "patient.firstName.placeholder": " Ingrese nombre del paciente",
  "patient.natId": "Identificador sanitario único",
  "patient.dataSource": "Fuente de datos",
  "patient.noResults": "0-0 de 0 elementos",
  "patient.new.info": "Introduzca a continuación la información del nuevo paciente. El paciente se creará al guardar la orden.",
  "pagination.showing": "Mostrando {start}-{end} de las pruebas de {total}",
  "results.found.for": "Resultados encontrados para «{term}»",
  "selected": "Seleccionado",
  "shipment.settings.siteOrgSaved": "Se ha guardado la organización del sitio (UUID de FHIR: {uuid})",
  "shipment.settings.siteOrgSection": "Organización del sitio (FHIR)",
  "shipment.settings.title": "Configuración de envíos",
  "shipment.state.cancelled": "Cancelado",
  "shipment.state.draft": "Borrador",
  "shipment.state.inTransit": "En tránsito",
  "shipment.state.lostInTransit": "Perdido durante el transporte",
  "shipment.state.partiallyReceived": "Recibido parcialmente",
  "shipment.state.readyToSend": "Listo para enviar",
  "shipment.state.received": "Recibido",
  "shipment.state.reconciled": "Reconciliado",
  "shipment.state.sent": "Enviado",
  "shipment.stats.delivered": "Entregado",
  "shipment.stats.inTransit": "En tránsito",
  "shipment.stats.reconciled": "Reconciliado",
  "shipment.stats.totalSamples": "Total de muestras",
  "shipment.temperature.ambient": "Temperatura ambiente (temperatura de la habitación)",
  "shipment.temperature.deepFrozen": "Ultracongelado (-80 °C)",
  "shipment.temperature.dryIce": "Hielo seco",
  "shipment.temperature.frozen": "Congelado (-20 °C)",
  "shipment.temperature.refrigerated": "Refrigerado (2-8 °C)",
  "shipment.validation.addSample": "Agregue al menos una muestra",
  "shipment.validation.selectDestination": "Seleccione una instalación de destino",
  "qc.dashboard.title": "Panel de control de calidad",
  "qc.dashboard.lastUpdate": "Última actualización",
  "qc.dashboard.complianceStatus": "Estado de cumplimiento",
  "qc.dashboard.compliant": "Conforme",
  "qc.dashboard.warning": "Advertencia",
  "qc.dashboard.nonCompliant": "No conforme",
  "qc.dashboard.violationsCount": "{count} infracciones",
  "qc.dashboard.lastResult": "Último resultado",
  "qc.dashboard.noInstruments": "No hay instrumentos configurados",
  "qc.dashboard.subtitle": "Supervisar el estado del control de calidad de los instrumentos y las alertas",
  "qc.dashboard.loading": "Cargando los datos del Panel...",
  "qc.dashboard.refresh": "Actualizar",
  "qc.dashboard.lastUpdated": "Última actualización",
  "qc.dashboard.export.title": "Export QC Data",
  "qc.dashboard.export.selectInstrument": "Select an instrument",
  "qc.dashboard.export.dateError": "End date must be on or after the start date.",
  "qc.dashboard.error.title": "Error",
  "qc.dashboard.error.loadFailed": "No se han podido cargar los datos del Panel. Inténtelo de nuevo.",
  "qc.dashboard.tab.instruments": "Instrumentos",
  "qc.dashboard.tab.alerts": "Alertas",
  "qc.dashboard.summary.inControl": "Instrumentos bajo control",
  "qc.dashboard.summary.warningStatus": "Estado de alerta",
  "qc.dashboard.summary.outOfControl": "Fuera de control",
  "qc.dashboard.summary.passRate": "% de instrumentos bajo control",
  "qc.dashboard.summary.ofTotal": "{percentage}% del total de instrumentos",
  "qc.dashboard.instruments.title": "Estado del control de calidad de los instrumentos",
  "qc.dashboard.instruments.subtitle": "Supervisar el estado de cumplimiento y el rendimiento del CC de todos los instrumentos de laboratorio",
  "qc.dashboard.instruments.search": "Buscar instrumentos...",
  "qc.dashboard.instruments.col.id": "Identificador del instrumento",
  "qc.dashboard.instruments.col.name": "Nombre del instrumento",
  "qc.dashboard.instruments.col.type": "Tipo",
  "qc.dashboard.instruments.col.location": "Ubicación",
  "qc.dashboard.instruments.col.status": "Estado",
  "qc.dashboard.instruments.col.analytes": "Analitos",
  "qc.dashboard.instruments.col.violations": "Infracciones recientes",
  "qc.dashboard.instruments.col.lastUpdate": "Última actualización",
  "qc.dashboard.instruments.col.actions": "Acciones",
  "qc.dashboard.instruments.view": "Consultar",
  "qc.dashboard.instruments.status.green": "Bajo control",
  "qc.dashboard.instruments.status.yellow": "Advertencia",
  "qc.dashboard.instruments.status.red": "Fuera de control",
  "qc.dashboard.instruments.status.notConfigured": "No está configurado",
  "qc.dashboard.instruments.status.unknown": "Desconocido",
  "qc.dashboard.instruments.noViolations": "No se han producido infracciones",
  "qc.dashboard.instruments.empty": "No se han encontrado instrumentos",
  "qc.dashboard.alerts.title": "Infracciones y alertas de CC",
  "qc.dashboard.alerts.subtitle": "Mostrando las infracciones de los últimos {period}",
  "qc.dashboard.alerts.timePeriod": "Período de tiempo",
  "qc.dashboard.alerts.timePeriod.24h": "Últimas 24 horas",
  "qc.dashboard.alerts.timePeriod.72h": "Últimas 72 horas",
  "qc.dashboard.alerts.timePeriod.7d": "Últimos 7 días",
  "qc.dashboard.alerts.timePeriod.30d": "Últimos 30 días",
  "qc.dashboard.alerts.timePeriod.all": "De todos los tiempos",
  "qc.dashboard.alerts.active": "Infracciones activas de CC",
  "qc.dashboard.alerts.active.count": "{count} infracciones sin confirmar que requieren atención",
  "qc.dashboard.alerts.active.empty": "No hay infracciones en curso",
  "qc.dashboard.alerts.acknowledge": "Confirmar",
  "qc.dashboard.alerts.acknowledged": "Infracciones confirmadas",
  "qc.dashboard.alerts.acknowledged.count": "Se han confirmado {count} infracciones",
  "qc.dashboard.alerts.acknowledged.empty": "No hay infracciones confirmadas",
  "qc.dashboard.alerts.col.severity": " Severidad",
  "qc.dashboard.alerts.col.time": "Hora",
  "qc.dashboard.alerts.col.instrument": "Instrumento",
  "qc.dashboard.alerts.col.analyte": "Analito",
  "qc.dashboard.alerts.col.rule": "Regla",
  "qc.dashboard.alerts.col.acknowledgedBy": "Confirmado por",
  "qc.dashboard.alerts.col.acknowledgedDate": "Fecha de confirmación",
  "qc.dashboard.banner.title": "{count} active QC violation(s) require attention",
  "qc.dashboard.banner.viewAll": "View all alerts",
  "qc.violations.error.acknowledgeFailed": "Failed to acknowledge violation",
  "qc.chart.axis.date": "Fecha/Hora",
  "qc.chart.axis.run": "Run",
  "qc.chart.axis.value": "Desviaciones estándar (σ)",
  "qc.instrument.notFound": "Instrument not found",
  "qc.chart.stats.sd": "SD",
  "qc.chart.stats.cv": "CV",
  "qc.chart.stats.sigma": "Sigma performance",
  "qc.chart.sigma.notCalculable": "Not calculable — TEa not configured",
  "qc.chart.sigma.bias": "Bias not applied (no peer data)",
  "qc.chart.sigma.WORLD_CLASS": "World-class",
  "qc.chart.sigma.ACCEPTABLE": "Aceptable",
  "qc.chart.sigma.MARGINAL": "Marginal",
  "qc.chart.sigma.POOR": "Poor",
  "qc.chart.title": "Quality Control Chart",
  "qc.chart.loading": "Loading control chart…",
  "qc.chart.error.title": "Unable to load control chart",
  "qc.chart.tabs.label": "Control chart levels",
  "qc.chart.filter.allLevels": "All levels",
  "qc.chart.filter.selectLot": "Select lot",
  "qc.chart.action.zoomIn": "Zoom in",
  "qc.chart.action.zoomOut": "Zoom out",
  "qc.chart.action.zoomReset": "Reset zoom",
  "qc.chart.legend.normal": "Normal",
  "qc.chart.legend.violation": "Infracción",
  "qc.chart.mean": "Media",
  "qc.chart.noData": "No hay datos de CC disponibles",
  "qc.chart.tooltip.date": "Fecha",
  "qc.chart.tooltip.value": "Valor",
  "qc.chart.tooltip.violations": "Infracciones",
  "qc.chart.tooltip.zScore": "Puntuación Z",
  "qc.charts.title": "Gráficos de control",
  "qc.charts.leveyJennings": "Gráfico de Levey-Jennings",
  "qc.charts.dateRange": "Rango de fechas",
  "qc.charts.controlLevel": "Nivel de control",
  "qc.charts.export": "Exportar gráfico",
  "qc.charts.noData": "No hay datos de QC disponibles",
  "qc.violations.title": "Incumplimientos en el QC",
  "qc.violations.severity": " Severidad",
  "qc.violations.rule": "Regla",
  "qc.violations.date": "Fecha",
  "qc.violations.status": "Estado",
  "qc.violations.unresolved": "Sin resolver",
  "qc.violations.resolved": "Resuelto",
  "qc.violations.acknowledged": "Reconocido",
  "qc.correctiveActions.title": "Acciones correctivas",
  "qc.correctiveActions.create": "Crear una acción correctiva",
  "qc.correctiveActions.type": " Tipo de acción",
  "qc.correctiveActions.description": "Descripción",
  "qc.correctiveActions.assignedTo": "Asignado a",
  "qc.correctiveActions.status": "Estado",
  "qc.correctiveActions.pending": "Pendiente",
  "qc.correctiveActions.inProgress": "En progreso",
  "qc.correctiveActions.completed": "Completado",
  "qc.correctiveActions.resolutionNotes": "Notas sobre la resolución",
  "qc.alerts.title": "Alertas de QC",
  "qc.alerts.markAsRead": "Marcar como leído",
  "qc.alerts.viewDetails": "Consultar detalles",
  "qc.rules.title": "Configuración de las reglas de Westgard",
  "qc.rules.enable": "Habilitar",
  "qc.rules.disable": "Desactivar",
  "qc.rules.preset": "Configuración preestablecida",
  "qc.rules.basic": "Básico",
  "qc.rules.standard": "Estándar",
  "qc.rules.comprehensive": "Exhaustivo",
  "qc.rules.1₂ₛ.description": "Uno de los controles supera ±2 DE",
  "qc.rules.1₃ₛ.description": "Uno de los controles supera ±3 DE",
  "qc.rules.2₂ₛ.description": "Dos controles consecutivos superan ±2 DE en la misma dirección",
  "qc.rules.R₄ₛ.description": "El rango entre dos controles supera las 4 desviaciones estándar",
  "qc.rules.4₁ₛ.description": "Cuatro controles consecutivos superan ±1 DE en la misma dirección",
  "qc.rules.10ₓ.description": "Diez controles consecutivos en el mismo lado de la media",
  "qc.rules.3₁ₛ.description": "Tres controles consecutivos superan ±1 DE en la misma dirección",
  "qc.rules.7ₜ.description": "Siete controles consecutivos que siguen la misma tendencia",
  "qc.ruleConfig.title": "Configuración de reglas",
  "qc.ruleConfig.subtitle": "Configurar las reglas de Westgard por combinación de analizador y prueba",
  "qc.ruleConfig.field.analyzer": "Analizador",
  "qc.ruleConfig.field.selectAnalyzer": "Seleccione un analizador",
  "qc.ruleConfig.field.test": "Prueba",
  "qc.ruleConfig.field.selectTest": "Seleccione una prueba",
  "qc.ruleConfig.field.severity": " Severidad",
  "qc.ruleConfig.severity.warning": "Advertencia",
  "qc.ruleConfig.severity.rejection": "Rechazo",
  "qc.ruleConfig.category.rejection": "Reglas de rechazo",
  "qc.ruleConfig.category.warning": "Reglas de advertencia",
  "qc.ruleConfig.action.reset": "Restablecer los valores predeterminados",
  "qc.ruleConfig.loading": "Cargando la configuración de las reglas...",
  "qc.ruleConfig.prompt.selectAnalyzerTest": "Seleccione un analizador y una prueba para configurar las reglas de Westgard.",
  "qc.ruleConfig.error.title": "Error",
  "qc.ruleConfig.error.selectAnalyzerTest": "Seleccione tanto un analizador como una prueba.",
  "qc.ruleConfig.error.saveFailed": "No se ha podido guardar la configuración de la regla.",
  "qc.ruleConfig.success.title": "Éxito",
  "qc.ruleConfig.success.saved": "La configuración de la regla se ha guardado exitosamente.",
  "qc.ruleConfig.table.title": "Conjuntos de reglas configurados",
  "qc.ruleConfig.table.empty": "No se han encontrado configuraciones de reglas.",
  "qc.ruleConfig.field.enabledRules": "Reglas activadas",
  "qc.ruleConfig.unconfigured.title": "Asignaciones de controles sin configurar",
  "qc.ruleConfig.unconfigured.subtitle": "Lotes de control sin configuraciones de la regla de Westgard",
  "qc.ruleConfig.unconfigured.configure": "Configurar",
  "qc.ruleConfig.unconfigured.activeLots": "Lotes activos",
  "qc.ruleConfig.modal.title.edit": "Editar la configuración de las reglas",
  "qc.ruleConfig.modal.title.create": "Crear configuración de regla",
  "button.saving": "Guardando...",
  "qc.controlLots.title": "Lotes de control",
  "qc.controlLots.create": "Crear lote de control",
  "qc.controlLots.productName": "Nombre del producto",
  "qc.controlLots.lotNumber": "Número de lote",
  "qc.controlLots.level": "Nivel de control",
  "qc.controlLots.statisticsMethod": "Método de cálculo de las estadísticas",
  "qc.controlLots.initialRuns": "Primeras tiradas",
  "qc.controlLots.rolling": "Ventana móvil",
  "qc.controlLots.manufacturerFixed": "Fabricante: Fixed",
  "qc.controlLots.activationDate": "Fecha de activación",
  "qc.controlLots.expirationDate": "Fecha de caducidad",
  "qc.controlLots.status.active": "Activo",
  "qc.controlLots.status.establishment": "Fundación",
  "qc.controlLots.status.expired": "Caducado",
  "qc.controlLots.subtitle": "Gestionar los lotes de control de CC para la evaluación de la regla de Westgard",
  "qc.controlLots.empty": "No se han encontrado lotes de control",
  "qc.controlLot.filter.allStatuses": "Todos los estados",
  "qc.controlLot.status.establishment": "Establecimiento",
  "qc.controlLot.status.active": "Activo",
  "qc.controlLot.status.expired": "Caducado",
  "qc.controlLot.field.lotNumber": "Número de lote",
  "qc.controlLot.field.lotNumberPlaceholder": "Ingrese el número de lote",
  "qc.controlLot.field.material": "Material de control",
  "qc.controlLot.field.materialPlaceholder": "Ingrese el nombre del material",
  "qc.controlLot.field.manufacturer": "Fabricante",
  "qc.controlLot.field.level": "Nivel de control",
  "qc.controlLot.field.selectLevel": "Seleccione el nivel",
  "qc.controlLot.field.expiration": "Fecha de caducidad",
  "qc.controlLot.field.analyzer": "Analizador",
  "qc.controlLot.field.selectAnalyzer": "Seleccione un analizador",
  "qc.controlLot.field.analyzerHelper": "Optional. Choose \"Bench / no analyzer\" for a manual method run at the bench without an instrument.",
  "qc.controlLot.analyzer.bench": "Bench / no analyzer (manual method)",
  "qc.controlLot.field.test": "Prueba",
  "qc.controlLot.field.selectTest": "Seleccione una prueba",
  "qc.controlLot.field.isActive": "Estado",
  "qc.controlLot.field.inactive": "Inactivo",
  "qc.controlLot.field.active": "Activo",
  "qc.controlLot.field.status": "Estado",
  "qc.controlLot.loading": "Cargando",
  "qc.controlLot.error.title": "Error",
  "qc.controlLot.error.saveFailed": "No se ha podido guardar el lote de control",
  "qc.controlLot.error.statsRequired": "Manufacturer-fixed lots need a mean and standard deviation. Click \"Configure\" to enter them before saving.",
  "qc.controlLot.error.benchNeedsFixedStats": "A bench lot has no analyzer accumulating runs, so it must use manufacturer-fixed statistics. Click \"Configure\" to enter a mean and standard deviation, or select an analyzer for this lot.",
  "qc.controlLot.new.title": "Nuevo lote de control",
  "qc.controlLot.viewChart": "View chart",
  "qc.controlLot.new.subtitle": "Crear un nuevo lote de control de CC",
  "qc.controlLot.edit.title": "Editar lote de control",
  "qc.controlLot.edit.subtitle": "Actualizar la configuración del lote de control",
  "qc.controlLot.validation.lotNumberRequired": "Es necesario indicar el número de lote",
  "qc.controlLot.validation.materialRequired": "Se necesita material",
  "qc.controlLot.validation.levelRequired": "Se requiere un nivel de control",
  "qc.controlLot.validation.expirationRequired": "Es obligatorio indicar la fecha de caducidad",
  "qc.controlLot.validation.analyzerRequired": "Es necesario disponer de un analizador",
  "qc.controlLot.validation.testRequired": "La prueba es obligatoria",
  "qc.controlLot.level.low": "Bajo",
  "qc.controlLot.level.normal": "Normal",
  "qc.controlLot.level.high": "Alto",
  "qc.controlLot.statistics.title": "Configuración de estadísticas",
  "qc.controlLot.statistics.configure": "Configurar",
  "qc.controlLot.statistics.method": "Método de cálculo",
  "qc.controlLot.statistics.mean": "Media",
  "qc.controlLot.statistics.sd": "Desviación estándar",
  "qc.controlLot.statistics.config.title": "Configuración de estadísticas",
  "qc.controlLot.statistics.config.label": "Configurar el método de cálculo de estadísticas",
  "qc.controlLot.statistics.method.manufacturer_fixed": "Fijo del fabricante",
  "qc.controlLot.statistics.method.manufacturer_fixed.description": "Utilice los valores de media y desviación estándar facilitados por el fabricante",
  "qc.controlLot.statistics.method.rolling": "Ventana móvil",
  "qc.controlLot.statistics.method.rolling.description": "Volver a calcular desde los N resultados más recientes",
  "qc.controlLot.statistics.method.initial_runs": "Ejecuciones iniciales",
  "qc.controlLot.statistics.method.initial_runs.description": "Calcular una sola vez a partir de las primeras N ejecuciones de establecimiento",
  "qc.controlLot.statistics.manufacturerValues": "Valores del fabricante",
  "qc.controlLot.statistics.rollingConfig": "Configuración de ventana móvil",
  "qc.controlLot.statistics.windowSize": "Tamaño de la ventana",
  "qc.controlLot.statistics.windowSize.helper": "Número de resultados recientes que se deben incluir en el cálculo",
  "qc.controlLot.statistics.initialRunsConfig": "Configuración de las ejecuciones iniciales",
  "qc.controlLot.statistics.initialRunsRequired": "Ejecuciones necesarias",
  "qc.controlLot.statistics.initialRunsRequired.helper": "Número de ejecuciones de establecimiento antes de calcular las estadísticas",
  "qc.instrumentDetail.analytesMonitored": "Analitos monitoreados",
  "qc.instrumentDetail.analyte.cv": "Currículum: {value}%",
  "qc.instrumentDetail.analyte.violations": "{count, plural, one {# violation} many {# violations} other {# infracciones}}",
  "qc.instrumentDetail.tab.activityTimeline": "Cronología de actividades",
  "qc.instrumentDetail.tab.controlChart": "Gráfico de control",
  "qc.instrumentDetail.timeline.empty": "No se han registrado alertas ni acciones correctivas para el periodo seleccionado",
  "qc.instrumentDetail.timeline.violation": "Infracción",
  "qc.instrumentDetail.timeline.correctiveAction": "Acciones correctivas",
  "qc.instrumentDetail.timeline.loading": "Cargando la cronología de actividades...",
  "qc.instrumentDetail.chart.selectAnalyte": "Seleccione el analito",
  "qc.instrumentDetail.chart.loading": "Cargando el gráfico de control...",
  "qc.instrumentDetail.chart.noData": "No hay datos de CC disponibles para este analito",
  "qc.instrumentDetail.chart.activeRules": "Reglas de CC activas",
  "qc.instrumentDetail.chart.noRules": "No hay reglas activas configuradas",
  "qc.instrumentDetail.chart.stats.cv": "CV%",
  "qc.instrumentDetail.chart.stats.mean": "Media (x̄)",
  "qc.instrumentDetail.chart.stats.n": "N",
  "qc.instrumentDetail.chart.stats.sd": "Desviación estándar (s)",
  "qc.instrumentDetail.error.loadFailed": "No se han podido cargar los detalles del instrumento",
  "qc.instrumentDetail.notConfigured.title": "El CC operativo no está configurado",
  "qc.instrumentDetail.notConfigured.description": "No hay lotes de control activos ni resultados de CC asociados a este analizador.",
  "question.text.required": "Es obligatorio introducir el texto de la pregunta",
  "compliance.legend.limitTypes": "TIPOS DE LÍMITE:",
  "compliance.limitType.borderlineShort": "Limítrofe ⚑",
  "compliance.limitType.descriptiveShort": "Cualitativo",
  "compliance.limitType.MAXIMUM": "Límite máximo ≤",
  "compliance.limitType.MINIMUM": "Límite inferior ≥",
  "compliance.limitType.RANGE": "Rango Normal",
  "compliance.limitType.BORDERLINE": "Limítrofe 🚩",
  "compliance.limitType.DESCRIPTIVE": "Cualitativo",
  "compliance.limitType.EXACT": "Exacto",
  "compliance.limitType.SELECT_MAP": "Mapeo de valores",
  "compliance.status.ACTIVE": "Activo",
  "compliance.status.DRAFT": "Borrador",
  "compliance.status.SUPERSEDED": "Derogado",
  "compliance.status.ARCHIVED": "Archivado",
  "compliance.standard.placeholder.name": "p. ej., PP n.º 22/2021 - Calidad del agua",
  "compliance.standard.placeholder.issuingBody": "p. ej., Gobierno de Indonesia",
  "compliance.standard.placeholder.regulationNumber": "p. ej., PP 22/2021",
  "compliance.standard.placeholder.version": "p. ej., 2021",
  "compliance.standard.placeholder.countryRegion": "p. ej., Indonesia",
  "compliance.standard.placeholder.description": "Opcional. Descripción completa del ámbito de aplicación de la norma.",
  "compliance.standard.placeholder.date": "aaaa-mm-dd",
  "compliance.threshold.placeholder.lower": "Inferior / Mín.",
  "compliance.threshold.placeholder.upper": "Superior / Máx.",
  "compliance.threshold.placeholder.unit": "Unidad",
  "compliance.standard.archive": "Archivar",
  "compliance.standard.archiveHeading": "Archivar norma de cumplimiento",
  "compliance.standard.archivePrompt": "¿Desea archivar esta norma? Los resultados de evaluación existentes seguirán vinculados a ella a efectos de auditoría, pero la norma quedará oculta en las listas de selección activas. Esta acción puede revertirse volviendo a establecer el estado de la norma en «Activo».",
  "compliance.standard.archived": "Norma de cumplimiento archivada.",
  "compliance.standard.archiveError": "No se ha podido archivar esta norma.",
  "button.complianceStandard.copy": "Copiar estándar",
  "compliance.standard.copied": "La norma de cumplimiento se ha copiado como un nuevo borrador.",
  "compliance.standard.copyError": "No se ha podido copiar esta norma.",
  "compliance.standard.viewLinkedTests": "Consultar pruebas relacionadas",
  "compliance.testEditor.groupBy": "Agrupar por",
  "compliance.testEditor.section.configuration": "Configuración",
  "compliance.testEditor.section.organization": "Organización",
  "compliance.testEditor.section.resources": "Recursos",
  "compliance.testEditor.section.automation": "Automatización",
  "compliance.testEditor.section.compliance": "Cumplimiento normativo",
  "compliance.testEditor.tab.compliance": "Cumplimiento normativo",
  "compliance.testEditor.tabPlaceholder": "Se incluye con la interfaz del Editor de pruebas; por el momento, puede gestionarlo desde la página «Modificar prueba».",
  "compliance.parameterGroup.editBtn": "Editar",
  "compliance.parameterGroup.moveUp": "Subir",
  "compliance.parameterGroup.moveDown": "Bajar",
  "compliance.parameterGroup.updateError": "No se ha podido actualizar el grupo de parámetros.",
  "compliance.testEditor.standardInactiveBanner": "Esta prueba tiene umbrales vinculados a {name}, que ahora tiene el estado {status}. Los resultados ya no se evaluarán con arreglo a esta norma.",
  "compliance.standard.viewLinkedTests.heading": "Pruebas relacionadas — {name}",
  "compliance.standard.viewLinkedTests.empty": "Actualmente no hay pruebas vinculadas a esta norma.",
  "compliance.filter.status": "Estado",
  "compliance.filter.region": "Región",
  "compliance.filter.allStatuses": "Todos los estados",
  "compliance.filter.allRegions": "Todas las regiones",
  "compliance.filter.sampleType": " Tipo de muestra",
  "compliance.filter.allSampleTypes": "Todos los tipos de muestras",
  "compliance.sampleTypes.addLabel": "Agregar tipo de muestra",
  "compliance.sampleTypes.noneConfigured": "Ninguno configurado",
  "compliance.sampleTypes.noneTitle": "Aún no se ha configurado ningún tipo de muestra.",
  "compliance.sampleTypes.noneSubtitle": "Agregue al menos un tipo de muestra antes de vincular las pruebas.",
  "compliance.sampleTypes.counter": "{count, plural, one {# sample type configured} many {# sample types configured} other {# tipos de muestra configurados}}",
  "compliance.standard.default": "Por defecto",
  "compliance.standard.groups": "Grupos",
  "compliance.standard.tests": "Pruebas",
  "compliance.standard.expiryDate": "Fecha de caducidad",
  "compliance.parameterGroups.heading": "Grupos de parámetros y pruebas vinculadas",
  "compliance.parameterGroups.requireSampleTypes": "Configure primero los campos y los tipos de muestra de la norma y, a continuación, vincule las pruebas.",
  "compliance.button.save": "Guardar",
  "compliance.button.saving": "Guardando…",
  "compliance.parameterGroup.createError": "No se ha podido agregar el grupo de parámetros.",
  "compliance.parameterGroup.deleteHeading": "Eliminar grupo de parámetros",
  "compliance.parameterGroup.deletePrompt": "¿Desea eliminar el grupo de parámetros «{name}» y todos sus umbrales? Esta acción no se puede deshacer.",
  "compliance.parameterGroup.deleteWarning": "{count, plural, one {# test is} many {# tests are} other {# pruebas son}} currently linked. All linked thresholds will be removed.",
  "compliance.threshold.saveError": "No se ha podido guardar esta fila.",
  "compliance.threshold.deleteError": "No se ha podido eliminar esta fila.",
  "compliance.validation.required": "Este campo es obligatorio.",
  "compliance.validation.expiryAfterEffective": "La fecha de caducidad debe ser igual o posterior a la fecha de entrada en vigor.",
  "compliance.validation.missingUpper": "Es necesario indicar un límite superior.",
  "compliance.validation.missingLower": "Es necesario indicar un límite inferior.",
  "compliance.validation.missingBounds": "Se requieren tanto el límite inferior como el superior.",
  "compliance.validation.lowerGtUpper": "El límite inferior debe ser menor o igual al límite superior.",
  "compliance.validation.missingDescriptive": "Se requiere un valor cualitativo.",
  "compliance.linkTest.selectNoOptions": "Esta prueba es del tipo «lista de selección», pero no tiene ninguna opción configurada en el Catálogo de pruebas. Agregue las opciones de resultado en la Gestión de Pruebas antes de vincularla a una norma de conformidad.",
  "compliance.linkTest.resultTypeLegend": " Tipo de resultado",
  "compliance.linkTest.resultType.numeric": "Numérico (utilice valores límite)",
  "compliance.linkTest.resultType.select": "Lista de selección (asignar opciones a estados)",
  "compliance.linkTest.optionsHint": "Agregue las opciones de resultado para esta prueba (por ejemplo, «Ausente», «Presente»). En el siguiente paso podrá asignar cada una de ellas a un estado de cumplimiento.",
  "compliance.linkTest.optionLabel": "Valor de la opción",
  "compliance.linkTest.optionPlaceholder": "p. ej., Ausente",
  "compliance.linkTest.optionsRequired": "Agregue al menos una de las opciones anteriores antes de asignar los estados.",
  "compliance.admin.title": "Administración de Normas de Cumplimiento",
  "compliance.admin.tile.explain": "Gestión de las normas de cumplimiento, los grupos de parámetros y los umbrales por prueba (por ejemplo, PP 22/2021, Agua potable de la OMS).",
  "compliance.tabs.standardsAdmin": "Lista de normas de cumplimiento",
  "compliance.tabs.testThresholds": "Pestaña «Cumplimiento» (Editor de pruebas)",
  "compliance.testEditor.back": "Atrás",
  "compliance.testEditor.editTest": "Prueba de edición:",
  "compliance.testEditor.loinc": "LOINC:",
  "compliance.testEditor.sampleType": "Tipo de muestra:",
  "compliance.testEditor.resultType": "Tipo de resultado:",
  "compliance.testEditor.saveTest": "Guardar prueba",
  "compliance.testEditor.saveDisabledHint": "El resto de pestañas del editor de pruebas aún no están conectadas en esta versión.",
  "compliance.testEditor.thresholdsHeading": "Límites de cumplimiento para",
  "compliance.testEditor.addThreshold": "Agregar umbral",
  "compliance.testEditor.addThresholdHeading": "Vincular {name} a una norma de cumplimiento",
  "compliance.testEditor.pickStandard": "Norma de cumplimiento",
  "compliance.testEditor.pickStandardPlaceholder": "-- Seleccione una norma --",
  "compliance.testEditor.pickGroup": "Grupo de parámetros",
  "compliance.testEditor.pickGroupPlaceholder": "-- Seleccione un grupo de parámetros --",
  "compliance.testEditor.pickGroupHint": "Seleccione un estándar y un grupo de parámetros de los que aparecen arriba para configurar el umbral.",
  "compliance.testEditor.unlink": "Desvincular",
  "compliance.testEditor.unlinkHeading": "Desvincular umbral",
  "compliance.testEditor.unlinkPrompt": "¿Se debe eliminar este umbral de «{test}»? El umbral en sí mismo permanece en el grupo de parámetros de la norma; solo se elimina el enlace a esta prueba concreta.",
  "compliance.testEditor.linkedBanner": "Esta prueba está vinculada a {count, plural, one {# estándar de conformidad} other {# estándares de conformidad}}. Los umbrales se evalúan en el momento de la validación.",
  "compliance.testEditor.expandRow": "Despliegar fila",
  "compliance.testEditor.col.standard": "Estándar",
  "compliance.testEditor.col.parameterGroup": "Grupo de parámetros",
  "compliance.testEditor.col.limitType": "Tipo de límite",
  "compliance.testEditor.col.thresholdRange": "Umbral / Rango",
  "compliance.testEditor.col.unit": "Unidad",
  "compliance.testEditor.col.effective": "Vigente",
  "compliance.testEditor.col.status": "Estado",
  "compliance.testThresholds.selectHint": "Seleccione una prueba para consultar sus umbrales de cumplimiento vinculados a las distintas normas.",
  "compliance.testThresholds.overviewHeading": "Pruebas relacionadas con las normas de cumplimiento",
  "compliance.testThresholds.overviewCount": "{filtered} de {total} {total, plural, one {prueba} other {pruebas}}",
  "compliance.testThresholds.overviewEmpty": "De momento, no hay pruebas vinculadas a las normas de cumplimiento.",
  "compliance.testThresholds.overviewEmptyHint": "Los umbrales definidos en el archivo CSV a nivel de grupo de parámetros aparecen en la pestaña 1 (Administración de normas de cumplimiento), no aquí. Utilice la función de Buscar situada más arriba para seleccionar una prueba del catálogo y vincularla a una norma.",
  "compliance.testThresholds.noLinkedMatches": "No hay pruebas relacionadas que coincidan con «{q}».",
  "compliance.testThresholds.addSection": "Agregar una prueba al cumplimiento",
  "compliance.testThresholds.col.test": "Prueba",
  "compliance.testThresholds.col.code": "Código",
  "compliance.testThresholds.col.loinc": "LOINC",
  "compliance.testThresholds.col.sampleTypes": "Tipos de muestra",
  "compliance.testThresholds.col.thresholdCount": "# Umbrales",
  "compliance.testThresholds.col.standardCount": "# Normas",
  "compliance.testThresholds.openEditor": "Abrir",
  "compliance.testThresholds.title": "Umbrales de cumplimiento de las pruebas",
  "compliance.testThresholds.tile.explain": "Consultar los umbrales de cumplimiento asociados a una prueba concreta, agrupados por norma y grupo de parámetros.",
  "compliance.testThresholds.searchLabel": "Buscar prueba",
  "compliance.testThresholds.searchPlaceholder": "Filtrar la lista de pruebas…",
  "compliance.testThresholds.test": "Prueba",
  "compliance.testThresholds.selectPlaceholder": "-- Seleccione una prueba --",
  "compliance.testThresholds.empty": "Aún no se han vinculado umbrales de cumplimiento a esta prueba. Haga clic en «+ Agregar umbral» más arriba para vincularla al grupo de parámetros de una norma de cumplimiento.",
  "compliance.testThresholds.parameter": "Parámetro",
  "compliance.testThresholds.type": "Tipo de límite",
  "compliance.testThresholds.value": "Valor",
  "compliance.testThresholds.note": " Nota",
  "compliance.testThresholds.unknownStandard": "Estándar desconocido",
  "compliance.button.openAdmin": "Administración de normas de cumplimiento abiertas",
  "compliance.button.addStandard": "Agregar estándar",
  "compliance.button.saveStandard": "Guardar estándar",
  "compliance.button.linkTest": "Asignar prueba a un grupo",
  "compliance.button.saveLimits": "Guardar límites",
  "compliance.button.saveMapping": "Guardar asignación",
  "compliance.search": "Buscar normas",
  "compliance.search.placeholder": "Buscar por nombre, organismo emisor, normativa, país…",
  "compliance.list.empty": "Aún no existen normas de cumplimiento.",
  "compliance.standard.name": "Nombre de la norma",
  "compliance.standard.issuingBody": "Organismo emisor",
  "compliance.standard.regulationNumber": "Número de reglamento",
  "compliance.standard.version": "Versión",
  "compliance.standard.countryRegion": "País / Región",
  "compliance.standard.status": "Estado",
  "compliance.standard.effectiveDate": "Fecha de entrada en vigor",
  "compliance.standard.description": "Descripción",
  "compliance.standard.addNew": "Agregar una nueva norma de cumplimiento",
  "compliance.standard.edit": "Editar norma de cumplimiento",
  "compliance.standard.preSeeded": "Clasificados de antemano",
  "compliance.standard.saved": "Se ha guardado la norma de cumplimiento.",
  "compliance.standard.saveError": "No se ha podido guardar el estándar.",
  "compliance.standard.saveBeforeGroups": "Guarde el estándar antes de añadir grupos de parámetros.",
  "compliance.standard.deleted": "Se ha eliminado la norma de cumplimiento.",
  "compliance.standard.deleteError": "No se ha podido eliminar el valor predeterminado (puede que esté preconfigurado o que tenga umbrales vinculados).",
  "compliance.standard.deleteHeading": "Eliminar norma de cumplimiento",
  "compliance.standard.deletePrompt": "¿Está seguro de que desea eliminar este estándar? No es posible eliminar los estándares predefinidos ni aquellos que tengan umbrales vinculados.",
  "compliance.sampleTypes.heading": "Tipos de muestras aplicables",
  "compliance.sampleTypes.explicitHint": "Indique a qué categorías de tipos de muestra se aplica esta norma. Estas selecciones determinan el filtro de pruebas al vincular las pruebas.",
  "compliance.sampleTypes.empty": "Aún no se han declarado tipos de muestra.",
  "compliance.sampleTypes.selectPlaceholder": "Seleccionar tipo de muestra...",
  "compliance.sampleTypes.addBtn": "Agregar tipo de muestra",
  "compliance.sampleTypes.remove": "Eliminar",
  "compliance.parameterGroups": "Grupos de parámetros",
  "compliance.parameterGroups.empty": "Aún no se han definido grupos de parámetros.",
  "compliance.parameterGroups.add": "Agregar grupo de parámetros",
  "compliance.parameterGroup.name": "Nombre del grupo",
  "compliance.parameterGroup.description": "Descripción",
  "compliance.parameterGroup.deleteBtn": "Eliminar",
  "compliance.label.tests": "pruebas",
  "compliance.linkedTest.name": "Prueba",
  "compliance.linkedTest.sampleTypes": "Tipos de muestra",
  "compliance.linkedTest.limits": "Límites configurados",
  "compliance.linkedTest.editLimits": "Editar límites",
  "compliance.linkedTest.unlink": "Eliminar del grupo",
  "compliance.linkedTest.unlinkHeading": "Eliminar prueba del grupo",
  "compliance.linkedTest.unlinkConfirm": "Eliminar",
  "compliance.linkedTest.unlinkPrompt": "¿Desea eliminar esta prueba del grupo? Se eliminarán todas las definiciones de umbrales de esta prueba en este grupo.",
  "compliance.group.noTests": "Aún no hay pruebas vinculadas a este grupo. Vincule pruebas para definir los umbrales de cumplimiento que se utilizarán en la evaluación.",
  "compliance.linkTest.heading": "Asignar prueba a un grupo",
  "compliance.linkTest.step1": "Paso 1 — Filtrar por tipo de muestra",
  "compliance.linkTest.step2": "Paso 2 — Buscar y seleccionar prueba",
  "compliance.linkTest.step3Numeric": "Paso 3 — Configurar los límites",
  "compliance.linkTest.step3Select": "Paso 3 — Mapeo de valores de cumplimiento",
  "compliance.linkTest.filterByST": "Filtrar por tipo de muestra:",
  "compliance.linkTest.searchTest": "Buscar en el catálogo de pruebas",
  "compliance.linkTest.searchPlaceholder": "Escriba para buscar por nombre o código...",
  "compliance.linkTest.noResults": "No se encontraron pruebas que coincidan.",
  "compliance.linkTest.selectListBadge": "Lista de selección",
  "compliance.linkTest.clearSelection": "Limpiar selección",
  "compliance.multiLimit.editHeading": "Configurar límites",
  "compliance.multiLimit.hint": "Active uno o varios tipos de límite para esta prueba. Debe activarse al menos un tipo de límite.",
  "compliance.multiLimit.type": "Tipo de límite",
  "compliance.multiLimit.lower": "Inferior",
  "compliance.multiLimit.upper": "Superior",
  "compliance.multiLimit.unit": "Unidad",
  "compliance.multiLimit.note": "Nota / Aviso",
  "compliance.multiLimit.descriptive.placeholder": "p. ej., sin olor, ausente, transparente",
  "compliance.multiLimit.note.placeholder": "Nota opcional",
  "compliance.limitType.high": "Límite máximo ≤",
  "compliance.limitType.high.hint": "Se considera que no cumple los requisitos si el resultado supera el límite superior",
  "compliance.limitType.low": "Límite inferior ≥",
  "compliance.limitType.low.hint": "Se considera que no cumple los requisitos si el resultado es inferior al límite inferior",
  "compliance.limitType.range": "Rango Normal",
  "compliance.limitType.range.hint": "Se ajusta al rango inferior-superior",
  "compliance.limitType.borderline": "Limítrofe (advertencia)",
  "compliance.limitType.borderline.hint": "Zona de aviso: activa una marca de revisión, pero no supone un fallo",
  "compliance.limitType.descriptive": "Cualitativo / Descriptivo",
  "compliance.limitType.descriptive.hint": "Valor de texto evaluado por el analista",
  "compliance.selectMap.editHeading": "Mapeo del cumplimiento normativo",
  "compliance.selectMap.hint": "Asigne a cada opción de resultado su estado de cumplimiento. Las opciones proceden del Catálogo de pruebas.",
  "compliance.selectMap.option": "Opción de resultado",
  "compliance.selectMap.status": "Estado de cumplimiento",
  "compliance.selectMap.preview": "Vista previa",
  "compliance.selectMap.badge": "Mapeo de valores",
  "compliance.selectMap.optionsLabel": "opciones asignadas",
  "compliance.selectMap.statusForOption": "Estado de cumplimiento de {option}",
  "compliance.status.compliant": "Conforme",
  "compliance.status.borderline": "Limítrofe",
  "compliance.status.nonCompliant": "No conforme",
  "compliance.status.compliantWithIcon": "Conforme ✓",
  "compliance.status.borderlineWithIcon": "Limítrofe ⚑",
  "compliance.status.nonCompliantWithIcon": "No conforme ✗",
  "compliance.linkedTest.noLimits": "No se han configurado límites",
  "compliance.threshold.savedThresholds": "Límites de cumplimiento vinculados a la prueba.",
  "compliance.threshold.savedValueMap": "Se ha guardado el umbral de asignación de valores.",
  "compliance.threshold.savedPartialError": "No se han podido guardar algunos umbrales. Revise las filas resaltadas.",
  "compliance.threshold.unlinked": "Umbral desvinculado de la prueba.",
  "compliance.threshold.unlinkError": "No se ha podido desvincular este umbral.",
  "notification.title.success": "Éxito",
  "notification.title.error": "Error",
  "sidenav.label.admin.vectorSurveillance": "Vigilancia de vectores",
  "vector.admin.title": "Configuración de la vigilancia de vectores",
  "vector.admin.groups": "Grupos de organismos",
  "vector.admin.group.code": "Código",
  "vector.admin.group.label": "Etiqueta",
  "vector.admin.group.colorTag": "Etiqueta de color",
  "vector.admin.group.description": "Descripción",
  "vector.admin.active": "Activo",
  "vector.admin.system": "Sistema",
  "vector.admin.trapTypes": "Tipos de trampas",
  "vector.admin.trapType.name": " Nombre",
  "vector.admin.trapType.description": "Descripción",
  "vector.admin.species": "Especies",
  "vector.admin.selectGroup": "Seleccione un grupo a la izquierda para gestionar sus tipos de trampas y especies.",
  "vector.admin.newGroup": "Nuevo grupo (sin guardar)",
  "vector.admin.newTrapType": "Nuevo tipo de trampa",
  "vector.admin.newSpecies": "Nueva especie",
  "vector.admin.saveGroup": "Guardar grupo",
  "vector.admin.saveTrap": "Guardar trampa",
  "vector.admin.saveSpecies": "Guardar especies",
  "vector.admin.addGroup": "+ Agregar grupo",
  "vector.admin.addTrapType": "+ Agregar tipo de trampa",
  "vector.admin.addSpecies": "+ Agregar especie",
  "vector.admin.locked": "bloqueado",
  "vector.admin.systemGroup": "Grupo protegido por el sistema",
  "vector.admin.systemGroup.desc": "El código está bloqueado porque este grupo aparece en informes básicos y datos de inicialización. No obstante, puede editar la etiqueta, el color y la descripción.",
  "vector.admin.usedBy": "Utilizado por",
  "vector.admin.status": "Estado",
  "vector.admin.status.active": "Activo",
  "vector.admin.status.inactive": "Inactivo",
  "vector.admin.group": "Grupo de organismos",
  "vector.admin.trapType.group": "Grupo de organismos objetivo",
  "vector.admin.trapType.groups": "Grupos de organismos",
  "vector.admin.trapType.sampleTypes": "Tipos de muestra",
  "vector.admin.sampleType": "Tipo de muestra",
  "vector.admin.search.groups": "Buscar por código o etiqueta...",
  "vector.admin.search.traps": "Buscar el nombre o la descripción de la trampa...",
  "vector.admin.search.species": "Buscar un género o una especie...",
  "vector.admin.samplingSites": "Puntos de muestra",
  "vector.admin.samplingSite.newSite": "Nuevo sitio",
  "vector.admin.samplingSite.allSites": "Todos los sitios",
  "vector.admin.samplingSite.code": "Código",
  "vector.admin.samplingSite.name": " Nombre del sitio",
  "vector.admin.samplingSite.type": "Tipo de sitio",
  "vector.admin.samplingSite.region": "Región",
  "vector.admin.samplingSite.district": "Distrito",
  "vector.admin.samplingSite.contactName": "Persona de contacto",
  "vector.admin.samplingSite.contactPhone": "Teléfono de contacto",
  "vector.admin.samplingSite.gpsLatitude": "Latitud GPS",
  "vector.admin.samplingSite.gpsLongitude": "Longitud GPS",
  "vector.admin.samplingSite.environmentalZone": "Zona medioambiental",
  "vector.admin.samplingSite.address": "Dirección",
  "vector.admin.samplingSite.description": "Descripción",
  "vector.admin.samplingSite.source": "Fuente",
  "vector.admin.samplingSite.source.local": "LOCAL",
  "vector.admin.samplingSite.source.hub": "HUB",
  "vector.admin.samplingSite.lastCollection": "Última recolección",
  "vector.admin.samplingSite.search": "Buscar por código, nombre, región...",
  "vector.admin.samplingSite.saveSite": "Guardar sitio",
  "vector.admin.samplingSites.registry": "Registro de sitios de muestreo",
  "vector.admin.samplingSite.deactivate": "Desactivar",
  "vector.admin.samplingSite.activate": "Activar",
  "vector.admin.samplingSite.location": "Ubicación",
  "vector.admin.samplingSite.allTypes": "Todos los tipos",
  "vector.admin.samplingSite.subtype": "Subtipo",
  "vector.admin.samplingSite.subtype.placeholder": "p. ej., río, pozo, BG-Sentinel, estación fija",
  "vector.admin.samplingSite.city": " Ciudad",
  "vector.admin.samplingSite.addressLocation": "Dirección y ubicación",
  "vector.admin.samplingSite.addressSearch.placeholder": "Buscar una ubicación para rellenar automáticamente los menús desplegables...",
  "vector.admin.samplingSite.gpsCoordinates": "Coordenadas GPS",
  "vector.admin.samplingSite.lastModified": "Última modificación",
  "label.noResults": " No se encontraron resultados",
  "vector.admin.addSite": "+ Nuevo sitio",
  "vector.order.title": "Nueva orden de vectores",
  "vector.order.subtitle": "Unidad de laboratorio: Laboratorio de Vigilancia de Vectores — Ámbito de vectores activo.",
  "vector.order.samplingSite": "Sitio de muestreo",
  "vector.order.site.code": "Código del sitio",
  "vector.order.site.helper": "En los resultados solo aparecen los sitios de vigilancia activos. Las coordenadas GPS se rellenan automáticamente desde el registro del sitio.",
  "vector.order.site.name": " Nombre del sitio",
  "vector.order.site.placeholder": "Buscar por nombre o código del sitio...",
  "vector.order.site.type": "Tipo de sitio",
  "vector.order.specimen": "Muestra",
  "vector.order.organism": "Animal / Organismo",
  "vector.order.organism.hint": "Nombre común — p. ej., mosquito, garrapata, roedor, flebotomo.",
  "vector.order.organism.placeholder": "Buscar un organismo o una especie...",
  "vector.order.quantity": "Cantidad",
  "vector.order.quantity.hint": "Número de organismos presentes en este grupo.",
  "vector.order.requester.section": "Solicitante / Programa de pedidos",
  "vector.order.requester": " Solicitante",
  "vector.order.requester.placeholder": "Buscar por nombre o código de la organización...",
  "vector.order.panels": "Ordenar Paneles",
  "vector.order.panels.search": "Elegir panel disponible",
  "vector.order.tests": " Solicitar pruebas",
  "vector.order.tests.search": "Elegir prueba disponible",
  "vector.order.collectionContext": "Contexto de la recolección (opcional: captura bionómica)",
  "vector.order.timeOfDay": "Hora del día",
  "vector.order.timeOfDay.dawn": "Amanecer",
  "vector.order.timeOfDay.day": "Día",
  "vector.order.timeOfDay.dusk": "Anochecer",
  "vector.order.timeOfDay.night": "Noche",
  "vector.order.restingContext": "Contexto de reposo",
  "vector.order.restingContext.outdoor": "Al aire libre (exofílico)",
  "vector.order.restingContext.indoor": "De interior (endófilo)",
  "vector.order.restingContext.peridomestic": "Peridoméstico",
  "vector.order.humanBitingCatch": "Captura con cebo humano",
  "vector.order.humanBitingCatch.hint": "la muestra procede de una captura con cebo humano",
  "vector.order.collectionNotes": "Notas de recolección",
  "vector.order.collectionNotes.placeholder": "El tiempo, el estado de las trampas, las anomalías...",
  "vector.admin.group.code.placeholder": "p. ej., SANDFLY",
  "vector.admin.group.label.placeholder": "p. ej., flebotomo",
  "vector.species.genus.placeholder": "p. ej., Mansonia",
  "vector.species.species.placeholder": "p. ej., uniformis",
  "vector.species.subspecies.placeholder": "p. ej., diardii",
  "vector.species.genus": "Género",
  "vector.species.species": "Especies",
  "vector.species.subspecies": "Subespecies",
  "vector.species.pathogensOfInterest": "Agentes patógenos de interés",
  "vector.species.lifecycleStages": "Etapas del ciclo de vida",
  "vector.species.pathogenCategory": "Categoría de patógenos",
  "vector.species.lifecycleCategory": "Categoría de ciclo de vida",
  "workflow.vector": "Vigilancia de vectores",
  "vector.sampleType": " Tipo de muestra",
  "vector.organismGroup": "Grupo de organismos",
  "vector.species": "Especies",
  "vector.animalOrganism": "Animal/Organismo",
  "vector.animalOrganism.add": "Agregar animal/organismo",
  "vector.animalOrganism.remove": "Eliminar animal/organismo",
  "vector.collectedVolume": "Cantidad en el grupo",
  "vector.lifecycleStage": "Etapa del ciclo de vida",
  "vector.trapCount": "Trampas colocadas",
  "vector.trapNights": "Noches de servicio",
  "vector.trapType": "Tipo de trampa",
  "vector.poolingMethod": "Método de agrupación",
  "vector.poolCount": "Número de piscinas",
  "vector.samplesPerPool": "Muestras por grupo",
  "vector.totalSpecimens": "Total de muestras",
  "vector.pathogensOfInterest": "Agentes patógenos de interés",
  "vector.homogeneous": "Homogéneo",
  "vector.random": "Aleatorio",
  "vector.collectionSite": "Punto de recogida",
  "vector.collectionSiteName": "Nombre del sitio",
  "vector.gpsLatitude": "Latitud GPS",
  "vector.gpsLongitude": "Longitud GPS",
  "patient.search.merged.tag": "Fusionado",
  "patient.merged.banner.title": "Este expediente del paciente se ha fusionado",
  "patient.merged.banner.subtitle": "Los registros activos se conservan en el paciente {target}.",
  "patient.merged.banner.subtitle.noTarget": "Este registro se ha fusionado con el de otro paciente.",
  "admin.testCatalog.tabs.ariaLabel": "Pestañas de detalles de la prueba",
  "admin.testCatalog.tabs.details": "Detalles",
  "admin.testCatalog.tabs.labels": "Etiquetas",
  "admin.testCatalog.labels.masterOverride.label": "Permitir la sustitución en la entrada de órdenes",
  "admin.testCatalog.labels.masterOverride.on": "Encendido",
  "admin.testCatalog.labels.masterOverride.off": "Apagado",
  "admin.testCatalog.labels.linkedPresets.title": "Preajustes de etiquetas vinculados",
  "admin.testCatalog.labels.linkedPresets.empty": "No hay preajustes de etiquetas vinculados. Utilice el menú desplegable que aparece a continuación para agregar uno.",
  "admin.testCatalog.labels.col.presetName": "Nombre del preajuste",
  "admin.testCatalog.labels.col.defaultQty": "Cantidad por defecto",
  "admin.testCatalog.labels.col.maxQty": "Cantidad máxima",
  "admin.testCatalog.labels.col.allowOverride": "Permitir la sustitución",
  "admin.testCatalog.labels.col.actions": "Acciones",
  "admin.testCatalog.labels.action.remove": "Eliminar vínculo del preajuste",
  "admin.testCatalog.labels.addPreset.label": "Agregar tipo de etiqueta",
  "admin.testCatalog.labels.addPreset.placeholder": "Seleccione una configuración predefinida de etiqueta",
  "admin.testCatalog.labels.preview.title": "Vista previa de la entrada de órdenes",
  "admin.testCatalog.labels.preview.col.locked": "Bloqueado",
  "admin.testCatalog.labels.preview.locked": "Bloqueado",
  "admin.testCatalog.labels.preview.unlocked": "Editable",
  "admin.testCatalog.labels.save.success": "Se ha guardado la configuración de la etiqueta.",
  "admin.testCatalog.labels.save.error": "No se ha podido guardar la configuración de la etiqueta.",
  "orderEntry.labels.orderTable.title": "Etiquetas de la orden",
  "orderEntry.labels.sampleTable.title": "Etiquetas de muestras",
  "orderEntry.labels.col.row": "Fila",
  "orderEntry.labels.col.sample": "Muestra",
  "orderEntry.labels.col.quantity": "Cantidad",
  "orderEntry.labels.orderRow.header": "Orden",
  "orderEntry.labels.sampleRow.header": "Muestra {number}",
  "orderEntry.labels.input.sample": "Cantidad de {column} de la muestra {number}",
  "orderEntry.labels.input.sampleNamed": "{sample} {column} quantity",
  "orderEntry.labels.source.test": "Desde la prueba",
  "orderEntry.labels.source.presetDefault": "Valor predeterminado",
  "orderEntry.labels.source.saved": "Guardado",
  "orderEntry.labels.locked.tooltipFor": "{label} está bloqueado por la configuración de la prueba y no se puede modificar.",
  "orderEntry.labels.total": "Número total de etiquetas: {total}",
  "orderEntry.labels.heading": "ETIQUETAS",
  "orderEntry.labels.title": "Etiquetas",
  "orderEntry.labels.printRow": "Print labels for {label}",
  "orderEntry.labels.printColumn": "Print all {label} labels",
  "orderEntry.labels.printAll": "Print all labels",
  "orderEntry.labels.pendingSave": "Prints after save",
  "orderEntry.labels.empty": "Add a sample above to see its labels.",
  "orderEntry.labels.loadFailed": "The label quantities could not be loaded from the presets.",
  "orderEntry.labels.printFailed": "The labels could not be generated.",
  "orderEntry.labels.printFailed.detail": "The server answered {status}.",
  "orderEntry.labels.printFailed.unreachable": "The server could not be reached.",
  "orderEntry.labels.nothingToPrint": "No labels are configured for this selection.",
  "orderEntry.labels.downloaded": "The print window was blocked, so the labels were downloaded instead.",
  "orderEntry.labels.retry": "Inténtelo de nuevo",
  "label.patientHistory.filterByCategory": "Filtrar por categoría de prueba",
  "label.patientHistory.testCategories": "Categorías de pruebas",
  "label.patientHistory.tree": "Árbol",
  "label.patientHistory.showTree": "Mostrar árbol",
  "label.patientHistory.resetTree": "Restablecer árbol",
  "label.patientHistory.viewResults": "Consultar {count} resultados",
  "label.patientHistory.emptyState": "No hay «{displayText}» que mostrar para este paciente",
  "label.patientHistory.record": "Registrar {displayText}",
  "label.patientHistory.dataLoadError": "Error al cargar los datos",
  "label.patientHistory.errorCopy": "Lo sentimos, se ha producido un problema al mostrar esta información. Puede intentar recargar esta página o ponerse en contacto con el administrador del sitio e indicar el código de error que aparece arriba.",
  "label.patientHistory.backToTimeline": "Volver a la cronología",
  "label.patientHistory.returnToTimeline": "Volver a la línea temporal",
  "label.patientHistory.timeOfTest": "Hora de la prueba",
  "label.patientHistory.observations": "observaciones",
  "label.patientHistory.range.oneDay": "1 día",
  "label.patientHistory.range.fiveDays": "5 días",
  "label.patientHistory.range.oneMonth": "1 mes",
  "label.patientHistory.range.sixMonths": "6 meses",
  "label.patientHistory.range.oneYear": "1 año",
  "label.patientHistory.range.fiveYears": "5 años",
  "label.patientHistory.range.all": "Todos",
  "label.patientHistory.date": "Fecha",
  "address.search.no.results": "No se han encontrado direcciones para «{term}».",
  "address.search.placeholder": "Buscar una dirección (ingrese al menos 2 caracteres)...",
  "address.search.results.count": "{count} resultados encontrados",
  "alert.error": "Error",
  "alert.warning": "Advertencia",
  "analyzer.errorDetails.noLogsAvailable": "No hay registros disponibles",
  "analyzer.fieldSelector.placeholder": "Campo de búsqueda y selección...",
  "analyzer.fieldSelector.title": "Seleccione un campo de OpenELIS",
  "analyzer.form.columnMappings": "Asignaciones de columnas (JSON)",
  "analyzer.form.columnMappings.helperText": "Asigna los nombres de las columnas del archivo a los nombres de los campos internos",
  "analyzer.form.delimiter": "Delimitador",
  "analyzer.form.fileFormat": "Formato de archivo",
  "analyzer.form.fileImport.title": "Configuración de la importación de archivos",
  "analyzer.form.filePattern": "Patrón de archivo",
  "analyzer.form.filePattern.helperText": "Patrón «Glob» para hacer coincidir los archivos de resultados",
  "analyzer.form.hasHeader": "El archivo contiene una fila de encabezado",
  "analyzer.form.importDirectory": "Directorio de importación",
  "analyzer.form.importDirectory.helperText": "Directorio en el que el puente supervisa la llegada de los archivos de resultados",
  "analyzer.form.importDirectory.placeholder": "/data/analyzer-imports/my-analyzer/incoming",
  "analyzer.form.validation.columnMappings.invalid": "Las asignaciones de columnas deben ser JSON válido",
  "analyzer.form.validation.importDirectory.required": "El directorio de importación es obligatorio para los analizadores basados en archivos",
  "analyzer.form.validation.port.invalid": "El puerto debe ser un número comprendido entre 1 y 65535",
  "analyzer.qc.batch.failure.subtitle": "Los controles de CC de este lote presentan fallos. Revise los resultados de CC que se indican a continuación antes de aceptar los resultados de los pacientes.",
  "analyzer.qc.batch.failure.title": "Fallos en los controles de CC",
  "analyzer.qc.controls.hidden": "Controles de CC ocultos a la vista del paciente",
  "analyzer.qc.controls.section.title": "Controles de CC ({count})",
  "audittrail.table.heading": "Información de la orden",
  "barcode.label.info.labnumber": "Número de acceso",
  "button.close": "Cerrar",
  "button.collapse": "Contraer",
  "button.expand": "Ampliar",
  "button.home": "Inicio",
  "button.new.search": "Nueva búsqueda",
  "column.name.labNo": "N.º de laboratorio",
  "env.collectionConditions.helper": "Buscar un punto de toma de muestras ya existente o cree uno nuevo. Los puntos de toma de muestras se pueden reutilizar en diferentes pedidos, al igual que los pacientes en los flujos de trabajo clínicos.",
  "env.collectionMethod.placeholder": "p. ej., muestra puntual, muestra compuesta de 24 horas",
  "env.conditions": "Condiciones ambientales",
  "env.conditions.placeholder": "por ejemplo, 20 °C, cielo despejado, estación seca",
  "env.regulatoryReference": "Referencia normativa",
  "env.regulatoryReference.placeholder": "p. ej., PP n.º 22/2021 Batu Mutu Air",
  "env.samplingSite.title": "Asunto: Punto de muestreo",
  "env.site.address": "Dirección",
  "env.site.addressSearch.placeholder": "Buscar una ubicación para que se rellenen automáticamente los menús desplegables que aparecen a continuación...",
  "env.site.code": "Código del sitio",
  "env.site.code.placeholder": "Generado automáticamente (o introdúzcalo manualmente)",
  "env.site.contactPerson": "Persona de contacto",
  "env.site.contactPerson.placeholder": "Nombre del responsable del sitio o de la persona de contacto",
  "env.site.contactPhone": "Teléfono de contacto",
  "env.site.description": "Descripción del sitio",
  "env.site.description.placeholder": "Por ejemplo, punto de control aguas abajo cerca de la compuerta.",
  "env.site.helperText": "Registre un nuevo punto de muestreo. El punto se guardará en el Registro de puntos y podrá volver a utilizarse para futuros pedidos.",
  "env.site.name": " Nombre del sitio",
  "env.site.name.placeholder": "p. ej., Sungai Ciliwung — Manggarai",
  "env.site.newTab": "Nueva página web",
  "env.site.saveAndSelect": "Guardar y seleccionar Sitio",
  "env.site.searchLabel": " Nombre del sitio",
  "env.site.searchPlaceholder": "p. ej., Sungai Ciliwung - Manggarai",
  "env.site.searchTab": "Buscar en el sitio web",
  "env.site.streetAddress": "Dirección",
  "env.site.streetAddress.placeholder": "Dirección postal o referencia de ubicación",
  "env.site.subtype": "Subtipo",
  "env.site.subtype.placeholder": "p. ej., río, pozo, BG-Sentinel, estación fija",
  "env.site.type": "Tipo de emplazamiento",
  "env.site.type.select": "Seleccione el tipo...",
  "env.site.zone": "Zona medioambiental",
  "env.site.zone.select": "Seleccione una zona...",
  "error.dateRange.start": "Seleccione, por favor, la fecha de inicio y la fecha de finalización.",
  "error.loading.metrics": "Error al cargar las métricas",
  "error.nonconform.report.data.found": "No se encontraron datos",
  "error.report.csv.dateType": " Por favor seleccione tipo de fecha.",
  "error.required.fields": "Le rogamos que rellene todos los campos obligatorios",
  "error.save.sample": "Error al guardar la muestra",
  "error.validation.failed": "La validación ha fallado",
  "error.value": "Seleccione un valor.",
  "esig.context.saveResults": "Guardar los resultados de {count} correspondientes al número de acceso {accession}",
  "esig.context.saveResultsMulti": "Guarde los resultados de «{count}» de todas las entradas de «{accessionCount}»",
  "esig.context.validateResults": "Valide los resultados de {count} correspondientes al número de acceso {accession}",
  "esig.context.validateResultsMulti": "Validar los resultados de «{count}» en todas las accesiones de «{accessionCount}»",
  "fhir.questionnaire.title": "Información Adicional",
  "genericSample.default.fields.title": "Información sobre la muestra",
  "genericSample.import.success": "La importación se ha realizado correctamente",
  "genericSample.notebook.label": "Seleccione un cuaderno",
  "genericSample.order.newOrder": "Crear otra muestra",
  "genericSample.search.title": "Buscar por Número de Acceso",
  "http.success": "¡Éxito!",
  "label.button.assign": " Asignar",
  "label.button.create": "Crear",
  "label.button.saving": "Guardando...",
  "label.button.view": "Ver informe",
  "label.code": "Código",
  "label.editing": "Edición",
  "label.label": "Etiqueta",
  "label.name": " Nombre",
  "label.panel": "Panel",
  "label.tests": "pruebas",
  "loading.label": "Cargando",
  "loading.metrics": "Cargando métricas...",
  "locale.save.error": "No se ha podido guardar el idioma",
  "logging.management.tail.clear": "Limpiar",
  "logging.management.tail.disconnected": "La transmisión se ha interrumpido. Desactive y vuelva a activar el interruptor para reconectarse.",
  "logging.management.tail.label": "Registro de eventos de la aplicación en tiempo real",
  "logging.management.tail.off": "Apagado",
  "logging.management.tail.on": "Encendido",
  "logging.management.tail.stream": "Transmisión en vivo",
  "nationalID.title": "ID Nacional",
  "nce.button.linkSelected": "Vincular muestras seleccionadas",
  "nce.button.submit": "Enviar NCE",
  "nce.error.numberGeneration": "No se ha podido generar el Número NCE. Inténtelo de nuevo.",
  "nce.field.dateOfEvent": " Fecha del evento",
  "nce.field.description": "Descripción",
  "nce.field.nceNumber": " Número NCE",
  "nce.field.proposedAction.helper": "Independiente de las acciones CAPA asignadas durante el flujo de trabajo de acciones correctivas",
  "nce.field.proposedAction.placeholder": "Siguientes pasos recomendados...",
  "nce.field.reporterName": "Nombre del notificador",
  "nce.field.reportingUnit": " Unidad informante",
  "nce.field.subcategory": "Subcategoría",
  "nce.field.suspectedCauses.helper": "Se trata únicamente de una evaluación inicial; la causa raíz oficial se determinará durante la investigación",
  "nce.field.suspectedCauses.placeholder": "Notificador",
  "nce.form.subtitle": "Documente un incidente relacionado con la calidad e incluya enlaces a las muestras y los resultados correspondientes",
  "nce.form.title": "Reportar evento no conforme",
  "nce.linkSamples.helper": "Busque órdenes arriba para vincular muestras a este NCE. Este paso es opcional.",
  "nce.section.attachments": "Archivos adjuntos",
  "nce.section.classification": "Clasificación",
  "nce.section.details": "Detalles",
  "nce.section.linkSamples": "Enlace a muestras / resultados (opcional)",
  "nce.section.reporterContext": "Notificador y contexto del evento",
  "nce.select.subcategory": "Seleccione una subcategoría...",
  "nce.severity.critical.desc": "Riesgo para la seguridad del paciente, incumplimiento normativo",
  "nce.severity.major.desc": "Repercusiones significativas en materia de calidad o en el funcionamiento",
  "nce.severity.minor.desc": "Impacto limitado, fácil de corregir",
  "nonconform.corrective.requiredFields": "Rellene todos los campos relativos a las acciones correctivas (acción, persona responsable, fecha completada y, al menos, un tipo de acción), o deje la fila completamente en blanco.",
  "nonconform.view.requiredFields": "Es obligatorio indicar el componente de laboratorio, la categoría NCE, el tipo NCE, la severidad, las consecuencias y la recurrencia.",
  "notebook.sample.create": "Crear",
  "notebook.sample.create.title": "Crear una nueva muestra",
  "notebook.sample.edit": "Editar",
  "notebook.sample.edit.title": "Editar muestra",
  "notebook.sample.import": "Importar",
  "notebook.sample.import.title": "Importar muestras",
  "notebook.sample.order.info": "Esta muestra se asociará al cuaderno de trabajo actual.",
  "notebook.sample.order.title": "Create Sample for Notebook",
  "notification.warning": "Advertencia",
  "order.entry.setup.batch": " Ingreso por lotes",
  "order.legend.patient1": "Información del paciente",
  "pagination.next": "Página siguiente",
  "pagination.previous": "Página anterior",
  "patient.fetch.error": "No se ha podido cargar el paciente. Es posible que el identificador no sea válido o que no se pueda acceder al servidor.",
  "patient.firstName": "Primer Nombre",
  "patient.lastName": "Apellido",
  "print.barcode.all": "Imprimir todos los códigos de barras ({count})",
  "sample.item.id": "ID de elemento de muestra",
  "sample.label": "Muestra",
  "sample.noPanels": "No hay paneles disponibles para este tipo de muestra",
  "sample.noTests": "No hay pruebas disponibles para este tipo de muestra",
  "sample.testsLoadFailed": "The tests for this sample type could not be loaded.",
  "sample.noTestsMatchSearch": "No tests match your search",
  "sample.noPanelsMatchSearch": "No panels match your search",
  "sample.selectType.first": "Seleccione un tipo de muestra más arriba para ver los paneles y las pruebas disponibles",
  "sample.testsCount": "{count} pruebas disponibles",
  "sample.types": "Muestras",
  "sample.referral.listsFailed": "The referral reasons or laboratories could not be loaded. Everything you entered is kept; press Retry to refer a test.",
  "sample.tests.loadFailed": "Tests for {sampleType} could not be loaded.",
  "sample.tests.loadFailed.hint": "Everything you entered is kept. Check the connection or sign in again, then press Retry.",
  "sample.tests.loading": "Loading tests…",
  "save.error.msg": "Error al guardar",
  "saving.label": "Guardando...",
  "select.label.analyzer": "Seleccionar analizador",
  "site.code": "Código",
  "steps.complete": "pasos",
  "storage.audit.empty": "Aún no se han registrado movimientos para esta muestra.",
  "storage.audit.empty.title": "No se observan movimientos",
  "storage.audit.fetch.error": "No se ha podido cargar el Registro de Auditoría.",
  "storage.audit.fetch.error.title": "Error",
  "storage.audit.from": "Desde",
  "storage.audit.movedBy": "Movido por",
  "storage.audit.movementDate": "Fecha del traslado",
  "storage.audit.reason": "Motivo",
  "storage.audit.to": "Hasta",
  "storage.box.code.helper": "Hasta 10 caracteres",
  "storage.confirm.disposal": "Confirmar la eliminación",
  "storage.dashboard.title": "Almacenamiento",
  "storage.disposal.method": "Método de eliminación",
  "storage.disposal.method.placeholder": "Seleccione un método...",
  "storage.disposal.notes": "Notas adicionales (opcional)",
  "storage.disposal.notes.placeholder": "Ingrese cualquier nota adicional...",
  "storage.disposal.reason": "Motivo de eliminación",
  "storage.disposal.reason.placeholder": "Seleccione el motivo...",
  "storage.dispose.confirmation": "Confirmo que deseo eliminar definitivamente esta muestra. Esta acción no se puede deshacer.",
  "storage.dispose.error": "La eliminación falló",
  "storage.dispose.instructions.subtitle": "Asegúrese de que se sigan los procedimientos de eliminación adecuados, de conformidad con los protocolos de seguridad del laboratorio.",
  "storage.dispose.instructions.title": "Instrucciones de eliminación",
  "storage.dispose.location.note": "La muestra se eliminará de esta ubicación en el momento de su eliminación.",
  "storage.dispose.sample": "Eliminar la muestra",
  "storage.dispose.sample.subtitle": "Elimine definitivamente la muestra {sampleId}",
  "storage.dispose.warning.subtitle": "La muestra se marcará como eliminada y se eliminará del almacén.",
  "storage.dispose.warning.title": "Esta acción no se puede deshacer",
  "storage.edit.heading": "Editar {type}",
  "storage.edit.title": "Editar",
  "storage.editbox.heading": "Cuadro de edición",
  "storage.error": "Error",
  "storage.error.save": "No se ha podido guardar la ubicación",
  "storage.filter.select.location": "Seleccione una ubicación...",
  "storage.filter.selected": "Seleccionado:",
  "storage.location.assigned.error": "No se ha podido asignar la ubicación",
  "storage.location.assigned.success": "La ubicación se ha asignado correctamente",
  "storage.location.created": "{level} creado",
  "storage.location.deleted": "{level} borrado",
  "storage.location.no.results": "No se han encontrado ubicaciones",
  "storage.location.type.devices": "dispositivos",
  "storage.location.type.racks": "estantes",
  "storage.location.type.rooms": "habitaciones",
  "storage.location.type.shelves": "estantes",
  "storage.location.updated": "{level} actualizado",
  "storage.manage.location": "Gestionar ubicación",
  "storage.nav.rack": "Rack",
  "storage.sample.actions": "Acciones de la muestra",
  "storage.sampleitem.accession": "Número de laboratorio de la muestra",
  "storage.sampleitem.location": "Ubicación de almacenamiento",
  "storage.sampleitem.status": "Estado",
  "storage.sampleitem.type": "Tipo",
  "storage.search.location.label": "Buscar una ubicación de almacenamiento",
  "storage.search.location.placeholder": "Escriba 2 o más caracteres para buscar…",
  "storage.skipRemaining": "Omitir el almacenamiento de muestras sin asignar ({count}): se procesarán de inmediato",
  "storage.view.audit": "Consultar auditoría",
  "storage.view.audit.subtitle": "Historial de movimientos de la muestra {sampleId}",
  "storage.view.audit.title": "Registro de Auditoría de almacenamiento",
  "systemDefaultPayloadTemplate.messageTemplate": "Plantilla de mensaje",
  "systemDefaultPayloadTemplate.subjectTemplate": "Plantilla de asunto",
  "tests.count": "{count, plural, one {test} many {tests} other {pruebas}}",
  "validation.invalid.ip": "Formato de dirección IP no válido (IPv4 o IPv6)",
  "validation.invalid.port": "El puerto debe estar comprendido entre 1 y 65535",
  "validation.required": "Este campo es obligatorio",
  "common.accept": "Aceptar",
  "common.accessionNumber": "Número de acceso",
  "common.action": " Acción",
  "common.actions": "Acciones",
  "common.active": "Activo",
  "common.addTests": "Agregar pruebas",
  "common.aliquots": "alícuotas",
  "common.all": "Todos",
  "common.allStatuses": "Todos los estados",
  "common.analyzer": "Analizador",
  "common.analyzers": "Analizadores",
  "common.auditTrail": "Registro de Auditoría",
  "common.back": "Atrás",
  "common.boxId": "ID de caja",
  "common.byUnit": " Por unidad",
  "common.cancel": "Cancelar",
  "common.category": " Categoría",
  "common.clinical": "Clínico",
  "common.code": "Código",
  "common.collected": "Recolectado",
  "common.collectionDate": "Fecha de recolección",
  "common.complete": "Completado",
  "common.completed": "Completado",
  "common.confirm": "Confirmar",
  "common.correctiveActions": "Acciones correctivas",
  "common.createAliquot": "Crear alícuota",
  "common.critical": "Crítico",
  "common.dashboard": "Panel",
  "common.date": "Fecha",
  "common.dateRange": "Rango de fechas",
  "common.deactivate": "Desactivar",
  "common.delete": "Eliminar",
  "common.description": "Descripción",
  "common.draft": "Borrador",
  "common.edit": "Editar",
  "common.editOrder": " Editar orden",
  "common.email": "Correo Electrónico",
  "common.enterResults": "Introducir resultados",
  "common.error": "Error",
  "common.expired": "Caducado",
  "common.exportPdf": "Exportar a PDF",
  "common.failed": "Fallido",
  "common.filterByStatus": "Filtrar por estado",
  "common.firstName": "Primer Nombre",
  "common.from": "Desde",
  "common.generateReport": "Generar Reporte",
  "common.home": "Inicio",
  "common.inProgress": "En progreso",
  "common.inactive": "Inactivo",
  "common.labNumber": " Número de laboratorio",
  "common.lastName": "Apellido",
  "common.loading": "Cargando",
  "common.location": "Ubicación",
  "common.mean": "Media",
  "common.name": " Nombre",
  "common.nationalId": "ID Nacional",
  "common.new": "Nuevo",
  "common.none": "Ninguno",
  "common.normal": "Normal",
  "common.normalRange": "Rango Normal",
  "common.notCompleted": "Not Completed",
  "common.notes": "Notas",
  "common.order": "Orden",
  "common.overdue": "Atrasado",
  "common.panels": "Paneles",
  "common.participants": "Participantes",
  "common.patient": "Paciente",
  "common.pending": "Pendiente",
  "common.position": "Posición",
  "common.printLabel": "Imprimir etiqueta",
  "common.priority": " Prioridad",
  "common.program": " Programa",
  "common.programName": "Nombre del programa",
  "common.provider": "Proveedor",
  "common.quantity": "Cantidad",
  "common.reason": "Motivo",
  "common.received": "Recibido",
  "common.referenceLab": "Laboratorio de Referencia",
  "common.reject": " Rechazar",
  "common.remove": "Eliminar",
  "common.removeSelection": "Eliminar «{name}»",
  "common.reports": "Informes",
  "common.requester": " Solicitante",
  "common.result": "Resultado",
  "common.results": "Resultados",
  "common.room": "Sala",
  "common.routine": "Rutina",
  "common.sample": "Muestra",
  "common.sampleId": "N.º de muestra",
  "common.sampleManagement": "Gestión de muestras",
  "common.sampleType": " Tipo de muestra",
  "common.samples": "Muestras",
  "common.samplingSite": "Punto de muestreo",
  "common.save": "Guardar",
  "common.saveFailed": " Error al guardar",
  "common.saving": "Guardando...",
  "common.search": "Buscar",
  "common.select": "Seleccionar",
  "common.severity": " Severidad",
  "common.siteName": " Nombre del sitio",
  "common.species": "Especies",
  "common.standard": "Estándar",
  "common.status": "Estado",
  "common.storageLocation": "Ubicación de almacenamiento",
  "common.study": "Estudio",
  "common.test": "Prueba",
  "common.testName": " Nombre de la prueba",
  "common.tests": "Pruebas",
  "common.type": "Tipo",
  "common.unit": "Unidad",
  "common.user": " Usuario",
  "common.value": "Valor",
  "common.view": "Consultar",
  "common.warning": "Advertencia",
  "label.testCatalog.alerts.field.component": "Componente de resultado",
  "label.testCatalog.alerts.field.componentHelp": "Resultado que supervisa esta alerta. Si no se especifica nada, se supervisarán todos los componentes de esta prueba.",
  "label.testCatalog.alerts.field.sampleType": "Tipo de muestra",
  "label.testCatalog.alerts.field.sampleTypeHelp": "Qué muestra supervisa esta alerta. Si no se especifica, se supervisarán todos los tipos de muestra en los que se ejecute esta prueba.",
  "label.testCatalog.alerts.scope.anyComponent": "Cualquiera de los componentes",
  "label.testCatalog.alerts.scope.anySampleType": "Cualquiera de los tipos de muestra",
  "label.testCatalog.alerts.col.scope": "Se aplica a",
  "label.testCatalog.alerts.scope.wholeTest": "Prueba completa",
  "microbiology.ast.breakpointStandard": "Estándar de punto de corte",
  "microbiology.ast.hint": "Registre las lecturas de CMI o de zona, revise las interpretaciones y documente las sustituciones directamente aquí.",
  "microbiology.ast.noOverride": "Sin sustitución",
  "microbiology.ast.reading": "Lectura de AST",
  "microbiology.case.isolates.hint": "Agregue y identifique el crecimiento clínicamente significativo antes de la AST.",
  "microbiology.isolate.contaminant": "Contaminante",
  "microbiology.isolate.edit": "Editar aislado",
  "microbiology.isolate.identificationStatus": "Estado de identificación",
  "microbiology.isolate.normalFlora": "Flora normal",
  "microbiology.isolate.organism": "Organismo",
  "microbiology.isolate.organism.freeText": "Ingrese el organismo como texto libre",
  "microbiology.isolate.significant": "Clínicamente significativo",
  "microbiology.isolate.unknown": "Desconocido",
  "microbiology.isolate.update": "Guardar datos de identificación",
  "microbiology.enum.AST_REVIEW_REQUIRED": "Se requiere una revisión de AST",
  "microbiology.enum.AWAITING_RESULTS": "A la espera de los resultados",
  "microbiology.enum.ANTIBIOTIC_MAPPING_REQUIRED": "Se requiere la asignación de antibióticos",
  "microbiology.enum.CASE_FINALIZATION_REQUIRED": "Es necesario finalizar el caso",
  "microbiology.enum.AMENDED": "Modificado",
  "microbiology.enum.AMENDMENT_ACTION_FAILED": "La acción de modificación ha fallado",
  "microbiology.enum.CULTURE_PROTOCOL_CHANGED": "Se ha modificado el protocolo de cultivo",
  "microbiology.enum.AMENDMENT_ALREADY_OPEN": "La enmienda ya está abierta",
  "microbiology.enum.AMENDMENT_HISTORY_LOAD_FAILED": "No se ha podido cargar el historial de modificaciones",
  "microbiology.enum.AMENDMENT_IN_PROGRESS": "Modificación en progreso",
  "microbiology.enum.AMENDMENT_NEW_AST_RUN_REQUIRED": "Se requiere una nueva ejecución del AST para la modificación",
  "microbiology.enum.AMENDMENT_NOT_OPEN": "Enmienda no abierta",
  "microbiology.enum.AMENDMENT_REASON_REQUIRED": "Motivo de la modificación: Obligatorio",
  "microbiology.enum.AMENDMENT_REQUIRES_FINAL_RELEASE": "La enmienda requiere la liberación final",
  "microbiology.enum.ACKNOWLEDGED": "Confirmado",
  "microbiology.enum.AMENDMENT_CANCELLED": "Enmienda cancelada",
  "microbiology.enum.AMENDMENT_OPENED": "Enmienda abierta",
  "microbiology.enum.AMENDMENT_RELEASED": "Se ha liberado la enmienda",
  "microbiology.enum.AST_AMENDMENT_SOURCE_MUST_BE_REPORTABLE": "El AST de origen de la enmienda debe ser notificable",
  "microbiology.enum.AST_ANALYZER_FLAGS_ACKNOWLEDGED": "Se han confirmado los indicadores del analizador",
  "microbiology.enum.AST_ANALYZER_QC_FAILED": "CC del analizador fallido",
  "microbiology.enum.AST_ANALYZER_RESULTS_RECEIVED": "Se han recibido los resultados del Analizador",
  "microbiology.enum.AST_ATTEMPT_REASON_REQUIRED": "Motivo del intento de AST: obligatorio",
  "microbiology.enum.AST_ENTRY": "Entrada AST",
  "microbiology.enum.AST_IN_PROGRESS": "AST en progreso",
  "microbiology.enum.AST_READY": "AST listo",
  "microbiology.enum.AST_REPEAT_OR_RETEST_REQUIRED": "Es necesario repetir la prueba o realizar una nueva",
  "microbiology.enum.AST_REVIEW": "Revisión de AST",
  "microbiology.enum.AST_REVIEWED": "AST revisado",
  "microbiology.enum.AST_READING_OVERRIDDEN": "Se ha sustituido la lectura de AST",
  "microbiology.enum.AST_READING_RECORDED": "Se ha registrado el valor de AST",
  "microbiology.enum.AST_REPORTABLE_SELECTED": "Se ha seleccionado el AST sujeto a declaración",
  "microbiology.enum.AST_RUN_CREATED": "Se ha creado una ejecución de AST",
  "microbiology.enum.AST_RUN_INVALIDATED": "Ejecución de AST invalidada",
  "microbiology.enum.AST_RUN_METHOD_MISMATCH": "Discrepancia en el método de ejecución de AST",
  "microbiology.enum.AST_QC_OVERRIDDEN": "Se ha sustituido el CC de AST",
  "microbiology.enum.AST_SETUP_UNAVAILABLE": "Configuración de AST no disponible",
  "microbiology.enum.AST_SOURCE_RUN_REVIEW_REQUIRED": "Se requiere revisar la ejecución de AST de origen",
  "microbiology.enum.ANALYZER": "Analizador",
  "microbiology.enum.BROTH_MICRODILUTION": "Microdilución en caldo",
  "microbiology.enum.CASE": "Caso",
  "microbiology.enum.CASE_CREATED": "Caso creado",
  "microbiology.enum.CASE_REVIEW": "Revisión del caso",
  "microbiology.enum.CANCELLED": "Cancelado",
  "microbiology.enum.CLINICALLY_SIGNIFICANT": "Clínicamente significativo",
  "microbiology.enum.CLOSED": "Cerrado",
  "microbiology.enum.CONFIRMED": "Confirmado",
  "microbiology.enum.CONTAMINANT": "Contaminante",
  "microbiology.enum.CRITICAL_COMMUNICATION_ACKNOWLEDGED": "Se ha confirmado la comunicación crítica",
  "microbiology.enum.CRITICAL_COMMUNICATION_CLOSED": "Comunicación crítica cerrada",
  "microbiology.enum.CRITICAL_COMMUNICATION_LOGGED": "Se ha registrado una comunicación crítica",
  "microbiology.enum.CRITICAL_FOLLOW_UP_REQUIRED": "Se requiere seguimiento crítico",
  "microbiology.enum.DISK_DIFFUSION": "Difusión en disco",
  "microbiology.enum.EMAIL": "Correo Electrónico",
  "microbiology.enum.EMERGENCY": "Emergencia",
  "microbiology.enum.ETEST": "Etest",
  "microbiology.enum.FAILED": "Fallido",
  "microbiology.enum.FINAL": "Final",
  "microbiology.enum.FINAL_REPORT_RELEASED": "Se ha liberado el informe final",
  "microbiology.enum.GROWTH_DETECTED": "Se ha detectado un crecimiento",
  "microbiology.enum.HIGH": "Alto",
  "microbiology.enum.IDENTIFICATION": "Identificación",
  "microbiology.enum.ICU": "UCI",
  "microbiology.enum.INCUBATING": "En fase de incubación",
  "microbiology.enum.INPATIENT": "Hospitalización",
  "microbiology.enum.IN_PROGRESS": "En progreso",
  "microbiology.enum.MALDI_TOF": "MALDI-TOF",
  "microbiology.enum.IN_PERSON": "En persona",
  "microbiology.enum.INOCULATION_RECORDED": "Inoculación registrada",
  "microbiology.enum.ISOLATE": "Aislado",
  "microbiology.enum.ISOLATE_CREATED": "Se ha creado el aislado",
  "microbiology.enum.ISOLATE_ID": "Identificador del aislado",
  "microbiology.enum.ISOLATE_REQUIRED": "Se requiere un aislado",
  "microbiology.enum.ISOLATE_UPDATED": "Aislado actualizado",
  "microbiology.enum.LEGACY_UNSPECIFIED_MIC": "Técnica de CMI no especificada",
  "microbiology.enum.LEGACY_UNSPECIFIED_ZONE": "Técnica de zona no especificada",
  "microbiology.enum.MANUAL_NOTE": "Nota manual",
  "microbiology.enum.MANUAL_ENTRY": "Ingreso manual",
  "microbiology.enum.MIC": "CMI",
  "microbiology.enum.MICROBIOLOGY_INOCULATION_AUDIT_SERIALIZATION_FAILED": "No se ha podido registrar la auditoría de inoculación",
  "microbiology.enum.MICROBIOLOGY_PROTOCOL_AUDIT_SERIALIZATION_FAILED": "No se ha podido registrar la auditoría del protocolo",
  "microbiology.enum.MICROBIOLOGY_PROTOCOL_UNCHANGED": "Seleccione un protocolo diferente",
  "microbiology.enum.MICROBIOLOGY_PROTOCOL_WORKFLOW_REQUIRED": "Asigne un flujo de trabajo antes de seleccionar un protocolo",
  "microbiology.enum.MICROBIOLOGY_SUBCULTURE_SOURCE_CASE_MISMATCH": "El origen del subcultivo debe pertenecer a este caso",
  "microbiology.enum.MICROBIOLOGY_WORKFLOW_AUDIT_SERIALIZATION_FAILED": "No se ha podido registrar la auditoría del flujo de trabajo",
  "microbiology.enum.MICROBIOLOGY_WORKFLOW_CHANGE_CONFIRMATION_REQUIRED": "Confirmar la conservación del trabajo existente",
  "microbiology.enum.MICROBIOLOGY_WORKFLOW_CLASSIFICATION_REQUIRED": "Se requiere la clasificación del flujo de trabajo",
  "microbiology.enum.MICROBIOLOGY_WORKFLOW_METHOD_INCOMPATIBLE": "El método de cultivo no es compatible con el flujo de trabajo",
  "microbiology.enum.MICROBIOLOGY_WORKFLOW_NOT_SUPPORTED": "Este flujo de trabajo no es compatible",
  "microbiology.enum.MICROBIOLOGY_WORKFLOW_SIBLING_EXISTS": "Ya existe un caso en el que se aplica este flujo de trabajo",
  "microbiology.enum.MICROBIOLOGY_WORKFLOW_UNCHANGED": "Seleccione un flujo de trabajo diferente",
  "microbiology.enum.NO_GROWTH_READY": "Listo sin crecimiento",
  "microbiology.enum.NORMAL_FLORA": "Flora normal",
  "microbiology.enum.NEEDS_WORKFLOW": "Se necesita un flujo de trabajo",
  "microbiology.enum.NOT_READY": "No listo",
  "microbiology.enum.NONCONFORMANCE_REPORTED": "Se ha notificado una no conformidad",
  "microbiology.enum.NONE": "Ninguno",
  "microbiology.enum.OPEN": "Abierto",
  "microbiology.enum.ORGANISM_MAPPING_REQUIRED": "Se requiere la asignación de organismos",
  "microbiology.enum.ORGANISM": "Organismo",
  "microbiology.enum.ORIGINAL": "Original",
  "microbiology.enum.OTHER": "Otros",
  "microbiology.enum.OUTPATIENT": "Atención ambulatoria",
  "microbiology.enum.PENDING": "Pendiente",
  "microbiology.enum.PASSED": "Aprobado",
  "microbiology.enum.PHOENIX": "Phoenix",
  "microbiology.enum.PHONE": "Teléfono",
  "microbiology.enum.POSITIVE_SIGNAL": "Señal positiva",
  "microbiology.enum.PRELIM_RELEASED": "Liberado como preliminar",
  "microbiology.enum.PRELIMINARY": "Preliminar",
  "microbiology.enum.PRELIMINARY_RELEASED": "Liberado como preliminar",
  "microbiology.enum.PRELIMINARY_REPORT_RELEASED": "Se ha liberado el informe preliminar",
  "microbiology.enum.QC_FAILED": "CC fallido",
  "microbiology.enum.RECEIVED": "Recibido",
  "microbiology.enum.RELEASED": "Liberado",
  "microbiology.enum.REPEAT": "Repetición",
  "microbiology.enum.REPORTABLE_AST_RUN_REQUIRED": "Se requiere la realización de una prueba de AST sujeta a notificación",
  "microbiology.enum.REPORTABLE_AST_RUN_MUST_BE_REVIEWED": "Es necesario revisar la ejecución de AST que debe notificarse",
  "microbiology.enum.RESULT": "Resultado",
  "microbiology.enum.RESULTS_IN": "Resultados recibidos",
  "microbiology.enum.RETEST": "Repetir Prueba",
  "microbiology.enum.REVIEW_READY": "Listo para revisión",
  "microbiology.enum.REVIEWED": "Revisado",
  "microbiology.enum.INTERMEDIATE": "Intermedio",
  "microbiology.enum.LOST_SPECIMEN": "Muestra perdida",
  "microbiology.enum.LOST_SPECIMEN_POSITIVE": "Muestra extraviada - Cultivo positivo",
  "microbiology.enum.NO_BREAKPOINT": "Sin punto de corte",
  "microbiology.enum.RESISTANT": "Resistente",
  "microbiology.enum.ROUTINE": "Rutina",
  "microbiology.enum.SAMPLE_ITEM": "Elemento de muestra",
  "microbiology.enum.SETUP": "Configuración",
  "microbiology.enum.SETUP_RECORDED": "Configuración guardada",
  "microbiology.enum.SMS": "SMS",
  "microbiology.enum.SPECIMEN_LOST": "Pérdida de una muestra",
  "microbiology.enum.STAGE_CHANGED": "Cambio de etapa",
  "microbiology.enum.SUBCULTURE_RECORDED": "Subcultivo registrado",
  "microbiology.enum.UNASSIGNED": "Sin asignar",
  "microbiology.enum.UNKNOWN_ERROR": "Error desconocido",
  "microbiology.enum.VITEK_2": "VITEK 2",
  "microbiology.enum.WORKFLOW_CHANGED": "Se ha modificado el flujo de trabajo",
  "microbiology.enum.ZONE": "Zona",
  "microbiology.enum.FINAL_RELEASED": "Liberado como final",
  "microbiology.enum.SUSCEPTIBLE": "Susceptible",
  "microbiology.enum.UNKNOWN": "Desconocido",
  "rulebuilder.label.selectComponent": "Seleccionar componente",
  "testcalculation.label.selectComponent": "Seleccionar componente",
  "testcalculation.label.finalComponent": "Componente de resultado",
  "qc.dashboard.tab.bench": "Bench QC",
  "qc.bench.source.all": "All bench sources",
  "qc.bench.source.manual": "Manual quantitative",
  "qc.bench.source.rdt": "Rapid test (RDT)",
  "qc.bench.column.runs": "Controls run",
  "qc.bench.column.lastRun": "Last run",
  "qc.bench.empty": "No manual or rapid-test controls were recorded in this period.",
  "microbiology.case.activityNote": "Nota sobre la actividad",
  "microbiology.case.accessionNumber": "Número de acceso",
  "microbiology.case.actionError": "No se ha podido completar la acción de cultivo",
  "microbiology.case.action.markNoGrowth": "Marcar como listo sin crecimiento",
  "microbiology.case.action.recordGrowth": "Registrar crecimiento detectado",
  "microbiology.case.action.rejectCase": "Rechazar el caso",
  "microbiology.case.action.setIncubating": "Iniciar la incubación",
  "microbiology.case.action.startInoculation": "Iniciar la inoculación",
  "microbiology.case.createIsolate": "Crear aislado",
  "microbiology.case.cultureAction": "Acción de cultivo",
  "microbiology.case.atmosphere": "Atmósfera",
  "microbiology.case.eyebrow": "Banco de trabajo para casos de microbiología",
  "microbiology.case.sectionExpanded": "{section} ampliado",
  "microbiology.case.sectionStatus": "Estado de la sección",
  "microbiology.case.error": "Error en un caso de microbiología",
  "microbiology.case.isolateLabel": "Etiqueta del aislado",
  "microbiology.case.isolates": "Aislados",
  "microbiology.case.isolates.empty": "No se han registrado aislados",
  "microbiology.case.loadError": "No se ha podido cargar el caso de microbiología",
  "microbiology.case.lastActivityBy": "Última actividad de",
  "microbiology.case.incubation": "Incubación",
  "microbiology.case.media": "Medio o botella",
  "microbiology.case.nextStage": "Siguiente etapa",
  "microbiology.case.patient": "Paciente",
  "microbiology.case.nonconformanceCount": "{count, plural, one {# NCE} many {# NCEs} other {# NCEs}}",
  "microbiology.case.relatedWorkflows": "Flujos de trabajo relacionados con las muestras",
  "microbiology.case.requestingLocation": "Ubicación solicitante",
  "microbiology.case.preliminaryOrganism": "Organismo preliminar",
  "microbiology.case.recordActivity": "Registrar actividad",
  "microbiology.case.sampleItem": "Elemento de muestra",
  "microbiology.case.setup": "Inoculación",
  "microbiology.case.setup.hint": "Registre la configuración inicial, el medio o la fase de incubación de este caso de cultivo.",
  "microbiology.case.significance": "Importancia",
  "microbiology.case.specimenType": "Tipo de muestra",
  "microbiology.case.timeline": "Cronología del caso",
  "microbiology.case.timeline.addNote": "Agregar nota",
  "microbiology.case.timeline.auto": "Automático",
  "microbiology.case.timeline.culturePurposeChange": "{from} a {to}",
  "microbiology.case.timeline.culturePurposeChanged": "Se ha modificado la finalidad del cultivo",
  "microbiology.case.timeline.empty": "No se ha registrado ninguna actividad relacionada con el caso",
  "microbiology.case.timeline.hint": "La actividad registrada de los casos se muestra por orden cronológico.",
  "microbiology.case.timeline.manual": "Manual",
  "microbiology.case.timeline.note": "Nota u observación",
  "microbiology.case.timeline.noteExpanded": "Formulario de nota desplegado",
  "microbiology.case.timeline.performedBy": "Realizado por {actor}",
  "microbiology.case.timeline.saveNote": "Guardar nota",
  "microbiology.case.timeline.showAll": "Mostrar los {count} eventos",
  "microbiology.case.timeline.showRecent": "Mostrar los {count} eventos recientes",
  "microbiology.case.events": "eventos",
  "microbiology.case.finalLocked.message": "Los cambios en aislados y AST quedan desactivados tras la liberación final.",
  "microbiology.case.finalLocked.title": "El caso final es de solo lectura",
  "microbiology.case.title": "Caso de microbiología",
  "microbiology.inoculation.addSubculture": "Agregar subcultivo",
  "microbiology.inoculation.empty": "Aún no se ha registrado ningún medio. Inicie la inoculación para comenzar.",
  "microbiology.inoculation.hint": "Registre cada frasco o placa y conserve su linaje de cultivo.",
  "microbiology.inoculation.identifier": "ID del frasco o de la placa",
  "microbiology.inoculation.identifierHint": "Escanee o ingrese el identificador.",
  "microbiology.inoculation.parent": "Medio de origen",
  "microbiology.inoculation.parentPlaceholder": "Elija el frasco o la placa de origen",
  "microbiology.inoculation.primaryExpanded": "Formulario de inoculación desplegado",
  "microbiology.inoculation.primary": "Primaria",
  "microbiology.inoculation.recorded": "Medios registrados",
  "microbiology.inoculation.save": "Guardar medio",
  "microbiology.inoculation.source": "Fuente",
  "microbiology.inoculation.start": "Iniciar la inoculación",
  "microbiology.inoculation.subcultureExpanded": "Formulario de subcultivo desplegado",
  "microbiology.inoculation.subculture": "Subcultivo",
  "microbiology.amendment.actionError": "No se ha podido completar la acción de modificación",
  "microbiology.amendment.cancel": "Cancelar la modificación",
  "microbiology.amendment.cancelReason": "Motivo de la cancelación",
  "microbiology.amendment.cancelled": "La modificación se ha cancelado; el caso definitivo vuelve a estar bloqueado",
  "microbiology.amendment.correctsVersion": "Se corrige la versión {number}",
  "microbiology.amendment.hint": "Corrija un informe final sin reemplazar su historial de versiones liberadas.",
  "microbiology.amendment.history": "Historial de modificaciones",
  "microbiology.amendment.inProgress.message": "Registre la corrección y libere o cancele esta modificación para volver a bloquear el caso.",
  "microbiology.amendment.inProgress.title": "Modificación en progreso",
  "microbiology.amendment.noReportVersions": "No se han registrado versiones del informe final",
  "microbiology.amendment.none": "No se han registrado enmiendas",
  "microbiology.amendment.number": "Enmienda",
  "microbiology.amendment.numberValue": "Enmienda {number}",
  "microbiology.amendment.open": "Abrir enmienda",
  "microbiology.amendment.opened": "Se ha abierto la enmienda; ya se permiten las correcciones clínicas",
  "microbiology.amendment.reason": "Motivo de la modificación",
  "microbiology.amendment.release": "Liberar el informe modificado",
  "microbiology.amendment.released": "Se ha liberado el informe modificado; el caso vuelve a estar bloqueado",
  "microbiology.amendment.reportVersions": "Versiones liberadas del informe",
  "microbiology.amendment.status": "Estado",
  "microbiology.amendment.status.closed": "No hay ninguna enmienda pendiente",
  "microbiology.amendment.status.open": "Enmienda abierta",
  "microbiology.amendment.title": "Enmiendas",
  "microbiology.amendment.version": "Versión {number}",
  "microbiology.ast.antibiotic": "Antibiótico",
  "microbiology.ast.acceptResults": "Aceptar los resultados",
  "microbiology.ast.acknowledgeFlags": "Confirmar los indicadores revisados",
  "microbiology.ast.analyzer": "Analizador",
  "microbiology.ast.analyzerOrganism": "Organismo del analizador: {organism} ({confidence}%)",
  "microbiology.ast.analyzerProvenance": "Tarjeta o panel {card} · software {version}",
  "microbiology.ast.analyzerResolutionReason": "Motivo y acción correctiva",
  "microbiology.ast.actionError": "No se ha podido completar la acción AST",
  "microbiology.ast.adjustPanel": "Ajustar panel",
  "microbiology.ast.orderedAntibiotics": "Antibióticos que se van a probar",
  "microbiology.ast.actions": "Acciones",
  "microbiology.ast.applyOverride": "Aplicar la sustitución",
  "microbiology.ast.attempt": "Intento",
  "microbiology.ast.attemptMethod": "Método de intento",
  "microbiology.ast.attemptNumber": "Intento {number}",
  "microbiology.ast.attemptReason": "Motivo",
  "microbiology.ast.attemptScope": "Ámbito de repetición",
  "microbiology.ast.attempts": "Intentos de AST",
  "microbiology.ast.attemptType": "Tipo de intento",
  "microbiology.ast.awaitingAnalyzerResults": "A la espera de los resultados del analizador",
  "microbiology.ast.awaitingAnalyzerResultsDetail": "Los resultados aparecerán automáticamente cuando el analizador conectado los envíe. Los eventos no emparejados se conservan en la sección «Problemas de importación del Analizador».",
  "microbiology.ast.awaitingSetupCount": "{count} a la espera de configuración",
  "microbiology.ast.cardId": "N.º de identificación de la tarjeta o del panel",
  "microbiology.ast.entryMode": "Ingreso de resultados",
  "microbiology.ast.entryMode.analyzer": "Analizador conectado",
  "microbiology.ast.entryMode.manual": "Ingreso manual",
  "microbiology.ast.expertFlags": "Los indicadores expertos del analizador requieren revisión",
  "microbiology.ast.hideOriginal": "Ocultar el historial",
  "microbiology.ast.historyTo": "a",
  "microbiology.ast.interpretation": "Interpretación",
  "microbiology.ast.instrumentInterpretation": "Analizador: {interpretation}",
  "microbiology.ast.invalidateAndRepeat": "Anular y iniciar una nueva ejecución",
  "microbiology.ast.includedInReport": "Incluido en el informe",
  "microbiology.ast.initialAttemptReason": "Primer intento",
  "microbiology.ast.isolate": "Aislado",
  "microbiology.ast.method": "Método",
  "microbiology.ast.matchedBy": "Punto de corte coincidente",
  "microbiology.ast.measurement.mic": "CMI (ug/mL)",
  "microbiology.ast.measurement.zone": "Diámetro de la zona (mm)",
  "microbiology.ast.noBreakpointGuidance": "No existe un punto de corte estándar. Interprete este resultado de acuerdo con el procedimiento operativo estándar (SOP) local.",
  "microbiology.ast.noBreakpointTitle": "Se requiere interpretación local",
  "microbiology.ast.noIsolate": "Cree un aislado antes de registrar la AST",
  "microbiology.ast.noSourceAttempt": "Intento original",
  "microbiology.ast.notIncludedInReport": "No incluido",
  "microbiology.ast.newAttempt": "Nueva repetición o repetición de prueba",
  "microbiology.ast.noRunsYet": "Aún no hay ejecuciones",
  "microbiology.ast.antibioticToRepeat": "Antibiótico que debe repetirse",
  "microbiology.ast.override": "Sustituir interpretación",
  "microbiology.ast.overrideHistory": "Historial de sustituciones",
  "microbiology.ast.optionsExpanded": "Opciones de {section} desplegadas.",
  "microbiology.ast.overrideReason": "Motivo de la sustitución",
  "microbiology.ast.orderedPanel": "Panel AST solicitado",
  "microbiology.ast.organismMismatch": "El organismo del analizador difiere del aislado del caso",
  "microbiology.ast.organismMismatchDetail": "La identificación del analizador tiene carácter meramente informativo. Revise la discrepancia; el aislado del caso confirmado sigue siendo el de referencia.",
  "microbiology.ast.overrideQc": "Sustituir el indicador de CC",
  "microbiology.ast.panel": "Panel AST",
  "microbiology.ast.panelAdjustmentReason": "Motivo del ajuste del panel",
  "microbiology.ast.panelProvenance.organismDefault": "Solicitado según la configuración predeterminada del organismo identificado",
  "microbiology.ast.rawValue": "Valor del resultado",
  "microbiology.ast.qcFailed": "Ha fallado el CC del analizador",
  "microbiology.ast.qcFailedDetail": "Referencia de CC: {reference}. La aceptación de los resultados queda bloqueada hasta que se invalide esta ejecución o un supervisor documente una sustitución.",
  "microbiology.ast.replacementCardId": "N.º de identificación de la nueva tarjeta o del nuevo panel",
  "microbiology.ast.resultsReady": "Los resultados del Analizador están listos para su revisión",
  "microbiology.ast.resultsReadyDetail": "Revise las discrepancias, los puntos de ruptura que falten y las indicaciones de los expertos antes de aceptar estos resultados.",
  "microbiology.ast.runsComplete": "{complete} / {total} ejecuciones completadas",
  "microbiology.ast.pendingIdentificationCount": "{count} pendiente de identificación",
  "microbiology.ast.reasonForAttempt": "Motivo de la repetición o de la Repetir Prueba",
  "microbiology.ast.recordReading": "Registrar lectura de AST",
  "microbiology.ast.reviewRun": "Revisar ejecución de AST",
  "microbiology.ast.repeat": "Repetir",
  "microbiology.ast.revertOverride": "Volver a la versión original",
  "microbiology.ast.revertReason": "Motivo para revertir la sustitución",
  "microbiology.ast.reporting": "Informes",
  "microbiology.ast.retest": "Repetir Prueba",
  "microbiology.ast.selectAntibiotic": "Seleccione un antibiótico",
  "microbiology.ast.singleAntibiotic": "Un único antibiótico",
  "microbiology.ast.wholePanel": "Panel completo",
  "microbiology.ast.runStatus": "Estado de la ejecución de AST",
  "microbiology.ast.startRun": "Iniciar la ejecución de AST",
  "microbiology.ast.startAttempt": "Iniciar un intento de «{type}»",
  "microbiology.ast.sourceAttempt": "Fuente",
  "microbiology.ast.source": "Fuente de lectura",
  "microbiology.ast.showOriginal": "Mostrar el original",
  "microbiology.ast.title": "AST manual",
  "microbiology.ast.useAttemptForReporting": "Usar el intento {number} para el informe",
  "microbiology.ast.useForReporting": "Utilizar para la elaboración de informes",
  "microbiology.ast.view": "Consultar",
  "microbiology.ast.viewAttempt": "Consultar intento: {number}",
  "microbiology.ast.viewing": "Consultando",
  "microbiology.ast.viewingAttempt": "Consultando el intento {number}",
  "microbiology.critical.acknowledge": "Confirmar",
  "microbiology.critical.followUp": "Es necesario realizar un seguimiento",
  "microbiology.critical.hint": "Registre las llamadas de resultados críticos y confirme su recepción directamente aquí.",
  "microbiology.critical.log": "Registrar comunicación",
  "microbiology.critical.logForIsolate": "Registrar una notificación crítica para {isolate}",
  "microbiology.critical.logNotification": "Registrar una notificación crítica",
  "microbiology.critical.method": "Método de comunicación",
  "microbiology.critical.message": "Mensaje",
  "microbiology.critical.messageRequired": "Es obligatorio introducir un mensaje",
  "microbiology.critical.none": "No se han registrado comunicaciones críticas",
  "microbiology.critical.recipient": "Destinatario",
  "microbiology.critical.recipientContact": "Datos de contacto del destinatario",
  "microbiology.critical.required": "Elija un destino e indique el destinatario y el mensaje.",
  "microbiology.critical.resolution": "Nota sobre la resolución",
  "microbiology.critical.resolutionRequired": "Es necesario incluir una nota de resolución antes de dar por concluida la comunicación.",
  "microbiology.critical.close": "Cerrar comunicación",
  "microbiology.critical.target": "Objetivo de resultado crítico",
  "microbiology.critical.targetId": "Registro de destino",
  "microbiology.critical.title": "Comunicación crítica",
  "microbiology.caseInfo.no": "No",
  "microbiology.caseInfo.notProvided": "No se ha facilitado",
  "microbiology.caseInfo.summary": "Resumen de la información del caso",
  "microbiology.caseInfo.yes": "Sí",
  "microbiology.currentStep.open": "Abrir {step}",
  "microbiology.currentStep.title": "Paso actual",
  "microbiology.cultureAction.error": "No se ha podido actualizar el estado del cultivo.",
  "microbiology.cultureAction.noGrowth.confirm": "Confirme que no ha habido crecimiento",
  "microbiology.cultureAction.noGrowth.detail": "Confirme que el periodo de incubación requerido esté completado y que no se haya detectado ningún crecimiento.",
  "microbiology.cultureAction.noGrowth.title": "Marque el cultivo como «sin crecimiento»",
  "microbiology.cultureAction.positive.confirm": "Confirmar señal positiva",
  "microbiology.cultureAction.positive.detail": "Confirme la señal positiva. El siguiente paso consiste en realizar un cultivo secundario y registrar el resultado de la tinción de Gram.",
  "microbiology.cultureAction.positive.title": "Marcar el cultivo como positivo",
  "microbiology.nce.category": "Categoría",
  "microbiology.nce.configurationBlockerTitle": "Se requiere configuración",
  "microbiology.nce.configurationLoadError": "No se han podido cargar las categorías NCE y las unidades informantes.",
  "microbiology.nce.critical": "Crítico",
  "microbiology.nce.description": "Descripción",
  "microbiology.nce.disposition": "Disposición",
  "microbiology.nce.errorTitle": "No se ha podido notificar la no conformidad",
  "microbiology.nce.flagOnly": "Solo marcar",
  "microbiology.nce.immediateAction": "Acción inmediata",
  "microbiology.nce.lostTypeMissing": "La configuración activa de NCE no incluye el tipo «Pérdida de muestra».",
  "microbiology.nce.major": "Mayor",
  "microbiology.nce.markLost": "Marcar como perdida",
  "microbiology.nce.markLostHint": "Registre la muestra física como perdida y rechace las pruebas en curso afectadas.",
  "microbiology.nce.markLostTitle": "Marcar la muestra como perdida",
  "microbiology.nce.minor": "Menor",
  "microbiology.nce.rejectTests": "Rechazar las pruebas afectadas",
  "microbiology.nce.retest": "Repetir la prueba de AST",
  "microbiology.nce.retestLoadError": "No se han podido cargar las ejecuciones de AST revisadas. Inténtelo de nuevo antes de seleccionar «Repetir la prueba de AST».",
  "microbiology.nce.sourceAstRun": "Ejecución de AST que se repetirá",
  "microbiology.nce.report": "Notificar NCE",
  "microbiology.nce.reportHint": "Registre una no conformidad relacionada con esta muestra y elija su resolución.",
  "microbiology.nce.reportingUnit": "Unidad informante",
  "microbiology.nce.reportTitle": "Notificar no conformidad",
  "microbiology.nce.required": "Seleccione una categoría, una unidad informante y una severidad, y facilite una descripción.",
  "microbiology.nce.sectionTitle": "No conformidad",
  "microbiology.nce.severity": "Severidad",
  "microbiology.nce.submitError": "No ha sido posible guardar la no conformidad.",
  "microbiology.nce.title": "Título",
  "microbiology.nce.type": "Tipo",
  "microbiology.isolate.identify": "Identificar organismo",
  "microbiology.isolate.reidentify": "Reidentificar",
  "microbiology.isolate.identified": "Identificado",
  "microbiology.isolate.pending": "Identificación pendiente",
  "microbiology.isolate.gramStain": "Tinción de Gram",
  "microbiology.isolate.colonyMorphology": "Morfología de la colonia",
  "microbiology.isolate.identification": "Identificación",
  "microbiology.isolate.identificationMethod": "Método de identificación",
  "microbiology.isolate.identificationConfidence": "Confianza en la identificación (%)",
  "microbiology.isolate.identificationChange": "{previous} a {next}: {reason}",
  "microbiology.isolate.identificationHistory": "Historial de identificación",
  "microbiology.isolate.identificationReason": "Motivo de la reidentificación",
  "microbiology.isolate.organism.select": "Seleccione un organismo",
  "microbiology.isolate.unidentified": "Sin identificar",
  "microbiology.ast.identificationRequired": "Identifique la cepa antes de realizar la prueba de sensibilidad a los antibióticos.",
  "microbiology.next.createIsolate": "Se ha registrado la inoculación. Agregue si se ha producido un crecimiento significativo o marque el caso como listo para su tratamiento en caso de ausencia de crecimiento.",
  "microbiology.next.completeAmendment": "La enmienda está abierta. Registre la corrección, revise el informe y, a continuación, libere la versión modificada.",
  "microbiology.next.finalReleased": "Se ha liberado el informe final. Revise la preparación para la vigilancia antes de exportar.",
  "microbiology.next.incubating": "Incubación. Marque el caso como positivo cuando se detecte crecimiento, o marque «sin crecimiento» cuando el periodo de incubación requerido esté completado.",
  "microbiology.next.subculturePositive": "Se ha registrado una señal positiva. Realice un subcultivo del frasco y registre el resultado de la tinción de Gram.",
  "microbiology.next.recordSetup": "Se ha recibido el caso. Registre la configuración inicial para iniciar la incubación.",
  "microbiology.next.release": "AST revisado. Confirme que el informe está listo y libere el informe final.",
  "microbiology.next.noGrowthRelease": "No se ha registrado ningún crecimiento. Revise y libere el informe negativo definitivo.",
  "microbiology.next.reviewAst": "Aislado registrado. Complete y revise el AST antes de la liberación.",
  "microbiology.next.title": "Siguiente paso",
  "microbiology.navigation.backToWorklist": "Volver a la lista de trabajo de microbiología",
  "microbiology.navigation.menu": "Microbiología",
  "microbiology.navigation.worklist": "Lista de trabajo de microbiología",
  "order.context.workflowProgress": "Estado del proceso de tramitación de las órdenes",
  "microbiology.culturePurpose.clinical": "Diagnóstico o tratamiento clínico",
  "microbiology.culturePurpose.label": "Finalidad del cultivo",
  "microbiology.culturePurpose.screening": "Detección activa o portador",
  "microbiology.culturePurpose.unspecified": "Sin especificar",
  "microbiology.orderDetail.antibioticExposure": "El paciente ha recibido antibióticos recientemente (en las últimas dos semanas)",
  "microbiology.orderDetail.admissionDate": "Fecha de ingreso",
  "microbiology.orderDetail.admissionDateFuture": "La fecha de admisión no puede ser futura.",
  "microbiology.orderDetail.admissionDateHelper": "Fecha de ingreso hospitalario. Déjelo en blanco si se desconoce.",
  "microbiology.orderDetail.admissionDateOutpatient": "Los pacientes ambulatorios no se hospitalizan; se registran como de origen comunitario.",
  "microbiology.orderDetail.collectionDateContext": "Fecha de recolección: {date}",
  "microbiology.orderDetail.collectionTimingHospital": "Recolectada {days} días después del ingreso: origen hospitalario para vigilancia.",
  "microbiology.orderDetail.collectionTimingCommunity": "Recolectada {days} días después del ingreso: origen comunitario para vigilancia.",
  "microbiology.orderDetail.clinicalHistory": "Historia clínica",
  "microbiology.orderDetail.cultureMethod": "Protocolo de cultivo",
  "microbiology.orderDetail.hint": "Recopile el contexto de la orden que el laboratorio necesita para preparar el cultivo y dar seguimiento a los resultados críticos.",
  "microbiology.orderDetail.numberOfSets": "Número de series",
  "microbiology.orderDetail.numberOfSets.helper": "Grupos de muestras, como dos conjuntos de hemocultivos extraídos de diferentes lugares. No se trata del número ni del volumen de las muestras.",
  "microbiology.orderDetail.patientOrigin": "Procedencia de los pacientes",
  "microbiology.orderDetail.protocolDerived": "Derivado",
  "microbiology.orderDetail.protocolHelper": "Desde la prueba solicitada. Modifíquelo en el banco si el procesamiento difiere.",
  "microbiology.orderDetail.protocolUnset": "No establecido: el banco seleccionará un protocolo",
  "microbiology.orderDetail.protocolUnsetTitle": "Protocolo no configurado",
  "microbiology.orderDetail.save": "Guardar los detalles de la orden",
  "microbiology.orderDetail.title": "Detalles de la orden",
  "microbiology.patientOrigin.emergency": "Servicio de urgencias",
  "microbiology.patientOrigin.icu": "Unidad de cuidados intensivos",
  "microbiology.patientOrigin.inpatient": "Sala de hospitalización",
  "microbiology.patientOrigin.other": "Otros",
  "microbiology.patientOrigin.outpatient": "Consulta externa",
  "microbiology.progress.ast": "Resultados de la AST",
  "microbiology.progress.caseInfo": "Información sobre el caso",
  "microbiology.progress.inoculation": "Inoculación",
  "microbiology.progress.isolates": "Aislados",
  "microbiology.progress.reports": "Informes",
  "microbiology.progress.review": "Revisión por expertos",
  "microbiology.progress.timeline": "Cronología",
  "microbiology.progress.title": "Evolución del caso",
  "microbiology.protocol.noneTitle": "No se ha establecido ningún protocolo",
  "microbiology.case.timeline.protocolChanged": "El protocolo de cultivo ha cambiado de {from} a {to}: {reason}",
  "microbiology.readiness.blocked": "Liberación final bloqueada",
  "microbiology.readiness.ready": "Listo para la liberación final",
  "microbiology.reagentLots.blocked": "Bloqueado: {reason}",
  "microbiology.reagentLots.context": "Contexto del banco",
  "microbiology.reagentLots.context.AST_SETUP": "Configuración de AST",
  "microbiology.reagentLots.context.CULTURE_SETUP": "Configuración del cultivo",
  "microbiology.reagentLots.empty": "No hay reactivos asociados a esta prueba.",
  "microbiology.reagentLots.fefo": "FEFO: «utilizar primero»",
  "microbiology.reagentLots.fifo.tooltip": "Los lotes se ordenan por fecha de caducidad más temprana y, cuando no se dispone de dicha fecha, por fecha de recepción.",
  "microbiology.reagentLots.hint": "Seleccione el lote exacto utilizado para cada reactivo o consumible vinculado.",
  "microbiology.reagentLots.history": "Uso registrado de los lotes",
  "microbiology.reagentLots.legend": "Lotes disponibles de {reagent}",
  "microbiology.reagentLots.lot": "Lote",
  "microbiology.reagentLots.noExpiry": "No se ha registrado ninguna fecha de caducidad",
  "microbiology.reagentLots.noLots": "No hay lotes en stock disponibles para este reactivo.",
  "microbiology.reagentLots.option": "{lot}, {quantity} {unit} disponible, caduca el {expiration}",
  "microbiology.reagentLots.quantity": "{quantity} {unit}",
  "microbiology.reagentLots.quantityPerTest": "Cantidad por prueba: {quantity} {unit}",
  "microbiology.reagentLots.conflict.INVENTORY_LOT_EXPIRED": "El lote {lot} de {reagent} ha caducado; elija otro lote.",
  "microbiology.reagentLots.conflict.INVENTORY_LOT_INSUFFICIENT_QUANTITY": "El lote {lot} de {reagent} ya no dispone de cantidad suficiente; elija otro lote.",
  "microbiology.reagentLots.conflict.INVENTORY_LOT_QC_FAILED": "El lote {lot} de {reagent} no superó el CC; elija un lote con CC aprobado.",
  "microbiology.reagentLots.conflict.INVENTORY_LOT_QC_NOT_PASSED": "El lote {lot} de {reagent} no tiene el CC aprobado; elija un lote con CC aprobado.",
  "microbiology.reagentLots.conflict.INVENTORY_LOT_UNAVAILABLE": "El lote {lot} de {reagent} ya no está disponible; actualice la página y elija otro lote.",
  "microbiology.reagentLots.qc.FAILED": "CC fallido",
  "microbiology.reagentLots.qc.PASSED": "CC aprobado",
  "microbiology.reagentLots.qc.PENDING": "CC pendiente",
  "microbiology.reagentLots.qc.QUARANTINED": "En cuarentena por CC",
  "microbiology.reagentLots.reason.INVENTORY_LOT_CONSUMED": "Consumido",
  "microbiology.reagentLots.reason.INVENTORY_LOT_EXPIRED": "Caducado",
  "microbiology.reagentLots.reason.INVENTORY_LOT_INACTIVE": "Inactivo",
  "microbiology.reagentLots.reason.INVENTORY_LOT_INSUFFICIENT_QUANTITY": "Cantidad insuficiente",
  "microbiology.reagentLots.reason.INVENTORY_LOT_QC_FAILED": "CC fallido",
  "microbiology.reagentLots.reason.INVENTORY_LOT_QC_NOT_PASSED": "CC no aprobado",
  "microbiology.reagentLots.reagent": "Reactivo o material fungible",
  "microbiology.reagentLots.recorded": "Registrado",
  "microbiology.reagentLots.role.PRIMARY": "Primaria",
  "microbiology.reagentLots.role.SECONDARY": "Secundaria",
  "microbiology.reagentLots.scan.ambiguous": "Ese número de lote coincide con más de un reactivo asociado. Seleccione el lote en su lista de reactivos.",
  "microbiology.reagentLots.scan.label": "Escanee o ingrese el número de lote",
  "microbiology.reagentLots.scan.notFound": "No hay ningún lote vinculado que coincida con ese número de lote.",
  "microbiology.reagentLots.scan.placeholder": "Escanee o ingrese el número de lote exacto",
  "microbiology.reagentLots.scan.selected": "Lote seleccionado: {lot}.",
  "microbiology.reagentLots.status": "Estado actual del lote",
  "microbiology.reagentLots.status.ACTIVE": "Activo",
  "microbiology.reagentLots.status.CONSUMED": "Consumido",
  "microbiology.reagentLots.status.IN_USE": "En uso",
  "microbiology.reagentLots.title": "Trazabilidad de los reactivos y los lotes",
  "microbiology.reagentLots.used": "Cantidad utilizada",
  "microbiology.release.failed": "No se ha podido liberar el informe. Revise los requisitos e inténtelo de nuevo.",
  "microbiology.release.final": "Liberar el informe final",
  "microbiology.release.finalReleased": "Se ha liberado el informe final",
  "microbiology.release.hint": "Libere los informes únicamente cuando se superen las comprobaciones de preparación.",
  "microbiology.release.mappingConfigured": "Se ha configurado la asignación del informe del paciente",
  "microbiology.release.mappingRequired": "Se requiere la asignación del informe del paciente para la liberación final",
  "microbiology.release.noReportableContent": "No hay contenido de microbiología notificable listo.",
  "microbiology.release.notEvaluated": "Aún no se ha evaluado el grado de preparación",
  "microbiology.release.patientReport": "Vista previa del informe del paciente",
  "microbiology.release.preliminary": "Liberar el informe preliminar",
  "microbiology.release.readinessChecks": "Preparación para la liberación final",
  "microbiology.release.title": "Estado de preparación del informe",
  "microbiology.release.viewPatientResults": "Consultar los resultados de los pacientes",
  "microbiology.release.useAmendment": "Libere la versión corregida desde Enmiendas",
  "microbiology.release.whonetChecks": "Preparación para WHONET",
  "microbiology.whonet.blocked": "Se ha bloqueado la exportación de WHONET",
  "microbiology.whonet.ready": "Listo para exportar a WHONET",
  "microbiology.worklist.clearFilters": "Limpiar filtros",
  "microbiology.worklist.column.action": "Acción",
  "microbiology.worklist.column.context": "Contexto",
  "microbiology.worklist.column.due": "Acción pendiente",
  "microbiology.worklist.column.flags": "Indicadores",
  "microbiology.worklist.column.isolate": "Aislado",
  "microbiology.worklist.column.labNumber": "N.º de laboratorio",
  "microbiology.worklist.column.lastActivity": "Última actividad de",
  "microbiology.worklist.column.organism": "Organismo",
  "microbiology.worklist.column.panel": "Panel",
  "microbiology.worklist.column.patient": "Paciente",
  "microbiology.worklist.column.priority": "Prioridad",
  "microbiology.worklist.column.sample": "Elemento de muestra",
  "microbiology.worklist.column.specimen": "Muestra",
  "microbiology.worklist.column.stage": "Etapa",
  "microbiology.worklist.column.started": "Iniciado",
  "microbiology.worklist.column.status": "Estado",
  "microbiology.worklist.column.urgency": "Urgencia",
  "microbiology.worklist.critical": "Comunicación crítica",
  "microbiology.worklist.dueDetail.ast_entry": "Configure el AST para el aislado identificado.",
  "microbiology.worklist.dueDetail.ast_review": "Revise los resultados de la prueba de sensibilidad comunicados.",
  "microbiology.worklist.dueDetail.case_review": "Revise el estado del informe y su liberación.",
  "microbiology.worklist.dueDetail.isolate_id": "Registre el crecimiento e identifique la cepa aislada.",
  "microbiology.worklist.dueDetail.incubating": "Día {day} de {max}",
  "microbiology.worklist.dueDetail.setup": "Anote la configuración inicial del cultivo.",
  "microbiology.worklist.dueDetail.subculture_gram_stain": "Realice un subcultivo y registre la tinción de Gram.",
  "microbiology.worklist.empty.ast": "No se han encontrado ejecuciones de AST que coincidan. Limpie la búsqueda o seleccione un estado diferente.",
  "microbiology.worklist.empty.cultures": "No hay cultivos que coincidan. Limpie la búsqueda o seleccione un estado diferente.",
  "microbiology.worklist.expertRulesUnavailable": "En la fase 1B están disponibles los indicadores de reglas de expertos de OpenELIS. Los indicadores generados por el Analizador se muestran cuando están presentes.",
  "microbiology.worklist.filters": "Filtros de la lista de trabajo",
  "microbiology.worklist.filter.allActions": "Todas las acciones",
  "microbiology.worklist.filter.allStages": "Todas las etapas",
  "microbiology.worklist.filter.allUrgencies": "Todos los niveles de urgencia",
  "microbiology.worklist.filter.activeAst": "Trabajo activo",
  "microbiology.worklist.filter.astStatus": "Estado de AST",
  "microbiology.worklist.filter.dueAction": "Acción pendiente",
  "microbiology.worklist.filter.reviewed": "Revisado",
  "microbiology.worklist.filter.stage": "Etapa",
  "microbiology.worklist.filter.urgency": "Urgencia",
  "microbiology.worklist.flagsUnavailable": "Reglas expertas (Fase 1B)",
  "microbiology.worklist.loadError.subtitle": "No se ha podido cargar la cola. Intente actualizar la página.",
  "microbiology.worklist.loadError.title": "No se ha podido cargar la lista de trabajo de microbiología",
  "microbiology.worklist.editAst": "Editar AST",
  "microbiology.worklist.grain.ast": "Ejecuciones de AST",
  "microbiology.worklist.grain.cultures": "Cultivos",
  "microbiology.worklist.notSet": "No se ha establecido",
  "microbiology.worklist.notStarted": "Aún no se ha iniciado",
  "microbiology.worklist.markLost": "Marcar como perdido",
  "microbiology.worklist.markNoGrowth": "Marcar sin crecimiento",
  "microbiology.worklist.markPositive": "Marque como positivo",
  "microbiology.worklist.openCase": "Abrir caso",
  "microbiology.worklist.newAstAttempt": "Configurar una nueva ejecución de AST",
  "microbiology.worklist.newPositive": "Nuevo caso positivo",
  "microbiology.worklist.phase1b": "Disponible en la fase 1B",
  "microbiology.worklist.print": "Imprimir lista",
  "microbiology.worklist.qcDashboard": "Panel de CC",
  "microbiology.worklist.queueStatus": "Cola compartida",
  "microbiology.worklist.refresh": "Actualizar ahora",
  "microbiology.worklist.rowActions": "Acciones de fila",
  "microbiology.worklist.recentActivity.empty": "No se han registrado actividades recientes en el ámbito de la microbiología.",
  "microbiology.worklist.recentActivity.title": "Actividad reciente ({count})",
  "microbiology.worklist.resistance.hint": "Las alertas notificadas por el Analizador se han resuelto hoy; la detección mediante reglas de expertos de OpenELIS sigue en la Fase 1B.",
  "microbiology.worklist.resistance.title": "Hallazgos de resistencia de hoy",
  "microbiology.worklist.search.ast": "Busque por número de laboratorio, paciente, aislado, organismo o panel",
  "microbiology.worklist.search.cultures": "Busque por número de laboratorio, paciente o muestra",
  "microbiology.worklist.sharedQueue": "Cola compartida del laboratorio",
  "microbiology.worklist.setupAst": "Configurar AST",
  "microbiology.worklist.sort": "Ordenar",
  "microbiology.worklist.sort.newest": "Actividad más reciente",
  "microbiology.worklist.sort.priority": "Prioridad",
  "microbiology.worklist.sort.workflow": "Flujo de trabajo",
  "microbiology.worklist.subtitle": "Priorice los casos de cultivos según la etapa del flujo de trabajo, la urgencia y la acción de laboratorio necesaria.",
  "microbiology.worklist.summary.astReview": "Revisión de AST",
  "microbiology.worklist.summary.astInProgress": "En progreso",
  "microbiology.worklist.summary.astInQueue": "En cola",
  "microbiology.worklist.summary.astPendingSetup": "Configuración pendiente",
  "microbiology.worklist.summary.astResultsIn": "Resultados recibidos: revisión",
  "microbiology.worklist.summary.caseReview": "Listo para la revisión del caso",
  "microbiology.worklist.summary.critical": "Seguimientos críticos pendientes",
  "microbiology.worklist.summary.growthDetected": "Se ha detectado un crecimiento",
  "microbiology.worklist.summary.hint": "Seleccione una cola para actualizar la lista de casos.",
  "microbiology.worklist.summary.identification": "Identificación en progreso",
  "microbiology.worklist.summary.incubating": "En fase de incubación",
  "microbiology.worklist.summary.positive": "Positivo",
  "microbiology.worklist.summary.expertFlags": "Indicadores de experto (1B)",
  "microbiology.worklist.summary.title": "Tareas que requieren acción",
  "microbiology.worklist.summary.totalPending": "Total pendiente",
  "microbiology.worklist.table.hint": "Los casos se ordenan según su urgencia y la siguiente acción que se debe llevar a cabo.",
  "microbiology.worklist.table.astTitle": "Ejecuciones de AST",
  "microbiology.worklist.table.title": "Casos de microbiología pendientes",
  "microbiology.worklist.viewAudit": "Consultar auditoría",
  "microbiology.worklist.viewReviewedAst": "Consultar el AST revisado",
  "microbiology.worklist.whonetExport": "Exportar a WHONET",
  "microbiology.worklist.surveillance.title": "Ámbito de la vigilancia",
  "microbiology.worklist.surveillance.description": "Limite las filas de AST según el período de referencia y los campos de vigilancia estructurada. Los filtros de la cola operativa no modifican el conjunto de datos que se exporta.",
  "microbiology.worklist.ast.automaticResults": "Los resultados del Analizador se reciben automáticamente",
  "microbiology.worklist.ast.automaticResultsDetail": "Los instrumentos conectados envían los resultados directamente al caso. Los eventos fallidos o que no coinciden se conservan en la sección «Problemas de importación» del Analizador.",
  "microbiology.worklist.ast.awaitingResults": "A la espera de los resultados del analizador",
  "microbiology.worklist.ast.pendingIdentification": "Identificación pendiente",
  "microbiology.worklist.ast.resultsInBadge": "Resultados recibidos",
  "microbiology.worklist.title": "Lista de trabajo de microbiología",
  "microbiology.worklist.updated": "Actualizado hace {seconds} s · actualización automática cada 30 s",
  "microbiology.admin.action.deactivate": "Desactivar",
  "microbiology.admin.action.moveDown": "Bajar",
  "microbiology.admin.action.moveUp": "Subir",
  "microbiology.admin.action.reactivate": "Reactivar",
  "microbiology.admin.actions": "Acciones de fila",
  "microbiology.admin.antibiotics.add": "Agregar antibiótico",
  "microbiology.admin.antibiotics.description": "Vocabulario antimicrobiano utilizado por los paneles AST y las reglas de puntos de corte.",
  "microbiology.admin.antibiotics.edit": "Antibiótico",
  "microbiology.admin.antibiotics.title": "Antibióticos",
  "microbiology.admin.astPanels.add": "Agregar panel AST",
  "microbiology.admin.astPanels.antibiotic": "Antibiótico",
  "microbiology.admin.astPanels.behavior.always": "Siempre",
  "microbiology.admin.astPanels.behavior.cascade": "Cascada",
  "microbiology.admin.astPanels.behavior.resistant": "Solo cuando se muestra resistencia",
  "microbiology.admin.astPanels.current": "Actual",
  "microbiology.admin.astPanels.confirmDeactivate": "¿Se va a marcar la versión «{version}» como no disponible para nuevos trabajos? Las ejecuciones de AST ya existentes conservarán su versión de panel original.",
  "microbiology.admin.astPanels.confirmPublish": "¿Publicar la versión {version}? Las ejecuciones de AST existentes conservarán su versión original del panel.",
  "microbiology.admin.astPanels.confirmTitle": "Confirmar la publicación del panel",
  "microbiology.admin.astPanels.historical": "Histórico",
  "microbiology.admin.astPanels.loadingEditor": "Se está cargando la administración de paneles AST.",
  "microbiology.admin.astPanels.publishVersion": "Publicar una nueva versión",
  "microbiology.admin.astPanels.readOnly": "Esta versión histórica es de solo lectura. Abra la versión actual para publicar un cambio.",
  "microbiology.admin.astPanels.reportBehavior": "Comportamiento en el informe",
  "microbiology.admin.astPanels.tier": "Nivel",
  "microbiology.admin.astPanels.title": "Paneles AST",
  "microbiology.admin.astPanels.version": "Versión",
  "microbiology.admin.astPanels.versionNotice": "Al guardar se crea una nueva versión del panel; las ejecuciones de AST existentes conservan su versión original.",
  "microbiology.admin.astPanels.viewVersion": "Consultar versión",
  "microbiology.admin.breakpoints.activate": "Activar estándar",
  "microbiology.admin.breakpoints.applyValid": "Aplicar las filas válidas",
  "microbiology.admin.breakpoints.archive": "Archivar estándar",
  "microbiology.admin.breakpoints.archiveConfirm": "Esta norma seguirá estando disponible para las ejecuciones históricas de AST, pero no podrá seleccionarse para nuevos trabajos.",
  "microbiology.admin.breakpoints.back": "Volver a los estándares",
  "microbiology.admin.breakpoints.breakpointType": "Tipo de punto de corte",
  "microbiology.admin.breakpoints.chooseFile": "Seleccione un archivo CSV",
  "microbiology.admin.breakpoints.correction.add": "Agregar corrección local",
  "microbiology.admin.breakpoints.correction.edit": "Editar corrección local",
  "microbiology.admin.breakpoints.count.imported": "{count} importados",
  "microbiology.admin.breakpoints.count.skipped": "{count} omitidos",
  "microbiology.admin.breakpoints.count.unchanged": "{count} sin cambios",
  "microbiology.admin.breakpoints.count.valid": "{count} válidos",
  "microbiology.admin.breakpoints.csv": "CSV de puntos de corte",
  "microbiology.admin.breakpoints.description": "Estándares de puntos de corte cargados y la versión activa para las nuevas ejecuciones de AST.",
  "microbiology.admin.breakpoints.detail": "Reglas de puntos de corte",
  "microbiology.admin.breakpoints.downloadRejected": "Descargar las filas rechazadas",
  "microbiology.admin.breakpoints.effectiveDate": "Fecha de entrada en vigor",
  "microbiology.admin.breakpoints.import": "Importar CSV",
  "microbiology.admin.breakpoints.intermediate": "Intermedio",
  "microbiology.admin.breakpoints.intermediateLower": "Intermedio inferior",
  "microbiology.admin.breakpoints.intermediateUpper": "Intermedio superior",
  "microbiology.admin.breakpoints.groupOption": "Grupo: {name}",
  "microbiology.admin.breakpoints.method.all": "Todos los métodos",
  "microbiology.admin.breakpoints.method.zone": "Zona",
  "microbiology.admin.breakpoints.organism": "Organismo o grupo",
  "microbiology.admin.breakpoints.organismGroup": "Grupo de organismos",
  "microbiology.admin.breakpoints.publisher": "Organismo emisor",
  "microbiology.admin.breakpoints.resistant": "Resistente",
  "microbiology.admin.breakpoints.rowError": "Fila {row}",
  "microbiology.admin.breakpoints.rules": "Reglas",
  "microbiology.admin.breakpoints.source": "Fuente",
  "microbiology.admin.breakpoints.source.imported": "Importado",
  "microbiology.admin.breakpoints.source.local": "Corrección local",
  "microbiology.admin.breakpoints.source.manual": "Manual",
  "microbiology.admin.breakpoints.specimen": "Contexto de la muestra",
  "microbiology.admin.breakpoints.specimen.any": "Cualquiera de las muestras",
  "microbiology.admin.breakpoints.status.active": "Activo",
  "microbiology.admin.breakpoints.status.archived": "Archivado",
  "microbiology.admin.breakpoints.status.loaded": "Cargado",
  "microbiology.admin.breakpoints.susceptible": "Susceptible",
  "microbiology.admin.breakpoints.title": "Estándares de puntos de corte",
  "microbiology.admin.breakpoints.units": "Unidades",
  "microbiology.admin.breakpoints.view": "Consultar reglas",
  "microbiology.admin.filter.all": "Todos",
  "microbiology.admin.sort": "Ordenar",
  "microbiology.admin.sort.nameAsc": "Nombre (A-Z)",
  "microbiology.admin.sort.nameDesc": "Nombre: Z-A",
  "microbiology.admin.deactivate.impact": "{name} es utilizado por {count, plural, one {# registro de flujo de trabajo existente} other {# registros de flujo de trabajo existentes}}. La desactivación previene una nueva selección pero conserva esas referencias históricas.",
  "microbiology.admin.deactivate.title": "Analizar el impacto de la desactivación",
  "microbiology.admin.deactivated": "Referencia desactivada",
  "microbiology.admin.empty": "No se han encontrado registros de referencia coincidentes",
  "microbiology.admin.error.save": "No se ha podido guardar el registro de referencia.",
  "microbiology.admin.error.title": "No se ha podido completar la solicitud",
  "microbiology.admin.field.active": "Disponible para nuevos trabajos",
  "microbiology.admin.field.atmosphere": "Atmósfera predeterminada",
  "microbiology.admin.field.class": "Clase",
  "microbiology.admin.field.code": "Código",
  "microbiology.admin.field.defaultPanel": "Panel AST predeterminado",
  "microbiology.admin.field.defaultPanelId": "ID del panel AST predeterminado",
  "microbiology.admin.field.gramStain": "Tinción de Gram",
  "microbiology.admin.field.group": "Grupo de organismos",
  "microbiology.admin.field.incubation": "Valores predeterminados de incubación",
  "microbiology.admin.field.incubationHours": "Intervalo de lectura de rutina (horas)",
  "microbiology.admin.field.subcultureAtHours": "Subcultivo a las (horas)",
  "microbiology.admin.field.maxIncubationDays": "Incubación máxima (días)",
  "microbiology.admin.field.media": "Medios de cultivo predeterminados",
  "microbiology.admin.field.method": "Método",
  "microbiology.admin.field.methodId": "ID del método",
  "microbiology.admin.field.name": "Nombre",
  "microbiology.admin.field.notes": "Notas",
  "microbiology.admin.field.oclCode": "Código OCL",
  "microbiology.admin.field.reportableAnalyteId": "Identificador del analito que debe notificarse",
  "microbiology.admin.field.route": "Ruta",
  "microbiology.admin.field.shortName": "Nombre abreviado",
  "microbiology.admin.field.significance": "Importancia inicial",
  "microbiology.admin.field.whonetCode": "Código WHONET",
  "microbiology.admin.organisms.add": "Agregar organismo",
  "microbiology.admin.organisms.description": "Vocabulario relativo a los organismos utilizado en la identificación mediante cultivo y en el AST.",
  "microbiology.admin.organisms.edit": "Organismo",
  "microbiology.admin.organisms.title": "Organismos",
  "microbiology.admin.patientOrigins.description": "Opciones de origen del paciente configuradas que se utilizan durante el ingreso de órdenes de microbiología y la exportación a WHONET.",
  "microbiology.admin.patientOrigins.title": "Procedencia de los pacientes",
  "microbiology.admin.reactivated": "Referencia reactivada",
  "microbiology.admin.route.both": "Por vía oral e intravenosa",
  "microbiology.admin.route.iv": "IV",
  "microbiology.admin.route.oral": "Oral",
  "microbiology.admin.route.topical": "Tópica",
  "microbiology.admin.saved": "Referencia guardada",
  "microbiology.admin.search": "Buscar datos de referencia",
  "microbiology.admin.sections": "Secciones de referencia sobre microbiología",
  "microbiology.admin.significance.possible": "Posible agente patógeno",
  "microbiology.admin.significance.rare": "Patógeno poco común",
  "microbiology.admin.significance.usually": "Normalmente significativo",
  "microbiology.admin.status": "Estado",
  "microbiology.admin.status.active": "Activo",
  "microbiology.admin.status.all": "Todos los estados",
  "microbiology.admin.status.inactive": "Inactivo",
  "microbiology.admin.title": "Datos de referencia sobre microbiología",
  "button.add": "Agregar",
  "button.remove": "Eliminar",
  "sidenav.label.microbiology": "Microbiología",
  "sidenav.label.microbiology.worklist": "Lista de trabajo de microbiología",
  "sidenav.label.microbiology.whonet": "Exportación de WHONET",
  "microbiology.whonet.title": "Exportación de WHONET",
  "microbiology.whonet.eyebrow": "Vigilancia bacteriológica de rutina",
  "microbiology.whonet.subtitle": "Revise los datos definitivos de cultivos y pruebas de sensibilidad a los antibióticos antes de generar el archivo CSV de vigilancia de OpenELIS actual para su validación en WHONET.",
  "microbiology.whonet.progress": "Progreso de la exportación de WHONET",
  "microbiology.whonet.step.configure": "Configurar",
  "microbiology.whonet.step.preview": "Vista previa",
  "microbiology.whonet.step.generate": "Generar",
  "microbiology.whonet.configure.title": "Configurar la exportación",
  "microbiology.whonet.configure.description": "Seleccione el período de referencia y los aislados que desea incluir.",
  "microbiology.whonet.from": "Desde",
  "microbiology.whonet.to": "Hasta",
  "microbiology.whonet.date.placeholder": "aaaa-mm-dd",
  "microbiology.whonet.period.invalid": "La fecha de finalización debe ser igual o posterior a la fecha de inicio.",
  "microbiology.whonet.period.preset": "Período de referencia",
  "microbiology.whonet.period.thisMonth": "Este mes",
  "microbiology.whonet.period.lastMonth": "El mes pasado",
  "microbiology.whonet.period.thisQuarter": "Este trimestre",
  "microbiology.whonet.period.custom": "Personalizado",
  "microbiology.whonet.source.worklist.title": "Ámbito proporcionado por la lista de trabajo de AST",
  "microbiology.whonet.source.worklist.description": "El periodo de referencia y los filtros de vigilancia estructurados proceden de la lista de trabajo de AST. Aquí siguen siendo editables.",
  "microbiology.whonet.source.worklist.clear": "Limpiar el ámbito de la lista de trabajo",
  "microbiology.whonet.significance": "Inclusión",
  "microbiology.whonet.significance.clinical": "Aislados clínicamente significativos",
  "microbiology.whonet.significance.all": "Todos los aislados",
  "microbiology.whonet.significance.CLINICALLY_SIGNIFICANT": "Clínicamente significativo",
  "microbiology.whonet.significance.CONTAMINANT": "Contaminante",
  "microbiology.whonet.significance.NORMAL_FLORA": "Flora normal",
  "microbiology.whonet.significance.UNKNOWN": "Sin clasificar",
  "microbiology.whonet.culturePurpose.description": "Los cultivos clínicos se incluyen de forma predeterminada. Agregue otras poblaciones de forma explícita cuando la pregunta de vigilancia así lo requiera.",
  "microbiology.whonet.culturePurpose.includeScreening": "Incluya pruebas de detección activas o cultivos de portadores",
  "microbiology.whonet.culturePurpose.includeUnspecified": "Incluir cultivos históricos sin finalidad especificada",
  "microbiology.whonet.culturePurpose.title": "Finalidad del cultivo",
  "microbiology.whonet.filter.specimen": "Tipos de muestras",
  "microbiology.whonet.filter.organism": "Organismos",
  "microbiology.whonet.filter.origin": "Procedencia de los pacientes",
  "microbiology.whonet.filter.any": "Cualquiera",
  "microbiology.whonet.filter.choose": "Seleccione los valores",
  "microbiology.whonet.dedup": "Desduplicación",
  "microbiology.whonet.dedup.apply": "Aplicar la selección de primer aislado",
  "microbiology.whonet.dedup.apply.help": "Consolidar los aislados repetidos de un mismo paciente y organismo dentro del intervalo seleccionado.",
  "microbiology.whonet.dedup.advanced": "Ajustar la política de primer aislado",
  "microbiology.whonet.dedup.window": "Longitud de la ventana",
  "microbiology.whonet.dedup.window.help": "Las repeticiones que se producen exactamente en el límite del día seleccionado dan lugar a una nueva ventana.",
  "microbiology.whonet.dedup.sevenDay": "7 días",
  "microbiology.whonet.dedup.fourteenDay": "14 días",
  "microbiology.whonet.dedup.thirtyDay": "30 días",
  "microbiology.whonet.dedup.basis": "Fecha base del intervalo",
  "microbiology.whonet.dedup.basis.collection": "Fecha de recolección de la muestra",
  "microbiology.whonet.dedup.basis.release": "Fecha de liberación del resultado final",
  "microbiology.whonet.dedup.basis.help": "Elija si el intervalo se basa en la fecha de recolección de la muestra o en la liberación del resultado final. El periodo de notificación siempre sigue la fecha de recolección.",
  "microbiology.whonet.dedup.scope": "Ámbito de aplicación de la fuente de muestras",
  "microbiology.whonet.dedup.scope.any": "Cualquiera de los orígenes de las muestras",
  "microbiology.whonet.dedup.scope.same": "Únicamente de la misma fuente de muestras",
  "microbiology.whonet.dedup.scope.help": "Cualquiera de las fuentes compara al paciente y al organismo entre los distintos tipos de muestras; la misma fuente realiza la comparación dentro de cada tipo de muestra.",
  "microbiology.whonet.dedup.contaminants": "Excluya los posibles contaminantes antes de seleccionar",
  "microbiology.whonet.dedup.contaminants.help": "Eliminar los posibles contaminantes antes de seleccionar el primer aislado representativo.",
  "microbiology.whonet.dedup.profile": "Perfil de susceptibilidad",
  "microbiology.whonet.dedup.profile.insensitive": "Ignorar los cambios en S/I/R",
  "microbiology.whonet.dedup.profile.sensitive": "Trate el S/I/R modificado como si fuera nuevo",
  "microbiology.whonet.dedup.profile.help": "La selección sensible al perfil cuenta como un nuevo aislado dentro del intervalo un patrón S/I/R distinto en los antibióticos revisados.",
  "microbiology.whonet.dedup.none": "Sin deduplicación",
  "microbiology.whonet.preview.action": "Vista previa de la exportación",
  "microbiology.whonet.preview.title": "Vista previa",
  "microbiology.whonet.preview.description": "Estos recuentos y filas se utilizarán al generar el archivo CSV.",
  "microbiology.whonet.generate.action": "Generar CSV",
  "microbiology.whonet.count.cases": "Casos finalizados",
  "microbiology.whonet.count.clinicalPurpose": "Cultivos clínicos",
  "microbiology.whonet.count.screeningPurpose": "Cultivos de cribado",
  "microbiology.whonet.count.unspecifiedPurpose": "Cultivos no especificados",
  "microbiology.whonet.count.purposeIncluded": "Tras la selección en función de la finalidad del cultivo",
  "microbiology.whonet.count.isolates": "Aislados encontrados",
  "microbiology.whonet.count.specimen": "Después del filtro de muestras",
  "microbiology.whonet.count.organism": "Tras el filtro de organismos",
  "microbiology.whonet.count.origin": "Después del filtro de origen",
  "microbiology.whonet.count.included": "Aislados incluidos",
  "microbiology.whonet.count.deduplicated": "Tras la deduplicación",
  "microbiology.whonet.count.mappable": "Aislados asignables",
  "microbiology.whonet.count.rows": "Filas que cumplen los requisitos",
  "microbiology.whonet.count.excluded": "Filas excluidas",
  "microbiology.whonet.mapping.title": "Preparación de las asignaciones",
  "microbiology.whonet.mapping.excluded": "{count, plural, one {# row excluded} many {# rows excluded} other {# filas excluidas}} from this export.",
  "microbiology.whonet.mapping.fixOrganism": "Corregir la asignación de organismos",
  "microbiology.whonet.mapping.fixAntibiotic": "Corregir la asignación de antibióticos",
  "microbiology.whonet.mapping.fixSpecimen": "Corregir la asignación de muestras",
  "microbiology.whonet.table.title": "Filas AST que cumplen los requisitos",
  "microbiology.whonet.table.description": "Lecturas de AST revisadas y notificables, con las asignaciones que exige esta exportación.",
  "microbiology.whonet.table.accession": "Número de laboratorio",
  "microbiology.whonet.table.specimen": "Muestra",
  "microbiology.whonet.table.organism": "Organismo",
  "microbiology.whonet.table.antibiotic": "Antibiótico",
  "microbiology.whonet.table.interpretation": "S / I / R",
  "microbiology.whonet.table.method": "Método",
  "microbiology.whonet.error.title": "No se ha podido completar la exportación de WHONET",
  "microbiology.whonet.error.invalidRequest": "Revise el período del informe y las opciones para exportar y, a continuación, inténtelo de nuevo.",
  "microbiology.whonet.error.blocked": "No quedan filas válidas. Resuelva los problemas de preparación indicados antes de generar el archivo CSV.",
  "microbiology.whonet.error.network": "No se ha podido acceder al servicio de exportación. Inténtelo de nuevo cuando la conexión esté disponible.",
  "microbiology.whonet.error.generic": "No se ha podido completar la solicitud de exportación.",
  "microbiology.whonet.preview.loading": "Preparando la vista previa de la exportación.",
  "microbiology.whonet.preview.announced": "Vista previa lista con {count, plural, one {# fila elegible} other {# filas elegibles}}.",
  "microbiology.whonet.generated.title": "Archivo CSV generado",
  "microbiology.whonet.generated.subtitle": "Se ha descargado la exportación validada y se ha registrado su resumen de auditoría.",
  "catalog.import.title": "Importar catálogo (CSV)",
  "catalog.import.description": "Cargue archivos de catálogo de pruebas sin editar las pruebas una por una. La vista previa verifica cada archivo contra el catálogo actual y no guarda nada, por lo que una fila que necesite una unidad de laboratorio, espécimen o prueba que otro archivo en la misma carga cree se lista como omitida hasta que aplique. Aplicar carga los archivos en orden y los guarda con la configuración, por lo que el próximo reinicio carga exactamente lo que aplicó.",
  "catalog.import.dropzone": "Añadir archivos CSV",
  "catalog.import.preview": "Vista previa",
  "catalog.import.apply": "Aplicar",
  "catalog.import.remove": "Eliminar",
  "catalog.import.plan.title": "Qué harían estos archivos",
  "catalog.import.result.title": "Qué se cargó",
  "catalog.import.column.file": "Archivo",
  "catalog.import.column.domain": "Área del catálogo",
  "catalog.import.column.created": "Creado",
  "catalog.import.column.updated": "Actualizado",
  "catalog.import.column.skipped": "Omitido",
  "catalog.import.column.name": "Nombre en el archivo",
  "catalog.import.column.where": "Dónde apareció",
  "catalog.import.column.use": "Usar este registro",
  "catalog.import.file.error": "No se pudo leer este archivo",
  "catalog.import.applied": "Los archivos de catálogo fueron aplicados.",
  "catalog.import.applied.partial": "Algunos archivos de catálogo no se cargaron. La tabla indica cuáles y por qué.",
  "catalog.import.apply.failed": "Los archivos de catálogo no fueron aplicados.",
  "catalog.import.apply.hint": "Primero, previsualice los archivos. Aplicar se habilita una vez que la vista previa no muestra errores en los archivos.",
  "catalog.import.failed": "No se pudieron enviar los archivos de catálogo.",
  "catalog.import.unresolved.title": "Requiere su decisión",
  "catalog.import.unresolved.description": "Nombres que la importación no pudo asociar a un registro. Asigne cada uno al registro correspondiente u omítalo. Recordar un nombre lo resuelve automáticamente la próxima vez.",
  "catalog.import.unresolved.empty": "No hay nada esperando una decisión.",
  "catalog.import.remember": "Recordar este nombre",
  "catalog.import.resolve": "Usar",
  "catalog.import.skip": "Saltar",
  "sidenav.label.admin.catalogImport": "Importar catálogo (CSV)",
  "reporting.design.subtitle": "Create a CSV for a new question or rerun a familiar report for a new period.",
  "reporting.design.overview": "Export overview",
  "reporting.design.newTitle": "Create a new export",
  "reporting.design.newHelp": "Choose the kind of report, the fields you need, and a reporting period. Your work remains available if you visit the queue or return later.",
  "reporting.design.savedTitle": "Use a saved report",
  "reporting.design.savedHelp": "Reuse saved fields and filters, then choose a fresh reporting period.",
  "reporting.design.start": "Start a new export",
  "reporting.design.continue": "Continue current export",
  "reporting.design.newExport": "New export",
  "reporting.design.useReport": "Use report",
  "reporting.design.savedFields": "{count} saved fields · reporting period is never saved",
  "reporting.design.steps": "Export steps",
  "reporting.design.chooseColumns": "Choose columns",
  "reporting.design.setFilters": "Set Filters",
  "reporting.design.reviewSubmit": "Review & Submit",
  "reporting.design.typeQuestion": "What kind of information do you need?",
  "reporting.design.typeHelp": "Choose one report type so every CSV row has a clear meaning. You can change the type until you select fields.",
  "reporting.design.type.SAMPLE_TESTING": "Sample & Testing",
  "reporting.design.type.REFERRALS": "Referencias",
  "reporting.design.type.NON_CONFORMANCE": "Non-Conformance",
  "reporting.design.typeHelp.SAMPLE_TESTING": "Orders, results, patients & turnaround times",
  "reporting.design.typeHelp.REFERRALS": "Tests referred to other labs · preserves returned results and pending referrals",
  "reporting.design.typeHelp.NON_CONFORMANCE": "Rejected samples & non-conforming events · preserves linked specimens and separate occurrences",
  "reporting.design.pending": "Not yet connected",
  "reporting.design.building": "You’re building a {type} report.",
  "reporting.design.changeType": "Change type and clear fields",
  "reporting.design.chooseType": "Choose a report type to see its fields.",
  "reporting.design.configuredReports": "Configured reports",
  "reporting.design.chooseConfigured": "Choose a configured report",
  "reporting.design.available": "Available fields",
  "reporting.design.findField": "Find a field",
  "reporting.design.searchPlaceholder": "Search all fields and groups…",
  "reporting.design.clearSearch": "Clear search",
  "reporting.design.fieldCount": "{count} fields across {groups} groups",
  "reporting.design.matchCount": "{count} matching fields across {groups} groups",
  "reporting.design.expansion": "Expand or collapse field groups",
  "reporting.design.expandAll": "Expand all",
  "reporting.design.collapseAll": "Collapse all",
  "reporting.design.groupCount": "{added} / {total} added",
  "reporting.design.scrollCatalog": "Scrollable field catalog",
  "reporting.design.addShown": "Add all shown",
  "reporting.design.removeShown": "Remove shown",
  "reporting.design.addShownGroup": "Add all shown {group} fields",
  "reporting.design.removeShownGroup": "Remove all shown {group} fields",
  "reporting.design.addField": "Add {field}",
  "reporting.design.addedField": "Added {field}",
  "reporting.design.add": "+ Add",
  "reporting.design.added": "Added",
  "reporting.design.noFields": "No fields match your search.",
  "reporting.design.selectedCount": "Your CSV columns ({count})",
  "reporting.design.orderHelp": "Drag a handle to change column order, or use the arrows. Arrow keys move the focused handle; Home and End move it to the first or last position.",
  "reporting.design.columnOrder": "CSV columns in order",
  "reporting.design.drag": "Drag {field} to reorder",
  "reporting.design.move": "Move {field}",
  "reporting.design.emptyColumns": "Add fields to build your CSV.",
  "reporting.design.addedMessage": "{field} added. {count} columns.",
  "reporting.design.removedMessage": "{field} removed. {count} columns.",
  "reporting.design.columnViews": "Column builder views",
  "reporting.design.yourColumns": "Your columns ({count})",
  "reporting.design.csvPreview": "CSV preview",
  "reporting.design.previewHelp": "Column layout in the order it will appear in your downloaded CSV.",
  "reporting.design.scrollPreview": "Scrollable CSV preview",
  "reporting.design.nextFilters": "Next: Set Filters",
  "reporting.design.nextReview": "Next: Review & Submit",
  "reporting.design.scopeFilters": "Scope Filters (Optional)",
  "reporting.design.periodDays": "{count, plural, one {# day} other {# days}}",
  "reporting.design.moreFilters": "Show more filters",
  "reporting.design.hideFilters": "Hide more filters",
  "reporting.design.sampleStatus": "Sample Status",
  "reporting.design.referringSite": "Referring Site",
  "reporting.design.reviewConfiguration": "Review Configuration",
  "reporting.design.dateFilters": "Date Range and filters",
  "reporting.design.testStatus": "Test and status",
  "reporting.design.change": "Cambiar",
  "reporting.design.deliveryHelp": "Your CSV will be generated in the background. Download it here when ready, or return to My Report Queue.",
  "reporting.design.fileName": "Nombre del archivo",
  "reporting.design.customFileName": "Custom file name",
  "reporting.design.fileNamePending": "A file name is generated automatically. Custom names are not yet connected.",
  "reporting.design.saveLater": "Save these report settings for later",
  "reporting.design.saveSettings": "Save report settings",
  "reporting.design.queueHelp": "View and download your queued CSV exports.",
  "reporting.design.queue.jobName": "Job Name",
  "reporting.design.queue.report": "Informe",
  "reporting.design.queue.size": "Rows / File Size",
  "reporting.design.queue.submitted": "Submitted At",
  "reporting.design.queuePending": "Active jobs refresh automatically. Retry failed exports, cancel queued work or rerun expired reports with fresh dates. Job deletion is not yet connected.",
  "reporting.design.details": "Detalles",
  "reporting.design.expires": "Available until {date}",
  "reporting.design.jobsShown": "Showing {count} jobs",
  "reporting.design.jobAction.EXPIRED": "Re-run",
  "reporting.design.labScope": "Lab Scope",
  "reporting.design.reviewFields": "Selected Fields ({count})",
  "reporting.recovery.cancelTitle": "Cancel export",
  "reporting.recovery.keepQueued": "Keep queued",
  "reporting.recovery.cancelHelp": "Cancel this queued export? If processing has already started, it will continue and you can return to its result.",
  "reporting.job.cannotCancel": "This export has already started or finished and cannot be cancelled.",
  "reporting.job.cannotRetry": "Only a failed export can be retried. Use the current job or start a new export.",
  "reporting.job.interrupted": "Processing was interrupted. Retry this export to generate a new file.",
  "reporting.job.claimLost": "This export is no longer assigned to the current worker. Return to the queue for its status.",
  "sidenav.section.main": "Main Menu",
  "sidenav.section.patientOrders": "Patient & Orders",
  "sidenav.section.administration": "Administración",
  "sidenav.workflow.orderTest": "Order Test",
  "sidenav.workflow.resultsValidation": "Results Validation",
  "sidenav.workflow.patientManagement": "Patient Management",
  "sidenav.moreTools": "More tools",
  "reporting.menu.otherReports": "Other reports",
  "reporting.menu.patientPrintQueue": "Patient Report Print Queue",
  "common.icon": "Icon",
  "menu.presentation.style": "Display as",
  "menu.presentation.item": "Menu item",
  "menu.presentation.section": "Section heading",
  "menu.configuration.managed": "Managed by instance configuration",
  "menu.configuration.description": "Update menu visibility, section headings and icons. Settings managed by this instance are read-only here.",
  "menu.configuration.loadError": "Menu settings could not be loaded.",
  "menu.configuration.saved": "Menu settings saved.",
  "menu.presentation.sectionHint": "Section headings group their child menu items without a link.",
  "menu.presentation.sectionIconHint": "Icons are shown on menu items, not section headings.",
  "analyzer.action.copyMappings": "Copy Mappings",
  "analyzer.action.delete": "Eliminar",
  "analyzer.action.edit": "Editar",
  "analyzer.action.fieldMappings": "Asignaciones de campos",
  "analyzer.action.qcRules": "QC Rules",
  "analyzer.action.testConnection": "Probar conexión",
  "analyzer.copyMappings.confirmation.message": "Are you sure you want to copy {count} mappings? Existing mappings will be overwritten.",
  "analyzer.copyMappings.confirmation.title": "Confirm Copy Mappings",
  "analyzer.copyMappings.copy": "Copy Mappings",
  "analyzer.copyMappings.error": "Error copying mappings",
  "analyzer.copyMappings.error.noSourceMappings": "Source analyzer has no active mappings to copy",
  "analyzer.copyMappings.loading": "Copying mappings...",
  "analyzer.copyMappings.source": "Source Analyzer",
  "analyzer.copyMappings.source.name": "Nombre",
  "analyzer.copyMappings.source.type": "Tipo",
  "analyzer.copyMappings.subtitle": "Copy field mappings from {source} to {target}",
  "analyzer.copyMappings.success": "Successfully copied {count} mappings",
  "analyzer.copyMappings.success.viewTarget": "View Target Analyzer",
  "analyzer.copyMappings.summary": "Mapping Summary",
  "analyzer.copyMappings.summary.breakdown": "Field mappings: {fieldCount}, Unit conversions: {unitCount}, Qualitative mappings: {qualCount}",
  "analyzer.copyMappings.summary.count": "{count} mappings will be copied",
  "analyzer.copyMappings.target": "Target Analyzer",
  "analyzer.copyMappings.target.placeholder": "Select target analyzer",
  "analyzer.copyMappings.target.required": "Target Analyzer *",
  "analyzer.copyMappings.title": "Copy Field Mappings",
  "analyzer.copyMappings.warning": "This will copy all field mappings including unit conversions and qualitative value mappings. Existing mappings will be overwritten.",
  "analyzer.delete.cancel": "Cancelar",
  "analyzer.delete.delete": "Eliminar",
  "analyzer.delete.error": "Error",
  "analyzer.delete.error.noId": "Es necesario indicar el ID del Analizador",
  "analyzer.delete.error.unknown": "An unknown error occurred while deleting the analyzer",
  "analyzer.delete.message": "Are you sure you want to delete '{name}'? This action cannot be undone and will remove all associated field mappings.",
  "analyzer.delete.success": "Analyzer deleted",
  "analyzer.delete.title": "Delete Analyzer",
  "analyzer.delete.unknown": "Unknown Analyzer",
  "analyzer.errorDashboard.acknowledgeAll": "Acknowledge All",
  "analyzer.errorDashboard.action.acknowledge": "Confirmar",
  "analyzer.errorDashboard.action.menu": "Error actions",
  "analyzer.errorDashboard.action.viewDetails": "Consultar detalles",
  "analyzer.errorDashboard.errorType.connection": "Conexión",
  "analyzer.errorDashboard.errorType.mapping": "Mapping",
  "analyzer.errorDashboard.errorType.protocol": "Protocolo",
  "analyzer.errorDashboard.errorType.timeout": "Timeout",
  "analyzer.errorDashboard.errorType.validation": "Validación",
  "analyzer.errorDashboard.filter.analyzer": "Analizador",
  "analyzer.errorDashboard.filter.analyzer.all": "Todos",
  "analyzer.errorDashboard.filter.search": "Search errors...",
  "analyzer.errorDashboard.filter.severity": "Severidad",
  "analyzer.errorDashboard.filter.severity.all": "Todas las severidades",
  "analyzer.errorDashboard.filter.type": "Error Type",
  "analyzer.errorDashboard.filter.type.all": "Todos los tipos",
  "analyzer.errorDashboard.severity.critical": "Crítico",
  "analyzer.errorDashboard.severity.error": "Error",
  "analyzer.errorDashboard.severity.warning": "Advertencia",
  "analyzer.errorDashboard.stats.critical": "Crítico",
  "analyzer.errorDashboard.stats.last24Hours": "Últimas 24 horas",
  "analyzer.errorDashboard.stats.total": "Total Errors",
  "analyzer.errorDashboard.stats.unacknowledged": "Unacknowledged",
  "analyzer.errorDashboard.status.acknowledged": "Confirmado",
  "analyzer.errorDashboard.status.unacknowledged": "Unacknowledged",
  "analyzer.errorDashboard.subtitle": "View and manage analyzer errors and alerts",
  "analyzer.errorDashboard.table.analyzer": "Analizador",
  "analyzer.errorDashboard.table.message": "Mensaje",
  "analyzer.errorDashboard.table.severity": "Severidad",
  "analyzer.errorDashboard.table.status": "Estado",
  "analyzer.errorDashboard.table.timestamp": "Marca de tiempo",
  "analyzer.errorDashboard.table.type": "Tipo",
  "analyzer.errorDashboard.title": "Error Dashboard",
  "analyzer.errorDetails.acknowledged": "Confirmado",
  "analyzer.errorDetails.acknowledgedBy": "By {user} on {date}",
  "analyzer.errorDetails.analyzer": "Analizador",
  "analyzer.errorDetails.analyzerId": "Analyzer ID",
  "analyzer.errorDetails.close": "Cerrar",
  "analyzer.errorDetails.copy": "Copy",
  "analyzer.errorDetails.createMapping": "Create Mapping",
  "analyzer.errorDetails.download": "Descargar",
  "analyzer.errorDetails.errorId": "Error ID",
  "analyzer.errorDetails.errorMessage": "Mensaje de error",
  "analyzer.errorDetails.errorType": "Error Type",
  "analyzer.errorDetails.logs": "Analyzer Logs ({count} entries)",
  "analyzer.errorDetails.recommendedActions": "Recommended Actions",
  "analyzer.errorDetails.recommendedActions.checkConfiguration": "Check IP address and port configuration in analyzer settings",
  "analyzer.errorDetails.recommendedActions.createMapping": "Create a mapping for the unmapped field to resolve this error",
  "analyzer.errorDetails.recommendedActions.testConnection": "Test connection using the 'Test Connection' feature",
  "analyzer.errorDetails.recommendedActions.verifyConnection": "Verify analyzer is powered on and network cable is connected",
  "analyzer.errorDetails.severity": "Severidad",
  "analyzer.errorDetails.subtitle": "Detailed information and analyzer logs for error {id}",
  "analyzer.errorDetails.timestamp": "Marca de tiempo",
  "analyzer.errorDetails.title": "Error Details",
  "analyzer.fieldMapping.activationModal.activate": "Activate Changes",
  "analyzer.fieldMapping.activationModal.cancel": "Cancelar",
  "analyzer.fieldMapping.activationModal.confirmCheckbox": "I understand these changes will apply to new messages only",
  "analyzer.fieldMapping.activationModal.errorConcurrentEdit": "Mapping changes detected. Another user has modified mappings for this analyzer. Please reload the page to see latest changes.",
  "analyzer.fieldMapping.activationModal.errorMissingRequired": "Cannot activate: Required mappings missing",
  "analyzer.fieldMapping.activationModal.errorMissingRequired.detail": "Missing required fields: {fields}",
  "analyzer.fieldMapping.activationModal.reloadPage": "Reload Page",
  "analyzer.fieldMapping.activationModal.subtitle": "Confirm activation of mapping changes for analyzer '{name}'",
  "analyzer.fieldMapping.activationModal.title": "Activate Mapping Changes",
  "analyzer.fieldMapping.activationModal.viewPendingMessages": "View Pending Messages",
  "analyzer.fieldMapping.activationModal.warning": "You are about to activate mapping changes for analyzer '{name}'. These changes will apply to all new messages received after activation. Existing results will not be affected.",
  "analyzer.fieldMapping.activationModal.warningActive": "This analyzer is currently active. Activating changes may affect incoming results.",
  "analyzer.fieldMapping.activationModal.warningPendingMessages": "This analyzer has {count} pending messages in the error queue. Activating mapping changes may affect how these messages are reprocessed. Consider resolving errors first.",
  "analyzer.fieldMapping.back": "Atrás",
  "analyzer.fieldMapping.fieldType.controlTest": "Control Test",
  "analyzer.fieldMapping.fieldType.custom": "Personalizado",
  "analyzer.fieldMapping.fieldType.dateTime": "Fecha/Hora",
  "analyzer.fieldMapping.fieldType.meltingPoint": "Melting Point",
  "analyzer.fieldMapping.fieldType.numeric": "Numérico",
  "analyzer.fieldMapping.fieldType.qualitative": "Cualitativo",
  "analyzer.fieldMapping.fieldType.text": "Text",
  "analyzer.fieldMapping.page.subtitle": "Configure field mappings between analyzer and OpenELIS",
  "analyzer.fieldMapping.page.title": "Asignaciones de campos",
  "analyzer.fieldMapping.panel.mapping.active": "Activo",
  "analyzer.fieldMapping.panel.mapping.retired": "Retired",
  "analyzer.fieldMapping.panel.retire": "Retire Mapping",
  "analyzer.fieldMapping.panel.retire.disabled.tooltip": "Cannot retire: {reason}",
  "analyzer.fieldMapping.panel.source.fieldsAvailable": "{count} fields available",
  "analyzer.fieldMapping.panel.source.search": "Search fields...",
  "analyzer.fieldMapping.panel.source.title": "Analyzer Fields ({type})",
  "analyzer.fieldMapping.panel.status.mapped": "Asignado",
  "analyzer.fieldMapping.panel.status.unmapped": "Unmapped",
  "analyzer.fieldMapping.panel.statusFilter.active": "Solo activos",
  "analyzer.fieldMapping.panel.statusFilter.all": "All Fields",
  "analyzer.fieldMapping.panel.statusFilter.draft": "Draft Only",
  "analyzer.fieldMapping.panel.statusFilter.label": "Filtrar por estado",
  "analyzer.fieldMapping.panel.statusFilter.mapped": "Mapped Only",
  "analyzer.fieldMapping.panel.statusFilter.unmapped": "Unmapped Only",
  "analyzer.fieldMapping.panel.target.cancel": "Cancelar",
  "analyzer.fieldMapping.panel.target.edit": "Editar",
  "analyzer.fieldMapping.panel.target.remove": "Eliminar",
  "analyzer.fieldMapping.panel.target.saveActivate": "Save and Activate",
  "analyzer.fieldMapping.panel.target.saveDraft": "Guardar como borrador",
  "analyzer.fieldMapping.panel.target.selectField": "Select a field from the left panel to view or create mappings.",
  "analyzer.fieldMapping.panel.target.summary": "Mappings Summary",
  "analyzer.fieldMapping.panel.unmappedField.tooltip": "Unmapped Field - This field has no mapping configured",
  "analyzer.fieldMapping.pendingCodes.actions": "Acciones",
  "analyzer.fieldMapping.pendingCodes.code": "Analyzer Code",
  "analyzer.fieldMapping.pendingCodes.empty": "No pending unmapped analyzer codes.",
  "analyzer.fieldMapping.pendingCodes.ignore": "Ignorar",
  "analyzer.fieldMapping.pendingCodes.markMapped": "Mark Mapped",
  "analyzer.fieldMapping.pendingCodes.seenCount": "Seen",
  "analyzer.fieldMapping.pendingCodes.status": "Estado",
  "analyzer.fieldMapping.pendingCodes.subtitle": "Review and resolve unmapped analyzer test codes.",
  "analyzer.fieldMapping.pendingCodes.title": "Pending Unmapped Codes",
  "analyzer.fieldMapping.pluginConfig.title": "Plugin Configuration Snapshot",
  "analyzer.fieldMapping.queryAnalyzer": "Consultar analizador",
  "analyzer.fieldMapping.retirementModal.cancel": "Cancelar",
  "analyzer.fieldMapping.retirementModal.confirmation": "Are you sure you want to retire this mapping? Historical messages will still reference it for audit purposes.",
  "analyzer.fieldMapping.retirementModal.errorPendingMessages": "Cannot retire: {count} pending messages use this mapping",
  "analyzer.fieldMapping.retirementModal.reasonLabel": "Retirement Reason (Optional)",
  "analyzer.fieldMapping.retirementModal.reasonPlaceholder": "Optional: Reason for retiring this mapping",
  "analyzer.fieldMapping.retirementModal.retire": "Retire Mapping",
  "analyzer.fieldMapping.retirementModal.subtitle": "Confirm retirement of field mapping",
  "analyzer.fieldMapping.retirementModal.title": "Retire Mapping",
  "analyzer.fieldMapping.save": "Save Mappings",
  "analyzer.fieldMapping.stats.pendingCodes": "Pending Codes",
  "analyzer.fieldMapping.stats.required": "Required Mappings",
  "analyzer.fieldMapping.stats.total": "Total Mappings",
  "analyzer.fieldMapping.stats.unmapped": "Unmapped Fields",
  "analyzer.fieldMapping.status.active": "Activo",
  "analyzer.fieldMapping.status.draft": "Borrador",
  "analyzer.fieldMapping.status.retired": "Retired",
  "analyzer.fieldMapping.status.unmapped": "Unmapped",
  "analyzer.fieldMapping.testMapping": "Test Mapping",
  "analyzer.fieldMapping.warning.missingRequired": "Required mappings are missing",
  "analyzer.fieldMapping.warning.missingRequired.detail": "Some required fields are not mapped. Please map all required fields before activating.",
  "analyzer.navigation.errorDashboard": "Error Dashboard",
  "analyzerType.column.name": "Nombre",
  "analyzerType.column.description": "Descripción",
  "analyzerType.column.pluginClass": "Plugin Class",
  "analyzerType.column.genericPlugin": "Generic Plugin",
  "analyzerType.column.identifierPattern": "Patrón de identificador",
  "analyzerType.column.pluginLoaded": "Plugin Loaded",
  "analyzerType.column.instances": "Instances",
  "analyzerType.button.creating": "Creando...",
  "analyzerType.modal.createTitle": "Create New Analyzer Type",
  "analyzerType.field.name": "Nombre",
  "analyzerType.field.description": "Descripción",
  "analyzerType.field.selectProtocol": "Select protocol",
  "analyzerType.field.pluginClassName": "Plugin Class Name",
  "analyzerType.field.identifierPattern": "Patrón de identificador",
  "analyzerType.field.identifierPatternHelper": "Regex pattern for matching sample identifiers (e.g. ^[A-Z]{2}\\d{6}$)",
  "analyzerType.field.isGenericPlugin": "Generic Plugin",
  "analyzerType.field.isActive": "Activo",
  "analyzerType.error.nameRequired": "Es obligatorio ingresar el nombre",
  "analyzerType.notification.createSuccess": "Analyzer type created successfully",
  "analyzerType.notification.createError": "Failed to create analyzer type",
  "analyzer.stat.pluginWarnings": "Plugin Warnings",
  "analyzer.status.pending_registration": "Pending Registration",
  "analyzer.qcRules.modal.title": "QC Sample Identification Rules — {analyzerName}",
  "analyzer.qcRules.breadcrumb": "QC Sample Identification Rules",
  "analyzer.qcRules.orSemantics": "Rules use OR semantics: a sample is flagged as QC if ANY active rule matches.",
  "analyzer.qcRules.addRule": "Agregar regla",
  "analyzer.qcRules.deleteRule": "Delete Rule",
  "analyzer.qcRules.noRules": "No QC rules configured. Add at least one rule before activating this analyzer.",
  "analyzer.qcRules.ruleType": "Rule Type",
  "analyzer.qcRules.targetField": "Field Reference",
  "analyzer.qcRules.targetField.placeholder": "e.g., O.12, QC_TASK",
  "analyzer.qcRules.operand": "Match Value",
  "analyzer.qcRules.operand.placeholder": "e.g., Q, CNEG, ^(CNEG|CPOS).*",
  "analyzer.qcRules.error.loadFailed": "Failed to load QC rules",
  "analyzer.qcRules.error.saveFailed": "Failed to save QC rule",
  "analyzer.qcRules.error.deleteFailed": "Failed to delete QC rule",
  "analyzer.placement.instrumentSpecimen": "Instrument sent: {id}",
  "analyzer.placement.state.RESOLVED": "Matched",
  "analyzer.placement.state.RETEST_CHOICE": "Already has a result",
  "analyzer.placement.state.MULTI_TUBE": "Several matches",
  "analyzer.placement.state.UNORDERED_ONE_FITS": "Test not ordered",
  "analyzer.placement.state.UNORDERED_MANY_FIT": "Test not ordered",
  "analyzer.placement.state.UNORDERED_NONE_FIT": "Test not ordered",
  "analyzer.placement.state.NEW_SAMPLE": "New sample",
  "analyzer.placement.reason.RESOLVED": "One analysis on {tube} is waiting for this result.",
  "analyzer.placement.reason.RETEST_CHOICE": "The analysis on {tube} already holds a result. Saving replaces it and marks it corrected.",
  "analyzer.placement.reason.MULTI_TUBE": "More than one analysis matches this ID. Choose the one this result belongs to.",
  "analyzer.placement.reason.MULTI_TUBE_NO_ANALYSIS": "More than one tube carries this ID. Correct the duplicate tube labels, then review again.",
  "analyzer.placement.reason.UNORDERED_ONE_FITS": "This test is not ordered. Saving adds it to {tube}.",
  "analyzer.placement.reason.UNORDERED_MANY_FIT": "This test is not ordered and more than one tube could hold it. Choose the sample type below.",
  "analyzer.placement.reason.UNORDERED_NONE_FIT": "This test is not ordered and no tube on the order can hold it. Saving adds a new tube of the test's sample type.",
  "analyzer.placement.reason.NEW_SAMPLE": "No order or tube carries this ID. Saving creates a new sample for it.",
  "analyzer.placement.chooseAnalysis": "Analysis this result belongs to",
  "analyzer.placement.chooseAnalysis.none": "Choose an analysis",
  "analyzer.placement.option": "{tube}, {status}",
  "analyzer.placement.option.awaiting": "waiting for a result",
  "analyzer.placement.option.hasResult": "has a result",
  "analyzer.placement.tubeUnlabelled": "tube {id}",
  "analyzer.placement.viewBundle": "View bundle",
  "analyzer.placement.bundleTitle": "Delivery bundle",
  "analyzer.placement.bundleLoading": "Loading the delivery bundle",
  "analyzer.placement.bundleFailed": "The delivery bundle could not be loaded.",
  "analyzer.placement.redirect.open": "Place on another order",
  "analyzer.placement.redirect.accession": "Order (lab number)",
  "analyzer.placement.redirect.reason": "Why this belongs to that order",
  "analyzer.placement.redirect.help": "Use this when the instrument misread the specimen ID. The reason is saved with the result.",
  "analyzer.placement.redirect.reasonRequired": "Enter the reason before saving.",
  "analyzer.placement.patient.match": "Instrument patient {instrument} matches the order's patient.",
  "analyzer.placement.patient.mismatch.tag": "Patient mismatch",
  "analyzer.placement.patient.mismatch": "The instrument reported patient {instrument}, but the order's patient is {order}. Add a note saying why before saving.",
  "analyzer.placement.patient.noOrderPatient": "The instrument reported patient {instrument}. The order has no patient identifier to compare it with.",
  "instructions.qc.fail.blocks.validation": "When enabled, results covered by an open quality-control failure cannot be accepted in Validation until the non-conformity is closed; they can still be rejected. When disabled, the failure is shown on the row as a warning only.",
  "coldStorage.bacnetUdpPort": "BACnet UDP Port",
  "coldStorage.config.saveSuccess": "System configuration saved successfully",
  "coldStorage.configMoved": "Configuration Moved to Admin Panel",
  "coldStorage.configMovedDesc": "System-wide settings should be managed in the Admin UI where all global configurations are centralized. This page is read-only and will be removed in a future release.",
  "coldStorage.databaseVersion": "Database Version",
  "coldStorage.error.loadConfig": "Failed to load system configuration: ",
  "coldStorage.error.saveConfig": "Failed to save system configuration: ",
  "coldStorage.lastUpdate": "Última actualización",
  "coldStorage.loadingConfig": "Loading system configuration...",
  "coldStorage.modbusTcpPort": "Modbus TCP Port",
  "coldStorage.protocolConfiguration": "Protocol Configuration",
  "coldStorage.readOnlyMode": "Read-Only Mode",
  "coldStorage.readOnlyModeDesc": "To modify these settings, please navigate to Admin → System Configuration",
  "coldStorage.securitySettings": "Security Settings",
  "coldStorage.sessionTimeout": "Session Timeout",
  "coldStorage.systemConfiguration": "System Configuration",
  "coldStorage.systemInformation": "System Information",
  "coldStorage.systemVersion": "System Version",
  "coldStorage.twoFactorAuth": "Two-Factor Authentication",
  "coldStorage.uptime": "Uptime",
  "customFieldType.page.hierarchy.management": "Custom Field Types",
  "customFieldType.page.hierarchy.root": "System Administration",
  "eqa.program.tests.helper": "Result intake for this scheme offers exactly these tests, on the results grid and in its CSV import.",
  "eqa.program.tests.saveFailed": "The scheme was saved but its tests were not. Reopen it and set them again.",
  "inventory.search.placeholder": "Buscar por nombre del ítem, número de lote o código de barras",
  "label.results.control.capture.pass": "Aprobado",
  "label.results.control.capture.fail": "Fallido",
  "message.noPluginFound": "No se encontraron complementos",
  "nce.status.capa": "CAPA",
  "nce.status.completed": "Completado",
  "nce.capa.add": "Agregar",
  "plugin.files": "Archivos de complementos",
  "plugin.name": "Plugin Name",
  "sidenav.label.admin.analyzerTest": "Nombre de prueba del analizador",
  "sidenav.label.admin.Listplugin": "Plugins de Lista",
  "sidenav.label.admin.pluginFile": "Archivos de complementos",
  "label.testCatalog.accreditation.col.body": "Accrediting Body",
  "label.testCatalog.accreditation.col.expires": "Body Expires",
  "label.testCatalog.accreditation.col.status": "Estado",
  "label.testCatalog.accreditation.col.actions": "Acciones",
  "label.testCatalog.accreditation.remove.confirm": "Eliminar",
  "qa.qiConfig.title": "QI Configuration",
  "qa.qiConfig.error": "Unable to load QI configuration.",
  "qa.qiConfig.column.indicator": "Indicador",
  "qa.qiConfig.column.enabled": "Activado",
  "qa.qiConfig.column.target": "Target",
  "qa.qiConfig.column.action": "Action threshold",
  "qa.qiConfig.column.actions": "Acciones",
  "qa.qms.capaRegister.title": "CAPA Register",
  "qa.qms.capaRegister.tile.open": "Abierto",
  "qa.qms.capaRegister.tile.overdue": "Atrasado",
  "qa.qms.capaRegister.filter.status": "Estado",
  "qa.qms.capaRegister.filter.status.all": "Todos",
  "qa.qms.capaRegister.column.nceNumber": " Número NCE",
  "qa.qms.capaRegister.column.actionType": "Tipo",
  "qa.qms.capaRegister.column.dueDate": "Due Date",
  "qa.qms.capaRegister.column.completed": "Completado",
  "qa.qms.capaRegister.column.status": "Estado",
  "qa.qms.accreditation.tile.active": "Activo",
  "qa.qms.accreditation.tile.expiring": "Caduca en breve",
  "qa.qms.accreditation.tile.expired": "Caducado",
  "qa.qms.accreditation.body.column.code": "Código",
  "qa.qms.accreditation.body.column.name": "Nombre",
  "qa.qms.accreditation.body.column.enrolled": "Enrolled Tests",
  "qa.qms.accreditation.body.column.status": "Estado",
  "qa.qms.accreditation.body.column.actions": "Acciones",
  "qa.qms.accreditation.body.field.code": "Código",
  "qa.qms.accreditation.body.field.name": "Nombre",
  "qa.qms.accreditation.body.field.displayOrder": "Orden de visualización",
  "qa.qms.accreditation.body.field.active": "Activo",
  "qa.qms.accreditation.body.delete.confirm": "Eliminar",
  "qa.qms.accreditation.enrollment.column.test": "Prueba",
  "qa.qms.accreditation.enrollment.column.status": "Estado",
  "qa.qms.accreditation.enrollment.column.actions": "Acciones",
  "qa.qms.accreditation.eqa.column.body": "Accrediting Body",
  "qa.qms.accreditation.filter.status": "Estado",
  "qa.qms.accreditation.filter.all": "Todos",
  "qa.qms.accreditation.filter.search": "Buscar pruebas",
  "qa.qms.accreditation.enroll.field.body": "Accrediting body",
  "qa.qms.accreditation.enroll.field.tests": "Pruebas",
  "qa.qms.accreditation.enrollment.delete.confirm": "Eliminar",
  "qa.qms.esigLog.title": "Electronic Signature Log",
  "qa.qms.esigLog.column.signedAt": "Firmado el",
  "qa.qms.esigLog.column.action": "Acción",
  "qa.qms.esigLog.column.reason": "Motivo",
  "qa.qms.esigLog.filter.from": "Rango de fechas (Desde)",
  "qa.qms.esigLog.filter.to": "Rango de fechas (hasta)",
  "qa.qms.esigLog.filter.action": "Acción",
  "qa.qms.esigLog.filter.user": "Usuario",
  "qa.qms.esigLog.filter.all": "Todos",
  "qa.qms.esigLog.filter.clear": "Limpiar filtros",
  "qa.qms.esigLog.export.csv": "Exportar CSV",
  "qa.qms.esigLog.export.pdf": "Exportar a PDF",
  "qa.qms.esigLog.export.confirm.confirm": " Exportar",
  "qa.qms.esigLog.export.confirm.cancel": "Cancelar",
  "qa.qi.dashboard.title": "QI Dashboard",
  "qa.qi.dashboard.refresh": "Actualizar",
  "qa.qi.dashboard.comingSoon": "Coming soon — {ticket}",
  "qa.qi.amendment.filter.from": "Desde",
  "qa.qi.amendment.filter.to": "Hasta",
  "qa.qi.amendment.column.labNumber": "Número de laboratorio",
  "qa.qi.amendment.column.test": "Prueba",
  "qa.qi.amendment.empty": "No amendments in this window.",
  "qa.qi.amendment.error": "Amendment data is unavailable.",
  "qa.qi.amendment.trend.title": "Tendencias",
  "qa.qi.amendment.trend.series": "Amendment rate",
  "qa.qi.amendment.trend.interval": "Agregación",
  "qa.qi.amendment.threshold.target": "Target",
  "qa.qi.amendment.threshold.action": "Acción",
  "qa.qi.amendment.breakdown.column.test": "Prueba",
  "qa.qi.amendment.breakdown.column.amended": "Modificado",
  "qa.qi.amendment.breakdown.column.released": "Liberado",
  "qa.qi.rejection.filter.from": "Desde",
  "qa.qi.rejection.filter.to": "Hasta",
  "qa.qi.rejection.column.labNumber": "Número de laboratorio",
  "qa.qi.rejection.column.test": "Prueba",
  "qa.qi.rejection.column.reason": "Motivo",
  "qa.qi.rejection.column.location": "Ubicación",
  "qa.qi.rejection.column.nce": "NCE",
  "qa.qi.rejection.error": "Rejection data is unavailable.",
  "qa.qi.rejection.trend.title": "Tendencias",
  "qa.qi.rejection.trend.series": "Rejection rate",
  "qa.qi.rejection.trend.interval": "Agregación",
  "qa.qi.rejection.trend.empty": "No trend data in this window.",
  "qa.qi.rejection.threshold.target": "Target",
  "qa.qi.rejection.threshold.action": "Acción",
  "qa.qi.rejection.reasons.column.reason": "Motivo",
  "qa.qi.rejection.reasons.column.count": "Recuento",
  "qa.qi.rejection.breakdown.title": "By test",
  "qa.qi.rejection.breakdown.column.test": "Prueba",
  "qa.qi.rejection.breakdown.column.rejected": "Rechazado",
  "qa.qi.rejection.breakdown.column.total": "Iniciado",
  "qa.qi.rejection.breakdown.column.rate": "Rate",
  "qa.qi.callback.failures.column.reason": "Motivo",
  "qa.qi.callback.failures.column.count": "Recuento",
  "qa.qi.callback.error": "Callback data is unavailable.",
  "qa.qi.callback.column.releasedAt": "Liberado",
  "qa.qi.callback.column.labNumber": "Número de laboratorio",
  "qa.qi.callback.column.test": "Prueba",
  "qa.qi.callback.column.resultValue": "Resultado",
  "qa.qi.callback.column.criticalRange": "Rango crítico",
  "qa.qi.callback.column.recipient": "Person notified",
  "qa.comingSoon.subtitle": "This page is planned but not yet built.",
  "qa.overview.section.today": "Hoy",
  "qa.overview.tile.tat": "Average TAT",
  "qa.overview.tile.rejectionRate": "Rejection Rate",
  "qa.overview.tile.amendmentRate": "Amendment Rate",
  "qa.overview.tile.ncePulse": "NCE Pulse",
  "qa.overview.ncePulse.criticalPending": "critical pending",
  "qa.overview.ncePulse.inCorrectiveAction": "{count} in corrective action",
  "qa.overview.activity.system": "Sistema",
  "storage.picker.backToSearch": "Volver a la búsqueda",
  "storage.picker.createNewLocation": "Crear una nueva ubicación",
  "storage.picker.heading.moveSample": "Mover muestra",
  "storage.picker.sample.accession": "Número de laboratorio",
  "storage.picker.sample.heading": "Muestra",
  "storage.picker.sample.status": "Estado",
  "storage.picker.sample.type": "Tipo",
  "storage.metrics.storage.locations": "Ubicaciones de almacenamiento",
  "storage.tab.devices": "Dispositivos",
  "storage.tab.racks": "Racks",
  "storage.tab.rooms": "Salas",
  "storage.tab.shelves": "Estantes",
  "validation.label.qcHold": "CC fallido",
  "validation.qcHold.blocked": "Some results were not released because a quality control covering them failed. Close the non-conformity, or reject the affected results.",
  "validation.qcHold.withheld": "{count, plural, one {1 result was not released ({accessions}). A QC failure covering it is still open. Review the non-conformity, or reject the result.} other {# results were not released ({accessions}). A QC failure covering them is still open. Review the non-conformity, or reject the result.}}",
  "qc.dashboard.export.button": " Exportar",
  "qc.dashboard.export.instrument": "Instrumento",
  "qc.dashboard.export.level": "Nivel de control",
  "qc.dashboard.export.startDate": " Fecha de inicio",
  "qc.dashboard.export.endDate": " Fecha de finalización",
  "qc.dashboard.export.csv": "Exportar CSV",
  "qc.dashboard.export.pdf": "Exportar a PDF",
  "qc.dashboard.export.cancel": "Cancelar",
  "qc.instrument.tab.timeline": "Cronología de actividades",
  "qc.instrument.tab.chart": "Gráfico de control",
  "qc.chart.stats.mean": "Media",
  "qc.chart.stats.n": "N",
  "qc.chart.subtitle": "Levey-Jennings control chart",
  "qc.chart.filter.startDate": "Fecha de inicio",
  "qc.chart.filter.endDate": "Fecha de finalización",
  "qc.chart.filter.controlLevel": "Nivel de control",
  "qc.chart.filter.selectLevel": "Seleccione el nivel",
  "qc.chart.filter.levelLow": "Bajo",
  "qc.chart.filter.levelNormal": "Normal",
  "qc.chart.filter.levelHigh": "Alto",
  "qc.chart.filter.controlLot": "Lote de control",
  "qc.chart.filter.allLots": "Todos los lotes",
  "qc.chart.action.export": " Exportar",
  "qc.bench.source.label": "Fuente",
  "qc.bench.column.labUnit": "Lab unit",
  "qc.bench.column.test": "Prueba",
  "qc.bench.column.source": "Fuente",
  "qc.bench.column.failed": "Fallido",
  "eqa.distribution.updateSuccess": "Draft distribution updated.",
  "banner.menu.eqa.myCycles": "My Cycles",
  "banner.menu.eqa.labPerformance": "Lab Performance",
  "banner.menu.eqa.followUpQueue": "This Lab's Follow-Up",
  "banner.menu.eqa.analystCompetency": "Analyst Competency",
  "banner.menu.eqa.provider": "EQA Provider",
  "eqa.participant.myCycles.title": "My EQA Cycles",
  "eqa.participant.myCycles.subtitle": "Cycles your lab is participating in. Result entry and validation happen in the standard OpenELIS result pipeline — this page tracks progress and routes you there.",
  "eqa.participant.infoTitle": "EQA results flow through standard validation.",
  "eqa.participant.infoBody": "Click a Lab No to open standard result entry for that sample. Once validation completes, the cycle advances to Submitted (or Ready to submit if the scheme requires cycle-level review).",
  "eqa.kpi.active": "Active cycles",
  "eqa.kpi.active.hint": "in flight",
  "eqa.kpi.readyToSubmit": "Listo para enviar",
  "eqa.kpi.readyToSubmit.hint": "with review flag on",
  "eqa.kpi.awaiting": "Awaiting scores",
  "eqa.kpi.awaiting.hint": "submitted to provider",
  "eqa.kpi.openNce": "Open EQA-linked NCE",
  "eqa.kpi.openNce.attention": "needs attention",
  "eqa.kpi.openNce.none": "none open",
  "eqa.bucket.label": "Estado",
  "eqa.bucket.active": "Activo",
  "eqa.bucket.awaiting": "Awaiting scores",
  "eqa.bucket.completed": "Completado",
  "eqa.bucket.all": "Todos",
  "eqa.bucket.active.hint": "Work in flight — upcoming, testing, or ready to submit",
  "eqa.bucket.awaiting.hint": "Submitted to provider; waiting for scoring",
  "eqa.bucket.completed.hint": "Scored or closed",
  "eqa.bucket.all.hint": "Every cycle this lab has ever touched",
  "eqa.filter.schemeType": "Scheme type",
  "eqa.schemeType.all": "Todos los tipos",
  "eqa.schemeType.international_pt": "International PT",
  "eqa.schemeType.regional_pt": "Regional PT",
  "eqa.schemeType.inter_lab_split": "Inter-lab split",
  "eqa.schemeType.in_house": "Interno",
  "eqa.filter.searchCycles": "Search scheme, provider, or cycle",
  "eqa.filter.showing": "Showing {shown} of {total} cycles",
  "eqa.filter.clear": "Limpiar filtros",
  "eqa.col.scheme": "Programa",
  "eqa.col.type": "Tipo",
  "eqa.col.cycle": "Cycle",
  "eqa.col.status": "Estado",
  "eqa.col.deadline": "Fecha límite",
  "eqa.col.progress": "Avances",
  "eqa.cycle.status.planned": "Planned",
  "eqa.cycle.status.panel_received": "Panel received",
  "eqa.cycle.status.testing": "Testing",
  "eqa.cycle.status.ready_to_submit": "Listo para enviar",
  "eqa.cycle.status.submitted": "Enviado",
  "eqa.cycle.status.scored": "Scored",
  "eqa.cycle.status.closed": "Cerrado",
  "eqa.cycle.toggleDetails": "Toggle cycle details",
  "eqa.cycle.emptyFiltered": "No cycles match these filters.",
  "eqa.cycle.nceBanner": "Unacceptable score on {scheme}. Follow up in the NCE register.",
  "eqa.cycle.perAnalyst.title": "Per-analyst required",
  "eqa.cycle.perAnalyst.body": "Analysts are mapped at scheme enrollment. The per-analyst column is visible on the standard result entry page.",
  "eqa.cycle.review.title": "Optional cycle-level review enabled for this scheme.",
  "eqa.cycle.review.body": "All {total} analytes validated in the standard pipeline. Submit is a single click — validation is the authoritative gate, no re-authentication.",
  "eqa.btn.reviewSubmit": "Review & submit",
  "eqa.cycle.submitted.success": "Cycle submitted to provider — awaiting scores.",
  "eqa.cycle.submitted.error": "Submit failed — the cycle was not advanced. Check that all results are validated and try again.",
  "eqa.progress.title": "Sample progress",
  "eqa.sample.labNo": " Número de laboratorio",
  "eqa.sample.providerId": "Provider sample ID",
  "eqa.sample.analytes": "Analitos",
  "eqa.sample.analyst": "Assigned analyst",
  "eqa.sample.entryStatus": "Entry status",
  "eqa.labNo.tooltip": "Open results entry for this lab number",
  "eqa.entry.entered": "Entered",
  "eqa.entry.in_progress": "En progreso",
  "eqa.entry.empty": "Not entered",
  "eqa.cycle.scoredCopy": "Scoring complete. Scored results appear under Lab Performance.",
  "eqa.cycle.submittedCopy": "Submitted to provider — awaiting scores.",
  "eqa.cycle.closedCopy": "Cycle closed.",
  "eqa.cycle.panelReceivedCopy": "Panel received. Proceed to standard result entry to begin testing.",
  "eqa.cycle.plannedCopy": "Panel has not yet been received at this lab. Open Add Order with the EQA box checked to record the receipt.",
  "eqa.btn.receivePanel": "Receive panel — open Add Order",
  "eqa.uncycled.title": "Uncycled EQA orders",
  "eqa.uncycled.subtitle": "EQA orders not linked to any cycle. They stay visible here so nothing is lost.",
  "eqa.review.title": "Pre-submission summary",
  "eqa.review.subtitle": "Read-only summary of every validated result, grouped by sample. This is what will be submitted to the provider.",
  "eqa.review.auditFootnote": "Every value above was validated in the standard pipeline, which captured the validating user in the audit trail. Submitting records the acknowledgement only — no separate sign-off.",
  "eqa.sample.analyte": "Analito",
  "eqa.sample.reportedValue": "Reported value",
  "eqa.sample.validatedAt": "Validado",
  "eqa.order.cycle": "EQA Cycle",
  "eqa.order.receipt.title": "Panel Receipt",
  "eqa.order.receipt.tempC": "Temperature on arrival (°C)",
  "eqa.order.receipt.integrityOk": "Panel arrived intact",
  "eqa.order.receipt.notes": "Integrity notes",
  "eqa.order.receipt.recorded": "Panel receipt already recorded on {date}.",
  "eqa.cycle.status.prep_in_progress": "Prep in progress",
  "eqa.cycle.status.ready_to_ship": "Ready to ship",
  "eqa.cycle.status.shipped": "Enviado",
  "eqa.cycle.status.delivered": "Entregado",
  "eqa.cycle.status.submissions_open": "Submissions open",
  "eqa.cycle.status.submissions_closed": "Submissions closed",
  "eqa.cycle.status.scoring": "Scoring",
  "eqa.provider.workbench.cycle": "Cycle workbench",
  "eqa.provider.workbench.forCycle": "Prep & shipping — {name}",
  "eqa.provider.workbench.tabs": "Workbenches",
  "eqa.provider.workbench.stateHint": "Prep must clear the inventory and QC gate before any panel can be dispatched.",
  "eqa.prep.tab": "Prep",
  "eqa.prep.participants": "Participantes",
  "eqa.prep.panels": "Paneles",
  "eqa.prep.gate": "Ready-to-ship gate",
  "eqa.prep.gate.clear": "All prep requirements met",
  "eqa.prep.noPanel.title": "No panel prepared",
  "eqa.prep.noPanel.body": "Create the cycle's panel and its samples before recording prep progress.",
  "eqa.prep.needExplained": "Aliquots needed: {samples, plural, one {# sample} other {# samples}} x {participants, plural, one {# participant} other {# participants}} + {reserved} held in reserve = {needed, plural, one {# aliquot} other {# aliquots}}; {shipped, plural, one {# aliquot} other {# aliquots}} dispatched so far.",
  "eqa.prep.produced": "Aliquots produced",
  "eqa.prep.reserved": "Aliquots reserved",
  "eqa.prep.shortfall": "{n} short",
  "eqa.prep.homogeneity": "Homogeneity QC passed",
  "eqa.prep.homogeneityNotes": "QC notes",
  "eqa.prep.save": "Save prep record",
  "eqa.prep.saved": "Prep record updated.",
  "eqa.prep.saveFailed": "Prep record was not saved.",
  "eqa.prep.readyToShip": "Mark cycle ready to ship",
  "eqa.prep.readyToShip.success": "Cycle cleared to ship — record courier details on the Shipments tab.",
  "eqa.prep.readyToShip.refused": "The cycle was not cleared to ship. Resolve the outstanding prep items and try again.",
  "eqa.shipment.tab": "Envíos",
  "eqa.shipment.participant": "Participant",
  "eqa.shipment.box": "Caja",
  "eqa.shipment.courier": "Courier",
  "eqa.shipment.courierFor": "Courier for {name}",
  "eqa.shipment.tracking": "Tracking number",
  "eqa.shipment.trackingFor": "Tracking number for {name}",
  "eqa.shipment.expected": "Expected delivery",
  "eqa.shipment.expectedFor": "Expected delivery for {name}",
  "eqa.shipment.selectAll": "Select all pending",
  "eqa.shipment.selectRow": "Select {name} for dispatch",
  "eqa.shipment.markShipped": "Mark {n} shipped",
  "eqa.shipment.firstShipHint": "The first dispatch moves the cycle to shipped.",
  "eqa.shipment.saved": "Shipment details saved.",
  "eqa.shipment.saveFailed": "Shipment details were not saved.",
  "eqa.shipment.shipped": "{n} participant shipments dispatched.",
  "eqa.shipment.shipFailed": "Nothing was dispatched.",
  "eqa.shipment.shippedOn": "Shipped {date}",
  "eqa.shipment.packList": "Pack list",
  "eqa.shipment.packList.noPanel": "This cycle has no panel, so there is nothing to pack.",
  "eqa.shipment.packList.unavailable": "The panel samples could not be read, so no pack list was produced. Reload and try again.",
  "eqa.shipment.packList.notes": "EQA panel material — do not open before the testing window.",
  "eqa.shipment.label": "Etiqueta",
  "eqa.shipment.noParticipants.title": "No participants",
  "eqa.shipment.noParticipants.body": "Enrol participant laboratories in this cycle before shipping panels.",
  "eqa.report.download": "Download performance report",
  "banner.menu.eqa.inHouse": "In-House Blinding",
  "eqa.inhouse.wizard.title": "Create in-house blinded panel",
  "eqa.inhouse.step1": "Scheme & cycle",
  "eqa.inhouse.step2": "Samples & prep",
  "eqa.inhouse.step3": "Analysts",
  "eqa.inhouse.step4": "Confirm & seal",
  "eqa.inhouse.scheme": "In-house scheme",
  "eqa.inhouse.cycleName": "Cycle name",
  "eqa.inhouse.plannedStart": "Planned start date",
  "eqa.inhouse.unblindDate": "Unblind date (submission deadline)",
  "eqa.inhouse.sample": "Muestra",
  "eqa.inhouse.samples": "Muestras",
  "eqa.inhouse.test": "Prueba",
  "eqa.inhouse.target": "Target value",
  "eqa.inhouse.unit": "Unidad",
  "eqa.inhouse.rangeLow": "Range low",
  "eqa.inhouse.rangeHigh": "Range high",
  "eqa.inhouse.addSample": "Add sample",
  "eqa.inhouse.analyst": "Analyst",
  "eqa.inhouse.roster": "Scheme analysts",
  "eqa.inhouse.roster.pick": "Select analysts",
  "eqa.inhouse.roster.saveError": "Could not save the analyst roster",
  "eqa.inhouse.assign.manual": "Assign analysts manually (otherwise round-robin)",
  "eqa.inhouse.assign.mode": "Assignment mode",
  "eqa.inhouse.assign.ROUND_ROBIN": "Round-robin — one analyst per sample, dealt in rotation",
  "eqa.inhouse.assign.IDENTICAL": "Identical set — every analyst tests the same samples",
  "eqa.inhouse.assign.MANUAL": "Manual per-sample assignment",
  "eqa.inhouse.assign.identicalNote": "Every analyst runs every sample: {materials, plural, one {# sample} other {# samples}} × {analysts, plural, one {# analyst} other {# analysts}} = {aliquots, plural, one {# blinded aliquot} other {# blinded aliquots}}, each with its own blind code.",
  "eqa.inhouse.assign.footnote": "Each assignment is recorded on the blinded order it creates, and follows that order through result entry.",
  "eqa.inhouse.gate.identicalNeedsAnalysts": "An identical set needs at least one analyst on the scheme roster",
  "eqa.inhouse.samplesLeadIn": "{count, plural, one {# sample} other {# samples}} defined. Target values are sealed when the wizard finishes; they are never stored in clear text.",
  "eqa.inhouse.confirm.aliquotRows": "Blinded aliquots",
  "eqa.inhouse.confirm.sealWarning": "Sealing encrypts the target values",
  "eqa.inhouse.confirm.sealWarningBody": "After sealing, revealing a target takes the unblind privilege and is recorded in the audit trail. The panel cannot be edited afterwards.",
  "eqa.inhouse.confirm.afterSeal": "Sealing creates one blinded order per aliquot. They appear in result entry and the Workplan under their blind codes, like any other order.",
  "eqa.inhouse.prep.sourceType": "Fuente",
  "eqa.inhouse.prep.lotNumber": "Lot number",
  "eqa.inhouse.prep.aliquots": "Aliquots produced",
  "eqa.inhouse.prep.storageTemp": "Storage temperature",
  "eqa.inhouse.prep.expiration": "Expiration date",
  "eqa.inhouse.prep.homogeneity": "Homogeneity QC passed",
  "eqa.inhouse.prep.homogeneityNotes": "Homogeneity QC notes",
  "eqa.inhouse.gate.noSamples": "Add at least one sample before continuing",
  "eqa.inhouse.gate.aliquots": "Aliquots produced must cover every blinded sample",
  "eqa.inhouse.gate.homogeneity": "Homogeneity QC has not passed, so distributing requires a written justification",
  "eqa.inhouse.gate.targets": "Every sample needs a test and a target value",
  "eqa.inhouse.confirm.samples": "Muestras",
  "eqa.inhouse.confirm.labelNote": "Label sheets carry the blind code, cycle and analyte only — never a target value.",
  "eqa.inhouse.seal": "Seal panel & distribute",
  "eqa.inhouse.seal.error": "Could not seal the panel",
  "eqa.inhouse.seal.cycleError": "Could not create the cycle",
  "eqa.inhouse.seal.panelError": "Could not create the panel",
  "eqa.inhouse.sealed.title": "Panel sealed and distributed",
  "eqa.inhouse.sealed.help": "The blinded orders now carry these blind codes as their sample IDs, in result entry and in the Workplan.",
  "eqa.inhouse.sealed.done": "Back to in-house panels",
  "eqa.inhouse.panel": "EQA material panel",
  "eqa.inhouse.panel.defaultName": "In-house panel",
  "eqa.inhouse.cycle": "Cycle",
  "eqa.inhouse.status": "Estado",
  "eqa.inhouse.actions": "Acciones",
  "eqa.inhouse.launchWizard": "Launch blinding wizard",
  "eqa.inhouse.noSchemes": "No in-house scheme exists yet. Create one under EQA scheme management first.",
  "eqa.inhouse.labels.print": "Print label sheet",
  "eqa.inhouse.labels.error": "Could not generate the label sheet",
  "eqa.inhouse.unblind.now": "Unblind now",
  "eqa.inhouse.unblind.done": "Panel unblinded and scored",
  "eqa.inhouse.unblind.error": "Could not unblind this panel",
  "eqa.inhouse.targetValues": "Target values",
  "eqa.inhouse.seal.sealed": "Sealed",
  "eqa.inhouse.seal.unsealed": "Unsealed",
  "eqa.inhouse.kpi.awaitingDistribution": "Sealed, awaiting distribution",
  "eqa.inhouse.kpi.inTesting": "In testing",
  "eqa.inhouse.kpi.unblindingSoon": "Unblinding within 7 days",
  "eqa.inhouse.kpi.closed": "Scored or closed",
  "eqa.inhouse.prep.title": "Prep & aliquoting details",
  "eqa.inhouse.prep.subtitle": "Record the same panel inventory details that a provider records.",
  "eqa.inhouse.prep.required": "Required: {samples, plural, one {# sample} other {# samples}} = {samples, plural, one {# aliquot} other {# aliquots}} minimum",
  "eqa.inhouse.back": "Atrás",
  "eqa.inhouse.next": "Siguiente",
  "eqa.inhouse.cancel": "Cancelar",
  "eqa.enrollment.testAnalytes": "Reporting analyte per test",
  "eqa.enrollment.testAnalytes.help": "Set which analyte each test reports for this scheme. Results are submitted to the provider under this analyte; a test left unset is not submitted automatically.",
  "eqa.enrollment.selectAnalyte": "Choose an analyte",
  "eqa.provider.schemes.title": "EQA schemes we provide",
  "eqa.provider.schemes.hint": "Expand a scheme to see its cycles, or start a new cycle to define its panel and participants.",
  "eqa.provider.schemes.none.title": "No schemes to provide yet",
  "eqa.provider.schemes.none.body": "A scheme appears here once another laboratory is actively enrolled in it.",
  "eqa.provider.schemes.provider": "Proveedor",
  "eqa.provider.schemes.enrolled": "Enrolled labs",
  "eqa.provider.schemes.cycles": "Cycles",
  "eqa.provider.schemes.expand": "Show cycles",
  "eqa.provider.schemes.newCycle": "New cycle",
  "eqa.provider.schemes.noCycles": "No cycles yet. Start one to define its panel and participants.",
  "eqa.scheme.type.international_pt": "International PT",
  "eqa.scheme.type.regional_pt": "Regional PT",
  "eqa.scheme.type.inter_lab_split": "Inter-lab split",
  "eqa.scheme.type.in_house": "Interno",
  "eqa.panel.source.in_house_aliquoted": "Patient-sample pool, aliquoted in-house",
  "eqa.panel.source.vendor_sourced": "Vendor-supplied material",
  "eqa.panel.source.mixed": "Mixed sources",
  "eqa.panel.storage.ambient": "Room temperature",
  "eqa.panel.storage.refrigerated_2_8c": "Refrigerated, 2–8°C",
  "eqa.panel.storage.frozen_minus_20c": "Frozen, −20°C",
  "eqa.panel.storage.ultra_frozen_minus_80c": "Ultra-frozen, −80°C",
  "eqa.panel.storage.dry_ice": "Dry ice",
  "eqa.provider.wizard.title": "New cycle",
  "eqa.provider.wizard.forScheme": "New cycle — {name}",
  "eqa.provider.wizard.step.cycle": "Cycle",
  "eqa.provider.wizard.step.panel": "Panel",
  "eqa.provider.wizard.step.distribution": "Distribution",
  "eqa.provider.wizard.cycleName": "Cycle name",
  "eqa.provider.wizard.cycleNumber": "Cycle number",
  "eqa.provider.wizard.cycleNumber.hint": "Left blank, the next unused number for this scheme is used.",
  "eqa.provider.wizard.panelName": "Nombre del Panel",
  "eqa.provider.wizard.source": "Material source",
  "eqa.provider.wizard.lot": "Lot number",
  "eqa.provider.wizard.vendor": "Vendor name",
  "eqa.provider.wizard.vendorLot": "Vendor lot",
  "eqa.provider.wizard.vendorCertificate": "Vendor certificate reference",
  "eqa.provider.wizard.sampleCode": "Sample code",
  "eqa.provider.wizard.target": "Target value",
  "eqa.provider.wizard.target.hint": "A target value is sealed and encrypted at rest; leave it blank when the target is only known at scoring time.",
  "eqa.provider.wizard.unit": "Unidad",
  "eqa.provider.wizard.rangeLow": "Acceptance low",
  "eqa.provider.wizard.rangeHigh": "Acceptance high",
  "eqa.provider.wizard.addSample": "Add sample",
  "eqa.provider.wizard.removeSample": "Eliminar",
  "eqa.provider.wizard.sampleCount": "Panel samples",
  "eqa.provider.wizard.test": "Prueba",
  "eqa.provider.wizard.test.select": "Seleccione una prueba",
  "eqa.provider.wizard.participants": "Participating laboratories",
  "eqa.provider.wizard.participants.hint": "Only labs actively enrolled in this scheme can take part, and only those chosen here are counted by the prep gate.",
  "eqa.provider.wizard.storageTemp": "Storage temperature",
  "eqa.provider.wizard.storageTemp.hint": "Becomes each shipping box's temperature requirement.",
  "eqa.provider.wizard.storageTemp.select": "Select a temperature",
  "eqa.provider.wizard.expiration": "Material expiry",
  "eqa.provider.wizard.reserve.hint": "Aliquots held back for repeat testing are recorded on the prep workbench, once the material exists.",
  "eqa.provider.wizard.confirm.hint": "Creating the cycle moves it straight into prep, where aliquot counts and homogeneity QC are recorded.",
  "eqa.provider.wizard.create": "Create cycle and begin prep",
  "eqa.provider.wizard.failed": "The cycle was not created.",
  "eqa.cycle.distributionMethod": "Distribution method",
  "eqa.cycle.distributionMethod.fhir": "FHIR",
  "eqa.cycle.distributionMethod.csv": "CSV export",
  "eqa.cycle.distributionMethod.mixed": "Mixed",
  "eqa.cycle.distributionMethod.hint": "Wired FHIR, exported files, or both where participants differ. The panel's cold chain is recorded with its source in step 2.",
  "eqa.cycle.history": "Cycle history",
  "eqa.cycle.history.empty": "No state changes recorded for this cycle yet.",
  "eqa.cycle.history.when": "Cuando",
  "eqa.cycle.history.state": "Estado",
  "eqa.cycle.history.trigger": "Disparador",
  "eqa.cycle.history.reason": "Motivo",
  "eqa.cycle.history.manual": "Manual",
  "eqa.report.comments.tab": "Report comments",
  "eqa.report.comments.hint": "Only pre-approved comments can be printed. Edit the wording under Administration → Dictionary Management.",
  "eqa.report.comments.picker": "Approved comments",
  "eqa.report.comments.pickerLabel": "Select comments",
  "eqa.report.comments.add": "Add to report",
  "eqa.report.comments.added": "{count} comment(s) added to the report",
  "eqa.report.comments.comment": "Comment",
  "eqa.report.comments.attribution": "Added by",
  "eqa.report.comments.none": "No comments on this cycle's report yet.",
  "eqa.report.comments.remove": "Eliminar",
  "eqa.report.comments.emptyLibrary.title": "No approved comments configured",
  "eqa.report.comments.emptyLibrary.body": "Add entries to the EQA Report Comment dictionary category to make them selectable here.",
  "eqa.report.comments.addFailed": "The comment could not be added to the report.",
  "eqa.report.comments.removeFailed": "The comment could not be removed from the report.",
  "eqa.performance.ACCEPTABLE": "Aceptable",
  "eqa.performance.QUESTIONABLE": "Cuestionable",
  "eqa.performance.UNACCEPTABLE": "Inaceptable",
  "eqa.oversight.followUpQueue": "This Lab's Follow-Up",
  "eqa.oversight.queueSubtitle": "This lab's questionable EQA scores awaiting corrective review, from external providers and this lab's own in-house schemes. Correspondence with the laboratories that take part in the schemes this lab provides is a different register:",
  "eqa.queue.policyTitle": "Auto-NCE policy active.",
  "eqa.queue.policyBody": "Unacceptable scores on any external scheme this lab participates in open an NCE automatically. This queue holds the questionable range (2 < |Z| ≤ 3) and in-house failures, which need human triage.",
  "eqa.queue.kpi.queued": "Items queued",
  "eqa.queue.kpi.questionable": "Cuestionable",
  "eqa.queue.kpi.questionable.hint": "2 < |Z| ≤ 3",
  "eqa.queue.kpi.inHouse": "In-house failures",
  "eqa.queue.kpi.oldest": "Oldest",
  "eqa.queue.kpi.days": "{days} days",
  "eqa.queue.count": "Queue · {count, plural, one {# item} other {# items}}",
  "eqa.queue.exportCsv": "Exportar CSV",
  "eqa.queue.empty": "Nothing awaiting triage. Questionable scores and in-house failures land here as cycles are scored.",
  "eqa.queue.cycle": "Cycle",
  "eqa.queue.cycleNumber": "Cycle {number}",
  "eqa.queue.analyte": "Analito",
  "eqa.queue.analytePlus": "{first} +{more} more",
  "eqa.queue.zScore": "Z-score",
  "eqa.queue.reason": "Motivo",
  "eqa.queue.enqueued": "Enqueued",
  "eqa.queue.source": "Fuente",
  "eqa.queue.source.external": "External provider",
  "eqa.queue.source.in_house": "Interno",
  "eqa.queue.source.inter_lab_split": "Inter-lab split",
  "eqa.queue.reason.questionable": "Cuestionable",
  "eqa.queue.reason.inHouseFailure": "In-house fail",
  "eqa.queue.triage": "Triage",
  "eqa.queue.triageTitle": "Triage this item",
  "eqa.queue.triageHelp": "Escalate if you suspect a real non-conformity. Dismiss with a reason if this is noise — a transcription error, or equipment trouble already documented. Dismissed entries stay linked to the cycle for accreditation trace.",
  "eqa.queue.reported": "Reported",
  "eqa.queue.target": "Target",
  "eqa.queue.verdict": "Verdict",
  "eqa.queue.escalate": "Escalate to NCE",
  "eqa.queue.dismiss": "Dismiss with reason",
  "eqa.queue.viewCycle": "View cycle",
  "eqa.queue.escalated": "Escalated — NCE {nce} raised for this cycle.",
  "eqa.queue.escalateFailed": "The escalation was refused.",
  "eqa.queue.dismissed": "Dismissed. The competency event for this category is recorded.",
  "eqa.queue.dismissFailed": "The dismissal was refused.",
  "eqa.queue.dismissHeading": "Dismiss with reason",
  "eqa.queue.dismissConfirm": "Descartar",
  "eqa.queue.dismissHelp": "The category decides which competency event is written against every result this entry covers, so pick the one that describes what happened.",
  "eqa.queue.cancel": "Cancelar",
  "eqa.queue.category": "Categoría",
  "eqa.queue.category.TRANSCRIPTION_ERROR": "Error de transcripción",
  "eqa.queue.category.KNOWN_EQUIPMENT_ISSUE": "Known equipment issue",
  "eqa.queue.category.PENDING_RE_TEST": "Pending re-test",
  "eqa.queue.category.ACCEPTABLE_ON_REVIEW": "Acceptable on review",
  "eqa.queue.category.OTHER": "Otros",
  "eqa.queue.notes": "Notas",
  "eqa.labperf.title": "Lab Performance",
  "eqa.labperf.coverage.title": "Lab EQA Performance — Coverage",
  "eqa.labperf.coverage.subtitle": "Accreditation snapshot: lab-wide KPIs, then EQA coverage by section across each scheme's last four cycles. Sections with no active PT are candidates for ISO 15189 §7.7.2 alternative assessment.",
  "eqa.labperf.recent.title": "Lab EQA Performance — Recent Cycles",
  "eqa.labperf.recent.subtitle": "Cycles this lab reported in the last 12 months, with scoring status and verdict.",
  "eqa.labperf.tab.coverage": "Coverage",
  "eqa.labperf.tab.recent": "Recent Cycles",
  "eqa.labperf.kpi.acceptance": "Acceptance rate (12 mo)",
  "eqa.labperf.kpi.delta": "{delta} vs. prior year",
  "eqa.labperf.kpi.noPriorYear": "no prior year to compare",
  "eqa.labperf.kpi.onTime": "On-time submission rate",
  "eqa.labperf.kpi.late": "{late} late of {total}",
  "eqa.labperf.kpi.nce": "EQA-triggered NCEs (12 mo)",
  "eqa.labperf.kpi.nceOpen": "{open} open → NCE register",
  "eqa.labperf.kpi.uncovered": "Accredited tests without EQA",
  "eqa.labperf.kpi.uncovered.hint": "§7.7.2 candidates",
  "eqa.labperf.openNceRegister": "Open the NCE register filtered to EQA-triggered events",
  "eqa.labperf.legendIntro": "Each scheme's last four cycles, by section.",
  "eqa.labperf.legend.acceptable": "Aceptable",
  "eqa.labperf.legend.questionable": "Cuestionable",
  "eqa.labperf.legend.unacceptable": "Inaceptable",
  "eqa.labperf.legend.missing": "Not enrolled / missed",
  "eqa.labperf.section": "Section",
  "eqa.labperf.unassignedSection": "Unassigned section",
  "eqa.labperf.scheme": "Programa",
  "eqa.labperf.cycle": "Cycle",
  "eqa.labperf.cycleOffset": "Cycle −{n}",
  "eqa.labperf.mostRecent": "Most recent",
  "eqa.labperf.acceptanceRate": "Acceptance rate",
  "eqa.labperf.coverage.empty": "No scored EQA results yet. Coverage appears once a cycle this lab took part in has been scored.",
  "eqa.labperf.gapTitle": "Accredited without EQA cover:",
  "eqa.labperf.gapBody": "{tests} — no active EQA enrollment, so ISO 15189 §7.7.2 alternative assessment is required.",
  "eqa.labperf.filterScheme": "Filter scheme",
  "eqa.labperf.status": "Estado",
  "eqa.labperf.score": "Score",
  "eqa.labperf.scoreOf": "{acceptable} of {scored}",
  "eqa.labperf.performance": "Rendimiento",
  "eqa.labperf.submitted": "Enviado",
  "eqa.labperf.pending": "pending",
  "eqa.labperf.verdict.acceptable": "Aceptable",
  "eqa.labperf.verdict.questionable": "Cuestionable",
  "eqa.labperf.verdict.unacceptable": "Inaceptable",
  "eqa.labperf.recent.empty": "No cycles reported in the last 12 months.",
  "nce.filter.source": "Fuente",
  "nce.filter.source.all": "All sources",
  "nce.filter.source.eqa": "EQA-triggered",
  "eqa.receipt.tab": "Receipts & scoring",
  "eqa.receipt.hint": "Submissions open on their own once every participant holds its panel. Overdue means two business days past the expected delivery.",
  "eqa.receipt.noParticipants.body": "Receipts appear here once panels have been dispatched to enrolled participant laboratories.",
  "eqa.receipt.condition": "Condition",
  "eqa.receipt.damaged": "Damaged: {notes}",
  "eqa.receipt.tempOnArrival": "{temp} °C",
  "eqa.receipt.isRepeat": "Repeat shipment",
  "eqa.receipt.markReceived": "Mark received",
  "eqa.receipt.delivered": "Delivery recorded.",
  "eqa.receipt.deliveredFailed": "The delivery could not be recorded.",
  "eqa.receipt.sendRepeat": "Send repeat",
  "eqa.receipt.repeatHeading": "Send a repeat panel",
  "eqa.receipt.repeatHelp": "The repeat comes out of the panel's reserve. If the reserve cannot cover it, a written justification is required before unreserved material is used.",
  "eqa.receipt.overrideNote": "Override note",
  "eqa.receipt.repeatSent": "Repeat panel dispatched.",
  "eqa.receipt.repeatFailed": "The repeat was refused.",
  "eqa.receipt.status.NOT_SHIPPED": "Not shipped",
  "eqa.receipt.status.IN_TRANSIT": "In transit",
  "eqa.receipt.status.EXCEPTION": "Arrived damaged",
  "eqa.score.scoreCycle": "Score cycle",
  "eqa.score.scored": "Cycle scored. Unacceptable participants are in the follow-up register.",
  "eqa.score.scoreFailed": "The cycle could not be scored.",
  "eqa.score.verdicts": "Scores",
  "eqa.score.counts": "{unacceptable} unacceptable of {total}",
  "eqa.score.sendScores": "Send scores",
  "eqa.score.distributed": "Scores placed in the FHIR store for the participant to collect.",
  "eqa.score.distributeFailed": "The scores could not be returned.",
  "eqa.score.downloadCsv": "Scores CSV",
  "eqa.provider.followups.title": "Participant follow-up",
  "eqa.provider.followups.subtitle": "Laboratories participating in the schemes this lab provides that returned unacceptable results. Follow-up here is correspondence with another lab — it never opens a non-conformity in this lab's own register.",
  "eqa.provider.followups.open": "Follow-up register",
  "eqa.provider.followups.empty": "No participant follow-ups. Entries appear here as provider cycles are scored.",
  "eqa.provider.followups.unknownOrg": "Unknown lab",
  "eqa.provider.followups.persistent": "Persistent failure",
  "eqa.provider.followups.response": "Response",
  "eqa.provider.followups.notify": "Notify lab",
  "eqa.provider.followups.emailed": "Notification emailed to {to}.",
  "eqa.provider.followups.csvFallback": "No contact email on file — the notification was downloaded as CSV to send by hand.",
  "eqa.provider.followups.flagRepeat": "Flag for repeat",
  "eqa.provider.followups.repeatSent": "Repeat panel dispatched to {name}.",
  "eqa.provider.followups.moved": "Follow-up moved to {status}.",
  "eqa.provider.followups.failed": "The action was refused.",
  "eqa.provider.followups.notesHelp": "What was agreed with the laboratory. Recorded against the register entry for accreditation trace.",
  "eqa.provider.followups.status.NOTIFIED": "Notified",
  "eqa.provider.followups.status.RESPONSE_RECEIVED": "Response received",
  "eqa.provider.followups.status.UNDER_INVESTIGATION": "Under investigation",
  "eqa.provider.followups.status.ESCALATED": "Escalado",
  "eqa.provider.followups.status.REMOVED_FROM_PROGRAM": "Removed from scheme",
  "eqa.provider.followups.action.RESPONSE_RECEIVED": "Record response",
  "eqa.provider.followups.action.UNDER_INVESTIGATION": "Investigate",
  "eqa.provider.followups.action.RESOLVED": "Resolver",
  "eqa.provider.followups.action.REMOVED_FROM_PROGRAM": "Remove from scheme",
  "eqa.competency.subtitle": "Every analyst assigned to proficiency testing in the last twelve months, banded per analyte. An analyst is competent only where the evidence says so — fewer than four assessable samples reads as under review, not as a pass.",
  "eqa.competency.band.competent": "Competent",
  "eqa.competency.band.underReview": "Under review",
  "eqa.competency.band.notCompetent": "Not competent",
  "eqa.competency.outcome.acceptable": "Aceptable",
  "eqa.competency.outcome.questionable": "Cuestionable",
  "eqa.competency.outcome.unacceptable": "Inaceptable",
  "eqa.competency.outcome.missed": "Missed deadline",
  "eqa.competency.outcome.dismissed": "Dismissed on triage",
  "eqa.competency.event.scored": "Scored result",
  "eqa.competency.event.UNACCEPTABLE_SCORE": "Unacceptable score",
  "eqa.competency.event.QUESTIONABLE_SCORE": "Questionable score",
  "eqa.competency.event.EXTERNAL_MISSED_DEADLINE": "Missed provider deadline",
  "eqa.competency.event.IN_HOUSE_MISSED_DEADLINE": "Missed in-house deadline",
  "eqa.competency.event.ESCALATED_TO_NCE": "Escalated to non-conformity",
  "eqa.competency.event.DISMISSED_EQUIPMENT": "Dismissed — equipment",
  "eqa.competency.event.DISMISSED_TRANSCRIPTION": "Dismissed — transcription",
  "eqa.competency.event.DISMISSED_ACCEPTABLE_ON_REVIEW": "Dismissed — acceptable on review",
  "eqa.competency.event.DISMISSED_OTHER": "Dismissed — other",
  "eqa.competency.kpi.analysts": "Analysts assessed",
  "eqa.competency.kpi.samples": "{count} PT samples",
  "eqa.competency.kpi.notCompetent.hint": "Open escalated NCE",
  "eqa.competency.search": "Filter analysts",
  "eqa.competency.export": "Exportar CSV",
  "eqa.competency.analyst": "Analyst",
  "eqa.competency.samples": "PT samples (12 mo)",
  "eqa.competency.recent": "Most recent performance",
  "eqa.competency.status": "Competency",
  "eqa.competency.history": "Historial",
  "eqa.competency.viewHistory": "Consultar historial",
  "eqa.competency.empty": "No analyst has been recorded on an EQA result in the last twelve months. Analysts appear here once results carry an assigned analyst.",
  "eqa.competency.analyteCount": "{count} analytes assessed",
  "eqa.competency.thisYear": "{count} this year · {failures} failed",
  "eqa.competency.byAnalyte": "Competency by analyte",
  "eqa.competency.analyte": "Analito",
  "eqa.competency.evaluable": "Evaluable",
  "eqa.competency.failures": "Failures",
  "eqa.competency.latest": "Latest",
  "eqa.competency.unnamedAnalyte": "Unnamed analyte",
  "eqa.competency.evidence": "Evidence · every event in the window",
  "eqa.competency.date": "Fecha",
  "eqa.competency.scheme": "Programa",
  "eqa.competency.event": "Evento",
  "eqa.competency.outcome": "Resultado",
  "eqa.competency.counted": "Counts against",
  "eqa.competency.countsFail": "Failure",
  "eqa.competency.countsPass": "Assessed",
  "eqa.competency.countsExcused": "Excused",
  "eqa.result.analyst": "Analyst (EQA)",
  "eqa.result.analystChoose": "Choose analyst",
  "eqa.result.analystRequired": "This EQA scheme records who ran each sample. Choose an analyst before saving.",
  "eqa.program.perAnalyst": "Record the analyst on every result",
  "eqa.program.perAnalyst.on": "Analyst recorded",
  "eqa.program.perAnalyst.off": "No se ha registrado",
  "eqa.result.analyst.tooltip": "Shown because this run includes an EQA sample whose scheme records who ran each sample. Choose the OpenELIS user who ran the sample, from the scheme's analyst roster — that is a separate record from whoever enters this result and whoever validates it. Non-EQA rows take no input.",
  "shipment.settings.siteOrgUnsetTitle": "Site organization not set",
  "shipment.settings.siteOrgUnsetSubtitle": "Incoming consignments are not filtered to this site and outgoing boxes carry no sender. Select the organization that represents this laboratory.",
  "shipment.settings.siteOrgUnmatchedTitle": "Set to an organization this instance does not hold",
  "shipment.settings.siteOrgUnmatchedSubtitle": "The UUID below is the one a partner addresses this laboratory by, and it matches no organization here. Filtering works; leave it unless the partner changes it.",
  "eqa.receipt.openSubmissions": "Open submissions",
  "eqa.receipt.openSubmissionsHeading": "Open submissions with undelivered panels",
  "eqa.receipt.openSubmissionsHelp": "Participants that have not received their panel stay on the roster as late. This is a recorded manual override — give the reason.",
  "eqa.receipt.openSubmissionsReason": "Motivo",
  "eqa.receipt.submissionsOpened": "Submissions are open.",
  "eqa.receipt.submissionsOpenFailed": "Could not open submissions.",
  "eqa.provider.schemes.lastDistribution": "Last distribution",
  "eqa.provider.wizard.distributionDate": "Distribution date",
  "eqa.provider.wizard.submissionDeadline": "Submission deadline",
  "eqa.provider.kpi.activeSchemes": "Active schemes",
  "eqa.provider.kpi.openCycles": "Open cycles",
  "eqa.provider.kpi.enrolled": "Enrolled participants",
  "eqa.provider.kpi.followupsOpen": "Follow-ups open",
  "eqa.provider.schemes.discipline": "Discipline",
  "eqa.cycle.history.actor": "Actor",
  "eqa.cycle.history.systemActor": "Sistema",
  "eqa.prep.reserved.recommend": "{n} recommended: max(10% of participants, 5)",
  "eqa.provider.schemes.participantOnly.title": "Participant view only",
  "eqa.provider.schemes.participantOnly.body": "Provider scheme administration needs the provider grant. Your lab's participation lives on the pages below.",
  "eqa.provider.schemes.link.myPrograms": "My enrollments — schemes this lab takes part in",
  "eqa.provider.schemes.link.myCycles": "My Cycles — panels, results and deadlines",
  "eqa.btn.newCycle": "New cycle",
  "eqa.cycle.new.heading": "New EQA cycle",
  "eqa.cycle.new.help": "For a provider that does not send consignments to this OpenELIS: record the cycle the panel belongs to so it appears here with \"Receive panel\". Consignments from an OpenELIS provider open their cycle on import.",
  "eqa.cycle.new.scheme": "Scheme (from My EQA Schemes)",
  "eqa.cycle.new.name": "Cycle name",
  "eqa.cycle.new.distributionDate": "Distribution date",
  "eqa.cycle.new.deadline": "Submission deadline",
  "eqa.cycle.new.create": "Create cycle",
  "eqa.cycle.new.created": "Cycle created. It is listed as Planned; use \"Receive panel\" when the panel arrives.",
  "eqa.cycle.new.error": "Could not create the cycle",
  "eqa.cycle.new.noPrograms": "Enroll in a scheme under My EQA Schemes first.",
  "eqa.order.receipt.consignment": "Inbound consignment",
  "eqa.order.receipt.consignment.none": "None — received outside the shipment module",
  "eqa.order.receipt.consignment.thisCycle": "this cycle",
  "eqa.order.receipt.consignment.help": "Choosing the consignment takes delivery of it and tells the provider the panel arrived.",
  "eqa.order.receipt.reference": "Shipment reference",
  "eqa.order.receipt.referenceRecorded": "Consignment {code} received.",
  "eqa.intake.enterResults": "Enter results",
  "eqa.intake.heading": "Results from {lab}",
  "eqa.intake.help": "Key the values as the participant reported them — numbers, or words such as Reactive. Saving overwrites what is on file for that test.",
  "eqa.intake.test": "Prueba",
  "eqa.intake.value": "Reported value",
  "eqa.intake.save": "Save results",
  "eqa.intake.saved": "Results recorded for {lab}.",
  "eqa.intake.failed": "Could not record the results",
  "eqa.intake.csv": "Or paste the participant's export bundle (CSV)",
  "eqa.intake.import": "Importar CSV",
  "eqa.intake.imported": "{count, plural, one {# value imported.} other {# values imported.}}",
  "eqa.intake.noTests": "This scheme has no tests assigned yet.",
  "eqa.cycle.importScores": "Import scores (CSV)",
  "eqa.cycle.importScores.heading": "Import the provider's scores",
  "eqa.cycle.importScores.help": "Paste the scores CSV the provider sent (analyte_name and performance_status columns). Scores from a provider OpenELIS arrive on their own through the FHIR store.",
  "eqa.cycle.importScores.csv": "Scores CSV",
  "eqa.cycle.importScores.import": "Import scores",
  "eqa.cycle.importScores.imported": "{count} scores recorded.",
  "eqa.cycle.importScores.unmapped": "Not recognised here: {names}",
  "eqa.cycle.importScores.failed": "Could not import the scores",
  "eqa.program.schemeType": "Scheme type",
  "eqa.program.schemeType.helper": "In-house schemes are run by this laboratory and need no provider; every other type does.",
  "eqa.order.receipt.notes.required": "Say what was wrong with the material. A receipt marked not intact needs the note that explains it.",
  "eqa.provider.wizard.cycleName.required": "A cycle needs a name.",
  "eqa.provider.wizard.dates.required": "A cycle needs both a distribution date and a submission deadline; the deadline is what its reminders are sent against.",
  "eqa.enrollment.scheme": "Programa",
  "eqa.enrollment.scheme.helper": "Pick a scheme this instance carries, or choose Not listed and type the name.",
  "eqa.enrollment.scheme.frozen": "This enrollment has cycles against it, so its scheme and provider cannot be changed.",
  "eqa.enrollment.scheme.other": "Not listed - type the name",
  "eqa.action.forbidden": "This action needs the {grant} permission, which your account does not have. Ask an administrator for it.",
  "eqa.receipt.readOnly.title": "Read-only view of receipts and scores",
  "eqa.receipt.readOnly.body": "Recording a delivery, dispatching a repeat, entering results and returning scores all need the provider grant; scoring the cycle needs the manage grant. The table below is the whole cycle either way.",
  "eqa.inhouse.readOnly.title": "Read-only view of in-house panels",
  "eqa.inhouse.readOnly.body": "Designing and sealing a blinded panel needs the manage grant. The panels below are the whole picture either way.",
  "eqa.score.downloadReport": "Report PDF",
  "eqa.labperf.exportCsv": "Exportar CSV",
  "eqa.labperf.kpi.submitted": "Submitted cycles",
  "eqa.labperf.acceptableOf": "Acceptable of scored",
  "eqa.labperf.kpi.lateCount": "Late submissions",
  "eqa.labperf.kpi.nceOpenCount": "Of those, still open",
  "eqa.queue.source.all": "Every source",
  "eqa.queue.countFiltered": "Queue · {count} of {total, plural, one {# item} other {# items}}",
  "eqa.queue.emptyForSource": "Nothing from this source is awaiting triage. The queue holds {total, plural, one {# item} other {# items}} from other sources.",
  "eqa.program.requiresCycleReview": "Hold each cycle for review before submitting",
  "eqa.program.requiresCycleReview.off": "Submit automatically",
  "eqa.program.requiresCycleReview.on": "Hold for review",
  "eqa.cycle.submitManual": "Submit by hand",
  "eqa.cycle.submitManual.heading": "Record a submission made by hand",
  "eqa.cycle.submitManual.help": "Use this once the results have reached the provider some other way. The reference they gave you is what makes this a record rather than a claim, so it is required.",
  "eqa.cycle.submitManual.reference": "Provider's reference",
  "eqa.cycle.submitManual.success": "Recorded as submitted by hand, with the provider's reference.",
  "eqa.cycle.retriesSpent.title": "Automatic submission has stopped for this cycle.",
  "eqa.cycle.retriesSpent.body": "It failed {attempts} times and will not be retried. Send the results to the provider yourself - the export bundle is on the scheme's page - and record their reference here.",
  "eqa.provider.wizard.sampleCode.duplicate": "Every sample code on a panel must be different.",
  "eqa.provider.wizard.rangeHigh.backwards": "The high end of an acceptance range cannot be below the low end.",
  "eqa.shipment.packList.panelColumn": "Panel",
  "eqa.provider.schemes.performance": "Rendimiento",
  "eqa.performance.title": "Participant performance",
  "eqa.performance.subtitle": "Each laboratory’s pass rate over its last four scored cycles in this scheme. Expand a row for the cycles behind the rate.",
  "eqa.performance.laboratory": "Laboratory",
  "eqa.performance.region": "Región",
  "eqa.performance.enrollment": "Enrollment",
  "eqa.performance.passRate": "Pass rate (last 4)",
  "eqa.performance.mostRecent": "Most recent",
  "eqa.performance.openFollowups": "Open follow-ups",
  "eqa.performance.expand": "Cycle history",
  "eqa.performance.ofJudged": "{accepted} of {judged}",
  "eqa.performance.noRate": "No scored cycle yet",
  "eqa.performance.noCycles": "This laboratory has not reported into a scored cycle yet.",
  "eqa.performance.empty": "No laboratory is enrolled in this scheme yet.",
  "eqa.performance.loadFailed": "Could not load participant performance",
  "eqa.myPrograms.group.active": "Active enrolments ({count})",
  "eqa.order.coverage.title": "Outside this laboratory's enrolment",
  "eqa.order.coverage.subtitle": "The enrolment for this scheme does not cover: {tests}. You can still save the order.",
  "eqa.myPrograms.group.suspended": "Suspended enrolments ({count})",
  "eqa.myPrograms.group.withdrawn": "Withdrawn enrolments ({count})",
  "eqa.enrollment.resume": "Resume",
  "eqa.enrollment.statusReason": "Motivo",
  "eqa.enrollment.statusReasonPlaceholder": "Why is this enrolment changing status?",
  "eqa.enrollment.statusEffectiveDate": "Effective from",
  "eqa.enrollment.withdrawIsFinal": "Withdrawing is final. To take part again, this laboratory enrols in the scheme afresh.",
  "eqa.enrollment.statusChanged": "This enrolment is now {status}",
  "eqa.enrollment.statusChangeFailed": "Could not change this enrolment's status",
  "eqa.enrollment.panels.help": "Standard test bundles from the catalogue. This is what your laboratory reports on, not the EQA material a provider ships you.",
  "eqa.myPrograms.panels.help": "Test panels from the catalogue that this enrolment covers.",
  "eqa.score.scoredWithUnjudged": "Cycle scored, but {count} result(s) got no verdict, on {tests}. Those analytes carry no sealed target and the cycle has too few peers to place them against.",
  "eqa.cycle.close": "Close cycle",
  "eqa.cycle.closeHeading": "Close this cycle",
  "eqa.cycle.closeHelp": "A closed cycle is final: participants see it as closed and no further verdicts are recorded against it. Closing is refused while a follow-up is open or a missed-deadline result is still waiting on an answer.",
  "eqa.cycle.closeFailed": "Could not close this cycle",
  "eqa.prep.ofTotal": "{n} of {total}",
  "eqa.prep.tile.participants": "Enrolled laboratories selected for this cycle",
  "eqa.prep.tile.panels": "Material panels prepared",
  "eqa.prep.dispatched": "Participant shipments dispatched",
  "eqa.prep.readyToShip.blockedByGate": "Prep is incomplete. The ready-to-ship gate above lists what is still outstanding.",
  "eqa.prep.readyToShip.notInPrep": "Cycle state: {status}. Clearing to ship is only offered while the cycle is in prep.",
  "eqa.prep.goToShipments": "Open the Shipments tab",
  "eqa.competency.rule.meetsEvidence": "Evidence met",
  "eqa.competency.rule.repeatedFailure": "Repeated failure",
  "eqa.competency.rule.insufficientEvidence": "Insufficient evidence",
  "eqa.competency.rule.openEscalation": "Open non-conformity",
  "eqa.competency.reason.meetsEvidence": "{evaluable} assessable samples with {failures} failures between {from} and {to}, at or above the evidence floor of {floor}. Nothing to action.",
  "eqa.competency.reason.repeatedFailure": "{failures} failures in {evaluable} assessable samples between {from} and {to}. This is a performance concern: review the failed results and raise a non-conformity, or dismiss them on triage.",
  "eqa.competency.reason.insufficientEvidence": "{evaluable} assessable samples between {from} and {to}, short of the evidence floor of {floor}. This is not a performance concern: assign this analyst more proficiency testing samples.",
  "eqa.competency.reason.openEscalation": "An escalated non-conformity raised between {from} and {to} is still open, over {evaluable} assessable samples with {failures} failures. Close the non-conformity to clear the band.",
  "eqa.competency.whatIsAnAnalyst": "An analyst is an OpenELIS user account on the scheme's analyst roster, recorded against the sample they ran. That is a separate record from whoever entered the result and whoever validated it.",
  "eqa.inhouse.roster.help": "Analysts are OpenELIS user accounts. Everyone selected here joins this scheme's roster and can be assigned samples to run; the roster is separate from who enters and who validates a result.",
  "banner.menu.eqa.providerFollowups": "Participant Follow-Up",
  "eqa.oversight.queueSubtitle.link": "Participant follow-up",
  "eqa.inhouse.sealed.deadline": "Unblind date, and the deadline for the analysts to submit: {date}",
  "eqa.inhouse.sealed.analysts": "Assigned analysts: {names}",
  "eqa.inhouse.sealed.noAnalysts": "No analyst is assigned to any sample on this panel.",
  "eqa.inhouse.sealed.toMyCycles": "Open My Cycles",
  "eqa.inhouse.sealed.toWorkplan": "Open the Workplan",
  "analyzerType.editor.heading": "Profile settings",
  "analyzerType.editor.choose": "Choose…",
  "analyzerType.editor.version": "Profile version",
  "analyzerType.editor.confidence": "Evidence confidence",
  "analyzerType.editor.category": "Laboratory discipline",
  "analyzerType.editor.inboundResults": "Receives analyzer results",
  "analyzerType.editor.outboundOrders": "Sends orders to the analyzer",
  "analyzerType.editor.connectionTest": "Supports a connection test",
  "analyzerType.editor.fileHeading": "File parsing",
  "analyzerType.editor.fileFormat": "Profile file format",
  "analyzerType.editor.defaultFileFormat": "Default file format",
  "analyzerType.editor.filePattern": "Filename pattern",
  "analyzerType.editor.hasHeader": "First row contains column names",
  "analyzerType.editor.delimiter": "Column delimiter",
  "analyzerType.editor.encoding": "Text encoding",
  "analyzerType.editor.sheetIndex": "Sheet number (starting at zero)",
  "analyzerType.editor.skipRows": "Rows to skip",
  "analyzerType.editor.extensions": "Supported file extensions",
  "analyzerType.editor.columns": "File columns",
  "analyzerType.editor.columnsHelp": "Match the column names in the exported file to the result fields below. Preserve spelling and punctuation.",
  "analyzerType.editor.columnNumber": "File column {number}",
  "analyzerType.editor.columnName": "Column name in the file",
  "analyzerType.editor.columnField": "Meaning of the column",
  "analyzerType.editor.removeColumn": "Remove column",
  "analyzerType.editor.columnsInvalid": "Each column needs a unique name and a selected meaning.",
  "analyzerType.editor.addColumn": "Add column",
  "analyzerType.editor.resultOrder": "Result value preference (first available value wins)",
  "analyzerType.editor.communicationHeading": "Communication defaults",
  "analyzerType.editor.analyzerName": "Instrument name in messages",
  "analyzerType.editor.identifierPattern": "Analyzer identifier pattern",
  "analyzerType.editor.protocolVersion": "Protocol version",
  "analyzerType.editor.lowerLayerVersion": "ASTM framing version",
  "analyzerType.editor.msh3Pattern": "Sending application pattern",
  "analyzerType.editor.communicationMode": "Who starts communication",
  "analyzerType.editor.lisInitiated": "Allows the laboratory system to start communication",
  "analyzerType.editor.connectionRole": "Default connection role",
  "analyzerType.editor.transport": "Default transport",
  "analyzerType.editor.port": "Default outbound port (optional)",
  "analyzerType.editor.aggregationMode": "Result grouping",
  "analyzerType.editor.aggregationWindowSeconds": "Result grouping window in seconds",
  "analyzerType.editor.connectionFields": "Fields shown when setting up a connection",
  "analyzerType.editor.connectionFieldsHelp": "These fields describe the settings a lab supplies for each connection. A FILE connection needs a directory field for its watched folder on Bridge. Labels use the application’s translation keys. Choices preserve their value types; visibility conditions refer to another setting.",
  "analyzerType.editor.connectionFieldNumber": "Connection field {number}",
  "analyzerType.editor.fieldKey": "Setting name",
  "analyzerType.editor.fieldLabel": "Label translation key",
  "analyzerType.editor.inputKind": "Input type",
  "analyzerType.editor.required": "Required during connection setup",
  "analyzerType.editor.addField": "Add connection field",
  "analyzerType.editor.removeField": "Remove connection field",
  "analyzerType.editor.save": "Save and validate profile settings",
  "analyzerType.editor.saved": "Profile settings saved",
  "analyzerType.editor.saveBeforeRecognition": "Save profile settings before editing control recognition or publishing.",
  "analyzerType.editor.loadError": "Could not reload the draft. Your unsaved edits are still here.",
  "analyzerType.editor.saveError": "Could not save the draft. Your edits are still here; try saving again.",
  "analyzerType.editor.conflict": "The draft changed since it was opened. Your edits have not been sent. Reload the saved draft before making further changes.",
  "analyzerType.editor.error": "Profile could not be saved",
  "analyzerType.editor.reload": "Reload saved draft and discard local edits",
  "analyzerType.editor.validation": "Profile needs attention",
  "analyzerType.editor.add": "Add value",
  "analyzerType.editor.remove": "Remove value",
  "analyzerType.editor.semantic.sampleId": "Specimen identifier",
  "analyzerType.editor.semantic.testCode": "Analyzer test code",
  "analyzerType.editor.semantic.qcTask": "Control task",
  "analyzerType.editor.semantic.ctValue": "Cycle threshold",
  "analyzerType.editor.inputKind.TEXT": "Text",
  "analyzerType.editor.inputKind.NUMBER": "Number",
  "analyzerType.editor.inputKind.SELECT": "Choice list",
  "analyzerType.editor.inputKind.BOOLEAN": "Yes or no",
  "analyzerType.editor.inputKind.SECRET": "Secret",
  "analyzerType.editor.inputKind.FILE_PATH": "Folder or file path",
  "analyzerType.editor.testDefinitions": "Analyzer test definitions",
  "analyzerType.editor.testDefinitionsHelp": "List the test codes and result values reported by the instrument. These definitions supply suggestions for matching to the laboratory catalog; they do not create or change laboratory tests.",
  "analyzerType.editor.testNumber": "Analyzer test {number}",
  "analyzerType.editor.testCode": "Analyzer test code",
  "analyzerType.editor.testName": "Suggested test name",
  "analyzerType.editor.loinc": "LOINC code",
  "analyzerType.editor.testUnit": "Reported units",
  "analyzerType.editor.resultType": "Reported value type",
  "analyzerType.editor.resultType.quantitative": "Numeric measurement",
  "analyzerType.editor.resultType.qualitative": "Named result",
  "analyzerType.editor.resultType.text": "Free text result",
  "analyzerType.editor.testAliases": "Other codes for this same test",
  "analyzerType.editor.testValues": "Result values reported by this test",
  "analyzerType.editor.removeTest": "Remove analyzer test",
  "analyzerType.editor.addTest": "Add analyzer test",
  "analyzerType.editor.choices": "Connection choices",
  "analyzerType.editor.choiceNumber": "Choice {number}",
  "analyzerType.editor.choiceValue": "Choice value",
  "analyzerType.editor.addChoice": "Add choice",
  "analyzerType.editor.removeChoice": "Remove choice",
  "analyzerType.editor.visibility": "Show this connection field when",
  "analyzerType.editor.controllingField": "Controlling setting",
  "analyzerType.editor.comparison": "Comparison",
  "analyzerType.editor.comparisonValue": "Comparison value",
  "analyzerType.editor.comparison.EQUALS": "Equals",
  "analyzerType.editor.comparison.NOT_EQUALS": "Does not equal",
  "analyzerType.editor.comparison.IN": "Is one of",
  "analyzerType.editor.comparison.NOT_IN": "Is not one of",
  "analyzerType.editor.addCondition": "Add visibility condition",
  "analyzerType.editor.removeCondition": "Remove visibility condition",
  "analyzerType.editor.valueType": "Value type",
  "analyzerType.editor.valueType.string": "Valor de texto",
  "analyzerType.editor.valueType.boolean": "Boolean value",
  "analyzerType.editor.valueType.array": "List value",
  "analyzerType.editor.valueType.object": "Object value",
  "analyzerType.editor.valueType.null": "Null value",
  "analyzerType.editor.nullValue": "This choice has a null value.",
  "analyzerType.editor.invalidTypedValue": "Enter a valid value of the selected type.",
  "analyzerType.editor.structuredValueHelp": "Enter a JSON list or object matching the selected type. Use a list for “is one of” comparisons.",
  "analyzerType.editor.newProtocolHelp": "Choose FILE, ASTM, or HL7 and enter the settings supported by the instrument. The protocol is fixed after the first save.",
  "analyzerType.editor.switchProtocol": "Switch protocol and clear its settings",
  "analyzerType.editor.switchProtocolHelp": "Switch to {protocol}? This clears unsaved communication, parsing, connection-field, and control-recognition settings. Profile identity, test definitions, and descriptive information are retained.",
  "analyzerType.editor.keepProtocol": "Keep the current protocol",
  "analyzerType.editor.supportedTransports": "Supported transports",
  "analyzerType.editor.supportTransport": "Support {transport}",
  "analyzerType.editor.transportSettings": "{transport} settings",
  "analyzerType.editor.transportPortHelp": "Optional outbound destination port for this transport. Leave blank to use the Bridge fallback; incoming messages use the shared listener.",
  "analyzerType.editor.serialSettings": "Serial communication settings",
  "analyzerType.editor.readTimeout": "Serial read timeout (milliseconds)",
  "analyzerType.editor.messageTimeout": "Serial message timeout (milliseconds)",
  "analyzerType.editor.reconnectInterval": "Serial reconnect interval (milliseconds)",
  "analyzerType.editor.maxReconnectAttempts": "Maximum serial reconnect attempts",
  "analyzerType.editor.rtsEnabled": "Enable RTS",
  "analyzerType.editor.dtrEnabled": "Enable DTR",
  "analyzerType.editor.resultRecords": "Result records to parse",
  "analyzerType.editor.resultRecords.ALL": "All result records",
  "analyzerType.editor.resultRecords.FIELD_NON_BLANK": "Records with a populated field",
  "analyzerType.editor.resultRecordField": "Required ASTM field (record.field.component)",
  "analyzerType.editor.specimenPosition": "HL7 specimen position relative to results",
  "analyzerType.editor.dataFlow": "Default direction of data transfer",
  "analyzerType.editor.outboundPortMode": "Default outbound port selection",
  "analyzerType.editor.clientProfilePort": "Client connection port stored in this profile (optional)",
  "eqa.intake.sample": "Muestra {code}",
  "eqa.competency.countsFoldedTriage": "Decided by triage",
  "eqa.competency.countsFoldedScore": "Counted with the score",
  "eqa.provider.followups.responseText": "What the laboratory said",
  "eqa.provider.followups.responseHelp": "The root cause the laboratory found and the corrective action it took. Kept with the follow-up.",
  "eqa.provider.followups.responseShown": "Laboratory's response: {text}",
  "notification.organization.post.error": "The organization was not saved. Check the fields and try again.",
  "organization.email": "Correo electrónico del contacto",
  "eqa.provider.followups.sendFailed": "Could not email {to}. The notification was downloaded as CSV to send by hand.",
  "label.validation.review.error.qcHold": "Release blocked: a failed QC control holds this result until its non-conformity is closed.",
  "sidenav.label.admin.locations": "Locations & Organizations",
  "sidenav.label.admin.locations.organizations": "Organizations",
  "sidenav.label.admin.locations.sites": "Sitios de muestreo",
  "sidenav.label.admin.locations.areas": "Geographic Areas",
  "sidenav.label.admin.locations.import": "Import / Export",
  "help.locations.page.organizations": "Organizations are the health facilities and laboratories your lab works with: the hospitals, clinics and health centres that send you patient samples, and the laboratories you refer samples to. Wards and departments inside an organization are listed under it. Organizations appear in order entry as the requesting site and in referrals as the destination lab.",
  "help.locations.page.sites": "Sampling sites are fixed places in the environment where samples are collected that do not come from a patient: a water source, a mosquito trap, an air monitor, a soil plot. A site does not order tests. It records where a sample was taken, so results can be compared over time at the same spot. Each site sits in a geographic area and can have its own GPS point and contact person.",
  "help.locations.page.areas": "Geographic areas are the administrative divisions of the country, for example Region, Province, District and LLG. They are used for patient addresses and to say where each organization and sampling site is. Most deployments load them once from the national list, then add or correct areas here. To add an area inside another one, use the + button on the parent row: \"+ District\" on Morobe Province adds a district in Morobe. Use \"+ Add Region\" at the top for a new top-level area.",
  "help.locations.page.import": "Load or update organizations, wards / depts, sampling sites and geographic areas from CSV files, in the same format the system uses at installation. Nothing is saved until you review the preview and apply it.",
  "label.locations.page.compare": "Organization or sampling site: which do I need?",
  "label.locations.page.compare.orgTitle": "Add an organization when...",
  "label.locations.page.compare.siteTitle": "Add a sampling site when...",
  "label.locations.page.compare.orgExamples": "Examples: Port Moresby General Hospital, 9 Mile Urban Clinic, Central Public Health Laboratory",
  "label.locations.page.compare.siteExamples": "Examples: Bumbu Settlement light trap, Laloki River intake, Waigani air monitor",
  "help.locations.page.compare.org": "Add an organization when samples come from people seen there, when it orders tests or receives reports or referred samples, or when it has wards or departments that request tests.",
  "help.locations.page.compare.site": "Add a sampling site when samples come from the environment (water, soil, air or insects), when you collect at the same fixed spot again and again, or when you want results for that spot over time, on a map.",
  "help.locations.page.compare.tip": "A water tank at a hospital is still a sampling site: the hospital is an organization, and the tank is a site placed in the same area.",
  "label.locations.kind.facility": "Instalación",
  "label.locations.kind.ward": "Ward / Dept",
  "label.locations.kind.wards": "wards / depts",
  "label.locations.kind.site": "Punto de muestreo",
  "label.locations.kind.area": "Geographic area",
  "label.locations.kind.records": "records",
  "label.locations.column.name": "Nombre",
  "label.locations.column.code": "Código",
  "label.locations.column.type": "Tipo",
  "label.locations.column.wards": "Wards / Depts",
  "label.locations.column.location": "Ubicación",
  "label.locations.column.inUse": "En uso",
  "label.locations.column.level": "Level",
  "label.locations.column.children": "Child areas",
  "label.locations.column.siteType": "Site type",
  "label.locations.column.active": "Activo",
  "label.locations.column.actions": "Acciones",
  "label.locations.column.serviceType": "Service type",
  "label.locations.column.contact": "Contact name",
  "label.locations.column.phone": "Teléfono",
  "label.locations.column.email": "Correo Electrónico",
  "label.locations.column.gps": "GPS",
  "label.locations.open": "open",
  "label.locations.openOrders": "open orders",
  "label.locations.none": "ninguno",
  "label.locations.empty": "(empty)",
  "label.locations.location.notSet": "not set",
  "label.locations.status.active": "Activo",
  "label.locations.status.inactive": "Inactivo",
  "label.locations.status.all": "Todos",
  "label.locations.source.registry": "Registry",
  "help.locations.registry": "Comes from the facility registry. The registry is the source of truth for this record.",
  "label.locations.filter.type": "Tipo",
  "label.locations.filter.type.all": "Todos los tipos",
  "label.locations.filter.location": "Location (includes areas beneath)",
  "label.locations.filter.location.any": "Any area",
  "label.locations.filter.status": "Estado",
  "label.locations.filter.clear": "Limpiar filtros",
  "label.locations.filter.reviewOverdue": "Referral labs overdue for review or with expired accreditation only",
  "label.locations.filter.category.all": "All categories",
  "label.locations.filter.ownership.all": "All ownership",
  "label.locations.toolbar": "Filtros",
  "placeholder.locations.search": "Search by name, code or any identifier",
  "placeholder.locations.area.search": "Search areas by name or code",
  "help.locations.status.inactive": "Inactive records are hidden from order entry and other pickers. They still appear on existing orders and reports.",
  "help.locations.field.location": "Pick the most specific area you know. A district is fine if you don't know the LLG.",
  "help.locations.field.gps": "Decimal degrees, WGS84",
  "help.locations.field.siteDescription": "Include directions so someone else can find the exact spot",
  "help.locations.identifiers": "Type any label, or pick one already used. The reporting code shows as Code in lists, exports and reports. Every identifier is searchable and used to match import rows.",
  "help.locations.ward": "Wards, departments or clinics inside this organization",
  "help.locations.ward.gps": "Leave GPS blank to use {parent}'s location. Address is always {parent}'s.",
  "label.locations.ward.inheritedGps": "{lat}, {lng} inherited from {parent}",
  "label.locations.inherited": "inherited",
  "label.locations.inherits": "inherits",
  "label.locations.draft": "Borrador",
  "label.locations.ward.namePlaceholder": "Ward / dept name",
  "label.locations.optional": "Opcional",
  "warning.locations.registry.edit": "This record comes from the facility registry. Changes to fields the registry supplies will be overwritten on the next sync. To change them for good, update the registry. Wards / depts and other local details you add here are kept.",
  "warning.locations.registry.deactivate": "This record comes from the facility registry. The next sync may reactivate it; to close it for good, update the registry.",
  "label.locations.registry.field": "From registry",
  "button.locations.add": "Agregar",
  "button.locations.import": "Importar",
  "button.locations.export": " Exportar",
  "button.locations.deactivate": "Desactivar",
  "button.locations.reactivate": "Reactivar",
  "button.locations.exportSelected": "Export selected",
  "button.locations.addWard": "Add ward / dept",
  "button.locations.saveWards": "Save {count} new ward / dept",
  "button.locations.moveWard": "Move",
  "button.locations.history": "Historial",
  "button.locations.history.hide": "Ocultar el historial",
  "button.locations.identifier.add": "Add identifier",
  "button.locations.area.addChildLevel": "+ {level}",
  "button.locations.area.addTop": "Add {level}",
  "button.locations.area.expandAll": "Expand all",
  "button.locations.area.collapseAll": "Collapse all",
  "button.locations.undo": "Deshacer",
  "button.locations.template": "Download template",
  "button.locations.import.preview": "Vista previa",
  "button.locations.import.apply": "Aplicar",
  "button.locations.import.report": "Download result report",
  "label.locations.selectAll": "Select all rows",
  "label.locations.select": "Seleccionar",
  "label.locations.section.identity": "Identity",
  "label.locations.section.identifiers": "Identificadores",
  "label.locations.section.location": "Ubicación",
  "label.locations.section.contact": "Contact",
  "label.locations.section.referral": "Referral laboratory",
  "label.locations.section.site": "Site details",
  "label.locations.section.wards": "Wards / Depts",
  "label.locations.form.jump": "Jump to",
  "label.locations.field.types": "Organization type(s)",
  "label.locations.field.shortName": "Nombre abreviado",
  "label.locations.field.category": "Categoría",
  "label.locations.field.ownership": "Ownership",
  "label.locations.field.description": "Descripción",
  "label.locations.field.location": "Ubicación",
  "label.locations.field.parentArea": "Parent area",
  "label.locations.field.streetAddress": "Street address",
  "label.locations.field.city": " Ciudad",
  "label.locations.field.state": "State / Province",
  "label.locations.field.zipCode": "Postal code",
  "label.locations.field.gpsLatitude": "GPS latitude",
  "label.locations.field.gpsLongitude": "GPS longitude",
  "label.locations.field.contactName": "Contact name",
  "label.locations.field.phone": "Teléfono",
  "label.locations.field.email": "Correo Electrónico",
  "label.locations.field.website": "Website",
  "label.locations.field.serviceType": "Service type",
  "label.locations.field.siteType": "Site type",
  "label.locations.field.subtype": "Subtipo",
  "label.locations.field.zone": "Environmental zone",
  "label.locations.identifier.label": "Etiqueta",
  "label.locations.identifier.value": "Valor",
  "label.locations.identifier.reporting": "Reporting code",
  "label.locations.identifier.labelPlaceholder": "e.g. DHIS2 ID",
  "label.locations.referral.approval": "Approval status",
  "label.locations.referral.approved": "Approved",
  "label.locations.referral.evaluation": "Under evaluation",
  "label.locations.referral.suspended": "Suspendido",
  "label.locations.referral.notApproved": "Not approved",
  "label.locations.referral.accreditationBody": "Accreditation body",
  "label.locations.referral.accreditationNumber": "Accreditation number",
  "label.locations.referral.accreditationExpiry": "Accreditation expiry",
  "label.locations.referral.lastReview": "Last review date",
  "label.locations.referral.nextReview": "Next review due",
  "label.locations.referral.notes": "Review notes",
  "label.locations.referral.overdue": "Review overdue",
  "label.locations.referral.expired": "Accreditation expired",
  "message.locations.referral.overdueSince": "Review overdue since {date}. Record the review below, or change the approval status.",
  "label.locations.history.title": "History of {name}",
  "label.locations.history.filter": "Filter by action",
  "label.locations.history.allChanges": "All changes",
  "help.locations.history.readOnly": "Read-only. Kept for as long as the record exists.",
  "label.locations.history.formerly": "Formerly {name}",
  "label.locations.history.action.created": "Creado",
  "label.locations.history.action.edited": "Editado",
  "label.locations.history.action.deactivated": "Desactivado",
  "label.locations.history.action.reactivated": "Reactivado",
  "label.locations.history.action.moved": "Moved",
  "label.locations.history.action.identifiers": "Identifiers changed",
  "label.locations.history.action.referralReview": "Referral review",
  "label.locations.history.action.imported": "Importado",
  "label.locations.history.action.registrySync": "Updated from registry",
  "label.locations.search.ward": "Ward / dept: {name}",
  "error.locations.name.required": "Es obligatorio introducir el nombre",
  "error.locations.types.required": "Choose at least one organization type",
  "error.locations.gps.range": "Enter decimal degrees: latitude -90 to 90, longitude -180 to 180",
  "error.locations.parent.kind": "A ward's parent must be a facility",
  "error.locations.parent.required": "Choose the parent area",
  "error.locations.referral.status": "Choose an approval status",
  "error.locations.identifier.duplicate": "{label} {value} is already used by {name}",
  "error.locations.reactivate.parentInactive": "Reactivate {parent} first.",
  "error.locations.save.conflict": "Another admin saved this record first. Their values are shown below; reapply your changes and save again.",
  "error.locations.save.failed": "The record was not saved.",
  "error.locations.request.failed": "The request could not be completed, so nothing was saved. Try again, and if it keeps failing tell your administrator.",
  "error.locations.save.check": "Not saved yet. Check: {fields}.",
  "error.locations.save.failedBecause": "The record was not saved: {reason}",
  "error.locations.save.conflictKept": "Another admin saved this record first. Your changes are kept, and their changes are filled in where you had not typed ({fields}). Check the form and save again.",
  "warning.locations.wards.unsaved": "{count, plural, one {# ward / dept is} other {# wards / depts are}} typed but not saved yet. Save them with Save wards, or remove them, then save the record.",
  "error.locations.ward.notSaved": "{name} was not saved: {reason}",
  "message.locations.wards.saved": "{count, plural, one {# ward / dept saved.} other {# wards / depts saved.}}",
  "warning.locations.import.ignoredColumns": "These columns are not imported and were ignored: {columns}",
  "label.locations.import.run.applied": "Applied",
  "label.locations.import.run.preview": "Vista previa",
  "warning.locations.identifiers.shared": "Some identifiers are used by more than one record. Give each record its own value.",
  "error.locations.load.failed": "The list could not be loaded. Try again.",
  "warning.locations.name.duplicate": "Another active {kind} named \"{name}\" exists",
  "message.locations.empty.none": "No records yet. Add one, or import a file.",
  "message.locations.empty.filtered": "No records match these filters.",
  "message.locations.search.elsewhere": "In {view}: {count, plural, one {# match} other {# matches}}",
  "message.locations.saved": "{name} saved.",
  "message.locations.added": "{name} added.",
  "message.locations.deactivated": "{name} deactivated.",
  "message.locations.reactivated": "{name} reactivated.",
  "message.locations.undo.deactivated": "{name} deactivated.",
  "message.locations.deactivate.inUse": "{name} has {open} open orders and {children} active {childKind}.",
  "message.locations.deactivate.confirm": "Deactivate {name}?",
  "button.locations.deactivate.record": "Desactivar {name}",
  "button.locations.deactivate.only": "Deactivate {name} only",
  "button.locations.deactivate.withChildren": "Deactivate {name} and its {count} {childKind}",
  "message.locations.area.inUse": "{name} still has active areas, organizations or sites inside it. Deactivate or move those first.",
  "message.locations.area.searchContext": "{count, plural, one {# match} other {# matches}}, shown with the areas they sit in",
  "message.locations.area.loadOnExpand": "Children load when a row is expanded.",
  "label.locations.area.new": "Nuevo",
  "label.locations.area.topLevel": "top level",
  "message.locations.unsaved": "You have unsaved changes. Leave without saving?",
  "label.locations.import.mode": "Import mode",
  "label.locations.import.mode.merge": "Add & update",
  "help.locations.import.mode.merge": "Add new records and update matching ones. Nothing else changes.",
  "label.locations.import.mode.replace": "Replace",
  "help.locations.import.mode.replace": "Also deactivate records of the types in this file that the file does not include. Nothing is deleted.",
  "label.locations.import.files": "Files",
  "label.locations.import.drop": "Drag CSV files here or click to browse (organizations-*.csv, *-levels.csv, *-values.csv)",
  "label.locations.import.area": "Area",
  "label.locations.import.area.organizations": "Facilities, wards & sites",
  "label.locations.import.area.levels": "Geographic levels",
  "label.locations.import.area.values": "Geographic areas",
  "label.locations.import.forThisFile": "For this file:",
  "label.locations.import.replaceScope": "This file has {types} rows. {untouched} will not change. Wards / depts will only be replaced at {parents}. Registry records are never deactivated.",
  "label.locations.import.rename.title": "Possible renames",
  "label.locations.import.rename.same": "Same place, renamed",
  "label.locations.import.rename.different": "Different places",
  "warning.locations.import.registryOverwrite": "Will be overwritten by the next registry sync",
  "warning.locations.import.wardAddressIgnored": "Line {line}: address is ignored for wards / depts, which use their organization's address",
  "label.locations.import.outcome.new": "Nuevo",
  "label.locations.import.outcome.updated": "Actualizado",
  "label.locations.import.outcome.unchanged": "Unchanged",
  "label.locations.import.outcome.reactivated": "Reactivado",
  "label.locations.import.outcome.deactivated": "Desactivado",
  "label.locations.import.outcome.decision": "Needs decision",
  "label.locations.import.outcome.rename": "Possible rename",
  "label.locations.import.outcome.rejected": "Rechazado",
  "label.locations.import.decision.use": "Usar este registro",
  "label.locations.import.decision.new": "Create new",
  "label.locations.import.decision.skip": "Skip row",
  "label.locations.import.decision.remember": "Recordar este nombre",
  "label.locations.import.willDeactivate": "Will be deactivated",
  "label.locations.import.rows": "Filas",
  "label.locations.import.column.line": "Line",
  "label.locations.import.column.outcome": "Resultado",
  "label.locations.import.column.type": "Tipo",
  "label.locations.import.column.code": "Código",
  "label.locations.import.column.name": "Nombre",
  "label.locations.import.column.detail": "Detalle",
  "message.locations.import.nothingSaved": "Nothing has been saved.",
  "label.locations.import.confirm.title": "Apply this import?",
  "label.locations.import.confirm.replace": "I understand {count} records will be deactivated",
  "label.locations.import.complete": "Import complete",
  "label.locations.import.recent": "Recent imports",
  "message.locations.export.done": "Exported {count} records in the import format.",
  "label.locations.import.working": "Reading the file and matching every row. Large files take a moment.",
  "message.locations.import.failed": "The import could not be read: {reason}",
  "eqa.wizard.noSchemeTests": "This scheme has no tests a panel can use.",
  "eqa.performance.titleForScheme": "Participant performance: {scheme}",
  "eqa.cycle.trigger.first_shipment_sent": "First shipment sent",
  "eqa.cycle.trigger.all_shipments_delivered": "All shipments delivered",
  "eqa.cycle.trigger.score_intake": "Scores recorded",
  "eqa.cycle.trigger.panel_receipt": "Panel received",
  "eqa.cycle.trigger.last_validated_result": "Last result validated",
  "eqa.cycle.trigger.fhir_submit_success": "Results submitted to the provider",
  "eqa.cycle.trigger.panel_unblind": "Panel unblinded",
  "eqa.cycle.trigger.v1_backfill": "Carried over from an earlier distribution",
  "sampleAcceptance.banner.resampledFrom.accession": "This is a replacement created by a resample of sample {accession}.",
  "label.results.sampleStatus.markUsedUpConfirm.title": "Mark this sample used up?",
  "label.results.sampleStatus.markUsedUpConfirm.body": "Its remaining volume is set to zero. The sample stays in storage until it is disposed.",
  "alerts.acknowledge.note": "Acknowledgment Comment",
  "alerts.acknowledge.note.required": "A comment is required to acknowledge a critical alert",
  "alerts.resolve.button": "Resolver",
  "alerts.resolve.title": "Resolve Alert",
  "alerts.resolve.comment.required": "A resolution comment is required",
  "alerts.resolve.error": "Failed to resolve alert",
  "configuration.panel.manage": "Administrar Paneles",
  "sidenav.label.admin.testmgt.ViewtestCatalog": "Ver Catálogo de Pruebas",
  "compliance.parameterGroup.deleted": "Parameter group deleted.",
  "compliance.parameterGroup.updated": "Parameter group updated.",
  "compliance.parameterGroup.deleteError": "Could not delete parameter group.",
  "compliance.validation.fillRequired": "Please fill in all required fields.",
  "compliance.parameterGroup.moveError": "Could not reorder parameter group.",
  "compliance.parameterGroup.moved": "Parameter group reordered.",
  "compliance.parameterGroup.created": "Parameter group added.",
  "compliance.testEditor.thresholdsDone": "Compliance thresholds updated for this test.",
  "compliance.testEditor.meta.loinc": "LOINC:",
  "compliance.testEditor.meta.resultType.select": "Lista de selección",
  "compliance.testEditor.meta.resultType": "Tipo de resultado:",
  "compliance.testEditor.editHeader": "Editar prueba:",
  "compliance.testEditor.meta.sampleType": "Tipo de muestra:",
  "compliance.testThresholds.comboboxPlaceholder": "Search by name, code, or LOINC…",
  "label.button.done": "Hecho",
  "compliance.testEditor.meta.resultType.numeric": "Numérico",
  "compliance.multiLimit.advisoryNote.placeholder": "e.g., Requires re-sampling within 24h",
  "compliance.multiLimit.advisoryNote": "Advisory Note",
  "compliance.inlineEdit.editingMapping": "editing compliance mapping",
  "label.loading.message": "Cargando…",
  "compliance.linkedTest.unlinked": "Test removed from the parameter group.",
  "compliance.linkedTest.unlinkError": "Could not remove this test from the group.",
  "compliance.threshold.testLinked": "Test linked to the parameter group.",
  "compliance.inlineEdit.editingLimits": "editing all limits",
  "search.possibleMatches.title": "Possible matches",
  "search.possibleMatches.intro": "These records look similar to the one you are creating. Use one of them, or create a new record.",
  "search.possibleMatches.use": "Use this one",
  "search.possibleMatches.createAnyway": "Create new anyway",
  "search.possibleMatches.confirm": "Create a new record even though {count} similar records exist?",
  "search.possibleMatches.confirm.button": "Create new record",
  "search.possibleMatches.back": "Atrás",
  "search.possibleMatches.matched": "Matched on: {fields}",
  "search.possibleMatches.field.name": "name",
  "search.possibleMatches.field.dateOfBirth": "date of birth",
  "search.possibleMatches.field.identifier": "identifier",
  "search.possibleMatches.field.code": "code",
  "search.possibleMatches.inactive": "Inactivo",
  "search.possibleMatches.failed": "Similar records could not be checked. You can still create the new record.",
  "search.possibleMatches.recordFailed": "Your choice could not be recorded, so nothing was created. Try again.",
  "order.entry.patient.create": "Create patient",
  "order.entry.patient.willBeCreated": "The new patient is created when the order is saved.",
  "provider.title.none": "No title",
  "order.billing.reference": "Billing reference",
  "sample.handling.title": "Handling",
  "sample.handling.noRequirement": "No requirement",
  "sample.handling.processWithin": "process within {time}",
  "sample.handling.holding.minutes": "{minutes} min",
  "sample.handling.holding.hours": "{hours} h",
  "sample.handling.holding.hoursMinutes": "{hours} h {minutes} min",
  "sample.handling.requiredLabel": "Required:",
  "sample.handling.storedAtLabel": "Stored at:",
  "sample.handling.arrivedAs": "Arrived as",
  "sample.handling.measuredTemp": "Measured temperature (°C)",
  "sample.handling.measuredTemp.invalid": "Enter a temperature from -100 to 60 °C.",
  "sample.handling.sameForAll": "Same for all samples",
  "sample.handling.notStored": "Not stored yet",
  "sample.handling.storedAt.temperature": "{location} ({degrees} °C)",
  "sample.handling.mismatch": "Handling mismatch",
  "sample.handling.mismatch.detail": "Needs {required}; {actual}",
  "sample.handling.actual.arrived": "arrived as {condition}",
  "sample.handling.actual.measured": "measured {degrees} °C on arrival",
  "sample.handling.actual.stored": "stored at {degrees} °C",
  "sample.handling.reportNonConformity": "Report non-conformity",
  "sample.condition.roomTemp": "Room temperature",
  "sample.condition.refrigerated": "Refrigerated 2 to 8 °C",
  "sample.condition.frozen": "Frozen",
  "sample.condition.onIce": "On ice",
  "sample.condition.dryIce": "Dry ice",
  "common.notRecorded": "No se ha registrado",
  "sample.legacy.recordedBefore": "Recorded before this version",
  "order.continue.item.arrivalTemperature": "Measured temperature of {sample} is outside -100 to 60 °C",
  "order.entry.receivedBy.you": "Received by {name} (you)",
  "order.entry.receivedBy.other": "Received by {name}",
  "order.entry.receivedBy.search": "Received by",
  "common.change": "Cambiar",
  "common.moreActions": "More actions",
  "order.tests.action.markTestedElsewhere": "Mark tested elsewhere",
  "order.tests.action.unmarkTestedElsewhere": "Not tested elsewhere",
  "order.tests.tag.testedElsewhere": "Tested elsewhere",
  "order.tests.testedElsewhere.help": "Result reported by another laboratory",
  "order.tests.testedElsewhereAt": "Tested elsewhere: {lab}",
  "order.tests.testedElsewhere.value": "Reported value",
  "order.tests.testedElsewhere.lab": "Performing laboratory",
  "order.tests.testedElsewhere.saveFailed": "Tested elsewhere was not saved: {reason}",
  "inventory.board.title": "Items",
  "inventory.board.purpose": "What you have and what to reorder. Expand a row to see its lots and where they are.",
  "inventory.board.column.item": " Elemento",
  "inventory.board.column.onHand": "On hand",
  "inventory.board.column.runsOut": "Runs out",
  "inventory.board.byLocation": "By location:",
  "inventory.board.empty": "No inventory items yet. Add an item to start tracking it, then receive stock.",
  "inventory.board.noMatches": "No items match your search and filters. Clear them to see the whole catalog.",
  "inventory.board.error": "The items board could not be loaded.",
  "inventory.filter.location": "Filter by Location",
  "inventory.projection.window": "{early} \u2013 {late}",
  "inventory.projection.windowOpen": "{early} or later",
  "inventory.projection.basis": "based on usage through {date}",
  "inventory.projection.stale": "Watch \u2014 usage data may be out of date",
  "inventory.projection.insufficient": "Too few days of use to project a run-out date",
  "inventory.projection.outOfStock": "Out of stock",
  "inventory.projection.trend": "Usage trend",
  "inventory.projection.trend.steady": "steady",
  "inventory.projection.trend.change": "{percent}% / {days}d",
  "inventory.projection.medianDailyUse": "Median daily use: {rate} {units}/day (last {days} days \u2014 the median smooths one-off spikes)",
  "inventory.orderBy.label": "Order by",
  "inventory.orderBy.pastDue": "past due",
  "inventory.orderBy.leadSet": "{days}d (set)",
  "inventory.orderBy.leadObserved": "~{days}d (observed)",
  "inventory.orderBy.leadDefault": "{days}d (default \u2014 set to improve)",
  "inventory.reorderStatus.now": "Reorder now",
  "inventory.reorderStatus.soon": "Reorder soon",
  "inventory.reorderStatus.adequate": "Adequate",
  "inventory.reorderStatus.buildingData": "Building data",
  "inventory.lots.useFirst": "Use first",
  "inventory.lots.disposeFailedQc": "Failed QC: dispose",
  "inventory.lots.flag": "Bandera",
  "inventory.lots.none": "No lots recorded for this item yet. Receive stock to start tracking it.",
  "inventory.actions.forItem": "Acciones de «{item}»",
  "inventory.actions.forLot": "Actions for lot {lot}",
  "inventory.actions.editItem": "Edit item details",
  "inventory.actions.editLot": "Edit lot and location",
  "inventory.lots.expiringInDays": "Expires in {days}d",
  "inventory.logUsage.button": "Log usage",
  "inventory.logUsage.title": "Log usage",
  "inventory.logUsage.help": "Record stock used at the bench. This feeds the run-out projection; use Adjust stock to correct a count instead.",
  "inventory.logUsage.quantityWithUnits": "Quantity used ({units})",
  "inventory.logUsage.onHand": "{quantity} {units} on hand. Lots are drawn earliest-expiry first.",
  "inventory.logUsage.error.noItem": "Choose an item to log usage against.",
  "inventory.logUsage.error.wholeUnits": "Enter a whole number of units, at least 1.",
  "inventory.receiveStock.button": "Receive stock",
  "label.testCatalog.basicInfo.opensMicrobiologyCase": "Opens a Microbiology case",
  "label.testCatalog.basicInfo.microbiologyCaseRole": "Case role",
  "label.testCatalog.basicInfo.microbiologyCaseRole.CULTURE": "Culture",
  "label.testCatalog.basicInfo.microbiologyCaseRole.DIRECT": "Direct",
  "label.testCatalog.basicInfo.microbiologyCaseRole.CASE": "Caso",
  "label.testCatalog.basicInfo.collectedInSets": "Collected in sets",
  "microbiology.sets.warning.SINGLE_BOTTLE": "Only one bottle in this set",
  "microbiology.sets.warning.REPEATED_CONTAINER": "Repeated container type in this set",
  "microbiology.sets.warning.DIFFERENT_SITES": "Different collection sites in this set",
  "microbiology.sets.warning.COLLECTION_INTERVAL": "Collection times are more than {minutes} minutes apart",
  "microbiology.sets.title": "Culture sets",
  "microbiology.sets.count.sets": "{sets, plural, one {# set} other {# sets}}",
  "microbiology.sets.count.bottles": "{bottles, plural, one {# bottle} other {# bottles}}",
  "microbiology.sets.count.summary": "{sets}, {bottles}",
  "microbiology.sets.number": "Set {number}",
  "microbiology.sets.unassigned": "Set not recorded",
  "order.microPreview.title": "What this order will open",
  "order.microPreview.loading": "Updating order preview…",
  "order.microPreview.failed": "Order preview unavailable",
  "order.microPreview.failedDetail": "The preview could not be updated. Check your connection and try again.",
  "order.microPreview.opens": "Opens a case",
  "order.microPreview.ordinary": "Stays in Results",
  "order.microPreview.case": "{tests} case in {unit}: {samples}",
  "order.microPreview.sample": "{type} sample {number}",
  "order.microPreview.stays": "{test} stays in Results",
  "order.microPreview.splitTag": "Separate cases",
  "order.microPreview.split": "Sample {number} opens {count} cases: {units}.",
  "order.microPreview.reflex": "{name}: if {conditions}, may add {tests}.",
  "order.microPreview.component": "{test} — {component}",
  "order.microPreview.specimen": "{test} ({type})",
  "order.microPreview.and": " and ",
  "order.microPreview.or": " or ",
  "order.microPreview.condition.EQUALS": "{subject} result equals {value}",
  "order.microPreview.condition.NOT_EQUALS": "{subject} result does not equal {value}",
  "order.microPreview.condition.LESS_THAN": "{subject} result is less than {value}",
  "order.microPreview.condition.LESS_THAN_OR_EQUAL": "{subject} result is at most {value}",
  "order.microPreview.condition.GREATER_THAN": "{subject} result is greater than {value}",
  "order.microPreview.condition.GREATER_THAN_OR_EQUAL": "{subject} result is at least {value}",
  "order.microPreview.condition.BETWEEN": "{subject} result is between {value} and {value2}",
  "order.microPreview.condition.INSIDE_NORMAL_RANGE": "{subject} result is within the normal range",
  "order.microPreview.condition.OUTSIDE_NORMAL_RANGE": "{subject} result is outside the normal range",
  "order.microPreview.newUnitTag": "New lab unit",
  "order.microPreview.newUnit": "{test} opens a case in {unit}; this order has no other work in that lab unit.",
  "dictionary.containerPopulation": "Bottle population (sample containers)",
  "dictionary.containerPopulation.unspecified": "No especificado",
  "dictionary.containerPopulation.ADULT": "Adult",
  "dictionary.containerPopulation.PAEDIATRIC": "Paediatric",
  "microbiology.sets.warning.MIXED_POPULATIONS": "This set contains paediatric and adult bottles.",
  "order.cultureSetNumber": "Set number",
  "order.cultureSetNumber.required": "Enter a positive whole set number.",
  "order.cultureBottle.duplicate": "Duplicate bottle",
  "microbiology.sets.container": "Container type",
  "microbiology.sets.bodySite": "Body site",
  "inventory.reorder.suggestions": "Reorder suggestions",
  "inventory.reorder.help": "Items at or below their threshold, or projected to reach it before a new order could arrive. Marking as ordered records that an order was placed \u2014 it does not place one.",
  "inventory.reorder.none": "Nothing needs ordering right now.",
  "inventory.reorder.markOrdered": "Mark as ordered",
  "inventory.reorder.onOrder": "On order",
  "inventory.reorder.note": " Nota",
  "inventory.reorder.note.placeholder": "Requisition or PO reference",
  "inventory.reorder.expectedDate": "Expected date",
  "inventory.reorder.marked": "{count, plural, one {# item} other {# items}} marked as ordered.",
  "inventory.reorder.reviewAndOrder": "Review and mark as ordered",
  "inventory.reorder.clearOrdered": "Not ordered after all",
  "inventory.reorder.cleared": "{count, plural, one {# item} other {# items}} no longer marked as ordered.",
  "inventory.board.andMore": "and {count} more",
  "inventory.item.leadTime": "Lead time (days)",
  "inventory.item.leadTime.help": "How long this item takes to arrive after it is ordered. Leave blank to let it be learned from your own deliveries.",
  "inventory.item.leadTime.observedSuggest": "Your last few deliveries took about {days} days.",
  "inventory.item.leadTime.useObserved": "Use this",
  "inventory.item.tags": "Etiquetas",
  "inventory.item.tags.help": "How this item is grouped, filtered and reported on. An item can carry more than one.",
  "inventory.item.tags.add": "Type to find or add a tag",
  "inventory.item.tags.remove": "Remove the tag {tag}",
  "inventory.item.autoConsume.help": "There is no auto-consume setting. Linking the item to a test in the Test Catalog lets the bench record its use when entering that test's results.",
  "inventory.search.placeholder.board": "Search by item name, code, tag or lot number",
  "inventory.filter.tags": "Filter by Tags",
  "inventory.filter.tags.clear": "Clear tags",
  "inventory.tags.manage": "Manage tags",
  "inventory.tags.help": "Tidy up your tags. Deactivating one stops it being suggested or offered as a filter. Items already carrying it keep it.",
  "inventory.tags.tag": "Etiqueta",
  "inventory.tags.usage": "Items",
  "inventory.tags.status": "Estado",
  "inventory.tags.active": "Activo",
  "inventory.tags.deactivated": "Desactivado",
  "inventory.tags.deactivate": "Desactivar",
  "inventory.tags.reactivate": "Reactivar",
  "inventory.tags.showDeactivated": "Mostrar desactivado",
  "inventory.tags.new": "New tag",
  "inventory.tags.add": "Add tag",
  "inventory.tags.none": "No tags yet. Add one here, or tag an item directly.",
  "inventory.tags.error.blank": "A tag needs a name.",
  "inventory.item.new": "New item",
  "inventory.item.created": "Item defined. Receive stock against it to start tracking quantities.",
  "inventory.item.showDeactivated": "Mostrar desactivado",
  "inventory.item.deactivated": "Desactivado",
  "inventory.item.deactivate": "Deactivate item",
  "inventory.item.reactivate": "Reactivate item",
  "inventory.item.reactivated": "{item} is active again.",
  "inventory.item.deactivated.success": "{item} is deactivated. Show deactivated to find it again.",
  "inventory.item.deactivate.confirm.title": "Deactivate this item?",
  "inventory.item.deactivate.confirm": "Deactivate {item}?",
  "inventory.item.deactivate.implication.hidden": "It leaves the board and stops being offered when receiving or recording usage.",
  "inventory.item.deactivate.implication.stock": "Its lots and history are kept, and any stock it still holds is not written off.",
  "inventory.item.deactivate.implication.reversible": "You can reactivate it at any time from Show deactivated.",
  "catalog.item.catalogNumber": "Catalog number",
  "catalog.item.expirationAlertDays": "Warn this many days before expiry",
  "catalog.item.trackLots": "Track lots and expiry",
  "catalog.item.trackLots.help": "Turn on for anything received in batches with an expiry date. Turn off for consumables counted as a single pool.",
  "catalog.item.form.help": "This defines a kind of item. To add more of one that already exists, use Receive stock.",
  "inventory.item.form.title.add": "New item",
  "inventory.item.form.title.edit": "Edit item",
  "inventory.count.enter": "Count mode",
  "inventory.count.leave": "Leave count mode",
  "inventory.count.confirm": "Confirm count",
  "inventory.count.expected": "of {expected} {units}",
  "inventory.count.matches": "Matches",
  "inventory.count.perLot": "Count each lot below ({expected} {units} expected here)",
  "inventory.count.nothingHere": "Nothing here to count",
  "inventory.count.countOf": "Counted quantity for {item}",
  "inventory.count.tally": "{counted, plural, =0 {Nothing counted yet} one {# lot counted} other {# lots counted}}",
  "inventory.count.scoped": "Counting {location}. Only stock in this location is listed, and only what you type is committed.",
  "inventory.count.unscoped": "Counting everywhere. Filter by location to count one shelf at a time. Only what you type is committed.",
  "inventory.count.done": "Count recorded: {adjusted, plural, =0 {no corrections} one {# correction} other {# corrections}}, {confirmed, plural, =0 {none confirmed} one {# lot confirmed} other {# lots confirmed}}.",
  "inventory.count.lastCounted": "Counted {date}",
  "inventory.count.neverCounted": "Never counted",
  "inventory.count.column": "Last count",
  "inventory.delivery.purpose": "Enter a delivery. Scan a box, type how much arrived, add it, scan the next. Nothing is saved until you confirm the whole delivery.",
  "inventory.delivery.scan": "Scan the box",
  "inventory.delivery.scan.help": "A GS1 label fills in the product, batch and expiry. Anything it does not carry can be typed below.",
  "inventory.delivery.scan.unread": "That code was not recognised. Enter the line by hand.",
  "inventory.delivery.partialScan": "Partly scanned",
  "inventory.delivery.add": "Add to delivery",
  "inventory.delivery.remove": "Eliminar",
  "inventory.delivery.confirm": "Receive {count, plural, one {# line} other {# lines}}",
  "inventory.delivery.discard": "Discard delivery",
  "inventory.delivery.received": "{count, plural, one {# line} other {# lines}} received.",
  "inventory.delivery.expired": "This lot is already past its expiry date",
  "inventory.delivery.expired.help": "You can still receive it. Short-dated stock is a normal delivery, and the board will flag it.",
  "catalog.item.upc": "Product barcode (UPC or GTIN)",
  "catalog.item.upc.help": "The manufacturer's barcode for this product. Every box of it carries the same one, so scanning it says what an item is, not which batch arrived.",
  "inventory.receive.title": "Receive stock",
  "inventory.receive.submit": "Receive",
  "inventory.receive.success": "Received {quantity} {units}. It counts towards on-hand now, and can be used once its QC passes.",
  "inventory.receive.help": "Adds more of an item that already exists. To define something new, use New item.",
  "inventory.receive.scan": "Scan a product barcode",
  "inventory.receive.scan.help": "Scan or type a UPC to pick the item without searching.",
  "inventory.receive.scan.unknown": "No item carries that barcode",
  "inventory.receive.quantityWithUnits": "Quantity received ({units})",
  "inventory.receive.lotNumber.help": "Leave blank and one is generated from the item code and today's date.",
  "inventory.receive.location.optional": "Not assigned. You can set this now or from the lot later.",
  "inventory.receive.error.noItem": "Choose the item being received.",
  "inventory.receive.error.quantity": "Enter how much arrived.",
  "inventory.receive.error.locationAfterReceive": "The stock was received, but the storage location could not be assigned: {reason}",
  "reports.type.received": "Recibido",
  "reports.type.received.description": "What arrived in the period, by item and lot.",
  "reports.type.consumed": "Consumido",
  "reports.type.consumed.description": "What was used in the period, totalled by item.",
  "reports.type.stockOnHand": "Stock on hand",
  "reports.type.stockOnHand.description": "What you hold, lot by lot, with expiry dates.",
  "reports.type.expiring": "A punto de caducar",
  "reports.type.expiring.description": "Lots whose expiry falls in a window you choose.",
  "reports.asOfDate": "As of",
  "reports.asOfDate.help": "Leave blank for stock as it stands now.",
  "reports.expiringFrom": "Expiring from",
  "reports.expiringTo": "Expiring to",
  "reports.tags": "Etiquetas",
  "reports.tags.help": "Limit the report to items carrying any of these tags.",
  "reports.tags.placeholder": "Any tag",
  "reports.run": "Run report",
  "reports.running": "Running...",
  "reports.empty": "Nothing matched these filters.",
  "reports.empty.stockOnHandAsOf": "No stock movements are recorded on or before this date, so stock as it stood then cannot be reconstructed. This is not the same as having held nothing.",
  "reports.asOfDate.basis": "Reconstructed from recorded stock movements up to this date, not from a physical count.",
  "order.continue.item.eqaScheme": "Choose the EQA scheme",
  "order.eqa.cycle": "Cycle",
  "order.eqa.cycle.none": "No cycle",
  "order.eqa.cycleNotInScheme": "The chosen cycle is not an open cycle of this EQA scheme.",
  "order.eqa.newCycle": "New cycle",
  "order.eqa.noCycle.warning": "This sample is not linked to a cycle, so it will not be submitted or scored from OpenELIS.",
  "order.eqa.noEnrollments.link": "Enroll under My EQA Schemes",
  "order.eqa.noEnrollments.title": "This laboratory is not enrolled in any active EQA scheme.",
  "order.eqa.providerSampleId.codes": "Panel codes for this cycle: {codes}",
  "order.eqa.providerSampleId.noMatch": "This code matches none of the cycle's panel codes ({codes}).",
  "order.eqa.scheme": "Programa de ECA",
  "order.eqa.scheme.choose": "Choose a scheme",
  "order.eqa.schemeRequired": "Choose the EQA scheme this sample belongs to.",
  "order.eqa.schemeUnknown": "The chosen EQA scheme is not one of this laboratory's active enrollments.",
  "order.save.requirement.eqaScheme": "the EQA scheme",
  "save.order.success.labNumber": "Order {labNumber} has been saved.",
  "qc.status.error.required": "Select a QC status.",
  "qc.status.error.notesRequired": "Say why QC failed.",
  "disposal.error.reasonRequired": "Select a disposal reason.",
  "common.error.notesRequiredForOther": "Add a note to explain the reason you chose.",
  "adjustment.error.negativeQuantity": "Quantity cannot be negative.",
  "adjustment.error.reasonRequired": "Select a reason for the adjustment.",
  "lot.error.numberRequired": "Lot number is required.",
  "lot.error.locationRequired": "Assign a storage location.",
  "lot.status.select": "Select lot status",
  "catalog.item.error.nameRequired": "Item name is required.",
  "sidenav.label.inventory.items": "Items",
  "sidenav.label.inventory.items.tooltip": "What you have and what to reorder",
  "sidenav.label.inventory.receive": "Receive",
  "sidenav.label.inventory.receive.tooltip": "Enter a delivery, scanning or typing each line",
  "sidenav.label.inventory.reports": "Informes",
  "sidenav.label.inventory.reports.tooltip": "Received, consumed, stock on hand and expiring",
  "inventory.import.button": "Import items",
  "inventory.import.title": "Import items from a file",
  "inventory.import.help": "Define many items at once from a CSV file. The preview shows what the file would do and saves nothing; only Apply writes anything. Re-importing a corrected file updates the same items rather than adding them again.",
  "inventory.import.template": "Download the template",
  "inventory.import.dropzone": "Add a CSV file",
  "inventory.import.preview": "Vista previa",
  "inventory.import.apply": "Aplicar",
  "inventory.import.plan.title": "What this file would do",
  "inventory.import.result.title": "What was imported",
  "inventory.import.column.line": "Line",
  "inventory.import.column.outcome": "Resultado",
  "inventory.import.column.reason": "Motivo",
  "inventory.import.outcome.create": "Nuevo",
  "inventory.import.outcome.update": "Actualizado",
  "inventory.import.outcome.unchanged": "Unchanged",
  "inventory.import.outcome.skip": "Omitido",
  "inventory.import.count.created": "{count} new",
  "inventory.import.count.updated": "{count} actualizado",
  "inventory.import.count.unchanged": "{count} sin cambios",
  "inventory.import.count.skipped": "{count} omitidos",
  "inventory.import.error.rowsTitle": "Some rows cannot be used",
  "inventory.import.error.rowsMessage": "The rows listed below will be skipped. Applying saves the rest; fix those rows and add the file again to include them.",
  "inventory.import.error.unreadable": "That file could not be read.",
  "inventory.import.error.failed": "The file could not be imported.",
  "inventory.import.nothingToDo": "This file would change nothing",
  "inventory.import.nothingToDo.help": "Every item in it already matches what is stored.",
  "sidenav.label.reports.printQueue": "Report Print Queue",
  "reportQueue.title": "Report Print Queue",
  "reportQueue.subtitle": "Print, reprint and reissue released reports",
  "reportQueue.guidance.lead": "Reports land here when their first result is released.",
  "reportQueue.guidance.body": "Printed reports come back when more results are released or a printed result changes.",
  "reportQueue.legend.partial": "Some results are not released yet",
  "reportQueue.legend.final": "Every result is released",
  "reportQueue.legend.amended": "A printed result changed, or the report was reissued with a correction",
  "reportQueue.legend.unprinted": "The current content has not been printed yet",
  "reportQueue.legend.printed": "The last print matches what is released",
  "reportQueue.tile.toPrint": "To print",
  "reportQueue.tile.amendedToPrint": "Amended to print",
  "reportQueue.type.patient": "Patient report",
  "reportQueue.state.partial": "Partial {released}/{total}",
  "reportQueue.state.partialName": "Partial",
  "reportQueue.state.final": "Final",
  "reportQueue.state.amended": "Modificado",
  "reportQueue.state.amendedPartial": "Amended {released}/{total}",
  "reportQueue.printStatus.unprinted": "Unprinted",
  "reportQueue.printStatus.printed": "Printed",
  "reportQueue.col.type": "Tipo",
  "reportQueue.col.labNoName": "Lab No / Name",
  "reportQueue.col.subject": "Asunto",
  "reportQueue.col.details": "Detalles",
  "reportQueue.col.released": "Released / Submitted",
  "reportQueue.col.state": "Estado",
  "reportQueue.col.printStatus": "Print status",
  "reportQueue.col.version": "Versión",
  "reportQueue.version.none": "Not printed",
  "reportQueue.version.value": "v{n}",
  "reportQueue.action.print": "Imprimir",
  "reportQueue.print.disabled.nothingReleased": "Nothing released yet on this order",
  "reportQueue.print.success": "{count, plural, one {# report} other {# reports}} ready",
  "reportQueue.print.failed": "Could not prepare {count, plural, one {# report} other {# reports}}: {labNumbers}",
  "reportQueue.print.reprinted": "Reprinted version {n} of {labNumber}",
  "reportQueue.print.issued": "Printed version {n} of {labNumber}",
  "reportQueue.print.popupBlocked": "The browser blocked the report window for {labNumber}",
  "reportQueue.print.open": "Open the report",
  "reportQueue.filter.labNo.placeholder": "Scan or type lab number",
  "reportQueue.filter.labNo.helper": "Scanning a barcode applies the filter instantly",
  "reportQueue.filter.labNo.range": "Rango",
  "reportQueue.filter.labNo.to": "To lab number",
  "reportQueue.filter.patient": "Buscar por paciente",
  "reportQueue.filter.state": "Estado",
  "reportQueue.filter.printStatus": "Print status",
  "reportQueue.filter.window": "Time window",
  "reportQueue.filter.window.24h": "Last 24 hours",
  "reportQueue.filter.window.7d": "Last 7 days",
  "reportQueue.filter.window.30d": "Last 30 days",
  "reportQueue.filter.window.all": "All time",
  "reportQueue.filter.window.custom": "Custom range",
  "reportQueue.filter.window.to": "Hasta",
  "reportQueue.filter.window.helper": "Applies to printed reports; unprinted ones always show",
  "reportQueue.filter.facility": "Instalación",
  "reportQueue.filter.ward": "Ward / Dept / Unit",
  "reportQueue.filter.ward.disabled": "Select a facility first",
  "reportQueue.filter.typeahead.helper": "Type 2 or more characters to search",
  "reportQueue.filter.clear": "Limpiar filtros",
  "reportQueue.search.active.labNo": "Lab No: {labNo}",
  "reportQueue.search.active.labRange": "Lab No: {from} to {to}",
  "reportQueue.search.active.patient": "Patient: {name}",
  "reportQueue.search.clear": "Clear search",
  "reportQueue.search.disabledHelper": "Other filters are off while you look up a specific order",
  "reportQueue.empty": "Nothing to print. Every released report in this view has been printed.",
  "reportQueue.error.load": "Could not load the queue.",
  "reportQueue.detail.tests": "Pruebas",
  "reportQueue.detail.order": "Orden",
  "reportQueue.detail.validatedBy": "Validated by",
  "reportQueue.detail.awaitingValidation": "Awaiting validation",
  "reportQueue.detail.inProgress": "En progreso",
  "reportQueue.history.title": "Version history",
  "reportQueue.history.issued": "Issued",
  "reportQueue.history.by": "Por",
  "reportQueue.history.change": "Cambio",
  "reportQueue.history.firstIssue": "First issue",
  "reportQueue.history.completeness": "Completeness",
  "reportQueue.history.fingerprint": "Fingerprint",
  "reportQueue.history.openPdf": "Open PDF",
  "reportQueue.history.reprinted": "Reprinted {date} by {user}",
  "reportQueue.history.notArchived": "Not archived (issued before {date})",
  "reportQueue.history.archiveFailed": "Archive failed",
  "reportQueue.history.none": "Nothing printed yet",
  "sidenav.label.reports.sentMessages": "Mensajes enviados",
  "sidenav.label.admin.notifications": "Notificaciones",
  "sidenav.label.admin.notifications.channels": "Canales",
  "sidenav.label.admin.notifications.templates": "Plantillas",
  "sidenav.label.admin.notifications.delivery": "Delivery Settings",
  "sidenav.label.admin.notifications.triggers": "Desencadenantes",
  "delivery.sent.title": "Mensajes enviados",
  "delivery.sent.subtitle": "Every message the laboratory sent or tried to send: reports, alerts, notices, notification triggers and channel tests",
  "delivery.sent.empty": "Nothing sent in this period.",
  "delivery.sent.loadError": "The messages could not be loaded",
  "delivery.sent.resend": "Reenviar",
  "delivery.sent.resend.done": "Message queued again.",
  "delivery.sent.resend.failed": "The message could not be queued again.",
  "delivery.sent.sentBy.auto": "Automatic",
  "delivery.sent.col.time": "Hora",
  "delivery.sent.col.product": "Product",
  "delivery.sent.col.labNo": "Número de laboratorio",
  "delivery.sent.col.recipient": "Destinatario",
  "delivery.sent.col.channel": "Canal",
  "delivery.sent.col.status": "Estado",
  "delivery.sent.col.attempts": "Intentos",
  "delivery.sent.col.sentBy": "Sent by",
  "delivery.sent.filter.product": "Product",
  "delivery.sent.filter.status": "Estado",
  "delivery.sent.filter.channel": "Canal",
  "delivery.sent.filter.to": "Hasta",
  "delivery.sent.filter.recipient": "Destinatario",
  "delivery.sent.filter.all": "Todos",
  "delivery.sent.detail.subject": "Asunto",
  "delivery.sent.detail.message": "Mensaje",
  "delivery.sent.detail.attempts": "Intentos",
  "delivery.sent.detail.noAttempts": "No attempt yet",
  "delivery.sent.detail.nextAttempt": "Next attempt {time}",
  "delivery.sent.detail.rule": "Regla",
  "delivery.sent.detail.report": "Report version {n}, {format}",
  "delivery.sent.detail.openOrder": "Open the order",
  "delivery.sent.detail.openQueue": "Open in the Report Print Queue",
  "delivery.sent.detail.loadError": "The message could not be loaded",
  "delivery.status.queued": "Queued",
  "delivery.status.sent": "Enviado",
  "delivery.status.failed": "Fallido",
  "delivery.status.skipped": "Omitido",
  "delivery.product.report": "Informe",
  "delivery.product.alert": "Alert",
  "delivery.product.notice": "Ready notice",
  "delivery.product.trigger": "Notification",
  "delivery.product.test": "Prueba",
  "delivery.format.protected": "Protected full report",
  "delivery.format.masked": "Masked copy",
  "delivery.channel.email": "Correo Electrónico",
  "delivery.channel.sms": "SMS",
  "delivery.channel.whatsapp": "WhatsApp",
  "delivery.channel.title": "Canales",
  "delivery.channel.subtitle": "Email, SMS and WhatsApp are set up here once and used by every message the laboratory sends",
  "delivery.channel.status.ready": "Ready",
  "delivery.channel.status.notSetUp": "Not set up",
  "delivery.channel.status.failing": "Failing",
  "delivery.channel.lastSuccess": "Last successful send",
  "delivery.channel.never": "Nunca",
  "delivery.channel.lastError": "Last error",
  "delivery.channel.active": "Activo",
  "delivery.channel.host": "SMTP host",
  "delivery.channel.port": "Puerto",
  "delivery.channel.security": "Security",
  "delivery.channel.security.starttls": "STARTTLS",
  "delivery.channel.security.ssl": "SSL/TLS",
  "delivery.channel.security.none": "Ninguno",
  "delivery.channel.username": "Nombre de usuario",
  "delivery.channel.password": "Contraseña",
  "delivery.channel.secretSet": "Set",
  "delivery.channel.secretHelper": "A secret is stored. Leave this blank to keep it.",
  "delivery.channel.replace": "Replace",
  "delivery.channel.senderAddress": "Sender address",
  "delivery.channel.senderName": "Sender name",
  "delivery.channel.replyTo": "Reply-to address",
  "delivery.channel.whatsapp.accountSid": "Account SID",
  "delivery.channel.whatsapp.token": "Auth token",
  "delivery.channel.whatsapp.from": "Sending number",
  "delivery.channel.whatsapp.address": "API address (optional)",
  "delivery.channel.countryCode": "Default country code",
  "delivery.channel.gateway": "Gateway",
  "delivery.channel.sms.note": "The SMS gateway (BMP or SMPP) keeps its settings in the server properties until its own change lands; this row shows whether one is enabled.",
  "delivery.channel.save": "Guardar",
  "delivery.channel.saved": "Channel saved.",
  "delivery.channel.saveFailed": "The channel could not be saved: check {field}.",
  "delivery.channel.sendTest": "Send test",
  "delivery.channel.test.title": "Send a test message",
  "delivery.channel.test.address": "Dirección",
  "delivery.channel.test.send": "Enviar",
  "delivery.channel.test.sent": "Test message sent.",
  "delivery.channel.test.failed": "The test message was not sent.",
  "delivery.settings.title": "Delivery Settings",
  "delivery.settings.subtitle": "Lab-wide rules for how reports, alerts and notices are sent",
  "delivery.settings.retryDelays": "Retry after (minutes, in order)",
  "delivery.settings.retryDelays.helper": "For example 1,5,15: a failed send is tried again after 1, 5 and 15 minutes, then marked Failed",
  "delivery.settings.defaultFormat": "Format for recipients without a password",
  "delivery.settings.hold": "Wait before sending a new version (minutes)",
  "delivery.settings.partials": "Send partial reports automatically",
  "delivery.settings.contact": "Lab contact line",
  "delivery.settings.contact.helper": "Phone, email and opening hours, as printed in notices",
  "delivery.settings.location": "Where reports are sent from",
  "delivery.settings.location.local": "This lab",
  "delivery.settings.location.central": "Central delivery service",
  "delivery.settings.centralAddress": "Central delivery service address",
  "delivery.settings.centralConfirm": "Reports, alerts and patient notices for this lab will be sent by the central service at {address}. This lab will stop sending them.",
  "delivery.settings.links": "Secure links",
  "delivery.settings.linkDays": "Link lifetime (days)",
  "delivery.settings.countryCode": "Default country code",
  "delivery.settings.save": "Guardar",
  "delivery.settings.saved": "Settings saved.",
  "delivery.settings.invalid": "The settings could not be saved: check {field}.",
  "externalconnections.password.set": "A password is stored. Leave this blank to keep it.",
  "notificationtrigger.referralrejected.name": "Referral result rejected",
  "notificationtrigger.referralrejected.description": "Sent when a result returned by the reference laboratory is rejected and the sample must be collected again.",
  "notificationtrigger.templates.referralrejected.description": "Sent to the ordering provider or the submitting user when a returned referral result is rejected.",
  "notificationtrigger.referralnudge.name": "Referral nudge",
  "notificationtrigger.referralnudge.description": "Sent to the reference laboratory's contact when a referral is overdue and a nudge is requested.",
  "notificationtrigger.templates.referralnudge.description": "Sent to the chain-of-custody contact at the reference laboratory when a result is awaited.",
  "notificationtrigger.sampleresampled.name": "Sample re-collection",
  "notificationtrigger.sampleresampled.description": "Sent when an order is marked for re-collection and a replacement order is created.",
  "notificationtrigger.templates.sampleresampled.description": "Sent to the ordering provider or the submitting user when a sample must be collected again.",
  "notificationtrigger.testresult.name": "Patient results ready",
  "notificationtrigger.testresult.description": "Sent to the patient or the provider when a test configured under Test Notifications has a released result.",
  "notificationtrigger.templates.testresult.description": "Sent to the patient or the provider when a configured test's result is released. It never names the patient."
}
